(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequireab9c"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequireab9c"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("5ytEK", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $40b721da8bb46d97$export$ffb0004e005737fa; }, function (v) { return $40b721da8bb46d97$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $40b721da8bb46d97$export$34b9dba7ce09269b; }, function (v) { return $40b721da8bb46d97$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $40b721da8bb46d97$export$25062201e9e25d76; }, function (v) { return $40b721da8bb46d97$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $40b721da8bb46d97$export$ffb0004e005737fa;
var $40b721da8bb46d97$export$34b9dba7ce09269b;
var $40b721da8bb46d97$export$25062201e9e25d76;
'use strict';

var $4Y8Vu = parcelRequire("4Y8Vu");
var $40b721da8bb46d97$var$k = Symbol.for("react.element"), $40b721da8bb46d97$var$l = Symbol.for("react.fragment"), $40b721da8bb46d97$var$m = Object.prototype.hasOwnProperty, $40b721da8bb46d97$var$n = $4Y8Vu.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $40b721da8bb46d97$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $40b721da8bb46d97$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$40b721da8bb46d97$var$m.call(a, b) && !$40b721da8bb46d97$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $40b721da8bb46d97$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $40b721da8bb46d97$var$n.current
    };
}
$40b721da8bb46d97$export$ffb0004e005737fa = $40b721da8bb46d97$var$l;
$40b721da8bb46d97$export$34b9dba7ce09269b = $40b721da8bb46d97$var$q;
$40b721da8bb46d97$export$25062201e9e25d76 = $40b721da8bb46d97$var$q;

});
parcelRegister("4Y8Vu", function(module, exports) {
'use strict';

module.exports = (parcelRequire("jP3xY"));

});
parcelRegister("jP3xY", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $e6e5881a45ab9908$export$dca3b0875bd9a954; }, function (v) { return $e6e5881a45ab9908$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $e6e5881a45ab9908$export$16fa2f45be04daa8; }, function (v) { return $e6e5881a45ab9908$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $e6e5881a45ab9908$export$ffb0004e005737fa; }, function (v) { return $e6e5881a45ab9908$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $e6e5881a45ab9908$export$e2c29f18771995cb; }, function (v) { return $e6e5881a45ab9908$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $e6e5881a45ab9908$export$221d75b3f55bb0bd; }, function (v) { return $e6e5881a45ab9908$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $e6e5881a45ab9908$export$5f8d39834fd61797; }, function (v) { return $e6e5881a45ab9908$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $e6e5881a45ab9908$export$74bf444e3cd11ea5; }, function (v) { return $e6e5881a45ab9908$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $e6e5881a45ab9908$export$ae55be85d98224ed; }, function (v) { return $e6e5881a45ab9908$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "act", function () { return $e6e5881a45ab9908$export$3ba232387fd5d6dd; }, function (v) { return $e6e5881a45ab9908$export$3ba232387fd5d6dd = v; });
$parcel$export(module.exports, "cloneElement", function () { return $e6e5881a45ab9908$export$e530037191fcd5d7; }, function (v) { return $e6e5881a45ab9908$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $e6e5881a45ab9908$export$fd42f52fd3ae1109; }, function (v) { return $e6e5881a45ab9908$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $e6e5881a45ab9908$export$c8a8987d4410bf2d; }, function (v) { return $e6e5881a45ab9908$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $e6e5881a45ab9908$export$d38cd72104c1f0e9; }, function (v) { return $e6e5881a45ab9908$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $e6e5881a45ab9908$export$7d1e3a5e95ceca43; }, function (v) { return $e6e5881a45ab9908$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $e6e5881a45ab9908$export$257a8862b851cb5b; }, function (v) { return $e6e5881a45ab9908$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $e6e5881a45ab9908$export$a8257692ac88316c; }, function (v) { return $e6e5881a45ab9908$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $e6e5881a45ab9908$export$488013bae63b21da; }, function (v) { return $e6e5881a45ab9908$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $e6e5881a45ab9908$export$7c73462e0d25e514; }, function (v) { return $e6e5881a45ab9908$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $e6e5881a45ab9908$export$7568632d0d33d16d; }, function (v) { return $e6e5881a45ab9908$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_act", function () { return $e6e5881a45ab9908$export$88948ce120ea2619; }, function (v) { return $e6e5881a45ab9908$export$88948ce120ea2619 = v; });
$parcel$export(module.exports, "useCallback", function () { return $e6e5881a45ab9908$export$35808ee640e87ca7; }, function (v) { return $e6e5881a45ab9908$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $e6e5881a45ab9908$export$fae74005e78b1a27; }, function (v) { return $e6e5881a45ab9908$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $e6e5881a45ab9908$export$dc8fbce3eb94dc1e; }, function (v) { return $e6e5881a45ab9908$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $e6e5881a45ab9908$export$6a7bc4e911dc01cf; }, function (v) { return $e6e5881a45ab9908$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $e6e5881a45ab9908$export$6d9c69b0de29b591; }, function (v) { return $e6e5881a45ab9908$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $e6e5881a45ab9908$export$f680877a34711e37; }, function (v) { return $e6e5881a45ab9908$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $e6e5881a45ab9908$export$d5a552a76deda3c2; }, function (v) { return $e6e5881a45ab9908$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $e6e5881a45ab9908$export$aaabe4eda9ed9969; }, function (v) { return $e6e5881a45ab9908$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $e6e5881a45ab9908$export$e5c5a5f917a5871c; }, function (v) { return $e6e5881a45ab9908$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $e6e5881a45ab9908$export$1538c33de8887b59; }, function (v) { return $e6e5881a45ab9908$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $e6e5881a45ab9908$export$13e3392192263954; }, function (v) { return $e6e5881a45ab9908$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $e6e5881a45ab9908$export$b8f5890fc79d6aca; }, function (v) { return $e6e5881a45ab9908$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $e6e5881a45ab9908$export$60241385465d0a34; }, function (v) { return $e6e5881a45ab9908$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $e6e5881a45ab9908$export$306c0aa65ff9ec16; }, function (v) { return $e6e5881a45ab9908$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $e6e5881a45ab9908$export$7b286972b8d8ccbf; }, function (v) { return $e6e5881a45ab9908$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $e6e5881a45ab9908$export$83d89fbfd8236492; }, function (v) { return $e6e5881a45ab9908$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $e6e5881a45ab9908$export$dca3b0875bd9a954;
var $e6e5881a45ab9908$export$16fa2f45be04daa8;
var $e6e5881a45ab9908$export$ffb0004e005737fa;
var $e6e5881a45ab9908$export$e2c29f18771995cb;
var $e6e5881a45ab9908$export$221d75b3f55bb0bd;
var $e6e5881a45ab9908$export$5f8d39834fd61797;
var $e6e5881a45ab9908$export$74bf444e3cd11ea5;
var $e6e5881a45ab9908$export$ae55be85d98224ed;
var $e6e5881a45ab9908$export$3ba232387fd5d6dd;
var $e6e5881a45ab9908$export$e530037191fcd5d7;
var $e6e5881a45ab9908$export$fd42f52fd3ae1109;
var $e6e5881a45ab9908$export$c8a8987d4410bf2d;
var $e6e5881a45ab9908$export$d38cd72104c1f0e9;
var $e6e5881a45ab9908$export$7d1e3a5e95ceca43;
var $e6e5881a45ab9908$export$257a8862b851cb5b;
var $e6e5881a45ab9908$export$a8257692ac88316c;
var $e6e5881a45ab9908$export$488013bae63b21da;
var $e6e5881a45ab9908$export$7c73462e0d25e514;
var $e6e5881a45ab9908$export$7568632d0d33d16d;
var $e6e5881a45ab9908$export$88948ce120ea2619;
var $e6e5881a45ab9908$export$35808ee640e87ca7;
var $e6e5881a45ab9908$export$fae74005e78b1a27;
var $e6e5881a45ab9908$export$dc8fbce3eb94dc1e;
var $e6e5881a45ab9908$export$6a7bc4e911dc01cf;
var $e6e5881a45ab9908$export$6d9c69b0de29b591;
var $e6e5881a45ab9908$export$f680877a34711e37;
var $e6e5881a45ab9908$export$d5a552a76deda3c2;
var $e6e5881a45ab9908$export$aaabe4eda9ed9969;
var $e6e5881a45ab9908$export$e5c5a5f917a5871c;
var $e6e5881a45ab9908$export$1538c33de8887b59;
var $e6e5881a45ab9908$export$13e3392192263954;
var $e6e5881a45ab9908$export$b8f5890fc79d6aca;
var $e6e5881a45ab9908$export$60241385465d0a34;
var $e6e5881a45ab9908$export$306c0aa65ff9ec16;
var $e6e5881a45ab9908$export$7b286972b8d8ccbf;
var $e6e5881a45ab9908$export$83d89fbfd8236492;
'use strict';
var $e6e5881a45ab9908$var$l = Symbol.for("react.element"), $e6e5881a45ab9908$var$n = Symbol.for("react.portal"), $e6e5881a45ab9908$var$p = Symbol.for("react.fragment"), $e6e5881a45ab9908$var$q = Symbol.for("react.strict_mode"), $e6e5881a45ab9908$var$r = Symbol.for("react.profiler"), $e6e5881a45ab9908$var$t = Symbol.for("react.provider"), $e6e5881a45ab9908$var$u = Symbol.for("react.context"), $e6e5881a45ab9908$var$v = Symbol.for("react.forward_ref"), $e6e5881a45ab9908$var$w = Symbol.for("react.suspense"), $e6e5881a45ab9908$var$x = Symbol.for("react.memo"), $e6e5881a45ab9908$var$y = Symbol.for("react.lazy"), $e6e5881a45ab9908$var$z = Symbol.iterator;
function $e6e5881a45ab9908$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $e6e5881a45ab9908$var$z && a[$e6e5881a45ab9908$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $e6e5881a45ab9908$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $e6e5881a45ab9908$var$C = Object.assign, $e6e5881a45ab9908$var$D = {};
function $e6e5881a45ab9908$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $e6e5881a45ab9908$var$D;
    this.updater = e || $e6e5881a45ab9908$var$B;
}
$e6e5881a45ab9908$var$E.prototype.isReactComponent = {};
$e6e5881a45ab9908$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$e6e5881a45ab9908$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $e6e5881a45ab9908$var$F() {}
$e6e5881a45ab9908$var$F.prototype = $e6e5881a45ab9908$var$E.prototype;
function $e6e5881a45ab9908$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $e6e5881a45ab9908$var$D;
    this.updater = e || $e6e5881a45ab9908$var$B;
}
var $e6e5881a45ab9908$var$H = $e6e5881a45ab9908$var$G.prototype = new $e6e5881a45ab9908$var$F;
$e6e5881a45ab9908$var$H.constructor = $e6e5881a45ab9908$var$G;
$e6e5881a45ab9908$var$C($e6e5881a45ab9908$var$H, $e6e5881a45ab9908$var$E.prototype);
$e6e5881a45ab9908$var$H.isPureReactComponent = !0;
var $e6e5881a45ab9908$var$I = Array.isArray, $e6e5881a45ab9908$var$J = Object.prototype.hasOwnProperty, $e6e5881a45ab9908$var$K = {
    current: null
}, $e6e5881a45ab9908$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $e6e5881a45ab9908$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$e6e5881a45ab9908$var$J.call(b, d) && !$e6e5881a45ab9908$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $e6e5881a45ab9908$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $e6e5881a45ab9908$var$K.current
    };
}
function $e6e5881a45ab9908$var$N(a, b) {
    return {
        $$typeof: $e6e5881a45ab9908$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $e6e5881a45ab9908$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $e6e5881a45ab9908$var$l;
}
function $e6e5881a45ab9908$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $e6e5881a45ab9908$var$P = /\/+/g;
function $e6e5881a45ab9908$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $e6e5881a45ab9908$var$escape("" + a.key) : b.toString(36);
}
function $e6e5881a45ab9908$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $e6e5881a45ab9908$var$l:
                case $e6e5881a45ab9908$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $e6e5881a45ab9908$var$Q(h, 0) : d, $e6e5881a45ab9908$var$I(c) ? (e = "", null != a && (e = a.replace($e6e5881a45ab9908$var$P, "$&/") + "/"), $e6e5881a45ab9908$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($e6e5881a45ab9908$var$O(c) && (c = $e6e5881a45ab9908$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($e6e5881a45ab9908$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($e6e5881a45ab9908$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $e6e5881a45ab9908$var$Q(k, g);
        h += $e6e5881a45ab9908$var$R(k, b, e, f, c);
    }
    else if (f = $e6e5881a45ab9908$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $e6e5881a45ab9908$var$Q(k, g++), h += $e6e5881a45ab9908$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $e6e5881a45ab9908$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $e6e5881a45ab9908$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $e6e5881a45ab9908$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $e6e5881a45ab9908$var$U = {
    current: null
}, $e6e5881a45ab9908$var$V = {
    transition: null
}, $e6e5881a45ab9908$var$W = {
    ReactCurrentDispatcher: $e6e5881a45ab9908$var$U,
    ReactCurrentBatchConfig: $e6e5881a45ab9908$var$V,
    ReactCurrentOwner: $e6e5881a45ab9908$var$K
};
function $e6e5881a45ab9908$var$X() {
    throw Error("act(...) is not supported in production builds of React.");
}
$e6e5881a45ab9908$export$dca3b0875bd9a954 = {
    map: $e6e5881a45ab9908$var$S,
    forEach: function(a, b, e) {
        $e6e5881a45ab9908$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $e6e5881a45ab9908$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $e6e5881a45ab9908$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$e6e5881a45ab9908$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$e6e5881a45ab9908$export$16fa2f45be04daa8 = $e6e5881a45ab9908$var$E;
$e6e5881a45ab9908$export$ffb0004e005737fa = $e6e5881a45ab9908$var$p;
$e6e5881a45ab9908$export$e2c29f18771995cb = $e6e5881a45ab9908$var$r;
$e6e5881a45ab9908$export$221d75b3f55bb0bd = $e6e5881a45ab9908$var$G;
$e6e5881a45ab9908$export$5f8d39834fd61797 = $e6e5881a45ab9908$var$q;
$e6e5881a45ab9908$export$74bf444e3cd11ea5 = $e6e5881a45ab9908$var$w;
$e6e5881a45ab9908$export$ae55be85d98224ed = $e6e5881a45ab9908$var$W;
$e6e5881a45ab9908$export$3ba232387fd5d6dd = $e6e5881a45ab9908$var$X;
$e6e5881a45ab9908$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $e6e5881a45ab9908$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $e6e5881a45ab9908$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$e6e5881a45ab9908$var$J.call(b, f) && !$e6e5881a45ab9908$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $e6e5881a45ab9908$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$e6e5881a45ab9908$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $e6e5881a45ab9908$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $e6e5881a45ab9908$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$e6e5881a45ab9908$export$c8a8987d4410bf2d = $e6e5881a45ab9908$var$M;
$e6e5881a45ab9908$export$d38cd72104c1f0e9 = function(a) {
    var b = $e6e5881a45ab9908$var$M.bind(null, a);
    b.type = a;
    return b;
};
$e6e5881a45ab9908$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$e6e5881a45ab9908$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $e6e5881a45ab9908$var$v,
        render: a
    };
};
$e6e5881a45ab9908$export$a8257692ac88316c = $e6e5881a45ab9908$var$O;
$e6e5881a45ab9908$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $e6e5881a45ab9908$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $e6e5881a45ab9908$var$T
    };
};
$e6e5881a45ab9908$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $e6e5881a45ab9908$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$e6e5881a45ab9908$export$7568632d0d33d16d = function(a) {
    var b = $e6e5881a45ab9908$var$V.transition;
    $e6e5881a45ab9908$var$V.transition = {};
    try {
        a();
    } finally{
        $e6e5881a45ab9908$var$V.transition = b;
    }
};
$e6e5881a45ab9908$export$88948ce120ea2619 = $e6e5881a45ab9908$var$X;
$e6e5881a45ab9908$export$35808ee640e87ca7 = function(a, b) {
    return $e6e5881a45ab9908$var$U.current.useCallback(a, b);
};
$e6e5881a45ab9908$export$fae74005e78b1a27 = function(a) {
    return $e6e5881a45ab9908$var$U.current.useContext(a);
};
$e6e5881a45ab9908$export$dc8fbce3eb94dc1e = function() {};
$e6e5881a45ab9908$export$6a7bc4e911dc01cf = function(a) {
    return $e6e5881a45ab9908$var$U.current.useDeferredValue(a);
};
$e6e5881a45ab9908$export$6d9c69b0de29b591 = function(a, b) {
    return $e6e5881a45ab9908$var$U.current.useEffect(a, b);
};
$e6e5881a45ab9908$export$f680877a34711e37 = function() {
    return $e6e5881a45ab9908$var$U.current.useId();
};
$e6e5881a45ab9908$export$d5a552a76deda3c2 = function(a, b, e) {
    return $e6e5881a45ab9908$var$U.current.useImperativeHandle(a, b, e);
};
$e6e5881a45ab9908$export$aaabe4eda9ed9969 = function(a, b) {
    return $e6e5881a45ab9908$var$U.current.useInsertionEffect(a, b);
};
$e6e5881a45ab9908$export$e5c5a5f917a5871c = function(a, b) {
    return $e6e5881a45ab9908$var$U.current.useLayoutEffect(a, b);
};
$e6e5881a45ab9908$export$1538c33de8887b59 = function(a, b) {
    return $e6e5881a45ab9908$var$U.current.useMemo(a, b);
};
$e6e5881a45ab9908$export$13e3392192263954 = function(a, b, e) {
    return $e6e5881a45ab9908$var$U.current.useReducer(a, b, e);
};
$e6e5881a45ab9908$export$b8f5890fc79d6aca = function(a) {
    return $e6e5881a45ab9908$var$U.current.useRef(a);
};
$e6e5881a45ab9908$export$60241385465d0a34 = function(a) {
    return $e6e5881a45ab9908$var$U.current.useState(a);
};
$e6e5881a45ab9908$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $e6e5881a45ab9908$var$U.current.useSyncExternalStore(a, b, e);
};
$e6e5881a45ab9908$export$7b286972b8d8ccbf = function() {
    return $e6e5881a45ab9908$var$U.current.useTransition();
};
$e6e5881a45ab9908$export$83d89fbfd8236492 = "18.3.1";

});



parcelRegister("foXlc", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $b36720cd87d29ff4$export$ae55be85d98224ed; }, function (v) { return $b36720cd87d29ff4$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "createPortal", function () { return $b36720cd87d29ff4$export$d39a5bbd09211389; }, function (v) { return $b36720cd87d29ff4$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "createRoot", function () { return $b36720cd87d29ff4$export$882461b6382ed46c; }, function (v) { return $b36720cd87d29ff4$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "findDOMNode", function () { return $b36720cd87d29ff4$export$466bfc07425424d5; }, function (v) { return $b36720cd87d29ff4$export$466bfc07425424d5 = v; });
$parcel$export(module.exports, "flushSync", function () { return $b36720cd87d29ff4$export$cd75ccfd720a3cd4; }, function (v) { return $b36720cd87d29ff4$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "hydrate", function () { return $b36720cd87d29ff4$export$fa8d919ba61d84db; }, function (v) { return $b36720cd87d29ff4$export$fa8d919ba61d84db = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $b36720cd87d29ff4$export$757ceba2d55c277e; }, function (v) { return $b36720cd87d29ff4$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "render", function () { return $b36720cd87d29ff4$export$b3890eb0ae9dca99; }, function (v) { return $b36720cd87d29ff4$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "unmountComponentAtNode", function () { return $b36720cd87d29ff4$export$502457920280e6be; }, function (v) { return $b36720cd87d29ff4$export$502457920280e6be = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $b36720cd87d29ff4$export$c78a37762a8d58e1; }, function (v) { return $b36720cd87d29ff4$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", function () { return $b36720cd87d29ff4$export$dc54d992c10e8a18; }, function (v) { return $b36720cd87d29ff4$export$dc54d992c10e8a18 = v; });
$parcel$export(module.exports, "version", function () { return $b36720cd87d29ff4$export$83d89fbfd8236492; }, function (v) { return $b36720cd87d29ff4$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $b36720cd87d29ff4$export$ae55be85d98224ed;
var $b36720cd87d29ff4$export$d39a5bbd09211389;
var $b36720cd87d29ff4$export$882461b6382ed46c;
var $b36720cd87d29ff4$export$466bfc07425424d5;
var $b36720cd87d29ff4$export$cd75ccfd720a3cd4;
var $b36720cd87d29ff4$export$fa8d919ba61d84db;
var $b36720cd87d29ff4$export$757ceba2d55c277e;
var $b36720cd87d29ff4$export$b3890eb0ae9dca99;
var $b36720cd87d29ff4$export$502457920280e6be;
var $b36720cd87d29ff4$export$c78a37762a8d58e1;
var $b36720cd87d29ff4$export$dc54d992c10e8a18;
var $b36720cd87d29ff4$export$83d89fbfd8236492;
'use strict';

var $4Y8Vu = parcelRequire("4Y8Vu");

var $ke6Ab = parcelRequire("ke6Ab");
function $b36720cd87d29ff4$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $b36720cd87d29ff4$var$da = new Set, $b36720cd87d29ff4$var$ea = {};
function $b36720cd87d29ff4$var$fa(a, b) {
    $b36720cd87d29ff4$var$ha(a, b);
    $b36720cd87d29ff4$var$ha(a + "Capture", b);
}
function $b36720cd87d29ff4$var$ha(a, b) {
    $b36720cd87d29ff4$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$b36720cd87d29ff4$var$da.add(b[a]);
}
var $b36720cd87d29ff4$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $b36720cd87d29ff4$var$ja = Object.prototype.hasOwnProperty, $b36720cd87d29ff4$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $b36720cd87d29ff4$var$la = {}, $b36720cd87d29ff4$var$ma = {};
function $b36720cd87d29ff4$var$oa(a) {
    if ($b36720cd87d29ff4$var$ja.call($b36720cd87d29ff4$var$ma, a)) return !0;
    if ($b36720cd87d29ff4$var$ja.call($b36720cd87d29ff4$var$la, a)) return !1;
    if ($b36720cd87d29ff4$var$ka.test(a)) return $b36720cd87d29ff4$var$ma[a] = !0;
    $b36720cd87d29ff4$var$la[a] = !0;
    return !1;
}
function $b36720cd87d29ff4$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $b36720cd87d29ff4$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $b36720cd87d29ff4$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $b36720cd87d29ff4$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $b36720cd87d29ff4$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $b36720cd87d29ff4$var$z[a] = new $b36720cd87d29ff4$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $b36720cd87d29ff4$var$z[b] = new $b36720cd87d29ff4$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $b36720cd87d29ff4$var$z[a] = new $b36720cd87d29ff4$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $b36720cd87d29ff4$var$z[a] = new $b36720cd87d29ff4$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $b36720cd87d29ff4$var$z[a] = new $b36720cd87d29ff4$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $b36720cd87d29ff4$var$z[a] = new $b36720cd87d29ff4$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $b36720cd87d29ff4$var$z[a] = new $b36720cd87d29ff4$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $b36720cd87d29ff4$var$z[a] = new $b36720cd87d29ff4$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $b36720cd87d29ff4$var$z[a] = new $b36720cd87d29ff4$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $b36720cd87d29ff4$var$ra = /[\-:]([a-z])/g;
function $b36720cd87d29ff4$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($b36720cd87d29ff4$var$ra, $b36720cd87d29ff4$var$sa);
    $b36720cd87d29ff4$var$z[b] = new $b36720cd87d29ff4$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($b36720cd87d29ff4$var$ra, $b36720cd87d29ff4$var$sa);
    $b36720cd87d29ff4$var$z[b] = new $b36720cd87d29ff4$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($b36720cd87d29ff4$var$ra, $b36720cd87d29ff4$var$sa);
    $b36720cd87d29ff4$var$z[b] = new $b36720cd87d29ff4$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $b36720cd87d29ff4$var$z[a] = new $b36720cd87d29ff4$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$b36720cd87d29ff4$var$z.xlinkHref = new $b36720cd87d29ff4$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $b36720cd87d29ff4$var$z[a] = new $b36720cd87d29ff4$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $b36720cd87d29ff4$var$ta(a, b, c, d) {
    var e = $b36720cd87d29ff4$var$z.hasOwnProperty(b) ? $b36720cd87d29ff4$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $b36720cd87d29ff4$var$qa(b, c, e, d) && (c = null), d || null === e ? $b36720cd87d29ff4$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $b36720cd87d29ff4$var$ua = $4Y8Vu.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $b36720cd87d29ff4$var$va = Symbol.for("react.element"), $b36720cd87d29ff4$var$wa = Symbol.for("react.portal"), $b36720cd87d29ff4$var$ya = Symbol.for("react.fragment"), $b36720cd87d29ff4$var$za = Symbol.for("react.strict_mode"), $b36720cd87d29ff4$var$Aa = Symbol.for("react.profiler"), $b36720cd87d29ff4$var$Ba = Symbol.for("react.provider"), $b36720cd87d29ff4$var$Ca = Symbol.for("react.context"), $b36720cd87d29ff4$var$Da = Symbol.for("react.forward_ref"), $b36720cd87d29ff4$var$Ea = Symbol.for("react.suspense"), $b36720cd87d29ff4$var$Fa = Symbol.for("react.suspense_list"), $b36720cd87d29ff4$var$Ga = Symbol.for("react.memo"), $b36720cd87d29ff4$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $b36720cd87d29ff4$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $b36720cd87d29ff4$var$Ja = Symbol.iterator;
function $b36720cd87d29ff4$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $b36720cd87d29ff4$var$Ja && a[$b36720cd87d29ff4$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $b36720cd87d29ff4$var$A = Object.assign, $b36720cd87d29ff4$var$La;
function $b36720cd87d29ff4$var$Ma(a) {
    if (void 0 === $b36720cd87d29ff4$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $b36720cd87d29ff4$var$La = b && b[1] || "";
    }
    return "\n" + $b36720cd87d29ff4$var$La + a;
}
var $b36720cd87d29ff4$var$Na = !1;
function $b36720cd87d29ff4$var$Oa(a, b) {
    if (!a || $b36720cd87d29ff4$var$Na) return "";
    $b36720cd87d29ff4$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $b36720cd87d29ff4$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $b36720cd87d29ff4$var$Ma(a) : "";
}
function $b36720cd87d29ff4$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $b36720cd87d29ff4$var$Ma(a.type);
        case 16:
            return $b36720cd87d29ff4$var$Ma("Lazy");
        case 13:
            return $b36720cd87d29ff4$var$Ma("Suspense");
        case 19:
            return $b36720cd87d29ff4$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $b36720cd87d29ff4$var$Oa(a.type, !1), a;
        case 11:
            return a = $b36720cd87d29ff4$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $b36720cd87d29ff4$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $b36720cd87d29ff4$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $b36720cd87d29ff4$var$ya:
            return "Fragment";
        case $b36720cd87d29ff4$var$wa:
            return "Portal";
        case $b36720cd87d29ff4$var$Aa:
            return "Profiler";
        case $b36720cd87d29ff4$var$za:
            return "StrictMode";
        case $b36720cd87d29ff4$var$Ea:
            return "Suspense";
        case $b36720cd87d29ff4$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $b36720cd87d29ff4$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $b36720cd87d29ff4$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $b36720cd87d29ff4$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $b36720cd87d29ff4$var$Ga:
            return b = a.displayName || null, null !== b ? b : $b36720cd87d29ff4$var$Qa(a.type) || "Memo";
        case $b36720cd87d29ff4$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $b36720cd87d29ff4$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $b36720cd87d29ff4$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $b36720cd87d29ff4$var$Qa(b);
        case 8:
            return b === $b36720cd87d29ff4$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $b36720cd87d29ff4$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $b36720cd87d29ff4$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $b36720cd87d29ff4$var$Ua(a) {
    var b = $b36720cd87d29ff4$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $b36720cd87d29ff4$var$Va(a) {
    a._valueTracker || (a._valueTracker = $b36720cd87d29ff4$var$Ua(a));
}
function $b36720cd87d29ff4$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $b36720cd87d29ff4$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $b36720cd87d29ff4$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $b36720cd87d29ff4$var$Ya(a, b) {
    var c = b.checked;
    return $b36720cd87d29ff4$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $b36720cd87d29ff4$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $b36720cd87d29ff4$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $b36720cd87d29ff4$var$ab(a, b) {
    b = b.checked;
    null != b && $b36720cd87d29ff4$var$ta(a, "checked", b, !1);
}
function $b36720cd87d29ff4$var$bb(a, b) {
    $b36720cd87d29ff4$var$ab(a, b);
    var c = $b36720cd87d29ff4$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $b36720cd87d29ff4$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $b36720cd87d29ff4$var$cb(a, b.type, $b36720cd87d29ff4$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $b36720cd87d29ff4$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $b36720cd87d29ff4$var$cb(a, b, c) {
    if ("number" !== b || $b36720cd87d29ff4$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $b36720cd87d29ff4$var$eb = Array.isArray;
function $b36720cd87d29ff4$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $b36720cd87d29ff4$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $b36720cd87d29ff4$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($b36720cd87d29ff4$var$p(91));
    return $b36720cd87d29ff4$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $b36720cd87d29ff4$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($b36720cd87d29ff4$var$p(92));
            if ($b36720cd87d29ff4$var$eb(c)) {
                if (1 < c.length) throw Error($b36720cd87d29ff4$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $b36720cd87d29ff4$var$Sa(c)
    };
}
function $b36720cd87d29ff4$var$ib(a, b) {
    var c = $b36720cd87d29ff4$var$Sa(b.value), d = $b36720cd87d29ff4$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $b36720cd87d29ff4$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $b36720cd87d29ff4$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $b36720cd87d29ff4$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $b36720cd87d29ff4$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $b36720cd87d29ff4$var$mb, $b36720cd87d29ff4$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $b36720cd87d29ff4$var$mb = $b36720cd87d29ff4$var$mb || document.createElement("div");
        $b36720cd87d29ff4$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $b36720cd87d29ff4$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $b36720cd87d29ff4$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $b36720cd87d29ff4$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $b36720cd87d29ff4$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($b36720cd87d29ff4$var$pb).forEach(function(a) {
    $b36720cd87d29ff4$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $b36720cd87d29ff4$var$pb[b] = $b36720cd87d29ff4$var$pb[a];
    });
});
function $b36720cd87d29ff4$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $b36720cd87d29ff4$var$pb.hasOwnProperty(a) && $b36720cd87d29ff4$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $b36720cd87d29ff4$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $b36720cd87d29ff4$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $b36720cd87d29ff4$var$tb = $b36720cd87d29ff4$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $b36720cd87d29ff4$var$ub(a, b) {
    if (b) {
        if ($b36720cd87d29ff4$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($b36720cd87d29ff4$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($b36720cd87d29ff4$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($b36720cd87d29ff4$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($b36720cd87d29ff4$var$p(62));
    }
}
function $b36720cd87d29ff4$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $b36720cd87d29ff4$var$wb = null;
function $b36720cd87d29ff4$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $b36720cd87d29ff4$var$yb = null, $b36720cd87d29ff4$var$zb = null, $b36720cd87d29ff4$var$Ab = null;
function $b36720cd87d29ff4$var$Bb(a) {
    if (a = $b36720cd87d29ff4$var$Cb(a)) {
        if ("function" !== typeof $b36720cd87d29ff4$var$yb) throw Error($b36720cd87d29ff4$var$p(280));
        var b = a.stateNode;
        b && (b = $b36720cd87d29ff4$var$Db(b), $b36720cd87d29ff4$var$yb(a.stateNode, a.type, b));
    }
}
function $b36720cd87d29ff4$var$Eb(a) {
    $b36720cd87d29ff4$var$zb ? $b36720cd87d29ff4$var$Ab ? $b36720cd87d29ff4$var$Ab.push(a) : $b36720cd87d29ff4$var$Ab = [
        a
    ] : $b36720cd87d29ff4$var$zb = a;
}
function $b36720cd87d29ff4$var$Fb() {
    if ($b36720cd87d29ff4$var$zb) {
        var a = $b36720cd87d29ff4$var$zb, b = $b36720cd87d29ff4$var$Ab;
        $b36720cd87d29ff4$var$Ab = $b36720cd87d29ff4$var$zb = null;
        $b36720cd87d29ff4$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$b36720cd87d29ff4$var$Bb(b[a]);
    }
}
function $b36720cd87d29ff4$var$Gb(a, b) {
    return a(b);
}
function $b36720cd87d29ff4$var$Hb() {}
var $b36720cd87d29ff4$var$Ib = !1;
function $b36720cd87d29ff4$var$Jb(a, b, c) {
    if ($b36720cd87d29ff4$var$Ib) return a(b, c);
    $b36720cd87d29ff4$var$Ib = !0;
    try {
        return $b36720cd87d29ff4$var$Gb(a, b, c);
    } finally{
        if ($b36720cd87d29ff4$var$Ib = !1, null !== $b36720cd87d29ff4$var$zb || null !== $b36720cd87d29ff4$var$Ab) $b36720cd87d29ff4$var$Hb(), $b36720cd87d29ff4$var$Fb();
    }
}
function $b36720cd87d29ff4$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $b36720cd87d29ff4$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($b36720cd87d29ff4$var$p(231, b, typeof c));
    return c;
}
var $b36720cd87d29ff4$var$Lb = !1;
if ($b36720cd87d29ff4$var$ia) try {
    var $b36720cd87d29ff4$var$Mb = {};
    Object.defineProperty($b36720cd87d29ff4$var$Mb, "passive", {
        get: function() {
            $b36720cd87d29ff4$var$Lb = !0;
        }
    });
    window.addEventListener("test", $b36720cd87d29ff4$var$Mb, $b36720cd87d29ff4$var$Mb);
    window.removeEventListener("test", $b36720cd87d29ff4$var$Mb, $b36720cd87d29ff4$var$Mb);
} catch (a) {
    $b36720cd87d29ff4$var$Lb = !1;
}
function $b36720cd87d29ff4$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $b36720cd87d29ff4$var$Ob = !1, $b36720cd87d29ff4$var$Pb = null, $b36720cd87d29ff4$var$Qb = !1, $b36720cd87d29ff4$var$Rb = null, $b36720cd87d29ff4$var$Sb = {
    onError: function(a) {
        $b36720cd87d29ff4$var$Ob = !0;
        $b36720cd87d29ff4$var$Pb = a;
    }
};
function $b36720cd87d29ff4$var$Tb(a, b, c, d, e, f, g, h, k) {
    $b36720cd87d29ff4$var$Ob = !1;
    $b36720cd87d29ff4$var$Pb = null;
    $b36720cd87d29ff4$var$Nb.apply($b36720cd87d29ff4$var$Sb, arguments);
}
function $b36720cd87d29ff4$var$Ub(a, b, c, d, e, f, g, h, k) {
    $b36720cd87d29ff4$var$Tb.apply(this, arguments);
    if ($b36720cd87d29ff4$var$Ob) {
        if ($b36720cd87d29ff4$var$Ob) {
            var l = $b36720cd87d29ff4$var$Pb;
            $b36720cd87d29ff4$var$Ob = !1;
            $b36720cd87d29ff4$var$Pb = null;
        } else throw Error($b36720cd87d29ff4$var$p(198));
        $b36720cd87d29ff4$var$Qb || ($b36720cd87d29ff4$var$Qb = !0, $b36720cd87d29ff4$var$Rb = l);
    }
}
function $b36720cd87d29ff4$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $b36720cd87d29ff4$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $b36720cd87d29ff4$var$Xb(a) {
    if ($b36720cd87d29ff4$var$Vb(a) !== a) throw Error($b36720cd87d29ff4$var$p(188));
}
function $b36720cd87d29ff4$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $b36720cd87d29ff4$var$Vb(a);
        if (null === b) throw Error($b36720cd87d29ff4$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $b36720cd87d29ff4$var$Xb(e), a;
                if (f === d) return $b36720cd87d29ff4$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($b36720cd87d29ff4$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($b36720cd87d29ff4$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($b36720cd87d29ff4$var$p(190));
    }
    if (3 !== c.tag) throw Error($b36720cd87d29ff4$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $b36720cd87d29ff4$var$Zb(a) {
    a = $b36720cd87d29ff4$var$Yb(a);
    return null !== a ? $b36720cd87d29ff4$var$$b(a) : null;
}
function $b36720cd87d29ff4$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $b36720cd87d29ff4$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $b36720cd87d29ff4$var$ac = $ke6Ab.unstable_scheduleCallback, $b36720cd87d29ff4$var$bc = $ke6Ab.unstable_cancelCallback, $b36720cd87d29ff4$var$cc = $ke6Ab.unstable_shouldYield, $b36720cd87d29ff4$var$dc = $ke6Ab.unstable_requestPaint, $b36720cd87d29ff4$var$B = $ke6Ab.unstable_now, $b36720cd87d29ff4$var$ec = $ke6Ab.unstable_getCurrentPriorityLevel, $b36720cd87d29ff4$var$fc = $ke6Ab.unstable_ImmediatePriority, $b36720cd87d29ff4$var$gc = $ke6Ab.unstable_UserBlockingPriority, $b36720cd87d29ff4$var$hc = $ke6Ab.unstable_NormalPriority, $b36720cd87d29ff4$var$ic = $ke6Ab.unstable_LowPriority, $b36720cd87d29ff4$var$jc = $ke6Ab.unstable_IdlePriority, $b36720cd87d29ff4$var$kc = null, $b36720cd87d29ff4$var$lc = null;
function $b36720cd87d29ff4$var$mc(a) {
    if ($b36720cd87d29ff4$var$lc && "function" === typeof $b36720cd87d29ff4$var$lc.onCommitFiberRoot) try {
        $b36720cd87d29ff4$var$lc.onCommitFiberRoot($b36720cd87d29ff4$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $b36720cd87d29ff4$var$oc = Math.clz32 ? Math.clz32 : $b36720cd87d29ff4$var$nc, $b36720cd87d29ff4$var$pc = Math.log, $b36720cd87d29ff4$var$qc = Math.LN2;
function $b36720cd87d29ff4$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($b36720cd87d29ff4$var$pc(a) / $b36720cd87d29ff4$var$qc | 0) | 0;
}
var $b36720cd87d29ff4$var$rc = 64, $b36720cd87d29ff4$var$sc = 4194304;
function $b36720cd87d29ff4$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $b36720cd87d29ff4$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $b36720cd87d29ff4$var$tc(h) : (f &= g, 0 !== f && (d = $b36720cd87d29ff4$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $b36720cd87d29ff4$var$tc(g) : 0 !== f && (d = $b36720cd87d29ff4$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $b36720cd87d29ff4$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $b36720cd87d29ff4$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $b36720cd87d29ff4$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $b36720cd87d29ff4$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $b36720cd87d29ff4$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $b36720cd87d29ff4$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $b36720cd87d29ff4$var$yc() {
    var a = $b36720cd87d29ff4$var$rc;
    $b36720cd87d29ff4$var$rc <<= 1;
    0 === ($b36720cd87d29ff4$var$rc & 4194240) && ($b36720cd87d29ff4$var$rc = 64);
    return a;
}
function $b36720cd87d29ff4$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $b36720cd87d29ff4$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $b36720cd87d29ff4$var$oc(b);
    a[b] = c;
}
function $b36720cd87d29ff4$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $b36720cd87d29ff4$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $b36720cd87d29ff4$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $b36720cd87d29ff4$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $b36720cd87d29ff4$var$C = 0;
function $b36720cd87d29ff4$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $b36720cd87d29ff4$var$Ec, $b36720cd87d29ff4$var$Fc, $b36720cd87d29ff4$var$Gc, $b36720cd87d29ff4$var$Hc, $b36720cd87d29ff4$var$Ic, $b36720cd87d29ff4$var$Jc = !1, $b36720cd87d29ff4$var$Kc = [], $b36720cd87d29ff4$var$Lc = null, $b36720cd87d29ff4$var$Mc = null, $b36720cd87d29ff4$var$Nc = null, $b36720cd87d29ff4$var$Oc = new Map, $b36720cd87d29ff4$var$Pc = new Map, $b36720cd87d29ff4$var$Qc = [], $b36720cd87d29ff4$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $b36720cd87d29ff4$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $b36720cd87d29ff4$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $b36720cd87d29ff4$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $b36720cd87d29ff4$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $b36720cd87d29ff4$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $b36720cd87d29ff4$var$Pc.delete(b.pointerId);
    }
}
function $b36720cd87d29ff4$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $b36720cd87d29ff4$var$Cb(b), null !== b && $b36720cd87d29ff4$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $b36720cd87d29ff4$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $b36720cd87d29ff4$var$Lc = $b36720cd87d29ff4$var$Tc($b36720cd87d29ff4$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $b36720cd87d29ff4$var$Mc = $b36720cd87d29ff4$var$Tc($b36720cd87d29ff4$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $b36720cd87d29ff4$var$Nc = $b36720cd87d29ff4$var$Tc($b36720cd87d29ff4$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $b36720cd87d29ff4$var$Oc.set(f, $b36720cd87d29ff4$var$Tc($b36720cd87d29ff4$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $b36720cd87d29ff4$var$Pc.set(f, $b36720cd87d29ff4$var$Tc($b36720cd87d29ff4$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $b36720cd87d29ff4$var$Vc(a) {
    var b = $b36720cd87d29ff4$var$Wc(a.target);
    if (null !== b) {
        var c = $b36720cd87d29ff4$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $b36720cd87d29ff4$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $b36720cd87d29ff4$var$Ic(a.priority, function() {
                        $b36720cd87d29ff4$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $b36720cd87d29ff4$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $b36720cd87d29ff4$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $b36720cd87d29ff4$var$wb = d;
            c.target.dispatchEvent(d);
            $b36720cd87d29ff4$var$wb = null;
        } else return b = $b36720cd87d29ff4$var$Cb(c), null !== b && $b36720cd87d29ff4$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $b36720cd87d29ff4$var$Zc(a, b, c) {
    $b36720cd87d29ff4$var$Xc(a) && c.delete(b);
}
function $b36720cd87d29ff4$var$$c() {
    $b36720cd87d29ff4$var$Jc = !1;
    null !== $b36720cd87d29ff4$var$Lc && $b36720cd87d29ff4$var$Xc($b36720cd87d29ff4$var$Lc) && ($b36720cd87d29ff4$var$Lc = null);
    null !== $b36720cd87d29ff4$var$Mc && $b36720cd87d29ff4$var$Xc($b36720cd87d29ff4$var$Mc) && ($b36720cd87d29ff4$var$Mc = null);
    null !== $b36720cd87d29ff4$var$Nc && $b36720cd87d29ff4$var$Xc($b36720cd87d29ff4$var$Nc) && ($b36720cd87d29ff4$var$Nc = null);
    $b36720cd87d29ff4$var$Oc.forEach($b36720cd87d29ff4$var$Zc);
    $b36720cd87d29ff4$var$Pc.forEach($b36720cd87d29ff4$var$Zc);
}
function $b36720cd87d29ff4$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $b36720cd87d29ff4$var$Jc || ($b36720cd87d29ff4$var$Jc = !0, $ke6Ab.unstable_scheduleCallback($ke6Ab.unstable_NormalPriority, $b36720cd87d29ff4$var$$c)));
}
function $b36720cd87d29ff4$var$bd(a) {
    function b(b) {
        return $b36720cd87d29ff4$var$ad(b, a);
    }
    if (0 < $b36720cd87d29ff4$var$Kc.length) {
        $b36720cd87d29ff4$var$ad($b36720cd87d29ff4$var$Kc[0], a);
        for(var c = 1; c < $b36720cd87d29ff4$var$Kc.length; c++){
            var d = $b36720cd87d29ff4$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $b36720cd87d29ff4$var$Lc && $b36720cd87d29ff4$var$ad($b36720cd87d29ff4$var$Lc, a);
    null !== $b36720cd87d29ff4$var$Mc && $b36720cd87d29ff4$var$ad($b36720cd87d29ff4$var$Mc, a);
    null !== $b36720cd87d29ff4$var$Nc && $b36720cd87d29ff4$var$ad($b36720cd87d29ff4$var$Nc, a);
    $b36720cd87d29ff4$var$Oc.forEach(b);
    $b36720cd87d29ff4$var$Pc.forEach(b);
    for(c = 0; c < $b36720cd87d29ff4$var$Qc.length; c++)d = $b36720cd87d29ff4$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $b36720cd87d29ff4$var$Qc.length && (c = $b36720cd87d29ff4$var$Qc[0], null === c.blockedOn);)$b36720cd87d29ff4$var$Vc(c), null === c.blockedOn && $b36720cd87d29ff4$var$Qc.shift();
}
var $b36720cd87d29ff4$var$cd = $b36720cd87d29ff4$var$ua.ReactCurrentBatchConfig, $b36720cd87d29ff4$var$dd = !0;
function $b36720cd87d29ff4$var$ed(a, b, c, d) {
    var e = $b36720cd87d29ff4$var$C, f = $b36720cd87d29ff4$var$cd.transition;
    $b36720cd87d29ff4$var$cd.transition = null;
    try {
        $b36720cd87d29ff4$var$C = 1, $b36720cd87d29ff4$var$fd(a, b, c, d);
    } finally{
        $b36720cd87d29ff4$var$C = e, $b36720cd87d29ff4$var$cd.transition = f;
    }
}
function $b36720cd87d29ff4$var$gd(a, b, c, d) {
    var e = $b36720cd87d29ff4$var$C, f = $b36720cd87d29ff4$var$cd.transition;
    $b36720cd87d29ff4$var$cd.transition = null;
    try {
        $b36720cd87d29ff4$var$C = 4, $b36720cd87d29ff4$var$fd(a, b, c, d);
    } finally{
        $b36720cd87d29ff4$var$C = e, $b36720cd87d29ff4$var$cd.transition = f;
    }
}
function $b36720cd87d29ff4$var$fd(a, b, c, d) {
    if ($b36720cd87d29ff4$var$dd) {
        var e = $b36720cd87d29ff4$var$Yc(a, b, c, d);
        if (null === e) $b36720cd87d29ff4$var$hd(a, b, d, $b36720cd87d29ff4$var$id, c), $b36720cd87d29ff4$var$Sc(a, d);
        else if ($b36720cd87d29ff4$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($b36720cd87d29ff4$var$Sc(a, d), b & 4 && -1 < $b36720cd87d29ff4$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $b36720cd87d29ff4$var$Cb(e);
                null !== f && $b36720cd87d29ff4$var$Ec(f);
                f = $b36720cd87d29ff4$var$Yc(a, b, c, d);
                null === f && $b36720cd87d29ff4$var$hd(a, b, d, $b36720cd87d29ff4$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $b36720cd87d29ff4$var$hd(a, b, d, null, c);
    }
}
var $b36720cd87d29ff4$var$id = null;
function $b36720cd87d29ff4$var$Yc(a, b, c, d) {
    $b36720cd87d29ff4$var$id = null;
    a = $b36720cd87d29ff4$var$xb(d);
    a = $b36720cd87d29ff4$var$Wc(a);
    if (null !== a) {
        if (b = $b36720cd87d29ff4$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $b36720cd87d29ff4$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $b36720cd87d29ff4$var$id = a;
    return null;
}
function $b36720cd87d29ff4$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($b36720cd87d29ff4$var$ec()){
                case $b36720cd87d29ff4$var$fc:
                    return 1;
                case $b36720cd87d29ff4$var$gc:
                    return 4;
                case $b36720cd87d29ff4$var$hc:
                case $b36720cd87d29ff4$var$ic:
                    return 16;
                case $b36720cd87d29ff4$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $b36720cd87d29ff4$var$kd = null, $b36720cd87d29ff4$var$ld = null, $b36720cd87d29ff4$var$md = null;
function $b36720cd87d29ff4$var$nd() {
    if ($b36720cd87d29ff4$var$md) return $b36720cd87d29ff4$var$md;
    var a, b = $b36720cd87d29ff4$var$ld, c = b.length, d, e = "value" in $b36720cd87d29ff4$var$kd ? $b36720cd87d29ff4$var$kd.value : $b36720cd87d29ff4$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $b36720cd87d29ff4$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $b36720cd87d29ff4$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $b36720cd87d29ff4$var$pd() {
    return !0;
}
function $b36720cd87d29ff4$var$qd() {
    return !1;
}
function $b36720cd87d29ff4$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $b36720cd87d29ff4$var$pd : $b36720cd87d29ff4$var$qd;
        this.isPropagationStopped = $b36720cd87d29ff4$var$qd;
        return this;
    }
    $b36720cd87d29ff4$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $b36720cd87d29ff4$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $b36720cd87d29ff4$var$pd);
        },
        persist: function() {},
        isPersistent: $b36720cd87d29ff4$var$pd
    });
    return b;
}
var $b36720cd87d29ff4$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $b36720cd87d29ff4$var$td = $b36720cd87d29ff4$var$rd($b36720cd87d29ff4$var$sd), $b36720cd87d29ff4$var$ud = $b36720cd87d29ff4$var$A({}, $b36720cd87d29ff4$var$sd, {
    view: 0,
    detail: 0
}), $b36720cd87d29ff4$var$vd = $b36720cd87d29ff4$var$rd($b36720cd87d29ff4$var$ud), $b36720cd87d29ff4$var$wd, $b36720cd87d29ff4$var$xd, $b36720cd87d29ff4$var$yd, $b36720cd87d29ff4$var$Ad = $b36720cd87d29ff4$var$A({}, $b36720cd87d29ff4$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $b36720cd87d29ff4$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $b36720cd87d29ff4$var$yd && ($b36720cd87d29ff4$var$yd && "mousemove" === a.type ? ($b36720cd87d29ff4$var$wd = a.screenX - $b36720cd87d29ff4$var$yd.screenX, $b36720cd87d29ff4$var$xd = a.screenY - $b36720cd87d29ff4$var$yd.screenY) : $b36720cd87d29ff4$var$xd = $b36720cd87d29ff4$var$wd = 0, $b36720cd87d29ff4$var$yd = a);
        return $b36720cd87d29ff4$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $b36720cd87d29ff4$var$xd;
    }
}), $b36720cd87d29ff4$var$Bd = $b36720cd87d29ff4$var$rd($b36720cd87d29ff4$var$Ad), $b36720cd87d29ff4$var$Cd = $b36720cd87d29ff4$var$A({}, $b36720cd87d29ff4$var$Ad, {
    dataTransfer: 0
}), $b36720cd87d29ff4$var$Dd = $b36720cd87d29ff4$var$rd($b36720cd87d29ff4$var$Cd), $b36720cd87d29ff4$var$Ed = $b36720cd87d29ff4$var$A({}, $b36720cd87d29ff4$var$ud, {
    relatedTarget: 0
}), $b36720cd87d29ff4$var$Fd = $b36720cd87d29ff4$var$rd($b36720cd87d29ff4$var$Ed), $b36720cd87d29ff4$var$Gd = $b36720cd87d29ff4$var$A({}, $b36720cd87d29ff4$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $b36720cd87d29ff4$var$Hd = $b36720cd87d29ff4$var$rd($b36720cd87d29ff4$var$Gd), $b36720cd87d29ff4$var$Id = $b36720cd87d29ff4$var$A({}, $b36720cd87d29ff4$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $b36720cd87d29ff4$var$Jd = $b36720cd87d29ff4$var$rd($b36720cd87d29ff4$var$Id), $b36720cd87d29ff4$var$Kd = $b36720cd87d29ff4$var$A({}, $b36720cd87d29ff4$var$sd, {
    data: 0
}), $b36720cd87d29ff4$var$Ld = $b36720cd87d29ff4$var$rd($b36720cd87d29ff4$var$Kd), $b36720cd87d29ff4$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $b36720cd87d29ff4$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $b36720cd87d29ff4$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $b36720cd87d29ff4$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $b36720cd87d29ff4$var$Od[a]) ? !!b[a] : !1;
}
function $b36720cd87d29ff4$var$zd() {
    return $b36720cd87d29ff4$var$Pd;
}
var $b36720cd87d29ff4$var$Qd = $b36720cd87d29ff4$var$A({}, $b36720cd87d29ff4$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $b36720cd87d29ff4$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $b36720cd87d29ff4$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $b36720cd87d29ff4$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $b36720cd87d29ff4$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $b36720cd87d29ff4$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $b36720cd87d29ff4$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $b36720cd87d29ff4$var$Rd = $b36720cd87d29ff4$var$rd($b36720cd87d29ff4$var$Qd), $b36720cd87d29ff4$var$Sd = $b36720cd87d29ff4$var$A({}, $b36720cd87d29ff4$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $b36720cd87d29ff4$var$Td = $b36720cd87d29ff4$var$rd($b36720cd87d29ff4$var$Sd), $b36720cd87d29ff4$var$Ud = $b36720cd87d29ff4$var$A({}, $b36720cd87d29ff4$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $b36720cd87d29ff4$var$zd
}), $b36720cd87d29ff4$var$Vd = $b36720cd87d29ff4$var$rd($b36720cd87d29ff4$var$Ud), $b36720cd87d29ff4$var$Wd = $b36720cd87d29ff4$var$A({}, $b36720cd87d29ff4$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $b36720cd87d29ff4$var$Xd = $b36720cd87d29ff4$var$rd($b36720cd87d29ff4$var$Wd), $b36720cd87d29ff4$var$Yd = $b36720cd87d29ff4$var$A({}, $b36720cd87d29ff4$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $b36720cd87d29ff4$var$Zd = $b36720cd87d29ff4$var$rd($b36720cd87d29ff4$var$Yd), $b36720cd87d29ff4$var$$d = [
    9,
    13,
    27,
    32
], $b36720cd87d29ff4$var$ae = $b36720cd87d29ff4$var$ia && "CompositionEvent" in window, $b36720cd87d29ff4$var$be = null;
$b36720cd87d29ff4$var$ia && "documentMode" in document && ($b36720cd87d29ff4$var$be = document.documentMode);
var $b36720cd87d29ff4$var$ce = $b36720cd87d29ff4$var$ia && "TextEvent" in window && !$b36720cd87d29ff4$var$be, $b36720cd87d29ff4$var$de = $b36720cd87d29ff4$var$ia && (!$b36720cd87d29ff4$var$ae || $b36720cd87d29ff4$var$be && 8 < $b36720cd87d29ff4$var$be && 11 >= $b36720cd87d29ff4$var$be), $b36720cd87d29ff4$var$ee = String.fromCharCode(32), $b36720cd87d29ff4$var$fe = !1;
function $b36720cd87d29ff4$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $b36720cd87d29ff4$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $b36720cd87d29ff4$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $b36720cd87d29ff4$var$ie = !1;
function $b36720cd87d29ff4$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $b36720cd87d29ff4$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $b36720cd87d29ff4$var$fe = !0;
            return $b36720cd87d29ff4$var$ee;
        case "textInput":
            return a = b.data, a === $b36720cd87d29ff4$var$ee && $b36720cd87d29ff4$var$fe ? null : a;
        default:
            return null;
    }
}
function $b36720cd87d29ff4$var$ke(a, b) {
    if ($b36720cd87d29ff4$var$ie) return "compositionend" === a || !$b36720cd87d29ff4$var$ae && $b36720cd87d29ff4$var$ge(a, b) ? (a = $b36720cd87d29ff4$var$nd(), $b36720cd87d29ff4$var$md = $b36720cd87d29ff4$var$ld = $b36720cd87d29ff4$var$kd = null, $b36720cd87d29ff4$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $b36720cd87d29ff4$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $b36720cd87d29ff4$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $b36720cd87d29ff4$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$b36720cd87d29ff4$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $b36720cd87d29ff4$var$ne(a, b, c, d) {
    $b36720cd87d29ff4$var$Eb(d);
    b = $b36720cd87d29ff4$var$oe(b, "onChange");
    0 < b.length && (c = new $b36720cd87d29ff4$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $b36720cd87d29ff4$var$pe = null, $b36720cd87d29ff4$var$qe = null;
function $b36720cd87d29ff4$var$re(a) {
    $b36720cd87d29ff4$var$se(a, 0);
}
function $b36720cd87d29ff4$var$te(a) {
    var b = $b36720cd87d29ff4$var$ue(a);
    if ($b36720cd87d29ff4$var$Wa(b)) return a;
}
function $b36720cd87d29ff4$var$ve(a, b) {
    if ("change" === a) return b;
}
var $b36720cd87d29ff4$var$we = !1;
if ($b36720cd87d29ff4$var$ia) {
    var $b36720cd87d29ff4$var$xe;
    if ($b36720cd87d29ff4$var$ia) {
        var $b36720cd87d29ff4$var$ye = "oninput" in document;
        if (!$b36720cd87d29ff4$var$ye) {
            var $b36720cd87d29ff4$var$ze = document.createElement("div");
            $b36720cd87d29ff4$var$ze.setAttribute("oninput", "return;");
            $b36720cd87d29ff4$var$ye = "function" === typeof $b36720cd87d29ff4$var$ze.oninput;
        }
        $b36720cd87d29ff4$var$xe = $b36720cd87d29ff4$var$ye;
    } else $b36720cd87d29ff4$var$xe = !1;
    $b36720cd87d29ff4$var$we = $b36720cd87d29ff4$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $b36720cd87d29ff4$var$Ae() {
    $b36720cd87d29ff4$var$pe && ($b36720cd87d29ff4$var$pe.detachEvent("onpropertychange", $b36720cd87d29ff4$var$Be), $b36720cd87d29ff4$var$qe = $b36720cd87d29ff4$var$pe = null);
}
function $b36720cd87d29ff4$var$Be(a) {
    if ("value" === a.propertyName && $b36720cd87d29ff4$var$te($b36720cd87d29ff4$var$qe)) {
        var b = [];
        $b36720cd87d29ff4$var$ne(b, $b36720cd87d29ff4$var$qe, a, $b36720cd87d29ff4$var$xb(a));
        $b36720cd87d29ff4$var$Jb($b36720cd87d29ff4$var$re, b);
    }
}
function $b36720cd87d29ff4$var$Ce(a, b, c) {
    "focusin" === a ? ($b36720cd87d29ff4$var$Ae(), $b36720cd87d29ff4$var$pe = b, $b36720cd87d29ff4$var$qe = c, $b36720cd87d29ff4$var$pe.attachEvent("onpropertychange", $b36720cd87d29ff4$var$Be)) : "focusout" === a && $b36720cd87d29ff4$var$Ae();
}
function $b36720cd87d29ff4$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $b36720cd87d29ff4$var$te($b36720cd87d29ff4$var$qe);
}
function $b36720cd87d29ff4$var$Ee(a, b) {
    if ("click" === a) return $b36720cd87d29ff4$var$te(b);
}
function $b36720cd87d29ff4$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $b36720cd87d29ff4$var$te(b);
}
function $b36720cd87d29ff4$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $b36720cd87d29ff4$var$He = "function" === typeof Object.is ? Object.is : $b36720cd87d29ff4$var$Ge;
function $b36720cd87d29ff4$var$Ie(a, b) {
    if ($b36720cd87d29ff4$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$b36720cd87d29ff4$var$ja.call(b, e) || !$b36720cd87d29ff4$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $b36720cd87d29ff4$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $b36720cd87d29ff4$var$Ke(a, b) {
    var c = $b36720cd87d29ff4$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $b36720cd87d29ff4$var$Je(c);
    }
}
function $b36720cd87d29ff4$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $b36720cd87d29ff4$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $b36720cd87d29ff4$var$Me() {
    for(var a = window, b = $b36720cd87d29ff4$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $b36720cd87d29ff4$var$Xa(a.document);
    }
    return b;
}
function $b36720cd87d29ff4$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $b36720cd87d29ff4$var$Oe(a) {
    var b = $b36720cd87d29ff4$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $b36720cd87d29ff4$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $b36720cd87d29ff4$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $b36720cd87d29ff4$var$Ke(c, f);
                var g = $b36720cd87d29ff4$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $b36720cd87d29ff4$var$Pe = $b36720cd87d29ff4$var$ia && "documentMode" in document && 11 >= document.documentMode, $b36720cd87d29ff4$var$Qe = null, $b36720cd87d29ff4$var$Re = null, $b36720cd87d29ff4$var$Se = null, $b36720cd87d29ff4$var$Te = !1;
function $b36720cd87d29ff4$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $b36720cd87d29ff4$var$Te || null == $b36720cd87d29ff4$var$Qe || $b36720cd87d29ff4$var$Qe !== $b36720cd87d29ff4$var$Xa(d) || (d = $b36720cd87d29ff4$var$Qe, "selectionStart" in d && $b36720cd87d29ff4$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $b36720cd87d29ff4$var$Se && $b36720cd87d29ff4$var$Ie($b36720cd87d29ff4$var$Se, d) || ($b36720cd87d29ff4$var$Se = d, d = $b36720cd87d29ff4$var$oe($b36720cd87d29ff4$var$Re, "onSelect"), 0 < d.length && (b = new $b36720cd87d29ff4$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $b36720cd87d29ff4$var$Qe)));
}
function $b36720cd87d29ff4$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $b36720cd87d29ff4$var$We = {
    animationend: $b36720cd87d29ff4$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $b36720cd87d29ff4$var$Ve("Animation", "AnimationIteration"),
    animationstart: $b36720cd87d29ff4$var$Ve("Animation", "AnimationStart"),
    transitionend: $b36720cd87d29ff4$var$Ve("Transition", "TransitionEnd")
}, $b36720cd87d29ff4$var$Xe = {}, $b36720cd87d29ff4$var$Ye = {};
$b36720cd87d29ff4$var$ia && ($b36720cd87d29ff4$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $b36720cd87d29ff4$var$We.animationend.animation, delete $b36720cd87d29ff4$var$We.animationiteration.animation, delete $b36720cd87d29ff4$var$We.animationstart.animation), "TransitionEvent" in window || delete $b36720cd87d29ff4$var$We.transitionend.transition);
function $b36720cd87d29ff4$var$Ze(a) {
    if ($b36720cd87d29ff4$var$Xe[a]) return $b36720cd87d29ff4$var$Xe[a];
    if (!$b36720cd87d29ff4$var$We[a]) return a;
    var b = $b36720cd87d29ff4$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $b36720cd87d29ff4$var$Ye) return $b36720cd87d29ff4$var$Xe[a] = b[c];
    return a;
}
var $b36720cd87d29ff4$var$$e = $b36720cd87d29ff4$var$Ze("animationend"), $b36720cd87d29ff4$var$af = $b36720cd87d29ff4$var$Ze("animationiteration"), $b36720cd87d29ff4$var$bf = $b36720cd87d29ff4$var$Ze("animationstart"), $b36720cd87d29ff4$var$cf = $b36720cd87d29ff4$var$Ze("transitionend"), $b36720cd87d29ff4$var$df = new Map, $b36720cd87d29ff4$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $b36720cd87d29ff4$var$ff(a, b) {
    $b36720cd87d29ff4$var$df.set(a, b);
    $b36720cd87d29ff4$var$fa(b, [
        a
    ]);
}
for(var $b36720cd87d29ff4$var$gf = 0; $b36720cd87d29ff4$var$gf < $b36720cd87d29ff4$var$ef.length; $b36720cd87d29ff4$var$gf++){
    var $b36720cd87d29ff4$var$hf = $b36720cd87d29ff4$var$ef[$b36720cd87d29ff4$var$gf], $b36720cd87d29ff4$var$jf = $b36720cd87d29ff4$var$hf.toLowerCase(), $b36720cd87d29ff4$var$kf = $b36720cd87d29ff4$var$hf[0].toUpperCase() + $b36720cd87d29ff4$var$hf.slice(1);
    $b36720cd87d29ff4$var$ff($b36720cd87d29ff4$var$jf, "on" + $b36720cd87d29ff4$var$kf);
}
$b36720cd87d29ff4$var$ff($b36720cd87d29ff4$var$$e, "onAnimationEnd");
$b36720cd87d29ff4$var$ff($b36720cd87d29ff4$var$af, "onAnimationIteration");
$b36720cd87d29ff4$var$ff($b36720cd87d29ff4$var$bf, "onAnimationStart");
$b36720cd87d29ff4$var$ff("dblclick", "onDoubleClick");
$b36720cd87d29ff4$var$ff("focusin", "onFocus");
$b36720cd87d29ff4$var$ff("focusout", "onBlur");
$b36720cd87d29ff4$var$ff($b36720cd87d29ff4$var$cf, "onTransitionEnd");
$b36720cd87d29ff4$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$b36720cd87d29ff4$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$b36720cd87d29ff4$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$b36720cd87d29ff4$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$b36720cd87d29ff4$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$b36720cd87d29ff4$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$b36720cd87d29ff4$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$b36720cd87d29ff4$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$b36720cd87d29ff4$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$b36720cd87d29ff4$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $b36720cd87d29ff4$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $b36720cd87d29ff4$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($b36720cd87d29ff4$var$lf));
function $b36720cd87d29ff4$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $b36720cd87d29ff4$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $b36720cd87d29ff4$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $b36720cd87d29ff4$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $b36720cd87d29ff4$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($b36720cd87d29ff4$var$Qb) throw a = $b36720cd87d29ff4$var$Rb, $b36720cd87d29ff4$var$Qb = !1, $b36720cd87d29ff4$var$Rb = null, a;
}
function $b36720cd87d29ff4$var$D(a, b) {
    var c = b[$b36720cd87d29ff4$var$of];
    void 0 === c && (c = b[$b36720cd87d29ff4$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($b36720cd87d29ff4$var$pf(b, a, 2, !1), c.add(d));
}
function $b36720cd87d29ff4$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $b36720cd87d29ff4$var$pf(c, a, d, b);
}
var $b36720cd87d29ff4$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $b36720cd87d29ff4$var$sf(a) {
    if (!a[$b36720cd87d29ff4$var$rf]) {
        a[$b36720cd87d29ff4$var$rf] = !0;
        $b36720cd87d29ff4$var$da.forEach(function(b) {
            "selectionchange" !== b && ($b36720cd87d29ff4$var$mf.has(b) || $b36720cd87d29ff4$var$qf(b, !1, a), $b36720cd87d29ff4$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$b36720cd87d29ff4$var$rf] || (b[$b36720cd87d29ff4$var$rf] = !0, $b36720cd87d29ff4$var$qf("selectionchange", !1, b));
    }
}
function $b36720cd87d29ff4$var$pf(a, b, c, d) {
    switch($b36720cd87d29ff4$var$jd(b)){
        case 1:
            var e = $b36720cd87d29ff4$var$ed;
            break;
        case 4:
            e = $b36720cd87d29ff4$var$gd;
            break;
        default:
            e = $b36720cd87d29ff4$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$b36720cd87d29ff4$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $b36720cd87d29ff4$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $b36720cd87d29ff4$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $b36720cd87d29ff4$var$Jb(function() {
        var d = f, e = $b36720cd87d29ff4$var$xb(c), g = [];
        a: {
            var h = $b36720cd87d29ff4$var$df.get(a);
            if (void 0 !== h) {
                var k = $b36720cd87d29ff4$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $b36720cd87d29ff4$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $b36720cd87d29ff4$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $b36720cd87d29ff4$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $b36720cd87d29ff4$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $b36720cd87d29ff4$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $b36720cd87d29ff4$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $b36720cd87d29ff4$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $b36720cd87d29ff4$var$Vd;
                        break;
                    case $b36720cd87d29ff4$var$$e:
                    case $b36720cd87d29ff4$var$af:
                    case $b36720cd87d29ff4$var$bf:
                        k = $b36720cd87d29ff4$var$Hd;
                        break;
                    case $b36720cd87d29ff4$var$cf:
                        k = $b36720cd87d29ff4$var$Xd;
                        break;
                    case "scroll":
                        k = $b36720cd87d29ff4$var$vd;
                        break;
                    case "wheel":
                        k = $b36720cd87d29ff4$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $b36720cd87d29ff4$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $b36720cd87d29ff4$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $b36720cd87d29ff4$var$Kb(w, x), null != F && t.push($b36720cd87d29ff4$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $b36720cd87d29ff4$var$wb && (n = c.relatedTarget || c.fromElement) && ($b36720cd87d29ff4$var$Wc(n) || n[$b36720cd87d29ff4$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $b36720cd87d29ff4$var$Wc(n) : null, null !== n && (J = $b36720cd87d29ff4$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $b36720cd87d29ff4$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $b36720cd87d29ff4$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $b36720cd87d29ff4$var$ue(k);
                        u = null == n ? h : $b36720cd87d29ff4$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $b36720cd87d29ff4$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $b36720cd87d29ff4$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $b36720cd87d29ff4$var$vf(F))u++;
                            for(; 0 < w - u;)t = $b36720cd87d29ff4$var$vf(t), w--;
                            for(; 0 < u - w;)x = $b36720cd87d29ff4$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $b36720cd87d29ff4$var$vf(t);
                                x = $b36720cd87d29ff4$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $b36720cd87d29ff4$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $b36720cd87d29ff4$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $b36720cd87d29ff4$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $b36720cd87d29ff4$var$ve;
                else if ($b36720cd87d29ff4$var$me(h)) {
                    if ($b36720cd87d29ff4$var$we) na = $b36720cd87d29ff4$var$Fe;
                    else {
                        na = $b36720cd87d29ff4$var$De;
                        var xa = $b36720cd87d29ff4$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $b36720cd87d29ff4$var$Ee);
                if (na && (na = na(a, d))) {
                    $b36720cd87d29ff4$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $b36720cd87d29ff4$var$cb(h, "number", h.value);
            }
            xa = d ? $b36720cd87d29ff4$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($b36720cd87d29ff4$var$me(xa) || "true" === xa.contentEditable) $b36720cd87d29ff4$var$Qe = xa, $b36720cd87d29ff4$var$Re = d, $b36720cd87d29ff4$var$Se = null;
                    break;
                case "focusout":
                    $b36720cd87d29ff4$var$Se = $b36720cd87d29ff4$var$Re = $b36720cd87d29ff4$var$Qe = null;
                    break;
                case "mousedown":
                    $b36720cd87d29ff4$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $b36720cd87d29ff4$var$Te = !1;
                    $b36720cd87d29ff4$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($b36720cd87d29ff4$var$Pe) break;
                case "keydown":
                case "keyup":
                    $b36720cd87d29ff4$var$Ue(g, c, e);
            }
            var $a;
            if ($b36720cd87d29ff4$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $b36720cd87d29ff4$var$ie ? $b36720cd87d29ff4$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($b36720cd87d29ff4$var$de && "ko" !== c.locale && ($b36720cd87d29ff4$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $b36720cd87d29ff4$var$ie && ($a = $b36720cd87d29ff4$var$nd()) : ($b36720cd87d29ff4$var$kd = e, $b36720cd87d29ff4$var$ld = "value" in $b36720cd87d29ff4$var$kd ? $b36720cd87d29ff4$var$kd.value : $b36720cd87d29ff4$var$kd.textContent, $b36720cd87d29ff4$var$ie = !0)), xa = $b36720cd87d29ff4$var$oe(d, ba), 0 < xa.length && (ba = new $b36720cd87d29ff4$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $b36720cd87d29ff4$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $b36720cd87d29ff4$var$ce ? $b36720cd87d29ff4$var$je(a, c) : $b36720cd87d29ff4$var$ke(a, c)) d = $b36720cd87d29ff4$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $b36720cd87d29ff4$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $b36720cd87d29ff4$var$se(g, b);
    });
}
function $b36720cd87d29ff4$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $b36720cd87d29ff4$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $b36720cd87d29ff4$var$Kb(a, c), null != f && d.unshift($b36720cd87d29ff4$var$tf(a, f, e)), f = $b36720cd87d29ff4$var$Kb(a, b), null != f && d.push($b36720cd87d29ff4$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $b36720cd87d29ff4$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $b36720cd87d29ff4$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $b36720cd87d29ff4$var$Kb(c, f), null != k && g.unshift($b36720cd87d29ff4$var$tf(c, k, h))) : e || (k = $b36720cd87d29ff4$var$Kb(c, f), null != k && g.push($b36720cd87d29ff4$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $b36720cd87d29ff4$var$xf = /\r\n?/g, $b36720cd87d29ff4$var$yf = /\u0000|\uFFFD/g;
function $b36720cd87d29ff4$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($b36720cd87d29ff4$var$xf, "\n").replace($b36720cd87d29ff4$var$yf, "");
}
function $b36720cd87d29ff4$var$Af(a, b, c) {
    b = $b36720cd87d29ff4$var$zf(b);
    if ($b36720cd87d29ff4$var$zf(a) !== b && c) throw Error($b36720cd87d29ff4$var$p(425));
}
function $b36720cd87d29ff4$var$Bf() {}
var $b36720cd87d29ff4$var$Cf = null, $b36720cd87d29ff4$var$Df = null;
function $b36720cd87d29ff4$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $b36720cd87d29ff4$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $b36720cd87d29ff4$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $b36720cd87d29ff4$var$Hf = "function" === typeof Promise ? Promise : void 0, $b36720cd87d29ff4$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $b36720cd87d29ff4$var$Hf ? function(a) {
    return $b36720cd87d29ff4$var$Hf.resolve(null).then(a).catch($b36720cd87d29ff4$var$If);
} : $b36720cd87d29ff4$var$Ff;
function $b36720cd87d29ff4$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $b36720cd87d29ff4$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $b36720cd87d29ff4$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $b36720cd87d29ff4$var$bd(b);
}
function $b36720cd87d29ff4$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $b36720cd87d29ff4$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $b36720cd87d29ff4$var$Nf = Math.random().toString(36).slice(2), $b36720cd87d29ff4$var$Of = "__reactFiber$" + $b36720cd87d29ff4$var$Nf, $b36720cd87d29ff4$var$Pf = "__reactProps$" + $b36720cd87d29ff4$var$Nf, $b36720cd87d29ff4$var$uf = "__reactContainer$" + $b36720cd87d29ff4$var$Nf, $b36720cd87d29ff4$var$of = "__reactEvents$" + $b36720cd87d29ff4$var$Nf, $b36720cd87d29ff4$var$Qf = "__reactListeners$" + $b36720cd87d29ff4$var$Nf, $b36720cd87d29ff4$var$Rf = "__reactHandles$" + $b36720cd87d29ff4$var$Nf;
function $b36720cd87d29ff4$var$Wc(a) {
    var b = a[$b36720cd87d29ff4$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$b36720cd87d29ff4$var$uf] || c[$b36720cd87d29ff4$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $b36720cd87d29ff4$var$Mf(a); null !== a;){
                if (c = a[$b36720cd87d29ff4$var$Of]) return c;
                a = $b36720cd87d29ff4$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $b36720cd87d29ff4$var$Cb(a) {
    a = a[$b36720cd87d29ff4$var$Of] || a[$b36720cd87d29ff4$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $b36720cd87d29ff4$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($b36720cd87d29ff4$var$p(33));
}
function $b36720cd87d29ff4$var$Db(a) {
    return a[$b36720cd87d29ff4$var$Pf] || null;
}
var $b36720cd87d29ff4$var$Sf = [], $b36720cd87d29ff4$var$Tf = -1;
function $b36720cd87d29ff4$var$Uf(a) {
    return {
        current: a
    };
}
function $b36720cd87d29ff4$var$E(a) {
    0 > $b36720cd87d29ff4$var$Tf || (a.current = $b36720cd87d29ff4$var$Sf[$b36720cd87d29ff4$var$Tf], $b36720cd87d29ff4$var$Sf[$b36720cd87d29ff4$var$Tf] = null, $b36720cd87d29ff4$var$Tf--);
}
function $b36720cd87d29ff4$var$G(a, b) {
    $b36720cd87d29ff4$var$Tf++;
    $b36720cd87d29ff4$var$Sf[$b36720cd87d29ff4$var$Tf] = a.current;
    a.current = b;
}
var $b36720cd87d29ff4$var$Vf = {}, $b36720cd87d29ff4$var$H = $b36720cd87d29ff4$var$Uf($b36720cd87d29ff4$var$Vf), $b36720cd87d29ff4$var$Wf = $b36720cd87d29ff4$var$Uf(!1), $b36720cd87d29ff4$var$Xf = $b36720cd87d29ff4$var$Vf;
function $b36720cd87d29ff4$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $b36720cd87d29ff4$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $b36720cd87d29ff4$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $b36720cd87d29ff4$var$$f() {
    $b36720cd87d29ff4$var$E($b36720cd87d29ff4$var$Wf);
    $b36720cd87d29ff4$var$E($b36720cd87d29ff4$var$H);
}
function $b36720cd87d29ff4$var$ag(a, b, c) {
    if ($b36720cd87d29ff4$var$H.current !== $b36720cd87d29ff4$var$Vf) throw Error($b36720cd87d29ff4$var$p(168));
    $b36720cd87d29ff4$var$G($b36720cd87d29ff4$var$H, b);
    $b36720cd87d29ff4$var$G($b36720cd87d29ff4$var$Wf, c);
}
function $b36720cd87d29ff4$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($b36720cd87d29ff4$var$p(108, $b36720cd87d29ff4$var$Ra(a) || "Unknown", e));
    return $b36720cd87d29ff4$var$A({}, c, d);
}
function $b36720cd87d29ff4$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $b36720cd87d29ff4$var$Vf;
    $b36720cd87d29ff4$var$Xf = $b36720cd87d29ff4$var$H.current;
    $b36720cd87d29ff4$var$G($b36720cd87d29ff4$var$H, a);
    $b36720cd87d29ff4$var$G($b36720cd87d29ff4$var$Wf, $b36720cd87d29ff4$var$Wf.current);
    return !0;
}
function $b36720cd87d29ff4$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($b36720cd87d29ff4$var$p(169));
    c ? (a = $b36720cd87d29ff4$var$bg(a, b, $b36720cd87d29ff4$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $b36720cd87d29ff4$var$E($b36720cd87d29ff4$var$Wf), $b36720cd87d29ff4$var$E($b36720cd87d29ff4$var$H), $b36720cd87d29ff4$var$G($b36720cd87d29ff4$var$H, a)) : $b36720cd87d29ff4$var$E($b36720cd87d29ff4$var$Wf);
    $b36720cd87d29ff4$var$G($b36720cd87d29ff4$var$Wf, c);
}
var $b36720cd87d29ff4$var$eg = null, $b36720cd87d29ff4$var$fg = !1, $b36720cd87d29ff4$var$gg = !1;
function $b36720cd87d29ff4$var$hg(a) {
    null === $b36720cd87d29ff4$var$eg ? $b36720cd87d29ff4$var$eg = [
        a
    ] : $b36720cd87d29ff4$var$eg.push(a);
}
function $b36720cd87d29ff4$var$ig(a) {
    $b36720cd87d29ff4$var$fg = !0;
    $b36720cd87d29ff4$var$hg(a);
}
function $b36720cd87d29ff4$var$jg() {
    if (!$b36720cd87d29ff4$var$gg && null !== $b36720cd87d29ff4$var$eg) {
        $b36720cd87d29ff4$var$gg = !0;
        var a = 0, b = $b36720cd87d29ff4$var$C;
        try {
            var c = $b36720cd87d29ff4$var$eg;
            for($b36720cd87d29ff4$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $b36720cd87d29ff4$var$eg = null;
            $b36720cd87d29ff4$var$fg = !1;
        } catch (e) {
            throw null !== $b36720cd87d29ff4$var$eg && ($b36720cd87d29ff4$var$eg = $b36720cd87d29ff4$var$eg.slice(a + 1)), $b36720cd87d29ff4$var$ac($b36720cd87d29ff4$var$fc, $b36720cd87d29ff4$var$jg), e;
        } finally{
            $b36720cd87d29ff4$var$C = b, $b36720cd87d29ff4$var$gg = !1;
        }
    }
    return null;
}
var $b36720cd87d29ff4$var$kg = [], $b36720cd87d29ff4$var$lg = 0, $b36720cd87d29ff4$var$mg = null, $b36720cd87d29ff4$var$ng = 0, $b36720cd87d29ff4$var$og = [], $b36720cd87d29ff4$var$pg = 0, $b36720cd87d29ff4$var$qg = null, $b36720cd87d29ff4$var$rg = 1, $b36720cd87d29ff4$var$sg = "";
function $b36720cd87d29ff4$var$tg(a, b) {
    $b36720cd87d29ff4$var$kg[$b36720cd87d29ff4$var$lg++] = $b36720cd87d29ff4$var$ng;
    $b36720cd87d29ff4$var$kg[$b36720cd87d29ff4$var$lg++] = $b36720cd87d29ff4$var$mg;
    $b36720cd87d29ff4$var$mg = a;
    $b36720cd87d29ff4$var$ng = b;
}
function $b36720cd87d29ff4$var$ug(a, b, c) {
    $b36720cd87d29ff4$var$og[$b36720cd87d29ff4$var$pg++] = $b36720cd87d29ff4$var$rg;
    $b36720cd87d29ff4$var$og[$b36720cd87d29ff4$var$pg++] = $b36720cd87d29ff4$var$sg;
    $b36720cd87d29ff4$var$og[$b36720cd87d29ff4$var$pg++] = $b36720cd87d29ff4$var$qg;
    $b36720cd87d29ff4$var$qg = a;
    var d = $b36720cd87d29ff4$var$rg;
    a = $b36720cd87d29ff4$var$sg;
    var e = 32 - $b36720cd87d29ff4$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $b36720cd87d29ff4$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $b36720cd87d29ff4$var$rg = 1 << 32 - $b36720cd87d29ff4$var$oc(b) + e | c << e | d;
        $b36720cd87d29ff4$var$sg = f + a;
    } else $b36720cd87d29ff4$var$rg = 1 << f | c << e | d, $b36720cd87d29ff4$var$sg = a;
}
function $b36720cd87d29ff4$var$vg(a) {
    null !== a.return && ($b36720cd87d29ff4$var$tg(a, 1), $b36720cd87d29ff4$var$ug(a, 1, 0));
}
function $b36720cd87d29ff4$var$wg(a) {
    for(; a === $b36720cd87d29ff4$var$mg;)$b36720cd87d29ff4$var$mg = $b36720cd87d29ff4$var$kg[--$b36720cd87d29ff4$var$lg], $b36720cd87d29ff4$var$kg[$b36720cd87d29ff4$var$lg] = null, $b36720cd87d29ff4$var$ng = $b36720cd87d29ff4$var$kg[--$b36720cd87d29ff4$var$lg], $b36720cd87d29ff4$var$kg[$b36720cd87d29ff4$var$lg] = null;
    for(; a === $b36720cd87d29ff4$var$qg;)$b36720cd87d29ff4$var$qg = $b36720cd87d29ff4$var$og[--$b36720cd87d29ff4$var$pg], $b36720cd87d29ff4$var$og[$b36720cd87d29ff4$var$pg] = null, $b36720cd87d29ff4$var$sg = $b36720cd87d29ff4$var$og[--$b36720cd87d29ff4$var$pg], $b36720cd87d29ff4$var$og[$b36720cd87d29ff4$var$pg] = null, $b36720cd87d29ff4$var$rg = $b36720cd87d29ff4$var$og[--$b36720cd87d29ff4$var$pg], $b36720cd87d29ff4$var$og[$b36720cd87d29ff4$var$pg] = null;
}
var $b36720cd87d29ff4$var$xg = null, $b36720cd87d29ff4$var$yg = null, $b36720cd87d29ff4$var$I = !1, $b36720cd87d29ff4$var$zg = null;
function $b36720cd87d29ff4$var$Ag(a, b) {
    var c = $b36720cd87d29ff4$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $b36720cd87d29ff4$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $b36720cd87d29ff4$var$xg = a, $b36720cd87d29ff4$var$yg = $b36720cd87d29ff4$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $b36720cd87d29ff4$var$xg = a, $b36720cd87d29ff4$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $b36720cd87d29ff4$var$qg ? {
                id: $b36720cd87d29ff4$var$rg,
                overflow: $b36720cd87d29ff4$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $b36720cd87d29ff4$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $b36720cd87d29ff4$var$xg = a, $b36720cd87d29ff4$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $b36720cd87d29ff4$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $b36720cd87d29ff4$var$Eg(a) {
    if ($b36720cd87d29ff4$var$I) {
        var b = $b36720cd87d29ff4$var$yg;
        if (b) {
            var c = b;
            if (!$b36720cd87d29ff4$var$Cg(a, b)) {
                if ($b36720cd87d29ff4$var$Dg(a)) throw Error($b36720cd87d29ff4$var$p(418));
                b = $b36720cd87d29ff4$var$Lf(c.nextSibling);
                var d = $b36720cd87d29ff4$var$xg;
                b && $b36720cd87d29ff4$var$Cg(a, b) ? $b36720cd87d29ff4$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $b36720cd87d29ff4$var$I = !1, $b36720cd87d29ff4$var$xg = a);
            }
        } else {
            if ($b36720cd87d29ff4$var$Dg(a)) throw Error($b36720cd87d29ff4$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $b36720cd87d29ff4$var$I = !1;
            $b36720cd87d29ff4$var$xg = a;
        }
    }
}
function $b36720cd87d29ff4$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $b36720cd87d29ff4$var$xg = a;
}
function $b36720cd87d29ff4$var$Gg(a) {
    if (a !== $b36720cd87d29ff4$var$xg) return !1;
    if (!$b36720cd87d29ff4$var$I) return $b36720cd87d29ff4$var$Fg(a), $b36720cd87d29ff4$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$b36720cd87d29ff4$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $b36720cd87d29ff4$var$yg)) {
        if ($b36720cd87d29ff4$var$Dg(a)) throw $b36720cd87d29ff4$var$Hg(), Error($b36720cd87d29ff4$var$p(418));
        for(; b;)$b36720cd87d29ff4$var$Ag(a, b), b = $b36720cd87d29ff4$var$Lf(b.nextSibling);
    }
    $b36720cd87d29ff4$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($b36720cd87d29ff4$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $b36720cd87d29ff4$var$yg = $b36720cd87d29ff4$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $b36720cd87d29ff4$var$yg = null;
        }
    } else $b36720cd87d29ff4$var$yg = $b36720cd87d29ff4$var$xg ? $b36720cd87d29ff4$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $b36720cd87d29ff4$var$Hg() {
    for(var a = $b36720cd87d29ff4$var$yg; a;)a = $b36720cd87d29ff4$var$Lf(a.nextSibling);
}
function $b36720cd87d29ff4$var$Ig() {
    $b36720cd87d29ff4$var$yg = $b36720cd87d29ff4$var$xg = null;
    $b36720cd87d29ff4$var$I = !1;
}
function $b36720cd87d29ff4$var$Jg(a) {
    null === $b36720cd87d29ff4$var$zg ? $b36720cd87d29ff4$var$zg = [
        a
    ] : $b36720cd87d29ff4$var$zg.push(a);
}
var $b36720cd87d29ff4$var$Kg = $b36720cd87d29ff4$var$ua.ReactCurrentBatchConfig;
function $b36720cd87d29ff4$var$Lg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($b36720cd87d29ff4$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($b36720cd87d29ff4$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($b36720cd87d29ff4$var$p(284));
        if (!c._owner) throw Error($b36720cd87d29ff4$var$p(290, a));
    }
    return a;
}
function $b36720cd87d29ff4$var$Mg(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($b36720cd87d29ff4$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $b36720cd87d29ff4$var$Ng(a) {
    var b = a._init;
    return b(a._payload);
}
function $b36720cd87d29ff4$var$Og(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $b36720cd87d29ff4$var$Pg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $b36720cd87d29ff4$var$Qg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $b36720cd87d29ff4$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $b36720cd87d29ff4$var$Ha && $b36720cd87d29ff4$var$Ng(f) === b.type)) return d = e(b, c.props), d.ref = $b36720cd87d29ff4$var$Lg(a, b, c), d.return = a, d;
        d = $b36720cd87d29ff4$var$Rg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $b36720cd87d29ff4$var$Lg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $b36720cd87d29ff4$var$Sg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $b36720cd87d29ff4$var$Tg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $b36720cd87d29ff4$var$Qg("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $b36720cd87d29ff4$var$va:
                    return c = $b36720cd87d29ff4$var$Rg(b.type, b.key, b.props, null, a.mode, c), c.ref = $b36720cd87d29ff4$var$Lg(a, null, b), c.return = a, c;
                case $b36720cd87d29ff4$var$wa:
                    return b = $b36720cd87d29ff4$var$Sg(b, a.mode, c), b.return = a, b;
                case $b36720cd87d29ff4$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($b36720cd87d29ff4$var$eb(b) || $b36720cd87d29ff4$var$Ka(b)) return b = $b36720cd87d29ff4$var$Tg(b, a.mode, c, null), b.return = a, b;
            $b36720cd87d29ff4$var$Mg(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $b36720cd87d29ff4$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $b36720cd87d29ff4$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $b36720cd87d29ff4$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($b36720cd87d29ff4$var$eb(c) || $b36720cd87d29ff4$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $b36720cd87d29ff4$var$Mg(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $b36720cd87d29ff4$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $b36720cd87d29ff4$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $b36720cd87d29ff4$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($b36720cd87d29ff4$var$eb(d) || $b36720cd87d29ff4$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $b36720cd87d29ff4$var$Mg(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $b36720cd87d29ff4$var$I && $b36720cd87d29ff4$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $b36720cd87d29ff4$var$I && $b36720cd87d29ff4$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $b36720cd87d29ff4$var$I && $b36720cd87d29ff4$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $b36720cd87d29ff4$var$Ka(h);
        if ("function" !== typeof l) throw Error($b36720cd87d29ff4$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($b36720cd87d29ff4$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $b36720cd87d29ff4$var$I && $b36720cd87d29ff4$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $b36720cd87d29ff4$var$I && $b36720cd87d29ff4$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $b36720cd87d29ff4$var$I && $b36720cd87d29ff4$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $b36720cd87d29ff4$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $b36720cd87d29ff4$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $b36720cd87d29ff4$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $b36720cd87d29ff4$var$Ha && $b36720cd87d29ff4$var$Ng(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $b36720cd87d29ff4$var$Lg(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $b36720cd87d29ff4$var$ya ? (d = $b36720cd87d29ff4$var$Tg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $b36720cd87d29ff4$var$Rg(f.type, f.key, f.props, null, a.mode, h), h.ref = $b36720cd87d29ff4$var$Lg(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $b36720cd87d29ff4$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $b36720cd87d29ff4$var$Sg(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $b36720cd87d29ff4$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($b36720cd87d29ff4$var$eb(f)) return n(a, d, f, h);
            if ($b36720cd87d29ff4$var$Ka(f)) return t(a, d, f, h);
            $b36720cd87d29ff4$var$Mg(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $b36720cd87d29ff4$var$Qg(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $b36720cd87d29ff4$var$Ug = $b36720cd87d29ff4$var$Og(!0), $b36720cd87d29ff4$var$Vg = $b36720cd87d29ff4$var$Og(!1), $b36720cd87d29ff4$var$Wg = $b36720cd87d29ff4$var$Uf(null), $b36720cd87d29ff4$var$Xg = null, $b36720cd87d29ff4$var$Yg = null, $b36720cd87d29ff4$var$Zg = null;
function $b36720cd87d29ff4$var$$g() {
    $b36720cd87d29ff4$var$Zg = $b36720cd87d29ff4$var$Yg = $b36720cd87d29ff4$var$Xg = null;
}
function $b36720cd87d29ff4$var$ah(a) {
    var b = $b36720cd87d29ff4$var$Wg.current;
    $b36720cd87d29ff4$var$E($b36720cd87d29ff4$var$Wg);
    a._currentValue = b;
}
function $b36720cd87d29ff4$var$bh(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $b36720cd87d29ff4$var$ch(a, b) {
    $b36720cd87d29ff4$var$Xg = a;
    $b36720cd87d29ff4$var$Zg = $b36720cd87d29ff4$var$Yg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($b36720cd87d29ff4$var$dh = !0), a.firstContext = null);
}
function $b36720cd87d29ff4$var$eh(a) {
    var b = a._currentValue;
    if ($b36720cd87d29ff4$var$Zg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $b36720cd87d29ff4$var$Yg) {
            if (null === $b36720cd87d29ff4$var$Xg) throw Error($b36720cd87d29ff4$var$p(308));
            $b36720cd87d29ff4$var$Yg = a;
            $b36720cd87d29ff4$var$Xg.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $b36720cd87d29ff4$var$Yg = $b36720cd87d29ff4$var$Yg.next = a;
    }
    return b;
}
var $b36720cd87d29ff4$var$fh = null;
function $b36720cd87d29ff4$var$gh(a) {
    null === $b36720cd87d29ff4$var$fh ? $b36720cd87d29ff4$var$fh = [
        a
    ] : $b36720cd87d29ff4$var$fh.push(a);
}
function $b36720cd87d29ff4$var$hh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $b36720cd87d29ff4$var$gh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $b36720cd87d29ff4$var$ih(a, d);
}
function $b36720cd87d29ff4$var$ih(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $b36720cd87d29ff4$var$jh = !1;
function $b36720cd87d29ff4$var$kh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $b36720cd87d29ff4$var$lh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $b36720cd87d29ff4$var$mh(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $b36720cd87d29ff4$var$nh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($b36720cd87d29ff4$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $b36720cd87d29ff4$var$ih(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $b36720cd87d29ff4$var$gh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $b36720cd87d29ff4$var$ih(a, c);
}
function $b36720cd87d29ff4$var$oh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $b36720cd87d29ff4$var$Cc(a, c);
    }
}
function $b36720cd87d29ff4$var$ph(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $b36720cd87d29ff4$var$qh(a, b, c, d) {
    var e = a.updateQueue;
    $b36720cd87d29ff4$var$jh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $b36720cd87d29ff4$var$A({}, q, r);
                            break a;
                        case 2:
                            $b36720cd87d29ff4$var$jh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $b36720cd87d29ff4$var$rh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $b36720cd87d29ff4$var$sh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($b36720cd87d29ff4$var$p(191, e));
            e.call(d);
        }
    }
}
var $b36720cd87d29ff4$var$th = {}, $b36720cd87d29ff4$var$uh = $b36720cd87d29ff4$var$Uf($b36720cd87d29ff4$var$th), $b36720cd87d29ff4$var$vh = $b36720cd87d29ff4$var$Uf($b36720cd87d29ff4$var$th), $b36720cd87d29ff4$var$wh = $b36720cd87d29ff4$var$Uf($b36720cd87d29ff4$var$th);
function $b36720cd87d29ff4$var$xh(a) {
    if (a === $b36720cd87d29ff4$var$th) throw Error($b36720cd87d29ff4$var$p(174));
    return a;
}
function $b36720cd87d29ff4$var$yh(a, b) {
    $b36720cd87d29ff4$var$G($b36720cd87d29ff4$var$wh, b);
    $b36720cd87d29ff4$var$G($b36720cd87d29ff4$var$vh, a);
    $b36720cd87d29ff4$var$G($b36720cd87d29ff4$var$uh, $b36720cd87d29ff4$var$th);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $b36720cd87d29ff4$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $b36720cd87d29ff4$var$lb(b, a);
    }
    $b36720cd87d29ff4$var$E($b36720cd87d29ff4$var$uh);
    $b36720cd87d29ff4$var$G($b36720cd87d29ff4$var$uh, b);
}
function $b36720cd87d29ff4$var$zh() {
    $b36720cd87d29ff4$var$E($b36720cd87d29ff4$var$uh);
    $b36720cd87d29ff4$var$E($b36720cd87d29ff4$var$vh);
    $b36720cd87d29ff4$var$E($b36720cd87d29ff4$var$wh);
}
function $b36720cd87d29ff4$var$Ah(a) {
    $b36720cd87d29ff4$var$xh($b36720cd87d29ff4$var$wh.current);
    var b = $b36720cd87d29ff4$var$xh($b36720cd87d29ff4$var$uh.current);
    var c = $b36720cd87d29ff4$var$lb(b, a.type);
    b !== c && ($b36720cd87d29ff4$var$G($b36720cd87d29ff4$var$vh, a), $b36720cd87d29ff4$var$G($b36720cd87d29ff4$var$uh, c));
}
function $b36720cd87d29ff4$var$Bh(a) {
    $b36720cd87d29ff4$var$vh.current === a && ($b36720cd87d29ff4$var$E($b36720cd87d29ff4$var$uh), $b36720cd87d29ff4$var$E($b36720cd87d29ff4$var$vh));
}
var $b36720cd87d29ff4$var$L = $b36720cd87d29ff4$var$Uf(0);
function $b36720cd87d29ff4$var$Ch(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $b36720cd87d29ff4$var$Dh = [];
function $b36720cd87d29ff4$var$Eh() {
    for(var a = 0; a < $b36720cd87d29ff4$var$Dh.length; a++)$b36720cd87d29ff4$var$Dh[a]._workInProgressVersionPrimary = null;
    $b36720cd87d29ff4$var$Dh.length = 0;
}
var $b36720cd87d29ff4$var$Fh = $b36720cd87d29ff4$var$ua.ReactCurrentDispatcher, $b36720cd87d29ff4$var$Gh = $b36720cd87d29ff4$var$ua.ReactCurrentBatchConfig, $b36720cd87d29ff4$var$Hh = 0, $b36720cd87d29ff4$var$M = null, $b36720cd87d29ff4$var$N = null, $b36720cd87d29ff4$var$O = null, $b36720cd87d29ff4$var$Ih = !1, $b36720cd87d29ff4$var$Jh = !1, $b36720cd87d29ff4$var$Kh = 0, $b36720cd87d29ff4$var$Lh = 0;
function $b36720cd87d29ff4$var$P() {
    throw Error($b36720cd87d29ff4$var$p(321));
}
function $b36720cd87d29ff4$var$Mh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$b36720cd87d29ff4$var$He(a[c], b[c])) return !1;
    return !0;
}
function $b36720cd87d29ff4$var$Nh(a, b, c, d, e, f) {
    $b36720cd87d29ff4$var$Hh = f;
    $b36720cd87d29ff4$var$M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $b36720cd87d29ff4$var$Fh.current = null === a || null === a.memoizedState ? $b36720cd87d29ff4$var$Oh : $b36720cd87d29ff4$var$Ph;
    a = c(d, e);
    if ($b36720cd87d29ff4$var$Jh) {
        f = 0;
        do {
            $b36720cd87d29ff4$var$Jh = !1;
            $b36720cd87d29ff4$var$Kh = 0;
            if (25 <= f) throw Error($b36720cd87d29ff4$var$p(301));
            f += 1;
            $b36720cd87d29ff4$var$O = $b36720cd87d29ff4$var$N = null;
            b.updateQueue = null;
            $b36720cd87d29ff4$var$Fh.current = $b36720cd87d29ff4$var$Qh;
            a = c(d, e);
        }while ($b36720cd87d29ff4$var$Jh);
    }
    $b36720cd87d29ff4$var$Fh.current = $b36720cd87d29ff4$var$Rh;
    b = null !== $b36720cd87d29ff4$var$N && null !== $b36720cd87d29ff4$var$N.next;
    $b36720cd87d29ff4$var$Hh = 0;
    $b36720cd87d29ff4$var$O = $b36720cd87d29ff4$var$N = $b36720cd87d29ff4$var$M = null;
    $b36720cd87d29ff4$var$Ih = !1;
    if (b) throw Error($b36720cd87d29ff4$var$p(300));
    return a;
}
function $b36720cd87d29ff4$var$Sh() {
    var a = 0 !== $b36720cd87d29ff4$var$Kh;
    $b36720cd87d29ff4$var$Kh = 0;
    return a;
}
function $b36720cd87d29ff4$var$Th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $b36720cd87d29ff4$var$O ? $b36720cd87d29ff4$var$M.memoizedState = $b36720cd87d29ff4$var$O = a : $b36720cd87d29ff4$var$O = $b36720cd87d29ff4$var$O.next = a;
    return $b36720cd87d29ff4$var$O;
}
function $b36720cd87d29ff4$var$Uh() {
    if (null === $b36720cd87d29ff4$var$N) {
        var a = $b36720cd87d29ff4$var$M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $b36720cd87d29ff4$var$N.next;
    var b = null === $b36720cd87d29ff4$var$O ? $b36720cd87d29ff4$var$M.memoizedState : $b36720cd87d29ff4$var$O.next;
    if (null !== b) $b36720cd87d29ff4$var$O = b, $b36720cd87d29ff4$var$N = a;
    else {
        if (null === a) throw Error($b36720cd87d29ff4$var$p(310));
        $b36720cd87d29ff4$var$N = a;
        a = {
            memoizedState: $b36720cd87d29ff4$var$N.memoizedState,
            baseState: $b36720cd87d29ff4$var$N.baseState,
            baseQueue: $b36720cd87d29ff4$var$N.baseQueue,
            queue: $b36720cd87d29ff4$var$N.queue,
            next: null
        };
        null === $b36720cd87d29ff4$var$O ? $b36720cd87d29ff4$var$M.memoizedState = $b36720cd87d29ff4$var$O = a : $b36720cd87d29ff4$var$O = $b36720cd87d29ff4$var$O.next = a;
    }
    return $b36720cd87d29ff4$var$O;
}
function $b36720cd87d29ff4$var$Vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $b36720cd87d29ff4$var$Wh(a) {
    var b = $b36720cd87d29ff4$var$Uh(), c = b.queue;
    if (null === c) throw Error($b36720cd87d29ff4$var$p(311));
    c.lastRenderedReducer = a;
    var d = $b36720cd87d29ff4$var$N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($b36720cd87d29ff4$var$Hh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $b36720cd87d29ff4$var$M.lanes |= m;
                $b36720cd87d29ff4$var$rh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $b36720cd87d29ff4$var$He(d, b.memoizedState) || ($b36720cd87d29ff4$var$dh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $b36720cd87d29ff4$var$M.lanes |= f, $b36720cd87d29ff4$var$rh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $b36720cd87d29ff4$var$Xh(a) {
    var b = $b36720cd87d29ff4$var$Uh(), c = b.queue;
    if (null === c) throw Error($b36720cd87d29ff4$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $b36720cd87d29ff4$var$He(f, b.memoizedState) || ($b36720cd87d29ff4$var$dh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $b36720cd87d29ff4$var$Yh() {}
function $b36720cd87d29ff4$var$Zh(a, b) {
    var c = $b36720cd87d29ff4$var$M, d = $b36720cd87d29ff4$var$Uh(), e = b(), f = !$b36720cd87d29ff4$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $b36720cd87d29ff4$var$dh = !0);
    d = d.queue;
    $b36720cd87d29ff4$var$$h($b36720cd87d29ff4$var$ai.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $b36720cd87d29ff4$var$O && $b36720cd87d29ff4$var$O.memoizedState.tag & 1) {
        c.flags |= 2048;
        $b36720cd87d29ff4$var$bi(9, $b36720cd87d29ff4$var$ci.bind(null, c, d, e, b), void 0, null);
        if (null === $b36720cd87d29ff4$var$Q) throw Error($b36720cd87d29ff4$var$p(349));
        0 !== ($b36720cd87d29ff4$var$Hh & 30) || $b36720cd87d29ff4$var$di(c, b, e);
    }
    return e;
}
function $b36720cd87d29ff4$var$di(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $b36720cd87d29ff4$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $b36720cd87d29ff4$var$M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $b36720cd87d29ff4$var$ci(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $b36720cd87d29ff4$var$ei(b) && $b36720cd87d29ff4$var$fi(a);
}
function $b36720cd87d29ff4$var$ai(a, b, c) {
    return c(function() {
        $b36720cd87d29ff4$var$ei(b) && $b36720cd87d29ff4$var$fi(a);
    });
}
function $b36720cd87d29ff4$var$ei(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$b36720cd87d29ff4$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $b36720cd87d29ff4$var$fi(a) {
    var b = $b36720cd87d29ff4$var$ih(a, 1);
    null !== b && $b36720cd87d29ff4$var$gi(b, a, 1, -1);
}
function $b36720cd87d29ff4$var$hi(a) {
    var b = $b36720cd87d29ff4$var$Th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $b36720cd87d29ff4$var$Vh,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $b36720cd87d29ff4$var$ii.bind(null, $b36720cd87d29ff4$var$M, a);
    return [
        b.memoizedState,
        a
    ];
}
function $b36720cd87d29ff4$var$bi(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $b36720cd87d29ff4$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $b36720cd87d29ff4$var$M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $b36720cd87d29ff4$var$ji() {
    return $b36720cd87d29ff4$var$Uh().memoizedState;
}
function $b36720cd87d29ff4$var$ki(a, b, c, d) {
    var e = $b36720cd87d29ff4$var$Th();
    $b36720cd87d29ff4$var$M.flags |= a;
    e.memoizedState = $b36720cd87d29ff4$var$bi(1 | b, c, void 0, void 0 === d ? null : d);
}
function $b36720cd87d29ff4$var$li(a, b, c, d) {
    var e = $b36720cd87d29ff4$var$Uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $b36720cd87d29ff4$var$N) {
        var g = $b36720cd87d29ff4$var$N.memoizedState;
        f = g.destroy;
        if (null !== d && $b36720cd87d29ff4$var$Mh(d, g.deps)) {
            e.memoizedState = $b36720cd87d29ff4$var$bi(b, c, f, d);
            return;
        }
    }
    $b36720cd87d29ff4$var$M.flags |= a;
    e.memoizedState = $b36720cd87d29ff4$var$bi(1 | b, c, f, d);
}
function $b36720cd87d29ff4$var$mi(a, b) {
    return $b36720cd87d29ff4$var$ki(8390656, 8, a, b);
}
function $b36720cd87d29ff4$var$$h(a, b) {
    return $b36720cd87d29ff4$var$li(2048, 8, a, b);
}
function $b36720cd87d29ff4$var$ni(a, b) {
    return $b36720cd87d29ff4$var$li(4, 2, a, b);
}
function $b36720cd87d29ff4$var$oi(a, b) {
    return $b36720cd87d29ff4$var$li(4, 4, a, b);
}
function $b36720cd87d29ff4$var$pi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $b36720cd87d29ff4$var$qi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $b36720cd87d29ff4$var$li(4, 4, $b36720cd87d29ff4$var$pi.bind(null, b, a), c);
}
function $b36720cd87d29ff4$var$ri() {}
function $b36720cd87d29ff4$var$si(a, b) {
    var c = $b36720cd87d29ff4$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $b36720cd87d29ff4$var$Mh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $b36720cd87d29ff4$var$ti(a, b) {
    var c = $b36720cd87d29ff4$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $b36720cd87d29ff4$var$Mh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $b36720cd87d29ff4$var$ui(a, b, c) {
    if (0 === ($b36720cd87d29ff4$var$Hh & 21)) return a.baseState && (a.baseState = !1, $b36720cd87d29ff4$var$dh = !0), a.memoizedState = c;
    $b36720cd87d29ff4$var$He(c, b) || (c = $b36720cd87d29ff4$var$yc(), $b36720cd87d29ff4$var$M.lanes |= c, $b36720cd87d29ff4$var$rh |= c, a.baseState = !0);
    return b;
}
function $b36720cd87d29ff4$var$vi(a, b) {
    var c = $b36720cd87d29ff4$var$C;
    $b36720cd87d29ff4$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $b36720cd87d29ff4$var$Gh.transition;
    $b36720cd87d29ff4$var$Gh.transition = {};
    try {
        a(!1), b();
    } finally{
        $b36720cd87d29ff4$var$C = c, $b36720cd87d29ff4$var$Gh.transition = d;
    }
}
function $b36720cd87d29ff4$var$wi() {
    return $b36720cd87d29ff4$var$Uh().memoizedState;
}
function $b36720cd87d29ff4$var$xi(a, b, c) {
    var d = $b36720cd87d29ff4$var$yi(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($b36720cd87d29ff4$var$zi(a)) $b36720cd87d29ff4$var$Ai(b, c);
    else if (c = $b36720cd87d29ff4$var$hh(a, b, c, d), null !== c) {
        var e = $b36720cd87d29ff4$var$R();
        $b36720cd87d29ff4$var$gi(c, a, d, e);
        $b36720cd87d29ff4$var$Bi(c, b, d);
    }
}
function $b36720cd87d29ff4$var$ii(a, b, c) {
    var d = $b36720cd87d29ff4$var$yi(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($b36720cd87d29ff4$var$zi(a)) $b36720cd87d29ff4$var$Ai(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($b36720cd87d29ff4$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $b36720cd87d29ff4$var$gh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $b36720cd87d29ff4$var$hh(a, b, e, d);
        null !== c && (e = $b36720cd87d29ff4$var$R(), $b36720cd87d29ff4$var$gi(c, a, d, e), $b36720cd87d29ff4$var$Bi(c, b, d));
    }
}
function $b36720cd87d29ff4$var$zi(a) {
    var b = a.alternate;
    return a === $b36720cd87d29ff4$var$M || null !== b && b === $b36720cd87d29ff4$var$M;
}
function $b36720cd87d29ff4$var$Ai(a, b) {
    $b36720cd87d29ff4$var$Jh = $b36720cd87d29ff4$var$Ih = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $b36720cd87d29ff4$var$Bi(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $b36720cd87d29ff4$var$Cc(a, c);
    }
}
var $b36720cd87d29ff4$var$Rh = {
    readContext: $b36720cd87d29ff4$var$eh,
    useCallback: $b36720cd87d29ff4$var$P,
    useContext: $b36720cd87d29ff4$var$P,
    useEffect: $b36720cd87d29ff4$var$P,
    useImperativeHandle: $b36720cd87d29ff4$var$P,
    useInsertionEffect: $b36720cd87d29ff4$var$P,
    useLayoutEffect: $b36720cd87d29ff4$var$P,
    useMemo: $b36720cd87d29ff4$var$P,
    useReducer: $b36720cd87d29ff4$var$P,
    useRef: $b36720cd87d29ff4$var$P,
    useState: $b36720cd87d29ff4$var$P,
    useDebugValue: $b36720cd87d29ff4$var$P,
    useDeferredValue: $b36720cd87d29ff4$var$P,
    useTransition: $b36720cd87d29ff4$var$P,
    useMutableSource: $b36720cd87d29ff4$var$P,
    useSyncExternalStore: $b36720cd87d29ff4$var$P,
    useId: $b36720cd87d29ff4$var$P,
    unstable_isNewReconciler: !1
}, $b36720cd87d29ff4$var$Oh = {
    readContext: $b36720cd87d29ff4$var$eh,
    useCallback: function(a, b) {
        $b36720cd87d29ff4$var$Th().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $b36720cd87d29ff4$var$eh,
    useEffect: $b36720cd87d29ff4$var$mi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $b36720cd87d29ff4$var$ki(4194308, 4, $b36720cd87d29ff4$var$pi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $b36720cd87d29ff4$var$ki(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $b36720cd87d29ff4$var$ki(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $b36720cd87d29ff4$var$Th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $b36720cd87d29ff4$var$Th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $b36720cd87d29ff4$var$xi.bind(null, $b36720cd87d29ff4$var$M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $b36720cd87d29ff4$var$Th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $b36720cd87d29ff4$var$hi,
    useDebugValue: $b36720cd87d29ff4$var$ri,
    useDeferredValue: function(a) {
        return $b36720cd87d29ff4$var$Th().memoizedState = a;
    },
    useTransition: function() {
        var a = $b36720cd87d29ff4$var$hi(!1), b = a[0];
        a = $b36720cd87d29ff4$var$vi.bind(null, a[1]);
        $b36720cd87d29ff4$var$Th().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $b36720cd87d29ff4$var$M, e = $b36720cd87d29ff4$var$Th();
        if ($b36720cd87d29ff4$var$I) {
            if (void 0 === c) throw Error($b36720cd87d29ff4$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $b36720cd87d29ff4$var$Q) throw Error($b36720cd87d29ff4$var$p(349));
            0 !== ($b36720cd87d29ff4$var$Hh & 30) || $b36720cd87d29ff4$var$di(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $b36720cd87d29ff4$var$mi($b36720cd87d29ff4$var$ai.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $b36720cd87d29ff4$var$bi(9, $b36720cd87d29ff4$var$ci.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $b36720cd87d29ff4$var$Th(), b = $b36720cd87d29ff4$var$Q.identifierPrefix;
        if ($b36720cd87d29ff4$var$I) {
            var c = $b36720cd87d29ff4$var$sg;
            var d = $b36720cd87d29ff4$var$rg;
            c = (d & ~(1 << 32 - $b36720cd87d29ff4$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $b36720cd87d29ff4$var$Kh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $b36720cd87d29ff4$var$Lh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $b36720cd87d29ff4$var$Ph = {
    readContext: $b36720cd87d29ff4$var$eh,
    useCallback: $b36720cd87d29ff4$var$si,
    useContext: $b36720cd87d29ff4$var$eh,
    useEffect: $b36720cd87d29ff4$var$$h,
    useImperativeHandle: $b36720cd87d29ff4$var$qi,
    useInsertionEffect: $b36720cd87d29ff4$var$ni,
    useLayoutEffect: $b36720cd87d29ff4$var$oi,
    useMemo: $b36720cd87d29ff4$var$ti,
    useReducer: $b36720cd87d29ff4$var$Wh,
    useRef: $b36720cd87d29ff4$var$ji,
    useState: function() {
        return $b36720cd87d29ff4$var$Wh($b36720cd87d29ff4$var$Vh);
    },
    useDebugValue: $b36720cd87d29ff4$var$ri,
    useDeferredValue: function(a) {
        var b = $b36720cd87d29ff4$var$Uh();
        return $b36720cd87d29ff4$var$ui(b, $b36720cd87d29ff4$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $b36720cd87d29ff4$var$Wh($b36720cd87d29ff4$var$Vh)[0], b = $b36720cd87d29ff4$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $b36720cd87d29ff4$var$Yh,
    useSyncExternalStore: $b36720cd87d29ff4$var$Zh,
    useId: $b36720cd87d29ff4$var$wi,
    unstable_isNewReconciler: !1
}, $b36720cd87d29ff4$var$Qh = {
    readContext: $b36720cd87d29ff4$var$eh,
    useCallback: $b36720cd87d29ff4$var$si,
    useContext: $b36720cd87d29ff4$var$eh,
    useEffect: $b36720cd87d29ff4$var$$h,
    useImperativeHandle: $b36720cd87d29ff4$var$qi,
    useInsertionEffect: $b36720cd87d29ff4$var$ni,
    useLayoutEffect: $b36720cd87d29ff4$var$oi,
    useMemo: $b36720cd87d29ff4$var$ti,
    useReducer: $b36720cd87d29ff4$var$Xh,
    useRef: $b36720cd87d29ff4$var$ji,
    useState: function() {
        return $b36720cd87d29ff4$var$Xh($b36720cd87d29ff4$var$Vh);
    },
    useDebugValue: $b36720cd87d29ff4$var$ri,
    useDeferredValue: function(a) {
        var b = $b36720cd87d29ff4$var$Uh();
        return null === $b36720cd87d29ff4$var$N ? b.memoizedState = a : $b36720cd87d29ff4$var$ui(b, $b36720cd87d29ff4$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $b36720cd87d29ff4$var$Xh($b36720cd87d29ff4$var$Vh)[0], b = $b36720cd87d29ff4$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $b36720cd87d29ff4$var$Yh,
    useSyncExternalStore: $b36720cd87d29ff4$var$Zh,
    useId: $b36720cd87d29ff4$var$wi,
    unstable_isNewReconciler: !1
};
function $b36720cd87d29ff4$var$Ci(a, b) {
    if (a && a.defaultProps) {
        b = $b36720cd87d29ff4$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $b36720cd87d29ff4$var$Di(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $b36720cd87d29ff4$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $b36720cd87d29ff4$var$Ei = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $b36720cd87d29ff4$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $b36720cd87d29ff4$var$R(), e = $b36720cd87d29ff4$var$yi(a), f = $b36720cd87d29ff4$var$mh(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $b36720cd87d29ff4$var$nh(a, f, e);
        null !== b && ($b36720cd87d29ff4$var$gi(b, a, e, d), $b36720cd87d29ff4$var$oh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $b36720cd87d29ff4$var$R(), e = $b36720cd87d29ff4$var$yi(a), f = $b36720cd87d29ff4$var$mh(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $b36720cd87d29ff4$var$nh(a, f, e);
        null !== b && ($b36720cd87d29ff4$var$gi(b, a, e, d), $b36720cd87d29ff4$var$oh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $b36720cd87d29ff4$var$R(), d = $b36720cd87d29ff4$var$yi(a), e = $b36720cd87d29ff4$var$mh(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $b36720cd87d29ff4$var$nh(a, e, d);
        null !== b && ($b36720cd87d29ff4$var$gi(b, a, d, c), $b36720cd87d29ff4$var$oh(b, a, d));
    }
};
function $b36720cd87d29ff4$var$Fi(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$b36720cd87d29ff4$var$Ie(c, d) || !$b36720cd87d29ff4$var$Ie(e, f) : !0;
}
function $b36720cd87d29ff4$var$Gi(a, b, c) {
    var d = !1, e = $b36720cd87d29ff4$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $b36720cd87d29ff4$var$eh(f) : (e = $b36720cd87d29ff4$var$Zf(b) ? $b36720cd87d29ff4$var$Xf : $b36720cd87d29ff4$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $b36720cd87d29ff4$var$Yf(a, e) : $b36720cd87d29ff4$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $b36720cd87d29ff4$var$Ei;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $b36720cd87d29ff4$var$Hi(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $b36720cd87d29ff4$var$Ei.enqueueReplaceState(b, b.state, null);
}
function $b36720cd87d29ff4$var$Ii(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    $b36720cd87d29ff4$var$kh(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $b36720cd87d29ff4$var$eh(f) : (f = $b36720cd87d29ff4$var$Zf(b) ? $b36720cd87d29ff4$var$Xf : $b36720cd87d29ff4$var$H.current, e.context = $b36720cd87d29ff4$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($b36720cd87d29ff4$var$Di(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $b36720cd87d29ff4$var$Ei.enqueueReplaceState(e, e.state, null), $b36720cd87d29ff4$var$qh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $b36720cd87d29ff4$var$Ji(a, b) {
    try {
        var c = "", d = b;
        do c += $b36720cd87d29ff4$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $b36720cd87d29ff4$var$Ki(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $b36720cd87d29ff4$var$Li(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $b36720cd87d29ff4$var$Mi = "function" === typeof WeakMap ? WeakMap : Map;
function $b36720cd87d29ff4$var$Ni(a, b, c) {
    c = $b36720cd87d29ff4$var$mh(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $b36720cd87d29ff4$var$Oi || ($b36720cd87d29ff4$var$Oi = !0, $b36720cd87d29ff4$var$Pi = d);
        $b36720cd87d29ff4$var$Li(a, b);
    };
    return c;
}
function $b36720cd87d29ff4$var$Qi(a, b, c) {
    c = $b36720cd87d29ff4$var$mh(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $b36720cd87d29ff4$var$Li(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $b36720cd87d29ff4$var$Li(a, b);
        "function" !== typeof d && (null === $b36720cd87d29ff4$var$Ri ? $b36720cd87d29ff4$var$Ri = new Set([
            this
        ]) : $b36720cd87d29ff4$var$Ri.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $b36720cd87d29ff4$var$Si(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $b36720cd87d29ff4$var$Mi;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $b36720cd87d29ff4$var$Ti.bind(null, a, b, c), b.then(a, a));
}
function $b36720cd87d29ff4$var$Ui(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $b36720cd87d29ff4$var$Vi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $b36720cd87d29ff4$var$mh(-1, 1), b.tag = 2, $b36720cd87d29ff4$var$nh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $b36720cd87d29ff4$var$Wi = $b36720cd87d29ff4$var$ua.ReactCurrentOwner, $b36720cd87d29ff4$var$dh = !1;
function $b36720cd87d29ff4$var$Xi(a, b, c, d) {
    b.child = null === a ? $b36720cd87d29ff4$var$Vg(b, null, c, d) : $b36720cd87d29ff4$var$Ug(b, a.child, c, d);
}
function $b36720cd87d29ff4$var$Yi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $b36720cd87d29ff4$var$ch(b, e);
    d = $b36720cd87d29ff4$var$Nh(a, b, c, d, f, e);
    c = $b36720cd87d29ff4$var$Sh();
    if (null !== a && !$b36720cd87d29ff4$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $b36720cd87d29ff4$var$Zi(a, b, e);
    $b36720cd87d29ff4$var$I && c && $b36720cd87d29ff4$var$vg(b);
    b.flags |= 1;
    $b36720cd87d29ff4$var$Xi(a, b, d, e);
    return b.child;
}
function $b36720cd87d29ff4$var$$i(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$b36720cd87d29ff4$var$aj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $b36720cd87d29ff4$var$bj(a, b, f, d, e);
        a = $b36720cd87d29ff4$var$Rg(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $b36720cd87d29ff4$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $b36720cd87d29ff4$var$Zi(a, b, e);
    }
    b.flags |= 1;
    a = $b36720cd87d29ff4$var$Pg(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $b36720cd87d29ff4$var$bj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($b36720cd87d29ff4$var$Ie(f, d) && a.ref === b.ref) {
            if ($b36720cd87d29ff4$var$dh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($b36720cd87d29ff4$var$dh = !0);
            else return b.lanes = a.lanes, $b36720cd87d29ff4$var$Zi(a, b, e);
        }
    }
    return $b36720cd87d29ff4$var$cj(a, b, c, d, e);
}
function $b36720cd87d29ff4$var$dj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $b36720cd87d29ff4$var$G($b36720cd87d29ff4$var$ej, $b36720cd87d29ff4$var$fj), $b36720cd87d29ff4$var$fj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $b36720cd87d29ff4$var$G($b36720cd87d29ff4$var$ej, $b36720cd87d29ff4$var$fj), $b36720cd87d29ff4$var$fj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $b36720cd87d29ff4$var$G($b36720cd87d29ff4$var$ej, $b36720cd87d29ff4$var$fj);
            $b36720cd87d29ff4$var$fj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $b36720cd87d29ff4$var$G($b36720cd87d29ff4$var$ej, $b36720cd87d29ff4$var$fj), $b36720cd87d29ff4$var$fj |= d;
    $b36720cd87d29ff4$var$Xi(a, b, e, c);
    return b.child;
}
function $b36720cd87d29ff4$var$gj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $b36720cd87d29ff4$var$cj(a, b, c, d, e) {
    var f = $b36720cd87d29ff4$var$Zf(c) ? $b36720cd87d29ff4$var$Xf : $b36720cd87d29ff4$var$H.current;
    f = $b36720cd87d29ff4$var$Yf(b, f);
    $b36720cd87d29ff4$var$ch(b, e);
    c = $b36720cd87d29ff4$var$Nh(a, b, c, d, f, e);
    d = $b36720cd87d29ff4$var$Sh();
    if (null !== a && !$b36720cd87d29ff4$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $b36720cd87d29ff4$var$Zi(a, b, e);
    $b36720cd87d29ff4$var$I && d && $b36720cd87d29ff4$var$vg(b);
    b.flags |= 1;
    $b36720cd87d29ff4$var$Xi(a, b, c, e);
    return b.child;
}
function $b36720cd87d29ff4$var$hj(a, b, c, d, e) {
    if ($b36720cd87d29ff4$var$Zf(c)) {
        var f = !0;
        $b36720cd87d29ff4$var$cg(b);
    } else f = !1;
    $b36720cd87d29ff4$var$ch(b, e);
    if (null === b.stateNode) $b36720cd87d29ff4$var$ij(a, b), $b36720cd87d29ff4$var$Gi(b, c, d), $b36720cd87d29ff4$var$Ii(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $b36720cd87d29ff4$var$eh(l) : (l = $b36720cd87d29ff4$var$Zf(c) ? $b36720cd87d29ff4$var$Xf : $b36720cd87d29ff4$var$H.current, l = $b36720cd87d29ff4$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $b36720cd87d29ff4$var$Hi(b, g, d, l);
        $b36720cd87d29ff4$var$jh = !1;
        var r = b.memoizedState;
        g.state = r;
        $b36720cd87d29ff4$var$qh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $b36720cd87d29ff4$var$Wf.current || $b36720cd87d29ff4$var$jh ? ("function" === typeof m && ($b36720cd87d29ff4$var$Di(b, c, m, d), k = b.memoizedState), (h = $b36720cd87d29ff4$var$jh || $b36720cd87d29ff4$var$Fi(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $b36720cd87d29ff4$var$lh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $b36720cd87d29ff4$var$Ci(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $b36720cd87d29ff4$var$eh(k) : (k = $b36720cd87d29ff4$var$Zf(c) ? $b36720cd87d29ff4$var$Xf : $b36720cd87d29ff4$var$H.current, k = $b36720cd87d29ff4$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $b36720cd87d29ff4$var$Hi(b, g, d, k);
        $b36720cd87d29ff4$var$jh = !1;
        r = b.memoizedState;
        g.state = r;
        $b36720cd87d29ff4$var$qh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $b36720cd87d29ff4$var$Wf.current || $b36720cd87d29ff4$var$jh ? ("function" === typeof y && ($b36720cd87d29ff4$var$Di(b, c, y, d), n = b.memoizedState), (l = $b36720cd87d29ff4$var$jh || $b36720cd87d29ff4$var$Fi(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $b36720cd87d29ff4$var$jj(a, b, c, d, f, e);
}
function $b36720cd87d29ff4$var$jj(a, b, c, d, e, f) {
    $b36720cd87d29ff4$var$gj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $b36720cd87d29ff4$var$dg(b, c, !1), $b36720cd87d29ff4$var$Zi(a, b, f);
    d = b.stateNode;
    $b36720cd87d29ff4$var$Wi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $b36720cd87d29ff4$var$Ug(b, a.child, null, f), b.child = $b36720cd87d29ff4$var$Ug(b, null, h, f)) : $b36720cd87d29ff4$var$Xi(a, b, h, f);
    b.memoizedState = d.state;
    e && $b36720cd87d29ff4$var$dg(b, c, !0);
    return b.child;
}
function $b36720cd87d29ff4$var$kj(a) {
    var b = a.stateNode;
    b.pendingContext ? $b36720cd87d29ff4$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $b36720cd87d29ff4$var$ag(a, b.context, !1);
    $b36720cd87d29ff4$var$yh(a, b.containerInfo);
}
function $b36720cd87d29ff4$var$lj(a, b, c, d, e) {
    $b36720cd87d29ff4$var$Ig();
    $b36720cd87d29ff4$var$Jg(e);
    b.flags |= 256;
    $b36720cd87d29ff4$var$Xi(a, b, c, d);
    return b.child;
}
var $b36720cd87d29ff4$var$mj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $b36720cd87d29ff4$var$nj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $b36720cd87d29ff4$var$oj(a, b, c) {
    var d = b.pendingProps, e = $b36720cd87d29ff4$var$L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $b36720cd87d29ff4$var$G($b36720cd87d29ff4$var$L, e & 1);
    if (null === a) {
        $b36720cd87d29ff4$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $b36720cd87d29ff4$var$pj(g, d, 0, null), a = $b36720cd87d29ff4$var$Tg(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $b36720cd87d29ff4$var$nj(c), b.memoizedState = $b36720cd87d29ff4$var$mj, a) : $b36720cd87d29ff4$var$qj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $b36720cd87d29ff4$var$rj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $b36720cd87d29ff4$var$Pg(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $b36720cd87d29ff4$var$Pg(h, f) : (f = $b36720cd87d29ff4$var$Tg(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $b36720cd87d29ff4$var$nj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $b36720cd87d29ff4$var$mj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $b36720cd87d29ff4$var$Pg(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $b36720cd87d29ff4$var$qj(a, b) {
    b = $b36720cd87d29ff4$var$pj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $b36720cd87d29ff4$var$sj(a, b, c, d) {
    null !== d && $b36720cd87d29ff4$var$Jg(d);
    $b36720cd87d29ff4$var$Ug(b, a.child, null, c);
    a = $b36720cd87d29ff4$var$qj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $b36720cd87d29ff4$var$rj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $b36720cd87d29ff4$var$Ki(Error($b36720cd87d29ff4$var$p(422))), $b36720cd87d29ff4$var$sj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $b36720cd87d29ff4$var$pj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $b36720cd87d29ff4$var$Tg(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $b36720cd87d29ff4$var$Ug(b, a.child, null, g);
        b.child.memoizedState = $b36720cd87d29ff4$var$nj(g);
        b.memoizedState = $b36720cd87d29ff4$var$mj;
        return f;
    }
    if (0 === (b.mode & 1)) return $b36720cd87d29ff4$var$sj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($b36720cd87d29ff4$var$p(419));
        d = $b36720cd87d29ff4$var$Ki(f, d, void 0);
        return $b36720cd87d29ff4$var$sj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($b36720cd87d29ff4$var$dh || h) {
        d = $b36720cd87d29ff4$var$Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $b36720cd87d29ff4$var$ih(a, e), $b36720cd87d29ff4$var$gi(d, a, e, -1));
        }
        $b36720cd87d29ff4$var$tj();
        d = $b36720cd87d29ff4$var$Ki(Error($b36720cd87d29ff4$var$p(421)));
        return $b36720cd87d29ff4$var$sj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $b36720cd87d29ff4$var$uj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $b36720cd87d29ff4$var$yg = $b36720cd87d29ff4$var$Lf(e.nextSibling);
    $b36720cd87d29ff4$var$xg = b;
    $b36720cd87d29ff4$var$I = !0;
    $b36720cd87d29ff4$var$zg = null;
    null !== a && ($b36720cd87d29ff4$var$og[$b36720cd87d29ff4$var$pg++] = $b36720cd87d29ff4$var$rg, $b36720cd87d29ff4$var$og[$b36720cd87d29ff4$var$pg++] = $b36720cd87d29ff4$var$sg, $b36720cd87d29ff4$var$og[$b36720cd87d29ff4$var$pg++] = $b36720cd87d29ff4$var$qg, $b36720cd87d29ff4$var$rg = a.id, $b36720cd87d29ff4$var$sg = a.overflow, $b36720cd87d29ff4$var$qg = b);
    b = $b36720cd87d29ff4$var$qj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $b36720cd87d29ff4$var$vj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $b36720cd87d29ff4$var$bh(a.return, b, c);
}
function $b36720cd87d29ff4$var$wj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $b36720cd87d29ff4$var$xj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $b36720cd87d29ff4$var$Xi(a, b, d.children, c);
    d = $b36720cd87d29ff4$var$L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $b36720cd87d29ff4$var$vj(a, c, b);
            else if (19 === a.tag) $b36720cd87d29ff4$var$vj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $b36720cd87d29ff4$var$G($b36720cd87d29ff4$var$L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $b36720cd87d29ff4$var$Ch(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $b36720cd87d29ff4$var$wj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $b36720cd87d29ff4$var$Ch(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $b36720cd87d29ff4$var$wj(b, !0, c, null, f);
            break;
        case "together":
            $b36720cd87d29ff4$var$wj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $b36720cd87d29ff4$var$ij(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $b36720cd87d29ff4$var$Zi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $b36720cd87d29ff4$var$rh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($b36720cd87d29ff4$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $b36720cd87d29ff4$var$Pg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $b36720cd87d29ff4$var$Pg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $b36720cd87d29ff4$var$yj(a, b, c) {
    switch(b.tag){
        case 3:
            $b36720cd87d29ff4$var$kj(b);
            $b36720cd87d29ff4$var$Ig();
            break;
        case 5:
            $b36720cd87d29ff4$var$Ah(b);
            break;
        case 1:
            $b36720cd87d29ff4$var$Zf(b.type) && $b36720cd87d29ff4$var$cg(b);
            break;
        case 4:
            $b36720cd87d29ff4$var$yh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $b36720cd87d29ff4$var$G($b36720cd87d29ff4$var$Wg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $b36720cd87d29ff4$var$G($b36720cd87d29ff4$var$L, $b36720cd87d29ff4$var$L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $b36720cd87d29ff4$var$oj(a, b, c);
                $b36720cd87d29ff4$var$G($b36720cd87d29ff4$var$L, $b36720cd87d29ff4$var$L.current & 1);
                a = $b36720cd87d29ff4$var$Zi(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $b36720cd87d29ff4$var$G($b36720cd87d29ff4$var$L, $b36720cd87d29ff4$var$L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $b36720cd87d29ff4$var$xj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $b36720cd87d29ff4$var$G($b36720cd87d29ff4$var$L, $b36720cd87d29ff4$var$L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $b36720cd87d29ff4$var$dj(a, b, c);
    }
    return $b36720cd87d29ff4$var$Zi(a, b, c);
}
var $b36720cd87d29ff4$var$zj, $b36720cd87d29ff4$var$Aj, $b36720cd87d29ff4$var$Bj, $b36720cd87d29ff4$var$Cj;
$b36720cd87d29ff4$var$zj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$b36720cd87d29ff4$var$Aj = function() {};
$b36720cd87d29ff4$var$Bj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $b36720cd87d29ff4$var$xh($b36720cd87d29ff4$var$uh.current);
        var f = null;
        switch(c){
            case "input":
                e = $b36720cd87d29ff4$var$Ya(a, e);
                d = $b36720cd87d29ff4$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $b36720cd87d29ff4$var$A({}, e, {
                    value: void 0
                });
                d = $b36720cd87d29ff4$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $b36720cd87d29ff4$var$gb(a, e);
                d = $b36720cd87d29ff4$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $b36720cd87d29ff4$var$Bf);
        }
        $b36720cd87d29ff4$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($b36720cd87d29ff4$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($b36720cd87d29ff4$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $b36720cd87d29ff4$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$b36720cd87d29ff4$var$Cj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $b36720cd87d29ff4$var$Dj(a, b) {
    if (!$b36720cd87d29ff4$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $b36720cd87d29ff4$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $b36720cd87d29ff4$var$Ej(a, b, c) {
    var d = b.pendingProps;
    $b36720cd87d29ff4$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $b36720cd87d29ff4$var$S(b), null;
        case 1:
            return $b36720cd87d29ff4$var$Zf(b.type) && $b36720cd87d29ff4$var$$f(), $b36720cd87d29ff4$var$S(b), null;
        case 3:
            d = b.stateNode;
            $b36720cd87d29ff4$var$zh();
            $b36720cd87d29ff4$var$E($b36720cd87d29ff4$var$Wf);
            $b36720cd87d29ff4$var$E($b36720cd87d29ff4$var$H);
            $b36720cd87d29ff4$var$Eh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $b36720cd87d29ff4$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $b36720cd87d29ff4$var$zg && ($b36720cd87d29ff4$var$Fj($b36720cd87d29ff4$var$zg), $b36720cd87d29ff4$var$zg = null));
            $b36720cd87d29ff4$var$Aj(a, b);
            $b36720cd87d29ff4$var$S(b);
            return null;
        case 5:
            $b36720cd87d29ff4$var$Bh(b);
            var e = $b36720cd87d29ff4$var$xh($b36720cd87d29ff4$var$wh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $b36720cd87d29ff4$var$Bj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($b36720cd87d29ff4$var$p(166));
                    $b36720cd87d29ff4$var$S(b);
                    return null;
                }
                a = $b36720cd87d29ff4$var$xh($b36720cd87d29ff4$var$uh.current);
                if ($b36720cd87d29ff4$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$b36720cd87d29ff4$var$Of] = b;
                    d[$b36720cd87d29ff4$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $b36720cd87d29ff4$var$D("cancel", d);
                            $b36720cd87d29ff4$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $b36720cd87d29ff4$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $b36720cd87d29ff4$var$lf.length; e++)$b36720cd87d29ff4$var$D($b36720cd87d29ff4$var$lf[e], d);
                            break;
                        case "source":
                            $b36720cd87d29ff4$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $b36720cd87d29ff4$var$D("error", d);
                            $b36720cd87d29ff4$var$D("load", d);
                            break;
                        case "details":
                            $b36720cd87d29ff4$var$D("toggle", d);
                            break;
                        case "input":
                            $b36720cd87d29ff4$var$Za(d, f);
                            $b36720cd87d29ff4$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $b36720cd87d29ff4$var$D("invalid", d);
                            break;
                        case "textarea":
                            $b36720cd87d29ff4$var$hb(d, f), $b36720cd87d29ff4$var$D("invalid", d);
                    }
                    $b36720cd87d29ff4$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $b36720cd87d29ff4$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $b36720cd87d29ff4$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $b36720cd87d29ff4$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $b36720cd87d29ff4$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $b36720cd87d29ff4$var$Va(d);
                            $b36720cd87d29ff4$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $b36720cd87d29ff4$var$Va(d);
                            $b36720cd87d29ff4$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $b36720cd87d29ff4$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $b36720cd87d29ff4$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$b36720cd87d29ff4$var$Of] = b;
                    a[$b36720cd87d29ff4$var$Pf] = d;
                    $b36720cd87d29ff4$var$zj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $b36720cd87d29ff4$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $b36720cd87d29ff4$var$D("cancel", a);
                                $b36720cd87d29ff4$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $b36720cd87d29ff4$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $b36720cd87d29ff4$var$lf.length; e++)$b36720cd87d29ff4$var$D($b36720cd87d29ff4$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $b36720cd87d29ff4$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $b36720cd87d29ff4$var$D("error", a);
                                $b36720cd87d29ff4$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $b36720cd87d29ff4$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $b36720cd87d29ff4$var$Za(a, d);
                                e = $b36720cd87d29ff4$var$Ya(a, d);
                                $b36720cd87d29ff4$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $b36720cd87d29ff4$var$A({}, d, {
                                    value: void 0
                                });
                                $b36720cd87d29ff4$var$D("invalid", a);
                                break;
                            case "textarea":
                                $b36720cd87d29ff4$var$hb(a, d);
                                e = $b36720cd87d29ff4$var$gb(a, d);
                                $b36720cd87d29ff4$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $b36720cd87d29ff4$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $b36720cd87d29ff4$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $b36720cd87d29ff4$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $b36720cd87d29ff4$var$ob(a, k) : "number" === typeof k && $b36720cd87d29ff4$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($b36720cd87d29ff4$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $b36720cd87d29ff4$var$D("scroll", a) : null != k && $b36720cd87d29ff4$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $b36720cd87d29ff4$var$Va(a);
                                $b36720cd87d29ff4$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $b36720cd87d29ff4$var$Va(a);
                                $b36720cd87d29ff4$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $b36720cd87d29ff4$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $b36720cd87d29ff4$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $b36720cd87d29ff4$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $b36720cd87d29ff4$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $b36720cd87d29ff4$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $b36720cd87d29ff4$var$Cj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($b36720cd87d29ff4$var$p(166));
                c = $b36720cd87d29ff4$var$xh($b36720cd87d29ff4$var$wh.current);
                $b36720cd87d29ff4$var$xh($b36720cd87d29ff4$var$uh.current);
                if ($b36720cd87d29ff4$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$b36720cd87d29ff4$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $b36720cd87d29ff4$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $b36720cd87d29ff4$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $b36720cd87d29ff4$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$b36720cd87d29ff4$var$Of] = b, b.stateNode = d;
            }
            $b36720cd87d29ff4$var$S(b);
            return null;
        case 13:
            $b36720cd87d29ff4$var$E($b36720cd87d29ff4$var$L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($b36720cd87d29ff4$var$I && null !== $b36720cd87d29ff4$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $b36720cd87d29ff4$var$Hg(), $b36720cd87d29ff4$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $b36720cd87d29ff4$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($b36720cd87d29ff4$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($b36720cd87d29ff4$var$p(317));
                        f[$b36720cd87d29ff4$var$Of] = b;
                    } else $b36720cd87d29ff4$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $b36720cd87d29ff4$var$S(b);
                    f = !1;
                } else null !== $b36720cd87d29ff4$var$zg && ($b36720cd87d29ff4$var$Fj($b36720cd87d29ff4$var$zg), $b36720cd87d29ff4$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($b36720cd87d29ff4$var$L.current & 1) ? 0 === $b36720cd87d29ff4$var$T && ($b36720cd87d29ff4$var$T = 3) : $b36720cd87d29ff4$var$tj()));
            null !== b.updateQueue && (b.flags |= 4);
            $b36720cd87d29ff4$var$S(b);
            return null;
        case 4:
            return $b36720cd87d29ff4$var$zh(), $b36720cd87d29ff4$var$Aj(a, b), null === a && $b36720cd87d29ff4$var$sf(b.stateNode.containerInfo), $b36720cd87d29ff4$var$S(b), null;
        case 10:
            return $b36720cd87d29ff4$var$ah(b.type._context), $b36720cd87d29ff4$var$S(b), null;
        case 17:
            return $b36720cd87d29ff4$var$Zf(b.type) && $b36720cd87d29ff4$var$$f(), $b36720cd87d29ff4$var$S(b), null;
        case 19:
            $b36720cd87d29ff4$var$E($b36720cd87d29ff4$var$L);
            f = b.memoizedState;
            if (null === f) return $b36720cd87d29ff4$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $b36720cd87d29ff4$var$Dj(f, !1);
                else {
                    if (0 !== $b36720cd87d29ff4$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $b36720cd87d29ff4$var$Ch(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $b36720cd87d29ff4$var$Dj(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $b36720cd87d29ff4$var$G($b36720cd87d29ff4$var$L, $b36720cd87d29ff4$var$L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $b36720cd87d29ff4$var$B() > $b36720cd87d29ff4$var$Gj && (b.flags |= 128, d = !0, $b36720cd87d29ff4$var$Dj(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $b36720cd87d29ff4$var$Ch(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $b36720cd87d29ff4$var$Dj(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$b36720cd87d29ff4$var$I) return $b36720cd87d29ff4$var$S(b), null;
                    } else 2 * $b36720cd87d29ff4$var$B() - f.renderingStartTime > $b36720cd87d29ff4$var$Gj && 1073741824 !== c && (b.flags |= 128, d = !0, $b36720cd87d29ff4$var$Dj(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $b36720cd87d29ff4$var$B(), b.sibling = null, c = $b36720cd87d29ff4$var$L.current, $b36720cd87d29ff4$var$G($b36720cd87d29ff4$var$L, d ? c & 1 | 2 : c & 1), b;
            $b36720cd87d29ff4$var$S(b);
            return null;
        case 22:
        case 23:
            return $b36720cd87d29ff4$var$Hj(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($b36720cd87d29ff4$var$fj & 1073741824) && ($b36720cd87d29ff4$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $b36720cd87d29ff4$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($b36720cd87d29ff4$var$p(156, b.tag));
}
function $b36720cd87d29ff4$var$Ij(a, b) {
    $b36720cd87d29ff4$var$wg(b);
    switch(b.tag){
        case 1:
            return $b36720cd87d29ff4$var$Zf(b.type) && $b36720cd87d29ff4$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $b36720cd87d29ff4$var$zh(), $b36720cd87d29ff4$var$E($b36720cd87d29ff4$var$Wf), $b36720cd87d29ff4$var$E($b36720cd87d29ff4$var$H), $b36720cd87d29ff4$var$Eh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $b36720cd87d29ff4$var$Bh(b), null;
        case 13:
            $b36720cd87d29ff4$var$E($b36720cd87d29ff4$var$L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($b36720cd87d29ff4$var$p(340));
                $b36720cd87d29ff4$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $b36720cd87d29ff4$var$E($b36720cd87d29ff4$var$L), null;
        case 4:
            return $b36720cd87d29ff4$var$zh(), null;
        case 10:
            return $b36720cd87d29ff4$var$ah(b.type._context), null;
        case 22:
        case 23:
            return $b36720cd87d29ff4$var$Hj(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $b36720cd87d29ff4$var$Jj = !1, $b36720cd87d29ff4$var$U = !1, $b36720cd87d29ff4$var$Kj = "function" === typeof WeakSet ? WeakSet : Set, $b36720cd87d29ff4$var$V = null;
function $b36720cd87d29ff4$var$Lj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $b36720cd87d29ff4$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $b36720cd87d29ff4$var$Mj(a, b, c) {
    try {
        c();
    } catch (d) {
        $b36720cd87d29ff4$var$W(a, b, d);
    }
}
var $b36720cd87d29ff4$var$Nj = !1;
function $b36720cd87d29ff4$var$Oj(a, b) {
    $b36720cd87d29ff4$var$Cf = $b36720cd87d29ff4$var$dd;
    a = $b36720cd87d29ff4$var$Me();
    if ($b36720cd87d29ff4$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $b36720cd87d29ff4$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $b36720cd87d29ff4$var$dd = !1;
    for($b36720cd87d29ff4$var$V = b; null !== $b36720cd87d29ff4$var$V;)if (b = $b36720cd87d29ff4$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $b36720cd87d29ff4$var$V = a;
    else for(; null !== $b36720cd87d29ff4$var$V;){
        b = $b36720cd87d29ff4$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $b36720cd87d29ff4$var$Ci(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($b36720cd87d29ff4$var$p(163));
            }
        } catch (F) {
            $b36720cd87d29ff4$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $b36720cd87d29ff4$var$V = a;
            break;
        }
        $b36720cd87d29ff4$var$V = b.return;
    }
    n = $b36720cd87d29ff4$var$Nj;
    $b36720cd87d29ff4$var$Nj = !1;
    return n;
}
function $b36720cd87d29ff4$var$Pj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $b36720cd87d29ff4$var$Mj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $b36720cd87d29ff4$var$Qj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $b36720cd87d29ff4$var$Rj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $b36720cd87d29ff4$var$Sj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $b36720cd87d29ff4$var$Sj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$b36720cd87d29ff4$var$Of], delete b[$b36720cd87d29ff4$var$Pf], delete b[$b36720cd87d29ff4$var$of], delete b[$b36720cd87d29ff4$var$Qf], delete b[$b36720cd87d29ff4$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $b36720cd87d29ff4$var$Tj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $b36720cd87d29ff4$var$Uj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $b36720cd87d29ff4$var$Tj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $b36720cd87d29ff4$var$Vj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $b36720cd87d29ff4$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($b36720cd87d29ff4$var$Vj(a, b, c), a = a.sibling; null !== a;)$b36720cd87d29ff4$var$Vj(a, b, c), a = a.sibling;
}
function $b36720cd87d29ff4$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($b36720cd87d29ff4$var$Wj(a, b, c), a = a.sibling; null !== a;)$b36720cd87d29ff4$var$Wj(a, b, c), a = a.sibling;
}
var $b36720cd87d29ff4$var$X = null, $b36720cd87d29ff4$var$Xj = !1;
function $b36720cd87d29ff4$var$Yj(a, b, c) {
    for(c = c.child; null !== c;)$b36720cd87d29ff4$var$Zj(a, b, c), c = c.sibling;
}
function $b36720cd87d29ff4$var$Zj(a, b, c) {
    if ($b36720cd87d29ff4$var$lc && "function" === typeof $b36720cd87d29ff4$var$lc.onCommitFiberUnmount) try {
        $b36720cd87d29ff4$var$lc.onCommitFiberUnmount($b36720cd87d29ff4$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $b36720cd87d29ff4$var$U || $b36720cd87d29ff4$var$Lj(c, b);
        case 6:
            var d = $b36720cd87d29ff4$var$X, e = $b36720cd87d29ff4$var$Xj;
            $b36720cd87d29ff4$var$X = null;
            $b36720cd87d29ff4$var$Yj(a, b, c);
            $b36720cd87d29ff4$var$X = d;
            $b36720cd87d29ff4$var$Xj = e;
            null !== $b36720cd87d29ff4$var$X && ($b36720cd87d29ff4$var$Xj ? (a = $b36720cd87d29ff4$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $b36720cd87d29ff4$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $b36720cd87d29ff4$var$X && ($b36720cd87d29ff4$var$Xj ? (a = $b36720cd87d29ff4$var$X, c = c.stateNode, 8 === a.nodeType ? $b36720cd87d29ff4$var$Kf(a.parentNode, c) : 1 === a.nodeType && $b36720cd87d29ff4$var$Kf(a, c), $b36720cd87d29ff4$var$bd(a)) : $b36720cd87d29ff4$var$Kf($b36720cd87d29ff4$var$X, c.stateNode));
            break;
        case 4:
            d = $b36720cd87d29ff4$var$X;
            e = $b36720cd87d29ff4$var$Xj;
            $b36720cd87d29ff4$var$X = c.stateNode.containerInfo;
            $b36720cd87d29ff4$var$Xj = !0;
            $b36720cd87d29ff4$var$Yj(a, b, c);
            $b36720cd87d29ff4$var$X = d;
            $b36720cd87d29ff4$var$Xj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$b36720cd87d29ff4$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $b36720cd87d29ff4$var$Mj(c, b, g) : 0 !== (f & 4) && $b36720cd87d29ff4$var$Mj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $b36720cd87d29ff4$var$Yj(a, b, c);
            break;
        case 1:
            if (!$b36720cd87d29ff4$var$U && ($b36720cd87d29ff4$var$Lj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $b36720cd87d29ff4$var$W(c, b, h);
            }
            $b36720cd87d29ff4$var$Yj(a, b, c);
            break;
        case 21:
            $b36720cd87d29ff4$var$Yj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($b36720cd87d29ff4$var$U = (d = $b36720cd87d29ff4$var$U) || null !== c.memoizedState, $b36720cd87d29ff4$var$Yj(a, b, c), $b36720cd87d29ff4$var$U = d) : $b36720cd87d29ff4$var$Yj(a, b, c);
            break;
        default:
            $b36720cd87d29ff4$var$Yj(a, b, c);
    }
}
function $b36720cd87d29ff4$var$ak(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $b36720cd87d29ff4$var$Kj);
        b.forEach(function(b) {
            var d = $b36720cd87d29ff4$var$bk.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $b36720cd87d29ff4$var$ck(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $b36720cd87d29ff4$var$X = h.stateNode;
                        $b36720cd87d29ff4$var$Xj = !1;
                        break a;
                    case 3:
                        $b36720cd87d29ff4$var$X = h.stateNode.containerInfo;
                        $b36720cd87d29ff4$var$Xj = !0;
                        break a;
                    case 4:
                        $b36720cd87d29ff4$var$X = h.stateNode.containerInfo;
                        $b36720cd87d29ff4$var$Xj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $b36720cd87d29ff4$var$X) throw Error($b36720cd87d29ff4$var$p(160));
            $b36720cd87d29ff4$var$Zj(f, g, e);
            $b36720cd87d29ff4$var$X = null;
            $b36720cd87d29ff4$var$Xj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $b36720cd87d29ff4$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$b36720cd87d29ff4$var$dk(b, a), b = b.sibling;
}
function $b36720cd87d29ff4$var$dk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $b36720cd87d29ff4$var$ck(b, a);
            $b36720cd87d29ff4$var$ek(a);
            if (d & 4) {
                try {
                    $b36720cd87d29ff4$var$Pj(3, a, a.return), $b36720cd87d29ff4$var$Qj(3, a);
                } catch (t) {
                    $b36720cd87d29ff4$var$W(a, a.return, t);
                }
                try {
                    $b36720cd87d29ff4$var$Pj(5, a, a.return);
                } catch (t) {
                    $b36720cd87d29ff4$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $b36720cd87d29ff4$var$ck(b, a);
            $b36720cd87d29ff4$var$ek(a);
            d & 512 && null !== c && $b36720cd87d29ff4$var$Lj(c, c.return);
            break;
        case 5:
            $b36720cd87d29ff4$var$ck(b, a);
            $b36720cd87d29ff4$var$ek(a);
            d & 512 && null !== c && $b36720cd87d29ff4$var$Lj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $b36720cd87d29ff4$var$ob(e, "");
                } catch (t) {
                    $b36720cd87d29ff4$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $b36720cd87d29ff4$var$ab(e, f);
                    $b36720cd87d29ff4$var$vb(h, g);
                    var l = $b36720cd87d29ff4$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $b36720cd87d29ff4$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $b36720cd87d29ff4$var$nb(e, q) : "children" === m ? $b36720cd87d29ff4$var$ob(e, q) : $b36720cd87d29ff4$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $b36720cd87d29ff4$var$bb(e, f);
                            break;
                        case "textarea":
                            $b36720cd87d29ff4$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $b36720cd87d29ff4$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $b36720cd87d29ff4$var$fb(e, !!f.multiple, f.defaultValue, !0) : $b36720cd87d29ff4$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$b36720cd87d29ff4$var$Pf] = f;
                } catch (t) {
                    $b36720cd87d29ff4$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $b36720cd87d29ff4$var$ck(b, a);
            $b36720cd87d29ff4$var$ek(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($b36720cd87d29ff4$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $b36720cd87d29ff4$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $b36720cd87d29ff4$var$ck(b, a);
            $b36720cd87d29ff4$var$ek(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $b36720cd87d29ff4$var$bd(b.containerInfo);
            } catch (t) {
                $b36720cd87d29ff4$var$W(a, a.return, t);
            }
            break;
        case 4:
            $b36720cd87d29ff4$var$ck(b, a);
            $b36720cd87d29ff4$var$ek(a);
            break;
        case 13:
            $b36720cd87d29ff4$var$ck(b, a);
            $b36720cd87d29ff4$var$ek(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($b36720cd87d29ff4$var$fk = $b36720cd87d29ff4$var$B()));
            d & 4 && $b36720cd87d29ff4$var$ak(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($b36720cd87d29ff4$var$U = (l = $b36720cd87d29ff4$var$U) || m, $b36720cd87d29ff4$var$ck(b, a), $b36720cd87d29ff4$var$U = l) : $b36720cd87d29ff4$var$ck(b, a);
            $b36720cd87d29ff4$var$ek(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($b36720cd87d29ff4$var$V = a, m = a.child; null !== m;){
                    for(q = $b36720cd87d29ff4$var$V = m; null !== $b36720cd87d29ff4$var$V;){
                        r = $b36720cd87d29ff4$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $b36720cd87d29ff4$var$Pj(4, r, r.return);
                                break;
                            case 1:
                                $b36720cd87d29ff4$var$Lj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $b36720cd87d29ff4$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $b36720cd87d29ff4$var$Lj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $b36720cd87d29ff4$var$gk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $b36720cd87d29ff4$var$V = y) : $b36720cd87d29ff4$var$gk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $b36720cd87d29ff4$var$rb("display", g));
                            } catch (t) {
                                $b36720cd87d29ff4$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $b36720cd87d29ff4$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $b36720cd87d29ff4$var$ck(b, a);
            $b36720cd87d29ff4$var$ek(a);
            d & 4 && $b36720cd87d29ff4$var$ak(a);
            break;
        case 21:
            break;
        default:
            $b36720cd87d29ff4$var$ck(b, a), $b36720cd87d29ff4$var$ek(a);
    }
}
function $b36720cd87d29ff4$var$ek(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($b36720cd87d29ff4$var$Tj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($b36720cd87d29ff4$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($b36720cd87d29ff4$var$ob(e, ""), d.flags &= -33);
                    var f = $b36720cd87d29ff4$var$Uj(a);
                    $b36720cd87d29ff4$var$Wj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $b36720cd87d29ff4$var$Uj(a);
                    $b36720cd87d29ff4$var$Vj(a, h, g);
                    break;
                default:
                    throw Error($b36720cd87d29ff4$var$p(161));
            }
        } catch (k) {
            $b36720cd87d29ff4$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $b36720cd87d29ff4$var$hk(a, b, c) {
    $b36720cd87d29ff4$var$V = a;
    $b36720cd87d29ff4$var$ik(a, b, c);
}
function $b36720cd87d29ff4$var$ik(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $b36720cd87d29ff4$var$V;){
        var e = $b36720cd87d29ff4$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $b36720cd87d29ff4$var$Jj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $b36720cd87d29ff4$var$U;
                h = $b36720cd87d29ff4$var$Jj;
                var l = $b36720cd87d29ff4$var$U;
                $b36720cd87d29ff4$var$Jj = g;
                if (($b36720cd87d29ff4$var$U = k) && !l) for($b36720cd87d29ff4$var$V = e; null !== $b36720cd87d29ff4$var$V;)g = $b36720cd87d29ff4$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $b36720cd87d29ff4$var$jk(e) : null !== k ? (k.return = g, $b36720cd87d29ff4$var$V = k) : $b36720cd87d29ff4$var$jk(e);
                for(; null !== f;)$b36720cd87d29ff4$var$V = f, $b36720cd87d29ff4$var$ik(f, b, c), f = f.sibling;
                $b36720cd87d29ff4$var$V = e;
                $b36720cd87d29ff4$var$Jj = h;
                $b36720cd87d29ff4$var$U = l;
            }
            $b36720cd87d29ff4$var$kk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $b36720cd87d29ff4$var$V = f) : $b36720cd87d29ff4$var$kk(a, b, c);
    }
}
function $b36720cd87d29ff4$var$kk(a) {
    for(; null !== $b36720cd87d29ff4$var$V;){
        var b = $b36720cd87d29ff4$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $b36720cd87d29ff4$var$U || $b36720cd87d29ff4$var$Qj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$b36720cd87d29ff4$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $b36720cd87d29ff4$var$Ci(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $b36720cd87d29ff4$var$sh(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $b36720cd87d29ff4$var$sh(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $b36720cd87d29ff4$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($b36720cd87d29ff4$var$p(163));
                }
                $b36720cd87d29ff4$var$U || b.flags & 512 && $b36720cd87d29ff4$var$Rj(b);
            } catch (r) {
                $b36720cd87d29ff4$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $b36720cd87d29ff4$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $b36720cd87d29ff4$var$V = c;
            break;
        }
        $b36720cd87d29ff4$var$V = b.return;
    }
}
function $b36720cd87d29ff4$var$gk(a) {
    for(; null !== $b36720cd87d29ff4$var$V;){
        var b = $b36720cd87d29ff4$var$V;
        if (b === a) {
            $b36720cd87d29ff4$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $b36720cd87d29ff4$var$V = c;
            break;
        }
        $b36720cd87d29ff4$var$V = b.return;
    }
}
function $b36720cd87d29ff4$var$jk(a) {
    for(; null !== $b36720cd87d29ff4$var$V;){
        var b = $b36720cd87d29ff4$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $b36720cd87d29ff4$var$Qj(4, b);
                    } catch (k) {
                        $b36720cd87d29ff4$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $b36720cd87d29ff4$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $b36720cd87d29ff4$var$Rj(b);
                    } catch (k) {
                        $b36720cd87d29ff4$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $b36720cd87d29ff4$var$Rj(b);
                    } catch (k) {
                        $b36720cd87d29ff4$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $b36720cd87d29ff4$var$W(b, b.return, k);
        }
        if (b === a) {
            $b36720cd87d29ff4$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $b36720cd87d29ff4$var$V = h;
            break;
        }
        $b36720cd87d29ff4$var$V = b.return;
    }
}
var $b36720cd87d29ff4$var$lk = Math.ceil, $b36720cd87d29ff4$var$mk = $b36720cd87d29ff4$var$ua.ReactCurrentDispatcher, $b36720cd87d29ff4$var$nk = $b36720cd87d29ff4$var$ua.ReactCurrentOwner, $b36720cd87d29ff4$var$ok = $b36720cd87d29ff4$var$ua.ReactCurrentBatchConfig, $b36720cd87d29ff4$var$K = 0, $b36720cd87d29ff4$var$Q = null, $b36720cd87d29ff4$var$Y = null, $b36720cd87d29ff4$var$Z = 0, $b36720cd87d29ff4$var$fj = 0, $b36720cd87d29ff4$var$ej = $b36720cd87d29ff4$var$Uf(0), $b36720cd87d29ff4$var$T = 0, $b36720cd87d29ff4$var$pk = null, $b36720cd87d29ff4$var$rh = 0, $b36720cd87d29ff4$var$qk = 0, $b36720cd87d29ff4$var$rk = 0, $b36720cd87d29ff4$var$sk = null, $b36720cd87d29ff4$var$tk = null, $b36720cd87d29ff4$var$fk = 0, $b36720cd87d29ff4$var$Gj = Infinity, $b36720cd87d29ff4$var$uk = null, $b36720cd87d29ff4$var$Oi = !1, $b36720cd87d29ff4$var$Pi = null, $b36720cd87d29ff4$var$Ri = null, $b36720cd87d29ff4$var$vk = !1, $b36720cd87d29ff4$var$wk = null, $b36720cd87d29ff4$var$xk = 0, $b36720cd87d29ff4$var$yk = 0, $b36720cd87d29ff4$var$zk = null, $b36720cd87d29ff4$var$Ak = -1, $b36720cd87d29ff4$var$Bk = 0;
function $b36720cd87d29ff4$var$R() {
    return 0 !== ($b36720cd87d29ff4$var$K & 6) ? $b36720cd87d29ff4$var$B() : -1 !== $b36720cd87d29ff4$var$Ak ? $b36720cd87d29ff4$var$Ak : $b36720cd87d29ff4$var$Ak = $b36720cd87d29ff4$var$B();
}
function $b36720cd87d29ff4$var$yi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($b36720cd87d29ff4$var$K & 2) && 0 !== $b36720cd87d29ff4$var$Z) return $b36720cd87d29ff4$var$Z & -$b36720cd87d29ff4$var$Z;
    if (null !== $b36720cd87d29ff4$var$Kg.transition) return 0 === $b36720cd87d29ff4$var$Bk && ($b36720cd87d29ff4$var$Bk = $b36720cd87d29ff4$var$yc()), $b36720cd87d29ff4$var$Bk;
    a = $b36720cd87d29ff4$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $b36720cd87d29ff4$var$jd(a.type);
    return a;
}
function $b36720cd87d29ff4$var$gi(a, b, c, d) {
    if (50 < $b36720cd87d29ff4$var$yk) throw $b36720cd87d29ff4$var$yk = 0, $b36720cd87d29ff4$var$zk = null, Error($b36720cd87d29ff4$var$p(185));
    $b36720cd87d29ff4$var$Ac(a, c, d);
    if (0 === ($b36720cd87d29ff4$var$K & 2) || a !== $b36720cd87d29ff4$var$Q) a === $b36720cd87d29ff4$var$Q && (0 === ($b36720cd87d29ff4$var$K & 2) && ($b36720cd87d29ff4$var$qk |= c), 4 === $b36720cd87d29ff4$var$T && $b36720cd87d29ff4$var$Ck(a, $b36720cd87d29ff4$var$Z)), $b36720cd87d29ff4$var$Dk(a, d), 1 === c && 0 === $b36720cd87d29ff4$var$K && 0 === (b.mode & 1) && ($b36720cd87d29ff4$var$Gj = $b36720cd87d29ff4$var$B() + 500, $b36720cd87d29ff4$var$fg && $b36720cd87d29ff4$var$jg());
}
function $b36720cd87d29ff4$var$Dk(a, b) {
    var c = a.callbackNode;
    $b36720cd87d29ff4$var$wc(a, b);
    var d = $b36720cd87d29ff4$var$uc(a, a === $b36720cd87d29ff4$var$Q ? $b36720cd87d29ff4$var$Z : 0);
    if (0 === d) null !== c && $b36720cd87d29ff4$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $b36720cd87d29ff4$var$bc(c);
        if (1 === b) 0 === a.tag ? $b36720cd87d29ff4$var$ig($b36720cd87d29ff4$var$Ek.bind(null, a)) : $b36720cd87d29ff4$var$hg($b36720cd87d29ff4$var$Ek.bind(null, a)), $b36720cd87d29ff4$var$Jf(function() {
            0 === ($b36720cd87d29ff4$var$K & 6) && $b36720cd87d29ff4$var$jg();
        }), c = null;
        else {
            switch($b36720cd87d29ff4$var$Dc(d)){
                case 1:
                    c = $b36720cd87d29ff4$var$fc;
                    break;
                case 4:
                    c = $b36720cd87d29ff4$var$gc;
                    break;
                case 16:
                    c = $b36720cd87d29ff4$var$hc;
                    break;
                case 536870912:
                    c = $b36720cd87d29ff4$var$jc;
                    break;
                default:
                    c = $b36720cd87d29ff4$var$hc;
            }
            c = $b36720cd87d29ff4$var$Fk(c, $b36720cd87d29ff4$var$Gk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $b36720cd87d29ff4$var$Gk(a, b) {
    $b36720cd87d29ff4$var$Ak = -1;
    $b36720cd87d29ff4$var$Bk = 0;
    if (0 !== ($b36720cd87d29ff4$var$K & 6)) throw Error($b36720cd87d29ff4$var$p(327));
    var c = a.callbackNode;
    if ($b36720cd87d29ff4$var$Hk() && a.callbackNode !== c) return null;
    var d = $b36720cd87d29ff4$var$uc(a, a === $b36720cd87d29ff4$var$Q ? $b36720cd87d29ff4$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $b36720cd87d29ff4$var$Ik(a, d);
    else {
        b = d;
        var e = $b36720cd87d29ff4$var$K;
        $b36720cd87d29ff4$var$K |= 2;
        var f = $b36720cd87d29ff4$var$Jk();
        if ($b36720cd87d29ff4$var$Q !== a || $b36720cd87d29ff4$var$Z !== b) $b36720cd87d29ff4$var$uk = null, $b36720cd87d29ff4$var$Gj = $b36720cd87d29ff4$var$B() + 500, $b36720cd87d29ff4$var$Kk(a, b);
        for(;;)try {
            $b36720cd87d29ff4$var$Lk();
            break;
        } catch (h) {
            $b36720cd87d29ff4$var$Mk(a, h);
        }
        $b36720cd87d29ff4$var$$g();
        $b36720cd87d29ff4$var$mk.current = f;
        $b36720cd87d29ff4$var$K = e;
        null !== $b36720cd87d29ff4$var$Y ? b = 0 : ($b36720cd87d29ff4$var$Q = null, $b36720cd87d29ff4$var$Z = 0, b = $b36720cd87d29ff4$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $b36720cd87d29ff4$var$xc(a), 0 !== e && (d = e, b = $b36720cd87d29ff4$var$Nk(a, e)));
        if (1 === b) throw c = $b36720cd87d29ff4$var$pk, $b36720cd87d29ff4$var$Kk(a, 0), $b36720cd87d29ff4$var$Ck(a, d), $b36720cd87d29ff4$var$Dk(a, $b36720cd87d29ff4$var$B()), c;
        if (6 === b) $b36720cd87d29ff4$var$Ck(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$b36720cd87d29ff4$var$Ok(e) && (b = $b36720cd87d29ff4$var$Ik(a, d), 2 === b && (f = $b36720cd87d29ff4$var$xc(a), 0 !== f && (d = f, b = $b36720cd87d29ff4$var$Nk(a, f))), 1 === b)) throw c = $b36720cd87d29ff4$var$pk, $b36720cd87d29ff4$var$Kk(a, 0), $b36720cd87d29ff4$var$Ck(a, d), $b36720cd87d29ff4$var$Dk(a, $b36720cd87d29ff4$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($b36720cd87d29ff4$var$p(345));
                case 2:
                    $b36720cd87d29ff4$var$Pk(a, $b36720cd87d29ff4$var$tk, $b36720cd87d29ff4$var$uk);
                    break;
                case 3:
                    $b36720cd87d29ff4$var$Ck(a, d);
                    if ((d & 130023424) === d && (b = $b36720cd87d29ff4$var$fk + 500 - $b36720cd87d29ff4$var$B(), 10 < b)) {
                        if (0 !== $b36720cd87d29ff4$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $b36720cd87d29ff4$var$R();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $b36720cd87d29ff4$var$Ff($b36720cd87d29ff4$var$Pk.bind(null, a, $b36720cd87d29ff4$var$tk, $b36720cd87d29ff4$var$uk), b);
                        break;
                    }
                    $b36720cd87d29ff4$var$Pk(a, $b36720cd87d29ff4$var$tk, $b36720cd87d29ff4$var$uk);
                    break;
                case 4:
                    $b36720cd87d29ff4$var$Ck(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $b36720cd87d29ff4$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $b36720cd87d29ff4$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $b36720cd87d29ff4$var$lk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $b36720cd87d29ff4$var$Ff($b36720cd87d29ff4$var$Pk.bind(null, a, $b36720cd87d29ff4$var$tk, $b36720cd87d29ff4$var$uk), d);
                        break;
                    }
                    $b36720cd87d29ff4$var$Pk(a, $b36720cd87d29ff4$var$tk, $b36720cd87d29ff4$var$uk);
                    break;
                case 5:
                    $b36720cd87d29ff4$var$Pk(a, $b36720cd87d29ff4$var$tk, $b36720cd87d29ff4$var$uk);
                    break;
                default:
                    throw Error($b36720cd87d29ff4$var$p(329));
            }
        }
    }
    $b36720cd87d29ff4$var$Dk(a, $b36720cd87d29ff4$var$B());
    return a.callbackNode === c ? $b36720cd87d29ff4$var$Gk.bind(null, a) : null;
}
function $b36720cd87d29ff4$var$Nk(a, b) {
    var c = $b36720cd87d29ff4$var$sk;
    a.current.memoizedState.isDehydrated && ($b36720cd87d29ff4$var$Kk(a, b).flags |= 256);
    a = $b36720cd87d29ff4$var$Ik(a, b);
    2 !== a && (b = $b36720cd87d29ff4$var$tk, $b36720cd87d29ff4$var$tk = c, null !== b && $b36720cd87d29ff4$var$Fj(b));
    return a;
}
function $b36720cd87d29ff4$var$Fj(a) {
    null === $b36720cd87d29ff4$var$tk ? $b36720cd87d29ff4$var$tk = a : $b36720cd87d29ff4$var$tk.push.apply($b36720cd87d29ff4$var$tk, a);
}
function $b36720cd87d29ff4$var$Ok(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$b36720cd87d29ff4$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $b36720cd87d29ff4$var$Ck(a, b) {
    b &= ~$b36720cd87d29ff4$var$rk;
    b &= ~$b36720cd87d29ff4$var$qk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $b36720cd87d29ff4$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $b36720cd87d29ff4$var$Ek(a) {
    if (0 !== ($b36720cd87d29ff4$var$K & 6)) throw Error($b36720cd87d29ff4$var$p(327));
    $b36720cd87d29ff4$var$Hk();
    var b = $b36720cd87d29ff4$var$uc(a, 0);
    if (0 === (b & 1)) return $b36720cd87d29ff4$var$Dk(a, $b36720cd87d29ff4$var$B()), null;
    var c = $b36720cd87d29ff4$var$Ik(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $b36720cd87d29ff4$var$xc(a);
        0 !== d && (b = d, c = $b36720cd87d29ff4$var$Nk(a, d));
    }
    if (1 === c) throw c = $b36720cd87d29ff4$var$pk, $b36720cd87d29ff4$var$Kk(a, 0), $b36720cd87d29ff4$var$Ck(a, b), $b36720cd87d29ff4$var$Dk(a, $b36720cd87d29ff4$var$B()), c;
    if (6 === c) throw Error($b36720cd87d29ff4$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $b36720cd87d29ff4$var$Pk(a, $b36720cd87d29ff4$var$tk, $b36720cd87d29ff4$var$uk);
    $b36720cd87d29ff4$var$Dk(a, $b36720cd87d29ff4$var$B());
    return null;
}
function $b36720cd87d29ff4$var$Qk(a, b) {
    var c = $b36720cd87d29ff4$var$K;
    $b36720cd87d29ff4$var$K |= 1;
    try {
        return a(b);
    } finally{
        $b36720cd87d29ff4$var$K = c, 0 === $b36720cd87d29ff4$var$K && ($b36720cd87d29ff4$var$Gj = $b36720cd87d29ff4$var$B() + 500, $b36720cd87d29ff4$var$fg && $b36720cd87d29ff4$var$jg());
    }
}
function $b36720cd87d29ff4$var$Rk(a) {
    null !== $b36720cd87d29ff4$var$wk && 0 === $b36720cd87d29ff4$var$wk.tag && 0 === ($b36720cd87d29ff4$var$K & 6) && $b36720cd87d29ff4$var$Hk();
    var b = $b36720cd87d29ff4$var$K;
    $b36720cd87d29ff4$var$K |= 1;
    var c = $b36720cd87d29ff4$var$ok.transition, d = $b36720cd87d29ff4$var$C;
    try {
        if ($b36720cd87d29ff4$var$ok.transition = null, $b36720cd87d29ff4$var$C = 1, a) return a();
    } finally{
        $b36720cd87d29ff4$var$C = d, $b36720cd87d29ff4$var$ok.transition = c, $b36720cd87d29ff4$var$K = b, 0 === ($b36720cd87d29ff4$var$K & 6) && $b36720cd87d29ff4$var$jg();
    }
}
function $b36720cd87d29ff4$var$Hj() {
    $b36720cd87d29ff4$var$fj = $b36720cd87d29ff4$var$ej.current;
    $b36720cd87d29ff4$var$E($b36720cd87d29ff4$var$ej);
}
function $b36720cd87d29ff4$var$Kk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $b36720cd87d29ff4$var$Gf(c));
    if (null !== $b36720cd87d29ff4$var$Y) for(c = $b36720cd87d29ff4$var$Y.return; null !== c;){
        var d = c;
        $b36720cd87d29ff4$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $b36720cd87d29ff4$var$$f();
                break;
            case 3:
                $b36720cd87d29ff4$var$zh();
                $b36720cd87d29ff4$var$E($b36720cd87d29ff4$var$Wf);
                $b36720cd87d29ff4$var$E($b36720cd87d29ff4$var$H);
                $b36720cd87d29ff4$var$Eh();
                break;
            case 5:
                $b36720cd87d29ff4$var$Bh(d);
                break;
            case 4:
                $b36720cd87d29ff4$var$zh();
                break;
            case 13:
                $b36720cd87d29ff4$var$E($b36720cd87d29ff4$var$L);
                break;
            case 19:
                $b36720cd87d29ff4$var$E($b36720cd87d29ff4$var$L);
                break;
            case 10:
                $b36720cd87d29ff4$var$ah(d.type._context);
                break;
            case 22:
            case 23:
                $b36720cd87d29ff4$var$Hj();
        }
        c = c.return;
    }
    $b36720cd87d29ff4$var$Q = a;
    $b36720cd87d29ff4$var$Y = a = $b36720cd87d29ff4$var$Pg(a.current, null);
    $b36720cd87d29ff4$var$Z = $b36720cd87d29ff4$var$fj = b;
    $b36720cd87d29ff4$var$T = 0;
    $b36720cd87d29ff4$var$pk = null;
    $b36720cd87d29ff4$var$rk = $b36720cd87d29ff4$var$qk = $b36720cd87d29ff4$var$rh = 0;
    $b36720cd87d29ff4$var$tk = $b36720cd87d29ff4$var$sk = null;
    if (null !== $b36720cd87d29ff4$var$fh) {
        for(b = 0; b < $b36720cd87d29ff4$var$fh.length; b++)if (c = $b36720cd87d29ff4$var$fh[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $b36720cd87d29ff4$var$fh = null;
    }
    return a;
}
function $b36720cd87d29ff4$var$Mk(a, b) {
    do {
        var c = $b36720cd87d29ff4$var$Y;
        try {
            $b36720cd87d29ff4$var$$g();
            $b36720cd87d29ff4$var$Fh.current = $b36720cd87d29ff4$var$Rh;
            if ($b36720cd87d29ff4$var$Ih) {
                for(var d = $b36720cd87d29ff4$var$M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $b36720cd87d29ff4$var$Ih = !1;
            }
            $b36720cd87d29ff4$var$Hh = 0;
            $b36720cd87d29ff4$var$O = $b36720cd87d29ff4$var$N = $b36720cd87d29ff4$var$M = null;
            $b36720cd87d29ff4$var$Jh = !1;
            $b36720cd87d29ff4$var$Kh = 0;
            $b36720cd87d29ff4$var$nk.current = null;
            if (null === c || null === c.return) {
                $b36720cd87d29ff4$var$T = 1;
                $b36720cd87d29ff4$var$pk = b;
                $b36720cd87d29ff4$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $b36720cd87d29ff4$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $b36720cd87d29ff4$var$Ui(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $b36720cd87d29ff4$var$Vi(y, g, h, f, b);
                        y.mode & 1 && $b36720cd87d29ff4$var$Si(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $b36720cd87d29ff4$var$Si(f, l, b);
                            $b36720cd87d29ff4$var$tj();
                            break a;
                        }
                        k = Error($b36720cd87d29ff4$var$p(426));
                    }
                } else if ($b36720cd87d29ff4$var$I && h.mode & 1) {
                    var J = $b36720cd87d29ff4$var$Ui(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $b36720cd87d29ff4$var$Vi(J, g, h, f, b);
                        $b36720cd87d29ff4$var$Jg($b36720cd87d29ff4$var$Ji(k, h));
                        break a;
                    }
                }
                f = k = $b36720cd87d29ff4$var$Ji(k, h);
                4 !== $b36720cd87d29ff4$var$T && ($b36720cd87d29ff4$var$T = 2);
                null === $b36720cd87d29ff4$var$sk ? $b36720cd87d29ff4$var$sk = [
                    f
                ] : $b36720cd87d29ff4$var$sk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $b36720cd87d29ff4$var$Ni(f, k, b);
                            $b36720cd87d29ff4$var$ph(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $b36720cd87d29ff4$var$Ri || !$b36720cd87d29ff4$var$Ri.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $b36720cd87d29ff4$var$Qi(f, h, b);
                                $b36720cd87d29ff4$var$ph(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $b36720cd87d29ff4$var$Sk(c);
        } catch (na) {
            b = na;
            $b36720cd87d29ff4$var$Y === c && null !== c && ($b36720cd87d29ff4$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $b36720cd87d29ff4$var$Jk() {
    var a = $b36720cd87d29ff4$var$mk.current;
    $b36720cd87d29ff4$var$mk.current = $b36720cd87d29ff4$var$Rh;
    return null === a ? $b36720cd87d29ff4$var$Rh : a;
}
function $b36720cd87d29ff4$var$tj() {
    if (0 === $b36720cd87d29ff4$var$T || 3 === $b36720cd87d29ff4$var$T || 2 === $b36720cd87d29ff4$var$T) $b36720cd87d29ff4$var$T = 4;
    null === $b36720cd87d29ff4$var$Q || 0 === ($b36720cd87d29ff4$var$rh & 268435455) && 0 === ($b36720cd87d29ff4$var$qk & 268435455) || $b36720cd87d29ff4$var$Ck($b36720cd87d29ff4$var$Q, $b36720cd87d29ff4$var$Z);
}
function $b36720cd87d29ff4$var$Ik(a, b) {
    var c = $b36720cd87d29ff4$var$K;
    $b36720cd87d29ff4$var$K |= 2;
    var d = $b36720cd87d29ff4$var$Jk();
    if ($b36720cd87d29ff4$var$Q !== a || $b36720cd87d29ff4$var$Z !== b) $b36720cd87d29ff4$var$uk = null, $b36720cd87d29ff4$var$Kk(a, b);
    for(;;)try {
        $b36720cd87d29ff4$var$Tk();
        break;
    } catch (e) {
        $b36720cd87d29ff4$var$Mk(a, e);
    }
    $b36720cd87d29ff4$var$$g();
    $b36720cd87d29ff4$var$K = c;
    $b36720cd87d29ff4$var$mk.current = d;
    if (null !== $b36720cd87d29ff4$var$Y) throw Error($b36720cd87d29ff4$var$p(261));
    $b36720cd87d29ff4$var$Q = null;
    $b36720cd87d29ff4$var$Z = 0;
    return $b36720cd87d29ff4$var$T;
}
function $b36720cd87d29ff4$var$Tk() {
    for(; null !== $b36720cd87d29ff4$var$Y;)$b36720cd87d29ff4$var$Uk($b36720cd87d29ff4$var$Y);
}
function $b36720cd87d29ff4$var$Lk() {
    for(; null !== $b36720cd87d29ff4$var$Y && !$b36720cd87d29ff4$var$cc();)$b36720cd87d29ff4$var$Uk($b36720cd87d29ff4$var$Y);
}
function $b36720cd87d29ff4$var$Uk(a) {
    var b = $b36720cd87d29ff4$var$Vk(a.alternate, a, $b36720cd87d29ff4$var$fj);
    a.memoizedProps = a.pendingProps;
    null === b ? $b36720cd87d29ff4$var$Sk(a) : $b36720cd87d29ff4$var$Y = b;
    $b36720cd87d29ff4$var$nk.current = null;
}
function $b36720cd87d29ff4$var$Sk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $b36720cd87d29ff4$var$Ej(c, b, $b36720cd87d29ff4$var$fj), null !== c) {
                $b36720cd87d29ff4$var$Y = c;
                return;
            }
        } else {
            c = $b36720cd87d29ff4$var$Ij(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $b36720cd87d29ff4$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $b36720cd87d29ff4$var$T = 6;
                $b36720cd87d29ff4$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $b36720cd87d29ff4$var$Y = b;
            return;
        }
        $b36720cd87d29ff4$var$Y = b = a;
    }while (null !== b);
    0 === $b36720cd87d29ff4$var$T && ($b36720cd87d29ff4$var$T = 5);
}
function $b36720cd87d29ff4$var$Pk(a, b, c) {
    var d = $b36720cd87d29ff4$var$C, e = $b36720cd87d29ff4$var$ok.transition;
    try {
        $b36720cd87d29ff4$var$ok.transition = null, $b36720cd87d29ff4$var$C = 1, $b36720cd87d29ff4$var$Wk(a, b, c, d);
    } finally{
        $b36720cd87d29ff4$var$ok.transition = e, $b36720cd87d29ff4$var$C = d;
    }
    return null;
}
function $b36720cd87d29ff4$var$Wk(a, b, c, d) {
    do $b36720cd87d29ff4$var$Hk();
    while (null !== $b36720cd87d29ff4$var$wk);
    if (0 !== ($b36720cd87d29ff4$var$K & 6)) throw Error($b36720cd87d29ff4$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($b36720cd87d29ff4$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $b36720cd87d29ff4$var$Bc(a, f);
    a === $b36720cd87d29ff4$var$Q && ($b36720cd87d29ff4$var$Y = $b36720cd87d29ff4$var$Q = null, $b36720cd87d29ff4$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $b36720cd87d29ff4$var$vk || ($b36720cd87d29ff4$var$vk = !0, $b36720cd87d29ff4$var$Fk($b36720cd87d29ff4$var$hc, function() {
        $b36720cd87d29ff4$var$Hk();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $b36720cd87d29ff4$var$ok.transition;
        $b36720cd87d29ff4$var$ok.transition = null;
        var g = $b36720cd87d29ff4$var$C;
        $b36720cd87d29ff4$var$C = 1;
        var h = $b36720cd87d29ff4$var$K;
        $b36720cd87d29ff4$var$K |= 4;
        $b36720cd87d29ff4$var$nk.current = null;
        $b36720cd87d29ff4$var$Oj(a, c);
        $b36720cd87d29ff4$var$dk(c, a);
        $b36720cd87d29ff4$var$Oe($b36720cd87d29ff4$var$Df);
        $b36720cd87d29ff4$var$dd = !!$b36720cd87d29ff4$var$Cf;
        $b36720cd87d29ff4$var$Df = $b36720cd87d29ff4$var$Cf = null;
        a.current = c;
        $b36720cd87d29ff4$var$hk(c, a, e);
        $b36720cd87d29ff4$var$dc();
        $b36720cd87d29ff4$var$K = h;
        $b36720cd87d29ff4$var$C = g;
        $b36720cd87d29ff4$var$ok.transition = f;
    } else a.current = c;
    $b36720cd87d29ff4$var$vk && ($b36720cd87d29ff4$var$vk = !1, $b36720cd87d29ff4$var$wk = a, $b36720cd87d29ff4$var$xk = e);
    f = a.pendingLanes;
    0 === f && ($b36720cd87d29ff4$var$Ri = null);
    $b36720cd87d29ff4$var$mc(c.stateNode, d);
    $b36720cd87d29ff4$var$Dk(a, $b36720cd87d29ff4$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($b36720cd87d29ff4$var$Oi) throw $b36720cd87d29ff4$var$Oi = !1, a = $b36720cd87d29ff4$var$Pi, $b36720cd87d29ff4$var$Pi = null, a;
    0 !== ($b36720cd87d29ff4$var$xk & 1) && 0 !== a.tag && $b36720cd87d29ff4$var$Hk();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $b36720cd87d29ff4$var$zk ? $b36720cd87d29ff4$var$yk++ : ($b36720cd87d29ff4$var$yk = 0, $b36720cd87d29ff4$var$zk = a) : $b36720cd87d29ff4$var$yk = 0;
    $b36720cd87d29ff4$var$jg();
    return null;
}
function $b36720cd87d29ff4$var$Hk() {
    if (null !== $b36720cd87d29ff4$var$wk) {
        var a = $b36720cd87d29ff4$var$Dc($b36720cd87d29ff4$var$xk), b = $b36720cd87d29ff4$var$ok.transition, c = $b36720cd87d29ff4$var$C;
        try {
            $b36720cd87d29ff4$var$ok.transition = null;
            $b36720cd87d29ff4$var$C = 16 > a ? 16 : a;
            if (null === $b36720cd87d29ff4$var$wk) var d = !1;
            else {
                a = $b36720cd87d29ff4$var$wk;
                $b36720cd87d29ff4$var$wk = null;
                $b36720cd87d29ff4$var$xk = 0;
                if (0 !== ($b36720cd87d29ff4$var$K & 6)) throw Error($b36720cd87d29ff4$var$p(331));
                var e = $b36720cd87d29ff4$var$K;
                $b36720cd87d29ff4$var$K |= 4;
                for($b36720cd87d29ff4$var$V = a.current; null !== $b36720cd87d29ff4$var$V;){
                    var f = $b36720cd87d29ff4$var$V, g = f.child;
                    if (0 !== ($b36720cd87d29ff4$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($b36720cd87d29ff4$var$V = l; null !== $b36720cd87d29ff4$var$V;){
                                    var m = $b36720cd87d29ff4$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $b36720cd87d29ff4$var$Pj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $b36720cd87d29ff4$var$V = q;
                                    else for(; null !== $b36720cd87d29ff4$var$V;){
                                        m = $b36720cd87d29ff4$var$V;
                                        var r = m.sibling, y = m.return;
                                        $b36720cd87d29ff4$var$Sj(m);
                                        if (m === l) {
                                            $b36720cd87d29ff4$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $b36720cd87d29ff4$var$V = r;
                                            break;
                                        }
                                        $b36720cd87d29ff4$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $b36720cd87d29ff4$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $b36720cd87d29ff4$var$V = g;
                    else b: for(; null !== $b36720cd87d29ff4$var$V;){
                        f = $b36720cd87d29ff4$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $b36720cd87d29ff4$var$Pj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $b36720cd87d29ff4$var$V = x;
                            break b;
                        }
                        $b36720cd87d29ff4$var$V = f.return;
                    }
                }
                var w = a.current;
                for($b36720cd87d29ff4$var$V = w; null !== $b36720cd87d29ff4$var$V;){
                    g = $b36720cd87d29ff4$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $b36720cd87d29ff4$var$V = u;
                    else b: for(g = w; null !== $b36720cd87d29ff4$var$V;){
                        h = $b36720cd87d29ff4$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $b36720cd87d29ff4$var$Qj(9, h);
                            }
                        } catch (na) {
                            $b36720cd87d29ff4$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $b36720cd87d29ff4$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $b36720cd87d29ff4$var$V = F;
                            break b;
                        }
                        $b36720cd87d29ff4$var$V = h.return;
                    }
                }
                $b36720cd87d29ff4$var$K = e;
                $b36720cd87d29ff4$var$jg();
                if ($b36720cd87d29ff4$var$lc && "function" === typeof $b36720cd87d29ff4$var$lc.onPostCommitFiberRoot) try {
                    $b36720cd87d29ff4$var$lc.onPostCommitFiberRoot($b36720cd87d29ff4$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $b36720cd87d29ff4$var$C = c, $b36720cd87d29ff4$var$ok.transition = b;
        }
    }
    return !1;
}
function $b36720cd87d29ff4$var$Xk(a, b, c) {
    b = $b36720cd87d29ff4$var$Ji(c, b);
    b = $b36720cd87d29ff4$var$Ni(a, b, 1);
    a = $b36720cd87d29ff4$var$nh(a, b, 1);
    b = $b36720cd87d29ff4$var$R();
    null !== a && ($b36720cd87d29ff4$var$Ac(a, 1, b), $b36720cd87d29ff4$var$Dk(a, b));
}
function $b36720cd87d29ff4$var$W(a, b, c) {
    if (3 === a.tag) $b36720cd87d29ff4$var$Xk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $b36720cd87d29ff4$var$Xk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $b36720cd87d29ff4$var$Ri || !$b36720cd87d29ff4$var$Ri.has(d))) {
                a = $b36720cd87d29ff4$var$Ji(c, a);
                a = $b36720cd87d29ff4$var$Qi(b, a, 1);
                b = $b36720cd87d29ff4$var$nh(b, a, 1);
                a = $b36720cd87d29ff4$var$R();
                null !== b && ($b36720cd87d29ff4$var$Ac(b, 1, a), $b36720cd87d29ff4$var$Dk(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $b36720cd87d29ff4$var$Ti(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $b36720cd87d29ff4$var$R();
    a.pingedLanes |= a.suspendedLanes & c;
    $b36720cd87d29ff4$var$Q === a && ($b36720cd87d29ff4$var$Z & c) === c && (4 === $b36720cd87d29ff4$var$T || 3 === $b36720cd87d29ff4$var$T && ($b36720cd87d29ff4$var$Z & 130023424) === $b36720cd87d29ff4$var$Z && 500 > $b36720cd87d29ff4$var$B() - $b36720cd87d29ff4$var$fk ? $b36720cd87d29ff4$var$Kk(a, 0) : $b36720cd87d29ff4$var$rk |= c);
    $b36720cd87d29ff4$var$Dk(a, b);
}
function $b36720cd87d29ff4$var$Yk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $b36720cd87d29ff4$var$sc, $b36720cd87d29ff4$var$sc <<= 1, 0 === ($b36720cd87d29ff4$var$sc & 130023424) && ($b36720cd87d29ff4$var$sc = 4194304)));
    var c = $b36720cd87d29ff4$var$R();
    a = $b36720cd87d29ff4$var$ih(a, b);
    null !== a && ($b36720cd87d29ff4$var$Ac(a, b, c), $b36720cd87d29ff4$var$Dk(a, c));
}
function $b36720cd87d29ff4$var$uj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $b36720cd87d29ff4$var$Yk(a, c);
}
function $b36720cd87d29ff4$var$bk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($b36720cd87d29ff4$var$p(314));
    }
    null !== d && d.delete(b);
    $b36720cd87d29ff4$var$Yk(a, c);
}
var $b36720cd87d29ff4$var$Vk;
$b36720cd87d29ff4$var$Vk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $b36720cd87d29ff4$var$Wf.current) $b36720cd87d29ff4$var$dh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $b36720cd87d29ff4$var$dh = !1, $b36720cd87d29ff4$var$yj(a, b, c);
            $b36720cd87d29ff4$var$dh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $b36720cd87d29ff4$var$dh = !1, $b36720cd87d29ff4$var$I && 0 !== (b.flags & 1048576) && $b36720cd87d29ff4$var$ug(b, $b36720cd87d29ff4$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $b36720cd87d29ff4$var$ij(a, b);
            a = b.pendingProps;
            var e = $b36720cd87d29ff4$var$Yf(b, $b36720cd87d29ff4$var$H.current);
            $b36720cd87d29ff4$var$ch(b, c);
            e = $b36720cd87d29ff4$var$Nh(null, b, d, a, e, c);
            var f = $b36720cd87d29ff4$var$Sh();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $b36720cd87d29ff4$var$Zf(d) ? (f = !0, $b36720cd87d29ff4$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $b36720cd87d29ff4$var$kh(b), e.updater = $b36720cd87d29ff4$var$Ei, b.stateNode = e, e._reactInternals = b, $b36720cd87d29ff4$var$Ii(b, d, a, c), b = $b36720cd87d29ff4$var$jj(null, b, d, !0, f, c)) : (b.tag = 0, $b36720cd87d29ff4$var$I && f && $b36720cd87d29ff4$var$vg(b), $b36720cd87d29ff4$var$Xi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $b36720cd87d29ff4$var$ij(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $b36720cd87d29ff4$var$Zk(d);
                a = $b36720cd87d29ff4$var$Ci(d, a);
                switch(e){
                    case 0:
                        b = $b36720cd87d29ff4$var$cj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $b36720cd87d29ff4$var$hj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $b36720cd87d29ff4$var$Yi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $b36720cd87d29ff4$var$$i(null, b, d, $b36720cd87d29ff4$var$Ci(d.type, a), c);
                        break a;
                }
                throw Error($b36720cd87d29ff4$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $b36720cd87d29ff4$var$Ci(d, e), $b36720cd87d29ff4$var$cj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $b36720cd87d29ff4$var$Ci(d, e), $b36720cd87d29ff4$var$hj(a, b, d, e, c);
        case 3:
            a: {
                $b36720cd87d29ff4$var$kj(b);
                if (null === a) throw Error($b36720cd87d29ff4$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $b36720cd87d29ff4$var$lh(a, b);
                $b36720cd87d29ff4$var$qh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $b36720cd87d29ff4$var$Ji(Error($b36720cd87d29ff4$var$p(423)), b);
                        b = $b36720cd87d29ff4$var$lj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $b36720cd87d29ff4$var$Ji(Error($b36720cd87d29ff4$var$p(424)), b);
                        b = $b36720cd87d29ff4$var$lj(a, b, d, c, e);
                        break a;
                    } else for($b36720cd87d29ff4$var$yg = $b36720cd87d29ff4$var$Lf(b.stateNode.containerInfo.firstChild), $b36720cd87d29ff4$var$xg = b, $b36720cd87d29ff4$var$I = !0, $b36720cd87d29ff4$var$zg = null, c = $b36720cd87d29ff4$var$Vg(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $b36720cd87d29ff4$var$Ig();
                    if (d === e) {
                        b = $b36720cd87d29ff4$var$Zi(a, b, c);
                        break a;
                    }
                    $b36720cd87d29ff4$var$Xi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $b36720cd87d29ff4$var$Ah(b), null === a && $b36720cd87d29ff4$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $b36720cd87d29ff4$var$Ef(d, e) ? g = null : null !== f && $b36720cd87d29ff4$var$Ef(d, f) && (b.flags |= 32), $b36720cd87d29ff4$var$gj(a, b), $b36720cd87d29ff4$var$Xi(a, b, g, c), b.child;
        case 6:
            return null === a && $b36720cd87d29ff4$var$Eg(b), null;
        case 13:
            return $b36720cd87d29ff4$var$oj(a, b, c);
        case 4:
            return $b36720cd87d29ff4$var$yh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $b36720cd87d29ff4$var$Ug(b, null, d, c) : $b36720cd87d29ff4$var$Xi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $b36720cd87d29ff4$var$Ci(d, e), $b36720cd87d29ff4$var$Yi(a, b, d, e, c);
        case 7:
            return $b36720cd87d29ff4$var$Xi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $b36720cd87d29ff4$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $b36720cd87d29ff4$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $b36720cd87d29ff4$var$G($b36720cd87d29ff4$var$Wg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($b36720cd87d29ff4$var$He(f.value, g)) {
                        if (f.children === e.children && !$b36720cd87d29ff4$var$Wf.current) {
                            b = $b36720cd87d29ff4$var$Zi(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $b36720cd87d29ff4$var$mh(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $b36720cd87d29ff4$var$bh(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($b36720cd87d29ff4$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $b36720cd87d29ff4$var$bh(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $b36720cd87d29ff4$var$Xi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $b36720cd87d29ff4$var$ch(b, c), e = $b36720cd87d29ff4$var$eh(e), d = d(e), b.flags |= 1, $b36720cd87d29ff4$var$Xi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $b36720cd87d29ff4$var$Ci(d, b.pendingProps), e = $b36720cd87d29ff4$var$Ci(d.type, e), $b36720cd87d29ff4$var$$i(a, b, d, e, c);
        case 15:
            return $b36720cd87d29ff4$var$bj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $b36720cd87d29ff4$var$Ci(d, e), $b36720cd87d29ff4$var$ij(a, b), b.tag = 1, $b36720cd87d29ff4$var$Zf(d) ? (a = !0, $b36720cd87d29ff4$var$cg(b)) : a = !1, $b36720cd87d29ff4$var$ch(b, c), $b36720cd87d29ff4$var$Gi(b, d, e), $b36720cd87d29ff4$var$Ii(b, d, e, c), $b36720cd87d29ff4$var$jj(null, b, d, !0, a, c);
        case 19:
            return $b36720cd87d29ff4$var$xj(a, b, c);
        case 22:
            return $b36720cd87d29ff4$var$dj(a, b, c);
    }
    throw Error($b36720cd87d29ff4$var$p(156, b.tag));
};
function $b36720cd87d29ff4$var$Fk(a, b) {
    return $b36720cd87d29ff4$var$ac(a, b);
}
function $b36720cd87d29ff4$var$$k(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $b36720cd87d29ff4$var$Bg(a, b, c, d) {
    return new $b36720cd87d29ff4$var$$k(a, b, c, d);
}
function $b36720cd87d29ff4$var$aj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $b36720cd87d29ff4$var$Zk(a) {
    if ("function" === typeof a) return $b36720cd87d29ff4$var$aj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $b36720cd87d29ff4$var$Da) return 11;
        if (a === $b36720cd87d29ff4$var$Ga) return 14;
    }
    return 2;
}
function $b36720cd87d29ff4$var$Pg(a, b) {
    var c = a.alternate;
    null === c ? (c = $b36720cd87d29ff4$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $b36720cd87d29ff4$var$Rg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $b36720cd87d29ff4$var$aj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $b36720cd87d29ff4$var$ya:
            return $b36720cd87d29ff4$var$Tg(c.children, e, f, b);
        case $b36720cd87d29ff4$var$za:
            g = 8;
            e |= 8;
            break;
        case $b36720cd87d29ff4$var$Aa:
            return a = $b36720cd87d29ff4$var$Bg(12, c, b, e | 2), a.elementType = $b36720cd87d29ff4$var$Aa, a.lanes = f, a;
        case $b36720cd87d29ff4$var$Ea:
            return a = $b36720cd87d29ff4$var$Bg(13, c, b, e), a.elementType = $b36720cd87d29ff4$var$Ea, a.lanes = f, a;
        case $b36720cd87d29ff4$var$Fa:
            return a = $b36720cd87d29ff4$var$Bg(19, c, b, e), a.elementType = $b36720cd87d29ff4$var$Fa, a.lanes = f, a;
        case $b36720cd87d29ff4$var$Ia:
            return $b36720cd87d29ff4$var$pj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $b36720cd87d29ff4$var$Ba:
                    g = 10;
                    break a;
                case $b36720cd87d29ff4$var$Ca:
                    g = 9;
                    break a;
                case $b36720cd87d29ff4$var$Da:
                    g = 11;
                    break a;
                case $b36720cd87d29ff4$var$Ga:
                    g = 14;
                    break a;
                case $b36720cd87d29ff4$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($b36720cd87d29ff4$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $b36720cd87d29ff4$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $b36720cd87d29ff4$var$Tg(a, b, c, d) {
    a = $b36720cd87d29ff4$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $b36720cd87d29ff4$var$pj(a, b, c, d) {
    a = $b36720cd87d29ff4$var$Bg(22, a, d, b);
    a.elementType = $b36720cd87d29ff4$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $b36720cd87d29ff4$var$Qg(a, b, c) {
    a = $b36720cd87d29ff4$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $b36720cd87d29ff4$var$Sg(a, b, c) {
    b = $b36720cd87d29ff4$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $b36720cd87d29ff4$var$al(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $b36720cd87d29ff4$var$zc(0);
    this.expirationTimes = $b36720cd87d29ff4$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $b36720cd87d29ff4$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $b36720cd87d29ff4$var$bl(a, b, c, d, e, f, g, h, k) {
    a = new $b36720cd87d29ff4$var$al(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $b36720cd87d29ff4$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $b36720cd87d29ff4$var$kh(f);
    return a;
}
function $b36720cd87d29ff4$var$cl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $b36720cd87d29ff4$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $b36720cd87d29ff4$var$dl(a) {
    if (!a) return $b36720cd87d29ff4$var$Vf;
    a = a._reactInternals;
    a: {
        if ($b36720cd87d29ff4$var$Vb(a) !== a || 1 !== a.tag) throw Error($b36720cd87d29ff4$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($b36720cd87d29ff4$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($b36720cd87d29ff4$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($b36720cd87d29ff4$var$Zf(c)) return $b36720cd87d29ff4$var$bg(a, c, b);
    }
    return b;
}
function $b36720cd87d29ff4$var$el(a, b, c, d, e, f, g, h, k) {
    a = $b36720cd87d29ff4$var$bl(c, d, !0, a, e, f, g, h, k);
    a.context = $b36720cd87d29ff4$var$dl(null);
    c = a.current;
    d = $b36720cd87d29ff4$var$R();
    e = $b36720cd87d29ff4$var$yi(c);
    f = $b36720cd87d29ff4$var$mh(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $b36720cd87d29ff4$var$nh(c, f, e);
    a.current.lanes = e;
    $b36720cd87d29ff4$var$Ac(a, e, d);
    $b36720cd87d29ff4$var$Dk(a, d);
    return a;
}
function $b36720cd87d29ff4$var$fl(a, b, c, d) {
    var e = b.current, f = $b36720cd87d29ff4$var$R(), g = $b36720cd87d29ff4$var$yi(e);
    c = $b36720cd87d29ff4$var$dl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $b36720cd87d29ff4$var$mh(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $b36720cd87d29ff4$var$nh(e, b, g);
    null !== a && ($b36720cd87d29ff4$var$gi(a, e, g, f), $b36720cd87d29ff4$var$oh(a, e, g));
    return g;
}
function $b36720cd87d29ff4$var$gl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $b36720cd87d29ff4$var$hl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $b36720cd87d29ff4$var$il(a, b) {
    $b36720cd87d29ff4$var$hl(a, b);
    (a = a.alternate) && $b36720cd87d29ff4$var$hl(a, b);
}
function $b36720cd87d29ff4$var$jl() {
    return null;
}
var $b36720cd87d29ff4$var$kl = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $b36720cd87d29ff4$var$ll(a) {
    this._internalRoot = a;
}
$b36720cd87d29ff4$var$ml.prototype.render = $b36720cd87d29ff4$var$ll.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($b36720cd87d29ff4$var$p(409));
    $b36720cd87d29ff4$var$fl(a, b, null, null);
};
$b36720cd87d29ff4$var$ml.prototype.unmount = $b36720cd87d29ff4$var$ll.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $b36720cd87d29ff4$var$Rk(function() {
            $b36720cd87d29ff4$var$fl(null, a, null, null);
        });
        b[$b36720cd87d29ff4$var$uf] = null;
    }
};
function $b36720cd87d29ff4$var$ml(a) {
    this._internalRoot = a;
}
$b36720cd87d29ff4$var$ml.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $b36720cd87d29ff4$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $b36720cd87d29ff4$var$Qc.length && 0 !== b && b < $b36720cd87d29ff4$var$Qc[c].priority; c++);
        $b36720cd87d29ff4$var$Qc.splice(c, 0, a);
        0 === c && $b36720cd87d29ff4$var$Vc(a);
    }
};
function $b36720cd87d29ff4$var$nl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $b36720cd87d29ff4$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $b36720cd87d29ff4$var$pl() {}
function $b36720cd87d29ff4$var$ql(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $b36720cd87d29ff4$var$gl(g);
                f.call(a);
            };
        }
        var g = $b36720cd87d29ff4$var$el(b, d, a, 0, null, !1, !1, "", $b36720cd87d29ff4$var$pl);
        a._reactRootContainer = g;
        a[$b36720cd87d29ff4$var$uf] = g.current;
        $b36720cd87d29ff4$var$sf(8 === a.nodeType ? a.parentNode : a);
        $b36720cd87d29ff4$var$Rk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $b36720cd87d29ff4$var$gl(k);
            h.call(a);
        };
    }
    var k = $b36720cd87d29ff4$var$bl(a, 0, !1, null, null, !1, !1, "", $b36720cd87d29ff4$var$pl);
    a._reactRootContainer = k;
    a[$b36720cd87d29ff4$var$uf] = k.current;
    $b36720cd87d29ff4$var$sf(8 === a.nodeType ? a.parentNode : a);
    $b36720cd87d29ff4$var$Rk(function() {
        $b36720cd87d29ff4$var$fl(b, k, c, d);
    });
    return k;
}
function $b36720cd87d29ff4$var$rl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $b36720cd87d29ff4$var$gl(g);
                h.call(a);
            };
        }
        $b36720cd87d29ff4$var$fl(b, g, a, e);
    } else g = $b36720cd87d29ff4$var$ql(c, b, a, e, d);
    return $b36720cd87d29ff4$var$gl(g);
}
$b36720cd87d29ff4$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $b36720cd87d29ff4$var$tc(b.pendingLanes);
                0 !== c && ($b36720cd87d29ff4$var$Cc(b, c | 1), $b36720cd87d29ff4$var$Dk(b, $b36720cd87d29ff4$var$B()), 0 === ($b36720cd87d29ff4$var$K & 6) && ($b36720cd87d29ff4$var$Gj = $b36720cd87d29ff4$var$B() + 500, $b36720cd87d29ff4$var$jg()));
            }
            break;
        case 13:
            $b36720cd87d29ff4$var$Rk(function() {
                var b = $b36720cd87d29ff4$var$ih(a, 1);
                if (null !== b) {
                    var c = $b36720cd87d29ff4$var$R();
                    $b36720cd87d29ff4$var$gi(b, a, 1, c);
                }
            }), $b36720cd87d29ff4$var$il(a, 1);
    }
};
$b36720cd87d29ff4$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $b36720cd87d29ff4$var$ih(a, 134217728);
        if (null !== b) {
            var c = $b36720cd87d29ff4$var$R();
            $b36720cd87d29ff4$var$gi(b, a, 134217728, c);
        }
        $b36720cd87d29ff4$var$il(a, 134217728);
    }
};
$b36720cd87d29ff4$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $b36720cd87d29ff4$var$yi(a), c = $b36720cd87d29ff4$var$ih(a, b);
        if (null !== c) {
            var d = $b36720cd87d29ff4$var$R();
            $b36720cd87d29ff4$var$gi(c, a, b, d);
        }
        $b36720cd87d29ff4$var$il(a, b);
    }
};
$b36720cd87d29ff4$var$Hc = function() {
    return $b36720cd87d29ff4$var$C;
};
$b36720cd87d29ff4$var$Ic = function(a, b) {
    var c = $b36720cd87d29ff4$var$C;
    try {
        return $b36720cd87d29ff4$var$C = a, b();
    } finally{
        $b36720cd87d29ff4$var$C = c;
    }
};
$b36720cd87d29ff4$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $b36720cd87d29ff4$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $b36720cd87d29ff4$var$Db(d);
                        if (!e) throw Error($b36720cd87d29ff4$var$p(90));
                        $b36720cd87d29ff4$var$Wa(d);
                        $b36720cd87d29ff4$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $b36720cd87d29ff4$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $b36720cd87d29ff4$var$fb(a, !!c.multiple, b, !1);
    }
};
$b36720cd87d29ff4$var$Gb = $b36720cd87d29ff4$var$Qk;
$b36720cd87d29ff4$var$Hb = $b36720cd87d29ff4$var$Rk;
var $b36720cd87d29ff4$var$sl = {
    usingClientEntryPoint: !1,
    Events: [
        $b36720cd87d29ff4$var$Cb,
        $b36720cd87d29ff4$var$ue,
        $b36720cd87d29ff4$var$Db,
        $b36720cd87d29ff4$var$Eb,
        $b36720cd87d29ff4$var$Fb,
        $b36720cd87d29ff4$var$Qk
    ]
}, $b36720cd87d29ff4$var$tl = {
    findFiberByHostInstance: $b36720cd87d29ff4$var$Wc,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom"
};
var $b36720cd87d29ff4$var$ul = {
    bundleType: $b36720cd87d29ff4$var$tl.bundleType,
    version: $b36720cd87d29ff4$var$tl.version,
    rendererPackageName: $b36720cd87d29ff4$var$tl.rendererPackageName,
    rendererConfig: $b36720cd87d29ff4$var$tl.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $b36720cd87d29ff4$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $b36720cd87d29ff4$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $b36720cd87d29ff4$var$tl.findFiberByHostInstance || $b36720cd87d29ff4$var$jl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $b36720cd87d29ff4$var$vl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$b36720cd87d29ff4$var$vl.isDisabled && $b36720cd87d29ff4$var$vl.supportsFiber) try {
        $b36720cd87d29ff4$var$kc = $b36720cd87d29ff4$var$vl.inject($b36720cd87d29ff4$var$ul), $b36720cd87d29ff4$var$lc = $b36720cd87d29ff4$var$vl;
    } catch (a) {}
}
$b36720cd87d29ff4$export$ae55be85d98224ed = $b36720cd87d29ff4$var$sl;
$b36720cd87d29ff4$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$b36720cd87d29ff4$var$nl(b)) throw Error($b36720cd87d29ff4$var$p(200));
    return $b36720cd87d29ff4$var$cl(a, b, null, c);
};
$b36720cd87d29ff4$export$882461b6382ed46c = function(a, b) {
    if (!$b36720cd87d29ff4$var$nl(a)) throw Error($b36720cd87d29ff4$var$p(299));
    var c = !1, d = "", e = $b36720cd87d29ff4$var$kl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $b36720cd87d29ff4$var$bl(a, 1, !1, null, null, c, !1, d, e);
    a[$b36720cd87d29ff4$var$uf] = b.current;
    $b36720cd87d29ff4$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $b36720cd87d29ff4$var$ll(b);
};
$b36720cd87d29ff4$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($b36720cd87d29ff4$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($b36720cd87d29ff4$var$p(268, a));
    }
    a = $b36720cd87d29ff4$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$b36720cd87d29ff4$export$cd75ccfd720a3cd4 = function(a) {
    return $b36720cd87d29ff4$var$Rk(a);
};
$b36720cd87d29ff4$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$b36720cd87d29ff4$var$ol(b)) throw Error($b36720cd87d29ff4$var$p(200));
    return $b36720cd87d29ff4$var$rl(null, a, b, !0, c);
};
$b36720cd87d29ff4$export$757ceba2d55c277e = function(a, b, c) {
    if (!$b36720cd87d29ff4$var$nl(a)) throw Error($b36720cd87d29ff4$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $b36720cd87d29ff4$var$kl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $b36720cd87d29ff4$var$el(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$b36720cd87d29ff4$var$uf] = b.current;
    $b36720cd87d29ff4$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $b36720cd87d29ff4$var$ml(b);
};
$b36720cd87d29ff4$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$b36720cd87d29ff4$var$ol(b)) throw Error($b36720cd87d29ff4$var$p(200));
    return $b36720cd87d29ff4$var$rl(null, a, b, !1, c);
};
$b36720cd87d29ff4$export$502457920280e6be = function(a) {
    if (!$b36720cd87d29ff4$var$ol(a)) throw Error($b36720cd87d29ff4$var$p(40));
    return a._reactRootContainer ? ($b36720cd87d29ff4$var$Rk(function() {
        $b36720cd87d29ff4$var$rl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$b36720cd87d29ff4$var$uf] = null;
        });
    }), !0) : !1;
};
$b36720cd87d29ff4$export$c78a37762a8d58e1 = $b36720cd87d29ff4$var$Qk;
$b36720cd87d29ff4$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$b36720cd87d29ff4$var$ol(c)) throw Error($b36720cd87d29ff4$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($b36720cd87d29ff4$var$p(38));
    return $b36720cd87d29ff4$var$rl(a, b, c, !1, d);
};
$b36720cd87d29ff4$export$83d89fbfd8236492 = "18.3.1-next-f1338f8080-20240426";

});
parcelRegister("ke6Ab", function(module, exports) {
'use strict';

module.exports = (parcelRequire("3EMEd"));

});
parcelRegister("3EMEd", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $2a9ad7f019c2f835$export$c4744153514ff05d; }, function (v) { return $2a9ad7f019c2f835$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $2a9ad7f019c2f835$export$3e506c1ccc9cc1a7; }, function (v) { return $2a9ad7f019c2f835$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $2a9ad7f019c2f835$export$e26fe2ed2fa76875; }, function (v) { return $2a9ad7f019c2f835$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $2a9ad7f019c2f835$export$502329bbf4b505b1; }, function (v) { return $2a9ad7f019c2f835$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $2a9ad7f019c2f835$export$6e3807111c4874c4; }, function (v) { return $2a9ad7f019c2f835$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $2a9ad7f019c2f835$export$c27134553091fb3a; }, function (v) { return $2a9ad7f019c2f835$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $2a9ad7f019c2f835$export$33ee1acdc04fd2a2; }, function (v) { return $2a9ad7f019c2f835$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $2a9ad7f019c2f835$export$b00a404bbd5edef2; }, function (v) { return $2a9ad7f019c2f835$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $2a9ad7f019c2f835$export$8352ce38b91d0c62; }, function (v) { return $2a9ad7f019c2f835$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $2a9ad7f019c2f835$export$d66a1c1c77bd778b; }, function (v) { return $2a9ad7f019c2f835$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $2a9ad7f019c2f835$export$d3dfb8e4810cb555; }, function (v) { return $2a9ad7f019c2f835$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $2a9ad7f019c2f835$export$839f9183b0465a69; }, function (v) { return $2a9ad7f019c2f835$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $2a9ad7f019c2f835$export$72fdf0e06517287b; }, function (v) { return $2a9ad7f019c2f835$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $2a9ad7f019c2f835$export$4b844e58a3e414b4; }, function (v) { return $2a9ad7f019c2f835$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $2a9ad7f019c2f835$export$816d2913ae6b83b1; }, function (v) { return $2a9ad7f019c2f835$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $2a9ad7f019c2f835$export$61bcfe829111a1d0; }, function (v) { return $2a9ad7f019c2f835$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $2a9ad7f019c2f835$export$7ee8c9beb337bc3f; }, function (v) { return $2a9ad7f019c2f835$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $2a9ad7f019c2f835$export$b5836b71941fa3ed; }, function (v) { return $2a9ad7f019c2f835$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $2a9ad7f019c2f835$export$cf845f2c119da08a; }, function (v) { return $2a9ad7f019c2f835$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $2a9ad7f019c2f835$export$c4744153514ff05d;
var $2a9ad7f019c2f835$export$3e506c1ccc9cc1a7;
var $2a9ad7f019c2f835$export$e26fe2ed2fa76875;
var $2a9ad7f019c2f835$export$502329bbf4b505b1;
var $2a9ad7f019c2f835$export$6e3807111c4874c4;
var $2a9ad7f019c2f835$export$c27134553091fb3a;
var $2a9ad7f019c2f835$export$33ee1acdc04fd2a2;
var $2a9ad7f019c2f835$export$b00a404bbd5edef2;
var $2a9ad7f019c2f835$export$8352ce38b91d0c62;
var $2a9ad7f019c2f835$export$d66a1c1c77bd778b;
var $2a9ad7f019c2f835$export$d3dfb8e4810cb555;
var $2a9ad7f019c2f835$export$839f9183b0465a69;
var $2a9ad7f019c2f835$export$72fdf0e06517287b;
var $2a9ad7f019c2f835$export$4b844e58a3e414b4;
var $2a9ad7f019c2f835$export$816d2913ae6b83b1;
var $2a9ad7f019c2f835$export$61bcfe829111a1d0;
var $2a9ad7f019c2f835$export$7ee8c9beb337bc3f;
var $2a9ad7f019c2f835$export$b5836b71941fa3ed;
var $2a9ad7f019c2f835$export$cf845f2c119da08a;
'use strict';
function $2a9ad7f019c2f835$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $2a9ad7f019c2f835$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $2a9ad7f019c2f835$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $2a9ad7f019c2f835$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $2a9ad7f019c2f835$var$g(C, c)) n < e && 0 > $2a9ad7f019c2f835$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $2a9ad7f019c2f835$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $2a9ad7f019c2f835$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $2a9ad7f019c2f835$var$l = performance;
    $2a9ad7f019c2f835$export$c4744153514ff05d = function() {
        return $2a9ad7f019c2f835$var$l.now();
    };
} else {
    var $2a9ad7f019c2f835$var$p = Date, $2a9ad7f019c2f835$var$q = $2a9ad7f019c2f835$var$p.now();
    $2a9ad7f019c2f835$export$c4744153514ff05d = function() {
        return $2a9ad7f019c2f835$var$p.now() - $2a9ad7f019c2f835$var$q;
    };
}
var $2a9ad7f019c2f835$var$r = [], $2a9ad7f019c2f835$var$t = [], $2a9ad7f019c2f835$var$u = 1, $2a9ad7f019c2f835$var$v = null, $2a9ad7f019c2f835$var$y = 3, $2a9ad7f019c2f835$var$z = !1, $2a9ad7f019c2f835$var$A = !1, $2a9ad7f019c2f835$var$B = !1, $2a9ad7f019c2f835$var$D = "function" === typeof setTimeout ? setTimeout : null, $2a9ad7f019c2f835$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $2a9ad7f019c2f835$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $2a9ad7f019c2f835$var$G(a) {
    for(var b = $2a9ad7f019c2f835$var$h($2a9ad7f019c2f835$var$t); null !== b;){
        if (null === b.callback) $2a9ad7f019c2f835$var$k($2a9ad7f019c2f835$var$t);
        else if (b.startTime <= a) $2a9ad7f019c2f835$var$k($2a9ad7f019c2f835$var$t), b.sortIndex = b.expirationTime, $2a9ad7f019c2f835$var$f($2a9ad7f019c2f835$var$r, b);
        else break;
        b = $2a9ad7f019c2f835$var$h($2a9ad7f019c2f835$var$t);
    }
}
function $2a9ad7f019c2f835$var$H(a) {
    $2a9ad7f019c2f835$var$B = !1;
    $2a9ad7f019c2f835$var$G(a);
    if (!$2a9ad7f019c2f835$var$A) {
        if (null !== $2a9ad7f019c2f835$var$h($2a9ad7f019c2f835$var$r)) $2a9ad7f019c2f835$var$A = !0, $2a9ad7f019c2f835$var$I($2a9ad7f019c2f835$var$J);
        else {
            var b = $2a9ad7f019c2f835$var$h($2a9ad7f019c2f835$var$t);
            null !== b && $2a9ad7f019c2f835$var$K($2a9ad7f019c2f835$var$H, b.startTime - a);
        }
    }
}
function $2a9ad7f019c2f835$var$J(a, b) {
    $2a9ad7f019c2f835$var$A = !1;
    $2a9ad7f019c2f835$var$B && ($2a9ad7f019c2f835$var$B = !1, $2a9ad7f019c2f835$var$E($2a9ad7f019c2f835$var$L), $2a9ad7f019c2f835$var$L = -1);
    $2a9ad7f019c2f835$var$z = !0;
    var c = $2a9ad7f019c2f835$var$y;
    try {
        $2a9ad7f019c2f835$var$G(b);
        for($2a9ad7f019c2f835$var$v = $2a9ad7f019c2f835$var$h($2a9ad7f019c2f835$var$r); null !== $2a9ad7f019c2f835$var$v && (!($2a9ad7f019c2f835$var$v.expirationTime > b) || a && !$2a9ad7f019c2f835$var$M());){
            var d = $2a9ad7f019c2f835$var$v.callback;
            if ("function" === typeof d) {
                $2a9ad7f019c2f835$var$v.callback = null;
                $2a9ad7f019c2f835$var$y = $2a9ad7f019c2f835$var$v.priorityLevel;
                var e = d($2a9ad7f019c2f835$var$v.expirationTime <= b);
                b = $2a9ad7f019c2f835$export$c4744153514ff05d();
                "function" === typeof e ? $2a9ad7f019c2f835$var$v.callback = e : $2a9ad7f019c2f835$var$v === $2a9ad7f019c2f835$var$h($2a9ad7f019c2f835$var$r) && $2a9ad7f019c2f835$var$k($2a9ad7f019c2f835$var$r);
                $2a9ad7f019c2f835$var$G(b);
            } else $2a9ad7f019c2f835$var$k($2a9ad7f019c2f835$var$r);
            $2a9ad7f019c2f835$var$v = $2a9ad7f019c2f835$var$h($2a9ad7f019c2f835$var$r);
        }
        if (null !== $2a9ad7f019c2f835$var$v) var w = !0;
        else {
            var m = $2a9ad7f019c2f835$var$h($2a9ad7f019c2f835$var$t);
            null !== m && $2a9ad7f019c2f835$var$K($2a9ad7f019c2f835$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $2a9ad7f019c2f835$var$v = null, $2a9ad7f019c2f835$var$y = c, $2a9ad7f019c2f835$var$z = !1;
    }
}
var $2a9ad7f019c2f835$var$N = !1, $2a9ad7f019c2f835$var$O = null, $2a9ad7f019c2f835$var$L = -1, $2a9ad7f019c2f835$var$P = 5, $2a9ad7f019c2f835$var$Q = -1;
function $2a9ad7f019c2f835$var$M() {
    return $2a9ad7f019c2f835$export$c4744153514ff05d() - $2a9ad7f019c2f835$var$Q < $2a9ad7f019c2f835$var$P ? !1 : !0;
}
function $2a9ad7f019c2f835$var$R() {
    if (null !== $2a9ad7f019c2f835$var$O) {
        var a = $2a9ad7f019c2f835$export$c4744153514ff05d();
        $2a9ad7f019c2f835$var$Q = a;
        var b = !0;
        try {
            b = $2a9ad7f019c2f835$var$O(!0, a);
        } finally{
            b ? $2a9ad7f019c2f835$var$S() : ($2a9ad7f019c2f835$var$N = !1, $2a9ad7f019c2f835$var$O = null);
        }
    } else $2a9ad7f019c2f835$var$N = !1;
}
var $2a9ad7f019c2f835$var$S;
if ("function" === typeof $2a9ad7f019c2f835$var$F) $2a9ad7f019c2f835$var$S = function() {
    $2a9ad7f019c2f835$var$F($2a9ad7f019c2f835$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $2a9ad7f019c2f835$var$T = new MessageChannel, $2a9ad7f019c2f835$var$U = $2a9ad7f019c2f835$var$T.port2;
    $2a9ad7f019c2f835$var$T.port1.onmessage = $2a9ad7f019c2f835$var$R;
    $2a9ad7f019c2f835$var$S = function() {
        $2a9ad7f019c2f835$var$U.postMessage(null);
    };
} else $2a9ad7f019c2f835$var$S = function() {
    $2a9ad7f019c2f835$var$D($2a9ad7f019c2f835$var$R, 0);
};
function $2a9ad7f019c2f835$var$I(a) {
    $2a9ad7f019c2f835$var$O = a;
    $2a9ad7f019c2f835$var$N || ($2a9ad7f019c2f835$var$N = !0, $2a9ad7f019c2f835$var$S());
}
function $2a9ad7f019c2f835$var$K(a, b) {
    $2a9ad7f019c2f835$var$L = $2a9ad7f019c2f835$var$D(function() {
        a($2a9ad7f019c2f835$export$c4744153514ff05d());
    }, b);
}
$2a9ad7f019c2f835$export$3e506c1ccc9cc1a7 = 5;
$2a9ad7f019c2f835$export$e26fe2ed2fa76875 = 1;
$2a9ad7f019c2f835$export$502329bbf4b505b1 = 4;
$2a9ad7f019c2f835$export$6e3807111c4874c4 = 3;
$2a9ad7f019c2f835$export$c27134553091fb3a = null;
$2a9ad7f019c2f835$export$33ee1acdc04fd2a2 = 2;
$2a9ad7f019c2f835$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$2a9ad7f019c2f835$export$8352ce38b91d0c62 = function() {
    $2a9ad7f019c2f835$var$A || $2a9ad7f019c2f835$var$z || ($2a9ad7f019c2f835$var$A = !0, $2a9ad7f019c2f835$var$I($2a9ad7f019c2f835$var$J));
};
$2a9ad7f019c2f835$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $2a9ad7f019c2f835$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$2a9ad7f019c2f835$export$d3dfb8e4810cb555 = function() {
    return $2a9ad7f019c2f835$var$y;
};
$2a9ad7f019c2f835$export$839f9183b0465a69 = function() {
    return $2a9ad7f019c2f835$var$h($2a9ad7f019c2f835$var$r);
};
$2a9ad7f019c2f835$export$72fdf0e06517287b = function(a) {
    switch($2a9ad7f019c2f835$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $2a9ad7f019c2f835$var$y;
    }
    var c = $2a9ad7f019c2f835$var$y;
    $2a9ad7f019c2f835$var$y = b;
    try {
        return a();
    } finally{
        $2a9ad7f019c2f835$var$y = c;
    }
};
$2a9ad7f019c2f835$export$4b844e58a3e414b4 = function() {};
$2a9ad7f019c2f835$export$816d2913ae6b83b1 = function() {};
$2a9ad7f019c2f835$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $2a9ad7f019c2f835$var$y;
    $2a9ad7f019c2f835$var$y = a;
    try {
        return b();
    } finally{
        $2a9ad7f019c2f835$var$y = c;
    }
};
$2a9ad7f019c2f835$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $2a9ad7f019c2f835$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $2a9ad7f019c2f835$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $2a9ad7f019c2f835$var$f($2a9ad7f019c2f835$var$t, a), null === $2a9ad7f019c2f835$var$h($2a9ad7f019c2f835$var$r) && a === $2a9ad7f019c2f835$var$h($2a9ad7f019c2f835$var$t) && ($2a9ad7f019c2f835$var$B ? ($2a9ad7f019c2f835$var$E($2a9ad7f019c2f835$var$L), $2a9ad7f019c2f835$var$L = -1) : $2a9ad7f019c2f835$var$B = !0, $2a9ad7f019c2f835$var$K($2a9ad7f019c2f835$var$H, c - d))) : (a.sortIndex = e, $2a9ad7f019c2f835$var$f($2a9ad7f019c2f835$var$r, a), $2a9ad7f019c2f835$var$A || $2a9ad7f019c2f835$var$z || ($2a9ad7f019c2f835$var$A = !0, $2a9ad7f019c2f835$var$I($2a9ad7f019c2f835$var$J)));
    return a;
};
$2a9ad7f019c2f835$export$b5836b71941fa3ed = $2a9ad7f019c2f835$var$M;
$2a9ad7f019c2f835$export$cf845f2c119da08a = function(a) {
    var b = $2a9ad7f019c2f835$var$y;
    return function() {
        var c = $2a9ad7f019c2f835$var$y;
        $2a9ad7f019c2f835$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $2a9ad7f019c2f835$var$y = c;
        }
    };
};

});



parcelRegister("bAq0e", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", function () { return $86f73a1f5d7b8f91$export$2b8d127b894957b9; }, function (v) { return $86f73a1f5d7b8f91$export$2b8d127b894957b9 = v; });
$parcel$export(module.exports, "ConcurrentMode", function () { return $86f73a1f5d7b8f91$export$cea3a54a6425200c; }, function (v) { return $86f73a1f5d7b8f91$export$cea3a54a6425200c = v; });
$parcel$export(module.exports, "ContextConsumer", function () { return $86f73a1f5d7b8f91$export$a7c73072b1a182ae; }, function (v) { return $86f73a1f5d7b8f91$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $86f73a1f5d7b8f91$export$9f27bc3417b4524d; }, function (v) { return $86f73a1f5d7b8f91$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $86f73a1f5d7b8f91$export$db77ccec0bb4ccac; }, function (v) { return $86f73a1f5d7b8f91$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $86f73a1f5d7b8f91$export$8392c0c9d3dcbd35; }, function (v) { return $86f73a1f5d7b8f91$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $86f73a1f5d7b8f91$export$ffb0004e005737fa; }, function (v) { return $86f73a1f5d7b8f91$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $86f73a1f5d7b8f91$export$b624eff549462981; }, function (v) { return $86f73a1f5d7b8f91$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $86f73a1f5d7b8f91$export$7897aa7841a5380c; }, function (v) { return $86f73a1f5d7b8f91$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $86f73a1f5d7b8f91$export$602eac185826482c; }, function (v) { return $86f73a1f5d7b8f91$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $86f73a1f5d7b8f91$export$e2c29f18771995cb; }, function (v) { return $86f73a1f5d7b8f91$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $86f73a1f5d7b8f91$export$5f8d39834fd61797; }, function (v) { return $86f73a1f5d7b8f91$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $86f73a1f5d7b8f91$export$74bf444e3cd11ea5; }, function (v) { return $86f73a1f5d7b8f91$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $86f73a1f5d7b8f91$export$92387174baf9b227; }, function (v) { return $86f73a1f5d7b8f91$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $86f73a1f5d7b8f91$export$ec112efeb987d9c6; }, function (v) { return $86f73a1f5d7b8f91$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $86f73a1f5d7b8f91$export$b706b080d889d2c9; }, function (v) { return $86f73a1f5d7b8f91$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $86f73a1f5d7b8f91$export$5be5a87408f70ddc; }, function (v) { return $86f73a1f5d7b8f91$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $86f73a1f5d7b8f91$export$45a5e7f76e0caa8d; }, function (v) { return $86f73a1f5d7b8f91$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $86f73a1f5d7b8f91$export$455c2e768291efa6; }, function (v) { return $86f73a1f5d7b8f91$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $86f73a1f5d7b8f91$export$9522e17588c12572; }, function (v) { return $86f73a1f5d7b8f91$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $86f73a1f5d7b8f91$export$2110ac352bb060b9; }, function (v) { return $86f73a1f5d7b8f91$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $86f73a1f5d7b8f91$export$56885ab8b9c456ab; }, function (v) { return $86f73a1f5d7b8f91$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $86f73a1f5d7b8f91$export$d927fcb6adf8f9de; }, function (v) { return $86f73a1f5d7b8f91$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $86f73a1f5d7b8f91$export$b82d16f27459e05a; }, function (v) { return $86f73a1f5d7b8f91$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $86f73a1f5d7b8f91$export$522c17b4f5e123e8; }, function (v) { return $86f73a1f5d7b8f91$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $86f73a1f5d7b8f91$export$1aabd8a0274ecfd6; }, function (v) { return $86f73a1f5d7b8f91$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $86f73a1f5d7b8f91$export$9b621391a187a31a; }, function (v) { return $86f73a1f5d7b8f91$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $86f73a1f5d7b8f91$export$f5bbd400c2f4426f; }, function (v) { return $86f73a1f5d7b8f91$export$f5bbd400c2f4426f = v; });
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $86f73a1f5d7b8f91$export$2b8d127b894957b9;
var $86f73a1f5d7b8f91$export$cea3a54a6425200c;
var $86f73a1f5d7b8f91$export$a7c73072b1a182ae;
var $86f73a1f5d7b8f91$export$9f27bc3417b4524d;
var $86f73a1f5d7b8f91$export$db77ccec0bb4ccac;
var $86f73a1f5d7b8f91$export$8392c0c9d3dcbd35;
var $86f73a1f5d7b8f91$export$ffb0004e005737fa;
var $86f73a1f5d7b8f91$export$b624eff549462981;
var $86f73a1f5d7b8f91$export$7897aa7841a5380c;
var $86f73a1f5d7b8f91$export$602eac185826482c;
var $86f73a1f5d7b8f91$export$e2c29f18771995cb;
var $86f73a1f5d7b8f91$export$5f8d39834fd61797;
var $86f73a1f5d7b8f91$export$74bf444e3cd11ea5;
var $86f73a1f5d7b8f91$export$92387174baf9b227;
var $86f73a1f5d7b8f91$export$ec112efeb987d9c6;
var $86f73a1f5d7b8f91$export$b706b080d889d2c9;
var $86f73a1f5d7b8f91$export$5be5a87408f70ddc;
var $86f73a1f5d7b8f91$export$45a5e7f76e0caa8d;
var $86f73a1f5d7b8f91$export$455c2e768291efa6;
var $86f73a1f5d7b8f91$export$9522e17588c12572;
var $86f73a1f5d7b8f91$export$2110ac352bb060b9;
var $86f73a1f5d7b8f91$export$56885ab8b9c456ab;
var $86f73a1f5d7b8f91$export$d927fcb6adf8f9de;
var $86f73a1f5d7b8f91$export$b82d16f27459e05a;
var $86f73a1f5d7b8f91$export$522c17b4f5e123e8;
var $86f73a1f5d7b8f91$export$1aabd8a0274ecfd6;
var $86f73a1f5d7b8f91$export$9b621391a187a31a;
var $86f73a1f5d7b8f91$export$f5bbd400c2f4426f;
'use strict';
var $86f73a1f5d7b8f91$var$b = "function" === typeof Symbol && Symbol.for, $86f73a1f5d7b8f91$var$c = $86f73a1f5d7b8f91$var$b ? Symbol.for("react.element") : 60103, $86f73a1f5d7b8f91$var$d = $86f73a1f5d7b8f91$var$b ? Symbol.for("react.portal") : 60106, $86f73a1f5d7b8f91$var$e = $86f73a1f5d7b8f91$var$b ? Symbol.for("react.fragment") : 60107, $86f73a1f5d7b8f91$var$f = $86f73a1f5d7b8f91$var$b ? Symbol.for("react.strict_mode") : 60108, $86f73a1f5d7b8f91$var$g = $86f73a1f5d7b8f91$var$b ? Symbol.for("react.profiler") : 60114, $86f73a1f5d7b8f91$var$h = $86f73a1f5d7b8f91$var$b ? Symbol.for("react.provider") : 60109, $86f73a1f5d7b8f91$var$k = $86f73a1f5d7b8f91$var$b ? Symbol.for("react.context") : 60110, $86f73a1f5d7b8f91$var$l = $86f73a1f5d7b8f91$var$b ? Symbol.for("react.async_mode") : 60111, $86f73a1f5d7b8f91$var$m = $86f73a1f5d7b8f91$var$b ? Symbol.for("react.concurrent_mode") : 60111, $86f73a1f5d7b8f91$var$n = $86f73a1f5d7b8f91$var$b ? Symbol.for("react.forward_ref") : 60112, $86f73a1f5d7b8f91$var$p = $86f73a1f5d7b8f91$var$b ? Symbol.for("react.suspense") : 60113, $86f73a1f5d7b8f91$var$q = $86f73a1f5d7b8f91$var$b ? Symbol.for("react.suspense_list") : 60120, $86f73a1f5d7b8f91$var$r = $86f73a1f5d7b8f91$var$b ? Symbol.for("react.memo") : 60115, $86f73a1f5d7b8f91$var$t = $86f73a1f5d7b8f91$var$b ? Symbol.for("react.lazy") : 60116, $86f73a1f5d7b8f91$var$v = $86f73a1f5d7b8f91$var$b ? Symbol.for("react.block") : 60121, $86f73a1f5d7b8f91$var$w = $86f73a1f5d7b8f91$var$b ? Symbol.for("react.fundamental") : 60117, $86f73a1f5d7b8f91$var$x = $86f73a1f5d7b8f91$var$b ? Symbol.for("react.responder") : 60118, $86f73a1f5d7b8f91$var$y = $86f73a1f5d7b8f91$var$b ? Symbol.for("react.scope") : 60119;
function $86f73a1f5d7b8f91$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $86f73a1f5d7b8f91$var$c:
                switch(a = a.type, a){
                    case $86f73a1f5d7b8f91$var$l:
                    case $86f73a1f5d7b8f91$var$m:
                    case $86f73a1f5d7b8f91$var$e:
                    case $86f73a1f5d7b8f91$var$g:
                    case $86f73a1f5d7b8f91$var$f:
                    case $86f73a1f5d7b8f91$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $86f73a1f5d7b8f91$var$k:
                            case $86f73a1f5d7b8f91$var$n:
                            case $86f73a1f5d7b8f91$var$t:
                            case $86f73a1f5d7b8f91$var$r:
                            case $86f73a1f5d7b8f91$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $86f73a1f5d7b8f91$var$d:
                return u;
        }
    }
}
function $86f73a1f5d7b8f91$var$A(a) {
    return $86f73a1f5d7b8f91$var$z(a) === $86f73a1f5d7b8f91$var$m;
}
$86f73a1f5d7b8f91$export$2b8d127b894957b9 = $86f73a1f5d7b8f91$var$l;
$86f73a1f5d7b8f91$export$cea3a54a6425200c = $86f73a1f5d7b8f91$var$m;
$86f73a1f5d7b8f91$export$a7c73072b1a182ae = $86f73a1f5d7b8f91$var$k;
$86f73a1f5d7b8f91$export$9f27bc3417b4524d = $86f73a1f5d7b8f91$var$h;
$86f73a1f5d7b8f91$export$db77ccec0bb4ccac = $86f73a1f5d7b8f91$var$c;
$86f73a1f5d7b8f91$export$8392c0c9d3dcbd35 = $86f73a1f5d7b8f91$var$n;
$86f73a1f5d7b8f91$export$ffb0004e005737fa = $86f73a1f5d7b8f91$var$e;
$86f73a1f5d7b8f91$export$b624eff549462981 = $86f73a1f5d7b8f91$var$t;
$86f73a1f5d7b8f91$export$7897aa7841a5380c = $86f73a1f5d7b8f91$var$r;
$86f73a1f5d7b8f91$export$602eac185826482c = $86f73a1f5d7b8f91$var$d;
$86f73a1f5d7b8f91$export$e2c29f18771995cb = $86f73a1f5d7b8f91$var$g;
$86f73a1f5d7b8f91$export$5f8d39834fd61797 = $86f73a1f5d7b8f91$var$f;
$86f73a1f5d7b8f91$export$74bf444e3cd11ea5 = $86f73a1f5d7b8f91$var$p;
$86f73a1f5d7b8f91$export$92387174baf9b227 = function(a) {
    return $86f73a1f5d7b8f91$var$A(a) || $86f73a1f5d7b8f91$var$z(a) === $86f73a1f5d7b8f91$var$l;
};
$86f73a1f5d7b8f91$export$ec112efeb987d9c6 = $86f73a1f5d7b8f91$var$A;
$86f73a1f5d7b8f91$export$b706b080d889d2c9 = function(a) {
    return $86f73a1f5d7b8f91$var$z(a) === $86f73a1f5d7b8f91$var$k;
};
$86f73a1f5d7b8f91$export$5be5a87408f70ddc = function(a) {
    return $86f73a1f5d7b8f91$var$z(a) === $86f73a1f5d7b8f91$var$h;
};
$86f73a1f5d7b8f91$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $86f73a1f5d7b8f91$var$c;
};
$86f73a1f5d7b8f91$export$455c2e768291efa6 = function(a) {
    return $86f73a1f5d7b8f91$var$z(a) === $86f73a1f5d7b8f91$var$n;
};
$86f73a1f5d7b8f91$export$9522e17588c12572 = function(a) {
    return $86f73a1f5d7b8f91$var$z(a) === $86f73a1f5d7b8f91$var$e;
};
$86f73a1f5d7b8f91$export$2110ac352bb060b9 = function(a) {
    return $86f73a1f5d7b8f91$var$z(a) === $86f73a1f5d7b8f91$var$t;
};
$86f73a1f5d7b8f91$export$56885ab8b9c456ab = function(a) {
    return $86f73a1f5d7b8f91$var$z(a) === $86f73a1f5d7b8f91$var$r;
};
$86f73a1f5d7b8f91$export$d927fcb6adf8f9de = function(a) {
    return $86f73a1f5d7b8f91$var$z(a) === $86f73a1f5d7b8f91$var$d;
};
$86f73a1f5d7b8f91$export$b82d16f27459e05a = function(a) {
    return $86f73a1f5d7b8f91$var$z(a) === $86f73a1f5d7b8f91$var$g;
};
$86f73a1f5d7b8f91$export$522c17b4f5e123e8 = function(a) {
    return $86f73a1f5d7b8f91$var$z(a) === $86f73a1f5d7b8f91$var$f;
};
$86f73a1f5d7b8f91$export$1aabd8a0274ecfd6 = function(a) {
    return $86f73a1f5d7b8f91$var$z(a) === $86f73a1f5d7b8f91$var$p;
};
$86f73a1f5d7b8f91$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $86f73a1f5d7b8f91$var$e || a === $86f73a1f5d7b8f91$var$m || a === $86f73a1f5d7b8f91$var$g || a === $86f73a1f5d7b8f91$var$f || a === $86f73a1f5d7b8f91$var$p || a === $86f73a1f5d7b8f91$var$q || "object" === typeof a && null !== a && (a.$$typeof === $86f73a1f5d7b8f91$var$t || a.$$typeof === $86f73a1f5d7b8f91$var$r || a.$$typeof === $86f73a1f5d7b8f91$var$h || a.$$typeof === $86f73a1f5d7b8f91$var$k || a.$$typeof === $86f73a1f5d7b8f91$var$n || a.$$typeof === $86f73a1f5d7b8f91$var$w || a.$$typeof === $86f73a1f5d7b8f91$var$x || a.$$typeof === $86f73a1f5d7b8f91$var$y || a.$$typeof === $86f73a1f5d7b8f91$var$v);
};
$86f73a1f5d7b8f91$export$f5bbd400c2f4426f = $86f73a1f5d7b8f91$var$z;

});

var $65eed959c02d7598$exports = {};
'use strict';

$65eed959c02d7598$exports = (parcelRequire("5ytEK"));


var $320b03ed0fb31615$exports = {};
'use strict';
function $320b03ed0fb31615$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($320b03ed0fb31615$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$320b03ed0fb31615$var$checkDCE();

$320b03ed0fb31615$exports = (parcelRequire("foXlc"));


function $f3601d07f0ff7403$export$2e2bcd8739ae039() {
    return $f3601d07f0ff7403$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $f3601d07f0ff7403$export$2e2bcd8739ae039.apply(null, arguments);
}



var $2d3546043d93dd46$export$6acf61af03e62db = typeof window === 'undefined';
function $2d3546043d93dd46$export$8793edee2d425525() {
    return undefined;
}
function $2d3546043d93dd46$export$7f095f455ad5af3f(updater, input) {
    return typeof updater === 'function' ? updater(input) : updater;
}
function $2d3546043d93dd46$export$e539f754e934e270(value) {
    return typeof value === 'number' && value >= 0 && value !== Infinity;
}
function $2d3546043d93dd46$export$4d32d63f64b825b9(value) {
    return Array.isArray(value) ? value : [
        value
    ];
}
function $2d3546043d93dd46$export$acaf96a27438246b(array1, array2) {
    return array1.filter(function(x) {
        return array2.indexOf(x) === -1;
    });
}
function $2d3546043d93dd46$export$224e3b7078227b8a(array, index, value) {
    var copy = array.slice(0);
    copy[index] = value;
    return copy;
}
function $2d3546043d93dd46$export$811b83d62bcf47f0(updatedAt, staleTime) {
    return Math.max(updatedAt + (staleTime || 0) - Date.now(), 0);
}
function $2d3546043d93dd46$export$8a11fbc2c8ea08fd(arg1, arg2, arg3) {
    if (!$2d3546043d93dd46$export$aaae5295ec3351c9(arg1)) return arg1;
    if (typeof arg2 === 'function') return (0, $f3601d07f0ff7403$export$2e2bcd8739ae039)({}, arg3, {
        queryKey: arg1,
        queryFn: arg2
    });
    return (0, $f3601d07f0ff7403$export$2e2bcd8739ae039)({}, arg2, {
        queryKey: arg1
    });
}
function $2d3546043d93dd46$export$b646c531ea475334(arg1, arg2, arg3) {
    if ($2d3546043d93dd46$export$aaae5295ec3351c9(arg1)) {
        if (typeof arg2 === 'function') return (0, $f3601d07f0ff7403$export$2e2bcd8739ae039)({}, arg3, {
            mutationKey: arg1,
            mutationFn: arg2
        });
        return (0, $f3601d07f0ff7403$export$2e2bcd8739ae039)({}, arg2, {
            mutationKey: arg1
        });
    }
    if (typeof arg1 === 'function') return (0, $f3601d07f0ff7403$export$2e2bcd8739ae039)({}, arg2, {
        mutationFn: arg1
    });
    return (0, $f3601d07f0ff7403$export$2e2bcd8739ae039)({}, arg1);
}
function $2d3546043d93dd46$export$18e8f4b987e6c111(arg1, arg2, arg3) {
    return $2d3546043d93dd46$export$aaae5295ec3351c9(arg1) ? [
        (0, $f3601d07f0ff7403$export$2e2bcd8739ae039)({}, arg2, {
            queryKey: arg1
        }),
        arg3
    ] : [
        arg1 || {},
        arg2
    ];
}
function $2d3546043d93dd46$export$42387eeaac09cf54(arg1, arg2) {
    return $2d3546043d93dd46$export$aaae5295ec3351c9(arg1) ? (0, $f3601d07f0ff7403$export$2e2bcd8739ae039)({}, arg2, {
        mutationKey: arg1
    }) : arg1;
}
function $2d3546043d93dd46$export$eafbe052e989494f(active, inactive) {
    if (active === true && inactive === true || active == null && inactive == null) return 'all';
    else if (active === false && inactive === false) return 'none';
    else {
        // At this point, active|inactive can only be true|false or false|true
        // so, when only one value is provided, the missing one has to be the negated value
        var isActive = active != null ? active : !inactive;
        return isActive ? 'active' : 'inactive';
    }
}
function $2d3546043d93dd46$export$c5d1efe363797780(filters, query) {
    var active = filters.active, exact = filters.exact, fetching = filters.fetching, inactive = filters.inactive, predicate = filters.predicate, queryKey = filters.queryKey, stale = filters.stale;
    if ($2d3546043d93dd46$export$aaae5295ec3351c9(queryKey)) {
        if (exact) {
            if (query.queryHash !== $2d3546043d93dd46$export$cc90ca97bc0d73fd(queryKey, query.options)) return false;
        } else if (!$2d3546043d93dd46$export$2f07189bb9fa26a7(query.queryKey, queryKey)) return false;
    }
    var queryStatusFilter = $2d3546043d93dd46$export$eafbe052e989494f(active, inactive);
    if (queryStatusFilter === 'none') return false;
    else if (queryStatusFilter !== 'all') {
        var isActive = query.isActive();
        if (queryStatusFilter === 'active' && !isActive) return false;
        if (queryStatusFilter === 'inactive' && isActive) return false;
    }
    if (typeof stale === 'boolean' && query.isStale() !== stale) return false;
    if (typeof fetching === 'boolean' && query.isFetching() !== fetching) return false;
    if (predicate && !predicate(query)) return false;
    return true;
}
function $2d3546043d93dd46$export$a1ea5fb559f63ae3(filters, mutation) {
    var exact = filters.exact, fetching = filters.fetching, predicate = filters.predicate, mutationKey = filters.mutationKey;
    if ($2d3546043d93dd46$export$aaae5295ec3351c9(mutationKey)) {
        if (!mutation.options.mutationKey) return false;
        if (exact) {
            if ($2d3546043d93dd46$export$5fcb678681417b54(mutation.options.mutationKey) !== $2d3546043d93dd46$export$5fcb678681417b54(mutationKey)) return false;
        } else if (!$2d3546043d93dd46$export$2f07189bb9fa26a7(mutation.options.mutationKey, mutationKey)) return false;
    }
    if (typeof fetching === 'boolean' && mutation.state.status === 'loading' !== fetching) return false;
    if (predicate && !predicate(mutation)) return false;
    return true;
}
function $2d3546043d93dd46$export$cc90ca97bc0d73fd(queryKey, options) {
    var hashFn = (options == null ? void 0 : options.queryKeyHashFn) || $2d3546043d93dd46$export$5fcb678681417b54;
    return hashFn(queryKey);
}
function $2d3546043d93dd46$export$5fcb678681417b54(queryKey) {
    var asArray = $2d3546043d93dd46$export$4d32d63f64b825b9(queryKey);
    return $2d3546043d93dd46$export$e7f2f041280beb00(asArray);
}
function $2d3546043d93dd46$export$e7f2f041280beb00(value) {
    return JSON.stringify(value, function(_, val) {
        return $2d3546043d93dd46$export$53b83ca8eaab0383(val) ? Object.keys(val).sort().reduce(function(result, key) {
            result[key] = val[key];
            return result;
        }, {}) : val;
    });
}
function $2d3546043d93dd46$export$2f07189bb9fa26a7(a, b) {
    return $2d3546043d93dd46$export$3bc9138b70293839($2d3546043d93dd46$export$4d32d63f64b825b9(a), $2d3546043d93dd46$export$4d32d63f64b825b9(b));
}
function $2d3546043d93dd46$export$3bc9138b70293839(a, b) {
    if (a === b) return true;
    if (typeof a !== typeof b) return false;
    if (a && b && typeof a === 'object' && typeof b === 'object') return !Object.keys(b).some(function(key) {
        return !$2d3546043d93dd46$export$3bc9138b70293839(a[key], b[key]);
    });
    return false;
}
function $2d3546043d93dd46$export$77a71fc411098696(a, b) {
    if (a === b) return a;
    var array = Array.isArray(a) && Array.isArray(b);
    if (array || $2d3546043d93dd46$export$53b83ca8eaab0383(a) && $2d3546043d93dd46$export$53b83ca8eaab0383(b)) {
        var aSize = array ? a.length : Object.keys(a).length;
        var bItems = array ? b : Object.keys(b);
        var bSize = bItems.length;
        var copy = array ? [] : {};
        var equalItems = 0;
        for(var i = 0; i < bSize; i++){
            var key = array ? i : bItems[i];
            copy[key] = $2d3546043d93dd46$export$77a71fc411098696(a[key], b[key]);
            if (copy[key] === a[key]) equalItems++;
        }
        return aSize === bSize && equalItems === aSize ? a : copy;
    }
    return b;
}
function $2d3546043d93dd46$export$3e67810a3f0e9f1c(a, b) {
    if (a && !b || b && !a) return false;
    for(var key in a){
        if (a[key] !== b[key]) return false;
    }
    return true;
} // Copied from: https://github.com/jonschlinkert/is-plain-object
function $2d3546043d93dd46$export$53b83ca8eaab0383(o) {
    if (!$2d3546043d93dd46$var$hasObjectPrototype(o)) return false;
     // If has modified constructor
    var ctor = o.constructor;
    if (typeof ctor === 'undefined') return true;
     // If has modified prototype
    var prot = ctor.prototype;
    if (!$2d3546043d93dd46$var$hasObjectPrototype(prot)) return false;
     // If constructor does not have an Object-specific method
    if (!prot.hasOwnProperty('isPrototypeOf')) return false;
     // Most likely a plain Object
    return true;
}
function $2d3546043d93dd46$var$hasObjectPrototype(o) {
    return Object.prototype.toString.call(o) === '[object Object]';
}
function $2d3546043d93dd46$export$aaae5295ec3351c9(value) {
    return typeof value === 'string' || Array.isArray(value);
}
function $2d3546043d93dd46$export$e6127cc7fe7395c3(value) {
    return value instanceof Error;
}
function $2d3546043d93dd46$export$e772c8ff12451969(timeout) {
    return new Promise(function(resolve) {
        setTimeout(resolve, timeout);
    });
}
function $2d3546043d93dd46$export$4304cb76768ca134(callback) {
    Promise.resolve().then(callback).catch(function(error) {
        return setTimeout(function() {
            throw error;
        });
    });
}
function $2d3546043d93dd46$export$382ca5d13a8f252c() {
    if (typeof AbortController === 'function') return new AbortController();
}


function $86863928c474254f$export$2e2bcd8739ae039(t, e) {
    return $86863928c474254f$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $86863928c474254f$export$2e2bcd8739ae039(t, e);
}


function $4708a8791a55a98c$export$2e2bcd8739ae039(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, (0, $86863928c474254f$export$2e2bcd8739ae039)(t, o);
}






var $4211147ddabe9d86$export$c3ab47f7c70c8aa4 = /*#__PURE__*/ function() {
    function NotifyManager() {
        this.queue = [];
        this.transactions = 0;
        this.notifyFn = function(callback) {
            callback();
        };
        this.batchNotifyFn = function(callback) {
            callback();
        };
    }
    var _proto = NotifyManager.prototype;
    _proto.batch = function batch(callback) {
        var result;
        this.transactions++;
        try {
            result = callback();
        } finally{
            this.transactions--;
            if (!this.transactions) this.flush();
        }
        return result;
    };
    _proto.schedule = function schedule(callback) {
        var _this = this;
        if (this.transactions) this.queue.push(callback);
        else (0, $2d3546043d93dd46$export$4304cb76768ca134)(function() {
            _this.notifyFn(callback);
        });
    };
    _proto.batchCalls = function batchCalls(callback) {
        var _this2 = this;
        return function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            _this2.schedule(function() {
                callback.apply(void 0, args);
            });
        };
    };
    _proto.flush = function flush() {
        var _this3 = this;
        var queue = this.queue;
        this.queue = [];
        if (queue.length) (0, $2d3546043d93dd46$export$4304cb76768ca134)(function() {
            _this3.batchNotifyFn(function() {
                queue.forEach(function(callback) {
                    _this3.notifyFn(callback);
                });
            });
        });
    };
    _proto.setNotifyFunction = function setNotifyFunction(fn) {
        this.notifyFn = fn;
    };
    _proto.setBatchNotifyFunction = function setBatchNotifyFunction(fn) {
        this.batchNotifyFn = fn;
    };
    return NotifyManager;
}(); // SINGLETON
var $4211147ddabe9d86$export$520687f44db6e1ab = new $4211147ddabe9d86$export$c3ab47f7c70c8aa4();


// TYPES
// FUNCTIONS
var $b06e329c274347ba$var$logger = console;
function $b06e329c274347ba$export$2b1d391cd05230fd() {
    return $b06e329c274347ba$var$logger;
}
function $b06e329c274347ba$export$3abbd92f765bee58(newLogger) {
    $b06e329c274347ba$var$logger = newLogger;
}



var $42c38dddc2ac9900$export$d26086b469ecdbcc = /*#__PURE__*/ function() {
    function Subscribable() {
        this.listeners = [];
    }
    var _proto = Subscribable.prototype;
    _proto.subscribe = function subscribe(listener) {
        var _this = this;
        var callback = listener || function() {
            return undefined;
        };
        this.listeners.push(callback);
        this.onSubscribe();
        return function() {
            _this.listeners = _this.listeners.filter(function(x) {
                return x !== callback;
            });
            _this.onUnsubscribe();
        };
    };
    _proto.hasListeners = function hasListeners() {
        return this.listeners.length > 0;
    };
    _proto.onSubscribe = function onSubscribe() {};
    _proto.onUnsubscribe = function onUnsubscribe() {};
    return Subscribable;
}();



var $f33c60d777f3113f$export$86f1af424b2ca4de = /*#__PURE__*/ function(_Subscribable) {
    (0, $4708a8791a55a98c$export$2e2bcd8739ae039)(FocusManager, _Subscribable);
    function FocusManager() {
        var _this;
        _this = _Subscribable.call(this) || this;
        _this.setup = function(onFocus) {
            var _window;
            if (!(0, $2d3546043d93dd46$export$6acf61af03e62db) && ((_window = window) == null ? void 0 : _window.addEventListener)) {
                var listener = function listener() {
                    return onFocus();
                }; // Listen to visibillitychange and focus
                window.addEventListener('visibilitychange', listener, false);
                window.addEventListener('focus', listener, false);
                return function() {
                    // Be sure to unsubscribe if a new handler is set
                    window.removeEventListener('visibilitychange', listener);
                    window.removeEventListener('focus', listener);
                };
            }
        };
        return _this;
    }
    var _proto = FocusManager.prototype;
    _proto.onSubscribe = function onSubscribe() {
        if (!this.cleanup) this.setEventListener(this.setup);
    };
    _proto.onUnsubscribe = function onUnsubscribe() {
        if (!this.hasListeners()) {
            var _this$cleanup;
            (_this$cleanup = this.cleanup) == null || _this$cleanup.call(this);
            this.cleanup = undefined;
        }
    };
    _proto.setEventListener = function setEventListener(setup) {
        var _this$cleanup2, _this2 = this;
        this.setup = setup;
        (_this$cleanup2 = this.cleanup) == null || _this$cleanup2.call(this);
        this.cleanup = setup(function(focused) {
            if (typeof focused === 'boolean') _this2.setFocused(focused);
            else _this2.onFocus();
        });
    };
    _proto.setFocused = function setFocused(focused) {
        this.focused = focused;
        if (focused) this.onFocus();
    };
    _proto.onFocus = function onFocus() {
        this.listeners.forEach(function(listener) {
            listener();
        });
    };
    _proto.isFocused = function isFocused() {
        if (typeof this.focused === 'boolean') return this.focused;
         // document global can be unavailable in react native
        if (typeof document === 'undefined') return true;
        return [
            undefined,
            'visible',
            'prerender'
        ].includes(document.visibilityState);
    };
    return FocusManager;
}((0, $42c38dddc2ac9900$export$d26086b469ecdbcc));
var $f33c60d777f3113f$export$6bf54661be5b02cf = new $f33c60d777f3113f$export$86f1af424b2ca4de();





var $03198870a80cc614$export$58774fb55d5ff7fc = /*#__PURE__*/ function(_Subscribable) {
    (0, $4708a8791a55a98c$export$2e2bcd8739ae039)(OnlineManager, _Subscribable);
    function OnlineManager() {
        var _this;
        _this = _Subscribable.call(this) || this;
        _this.setup = function(onOnline) {
            var _window;
            if (!(0, $2d3546043d93dd46$export$6acf61af03e62db) && ((_window = window) == null ? void 0 : _window.addEventListener)) {
                var listener = function listener() {
                    return onOnline();
                }; // Listen to online
                window.addEventListener('online', listener, false);
                window.addEventListener('offline', listener, false);
                return function() {
                    // Be sure to unsubscribe if a new handler is set
                    window.removeEventListener('online', listener);
                    window.removeEventListener('offline', listener);
                };
            }
        };
        return _this;
    }
    var _proto = OnlineManager.prototype;
    _proto.onSubscribe = function onSubscribe() {
        if (!this.cleanup) this.setEventListener(this.setup);
    };
    _proto.onUnsubscribe = function onUnsubscribe() {
        if (!this.hasListeners()) {
            var _this$cleanup;
            (_this$cleanup = this.cleanup) == null || _this$cleanup.call(this);
            this.cleanup = undefined;
        }
    };
    _proto.setEventListener = function setEventListener(setup) {
        var _this$cleanup2, _this2 = this;
        this.setup = setup;
        (_this$cleanup2 = this.cleanup) == null || _this$cleanup2.call(this);
        this.cleanup = setup(function(online) {
            if (typeof online === 'boolean') _this2.setOnline(online);
            else _this2.onOnline();
        });
    };
    _proto.setOnline = function setOnline(online) {
        this.online = online;
        if (online) this.onOnline();
    };
    _proto.onOnline = function onOnline() {
        this.listeners.forEach(function(listener) {
            listener();
        });
    };
    _proto.isOnline = function isOnline() {
        if (typeof this.online === 'boolean') return this.online;
        if (typeof navigator === 'undefined' || typeof navigator.onLine === 'undefined') return true;
        return navigator.onLine;
    };
    return OnlineManager;
}((0, $42c38dddc2ac9900$export$d26086b469ecdbcc));
var $03198870a80cc614$export$b113e788b2dd3fdc = new $03198870a80cc614$export$58774fb55d5ff7fc();



function $31c660a97a63c1d9$var$defaultRetryDelay(failureCount) {
    return Math.min(1000 * Math.pow(2, failureCount), 30000);
}
function $31c660a97a63c1d9$export$22e08d49843051be(value) {
    return typeof (value == null ? void 0 : value.cancel) === 'function';
}
var $31c660a97a63c1d9$export$a8430ed4188f35a9 = function CancelledError(options) {
    this.revert = options == null ? void 0 : options.revert;
    this.silent = options == null ? void 0 : options.silent;
};
function $31c660a97a63c1d9$export$986cc6445c1d323(value) {
    return value instanceof $31c660a97a63c1d9$export$a8430ed4188f35a9;
} // CLASS
var $31c660a97a63c1d9$export$586a619a4618a582 = function Retryer(config) {
    var _this = this;
    var cancelRetry = false;
    var cancelFn;
    var continueFn;
    var promiseResolve;
    var promiseReject;
    this.abort = config.abort;
    this.cancel = function(cancelOptions) {
        return cancelFn == null ? void 0 : cancelFn(cancelOptions);
    };
    this.cancelRetry = function() {
        cancelRetry = true;
    };
    this.continueRetry = function() {
        cancelRetry = false;
    };
    this.continue = function() {
        return continueFn == null ? void 0 : continueFn();
    };
    this.failureCount = 0;
    this.isPaused = false;
    this.isResolved = false;
    this.isTransportCancelable = false;
    this.promise = new Promise(function(outerResolve, outerReject) {
        promiseResolve = outerResolve;
        promiseReject = outerReject;
    });
    var resolve = function resolve(value) {
        if (!_this.isResolved) {
            _this.isResolved = true;
            config.onSuccess == null || config.onSuccess(value);
            continueFn == null || continueFn();
            promiseResolve(value);
        }
    };
    var reject = function reject(value) {
        if (!_this.isResolved) {
            _this.isResolved = true;
            config.onError == null || config.onError(value);
            continueFn == null || continueFn();
            promiseReject(value);
        }
    };
    var pause = function pause() {
        return new Promise(function(continueResolve) {
            continueFn = continueResolve;
            _this.isPaused = true;
            config.onPause == null || config.onPause();
        }).then(function() {
            continueFn = undefined;
            _this.isPaused = false;
            config.onContinue == null || config.onContinue();
        });
    }; // Create loop function
    var run = function run() {
        // Do nothing if already resolved
        if (_this.isResolved) return;
        var promiseOrValue; // Execute query
        try {
            promiseOrValue = config.fn();
        } catch (error) {
            promiseOrValue = Promise.reject(error);
        } // Create callback to cancel this fetch
        cancelFn = function cancelFn(cancelOptions) {
            if (!_this.isResolved) {
                reject(new $31c660a97a63c1d9$export$a8430ed4188f35a9(cancelOptions));
                _this.abort == null || _this.abort(); // Cancel transport if supported
                if ($31c660a97a63c1d9$export$22e08d49843051be(promiseOrValue)) try {
                    promiseOrValue.cancel();
                } catch (_unused) {}
            }
        }; // Check if the transport layer support cancellation
        _this.isTransportCancelable = $31c660a97a63c1d9$export$22e08d49843051be(promiseOrValue);
        Promise.resolve(promiseOrValue).then(resolve).catch(function(error) {
            var _config$retry, _config$retryDelay;
            // Stop if the fetch is already resolved
            if (_this.isResolved) return;
             // Do we need to retry the request?
            var retry = (_config$retry = config.retry) != null ? _config$retry : 3;
            var retryDelay = (_config$retryDelay = config.retryDelay) != null ? _config$retryDelay : $31c660a97a63c1d9$var$defaultRetryDelay;
            var delay = typeof retryDelay === 'function' ? retryDelay(_this.failureCount, error) : retryDelay;
            var shouldRetry = retry === true || typeof retry === 'number' && _this.failureCount < retry || typeof retry === 'function' && retry(_this.failureCount, error);
            if (cancelRetry || !shouldRetry) {
                // We are done if the query does not need to be retried
                reject(error);
                return;
            }
            _this.failureCount++; // Notify on fail
            config.onFail == null || config.onFail(_this.failureCount, error); // Delay
            (0, $2d3546043d93dd46$export$e772c8ff12451969)(delay) // Pause if the document is not visible or when the device is offline
            .then(function() {
                if (!(0, $f33c60d777f3113f$export$6bf54661be5b02cf).isFocused() || !(0, $03198870a80cc614$export$b113e788b2dd3fdc).isOnline()) return pause();
            }).then(function() {
                if (cancelRetry) reject(error);
                else run();
            });
        });
    }; // Start loop
    run();
};


var $22512fe455b7ce7b$export$62297b13309008b2 = /*#__PURE__*/ function() {
    function Query(config) {
        this.abortSignalConsumed = false;
        this.hadObservers = false;
        this.defaultOptions = config.defaultOptions;
        this.setOptions(config.options);
        this.observers = [];
        this.cache = config.cache;
        this.queryKey = config.queryKey;
        this.queryHash = config.queryHash;
        this.initialState = config.state || this.getDefaultState(this.options);
        this.state = this.initialState;
        this.meta = config.meta;
        this.scheduleGc();
    }
    var _proto = Query.prototype;
    _proto.setOptions = function setOptions(options) {
        var _this$options$cacheTi;
        this.options = (0, $f3601d07f0ff7403$export$2e2bcd8739ae039)({}, this.defaultOptions, options);
        this.meta = options == null ? void 0 : options.meta; // Default to 5 minutes if not cache time is set
        this.cacheTime = Math.max(this.cacheTime || 0, (_this$options$cacheTi = this.options.cacheTime) != null ? _this$options$cacheTi : 300000);
    };
    _proto.setDefaultOptions = function setDefaultOptions(options) {
        this.defaultOptions = options;
    };
    _proto.scheduleGc = function scheduleGc() {
        var _this = this;
        this.clearGcTimeout();
        if ((0, $2d3546043d93dd46$export$e539f754e934e270)(this.cacheTime)) this.gcTimeout = setTimeout(function() {
            _this.optionalRemove();
        }, this.cacheTime);
    };
    _proto.clearGcTimeout = function clearGcTimeout() {
        if (this.gcTimeout) {
            clearTimeout(this.gcTimeout);
            this.gcTimeout = undefined;
        }
    };
    _proto.optionalRemove = function optionalRemove() {
        if (!this.observers.length) {
            if (this.state.isFetching) {
                if (this.hadObservers) this.scheduleGc();
            } else this.cache.remove(this);
        }
    };
    _proto.setData = function setData(updater, options) {
        var _this$options$isDataE, _this$options;
        var prevData = this.state.data; // Get the new data
        var data = (0, $2d3546043d93dd46$export$7f095f455ad5af3f)(updater, prevData); // Use prev data if an isDataEqual function is defined and returns `true`
        if ((_this$options$isDataE = (_this$options = this.options).isDataEqual) == null ? void 0 : _this$options$isDataE.call(_this$options, prevData, data)) data = prevData;
        else if (this.options.structuralSharing !== false) // Structurally share data between prev and new data if needed
        data = (0, $2d3546043d93dd46$export$77a71fc411098696)(prevData, data);
         // Set data and mark it as cached
        this.dispatch({
            data: data,
            type: 'success',
            dataUpdatedAt: options == null ? void 0 : options.updatedAt
        });
        return data;
    };
    _proto.setState = function setState(state, setStateOptions) {
        this.dispatch({
            type: 'setState',
            state: state,
            setStateOptions: setStateOptions
        });
    };
    _proto.cancel = function cancel(options) {
        var _this$retryer;
        var promise = this.promise;
        (_this$retryer = this.retryer) == null || _this$retryer.cancel(options);
        return promise ? promise.then((0, $2d3546043d93dd46$export$8793edee2d425525)).catch((0, $2d3546043d93dd46$export$8793edee2d425525)) : Promise.resolve();
    };
    _proto.destroy = function destroy() {
        this.clearGcTimeout();
        this.cancel({
            silent: true
        });
    };
    _proto.reset = function reset() {
        this.destroy();
        this.setState(this.initialState);
    };
    _proto.isActive = function isActive() {
        return this.observers.some(function(observer) {
            return observer.options.enabled !== false;
        });
    };
    _proto.isFetching = function isFetching() {
        return this.state.isFetching;
    };
    _proto.isStale = function isStale() {
        return this.state.isInvalidated || !this.state.dataUpdatedAt || this.observers.some(function(observer) {
            return observer.getCurrentResult().isStale;
        });
    };
    _proto.isStaleByTime = function isStaleByTime(staleTime) {
        if (staleTime === void 0) staleTime = 0;
        return this.state.isInvalidated || !this.state.dataUpdatedAt || !(0, $2d3546043d93dd46$export$811b83d62bcf47f0)(this.state.dataUpdatedAt, staleTime);
    };
    _proto.onFocus = function onFocus() {
        var _this$retryer2;
        var observer = this.observers.find(function(x) {
            return x.shouldFetchOnWindowFocus();
        });
        if (observer) observer.refetch();
         // Continue fetch if currently paused
        (_this$retryer2 = this.retryer) == null || _this$retryer2.continue();
    };
    _proto.onOnline = function onOnline() {
        var _this$retryer3;
        var observer = this.observers.find(function(x) {
            return x.shouldFetchOnReconnect();
        });
        if (observer) observer.refetch();
         // Continue fetch if currently paused
        (_this$retryer3 = this.retryer) == null || _this$retryer3.continue();
    };
    _proto.addObserver = function addObserver(observer) {
        if (this.observers.indexOf(observer) === -1) {
            this.observers.push(observer);
            this.hadObservers = true; // Stop the query from being garbage collected
            this.clearGcTimeout();
            this.cache.notify({
                type: 'observerAdded',
                query: this,
                observer: observer
            });
        }
    };
    _proto.removeObserver = function removeObserver(observer) {
        if (this.observers.indexOf(observer) !== -1) {
            this.observers = this.observers.filter(function(x) {
                return x !== observer;
            });
            if (!this.observers.length) {
                // If the transport layer does not support cancellation
                // we'll let the query continue so the result can be cached
                if (this.retryer) {
                    if (this.retryer.isTransportCancelable || this.abortSignalConsumed) this.retryer.cancel({
                        revert: true
                    });
                    else this.retryer.cancelRetry();
                }
                if (this.cacheTime) this.scheduleGc();
                else this.cache.remove(this);
            }
            this.cache.notify({
                type: 'observerRemoved',
                query: this,
                observer: observer
            });
        }
    };
    _proto.getObserversCount = function getObserversCount() {
        return this.observers.length;
    };
    _proto.invalidate = function invalidate() {
        if (!this.state.isInvalidated) this.dispatch({
            type: 'invalidate'
        });
    };
    _proto.fetch = function fetch(options, fetchOptions) {
        var _this2 = this, _this$options$behavio, _context$fetchOptions, _abortController$abor;
        if (this.state.isFetching) {
            if (this.state.dataUpdatedAt && (fetchOptions == null ? void 0 : fetchOptions.cancelRefetch)) // Silently cancel current fetch if the user wants to cancel refetches
            this.cancel({
                silent: true
            });
            else if (this.promise) {
                var _this$retryer4;
                // make sure that retries that were potentially cancelled due to unmounts can continue
                (_this$retryer4 = this.retryer) == null || _this$retryer4.continueRetry(); // Return current promise if we are already fetching
                return this.promise;
            }
        } // Update config if passed, otherwise the config from the last execution is used
        if (options) this.setOptions(options);
         // Use the options from the first observer with a query function if no function is found.
        // This can happen when the query is hydrated or created with setQueryData.
        if (!this.options.queryFn) {
            var observer = this.observers.find(function(x) {
                return x.options.queryFn;
            });
            if (observer) this.setOptions(observer.options);
        }
        var queryKey = (0, $2d3546043d93dd46$export$4d32d63f64b825b9)(this.queryKey);
        var abortController = (0, $2d3546043d93dd46$export$382ca5d13a8f252c)(); // Create query function context
        var queryFnContext = {
            queryKey: queryKey,
            pageParam: undefined,
            meta: this.meta
        };
        Object.defineProperty(queryFnContext, 'signal', {
            enumerable: true,
            get: function get() {
                if (abortController) {
                    _this2.abortSignalConsumed = true;
                    return abortController.signal;
                }
                return undefined;
            }
        }); // Create fetch function
        var fetchFn = function fetchFn() {
            if (!_this2.options.queryFn) return Promise.reject('Missing queryFn');
            _this2.abortSignalConsumed = false;
            return _this2.options.queryFn(queryFnContext);
        }; // Trigger behavior hook
        var context = {
            fetchOptions: fetchOptions,
            options: this.options,
            queryKey: queryKey,
            state: this.state,
            fetchFn: fetchFn,
            meta: this.meta
        };
        if ((_this$options$behavio = this.options.behavior) == null ? void 0 : _this$options$behavio.onFetch) {
            var _this$options$behavio2;
            (_this$options$behavio2 = this.options.behavior) == null || _this$options$behavio2.onFetch(context);
        } // Store state in case the current fetch needs to be reverted
        this.revertState = this.state; // Set to fetching state if not already in it
        if (!this.state.isFetching || this.state.fetchMeta !== ((_context$fetchOptions = context.fetchOptions) == null ? void 0 : _context$fetchOptions.meta)) {
            var _context$fetchOptions2;
            this.dispatch({
                type: 'fetch',
                meta: (_context$fetchOptions2 = context.fetchOptions) == null ? void 0 : _context$fetchOptions2.meta
            });
        } // Try to fetch the data
        this.retryer = new (0, $31c660a97a63c1d9$export$586a619a4618a582)({
            fn: context.fetchFn,
            abort: abortController == null ? void 0 : (_abortController$abor = abortController.abort) == null ? void 0 : _abortController$abor.bind(abortController),
            onSuccess: function onSuccess(data) {
                _this2.setData(data); // Notify cache callback
                _this2.cache.config.onSuccess == null || _this2.cache.config.onSuccess(data, _this2); // Remove query after fetching if cache time is 0
                if (_this2.cacheTime === 0) _this2.optionalRemove();
            },
            onError: function onError(error) {
                // Optimistically update state if needed
                if (!((0, $31c660a97a63c1d9$export$986cc6445c1d323)(error) && error.silent)) _this2.dispatch({
                    type: 'error',
                    error: error
                });
                if (!(0, $31c660a97a63c1d9$export$986cc6445c1d323)(error)) {
                    // Notify cache callback
                    _this2.cache.config.onError == null || _this2.cache.config.onError(error, _this2); // Log error
                    (0, $b06e329c274347ba$export$2b1d391cd05230fd)().error(error);
                } // Remove query after fetching if cache time is 0
                if (_this2.cacheTime === 0) _this2.optionalRemove();
            },
            onFail: function onFail() {
                _this2.dispatch({
                    type: 'failed'
                });
            },
            onPause: function onPause() {
                _this2.dispatch({
                    type: 'pause'
                });
            },
            onContinue: function onContinue() {
                _this2.dispatch({
                    type: 'continue'
                });
            },
            retry: context.options.retry,
            retryDelay: context.options.retryDelay
        });
        this.promise = this.retryer.promise;
        return this.promise;
    };
    _proto.dispatch = function dispatch(action) {
        var _this3 = this;
        this.state = this.reducer(this.state, action);
        (0, $4211147ddabe9d86$export$520687f44db6e1ab).batch(function() {
            _this3.observers.forEach(function(observer) {
                observer.onQueryUpdate(action);
            });
            _this3.cache.notify({
                query: _this3,
                type: 'queryUpdated',
                action: action
            });
        });
    };
    _proto.getDefaultState = function getDefaultState(options) {
        var data = typeof options.initialData === 'function' ? options.initialData() : options.initialData;
        var hasInitialData = typeof options.initialData !== 'undefined';
        var initialDataUpdatedAt = hasInitialData ? typeof options.initialDataUpdatedAt === 'function' ? options.initialDataUpdatedAt() : options.initialDataUpdatedAt : 0;
        var hasData = typeof data !== 'undefined';
        return {
            data: data,
            dataUpdateCount: 0,
            dataUpdatedAt: hasData ? initialDataUpdatedAt != null ? initialDataUpdatedAt : Date.now() : 0,
            error: null,
            errorUpdateCount: 0,
            errorUpdatedAt: 0,
            fetchFailureCount: 0,
            fetchMeta: null,
            isFetching: false,
            isInvalidated: false,
            isPaused: false,
            status: hasData ? 'success' : 'idle'
        };
    };
    _proto.reducer = function reducer(state, action) {
        var _action$meta, _action$dataUpdatedAt;
        switch(action.type){
            case 'failed':
                return (0, $f3601d07f0ff7403$export$2e2bcd8739ae039)({}, state, {
                    fetchFailureCount: state.fetchFailureCount + 1
                });
            case 'pause':
                return (0, $f3601d07f0ff7403$export$2e2bcd8739ae039)({}, state, {
                    isPaused: true
                });
            case 'continue':
                return (0, $f3601d07f0ff7403$export$2e2bcd8739ae039)({}, state, {
                    isPaused: false
                });
            case 'fetch':
                return (0, $f3601d07f0ff7403$export$2e2bcd8739ae039)({}, state, {
                    fetchFailureCount: 0,
                    fetchMeta: (_action$meta = action.meta) != null ? _action$meta : null,
                    isFetching: true,
                    isPaused: false
                }, !state.dataUpdatedAt && {
                    error: null,
                    status: 'loading'
                });
            case 'success':
                return (0, $f3601d07f0ff7403$export$2e2bcd8739ae039)({}, state, {
                    data: action.data,
                    dataUpdateCount: state.dataUpdateCount + 1,
                    dataUpdatedAt: (_action$dataUpdatedAt = action.dataUpdatedAt) != null ? _action$dataUpdatedAt : Date.now(),
                    error: null,
                    fetchFailureCount: 0,
                    isFetching: false,
                    isInvalidated: false,
                    isPaused: false,
                    status: 'success'
                });
            case 'error':
                var error = action.error;
                if ((0, $31c660a97a63c1d9$export$986cc6445c1d323)(error) && error.revert && this.revertState) return (0, $f3601d07f0ff7403$export$2e2bcd8739ae039)({}, this.revertState);
                return (0, $f3601d07f0ff7403$export$2e2bcd8739ae039)({}, state, {
                    error: error,
                    errorUpdateCount: state.errorUpdateCount + 1,
                    errorUpdatedAt: Date.now(),
                    fetchFailureCount: state.fetchFailureCount + 1,
                    isFetching: false,
                    isPaused: false,
                    status: 'error'
                });
            case 'invalidate':
                return (0, $f3601d07f0ff7403$export$2e2bcd8739ae039)({}, state, {
                    isInvalidated: true
                });
            case 'setState':
                return (0, $f3601d07f0ff7403$export$2e2bcd8739ae039)({}, state, action.state);
            default:
                return state;
        }
    };
    return Query;
}();




var $b9d3d1c1b7905ae7$export$5dde0cd941da8468 = /*#__PURE__*/ function(_Subscribable) {
    (0, $4708a8791a55a98c$export$2e2bcd8739ae039)(QueryCache, _Subscribable);
    function QueryCache(config) {
        var _this;
        _this = _Subscribable.call(this) || this;
        _this.config = config || {};
        _this.queries = [];
        _this.queriesMap = {};
        return _this;
    }
    var _proto = QueryCache.prototype;
    _proto.build = function build(client, options, state) {
        var _options$queryHash;
        var queryKey = options.queryKey;
        var queryHash = (_options$queryHash = options.queryHash) != null ? _options$queryHash : (0, $2d3546043d93dd46$export$cc90ca97bc0d73fd)(queryKey, options);
        var query = this.get(queryHash);
        if (!query) {
            query = new (0, $22512fe455b7ce7b$export$62297b13309008b2)({
                cache: this,
                queryKey: queryKey,
                queryHash: queryHash,
                options: client.defaultQueryOptions(options),
                state: state,
                defaultOptions: client.getQueryDefaults(queryKey),
                meta: options.meta
            });
            this.add(query);
        }
        return query;
    };
    _proto.add = function add(query) {
        if (!this.queriesMap[query.queryHash]) {
            this.queriesMap[query.queryHash] = query;
            this.queries.push(query);
            this.notify({
                type: 'queryAdded',
                query: query
            });
        }
    };
    _proto.remove = function remove(query) {
        var queryInMap = this.queriesMap[query.queryHash];
        if (queryInMap) {
            query.destroy();
            this.queries = this.queries.filter(function(x) {
                return x !== query;
            });
            if (queryInMap === query) delete this.queriesMap[query.queryHash];
            this.notify({
                type: 'queryRemoved',
                query: query
            });
        }
    };
    _proto.clear = function clear() {
        var _this2 = this;
        (0, $4211147ddabe9d86$export$520687f44db6e1ab).batch(function() {
            _this2.queries.forEach(function(query) {
                _this2.remove(query);
            });
        });
    };
    _proto.get = function get(queryHash) {
        return this.queriesMap[queryHash];
    };
    _proto.getAll = function getAll() {
        return this.queries;
    };
    _proto.find = function find(arg1, arg2) {
        var _parseFilterArgs = (0, $2d3546043d93dd46$export$18e8f4b987e6c111)(arg1, arg2), filters = _parseFilterArgs[0];
        if (typeof filters.exact === 'undefined') filters.exact = true;
        return this.queries.find(function(query) {
            return (0, $2d3546043d93dd46$export$c5d1efe363797780)(filters, query);
        });
    };
    _proto.findAll = function findAll(arg1, arg2) {
        var _parseFilterArgs2 = (0, $2d3546043d93dd46$export$18e8f4b987e6c111)(arg1, arg2), filters = _parseFilterArgs2[0];
        return Object.keys(filters).length > 0 ? this.queries.filter(function(query) {
            return (0, $2d3546043d93dd46$export$c5d1efe363797780)(filters, query);
        }) : this.queries;
    };
    _proto.notify = function notify(event) {
        var _this3 = this;
        (0, $4211147ddabe9d86$export$520687f44db6e1ab).batch(function() {
            _this3.listeners.forEach(function(listener) {
                listener(event);
            });
        });
    };
    _proto.onFocus = function onFocus() {
        var _this4 = this;
        (0, $4211147ddabe9d86$export$520687f44db6e1ab).batch(function() {
            _this4.queries.forEach(function(query) {
                query.onFocus();
            });
        });
    };
    _proto.onOnline = function onOnline() {
        var _this5 = this;
        (0, $4211147ddabe9d86$export$520687f44db6e1ab).batch(function() {
            _this5.queries.forEach(function(query) {
                query.onOnline();
            });
        });
    };
    return QueryCache;
}((0, $42c38dddc2ac9900$export$d26086b469ecdbcc));









var $264df94243da3226$export$17b8b19c814bcf56 = /*#__PURE__*/ function() {
    function Mutation(config) {
        this.options = (0, $f3601d07f0ff7403$export$2e2bcd8739ae039)({}, config.defaultOptions, config.options);
        this.mutationId = config.mutationId;
        this.mutationCache = config.mutationCache;
        this.observers = [];
        this.state = config.state || $264df94243da3226$export$a1659b54bac3252a();
        this.meta = config.meta;
    }
    var _proto = Mutation.prototype;
    _proto.setState = function setState(state) {
        this.dispatch({
            type: 'setState',
            state: state
        });
    };
    _proto.addObserver = function addObserver(observer) {
        if (this.observers.indexOf(observer) === -1) this.observers.push(observer);
    };
    _proto.removeObserver = function removeObserver(observer) {
        this.observers = this.observers.filter(function(x) {
            return x !== observer;
        });
    };
    _proto.cancel = function cancel() {
        if (this.retryer) {
            this.retryer.cancel();
            return this.retryer.promise.then((0, $2d3546043d93dd46$export$8793edee2d425525)).catch((0, $2d3546043d93dd46$export$8793edee2d425525));
        }
        return Promise.resolve();
    };
    _proto.continue = function _continue() {
        if (this.retryer) {
            this.retryer.continue();
            return this.retryer.promise;
        }
        return this.execute();
    };
    _proto.execute = function execute() {
        var _this = this;
        var data;
        var restored = this.state.status === 'loading';
        var promise = Promise.resolve();
        if (!restored) {
            this.dispatch({
                type: 'loading',
                variables: this.options.variables
            });
            promise = promise.then(function() {
                // Notify cache callback
                _this.mutationCache.config.onMutate == null || _this.mutationCache.config.onMutate(_this.state.variables, _this);
            }).then(function() {
                return _this.options.onMutate == null ? void 0 : _this.options.onMutate(_this.state.variables);
            }).then(function(context) {
                if (context !== _this.state.context) _this.dispatch({
                    type: 'loading',
                    context: context,
                    variables: _this.state.variables
                });
            });
        }
        return promise.then(function() {
            return _this.executeMutation();
        }).then(function(result) {
            data = result; // Notify cache callback
            _this.mutationCache.config.onSuccess == null || _this.mutationCache.config.onSuccess(data, _this.state.variables, _this.state.context, _this);
        }).then(function() {
            return _this.options.onSuccess == null ? void 0 : _this.options.onSuccess(data, _this.state.variables, _this.state.context);
        }).then(function() {
            return _this.options.onSettled == null ? void 0 : _this.options.onSettled(data, null, _this.state.variables, _this.state.context);
        }).then(function() {
            _this.dispatch({
                type: 'success',
                data: data
            });
            return data;
        }).catch(function(error) {
            // Notify cache callback
            _this.mutationCache.config.onError == null || _this.mutationCache.config.onError(error, _this.state.variables, _this.state.context, _this); // Log error
            (0, $b06e329c274347ba$export$2b1d391cd05230fd)().error(error);
            return Promise.resolve().then(function() {
                return _this.options.onError == null ? void 0 : _this.options.onError(error, _this.state.variables, _this.state.context);
            }).then(function() {
                return _this.options.onSettled == null ? void 0 : _this.options.onSettled(undefined, error, _this.state.variables, _this.state.context);
            }).then(function() {
                _this.dispatch({
                    type: 'error',
                    error: error
                });
                throw error;
            });
        });
    };
    _proto.executeMutation = function executeMutation() {
        var _this2 = this, _this$options$retry;
        this.retryer = new (0, $31c660a97a63c1d9$export$586a619a4618a582)({
            fn: function fn() {
                if (!_this2.options.mutationFn) return Promise.reject('No mutationFn found');
                return _this2.options.mutationFn(_this2.state.variables);
            },
            onFail: function onFail() {
                _this2.dispatch({
                    type: 'failed'
                });
            },
            onPause: function onPause() {
                _this2.dispatch({
                    type: 'pause'
                });
            },
            onContinue: function onContinue() {
                _this2.dispatch({
                    type: 'continue'
                });
            },
            retry: (_this$options$retry = this.options.retry) != null ? _this$options$retry : 0,
            retryDelay: this.options.retryDelay
        });
        return this.retryer.promise;
    };
    _proto.dispatch = function dispatch(action) {
        var _this3 = this;
        this.state = $264df94243da3226$var$reducer(this.state, action);
        (0, $4211147ddabe9d86$export$520687f44db6e1ab).batch(function() {
            _this3.observers.forEach(function(observer) {
                observer.onMutationUpdate(action);
            });
            _this3.mutationCache.notify(_this3);
        });
    };
    return Mutation;
}();
function $264df94243da3226$export$a1659b54bac3252a() {
    return {
        context: undefined,
        data: undefined,
        error: null,
        failureCount: 0,
        isPaused: false,
        status: 'idle',
        variables: undefined
    };
}
function $264df94243da3226$var$reducer(state, action) {
    switch(action.type){
        case 'failed':
            return (0, $f3601d07f0ff7403$export$2e2bcd8739ae039)({}, state, {
                failureCount: state.failureCount + 1
            });
        case 'pause':
            return (0, $f3601d07f0ff7403$export$2e2bcd8739ae039)({}, state, {
                isPaused: true
            });
        case 'continue':
            return (0, $f3601d07f0ff7403$export$2e2bcd8739ae039)({}, state, {
                isPaused: false
            });
        case 'loading':
            return (0, $f3601d07f0ff7403$export$2e2bcd8739ae039)({}, state, {
                context: action.context,
                data: undefined,
                error: null,
                isPaused: false,
                status: 'loading',
                variables: action.variables
            });
        case 'success':
            return (0, $f3601d07f0ff7403$export$2e2bcd8739ae039)({}, state, {
                data: action.data,
                error: null,
                status: 'success',
                isPaused: false
            });
        case 'error':
            return (0, $f3601d07f0ff7403$export$2e2bcd8739ae039)({}, state, {
                data: undefined,
                error: action.error,
                failureCount: state.failureCount + 1,
                isPaused: false,
                status: 'error'
            });
        case 'setState':
            return (0, $f3601d07f0ff7403$export$2e2bcd8739ae039)({}, state, action.state);
        default:
            return state;
    }
}




var $92ea615a704e0a90$export$1fcfd9a244434844 = /*#__PURE__*/ function(_Subscribable) {
    (0, $4708a8791a55a98c$export$2e2bcd8739ae039)(MutationCache, _Subscribable);
    function MutationCache(config) {
        var _this;
        _this = _Subscribable.call(this) || this;
        _this.config = config || {};
        _this.mutations = [];
        _this.mutationId = 0;
        return _this;
    }
    var _proto = MutationCache.prototype;
    _proto.build = function build(client, options, state) {
        var mutation = new (0, $264df94243da3226$export$17b8b19c814bcf56)({
            mutationCache: this,
            mutationId: ++this.mutationId,
            options: client.defaultMutationOptions(options),
            state: state,
            defaultOptions: options.mutationKey ? client.getMutationDefaults(options.mutationKey) : undefined,
            meta: options.meta
        });
        this.add(mutation);
        return mutation;
    };
    _proto.add = function add(mutation) {
        this.mutations.push(mutation);
        this.notify(mutation);
    };
    _proto.remove = function remove(mutation) {
        this.mutations = this.mutations.filter(function(x) {
            return x !== mutation;
        });
        mutation.cancel();
        this.notify(mutation);
    };
    _proto.clear = function clear() {
        var _this2 = this;
        (0, $4211147ddabe9d86$export$520687f44db6e1ab).batch(function() {
            _this2.mutations.forEach(function(mutation) {
                _this2.remove(mutation);
            });
        });
    };
    _proto.getAll = function getAll() {
        return this.mutations;
    };
    _proto.find = function find(filters) {
        if (typeof filters.exact === 'undefined') filters.exact = true;
        return this.mutations.find(function(mutation) {
            return (0, $2d3546043d93dd46$export$a1ea5fb559f63ae3)(filters, mutation);
        });
    };
    _proto.findAll = function findAll(filters) {
        return this.mutations.filter(function(mutation) {
            return (0, $2d3546043d93dd46$export$a1ea5fb559f63ae3)(filters, mutation);
        });
    };
    _proto.notify = function notify(mutation) {
        var _this3 = this;
        (0, $4211147ddabe9d86$export$520687f44db6e1ab).batch(function() {
            _this3.listeners.forEach(function(listener) {
                listener(mutation);
            });
        });
    };
    _proto.onFocus = function onFocus() {
        this.resumePausedMutations();
    };
    _proto.onOnline = function onOnline() {
        this.resumePausedMutations();
    };
    _proto.resumePausedMutations = function resumePausedMutations() {
        var pausedMutations = this.mutations.filter(function(x) {
            return x.state.isPaused;
        });
        return (0, $4211147ddabe9d86$export$520687f44db6e1ab).batch(function() {
            return pausedMutations.reduce(function(promise, mutation) {
                return promise.then(function() {
                    return mutation.continue().catch((0, $2d3546043d93dd46$export$8793edee2d425525));
                });
            }, Promise.resolve());
        });
    };
    return MutationCache;
}((0, $42c38dddc2ac9900$export$d26086b469ecdbcc));







function $c0029b4117f43962$export$84470d1367601e8d() {
    return {
        onFetch: function onFetch(context) {
            context.fetchFn = function() {
                var _context$fetchOptions, _context$fetchOptions2, _context$fetchOptions3, _context$fetchOptions4, _context$state$data, _context$state$data2;
                var refetchPage = (_context$fetchOptions = context.fetchOptions) == null ? void 0 : (_context$fetchOptions2 = _context$fetchOptions.meta) == null ? void 0 : _context$fetchOptions2.refetchPage;
                var fetchMore = (_context$fetchOptions3 = context.fetchOptions) == null ? void 0 : (_context$fetchOptions4 = _context$fetchOptions3.meta) == null ? void 0 : _context$fetchOptions4.fetchMore;
                var pageParam = fetchMore == null ? void 0 : fetchMore.pageParam;
                var isFetchingNextPage = (fetchMore == null ? void 0 : fetchMore.direction) === 'forward';
                var isFetchingPreviousPage = (fetchMore == null ? void 0 : fetchMore.direction) === 'backward';
                var oldPages = ((_context$state$data = context.state.data) == null ? void 0 : _context$state$data.pages) || [];
                var oldPageParams = ((_context$state$data2 = context.state.data) == null ? void 0 : _context$state$data2.pageParams) || [];
                var abortController = (0, $2d3546043d93dd46$export$382ca5d13a8f252c)();
                var abortSignal = abortController == null ? void 0 : abortController.signal;
                var newPageParams = oldPageParams;
                var cancelled = false; // Get query function
                var queryFn = context.options.queryFn || function() {
                    return Promise.reject('Missing queryFn');
                };
                var buildNewPages = function buildNewPages(pages, param, page, previous) {
                    newPageParams = previous ? [
                        param
                    ].concat(newPageParams) : [].concat(newPageParams, [
                        param
                    ]);
                    return previous ? [
                        page
                    ].concat(pages) : [].concat(pages, [
                        page
                    ]);
                }; // Create function to fetch a page
                var fetchPage = function fetchPage(pages, manual, param, previous) {
                    if (cancelled) return Promise.reject('Cancelled');
                    if (typeof param === 'undefined' && !manual && pages.length) return Promise.resolve(pages);
                    var queryFnContext = {
                        queryKey: context.queryKey,
                        signal: abortSignal,
                        pageParam: param,
                        meta: context.meta
                    };
                    var queryFnResult = queryFn(queryFnContext);
                    var promise = Promise.resolve(queryFnResult).then(function(page) {
                        return buildNewPages(pages, param, page, previous);
                    });
                    if ((0, $31c660a97a63c1d9$export$22e08d49843051be)(queryFnResult)) {
                        var promiseAsAny = promise;
                        promiseAsAny.cancel = queryFnResult.cancel;
                    }
                    return promise;
                };
                var promise; // Fetch first page?
                if (!oldPages.length) promise = fetchPage([]);
                else if (isFetchingNextPage) {
                    var manual = typeof pageParam !== 'undefined';
                    var param = manual ? pageParam : $c0029b4117f43962$export$1186159d57de7255(context.options, oldPages);
                    promise = fetchPage(oldPages, manual, param);
                } else if (isFetchingPreviousPage) {
                    var _manual = typeof pageParam !== 'undefined';
                    var _param = _manual ? pageParam : $c0029b4117f43962$export$48efda17d8ac7ac7(context.options, oldPages);
                    promise = fetchPage(oldPages, _manual, _param, true);
                } else (function() {
                    newPageParams = [];
                    var manual = typeof context.options.getNextPageParam === 'undefined';
                    var shouldFetchFirstPage = refetchPage && oldPages[0] ? refetchPage(oldPages[0], 0, oldPages) : true; // Fetch first page
                    promise = shouldFetchFirstPage ? fetchPage([], manual, oldPageParams[0]) : Promise.resolve(buildNewPages([], oldPageParams[0], oldPages[0])); // Fetch remaining pages
                    var _loop = function _loop(i) {
                        promise = promise.then(function(pages) {
                            var shouldFetchNextPage = refetchPage && oldPages[i] ? refetchPage(oldPages[i], i, oldPages) : true;
                            if (shouldFetchNextPage) {
                                var _param2 = manual ? oldPageParams[i] : $c0029b4117f43962$export$1186159d57de7255(context.options, pages);
                                return fetchPage(pages, manual, _param2);
                            }
                            return Promise.resolve(buildNewPages(pages, oldPageParams[i], oldPages[i]));
                        });
                    };
                    for(var i = 1; i < oldPages.length; i++)_loop(i);
                })();
                var finalPromise = promise.then(function(pages) {
                    return {
                        pages: pages,
                        pageParams: newPageParams
                    };
                });
                var finalPromiseAsAny = finalPromise;
                finalPromiseAsAny.cancel = function() {
                    cancelled = true;
                    abortController == null || abortController.abort();
                    if ((0, $31c660a97a63c1d9$export$22e08d49843051be)(promise)) promise.cancel();
                };
                return finalPromise;
            };
        }
    };
}
function $c0029b4117f43962$export$1186159d57de7255(options, pages) {
    return options.getNextPageParam == null ? void 0 : options.getNextPageParam(pages[pages.length - 1], pages);
}
function $c0029b4117f43962$export$48efda17d8ac7ac7(options, pages) {
    return options.getPreviousPageParam == null ? void 0 : options.getPreviousPageParam(pages[0], pages);
}
function $c0029b4117f43962$export$b9c88add8b8b5e6a(options, pages) {
    if (options.getNextPageParam && Array.isArray(pages)) {
        var nextPageParam = $c0029b4117f43962$export$1186159d57de7255(options, pages);
        return typeof nextPageParam !== 'undefined' && nextPageParam !== null && nextPageParam !== false;
    }
}
function $c0029b4117f43962$export$db1663b730a8e6e4(options, pages) {
    if (options.getPreviousPageParam && Array.isArray(pages)) {
        var previousPageParam = $c0029b4117f43962$export$48efda17d8ac7ac7(options, pages);
        return typeof previousPageParam !== 'undefined' && previousPageParam !== null && previousPageParam !== false;
    }
}


var $af3ad2fcddfb519e$export$405d0624ed55a03f = /*#__PURE__*/ function() {
    function QueryClient(config) {
        if (config === void 0) config = {};
        this.queryCache = config.queryCache || new (0, $b9d3d1c1b7905ae7$export$5dde0cd941da8468)();
        this.mutationCache = config.mutationCache || new (0, $92ea615a704e0a90$export$1fcfd9a244434844)();
        this.defaultOptions = config.defaultOptions || {};
        this.queryDefaults = [];
        this.mutationDefaults = [];
    }
    var _proto = QueryClient.prototype;
    _proto.mount = function mount() {
        var _this = this;
        this.unsubscribeFocus = (0, $f33c60d777f3113f$export$6bf54661be5b02cf).subscribe(function() {
            if ((0, $f33c60d777f3113f$export$6bf54661be5b02cf).isFocused() && (0, $03198870a80cc614$export$b113e788b2dd3fdc).isOnline()) {
                _this.mutationCache.onFocus();
                _this.queryCache.onFocus();
            }
        });
        this.unsubscribeOnline = (0, $03198870a80cc614$export$b113e788b2dd3fdc).subscribe(function() {
            if ((0, $f33c60d777f3113f$export$6bf54661be5b02cf).isFocused() && (0, $03198870a80cc614$export$b113e788b2dd3fdc).isOnline()) {
                _this.mutationCache.onOnline();
                _this.queryCache.onOnline();
            }
        });
    };
    _proto.unmount = function unmount() {
        var _this$unsubscribeFocu, _this$unsubscribeOnli;
        (_this$unsubscribeFocu = this.unsubscribeFocus) == null || _this$unsubscribeFocu.call(this);
        (_this$unsubscribeOnli = this.unsubscribeOnline) == null || _this$unsubscribeOnli.call(this);
    };
    _proto.isFetching = function isFetching(arg1, arg2) {
        var _parseFilterArgs = (0, $2d3546043d93dd46$export$18e8f4b987e6c111)(arg1, arg2), filters = _parseFilterArgs[0];
        filters.fetching = true;
        return this.queryCache.findAll(filters).length;
    };
    _proto.isMutating = function isMutating(filters) {
        return this.mutationCache.findAll((0, $f3601d07f0ff7403$export$2e2bcd8739ae039)({}, filters, {
            fetching: true
        })).length;
    };
    _proto.getQueryData = function getQueryData(queryKey, filters) {
        var _this$queryCache$find;
        return (_this$queryCache$find = this.queryCache.find(queryKey, filters)) == null ? void 0 : _this$queryCache$find.state.data;
    };
    _proto.getQueriesData = function getQueriesData(queryKeyOrFilters) {
        return this.getQueryCache().findAll(queryKeyOrFilters).map(function(_ref) {
            var queryKey = _ref.queryKey, state = _ref.state;
            var data = state.data;
            return [
                queryKey,
                data
            ];
        });
    };
    _proto.setQueryData = function setQueryData(queryKey, updater, options) {
        var parsedOptions = (0, $2d3546043d93dd46$export$8a11fbc2c8ea08fd)(queryKey);
        var defaultedOptions = this.defaultQueryOptions(parsedOptions);
        return this.queryCache.build(this, defaultedOptions).setData(updater, options);
    };
    _proto.setQueriesData = function setQueriesData(queryKeyOrFilters, updater, options) {
        var _this2 = this;
        return (0, $4211147ddabe9d86$export$520687f44db6e1ab).batch(function() {
            return _this2.getQueryCache().findAll(queryKeyOrFilters).map(function(_ref2) {
                var queryKey = _ref2.queryKey;
                return [
                    queryKey,
                    _this2.setQueryData(queryKey, updater, options)
                ];
            });
        });
    };
    _proto.getQueryState = function getQueryState(queryKey, filters) {
        var _this$queryCache$find2;
        return (_this$queryCache$find2 = this.queryCache.find(queryKey, filters)) == null ? void 0 : _this$queryCache$find2.state;
    };
    _proto.removeQueries = function removeQueries(arg1, arg2) {
        var _parseFilterArgs2 = (0, $2d3546043d93dd46$export$18e8f4b987e6c111)(arg1, arg2), filters = _parseFilterArgs2[0];
        var queryCache = this.queryCache;
        (0, $4211147ddabe9d86$export$520687f44db6e1ab).batch(function() {
            queryCache.findAll(filters).forEach(function(query) {
                queryCache.remove(query);
            });
        });
    };
    _proto.resetQueries = function resetQueries(arg1, arg2, arg3) {
        var _this3 = this;
        var _parseFilterArgs3 = (0, $2d3546043d93dd46$export$18e8f4b987e6c111)(arg1, arg2, arg3), filters = _parseFilterArgs3[0], options = _parseFilterArgs3[1];
        var queryCache = this.queryCache;
        var refetchFilters = (0, $f3601d07f0ff7403$export$2e2bcd8739ae039)({}, filters, {
            active: true
        });
        return (0, $4211147ddabe9d86$export$520687f44db6e1ab).batch(function() {
            queryCache.findAll(filters).forEach(function(query) {
                query.reset();
            });
            return _this3.refetchQueries(refetchFilters, options);
        });
    };
    _proto.cancelQueries = function cancelQueries(arg1, arg2, arg3) {
        var _this4 = this;
        var _parseFilterArgs4 = (0, $2d3546043d93dd46$export$18e8f4b987e6c111)(arg1, arg2, arg3), filters = _parseFilterArgs4[0], _parseFilterArgs4$ = _parseFilterArgs4[1], cancelOptions = _parseFilterArgs4$ === void 0 ? {} : _parseFilterArgs4$;
        if (typeof cancelOptions.revert === 'undefined') cancelOptions.revert = true;
        var promises = (0, $4211147ddabe9d86$export$520687f44db6e1ab).batch(function() {
            return _this4.queryCache.findAll(filters).map(function(query) {
                return query.cancel(cancelOptions);
            });
        });
        return Promise.all(promises).then((0, $2d3546043d93dd46$export$8793edee2d425525)).catch((0, $2d3546043d93dd46$export$8793edee2d425525));
    };
    _proto.invalidateQueries = function invalidateQueries(arg1, arg2, arg3) {
        var _ref3, _filters$refetchActiv, _filters$refetchInact, _this5 = this;
        var _parseFilterArgs5 = (0, $2d3546043d93dd46$export$18e8f4b987e6c111)(arg1, arg2, arg3), filters = _parseFilterArgs5[0], options = _parseFilterArgs5[1];
        var refetchFilters = (0, $f3601d07f0ff7403$export$2e2bcd8739ae039)({}, filters, {
            // if filters.refetchActive is not provided and filters.active is explicitly false,
            // e.g. invalidateQueries({ active: false }), we don't want to refetch active queries
            active: (_ref3 = (_filters$refetchActiv = filters.refetchActive) != null ? _filters$refetchActiv : filters.active) != null ? _ref3 : true,
            inactive: (_filters$refetchInact = filters.refetchInactive) != null ? _filters$refetchInact : false
        });
        return (0, $4211147ddabe9d86$export$520687f44db6e1ab).batch(function() {
            _this5.queryCache.findAll(filters).forEach(function(query) {
                query.invalidate();
            });
            return _this5.refetchQueries(refetchFilters, options);
        });
    };
    _proto.refetchQueries = function refetchQueries(arg1, arg2, arg3) {
        var _this6 = this;
        var _parseFilterArgs6 = (0, $2d3546043d93dd46$export$18e8f4b987e6c111)(arg1, arg2, arg3), filters = _parseFilterArgs6[0], options = _parseFilterArgs6[1];
        var promises = (0, $4211147ddabe9d86$export$520687f44db6e1ab).batch(function() {
            return _this6.queryCache.findAll(filters).map(function(query) {
                return query.fetch(undefined, (0, $f3601d07f0ff7403$export$2e2bcd8739ae039)({}, options, {
                    meta: {
                        refetchPage: filters == null ? void 0 : filters.refetchPage
                    }
                }));
            });
        });
        var promise = Promise.all(promises).then((0, $2d3546043d93dd46$export$8793edee2d425525));
        if (!(options == null ? void 0 : options.throwOnError)) promise = promise.catch((0, $2d3546043d93dd46$export$8793edee2d425525));
        return promise;
    };
    _proto.fetchQuery = function fetchQuery(arg1, arg2, arg3) {
        var parsedOptions = (0, $2d3546043d93dd46$export$8a11fbc2c8ea08fd)(arg1, arg2, arg3);
        var defaultedOptions = this.defaultQueryOptions(parsedOptions); // https://github.com/tannerlinsley/react-query/issues/652
        if (typeof defaultedOptions.retry === 'undefined') defaultedOptions.retry = false;
        var query = this.queryCache.build(this, defaultedOptions);
        return query.isStaleByTime(defaultedOptions.staleTime) ? query.fetch(defaultedOptions) : Promise.resolve(query.state.data);
    };
    _proto.prefetchQuery = function prefetchQuery(arg1, arg2, arg3) {
        return this.fetchQuery(arg1, arg2, arg3).then((0, $2d3546043d93dd46$export$8793edee2d425525)).catch((0, $2d3546043d93dd46$export$8793edee2d425525));
    };
    _proto.fetchInfiniteQuery = function fetchInfiniteQuery(arg1, arg2, arg3) {
        var parsedOptions = (0, $2d3546043d93dd46$export$8a11fbc2c8ea08fd)(arg1, arg2, arg3);
        parsedOptions.behavior = (0, $c0029b4117f43962$export$84470d1367601e8d)();
        return this.fetchQuery(parsedOptions);
    };
    _proto.prefetchInfiniteQuery = function prefetchInfiniteQuery(arg1, arg2, arg3) {
        return this.fetchInfiniteQuery(arg1, arg2, arg3).then((0, $2d3546043d93dd46$export$8793edee2d425525)).catch((0, $2d3546043d93dd46$export$8793edee2d425525));
    };
    _proto.cancelMutations = function cancelMutations() {
        var _this7 = this;
        var promises = (0, $4211147ddabe9d86$export$520687f44db6e1ab).batch(function() {
            return _this7.mutationCache.getAll().map(function(mutation) {
                return mutation.cancel();
            });
        });
        return Promise.all(promises).then((0, $2d3546043d93dd46$export$8793edee2d425525)).catch((0, $2d3546043d93dd46$export$8793edee2d425525));
    };
    _proto.resumePausedMutations = function resumePausedMutations() {
        return this.getMutationCache().resumePausedMutations();
    };
    _proto.executeMutation = function executeMutation(options) {
        return this.mutationCache.build(this, options).execute();
    };
    _proto.getQueryCache = function getQueryCache() {
        return this.queryCache;
    };
    _proto.getMutationCache = function getMutationCache() {
        return this.mutationCache;
    };
    _proto.getDefaultOptions = function getDefaultOptions() {
        return this.defaultOptions;
    };
    _proto.setDefaultOptions = function setDefaultOptions(options) {
        this.defaultOptions = options;
    };
    _proto.setQueryDefaults = function setQueryDefaults(queryKey, options) {
        var result = this.queryDefaults.find(function(x) {
            return (0, $2d3546043d93dd46$export$5fcb678681417b54)(queryKey) === (0, $2d3546043d93dd46$export$5fcb678681417b54)(x.queryKey);
        });
        if (result) result.defaultOptions = options;
        else this.queryDefaults.push({
            queryKey: queryKey,
            defaultOptions: options
        });
    };
    _proto.getQueryDefaults = function getQueryDefaults(queryKey) {
        var _this$queryDefaults$f;
        return queryKey ? (_this$queryDefaults$f = this.queryDefaults.find(function(x) {
            return (0, $2d3546043d93dd46$export$2f07189bb9fa26a7)(queryKey, x.queryKey);
        })) == null ? void 0 : _this$queryDefaults$f.defaultOptions : undefined;
    };
    _proto.setMutationDefaults = function setMutationDefaults(mutationKey, options) {
        var result = this.mutationDefaults.find(function(x) {
            return (0, $2d3546043d93dd46$export$5fcb678681417b54)(mutationKey) === (0, $2d3546043d93dd46$export$5fcb678681417b54)(x.mutationKey);
        });
        if (result) result.defaultOptions = options;
        else this.mutationDefaults.push({
            mutationKey: mutationKey,
            defaultOptions: options
        });
    };
    _proto.getMutationDefaults = function getMutationDefaults(mutationKey) {
        var _this$mutationDefault;
        return mutationKey ? (_this$mutationDefault = this.mutationDefaults.find(function(x) {
            return (0, $2d3546043d93dd46$export$2f07189bb9fa26a7)(mutationKey, x.mutationKey);
        })) == null ? void 0 : _this$mutationDefault.defaultOptions : undefined;
    };
    _proto.defaultQueryOptions = function defaultQueryOptions(options) {
        if (options == null ? void 0 : options._defaulted) return options;
        var defaultedOptions = (0, $f3601d07f0ff7403$export$2e2bcd8739ae039)({}, this.defaultOptions.queries, this.getQueryDefaults(options == null ? void 0 : options.queryKey), options, {
            _defaulted: true
        });
        if (!defaultedOptions.queryHash && defaultedOptions.queryKey) defaultedOptions.queryHash = (0, $2d3546043d93dd46$export$cc90ca97bc0d73fd)(defaultedOptions.queryKey, defaultedOptions);
        return defaultedOptions;
    };
    _proto.defaultQueryObserverOptions = function defaultQueryObserverOptions(options) {
        return this.defaultQueryOptions(options);
    };
    _proto.defaultMutationOptions = function defaultMutationOptions(options) {
        if (options == null ? void 0 : options._defaulted) return options;
        return (0, $f3601d07f0ff7403$export$2e2bcd8739ae039)({}, this.defaultOptions.mutations, this.getMutationDefaults(options == null ? void 0 : options.mutationKey), options, {
            _defaulted: true
        });
    };
    _proto.clear = function clear() {
        this.queryCache.clear();
        this.mutationCache.clear();
    };
    return QueryClient;
}();


// Side effects


var $9a1cc08ee62eb39b$export$c78a37762a8d58e1 = (0, (/*@__PURE__*/$parcel$interopDefault($320b03ed0fb31615$exports))).unstable_batchedUpdates;


(0, $4211147ddabe9d86$export$520687f44db6e1ab).setBatchNotifyFunction((0, $9a1cc08ee62eb39b$export$c78a37762a8d58e1));



var $a09cbd499b7faad1$export$af88d00dbe7f521 = console;


(0, $b06e329c274347ba$export$3abbd92f765bee58)((0, $a09cbd499b7faad1$export$af88d00dbe7f521));



var $4Y8Vu = parcelRequire("4Y8Vu");
var $5bfa3d489cb629a7$var$defaultContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4Y8Vu))).createContext(undefined);
var $5bfa3d489cb629a7$var$QueryClientSharingContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4Y8Vu))).createContext(false); // if contextSharing is on, we share the first and at least one
// instance of the context across the window
// to ensure that if React Query is used across
// different bundles or microfrontends they will
// all use the same **instance** of context, regardless
// of module scoping.
function $5bfa3d489cb629a7$var$getQueryClientContext(contextSharing) {
    if (contextSharing && typeof window !== 'undefined') {
        if (!window.ReactQueryClientContext) window.ReactQueryClientContext = $5bfa3d489cb629a7$var$defaultContext;
        return window.ReactQueryClientContext;
    }
    return $5bfa3d489cb629a7$var$defaultContext;
}
var $5bfa3d489cb629a7$export$22e77b9572c4fded = function useQueryClient() {
    var queryClient = (0, (/*@__PURE__*/$parcel$interopDefault($4Y8Vu))).useContext($5bfa3d489cb629a7$var$getQueryClientContext((0, (/*@__PURE__*/$parcel$interopDefault($4Y8Vu))).useContext($5bfa3d489cb629a7$var$QueryClientSharingContext)));
    if (!queryClient) throw new Error('No QueryClient set, use QueryClientProvider to set one');
    return queryClient;
};
var $5bfa3d489cb629a7$export$45604f0cc8ae667b = function QueryClientProvider(_ref) {
    var client = _ref.client, _ref$contextSharing = _ref.contextSharing, contextSharing = _ref$contextSharing === void 0 ? false : _ref$contextSharing, children = _ref.children;
    (0, (/*@__PURE__*/$parcel$interopDefault($4Y8Vu))).useEffect(function() {
        client.mount();
        return function() {
            client.unmount();
        };
    }, [
        client
    ]);
    var Context = $5bfa3d489cb629a7$var$getQueryClientContext(contextSharing);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4Y8Vu))).createElement($5bfa3d489cb629a7$var$QueryClientSharingContext.Provider, {
        value: contextSharing
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4Y8Vu))).createElement(Context.Provider, {
        value: client
    }, children));
};







var $4Y8Vu = parcelRequire("4Y8Vu");







var $40955722ea430c4f$export$d3c1860ee66f291a = /*#__PURE__*/ function(_Subscribable) {
    (0, $4708a8791a55a98c$export$2e2bcd8739ae039)(MutationObserver, _Subscribable);
    function MutationObserver(client, options) {
        var _this;
        _this = _Subscribable.call(this) || this;
        _this.client = client;
        _this.setOptions(options);
        _this.bindMethods();
        _this.updateResult();
        return _this;
    }
    var _proto = MutationObserver.prototype;
    _proto.bindMethods = function bindMethods() {
        this.mutate = this.mutate.bind(this);
        this.reset = this.reset.bind(this);
    };
    _proto.setOptions = function setOptions(options) {
        this.options = this.client.defaultMutationOptions(options);
    };
    _proto.onUnsubscribe = function onUnsubscribe() {
        if (!this.listeners.length) {
            var _this$currentMutation;
            (_this$currentMutation = this.currentMutation) == null || _this$currentMutation.removeObserver(this);
        }
    };
    _proto.onMutationUpdate = function onMutationUpdate(action) {
        this.updateResult(); // Determine which callbacks to trigger
        var notifyOptions = {
            listeners: true
        };
        if (action.type === 'success') notifyOptions.onSuccess = true;
        else if (action.type === 'error') notifyOptions.onError = true;
        this.notify(notifyOptions);
    };
    _proto.getCurrentResult = function getCurrentResult() {
        return this.currentResult;
    };
    _proto.reset = function reset() {
        this.currentMutation = undefined;
        this.updateResult();
        this.notify({
            listeners: true
        });
    };
    _proto.mutate = function mutate(variables, options) {
        this.mutateOptions = options;
        if (this.currentMutation) this.currentMutation.removeObserver(this);
        this.currentMutation = this.client.getMutationCache().build(this.client, (0, $f3601d07f0ff7403$export$2e2bcd8739ae039)({}, this.options, {
            variables: typeof variables !== 'undefined' ? variables : this.options.variables
        }));
        this.currentMutation.addObserver(this);
        return this.currentMutation.execute();
    };
    _proto.updateResult = function updateResult() {
        var state = this.currentMutation ? this.currentMutation.state : (0, $264df94243da3226$export$a1659b54bac3252a)();
        var result = (0, $f3601d07f0ff7403$export$2e2bcd8739ae039)({}, state, {
            isLoading: state.status === 'loading',
            isSuccess: state.status === 'success',
            isError: state.status === 'error',
            isIdle: state.status === 'idle',
            mutate: this.mutate,
            reset: this.reset
        });
        this.currentResult = result;
    };
    _proto.notify = function notify(options) {
        var _this2 = this;
        (0, $4211147ddabe9d86$export$520687f44db6e1ab).batch(function() {
            // First trigger the mutate callbacks
            if (_this2.mutateOptions) {
                if (options.onSuccess) {
                    _this2.mutateOptions.onSuccess == null || _this2.mutateOptions.onSuccess(_this2.currentResult.data, _this2.currentResult.variables, _this2.currentResult.context);
                    _this2.mutateOptions.onSettled == null || _this2.mutateOptions.onSettled(_this2.currentResult.data, null, _this2.currentResult.variables, _this2.currentResult.context);
                } else if (options.onError) {
                    _this2.mutateOptions.onError == null || _this2.mutateOptions.onError(_this2.currentResult.error, _this2.currentResult.variables, _this2.currentResult.context);
                    _this2.mutateOptions.onSettled == null || _this2.mutateOptions.onSettled(undefined, _this2.currentResult.error, _this2.currentResult.variables, _this2.currentResult.context);
                }
            } // Then trigger the listeners
            if (options.listeners) _this2.listeners.forEach(function(listener) {
                listener(_this2.currentResult);
            });
        });
    };
    return MutationObserver;
}((0, $42c38dddc2ac9900$export$d26086b469ecdbcc));



function $aa8b04f431104057$export$2072f68e6c3507cf(suspense, _useErrorBoundary, params) {
    // Allow useErrorBoundary function to override throwing behavior on a per-error basis
    if (typeof _useErrorBoundary === 'function') return _useErrorBoundary.apply(void 0, params);
     // Allow useErrorBoundary to override suspense's throwing behavior
    if (typeof _useErrorBoundary === 'boolean') return _useErrorBoundary; // If suspense is enabled default to throwing errors
    return !!suspense;
}


function $01ce8e6f2ff7deb7$export$609860bf8b0084c(arg1, arg2, arg3) {
    var mountedRef = (0, (/*@__PURE__*/$parcel$interopDefault($4Y8Vu))).useRef(false);
    var _React$useState = (0, (/*@__PURE__*/$parcel$interopDefault($4Y8Vu))).useState(0), forceUpdate = _React$useState[1];
    var options = (0, $2d3546043d93dd46$export$b646c531ea475334)(arg1, arg2, arg3);
    var queryClient = (0, $5bfa3d489cb629a7$export$22e77b9572c4fded)();
    var obsRef = (0, (/*@__PURE__*/$parcel$interopDefault($4Y8Vu))).useRef();
    if (!obsRef.current) obsRef.current = new (0, $40955722ea430c4f$export$d3c1860ee66f291a)(queryClient, options);
    else obsRef.current.setOptions(options);
    var currentResult = obsRef.current.getCurrentResult();
    (0, (/*@__PURE__*/$parcel$interopDefault($4Y8Vu))).useEffect(function() {
        mountedRef.current = true;
        var unsubscribe = obsRef.current.subscribe((0, $4211147ddabe9d86$export$520687f44db6e1ab).batchCalls(function() {
            if (mountedRef.current) forceUpdate(function(x) {
                return x + 1;
            });
        }));
        return function() {
            mountedRef.current = false;
            unsubscribe();
        };
    }, []);
    var mutate = (0, (/*@__PURE__*/$parcel$interopDefault($4Y8Vu))).useCallback(function(variables, mutateOptions) {
        obsRef.current.mutate(variables, mutateOptions).catch((0, $2d3546043d93dd46$export$8793edee2d425525));
    }, []);
    if (currentResult.error && (0, $aa8b04f431104057$export$2072f68e6c3507cf)(undefined, obsRef.current.options.useErrorBoundary, [
        currentResult.error
    ])) throw currentResult.error;
    return (0, $f3601d07f0ff7403$export$2e2bcd8739ae039)({}, currentResult, {
        mutate: mutate,
        mutateAsync: currentResult.mutate
    });
}










var $57d378d2b36cd1ab$export$a06cf8c0066f0d4c = /*#__PURE__*/ function(_Subscribable) {
    (0, $4708a8791a55a98c$export$2e2bcd8739ae039)(QueryObserver, _Subscribable);
    function QueryObserver(client, options) {
        var _this;
        _this = _Subscribable.call(this) || this;
        _this.client = client;
        _this.options = options;
        _this.trackedProps = [];
        _this.selectError = null;
        _this.bindMethods();
        _this.setOptions(options);
        return _this;
    }
    var _proto = QueryObserver.prototype;
    _proto.bindMethods = function bindMethods() {
        this.remove = this.remove.bind(this);
        this.refetch = this.refetch.bind(this);
    };
    _proto.onSubscribe = function onSubscribe() {
        if (this.listeners.length === 1) {
            this.currentQuery.addObserver(this);
            if ($57d378d2b36cd1ab$var$shouldFetchOnMount(this.currentQuery, this.options)) this.executeFetch();
            this.updateTimers();
        }
    };
    _proto.onUnsubscribe = function onUnsubscribe() {
        if (!this.listeners.length) this.destroy();
    };
    _proto.shouldFetchOnReconnect = function shouldFetchOnReconnect() {
        return $57d378d2b36cd1ab$var$shouldFetchOn(this.currentQuery, this.options, this.options.refetchOnReconnect);
    };
    _proto.shouldFetchOnWindowFocus = function shouldFetchOnWindowFocus() {
        return $57d378d2b36cd1ab$var$shouldFetchOn(this.currentQuery, this.options, this.options.refetchOnWindowFocus);
    };
    _proto.destroy = function destroy() {
        this.listeners = [];
        this.clearTimers();
        this.currentQuery.removeObserver(this);
    };
    _proto.setOptions = function setOptions(options, notifyOptions) {
        var prevOptions = this.options;
        var prevQuery = this.currentQuery;
        this.options = this.client.defaultQueryObserverOptions(options);
        if (typeof this.options.enabled !== 'undefined' && typeof this.options.enabled !== 'boolean') throw new Error('Expected enabled to be a boolean');
         // Keep previous query key if the user does not supply one
        if (!this.options.queryKey) this.options.queryKey = prevOptions.queryKey;
        this.updateQuery();
        var mounted = this.hasListeners(); // Fetch if there are subscribers
        if (mounted && $57d378d2b36cd1ab$var$shouldFetchOptionally(this.currentQuery, prevQuery, this.options, prevOptions)) this.executeFetch();
         // Update result
        this.updateResult(notifyOptions); // Update stale interval if needed
        if (mounted && (this.currentQuery !== prevQuery || this.options.enabled !== prevOptions.enabled || this.options.staleTime !== prevOptions.staleTime)) this.updateStaleTimeout();
        var nextRefetchInterval = this.computeRefetchInterval(); // Update refetch interval if needed
        if (mounted && (this.currentQuery !== prevQuery || this.options.enabled !== prevOptions.enabled || nextRefetchInterval !== this.currentRefetchInterval)) this.updateRefetchInterval(nextRefetchInterval);
    };
    _proto.getOptimisticResult = function getOptimisticResult(options) {
        var defaultedOptions = this.client.defaultQueryObserverOptions(options);
        var query = this.client.getQueryCache().build(this.client, defaultedOptions);
        return this.createResult(query, defaultedOptions);
    };
    _proto.getCurrentResult = function getCurrentResult() {
        return this.currentResult;
    };
    _proto.trackResult = function trackResult(result, defaultedOptions) {
        var _this2 = this;
        var trackedResult = {};
        var trackProp = function trackProp(key) {
            if (!_this2.trackedProps.includes(key)) _this2.trackedProps.push(key);
        };
        Object.keys(result).forEach(function(key) {
            Object.defineProperty(trackedResult, key, {
                configurable: false,
                enumerable: true,
                get: function get() {
                    trackProp(key);
                    return result[key];
                }
            });
        });
        if (defaultedOptions.useErrorBoundary || defaultedOptions.suspense) trackProp('error');
        return trackedResult;
    };
    _proto.getNextResult = function getNextResult(options) {
        var _this3 = this;
        return new Promise(function(resolve, reject) {
            var unsubscribe = _this3.subscribe(function(result) {
                if (!result.isFetching) {
                    unsubscribe();
                    if (result.isError && (options == null ? void 0 : options.throwOnError)) reject(result.error);
                    else resolve(result);
                }
            });
        });
    };
    _proto.getCurrentQuery = function getCurrentQuery() {
        return this.currentQuery;
    };
    _proto.remove = function remove() {
        this.client.getQueryCache().remove(this.currentQuery);
    };
    _proto.refetch = function refetch(options) {
        return this.fetch((0, $f3601d07f0ff7403$export$2e2bcd8739ae039)({}, options, {
            meta: {
                refetchPage: options == null ? void 0 : options.refetchPage
            }
        }));
    };
    _proto.fetchOptimistic = function fetchOptimistic(options) {
        var _this4 = this;
        var defaultedOptions = this.client.defaultQueryObserverOptions(options);
        var query = this.client.getQueryCache().build(this.client, defaultedOptions);
        return query.fetch().then(function() {
            return _this4.createResult(query, defaultedOptions);
        });
    };
    _proto.fetch = function fetch(fetchOptions) {
        var _this5 = this;
        return this.executeFetch(fetchOptions).then(function() {
            _this5.updateResult();
            return _this5.currentResult;
        });
    };
    _proto.executeFetch = function executeFetch(fetchOptions) {
        // Make sure we reference the latest query as the current one might have been removed
        this.updateQuery(); // Fetch
        var promise = this.currentQuery.fetch(this.options, fetchOptions);
        if (!(fetchOptions == null ? void 0 : fetchOptions.throwOnError)) promise = promise.catch((0, $2d3546043d93dd46$export$8793edee2d425525));
        return promise;
    };
    _proto.updateStaleTimeout = function updateStaleTimeout() {
        var _this6 = this;
        this.clearStaleTimeout();
        if ((0, $2d3546043d93dd46$export$6acf61af03e62db) || this.currentResult.isStale || !(0, $2d3546043d93dd46$export$e539f754e934e270)(this.options.staleTime)) return;
        var time = (0, $2d3546043d93dd46$export$811b83d62bcf47f0)(this.currentResult.dataUpdatedAt, this.options.staleTime); // The timeout is sometimes triggered 1 ms before the stale time expiration.
        // To mitigate this issue we always add 1 ms to the timeout.
        var timeout = time + 1;
        this.staleTimeoutId = setTimeout(function() {
            if (!_this6.currentResult.isStale) _this6.updateResult();
        }, timeout);
    };
    _proto.computeRefetchInterval = function computeRefetchInterval() {
        var _this$options$refetch;
        return typeof this.options.refetchInterval === 'function' ? this.options.refetchInterval(this.currentResult.data, this.currentQuery) : (_this$options$refetch = this.options.refetchInterval) != null ? _this$options$refetch : false;
    };
    _proto.updateRefetchInterval = function updateRefetchInterval(nextInterval) {
        var _this7 = this;
        this.clearRefetchInterval();
        this.currentRefetchInterval = nextInterval;
        if ((0, $2d3546043d93dd46$export$6acf61af03e62db) || this.options.enabled === false || !(0, $2d3546043d93dd46$export$e539f754e934e270)(this.currentRefetchInterval) || this.currentRefetchInterval === 0) return;
        this.refetchIntervalId = setInterval(function() {
            if (_this7.options.refetchIntervalInBackground || (0, $f33c60d777f3113f$export$6bf54661be5b02cf).isFocused()) _this7.executeFetch();
        }, this.currentRefetchInterval);
    };
    _proto.updateTimers = function updateTimers() {
        this.updateStaleTimeout();
        this.updateRefetchInterval(this.computeRefetchInterval());
    };
    _proto.clearTimers = function clearTimers() {
        this.clearStaleTimeout();
        this.clearRefetchInterval();
    };
    _proto.clearStaleTimeout = function clearStaleTimeout() {
        if (this.staleTimeoutId) {
            clearTimeout(this.staleTimeoutId);
            this.staleTimeoutId = undefined;
        }
    };
    _proto.clearRefetchInterval = function clearRefetchInterval() {
        if (this.refetchIntervalId) {
            clearInterval(this.refetchIntervalId);
            this.refetchIntervalId = undefined;
        }
    };
    _proto.createResult = function createResult(query, options) {
        var prevQuery = this.currentQuery;
        var prevOptions = this.options;
        var prevResult = this.currentResult;
        var prevResultState = this.currentResultState;
        var prevResultOptions = this.currentResultOptions;
        var queryChange = query !== prevQuery;
        var queryInitialState = queryChange ? query.state : this.currentQueryInitialState;
        var prevQueryResult = queryChange ? this.currentResult : this.previousQueryResult;
        var state = query.state;
        var dataUpdatedAt = state.dataUpdatedAt, error = state.error, errorUpdatedAt = state.errorUpdatedAt, isFetching = state.isFetching, status = state.status;
        var isPreviousData = false;
        var isPlaceholderData = false;
        var data; // Optimistically set result in fetching state if needed
        if (options.optimisticResults) {
            var mounted = this.hasListeners();
            var fetchOnMount = !mounted && $57d378d2b36cd1ab$var$shouldFetchOnMount(query, options);
            var fetchOptionally = mounted && $57d378d2b36cd1ab$var$shouldFetchOptionally(query, prevQuery, options, prevOptions);
            if (fetchOnMount || fetchOptionally) {
                isFetching = true;
                if (!dataUpdatedAt) status = 'loading';
            }
        } // Keep previous data if needed
        if (options.keepPreviousData && !state.dataUpdateCount && (prevQueryResult == null ? void 0 : prevQueryResult.isSuccess) && status !== 'error') {
            data = prevQueryResult.data;
            dataUpdatedAt = prevQueryResult.dataUpdatedAt;
            status = prevQueryResult.status;
            isPreviousData = true;
        } else if (options.select && typeof state.data !== 'undefined') {
            // Memoize select result
            if (prevResult && state.data === (prevResultState == null ? void 0 : prevResultState.data) && options.select === this.selectFn) data = this.selectResult;
            else try {
                this.selectFn = options.select;
                data = options.select(state.data);
                if (options.structuralSharing !== false) data = (0, $2d3546043d93dd46$export$77a71fc411098696)(prevResult == null ? void 0 : prevResult.data, data);
                this.selectResult = data;
                this.selectError = null;
            } catch (selectError) {
                (0, $b06e329c274347ba$export$2b1d391cd05230fd)().error(selectError);
                this.selectError = selectError;
            }
        } else data = state.data;
         // Show placeholder data if needed
        if (typeof options.placeholderData !== 'undefined' && typeof data === 'undefined' && (status === 'loading' || status === 'idle')) {
            var placeholderData; // Memoize placeholder data
            if ((prevResult == null ? void 0 : prevResult.isPlaceholderData) && options.placeholderData === (prevResultOptions == null ? void 0 : prevResultOptions.placeholderData)) placeholderData = prevResult.data;
            else {
                placeholderData = typeof options.placeholderData === 'function' ? options.placeholderData() : options.placeholderData;
                if (options.select && typeof placeholderData !== 'undefined') try {
                    placeholderData = options.select(placeholderData);
                    if (options.structuralSharing !== false) placeholderData = (0, $2d3546043d93dd46$export$77a71fc411098696)(prevResult == null ? void 0 : prevResult.data, placeholderData);
                    this.selectError = null;
                } catch (selectError) {
                    (0, $b06e329c274347ba$export$2b1d391cd05230fd)().error(selectError);
                    this.selectError = selectError;
                }
            }
            if (typeof placeholderData !== 'undefined') {
                status = 'success';
                data = placeholderData;
                isPlaceholderData = true;
            }
        }
        if (this.selectError) {
            error = this.selectError;
            data = this.selectResult;
            errorUpdatedAt = Date.now();
            status = 'error';
        }
        var result = {
            status: status,
            isLoading: status === 'loading',
            isSuccess: status === 'success',
            isError: status === 'error',
            isIdle: status === 'idle',
            data: data,
            dataUpdatedAt: dataUpdatedAt,
            error: error,
            errorUpdatedAt: errorUpdatedAt,
            failureCount: state.fetchFailureCount,
            errorUpdateCount: state.errorUpdateCount,
            isFetched: state.dataUpdateCount > 0 || state.errorUpdateCount > 0,
            isFetchedAfterMount: state.dataUpdateCount > queryInitialState.dataUpdateCount || state.errorUpdateCount > queryInitialState.errorUpdateCount,
            isFetching: isFetching,
            isRefetching: isFetching && status !== 'loading',
            isLoadingError: status === 'error' && state.dataUpdatedAt === 0,
            isPlaceholderData: isPlaceholderData,
            isPreviousData: isPreviousData,
            isRefetchError: status === 'error' && state.dataUpdatedAt !== 0,
            isStale: $57d378d2b36cd1ab$var$isStale(query, options),
            refetch: this.refetch,
            remove: this.remove
        };
        return result;
    };
    _proto.shouldNotifyListeners = function shouldNotifyListeners(result, prevResult) {
        if (!prevResult) return true;
        var _this$options = this.options, notifyOnChangeProps = _this$options.notifyOnChangeProps, notifyOnChangePropsExclusions = _this$options.notifyOnChangePropsExclusions;
        if (!notifyOnChangeProps && !notifyOnChangePropsExclusions) return true;
        if (notifyOnChangeProps === 'tracked' && !this.trackedProps.length) return true;
        var includedProps = notifyOnChangeProps === 'tracked' ? this.trackedProps : notifyOnChangeProps;
        return Object.keys(result).some(function(key) {
            var typedKey = key;
            var changed = result[typedKey] !== prevResult[typedKey];
            var isIncluded = includedProps == null ? void 0 : includedProps.some(function(x) {
                return x === key;
            });
            var isExcluded = notifyOnChangePropsExclusions == null ? void 0 : notifyOnChangePropsExclusions.some(function(x) {
                return x === key;
            });
            return changed && !isExcluded && (!includedProps || isIncluded);
        });
    };
    _proto.updateResult = function updateResult(notifyOptions) {
        var prevResult = this.currentResult;
        this.currentResult = this.createResult(this.currentQuery, this.options);
        this.currentResultState = this.currentQuery.state;
        this.currentResultOptions = this.options; // Only notify if something has changed
        if ((0, $2d3546043d93dd46$export$3e67810a3f0e9f1c)(this.currentResult, prevResult)) return;
         // Determine which callbacks to trigger
        var defaultNotifyOptions = {
            cache: true
        };
        if ((notifyOptions == null ? void 0 : notifyOptions.listeners) !== false && this.shouldNotifyListeners(this.currentResult, prevResult)) defaultNotifyOptions.listeners = true;
        this.notify((0, $f3601d07f0ff7403$export$2e2bcd8739ae039)({}, defaultNotifyOptions, notifyOptions));
    };
    _proto.updateQuery = function updateQuery() {
        var query = this.client.getQueryCache().build(this.client, this.options);
        if (query === this.currentQuery) return;
        var prevQuery = this.currentQuery;
        this.currentQuery = query;
        this.currentQueryInitialState = query.state;
        this.previousQueryResult = this.currentResult;
        if (this.hasListeners()) {
            prevQuery == null || prevQuery.removeObserver(this);
            query.addObserver(this);
        }
    };
    _proto.onQueryUpdate = function onQueryUpdate(action) {
        var notifyOptions = {};
        if (action.type === 'success') notifyOptions.onSuccess = true;
        else if (action.type === 'error' && !(0, $31c660a97a63c1d9$export$986cc6445c1d323)(action.error)) notifyOptions.onError = true;
        this.updateResult(notifyOptions);
        if (this.hasListeners()) this.updateTimers();
    };
    _proto.notify = function notify(notifyOptions) {
        var _this8 = this;
        (0, $4211147ddabe9d86$export$520687f44db6e1ab).batch(function() {
            // First trigger the configuration callbacks
            if (notifyOptions.onSuccess) {
                _this8.options.onSuccess == null || _this8.options.onSuccess(_this8.currentResult.data);
                _this8.options.onSettled == null || _this8.options.onSettled(_this8.currentResult.data, null);
            } else if (notifyOptions.onError) {
                _this8.options.onError == null || _this8.options.onError(_this8.currentResult.error);
                _this8.options.onSettled == null || _this8.options.onSettled(undefined, _this8.currentResult.error);
            } // Then trigger the listeners
            if (notifyOptions.listeners) _this8.listeners.forEach(function(listener) {
                listener(_this8.currentResult);
            });
             // Then the cache listeners
            if (notifyOptions.cache) _this8.client.getQueryCache().notify({
                query: _this8.currentQuery,
                type: 'observerResultsUpdated'
            });
        });
    };
    return QueryObserver;
}((0, $42c38dddc2ac9900$export$d26086b469ecdbcc));
function $57d378d2b36cd1ab$var$shouldLoadOnMount(query, options) {
    return options.enabled !== false && !query.state.dataUpdatedAt && !(query.state.status === 'error' && options.retryOnMount === false);
}
function $57d378d2b36cd1ab$var$shouldFetchOnMount(query, options) {
    return $57d378d2b36cd1ab$var$shouldLoadOnMount(query, options) || query.state.dataUpdatedAt > 0 && $57d378d2b36cd1ab$var$shouldFetchOn(query, options, options.refetchOnMount);
}
function $57d378d2b36cd1ab$var$shouldFetchOn(query, options, field) {
    if (options.enabled !== false) {
        var value = typeof field === 'function' ? field(query) : field;
        return value === 'always' || value !== false && $57d378d2b36cd1ab$var$isStale(query, options);
    }
    return false;
}
function $57d378d2b36cd1ab$var$shouldFetchOptionally(query, prevQuery, options, prevOptions) {
    return options.enabled !== false && (query !== prevQuery || prevOptions.enabled === false) && (!options.suspense || query.state.status !== 'error') && $57d378d2b36cd1ab$var$isStale(query, options);
}
function $57d378d2b36cd1ab$var$isStale(query, options) {
    return query.isStaleByTime(options.staleTime);
}




var $4Y8Vu = parcelRequire("4Y8Vu");


var $4Y8Vu = parcelRequire("4Y8Vu");
function $6fe4c738a0e6d828$var$createValue() {
    var _isReset = false;
    return {
        clearReset: function clearReset() {
            _isReset = false;
        },
        reset: function reset() {
            _isReset = true;
        },
        isReset: function isReset() {
            return _isReset;
        }
    };
}
var $6fe4c738a0e6d828$var$QueryErrorResetBoundaryContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4Y8Vu))).createContext($6fe4c738a0e6d828$var$createValue()); // HOOK
var $6fe4c738a0e6d828$export$50dfac555130cafd = function useQueryErrorResetBoundary() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($4Y8Vu))).useContext($6fe4c738a0e6d828$var$QueryErrorResetBoundaryContext);
}; // COMPONENT
var $6fe4c738a0e6d828$export$ddb9962d870f2330 = function QueryErrorResetBoundary(_ref) {
    var children = _ref.children;
    var value = (0, (/*@__PURE__*/$parcel$interopDefault($4Y8Vu))).useMemo(function() {
        return $6fe4c738a0e6d828$var$createValue();
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4Y8Vu))).createElement($6fe4c738a0e6d828$var$QueryErrorResetBoundaryContext.Provider, {
        value: value
    }, typeof children === 'function' ? children(value) : children);
};




function $db873db6e64be868$export$fff0865807e996c5(options, Observer) {
    var mountedRef = (0, (/*@__PURE__*/$parcel$interopDefault($4Y8Vu))).useRef(false);
    var _React$useState = (0, (/*@__PURE__*/$parcel$interopDefault($4Y8Vu))).useState(0), forceUpdate = _React$useState[1];
    var queryClient = (0, $5bfa3d489cb629a7$export$22e77b9572c4fded)();
    var errorResetBoundary = (0, $6fe4c738a0e6d828$export$50dfac555130cafd)();
    var defaultedOptions = queryClient.defaultQueryObserverOptions(options); // Make sure results are optimistically set in fetching state before subscribing or updating options
    defaultedOptions.optimisticResults = true; // Include callbacks in batch renders
    if (defaultedOptions.onError) defaultedOptions.onError = (0, $4211147ddabe9d86$export$520687f44db6e1ab).batchCalls(defaultedOptions.onError);
    if (defaultedOptions.onSuccess) defaultedOptions.onSuccess = (0, $4211147ddabe9d86$export$520687f44db6e1ab).batchCalls(defaultedOptions.onSuccess);
    if (defaultedOptions.onSettled) defaultedOptions.onSettled = (0, $4211147ddabe9d86$export$520687f44db6e1ab).batchCalls(defaultedOptions.onSettled);
    if (defaultedOptions.suspense) {
        // Always set stale time when using suspense to prevent
        // fetching again when directly mounting after suspending
        if (typeof defaultedOptions.staleTime !== 'number') defaultedOptions.staleTime = 1000;
         // Set cache time to 1 if the option has been set to 0
        // when using suspense to prevent infinite loop of fetches
        if (defaultedOptions.cacheTime === 0) defaultedOptions.cacheTime = 1;
    }
    if (defaultedOptions.suspense || defaultedOptions.useErrorBoundary) // Prevent retrying failed query if the error boundary has not been reset yet
    {
        if (!errorResetBoundary.isReset()) defaultedOptions.retryOnMount = false;
    }
    var _React$useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($4Y8Vu))).useState(function() {
        return new Observer(queryClient, defaultedOptions);
    }), observer = _React$useState2[0];
    var result = observer.getOptimisticResult(defaultedOptions);
    (0, (/*@__PURE__*/$parcel$interopDefault($4Y8Vu))).useEffect(function() {
        mountedRef.current = true;
        errorResetBoundary.clearReset();
        var unsubscribe = observer.subscribe((0, $4211147ddabe9d86$export$520687f44db6e1ab).batchCalls(function() {
            if (mountedRef.current) forceUpdate(function(x) {
                return x + 1;
            });
        })); // Update result to make sure we did not miss any query updates
        // between creating the observer and subscribing to it.
        observer.updateResult();
        return function() {
            mountedRef.current = false;
            unsubscribe();
        };
    }, [
        errorResetBoundary,
        observer
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($4Y8Vu))).useEffect(function() {
        // Do not notify on updates because of changes in the options because
        // these changes should already be reflected in the optimistic result.
        observer.setOptions(defaultedOptions, {
            listeners: false
        });
    }, [
        defaultedOptions,
        observer
    ]); // Handle suspense
    if (defaultedOptions.suspense && result.isLoading) throw observer.fetchOptimistic(defaultedOptions).then(function(_ref) {
        var data = _ref.data;
        defaultedOptions.onSuccess == null || defaultedOptions.onSuccess(data);
        defaultedOptions.onSettled == null || defaultedOptions.onSettled(data, null);
    }).catch(function(error) {
        errorResetBoundary.clearReset();
        defaultedOptions.onError == null || defaultedOptions.onError(error);
        defaultedOptions.onSettled == null || defaultedOptions.onSettled(undefined, error);
    });
     // Handle error boundary
    if (result.isError && !errorResetBoundary.isReset() && !result.isFetching && (0, $aa8b04f431104057$export$2072f68e6c3507cf)(defaultedOptions.suspense, defaultedOptions.useErrorBoundary, [
        result.error,
        observer.getCurrentQuery()
    ])) throw result.error;
     // Handle result property usage tracking
    if (defaultedOptions.notifyOnChangeProps === 'tracked') result = observer.trackResult(result, defaultedOptions);
    return result;
}


function $57c3b87db6e4f350$export$dd0a697e1782aedd(arg1, arg2, arg3) {
    var parsedOptions = (0, $2d3546043d93dd46$export$8a11fbc2c8ea08fd)(arg1, arg2, arg3);
    return (0, $db873db6e64be868$export$fff0865807e996c5)(parsedOptions, (0, $57d378d2b36cd1ab$export$a06cf8c0066f0d4c));
}










function $90bb5a7b8adaf72f$export$71511d61b312f219(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}


function $45c1a8590053a015$export$71511d61b312f219(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            (0, $90bb5a7b8adaf72f$export$71511d61b312f219)(target, key, source[key]);
        });
    }
    return target;
}


function $8f44472fa5eb25c0$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $8f44472fa5eb25c0$export$71511d61b312f219(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else $8f44472fa5eb25c0$var$ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}


function $5496fef4f468f9dc$export$71511d61b312f219(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}


function $30c24b3cbf3b0a7a$export$71511d61b312f219(source, excluded) {
    if (source == null) return {};
    var target = (0, $5496fef4f468f9dc$export$71511d61b312f219)(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}




var $4Y8Vu = parcelRequire("4Y8Vu");


const $17f149b88fede922$var$AUTH_KEY = "application-form";
const $17f149b88fede922$export$38e1f53b76ec7fed = ()=>{
    try {
        const token = window.localStorage.getItem($17f149b88fede922$var$AUTH_KEY);
        return token;
    } catch (error) {
        console.error(error);
        return null;
    }
};
const $17f149b88fede922$export$3c4602e16d9ace38 = (token)=>{
    try {
        window.localStorage.setItem($17f149b88fede922$var$AUTH_KEY, token);
    } catch (error) {
        console.error(error);
    }
};


const $8149f886a66cd959$export$205bc258834dc08 = async (id)=>{
    try {
        const token = (0, $17f149b88fede922$export$38e1f53b76ec7fed)();
        const res = await fetch(`${api.url}/application/${id}`, {
            headers: {
                Authorization: token ? `Bearer ${token}` : null
            }
        });
        const data = await res.json();
        // New session
        if (res.status === 201) {
            (0, $17f149b88fede922$export$3c4602e16d9ace38)(data.token);
            return null;
        }
        return data;
    } catch (error) {
        console.error(error);
    }
};
const $8149f886a66cd959$export$df78b02a879196da = async (_param)=>{
    var { id: id } = _param, data = (0, $30c24b3cbf3b0a7a$export$71511d61b312f219)(_param, [
        "id"
    ]);
    try {
        const token = (0, $17f149b88fede922$export$38e1f53b76ec7fed)();
        if (!token) throw "No application token";
        await fetch(`${api.url}/application/${id}`, {
            method: "POST",
            headers: {
                Authorization: `Bearer ${token}`,
                Accept: "application/json",
                "Content-Type": "application/json"
            },
            body: JSON.stringify(data)
        });
    } catch (error) {
        console.error(error);
    }
};
const $8149f886a66cd959$export$b20f6289855f1000 = async (id)=>{
    try {
        const token = (0, $17f149b88fede922$export$38e1f53b76ec7fed)();
        if (!token) throw "No application token";
        await fetch(`${api.url}/application/${id}/submit`, {
            method: "POST",
            headers: {
                Authorization: `Bearer ${token}`,
                Accept: "application/json",
                "Content-Type": "application/json"
            }
        });
    } catch (error) {
        console.error(error);
    }
};



var $089b8b220739f318$export$641374ffb95bc399;
var $089b8b220739f318$export$d1e5ecbf6a583564;
var $089b8b220739f318$export$6f093cfa640b7166;
var $089b8b220739f318$export$4997ffc0176396a6;
$089b8b220739f318$export$641374ffb95bc399 = `_aRYQq_spinner`;
$089b8b220739f318$export$d1e5ecbf6a583564 = `_aRYQq_spinner-border`;
$089b8b220739f318$export$d1e5ecbf6a583564;
$089b8b220739f318$export$6f093cfa640b7166 = `_aRYQq_text`;
$089b8b220739f318$export$4997ffc0176396a6 = `_aRYQq_wrap`;


const $c8ea150d97ed3449$var$Loader = ()=>{
    return /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsxs)("div", {
        className: $089b8b220739f318$export$4997ffc0176396a6,
        children: [
            /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)("div", {
                className: $089b8b220739f318$export$641374ffb95bc399,
                role: "status",
                children: /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)("span", {
                    className: "sr-only",
                    children: "Loading..."
                })
            }),
            /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)("p", {
                className: $089b8b220739f318$export$6f093cfa640b7166,
                children: "Loading..."
            })
        ]
    });
};
var $c8ea150d97ed3449$export$2e2bcd8739ae039 = $c8ea150d97ed3449$var$Loader;


const $7fc884044a60e38c$var$ApplicationContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4Y8Vu))).createContext();
const $7fc884044a60e38c$var$Provider = ({ id: id, children: children })=>{
    const queryClient = (0, $5bfa3d489cb629a7$export$22e77b9572c4fded)();
    const { data: data, error: error, isLoading: isLoading } = (0, $57c3b87db6e4f350$export$dd0a697e1782aedd)([
        "application",
        id
    ], ()=>(0, $8149f886a66cd959$export$205bc258834dc08)(id));
    const updateMutation = (0, $01ce8e6f2ff7deb7$export$609860bf8b0084c)((0, $8149f886a66cd959$export$df78b02a879196da), {
        onMutate: async (_param)=>{
            var { id: id } = _param, newData = (0, $30c24b3cbf3b0a7a$export$71511d61b312f219)(_param, [
                "id"
            ]);
            await queryClient.cancelQueries([
                "application",
                id
            ]);
            const previous = queryClient.getQueryData([
                "application",
                id
            ]);
            queryClient.setQueryData([
                "application",
                id
            ], (0, $8f44472fa5eb25c0$export$71511d61b312f219)((0, $45c1a8590053a015$export$71511d61b312f219)({}, previous), {
                data: (0, $45c1a8590053a015$export$71511d61b312f219)({}, previous === null || previous === void 0 ? void 0 : previous.data, newData)
            }));
            return {
                previous: previous,
                id: id
            };
        },
        onError: (error, _, context)=>{
            if (error) console.error(error);
            queryClient.setQueryData([
                "application",
                context.id
            ], context.previous);
        },
        onSettled: (_, error, context)=>{
            if (error) console.error(error);
            queryClient.invalidateQueries([
                "application",
                context.id
            ]);
        }
    });
    const onUpdate = (data)=>{
        updateMutation.mutate((0, $45c1a8590053a015$export$71511d61b312f219)({
            id: id
        }, data));
    };
    const onSubmit = async ()=>{
        await (0, $8149f886a66cd959$export$b20f6289855f1000)(id);
        window.location.replace("/thanks/");
    };
    if (isLoading) return /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)((0, $c8ea150d97ed3449$export$2e2bcd8739ae039), {});
    if (error || (data === null || data === void 0 ? void 0 : data.code)) return /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)("p", {
        children: "We are unable to take online applications at the moment."
    });
    return /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)($7fc884044a60e38c$var$ApplicationContext.Provider, {
        value: {
            id: id,
            data: (data === null || data === void 0 ? void 0 : data.data) || null,
            onUpdate: onUpdate,
            onSubmit: onSubmit
        },
        children: children
    });
};
const $7fc884044a60e38c$export$aaf75bb403fe1fb5 = ()=>(0, $4Y8Vu.useContext)($7fc884044a60e38c$var$ApplicationContext);
var $7fc884044a60e38c$export$2e2bcd8739ae039 = $7fc884044a60e38c$var$Provider;





var $4Y8Vu = parcelRequire("4Y8Vu");
const $71113b02d2c3a867$export$31f4a6fd27e146da = {
    PersonalDetails: 1,
    EqualOpportunities: 2,
    EducationHistory: 3,
    MoreAboutYou: 4,
    Declaration: 5
};
const $71113b02d2c3a867$export$be3f796aed065412 = [
    {
        step: $71113b02d2c3a867$export$31f4a6fd27e146da.PersonalDetails,
        name: "Personal Details"
    },
    {
        step: $71113b02d2c3a867$export$31f4a6fd27e146da.EqualOpportunities,
        name: "Equal Opportunities"
    },
    {
        step: $71113b02d2c3a867$export$31f4a6fd27e146da.EducationHistory,
        name: "Education History"
    },
    {
        step: $71113b02d2c3a867$export$31f4a6fd27e146da.MoreAboutYou,
        name: "More About You"
    },
    {
        step: $71113b02d2c3a867$export$31f4a6fd27e146da.Declaration,
        name: "Declaration"
    }
];
const $71113b02d2c3a867$export$81183a123171043b = (data)=>{
    if (data === null || data === void 0 ? void 0 : data.ApplicationUserDefined12) return $71113b02d2c3a867$export$31f4a6fd27e146da.Declaration;
    if (data === null || data === void 0 ? void 0 : data.StillAtLastSchool) return $71113b02d2c3a867$export$31f4a6fd27e146da.MoreAboutYou;
    if (data === null || data === void 0 ? void 0 : data.CriminalConvictionID) return $71113b02d2c3a867$export$31f4a6fd27e146da.EducationHistory;
    if (data === null || data === void 0 ? void 0 : data.FirstForename) return $71113b02d2c3a867$export$31f4a6fd27e146da.EqualOpportunities;
    return $71113b02d2c3a867$export$31f4a6fd27e146da.PersonalDetails;
};




function $747032d831df0173$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) for(t = 0; t < e.length; t++)e[t] && (f = $747032d831df0173$var$r(e[t])) && (n && (n += " "), n += f);
        else for(t in e)e[t] && (n && (n += " "), n += t);
    }
    return n;
}
function $747032d831df0173$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = ""; f < arguments.length;)(e = arguments[f++]) && (t = $747032d831df0173$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $747032d831df0173$export$2e2bcd8739ae039 = $747032d831df0173$export$4f5d2d50c9deca37;


const $27aa04694c091085$var$Navigation = ({ activeStep: activeStep, maxPossibleStep: maxPossibleStep, steps: steps, onChange: onChange })=>{
    return /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)("section", {
        className: "tabs is-detached is-first has-text-align-center",
        children: /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)("nav", {
            className: "tabs-nav",
            children: /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)("ul", {
                className: "nav-items",
                role: "tablist",
                children: steps.map(({ step: step, name: name }, index)=>/*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)("li", {
                        className: "nav-item",
                        role: "presentation",
                        children: /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)("button", {
                            type: "button",
                            onClick: ()=>onChange(step),
                            className: (0, $747032d831df0173$export$2e2bcd8739ae039)("nav-link", activeStep === step && "is-active"),
                            disabled: step > maxPossibleStep,
                            role: "tab",
                            children: name
                        })
                    }, `step-${index}`))
            })
        })
    });
};
var $27aa04694c091085$export$2e2bcd8739ae039 = $27aa04694c091085$var$Navigation;




var $4Y8Vu = parcelRequire("4Y8Vu");





var $4Y8Vu = parcelRequire("4Y8Vu");
var $89763f9db12fbe81$var$isCheckBoxInput = (element)=>element.type === 'checkbox';
var $89763f9db12fbe81$var$isDateObject = (value1)=>value1 instanceof Date;
var $89763f9db12fbe81$var$isNullOrUndefined = (value1)=>value1 == null;
const $89763f9db12fbe81$var$isObjectType = (value1)=>typeof value1 === 'object';
var $89763f9db12fbe81$var$isObject = (value1)=>!$89763f9db12fbe81$var$isNullOrUndefined(value1) && !Array.isArray(value1) && $89763f9db12fbe81$var$isObjectType(value1) && !$89763f9db12fbe81$var$isDateObject(value1);
var $89763f9db12fbe81$var$getEventValue = (event)=>$89763f9db12fbe81$var$isObject(event) && event.target ? $89763f9db12fbe81$var$isCheckBoxInput(event.target) ? event.target.checked : event.target.value : event;
var $89763f9db12fbe81$var$getNodeParentName = (name)=>name.substring(0, name.search(/\.\d+(\.|$)/)) || name;
var $89763f9db12fbe81$var$isNameInFieldArray = (names, name)=>names.has($89763f9db12fbe81$var$getNodeParentName(name));
var $89763f9db12fbe81$var$isPlainObject = (tempObject)=>{
    const prototypeCopy = tempObject.constructor && tempObject.constructor.prototype;
    return $89763f9db12fbe81$var$isObject(prototypeCopy) && prototypeCopy.hasOwnProperty('isPrototypeOf');
};
var $89763f9db12fbe81$var$isWeb = typeof window !== 'undefined' && typeof window.HTMLElement !== 'undefined' && typeof document !== 'undefined';
function $89763f9db12fbe81$var$cloneObject(data) {
    let copy;
    const isArray = Array.isArray(data);
    const isFileListInstance = typeof FileList !== 'undefined' ? data instanceof FileList : false;
    if (data instanceof Date) copy = new Date(data);
    else if (data instanceof Set) copy = new Set(data);
    else if (!($89763f9db12fbe81$var$isWeb && (data instanceof Blob || isFileListInstance)) && (isArray || $89763f9db12fbe81$var$isObject(data))) {
        copy = isArray ? [] : {};
        if (!isArray && !$89763f9db12fbe81$var$isPlainObject(data)) copy = data;
        else {
            for(const key in data)if (data.hasOwnProperty(key)) copy[key] = $89763f9db12fbe81$var$cloneObject(data[key]);
        }
    } else return data;
    return copy;
}
var $89763f9db12fbe81$var$compact = (value1)=>Array.isArray(value1) ? value1.filter(Boolean) : [];
var $89763f9db12fbe81$var$isUndefined = (val)=>val === undefined;
var $89763f9db12fbe81$export$3988ae62b71be9a3 = (object, path, defaultValue)=>{
    if (!path || !$89763f9db12fbe81$var$isObject(object)) return defaultValue;
    const result = $89763f9db12fbe81$var$compact(path.split(/[,[\].]+?/)).reduce((result, key)=>$89763f9db12fbe81$var$isNullOrUndefined(result) ? result : result[key], object);
    return $89763f9db12fbe81$var$isUndefined(result) || result === object ? $89763f9db12fbe81$var$isUndefined(object[path]) ? defaultValue : object[path] : result;
};
var $89763f9db12fbe81$var$isBoolean = (value1)=>typeof value1 === 'boolean';
var $89763f9db12fbe81$var$isKey = (value1)=>/^\w*$/.test(value1);
var $89763f9db12fbe81$var$stringToPath = (input)=>$89763f9db12fbe81$var$compact(input.replace(/["|']|\]/g, '').split(/\.|\[/));
var $89763f9db12fbe81$export$adaa4cf7ef1b65be = (object, path, value1)=>{
    let index = -1;
    const tempPath = $89763f9db12fbe81$var$isKey(path) ? [
        path
    ] : $89763f9db12fbe81$var$stringToPath(path);
    const length = tempPath.length;
    const lastIndex = length - 1;
    while(++index < length){
        const key = tempPath[index];
        let newValue = value1;
        if (index !== lastIndex) {
            const objValue = object[key];
            newValue = $89763f9db12fbe81$var$isObject(objValue) || Array.isArray(objValue) ? objValue : !isNaN(+tempPath[index + 1]) ? [] : {};
        }
        if (key === '__proto__' || key === 'constructor' || key === 'prototype') return;
        object[key] = newValue;
        object = object[key];
    }
};
const $89763f9db12fbe81$var$EVENTS = {
    BLUR: 'blur',
    FOCUS_OUT: 'focusout',
    CHANGE: 'change'
};
const $89763f9db12fbe81$var$VALIDATION_MODE = {
    onBlur: 'onBlur',
    onChange: 'onChange',
    onSubmit: 'onSubmit',
    onTouched: 'onTouched',
    all: 'all'
};
const $89763f9db12fbe81$var$INPUT_VALIDATION_RULES = {
    max: 'max',
    min: 'min',
    maxLength: 'maxLength',
    minLength: 'minLength',
    pattern: 'pattern',
    required: 'required',
    validate: 'validate'
};
const $89763f9db12fbe81$var$HookFormContext = (0, (/*@__PURE__*/$parcel$interopDefault($4Y8Vu))).createContext(null);
/**
 * This custom hook allows you to access the form context. useFormContext is intended to be used in deeply nested structures, where it would become inconvenient to pass the context as a prop. To be used with {@link FormProvider}.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/useformcontext) • [Demo](https://codesandbox.io/s/react-hook-form-v7-form-context-ytudi)
 *
 * @returns return all useForm methods
 *
 * @example
 * ```tsx
 * function App() {
 *   const methods = useForm();
 *   const onSubmit = data => console.log(data);
 *
 *   return (
 *     <FormProvider {...methods} >
 *       <form onSubmit={methods.handleSubmit(onSubmit)}>
 *         <NestedInput />
 *         <input type="submit" />
 *       </form>
 *     </FormProvider>
 *   );
 * }
 *
 *  function NestedInput() {
 *   const { register } = useFormContext(); // retrieve all hook methods
 *   return <input {...register("test")} />;
 * }
 * ```
 */ const $89763f9db12fbe81$export$4d957a5e1be13b03 = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($4Y8Vu))).useContext($89763f9db12fbe81$var$HookFormContext);
/**
 * A provider component that propagates the `useForm` methods to all children components via [React Context](https://reactjs.org/docs/context.html) API. To be used with {@link useFormContext}.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/useformcontext) • [Demo](https://codesandbox.io/s/react-hook-form-v7-form-context-ytudi)
 *
 * @param props - all useForm methods
 *
 * @example
 * ```tsx
 * function App() {
 *   const methods = useForm();
 *   const onSubmit = data => console.log(data);
 *
 *   return (
 *     <FormProvider {...methods} >
 *       <form onSubmit={methods.handleSubmit(onSubmit)}>
 *         <NestedInput />
 *         <input type="submit" />
 *       </form>
 *     </FormProvider>
 *   );
 * }
 *
 *  function NestedInput() {
 *   const { register } = useFormContext(); // retrieve all hook methods
 *   return <input {...register("test")} />;
 * }
 * ```
 */ const $89763f9db12fbe81$export$8ce1ff4f94d08846 = (props)=>{
    const { children: children } = props, data = (0, $30c24b3cbf3b0a7a$export$71511d61b312f219)(props, [
        "children"
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($4Y8Vu))).createElement($89763f9db12fbe81$var$HookFormContext.Provider, {
        value: data
    }, children);
};
var $89763f9db12fbe81$var$getProxyFormState = (formState, control, localProxyFormState, isRoot = true)=>{
    const result = {
        defaultValues: control._defaultValues
    };
    for(const key in formState)Object.defineProperty(result, key, {
        get: ()=>{
            const _key = key;
            if (control._proxyFormState[_key] !== $89763f9db12fbe81$var$VALIDATION_MODE.all) control._proxyFormState[_key] = !isRoot || $89763f9db12fbe81$var$VALIDATION_MODE.all;
            localProxyFormState && (localProxyFormState[_key] = true);
            return formState[_key];
        }
    });
    return result;
};
const $89763f9db12fbe81$var$useIsomorphicLayoutEffect = typeof window !== 'undefined' ? $4Y8Vu.useLayoutEffect : $4Y8Vu.useEffect;
/**
 * This custom hook allows you to subscribe to each form state, and isolate the re-render at the custom hook level. It has its scope in terms of form state subscription, so it would not affect other useFormState and useForm. Using this hook can reduce the re-render impact on large and complex form application.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/useformstate) • [Demo](https://codesandbox.io/s/useformstate-75xly)
 *
 * @param props - include options on specify fields to subscribe. {@link UseFormStateReturn}
 *
 * @example
 * ```tsx
 * function App() {
 *   const { register, handleSubmit, control } = useForm({
 *     defaultValues: {
 *     firstName: "firstName"
 *   }});
 *   const { dirtyFields } = useFormState({
 *     control
 *   });
 *   const onSubmit = (data) => console.log(data);
 *
 *   return (
 *     <form onSubmit={handleSubmit(onSubmit)}>
 *       <input {...register("firstName")} placeholder="First Name" />
 *       {dirtyFields.firstName && <p>Field is dirty.</p>}
 *       <input type="submit" />
 *     </form>
 *   );
 * }
 * ```
 */ function $89763f9db12fbe81$export$606f11b2eb45ecc6(props) {
    const methods = $89763f9db12fbe81$export$4d957a5e1be13b03();
    const { control: control = methods.control, disabled: disabled, name: name, exact: exact } = props || {};
    const [formState, updateFormState] = (0, (/*@__PURE__*/$parcel$interopDefault($4Y8Vu))).useState(control._formState);
    const _localProxyFormState = (0, (/*@__PURE__*/$parcel$interopDefault($4Y8Vu))).useRef({
        isDirty: false,
        isLoading: false,
        dirtyFields: false,
        touchedFields: false,
        validatingFields: false,
        isValidating: false,
        isValid: false,
        errors: false
    });
    $89763f9db12fbe81$var$useIsomorphicLayoutEffect(()=>control._subscribe({
            name: name,
            formState: _localProxyFormState.current,
            exact: exact,
            callback: (formState)=>{
                !disabled && updateFormState((0, $45c1a8590053a015$export$71511d61b312f219)({}, control._formState, formState));
            }
        }), [
        name,
        disabled,
        exact
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($4Y8Vu))).useEffect(()=>{
        _localProxyFormState.current.isValid && control._setValid(true);
    }, [
        control
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($4Y8Vu))).useMemo(()=>$89763f9db12fbe81$var$getProxyFormState(formState, control, _localProxyFormState.current, false), [
        formState,
        control
    ]);
}
var $89763f9db12fbe81$var$isString = (value1)=>typeof value1 === 'string';
var $89763f9db12fbe81$var$generateWatchOutput = (names, _names, formValues, isGlobal, defaultValue)=>{
    if ($89763f9db12fbe81$var$isString(names)) {
        isGlobal && _names.watch.add(names);
        return $89763f9db12fbe81$export$3988ae62b71be9a3(formValues, names, defaultValue);
    }
    if (Array.isArray(names)) return names.map((fieldName)=>(isGlobal && _names.watch.add(fieldName), $89763f9db12fbe81$export$3988ae62b71be9a3(formValues, fieldName)));
    isGlobal && (_names.watchAll = true);
    return formValues;
};
/**
 * Custom hook to subscribe to field change and isolate re-rendering at the component level.
 *
 * @remarks
 *
 * [API](https://react-hook-form.com/docs/usewatch) • [Demo](https://codesandbox.io/s/react-hook-form-v7-ts-usewatch-h9i5e)
 *
 * @example
 * ```tsx
 * const { control } = useForm();
 * const values = useWatch({
 *   name: "fieldName"
 *   control,
 * })
 * ```
 */ function $89763f9db12fbe81$export$3c773aa2b84f29e0(props) {
    const methods = $89763f9db12fbe81$export$4d957a5e1be13b03();
    const { control: control = methods.control, name: name, defaultValue: defaultValue, disabled: disabled, exact: exact } = props || {};
    const _defaultValue = (0, (/*@__PURE__*/$parcel$interopDefault($4Y8Vu))).useRef(defaultValue);
    const [value1, updateValue] = (0, (/*@__PURE__*/$parcel$interopDefault($4Y8Vu))).useState(control._getWatch(name, _defaultValue.current));
    $89763f9db12fbe81$var$useIsomorphicLayoutEffect(()=>control._subscribe({
            name: name,
            formState: {
                values: true
            },
            exact: exact,
            callback: (formState)=>!disabled && updateValue($89763f9db12fbe81$var$generateWatchOutput(name, control._names, formState.values || control._formValues, false, _defaultValue.current))
        }), [
        name,
        control,
        disabled,
        exact
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($4Y8Vu))).useEffect(()=>control._removeUnmounted());
    return value1;
}
/**
 * Custom hook to work with controlled component, this function provide you with both form and field level state. Re-render is isolated at the hook level.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/usecontroller) • [Demo](https://codesandbox.io/s/usecontroller-0o8px)
 *
 * @param props - the path name to the form field value, and validation rules.
 *
 * @returns field properties, field and form state. {@link UseControllerReturn}
 *
 * @example
 * ```tsx
 * function Input(props) {
 *   const { field, fieldState, formState } = useController(props);
 *   return (
 *     <div>
 *       <input {...field} placeholder={props.name} />
 *       <p>{fieldState.isTouched && "Touched"}</p>
 *       <p>{formState.isSubmitted ? "submitted" : ""}</p>
 *     </div>
 *   );
 * }
 * ```
 */ function $89763f9db12fbe81$export$e8c786024a2b0a79(props) {
    const methods = $89763f9db12fbe81$export$4d957a5e1be13b03();
    const { name: name, disabled: disabled, control: control = methods.control, shouldUnregister: shouldUnregister } = props;
    const isArrayField = $89763f9db12fbe81$var$isNameInFieldArray(control._names.array, name);
    const value1 = $89763f9db12fbe81$export$3c773aa2b84f29e0({
        control: control,
        name: name,
        defaultValue: $89763f9db12fbe81$export$3988ae62b71be9a3(control._formValues, name, $89763f9db12fbe81$export$3988ae62b71be9a3(control._defaultValues, name, props.defaultValue)),
        exact: true
    });
    const formState = $89763f9db12fbe81$export$606f11b2eb45ecc6({
        control: control,
        name: name,
        exact: true
    });
    const _props = (0, (/*@__PURE__*/$parcel$interopDefault($4Y8Vu))).useRef(props);
    const _registerProps = (0, (/*@__PURE__*/$parcel$interopDefault($4Y8Vu))).useRef(control.register(name, (0, $45c1a8590053a015$export$71511d61b312f219)((0, $8f44472fa5eb25c0$export$71511d61b312f219)((0, $45c1a8590053a015$export$71511d61b312f219)({}, props.rules), {
        value: value1
    }), $89763f9db12fbe81$var$isBoolean(props.disabled) ? {
        disabled: props.disabled
    } : {})));
    const fieldState = (0, (/*@__PURE__*/$parcel$interopDefault($4Y8Vu))).useMemo(()=>Object.defineProperties({}, {
            invalid: {
                enumerable: true,
                get: ()=>!!$89763f9db12fbe81$export$3988ae62b71be9a3(formState.errors, name)
            },
            isDirty: {
                enumerable: true,
                get: ()=>!!$89763f9db12fbe81$export$3988ae62b71be9a3(formState.dirtyFields, name)
            },
            isTouched: {
                enumerable: true,
                get: ()=>!!$89763f9db12fbe81$export$3988ae62b71be9a3(formState.touchedFields, name)
            },
            isValidating: {
                enumerable: true,
                get: ()=>!!$89763f9db12fbe81$export$3988ae62b71be9a3(formState.validatingFields, name)
            },
            error: {
                enumerable: true,
                get: ()=>$89763f9db12fbe81$export$3988ae62b71be9a3(formState.errors, name)
            }
        }), [
        formState,
        name
    ]);
    const onChange = (0, (/*@__PURE__*/$parcel$interopDefault($4Y8Vu))).useCallback((event)=>_registerProps.current.onChange({
            target: {
                value: $89763f9db12fbe81$var$getEventValue(event),
                name: name
            },
            type: $89763f9db12fbe81$var$EVENTS.CHANGE
        }), [
        name
    ]);
    const onBlur = (0, (/*@__PURE__*/$parcel$interopDefault($4Y8Vu))).useCallback(()=>_registerProps.current.onBlur({
            target: {
                value: $89763f9db12fbe81$export$3988ae62b71be9a3(control._formValues, name),
                name: name
            },
            type: $89763f9db12fbe81$var$EVENTS.BLUR
        }), [
        name,
        control._formValues
    ]);
    const ref = (0, (/*@__PURE__*/$parcel$interopDefault($4Y8Vu))).useCallback((elm)=>{
        const field = $89763f9db12fbe81$export$3988ae62b71be9a3(control._fields, name);
        if (field && elm) field._f.ref = {
            focus: ()=>elm.focus(),
            select: ()=>elm.select(),
            setCustomValidity: (message)=>elm.setCustomValidity(message),
            reportValidity: ()=>elm.reportValidity()
        };
    }, [
        control._fields,
        name
    ]);
    const field = (0, (/*@__PURE__*/$parcel$interopDefault($4Y8Vu))).useMemo(()=>(0, $8f44472fa5eb25c0$export$71511d61b312f219)((0, $45c1a8590053a015$export$71511d61b312f219)({
            name: name,
            value: value1
        }, $89763f9db12fbe81$var$isBoolean(disabled) || formState.disabled ? {
            disabled: formState.disabled || disabled
        } : {}), {
            onChange: onChange,
            onBlur: onBlur,
            ref: ref
        }), [
        name,
        disabled,
        formState.disabled,
        onChange,
        onBlur,
        ref,
        value1
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($4Y8Vu))).useEffect(()=>{
        const _shouldUnregisterField = control._options.shouldUnregister || shouldUnregister;
        control.register(name, (0, $45c1a8590053a015$export$71511d61b312f219)({}, _props.current.rules, $89763f9db12fbe81$var$isBoolean(_props.current.disabled) ? {
            disabled: _props.current.disabled
        } : {}));
        const updateMounted = (name, value1)=>{
            const field = $89763f9db12fbe81$export$3988ae62b71be9a3(control._fields, name);
            if (field && field._f) field._f.mount = value1;
        };
        updateMounted(name, true);
        if (_shouldUnregisterField) {
            const value1 = $89763f9db12fbe81$var$cloneObject($89763f9db12fbe81$export$3988ae62b71be9a3(control._options.defaultValues, name));
            $89763f9db12fbe81$export$adaa4cf7ef1b65be(control._defaultValues, name, value1);
            if ($89763f9db12fbe81$var$isUndefined($89763f9db12fbe81$export$3988ae62b71be9a3(control._formValues, name))) $89763f9db12fbe81$export$adaa4cf7ef1b65be(control._formValues, name, value1);
        }
        !isArrayField && control.register(name);
        return ()=>{
            (isArrayField ? _shouldUnregisterField && !control._state.action : _shouldUnregisterField) ? control.unregister(name) : updateMounted(name, false);
        };
    }, [
        name,
        control,
        isArrayField,
        shouldUnregister
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($4Y8Vu))).useEffect(()=>{
        control._setDisabledField({
            disabled: disabled,
            name: name
        });
    }, [
        disabled,
        name,
        control
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($4Y8Vu))).useMemo(()=>({
            field: field,
            formState: formState,
            fieldState: fieldState
        }), [
        field,
        formState,
        fieldState
    ]);
}
/**
 * Component based on `useController` hook to work with controlled component.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/usecontroller/controller) • [Demo](https://codesandbox.io/s/react-hook-form-v6-controller-ts-jwyzw) • [Video](https://www.youtube.com/watch?v=N2UNk_UCVyA)
 *
 * @param props - the path name to the form field value, and validation rules.
 *
 * @returns provide field handler functions, field and form state.
 *
 * @example
 * ```tsx
 * function App() {
 *   const { control } = useForm<FormValues>({
 *     defaultValues: {
 *       test: ""
 *     }
 *   });
 *
 *   return (
 *     <form>
 *       <Controller
 *         control={control}
 *         name="test"
 *         render={({ field: { onChange, onBlur, value, ref }, formState, fieldState }) => (
 *           <>
 *             <input
 *               onChange={onChange} // send value to hook form
 *               onBlur={onBlur} // notify when input is touched
 *               value={value} // return updated value
 *               ref={ref} // set ref for focus management
 *             />
 *             <p>{formState.isSubmitted ? "submitted" : ""}</p>
 *             <p>{fieldState.isTouched ? "touched" : ""}</p>
 *           </>
 *         )}
 *       />
 *     </form>
 *   );
 * }
 * ```
 */ const $89763f9db12fbe81$export$bd0bf19f25da8474 = (props)=>props.render($89763f9db12fbe81$export$e8c786024a2b0a79(props));
const $89763f9db12fbe81$var$flatten = (obj)=>{
    const output = {};
    for (const key of Object.keys(obj))if ($89763f9db12fbe81$var$isObjectType(obj[key]) && obj[key] !== null) {
        const nested = $89763f9db12fbe81$var$flatten(obj[key]);
        for (const nestedKey of Object.keys(nested))output[`${key}.${nestedKey}`] = nested[nestedKey];
    } else output[key] = obj[key];
    return output;
};
const $89763f9db12fbe81$var$POST_REQUEST = 'post';
/**
 * Form component to manage submission.
 *
 * @param props - to setup submission detail. {@link FormProps}
 *
 * @returns form component or headless render prop.
 *
 * @example
 * ```tsx
 * function App() {
 *   const { control, formState: { errors } } = useForm();
 *
 *   return (
 *     <Form action="/api" control={control}>
 *       <input {...register("name")} />
 *       <p>{errors?.root?.server && 'Server error'}</p>
 *       <button>Submit</button>
 *     </Form>
 *   );
 * }
 * ```
 */ function $89763f9db12fbe81$export$a7fed597f4b8afd8(props) {
    const methods = $89763f9db12fbe81$export$4d957a5e1be13b03();
    const [mounted, setMounted] = (0, (/*@__PURE__*/$parcel$interopDefault($4Y8Vu))).useState(false);
    const { control: control = methods.control, onSubmit: onSubmit, children: children, action: action, method: method = $89763f9db12fbe81$var$POST_REQUEST, headers: headers, encType: encType, onError: onError, render: render, onSuccess: onSuccess, validateStatus: validateStatus } = props, rest = (0, $30c24b3cbf3b0a7a$export$71511d61b312f219)(props, [
        "control",
        "onSubmit",
        "children",
        "action",
        "method",
        "headers",
        "encType",
        "onError",
        "render",
        "onSuccess",
        "validateStatus"
    ]);
    const submit = async (event)=>{
        let hasError = false;
        let type = '';
        await control.handleSubmit(async (data)=>{
            const formData = new FormData();
            let formDataJson = '';
            try {
                formDataJson = JSON.stringify(data);
            } catch (_a) {}
            const flattenFormValues = $89763f9db12fbe81$var$flatten(control._formValues);
            for(const key in flattenFormValues)formData.append(key, flattenFormValues[key]);
            if (onSubmit) await onSubmit({
                data: data,
                event: event,
                method: method,
                formData: formData,
                formDataJson: formDataJson
            });
            if (action) try {
                const shouldStringifySubmissionData = [
                    headers && headers['Content-Type'],
                    encType
                ].some((value1)=>value1 && value1.includes('json'));
                const response = await fetch(String(action), {
                    method: method,
                    headers: (0, $45c1a8590053a015$export$71511d61b312f219)({}, headers, encType ? {
                        'Content-Type': encType
                    } : {}),
                    body: shouldStringifySubmissionData ? formDataJson : formData
                });
                if (response && (validateStatus ? !validateStatus(response.status) : response.status < 200 || response.status >= 300)) {
                    hasError = true;
                    onError && onError({
                        response: response
                    });
                    type = String(response.status);
                } else onSuccess && onSuccess({
                    response: response
                });
            } catch (error) {
                hasError = true;
                onError && onError({
                    error: error
                });
            }
        })(event);
        if (hasError && props.control) {
            props.control._subjects.state.next({
                isSubmitSuccessful: false
            });
            props.control.setError('root.server', {
                type: type
            });
        }
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($4Y8Vu))).useEffect(()=>{
        setMounted(true);
    }, []);
    return render ? (0, (/*@__PURE__*/$parcel$interopDefault($4Y8Vu))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4Y8Vu))).Fragment, null, render({
        submit: submit
    })) : (0, (/*@__PURE__*/$parcel$interopDefault($4Y8Vu))).createElement("form", (0, $45c1a8590053a015$export$71511d61b312f219)({
        noValidate: mounted,
        action: action,
        method: method,
        encType: encType,
        onSubmit: submit
    }, rest), children);
}
var $89763f9db12fbe81$export$b196c2a4f765bd30 = (name, validateAllFieldCriteria, errors, type, message)=>validateAllFieldCriteria ? (0, $8f44472fa5eb25c0$export$71511d61b312f219)((0, $45c1a8590053a015$export$71511d61b312f219)({}, errors[name]), {
        types: (0, $8f44472fa5eb25c0$export$71511d61b312f219)((0, $45c1a8590053a015$export$71511d61b312f219)({}, errors[name] && errors[name].types ? errors[name].types : {}), {
            [type]: message || true
        })
    }) : {};
var $89763f9db12fbe81$var$convertToArrayPayload = (value1)=>Array.isArray(value1) ? value1 : [
        value1
    ];
var $89763f9db12fbe81$var$createSubject = ()=>{
    let _observers = [];
    const next = (value1)=>{
        for (const observer of _observers)observer.next && observer.next(value1);
    };
    const subscribe = (observer)=>{
        _observers.push(observer);
        return {
            unsubscribe: ()=>{
                _observers = _observers.filter((o)=>o !== observer);
            }
        };
    };
    const unsubscribe = ()=>{
        _observers = [];
    };
    return {
        get observers () {
            return _observers;
        },
        next: next,
        subscribe: subscribe,
        unsubscribe: unsubscribe
    };
};
var $89763f9db12fbe81$var$isPrimitive = (value1)=>$89763f9db12fbe81$var$isNullOrUndefined(value1) || !$89763f9db12fbe81$var$isObjectType(value1);
function $89763f9db12fbe81$var$deepEqual(object1, object2) {
    if ($89763f9db12fbe81$var$isPrimitive(object1) || $89763f9db12fbe81$var$isPrimitive(object2)) return object1 === object2;
    if ($89763f9db12fbe81$var$isDateObject(object1) && $89763f9db12fbe81$var$isDateObject(object2)) return object1.getTime() === object2.getTime();
    const keys1 = Object.keys(object1);
    const keys2 = Object.keys(object2);
    if (keys1.length !== keys2.length) return false;
    for (const key of keys1){
        const val1 = object1[key];
        if (!keys2.includes(key)) return false;
        if (key !== 'ref') {
            const val2 = object2[key];
            if ($89763f9db12fbe81$var$isDateObject(val1) && $89763f9db12fbe81$var$isDateObject(val2) || $89763f9db12fbe81$var$isObject(val1) && $89763f9db12fbe81$var$isObject(val2) || Array.isArray(val1) && Array.isArray(val2) ? !$89763f9db12fbe81$var$deepEqual(val1, val2) : val1 !== val2) return false;
        }
    }
    return true;
}
var $89763f9db12fbe81$var$isEmptyObject = (value1)=>$89763f9db12fbe81$var$isObject(value1) && !Object.keys(value1).length;
var $89763f9db12fbe81$var$isFileInput = (element)=>element.type === 'file';
var $89763f9db12fbe81$var$isFunction = (value1)=>typeof value1 === 'function';
var $89763f9db12fbe81$var$isHTMLElement = (value1)=>{
    if (!$89763f9db12fbe81$var$isWeb) return false;
    const owner = value1 ? value1.ownerDocument : 0;
    return value1 instanceof (owner && owner.defaultView ? owner.defaultView.HTMLElement : HTMLElement);
};
var $89763f9db12fbe81$var$isMultipleSelect = (element)=>element.type === `select-multiple`;
var $89763f9db12fbe81$var$isRadioInput = (element)=>element.type === 'radio';
var $89763f9db12fbe81$var$isRadioOrCheckbox = (ref)=>$89763f9db12fbe81$var$isRadioInput(ref) || $89763f9db12fbe81$var$isCheckBoxInput(ref);
var $89763f9db12fbe81$var$live = (ref)=>$89763f9db12fbe81$var$isHTMLElement(ref) && ref.isConnected;
function $89763f9db12fbe81$var$baseGet(object, updatePath) {
    const length = updatePath.slice(0, -1).length;
    let index = 0;
    while(index < length)object = $89763f9db12fbe81$var$isUndefined(object) ? index++ : object[updatePath[index++]];
    return object;
}
function $89763f9db12fbe81$var$isEmptyArray(obj) {
    for(const key in obj){
        if (obj.hasOwnProperty(key) && !$89763f9db12fbe81$var$isUndefined(obj[key])) return false;
    }
    return true;
}
function $89763f9db12fbe81$var$unset(object, path) {
    const paths = Array.isArray(path) ? path : $89763f9db12fbe81$var$isKey(path) ? [
        path
    ] : $89763f9db12fbe81$var$stringToPath(path);
    const childObject = paths.length === 1 ? object : $89763f9db12fbe81$var$baseGet(object, paths);
    const index = paths.length - 1;
    const key = paths[index];
    if (childObject) delete childObject[key];
    if (index !== 0 && ($89763f9db12fbe81$var$isObject(childObject) && $89763f9db12fbe81$var$isEmptyObject(childObject) || Array.isArray(childObject) && $89763f9db12fbe81$var$isEmptyArray(childObject))) $89763f9db12fbe81$var$unset(object, paths.slice(0, -1));
    return object;
}
var $89763f9db12fbe81$var$objectHasFunction = (data)=>{
    for(const key in data){
        if ($89763f9db12fbe81$var$isFunction(data[key])) return true;
    }
    return false;
};
function $89763f9db12fbe81$var$markFieldsDirty(data, fields = {}) {
    const isParentNodeArray = Array.isArray(data);
    if ($89763f9db12fbe81$var$isObject(data) || isParentNodeArray) for(const key in data){
        if (Array.isArray(data[key]) || $89763f9db12fbe81$var$isObject(data[key]) && !$89763f9db12fbe81$var$objectHasFunction(data[key])) {
            fields[key] = Array.isArray(data[key]) ? [] : {};
            $89763f9db12fbe81$var$markFieldsDirty(data[key], fields[key]);
        } else if (!$89763f9db12fbe81$var$isNullOrUndefined(data[key])) fields[key] = true;
    }
    return fields;
}
function $89763f9db12fbe81$var$getDirtyFieldsFromDefaultValues(data, formValues, dirtyFieldsFromValues) {
    const isParentNodeArray = Array.isArray(data);
    if ($89763f9db12fbe81$var$isObject(data) || isParentNodeArray) {
        for(const key in data)if (Array.isArray(data[key]) || $89763f9db12fbe81$var$isObject(data[key]) && !$89763f9db12fbe81$var$objectHasFunction(data[key])) {
            if ($89763f9db12fbe81$var$isUndefined(formValues) || $89763f9db12fbe81$var$isPrimitive(dirtyFieldsFromValues[key])) dirtyFieldsFromValues[key] = Array.isArray(data[key]) ? $89763f9db12fbe81$var$markFieldsDirty(data[key], []) : (0, $45c1a8590053a015$export$71511d61b312f219)({}, $89763f9db12fbe81$var$markFieldsDirty(data[key]));
            else $89763f9db12fbe81$var$getDirtyFieldsFromDefaultValues(data[key], $89763f9db12fbe81$var$isNullOrUndefined(formValues) ? {} : formValues[key], dirtyFieldsFromValues[key]);
        } else dirtyFieldsFromValues[key] = !$89763f9db12fbe81$var$deepEqual(data[key], formValues[key]);
    }
    return dirtyFieldsFromValues;
}
var $89763f9db12fbe81$var$getDirtyFields = (defaultValues, formValues)=>$89763f9db12fbe81$var$getDirtyFieldsFromDefaultValues(defaultValues, formValues, $89763f9db12fbe81$var$markFieldsDirty(formValues));
const $89763f9db12fbe81$var$defaultResult = {
    value: false,
    isValid: false
};
const $89763f9db12fbe81$var$validResult = {
    value: true,
    isValid: true
};
var $89763f9db12fbe81$var$getCheckboxValue = (options)=>{
    if (Array.isArray(options)) {
        if (options.length > 1) {
            const values = options.filter((option)=>option && option.checked && !option.disabled).map((option)=>option.value);
            return {
                value: values,
                isValid: !!values.length
            };
        }
        return options[0].checked && !options[0].disabled ? options[0].attributes && !$89763f9db12fbe81$var$isUndefined(options[0].attributes.value) ? $89763f9db12fbe81$var$isUndefined(options[0].value) || options[0].value === '' ? $89763f9db12fbe81$var$validResult : {
            value: options[0].value,
            isValid: true
        } : $89763f9db12fbe81$var$validResult : $89763f9db12fbe81$var$defaultResult;
    }
    return $89763f9db12fbe81$var$defaultResult;
};
var $89763f9db12fbe81$var$getFieldValueAs = (value1, { valueAsNumber: valueAsNumber, valueAsDate: valueAsDate, setValueAs: setValueAs })=>$89763f9db12fbe81$var$isUndefined(value1) ? value1 : valueAsNumber ? value1 === '' ? NaN : value1 ? +value1 : value1 : valueAsDate && $89763f9db12fbe81$var$isString(value1) ? new Date(value1) : setValueAs ? setValueAs(value1) : value1;
const $89763f9db12fbe81$var$defaultReturn = {
    isValid: false,
    value: null
};
var $89763f9db12fbe81$var$getRadioValue = (options)=>Array.isArray(options) ? options.reduce((previous, option)=>option && option.checked && !option.disabled ? {
            isValid: true,
            value: option.value
        } : previous, $89763f9db12fbe81$var$defaultReturn) : $89763f9db12fbe81$var$defaultReturn;
function $89763f9db12fbe81$var$getFieldValue(_f) {
    const ref = _f.ref;
    if ($89763f9db12fbe81$var$isFileInput(ref)) return ref.files;
    if ($89763f9db12fbe81$var$isRadioInput(ref)) return $89763f9db12fbe81$var$getRadioValue(_f.refs).value;
    if ($89763f9db12fbe81$var$isMultipleSelect(ref)) return [
        ...ref.selectedOptions
    ].map(({ value: value1 })=>value1);
    if ($89763f9db12fbe81$var$isCheckBoxInput(ref)) return $89763f9db12fbe81$var$getCheckboxValue(_f.refs).value;
    return $89763f9db12fbe81$var$getFieldValueAs($89763f9db12fbe81$var$isUndefined(ref.value) ? _f.ref.value : ref.value, _f);
}
var $89763f9db12fbe81$var$getResolverOptions = (fieldsNames, _fields, criteriaMode, shouldUseNativeValidation)=>{
    const fields = {};
    for (const name of fieldsNames){
        const field = $89763f9db12fbe81$export$3988ae62b71be9a3(_fields, name);
        field && $89763f9db12fbe81$export$adaa4cf7ef1b65be(fields, name, field._f);
    }
    return {
        criteriaMode: criteriaMode,
        names: [
            ...fieldsNames
        ],
        fields: fields,
        shouldUseNativeValidation: shouldUseNativeValidation
    };
};
var $89763f9db12fbe81$var$isRegex = (value1)=>value1 instanceof RegExp;
var $89763f9db12fbe81$var$getRuleValue = (rule)=>$89763f9db12fbe81$var$isUndefined(rule) ? rule : $89763f9db12fbe81$var$isRegex(rule) ? rule.source : $89763f9db12fbe81$var$isObject(rule) ? $89763f9db12fbe81$var$isRegex(rule.value) ? rule.value.source : rule.value : rule;
var $89763f9db12fbe81$var$getValidationModes = (mode)=>({
        isOnSubmit: !mode || mode === $89763f9db12fbe81$var$VALIDATION_MODE.onSubmit,
        isOnBlur: mode === $89763f9db12fbe81$var$VALIDATION_MODE.onBlur,
        isOnChange: mode === $89763f9db12fbe81$var$VALIDATION_MODE.onChange,
        isOnAll: mode === $89763f9db12fbe81$var$VALIDATION_MODE.all,
        isOnTouch: mode === $89763f9db12fbe81$var$VALIDATION_MODE.onTouched
    });
const $89763f9db12fbe81$var$ASYNC_FUNCTION = 'AsyncFunction';
var $89763f9db12fbe81$var$hasPromiseValidation = (fieldReference)=>!!fieldReference && !!fieldReference.validate && !!($89763f9db12fbe81$var$isFunction(fieldReference.validate) && fieldReference.validate.constructor.name === $89763f9db12fbe81$var$ASYNC_FUNCTION || $89763f9db12fbe81$var$isObject(fieldReference.validate) && Object.values(fieldReference.validate).find((validateFunction)=>validateFunction.constructor.name === $89763f9db12fbe81$var$ASYNC_FUNCTION));
var $89763f9db12fbe81$var$hasValidation = (options)=>options.mount && (options.required || options.min || options.max || options.maxLength || options.minLength || options.pattern || options.validate);
var $89763f9db12fbe81$var$isWatched = (name, _names, isBlurEvent)=>!isBlurEvent && (_names.watchAll || _names.watch.has(name) || [
        ..._names.watch
    ].some((watchName)=>name.startsWith(watchName) && /^\.\w+/.test(name.slice(watchName.length))));
const $89763f9db12fbe81$var$iterateFieldsByAction = (fields, action, fieldsNames, abortEarly)=>{
    for (const _ref of fieldsNames || Object.keys(fields)){
        let key = _ref;
        const field = $89763f9db12fbe81$export$3988ae62b71be9a3(fields, key);
        if (field) {
            const { _f: _f } = field, currentField = (0, $30c24b3cbf3b0a7a$export$71511d61b312f219)(field, [
                "_f"
            ]);
            if (_f) {
                if (_f.refs && _f.refs[0] && action(_f.refs[0], key) && !abortEarly) return true;
                else if (_f.ref && action(_f.ref, _f.name) && !abortEarly) return true;
                else {
                    if ($89763f9db12fbe81$var$iterateFieldsByAction(currentField, action)) break;
                }
            } else if ($89763f9db12fbe81$var$isObject(currentField)) {
                if ($89763f9db12fbe81$var$iterateFieldsByAction(currentField, action)) break;
            }
        }
    }
    return;
};
function $89763f9db12fbe81$var$schemaErrorLookup(errors, _fields, name) {
    const error = $89763f9db12fbe81$export$3988ae62b71be9a3(errors, name);
    if (error || $89763f9db12fbe81$var$isKey(name)) return {
        error: error,
        name: name
    };
    const names = name.split('.');
    while(names.length){
        const fieldName = names.join('.');
        const field = $89763f9db12fbe81$export$3988ae62b71be9a3(_fields, fieldName);
        const foundError = $89763f9db12fbe81$export$3988ae62b71be9a3(errors, fieldName);
        if (field && !Array.isArray(field) && name !== fieldName) return {
            name: name
        };
        if (foundError && foundError.type) return {
            name: fieldName,
            error: foundError
        };
        names.pop();
    }
    return {
        name: name
    };
}
var $89763f9db12fbe81$var$shouldRenderFormState = (formStateData, _proxyFormState, updateFormState, isRoot)=>{
    updateFormState(formStateData);
    const { name: name } = formStateData, formState = (0, $30c24b3cbf3b0a7a$export$71511d61b312f219)(formStateData, [
        "name"
    ]);
    return $89763f9db12fbe81$var$isEmptyObject(formState) || Object.keys(formState).length >= Object.keys(_proxyFormState).length || Object.keys(formState).find((key)=>_proxyFormState[key] === (!isRoot || $89763f9db12fbe81$var$VALIDATION_MODE.all));
};
var $89763f9db12fbe81$var$shouldSubscribeByName = (name, signalName, exact)=>!name || !signalName || name === signalName || $89763f9db12fbe81$var$convertToArrayPayload(name).some((currentName)=>currentName && (exact ? currentName === signalName : currentName.startsWith(signalName) || signalName.startsWith(currentName)));
var $89763f9db12fbe81$var$skipValidation = (isBlurEvent, isTouched, isSubmitted, reValidateMode, mode)=>{
    if (mode.isOnAll) return false;
    else if (!isSubmitted && mode.isOnTouch) return !(isTouched || isBlurEvent);
    else if (isSubmitted ? reValidateMode.isOnBlur : mode.isOnBlur) return !isBlurEvent;
    else if (isSubmitted ? reValidateMode.isOnChange : mode.isOnChange) return isBlurEvent;
    return true;
};
var $89763f9db12fbe81$var$unsetEmptyArray = (ref, name)=>!$89763f9db12fbe81$var$compact($89763f9db12fbe81$export$3988ae62b71be9a3(ref, name)).length && $89763f9db12fbe81$var$unset(ref, name);
var $89763f9db12fbe81$var$updateFieldArrayRootError = (errors, error, name)=>{
    const fieldArrayErrors = $89763f9db12fbe81$var$convertToArrayPayload($89763f9db12fbe81$export$3988ae62b71be9a3(errors, name));
    $89763f9db12fbe81$export$adaa4cf7ef1b65be(fieldArrayErrors, 'root', error[name]);
    $89763f9db12fbe81$export$adaa4cf7ef1b65be(errors, name, fieldArrayErrors);
    return errors;
};
var $89763f9db12fbe81$var$isMessage = (value1)=>$89763f9db12fbe81$var$isString(value1);
function $89763f9db12fbe81$var$getValidateError(result, ref, type = 'validate') {
    if ($89763f9db12fbe81$var$isMessage(result) || Array.isArray(result) && result.every($89763f9db12fbe81$var$isMessage) || $89763f9db12fbe81$var$isBoolean(result) && !result) return {
        type: type,
        message: $89763f9db12fbe81$var$isMessage(result) ? result : '',
        ref: ref
    };
}
var $89763f9db12fbe81$var$getValueAndMessage = (validationData)=>$89763f9db12fbe81$var$isObject(validationData) && !$89763f9db12fbe81$var$isRegex(validationData) ? validationData : {
        value: validationData,
        message: ''
    };
var $89763f9db12fbe81$var$validateField = async (field, disabledFieldNames, formValues, validateAllFieldCriteria, shouldUseNativeValidation, isFieldArray)=>{
    const { ref: ref, refs: refs, required: required, maxLength: maxLength, minLength: minLength, min: min, max: max, pattern: pattern, validate: validate, name: name, valueAsNumber: valueAsNumber, mount: mount } = field._f;
    const inputValue = $89763f9db12fbe81$export$3988ae62b71be9a3(formValues, name);
    if (!mount || disabledFieldNames.has(name)) return {};
    const inputRef = refs ? refs[0] : ref;
    const setCustomValidity = (message)=>{
        if (shouldUseNativeValidation && inputRef.reportValidity) {
            inputRef.setCustomValidity($89763f9db12fbe81$var$isBoolean(message) ? '' : message || '');
            inputRef.reportValidity();
        }
    };
    const error = {};
    const isRadio = $89763f9db12fbe81$var$isRadioInput(ref);
    const isCheckBox = $89763f9db12fbe81$var$isCheckBoxInput(ref);
    const isRadioOrCheckbox = isRadio || isCheckBox;
    const isEmpty = (valueAsNumber || $89763f9db12fbe81$var$isFileInput(ref)) && $89763f9db12fbe81$var$isUndefined(ref.value) && $89763f9db12fbe81$var$isUndefined(inputValue) || $89763f9db12fbe81$var$isHTMLElement(ref) && ref.value === '' || inputValue === '' || Array.isArray(inputValue) && !inputValue.length;
    const appendErrorsCurry = $89763f9db12fbe81$export$b196c2a4f765bd30.bind(null, name, validateAllFieldCriteria, error);
    const getMinMaxMessage = (exceedMax, maxLengthMessage, minLengthMessage, maxType = $89763f9db12fbe81$var$INPUT_VALIDATION_RULES.maxLength, minType = $89763f9db12fbe81$var$INPUT_VALIDATION_RULES.minLength)=>{
        const message = exceedMax ? maxLengthMessage : minLengthMessage;
        error[name] = (0, $45c1a8590053a015$export$71511d61b312f219)({
            type: exceedMax ? maxType : minType,
            message: message,
            ref: ref
        }, appendErrorsCurry(exceedMax ? maxType : minType, message));
    };
    if (isFieldArray ? !Array.isArray(inputValue) || !inputValue.length : required && (!isRadioOrCheckbox && (isEmpty || $89763f9db12fbe81$var$isNullOrUndefined(inputValue)) || $89763f9db12fbe81$var$isBoolean(inputValue) && !inputValue || isCheckBox && !$89763f9db12fbe81$var$getCheckboxValue(refs).isValid || isRadio && !$89763f9db12fbe81$var$getRadioValue(refs).isValid)) {
        const { value: value1, message: message } = $89763f9db12fbe81$var$isMessage(required) ? {
            value: !!required,
            message: required
        } : $89763f9db12fbe81$var$getValueAndMessage(required);
        if (value1) {
            error[name] = (0, $45c1a8590053a015$export$71511d61b312f219)({
                type: $89763f9db12fbe81$var$INPUT_VALIDATION_RULES.required,
                message: message,
                ref: inputRef
            }, appendErrorsCurry($89763f9db12fbe81$var$INPUT_VALIDATION_RULES.required, message));
            if (!validateAllFieldCriteria) {
                setCustomValidity(message);
                return error;
            }
        }
    }
    if (!isEmpty && (!$89763f9db12fbe81$var$isNullOrUndefined(min) || !$89763f9db12fbe81$var$isNullOrUndefined(max))) {
        let exceedMax;
        let exceedMin;
        const maxOutput = $89763f9db12fbe81$var$getValueAndMessage(max);
        const minOutput = $89763f9db12fbe81$var$getValueAndMessage(min);
        if (!$89763f9db12fbe81$var$isNullOrUndefined(inputValue) && !isNaN(inputValue)) {
            const valueNumber = ref.valueAsNumber || (inputValue ? +inputValue : inputValue);
            if (!$89763f9db12fbe81$var$isNullOrUndefined(maxOutput.value)) exceedMax = valueNumber > maxOutput.value;
            if (!$89763f9db12fbe81$var$isNullOrUndefined(minOutput.value)) exceedMin = valueNumber < minOutput.value;
        } else {
            const valueDate = ref.valueAsDate || new Date(inputValue);
            const convertTimeToDate = (time)=>new Date(new Date().toDateString() + ' ' + time);
            const isTime = ref.type == 'time';
            const isWeek = ref.type == 'week';
            if ($89763f9db12fbe81$var$isString(maxOutput.value) && inputValue) exceedMax = isTime ? convertTimeToDate(inputValue) > convertTimeToDate(maxOutput.value) : isWeek ? inputValue > maxOutput.value : valueDate > new Date(maxOutput.value);
            if ($89763f9db12fbe81$var$isString(minOutput.value) && inputValue) exceedMin = isTime ? convertTimeToDate(inputValue) < convertTimeToDate(minOutput.value) : isWeek ? inputValue < minOutput.value : valueDate < new Date(minOutput.value);
        }
        if (exceedMax || exceedMin) {
            getMinMaxMessage(!!exceedMax, maxOutput.message, minOutput.message, $89763f9db12fbe81$var$INPUT_VALIDATION_RULES.max, $89763f9db12fbe81$var$INPUT_VALIDATION_RULES.min);
            if (!validateAllFieldCriteria) {
                setCustomValidity(error[name].message);
                return error;
            }
        }
    }
    if ((maxLength || minLength) && !isEmpty && ($89763f9db12fbe81$var$isString(inputValue) || isFieldArray && Array.isArray(inputValue))) {
        const maxLengthOutput = $89763f9db12fbe81$var$getValueAndMessage(maxLength);
        const minLengthOutput = $89763f9db12fbe81$var$getValueAndMessage(minLength);
        const exceedMax = !$89763f9db12fbe81$var$isNullOrUndefined(maxLengthOutput.value) && inputValue.length > +maxLengthOutput.value;
        const exceedMin = !$89763f9db12fbe81$var$isNullOrUndefined(minLengthOutput.value) && inputValue.length < +minLengthOutput.value;
        if (exceedMax || exceedMin) {
            getMinMaxMessage(exceedMax, maxLengthOutput.message, minLengthOutput.message);
            if (!validateAllFieldCriteria) {
                setCustomValidity(error[name].message);
                return error;
            }
        }
    }
    if (pattern && !isEmpty && $89763f9db12fbe81$var$isString(inputValue)) {
        const { value: patternValue, message: message } = $89763f9db12fbe81$var$getValueAndMessage(pattern);
        if ($89763f9db12fbe81$var$isRegex(patternValue) && !inputValue.match(patternValue)) {
            error[name] = (0, $45c1a8590053a015$export$71511d61b312f219)({
                type: $89763f9db12fbe81$var$INPUT_VALIDATION_RULES.pattern,
                message: message,
                ref: ref
            }, appendErrorsCurry($89763f9db12fbe81$var$INPUT_VALIDATION_RULES.pattern, message));
            if (!validateAllFieldCriteria) {
                setCustomValidity(message);
                return error;
            }
        }
    }
    if (validate) {
        if ($89763f9db12fbe81$var$isFunction(validate)) {
            const result = await validate(inputValue, formValues);
            const validateError = $89763f9db12fbe81$var$getValidateError(result, inputRef);
            if (validateError) {
                error[name] = (0, $45c1a8590053a015$export$71511d61b312f219)({}, validateError, appendErrorsCurry($89763f9db12fbe81$var$INPUT_VALIDATION_RULES.validate, validateError.message));
                if (!validateAllFieldCriteria) {
                    setCustomValidity(validateError.message);
                    return error;
                }
            }
        } else if ($89763f9db12fbe81$var$isObject(validate)) {
            let validationResult = {};
            for(const key in validate){
                if (!$89763f9db12fbe81$var$isEmptyObject(validationResult) && !validateAllFieldCriteria) break;
                const validateError = $89763f9db12fbe81$var$getValidateError(await validate[key](inputValue, formValues), inputRef, key);
                if (validateError) {
                    validationResult = (0, $45c1a8590053a015$export$71511d61b312f219)({}, validateError, appendErrorsCurry(key, validateError.message));
                    setCustomValidity(validateError.message);
                    if (validateAllFieldCriteria) error[name] = validationResult;
                }
            }
            if (!$89763f9db12fbe81$var$isEmptyObject(validationResult)) {
                error[name] = (0, $45c1a8590053a015$export$71511d61b312f219)({
                    ref: inputRef
                }, validationResult);
                if (!validateAllFieldCriteria) return error;
            }
        }
    }
    setCustomValidity(true);
    return error;
};
const $89763f9db12fbe81$var$defaultOptions = {
    mode: $89763f9db12fbe81$var$VALIDATION_MODE.onSubmit,
    reValidateMode: $89763f9db12fbe81$var$VALIDATION_MODE.onChange,
    shouldFocusError: true
};
function $89763f9db12fbe81$export$1361f5e0e4cca3c3(props = {}) {
    let _options = (0, $45c1a8590053a015$export$71511d61b312f219)({}, $89763f9db12fbe81$var$defaultOptions, props);
    let _formState = {
        submitCount: 0,
        isDirty: false,
        isReady: false,
        isLoading: $89763f9db12fbe81$var$isFunction(_options.defaultValues),
        isValidating: false,
        isSubmitted: false,
        isSubmitting: false,
        isSubmitSuccessful: false,
        isValid: false,
        touchedFields: {},
        dirtyFields: {},
        validatingFields: {},
        errors: _options.errors || {},
        disabled: _options.disabled || false
    };
    const _fields = {};
    let _defaultValues = $89763f9db12fbe81$var$isObject(_options.defaultValues) || $89763f9db12fbe81$var$isObject(_options.values) ? $89763f9db12fbe81$var$cloneObject(_options.defaultValues || _options.values) || {} : {};
    let _formValues = _options.shouldUnregister ? {} : $89763f9db12fbe81$var$cloneObject(_defaultValues);
    let _state = {
        action: false,
        mount: false,
        watch: false
    };
    let _names = {
        mount: new Set(),
        disabled: new Set(),
        unMount: new Set(),
        array: new Set(),
        watch: new Set()
    };
    let delayErrorCallback;
    let timer = 0;
    const _proxyFormState = {
        isDirty: false,
        dirtyFields: false,
        validatingFields: false,
        touchedFields: false,
        isValidating: false,
        isValid: false,
        errors: false
    };
    let _proxySubscribeFormState = (0, $45c1a8590053a015$export$71511d61b312f219)({}, _proxyFormState);
    const _subjects = {
        array: $89763f9db12fbe81$var$createSubject(),
        state: $89763f9db12fbe81$var$createSubject()
    };
    const validationModeBeforeSubmit = $89763f9db12fbe81$var$getValidationModes(_options.mode);
    const validationModeAfterSubmit = $89763f9db12fbe81$var$getValidationModes(_options.reValidateMode);
    const shouldDisplayAllAssociatedErrors = _options.criteriaMode === $89763f9db12fbe81$var$VALIDATION_MODE.all;
    const debounce = (callback)=>(wait)=>{
            clearTimeout(timer);
            timer = setTimeout(callback, wait);
        };
    const _setValid = async (shouldUpdateValid)=>{
        if (!_options.disabled && (_proxyFormState.isValid || _proxySubscribeFormState.isValid || shouldUpdateValid)) {
            const isValid = _options.resolver ? $89763f9db12fbe81$var$isEmptyObject((await _runSchema()).errors) : await executeBuiltInValidation(_fields, true);
            if (isValid !== _formState.isValid) _subjects.state.next({
                isValid: isValid
            });
        }
    };
    const _updateIsValidating = (names, isValidating)=>{
        if (!_options.disabled && (_proxyFormState.isValidating || _proxyFormState.validatingFields || _proxySubscribeFormState.isValidating || _proxySubscribeFormState.validatingFields)) {
            (names || Array.from(_names.mount)).forEach((name)=>{
                if (name) isValidating ? $89763f9db12fbe81$export$adaa4cf7ef1b65be(_formState.validatingFields, name, isValidating) : $89763f9db12fbe81$var$unset(_formState.validatingFields, name);
            });
            _subjects.state.next({
                validatingFields: _formState.validatingFields,
                isValidating: !$89763f9db12fbe81$var$isEmptyObject(_formState.validatingFields)
            });
        }
    };
    const _setFieldArray = (name, values = [], method, args, shouldSetValues = true, shouldUpdateFieldsAndState = true)=>{
        if (args && method && !_options.disabled) {
            _state.action = true;
            if (shouldUpdateFieldsAndState && Array.isArray($89763f9db12fbe81$export$3988ae62b71be9a3(_fields, name))) {
                const fieldValues = method($89763f9db12fbe81$export$3988ae62b71be9a3(_fields, name), args.argA, args.argB);
                shouldSetValues && $89763f9db12fbe81$export$adaa4cf7ef1b65be(_fields, name, fieldValues);
            }
            if (shouldUpdateFieldsAndState && Array.isArray($89763f9db12fbe81$export$3988ae62b71be9a3(_formState.errors, name))) {
                const errors = method($89763f9db12fbe81$export$3988ae62b71be9a3(_formState.errors, name), args.argA, args.argB);
                shouldSetValues && $89763f9db12fbe81$export$adaa4cf7ef1b65be(_formState.errors, name, errors);
                $89763f9db12fbe81$var$unsetEmptyArray(_formState.errors, name);
            }
            if ((_proxyFormState.touchedFields || _proxySubscribeFormState.touchedFields) && shouldUpdateFieldsAndState && Array.isArray($89763f9db12fbe81$export$3988ae62b71be9a3(_formState.touchedFields, name))) {
                const touchedFields = method($89763f9db12fbe81$export$3988ae62b71be9a3(_formState.touchedFields, name), args.argA, args.argB);
                shouldSetValues && $89763f9db12fbe81$export$adaa4cf7ef1b65be(_formState.touchedFields, name, touchedFields);
            }
            if (_proxyFormState.dirtyFields || _proxySubscribeFormState.dirtyFields) _formState.dirtyFields = $89763f9db12fbe81$var$getDirtyFields(_defaultValues, _formValues);
            _subjects.state.next({
                name: name,
                isDirty: _getDirty(name, values),
                dirtyFields: _formState.dirtyFields,
                errors: _formState.errors,
                isValid: _formState.isValid
            });
        } else $89763f9db12fbe81$export$adaa4cf7ef1b65be(_formValues, name, values);
    };
    const updateErrors = (name, error)=>{
        $89763f9db12fbe81$export$adaa4cf7ef1b65be(_formState.errors, name, error);
        _subjects.state.next({
            errors: _formState.errors
        });
    };
    const _setErrors = (errors)=>{
        _formState.errors = errors;
        _subjects.state.next({
            errors: _formState.errors,
            isValid: false
        });
    };
    const updateValidAndValue = (name, shouldSkipSetValueAs, value1, ref)=>{
        const field = $89763f9db12fbe81$export$3988ae62b71be9a3(_fields, name);
        if (field) {
            const defaultValue = $89763f9db12fbe81$export$3988ae62b71be9a3(_formValues, name, $89763f9db12fbe81$var$isUndefined(value1) ? $89763f9db12fbe81$export$3988ae62b71be9a3(_defaultValues, name) : value1);
            $89763f9db12fbe81$var$isUndefined(defaultValue) || ref && ref.defaultChecked || shouldSkipSetValueAs ? $89763f9db12fbe81$export$adaa4cf7ef1b65be(_formValues, name, shouldSkipSetValueAs ? defaultValue : $89763f9db12fbe81$var$getFieldValue(field._f)) : setFieldValue(name, defaultValue);
            _state.mount && _setValid();
        }
    };
    const updateTouchAndDirty = (name, fieldValue, isBlurEvent, shouldDirty, shouldRender)=>{
        let shouldUpdateField = false;
        let isPreviousDirty = false;
        const output = {
            name: name
        };
        if (!_options.disabled) {
            if (!isBlurEvent || shouldDirty) {
                if (_proxyFormState.isDirty || _proxySubscribeFormState.isDirty) {
                    isPreviousDirty = _formState.isDirty;
                    _formState.isDirty = output.isDirty = _getDirty();
                    shouldUpdateField = isPreviousDirty !== output.isDirty;
                }
                const isCurrentFieldPristine = $89763f9db12fbe81$var$deepEqual($89763f9db12fbe81$export$3988ae62b71be9a3(_defaultValues, name), fieldValue);
                isPreviousDirty = !!$89763f9db12fbe81$export$3988ae62b71be9a3(_formState.dirtyFields, name);
                isCurrentFieldPristine ? $89763f9db12fbe81$var$unset(_formState.dirtyFields, name) : $89763f9db12fbe81$export$adaa4cf7ef1b65be(_formState.dirtyFields, name, true);
                output.dirtyFields = _formState.dirtyFields;
                shouldUpdateField = shouldUpdateField || (_proxyFormState.dirtyFields || _proxySubscribeFormState.dirtyFields) && isPreviousDirty !== !isCurrentFieldPristine;
            }
            if (isBlurEvent) {
                const isPreviousFieldTouched = $89763f9db12fbe81$export$3988ae62b71be9a3(_formState.touchedFields, name);
                if (!isPreviousFieldTouched) {
                    $89763f9db12fbe81$export$adaa4cf7ef1b65be(_formState.touchedFields, name, isBlurEvent);
                    output.touchedFields = _formState.touchedFields;
                    shouldUpdateField = shouldUpdateField || (_proxyFormState.touchedFields || _proxySubscribeFormState.touchedFields) && isPreviousFieldTouched !== isBlurEvent;
                }
            }
            shouldUpdateField && shouldRender && _subjects.state.next(output);
        }
        return shouldUpdateField ? output : {};
    };
    const shouldRenderByError = (name, isValid, error, fieldState)=>{
        const previousFieldError = $89763f9db12fbe81$export$3988ae62b71be9a3(_formState.errors, name);
        const shouldUpdateValid = (_proxyFormState.isValid || _proxySubscribeFormState.isValid) && $89763f9db12fbe81$var$isBoolean(isValid) && _formState.isValid !== isValid;
        if (_options.delayError && error) {
            delayErrorCallback = debounce(()=>updateErrors(name, error));
            delayErrorCallback(_options.delayError);
        } else {
            clearTimeout(timer);
            delayErrorCallback = null;
            error ? $89763f9db12fbe81$export$adaa4cf7ef1b65be(_formState.errors, name, error) : $89763f9db12fbe81$var$unset(_formState.errors, name);
        }
        if ((error ? !$89763f9db12fbe81$var$deepEqual(previousFieldError, error) : previousFieldError) || !$89763f9db12fbe81$var$isEmptyObject(fieldState) || shouldUpdateValid) {
            const updatedFormState = (0, $8f44472fa5eb25c0$export$71511d61b312f219)((0, $45c1a8590053a015$export$71511d61b312f219)({}, fieldState, shouldUpdateValid && $89763f9db12fbe81$var$isBoolean(isValid) ? {
                isValid: isValid
            } : {}), {
                errors: _formState.errors,
                name: name
            });
            _formState = (0, $45c1a8590053a015$export$71511d61b312f219)({}, _formState, updatedFormState);
            _subjects.state.next(updatedFormState);
        }
    };
    const _runSchema = async (name)=>{
        _updateIsValidating(name, true);
        const result = await _options.resolver(_formValues, _options.context, $89763f9db12fbe81$var$getResolverOptions(name || _names.mount, _fields, _options.criteriaMode, _options.shouldUseNativeValidation));
        _updateIsValidating(name);
        return result;
    };
    const executeSchemaAndUpdateState = async (names)=>{
        const { errors: errors } = await _runSchema(names);
        if (names) for (const name of names){
            const error = $89763f9db12fbe81$export$3988ae62b71be9a3(errors, name);
            error ? $89763f9db12fbe81$export$adaa4cf7ef1b65be(_formState.errors, name, error) : $89763f9db12fbe81$var$unset(_formState.errors, name);
        }
        else _formState.errors = errors;
        return errors;
    };
    const executeBuiltInValidation = async (fields, shouldOnlyCheckValid, context = {
        valid: true
    })=>{
        for(const _ref in fields){
            let name = _ref;
            const field = fields[name];
            if (field) {
                const { _f: _f } = field, fieldValue = (0, $30c24b3cbf3b0a7a$export$71511d61b312f219)(field, [
                    "_f"
                ]);
                if (_f) {
                    const isFieldArrayRoot = _names.array.has(_f.name);
                    const isPromiseFunction = field._f && $89763f9db12fbe81$var$hasPromiseValidation(field._f);
                    if (isPromiseFunction && _proxyFormState.validatingFields) _updateIsValidating([
                        name
                    ], true);
                    const fieldError = await $89763f9db12fbe81$var$validateField(field, _names.disabled, _formValues, shouldDisplayAllAssociatedErrors, _options.shouldUseNativeValidation && !shouldOnlyCheckValid, isFieldArrayRoot);
                    if (isPromiseFunction && _proxyFormState.validatingFields) _updateIsValidating([
                        name
                    ]);
                    if (fieldError[_f.name]) {
                        context.valid = false;
                        if (shouldOnlyCheckValid) break;
                    }
                    !shouldOnlyCheckValid && ($89763f9db12fbe81$export$3988ae62b71be9a3(fieldError, _f.name) ? isFieldArrayRoot ? $89763f9db12fbe81$var$updateFieldArrayRootError(_formState.errors, fieldError, _f.name) : $89763f9db12fbe81$export$adaa4cf7ef1b65be(_formState.errors, _f.name, fieldError[_f.name]) : $89763f9db12fbe81$var$unset(_formState.errors, _f.name));
                }
                !$89763f9db12fbe81$var$isEmptyObject(fieldValue) && await executeBuiltInValidation(fieldValue, shouldOnlyCheckValid, context);
            }
        }
        return context.valid;
    };
    const _removeUnmounted = ()=>{
        for (const name of _names.unMount){
            const field = $89763f9db12fbe81$export$3988ae62b71be9a3(_fields, name);
            field && (field._f.refs ? field._f.refs.every((ref)=>!$89763f9db12fbe81$var$live(ref)) : !$89763f9db12fbe81$var$live(field._f.ref)) && unregister(name);
        }
        _names.unMount = new Set();
    };
    const _getDirty = (name, data)=>!_options.disabled && (name && data && $89763f9db12fbe81$export$adaa4cf7ef1b65be(_formValues, name, data), !$89763f9db12fbe81$var$deepEqual(getValues(), _defaultValues));
    const _getWatch = (names, defaultValue, isGlobal)=>$89763f9db12fbe81$var$generateWatchOutput(names, _names, (0, $45c1a8590053a015$export$71511d61b312f219)({}, _state.mount ? _formValues : $89763f9db12fbe81$var$isUndefined(defaultValue) ? _defaultValues : $89763f9db12fbe81$var$isString(names) ? {
            [names]: defaultValue
        } : defaultValue), isGlobal, defaultValue);
    const _getFieldArray = (name)=>$89763f9db12fbe81$var$compact($89763f9db12fbe81$export$3988ae62b71be9a3(_state.mount ? _formValues : _defaultValues, name, _options.shouldUnregister ? $89763f9db12fbe81$export$3988ae62b71be9a3(_defaultValues, name, []) : []));
    const setFieldValue = (name, value1, options = {})=>{
        const field = $89763f9db12fbe81$export$3988ae62b71be9a3(_fields, name);
        let fieldValue = value1;
        if (field) {
            const fieldReference = field._f;
            if (fieldReference) {
                !fieldReference.disabled && $89763f9db12fbe81$export$adaa4cf7ef1b65be(_formValues, name, $89763f9db12fbe81$var$getFieldValueAs(value1, fieldReference));
                fieldValue = $89763f9db12fbe81$var$isHTMLElement(fieldReference.ref) && $89763f9db12fbe81$var$isNullOrUndefined(value1) ? '' : value1;
                if ($89763f9db12fbe81$var$isMultipleSelect(fieldReference.ref)) [
                    ...fieldReference.ref.options
                ].forEach((optionRef)=>optionRef.selected = fieldValue.includes(optionRef.value));
                else if (fieldReference.refs) {
                    if ($89763f9db12fbe81$var$isCheckBoxInput(fieldReference.ref)) fieldReference.refs.length > 1 ? fieldReference.refs.forEach((checkboxRef)=>(!checkboxRef.defaultChecked || !checkboxRef.disabled) && (checkboxRef.checked = Array.isArray(fieldValue) ? !!fieldValue.find((data)=>data === checkboxRef.value) : fieldValue === checkboxRef.value)) : fieldReference.refs[0] && (fieldReference.refs[0].checked = !!fieldValue);
                    else fieldReference.refs.forEach((radioRef)=>radioRef.checked = radioRef.value === fieldValue);
                } else if ($89763f9db12fbe81$var$isFileInput(fieldReference.ref)) fieldReference.ref.value = '';
                else {
                    fieldReference.ref.value = fieldValue;
                    if (!fieldReference.ref.type) _subjects.state.next({
                        name: name,
                        values: $89763f9db12fbe81$var$cloneObject(_formValues)
                    });
                }
            }
        }
        (options.shouldDirty || options.shouldTouch) && updateTouchAndDirty(name, fieldValue, options.shouldTouch, options.shouldDirty, true);
        options.shouldValidate && trigger(name);
    };
    const setValues = (name, value1, options)=>{
        for(const fieldKey in value1){
            const fieldValue = value1[fieldKey];
            const fieldName = `${name}.${fieldKey}`;
            const field = $89763f9db12fbe81$export$3988ae62b71be9a3(_fields, fieldName);
            (_names.array.has(name) || $89763f9db12fbe81$var$isObject(fieldValue) || field && !field._f) && !$89763f9db12fbe81$var$isDateObject(fieldValue) ? setValues(fieldName, fieldValue, options) : setFieldValue(fieldName, fieldValue, options);
        }
    };
    const setValue = (name, value1, options = {})=>{
        const field = $89763f9db12fbe81$export$3988ae62b71be9a3(_fields, name);
        const isFieldArray = _names.array.has(name);
        const cloneValue = $89763f9db12fbe81$var$cloneObject(value1);
        $89763f9db12fbe81$export$adaa4cf7ef1b65be(_formValues, name, cloneValue);
        if (isFieldArray) {
            _subjects.array.next({
                name: name,
                values: $89763f9db12fbe81$var$cloneObject(_formValues)
            });
            if ((_proxyFormState.isDirty || _proxyFormState.dirtyFields || _proxySubscribeFormState.isDirty || _proxySubscribeFormState.dirtyFields) && options.shouldDirty) _subjects.state.next({
                name: name,
                dirtyFields: $89763f9db12fbe81$var$getDirtyFields(_defaultValues, _formValues),
                isDirty: _getDirty(name, cloneValue)
            });
        } else field && !field._f && !$89763f9db12fbe81$var$isNullOrUndefined(cloneValue) ? setValues(name, cloneValue, options) : setFieldValue(name, cloneValue, options);
        $89763f9db12fbe81$var$isWatched(name, _names) && _subjects.state.next((0, $45c1a8590053a015$export$71511d61b312f219)({}, _formState));
        _subjects.state.next({
            name: _state.mount ? name : undefined,
            values: $89763f9db12fbe81$var$cloneObject(_formValues)
        });
    };
    const onChange = async (event)=>{
        _state.mount = true;
        const target = event.target;
        let name = target.name;
        let isFieldValueUpdated = true;
        const field = $89763f9db12fbe81$export$3988ae62b71be9a3(_fields, name);
        const _updateIsFieldValueUpdated = (fieldValue)=>{
            isFieldValueUpdated = Number.isNaN(fieldValue) || $89763f9db12fbe81$var$isDateObject(fieldValue) && isNaN(fieldValue.getTime()) || $89763f9db12fbe81$var$deepEqual(fieldValue, $89763f9db12fbe81$export$3988ae62b71be9a3(_formValues, name, fieldValue));
        };
        if (field) {
            let error;
            let isValid;
            const fieldValue = target.type ? $89763f9db12fbe81$var$getFieldValue(field._f) : $89763f9db12fbe81$var$getEventValue(event);
            const isBlurEvent = event.type === $89763f9db12fbe81$var$EVENTS.BLUR || event.type === $89763f9db12fbe81$var$EVENTS.FOCUS_OUT;
            const shouldSkipValidation = !$89763f9db12fbe81$var$hasValidation(field._f) && !_options.resolver && !$89763f9db12fbe81$export$3988ae62b71be9a3(_formState.errors, name) && !field._f.deps || $89763f9db12fbe81$var$skipValidation(isBlurEvent, $89763f9db12fbe81$export$3988ae62b71be9a3(_formState.touchedFields, name), _formState.isSubmitted, validationModeAfterSubmit, validationModeBeforeSubmit);
            const watched = $89763f9db12fbe81$var$isWatched(name, _names, isBlurEvent);
            $89763f9db12fbe81$export$adaa4cf7ef1b65be(_formValues, name, fieldValue);
            if (isBlurEvent) {
                field._f.onBlur && field._f.onBlur(event);
                delayErrorCallback && delayErrorCallback(0);
            } else if (field._f.onChange) field._f.onChange(event);
            const fieldState = updateTouchAndDirty(name, fieldValue, isBlurEvent);
            const shouldRender = !$89763f9db12fbe81$var$isEmptyObject(fieldState) || watched;
            !isBlurEvent && _subjects.state.next({
                name: name,
                type: event.type,
                values: $89763f9db12fbe81$var$cloneObject(_formValues)
            });
            if (shouldSkipValidation) {
                if (_proxyFormState.isValid || _proxySubscribeFormState.isValid) {
                    if (_options.mode === 'onBlur') {
                        if (isBlurEvent) _setValid();
                    } else if (!isBlurEvent) _setValid();
                }
                return shouldRender && _subjects.state.next((0, $45c1a8590053a015$export$71511d61b312f219)({
                    name: name
                }, watched ? {} : fieldState));
            }
            !isBlurEvent && watched && _subjects.state.next((0, $45c1a8590053a015$export$71511d61b312f219)({}, _formState));
            if (_options.resolver) {
                const { errors: errors } = await _runSchema([
                    name
                ]);
                _updateIsFieldValueUpdated(fieldValue);
                if (isFieldValueUpdated) {
                    const previousErrorLookupResult = $89763f9db12fbe81$var$schemaErrorLookup(_formState.errors, _fields, name);
                    const errorLookupResult = $89763f9db12fbe81$var$schemaErrorLookup(errors, _fields, previousErrorLookupResult.name || name);
                    error = errorLookupResult.error;
                    name = errorLookupResult.name;
                    isValid = $89763f9db12fbe81$var$isEmptyObject(errors);
                }
            } else {
                _updateIsValidating([
                    name
                ], true);
                error = (await $89763f9db12fbe81$var$validateField(field, _names.disabled, _formValues, shouldDisplayAllAssociatedErrors, _options.shouldUseNativeValidation))[name];
                _updateIsValidating([
                    name
                ]);
                _updateIsFieldValueUpdated(fieldValue);
                if (isFieldValueUpdated) {
                    if (error) isValid = false;
                    else if (_proxyFormState.isValid || _proxySubscribeFormState.isValid) isValid = await executeBuiltInValidation(_fields, true);
                }
            }
            if (isFieldValueUpdated) {
                field._f.deps && trigger(field._f.deps);
                shouldRenderByError(name, isValid, error, fieldState);
            }
        }
    };
    const _focusInput = (ref, key)=>{
        if ($89763f9db12fbe81$export$3988ae62b71be9a3(_formState.errors, key) && ref.focus) {
            ref.focus();
            return 1;
        }
        return;
    };
    const trigger = async (name, options = {})=>{
        let isValid;
        let validationResult;
        const fieldNames = $89763f9db12fbe81$var$convertToArrayPayload(name);
        if (_options.resolver) {
            const errors = await executeSchemaAndUpdateState($89763f9db12fbe81$var$isUndefined(name) ? name : fieldNames);
            isValid = $89763f9db12fbe81$var$isEmptyObject(errors);
            validationResult = name ? !fieldNames.some((name)=>$89763f9db12fbe81$export$3988ae62b71be9a3(errors, name)) : isValid;
        } else if (name) {
            validationResult = (await Promise.all(fieldNames.map(async (fieldName)=>{
                const field = $89763f9db12fbe81$export$3988ae62b71be9a3(_fields, fieldName);
                return await executeBuiltInValidation(field && field._f ? {
                    [fieldName]: field
                } : field);
            }))).every(Boolean);
            !(!validationResult && !_formState.isValid) && _setValid();
        } else validationResult = isValid = await executeBuiltInValidation(_fields);
        _subjects.state.next((0, $8f44472fa5eb25c0$export$71511d61b312f219)((0, $45c1a8590053a015$export$71511d61b312f219)({}, !$89763f9db12fbe81$var$isString(name) || (_proxyFormState.isValid || _proxySubscribeFormState.isValid) && isValid !== _formState.isValid ? {} : {
            name: name
        }, _options.resolver || !name ? {
            isValid: isValid
        } : {}), {
            errors: _formState.errors
        }));
        options.shouldFocus && !validationResult && $89763f9db12fbe81$var$iterateFieldsByAction(_fields, _focusInput, name ? fieldNames : _names.mount);
        return validationResult;
    };
    const getValues = (fieldNames)=>{
        const values = (0, $45c1a8590053a015$export$71511d61b312f219)({}, _state.mount ? _formValues : _defaultValues);
        return $89763f9db12fbe81$var$isUndefined(fieldNames) ? values : $89763f9db12fbe81$var$isString(fieldNames) ? $89763f9db12fbe81$export$3988ae62b71be9a3(values, fieldNames) : fieldNames.map((name)=>$89763f9db12fbe81$export$3988ae62b71be9a3(values, name));
    };
    const getFieldState = (name, formState)=>({
            invalid: !!$89763f9db12fbe81$export$3988ae62b71be9a3((formState || _formState).errors, name),
            isDirty: !!$89763f9db12fbe81$export$3988ae62b71be9a3((formState || _formState).dirtyFields, name),
            error: $89763f9db12fbe81$export$3988ae62b71be9a3((formState || _formState).errors, name),
            isValidating: !!$89763f9db12fbe81$export$3988ae62b71be9a3(_formState.validatingFields, name),
            isTouched: !!$89763f9db12fbe81$export$3988ae62b71be9a3((formState || _formState).touchedFields, name)
        });
    const clearErrors = (name)=>{
        name && $89763f9db12fbe81$var$convertToArrayPayload(name).forEach((inputName)=>$89763f9db12fbe81$var$unset(_formState.errors, inputName));
        _subjects.state.next({
            errors: name ? _formState.errors : {}
        });
    };
    const setError = (name, error, options)=>{
        const ref = ($89763f9db12fbe81$export$3988ae62b71be9a3(_fields, name, {
            _f: {}
        })._f || {}).ref;
        const currentError = $89763f9db12fbe81$export$3988ae62b71be9a3(_formState.errors, name) || {};
        // Don't override existing error messages elsewhere in the object tree.
        const { ref: currentRef, message: message, type: type } = currentError, restOfErrorTree = (0, $30c24b3cbf3b0a7a$export$71511d61b312f219)(currentError, [
            "ref",
            "message",
            "type"
        ]);
        $89763f9db12fbe81$export$adaa4cf7ef1b65be(_formState.errors, name, (0, $8f44472fa5eb25c0$export$71511d61b312f219)((0, $45c1a8590053a015$export$71511d61b312f219)({}, restOfErrorTree, error), {
            ref: ref
        }));
        _subjects.state.next({
            name: name,
            errors: _formState.errors,
            isValid: false
        });
        options && options.shouldFocus && ref && ref.focus && ref.focus();
    };
    const watch = (name, defaultValue)=>$89763f9db12fbe81$var$isFunction(name) ? _subjects.state.subscribe({
            next: (payload)=>name(_getWatch(undefined, defaultValue), payload)
        }) : _getWatch(name, defaultValue, true);
    const _subscribe = (props)=>_subjects.state.subscribe({
            next: (formState)=>{
                if ($89763f9db12fbe81$var$shouldSubscribeByName(props.name, formState.name, props.exact) && $89763f9db12fbe81$var$shouldRenderFormState(formState, props.formState || _proxyFormState, _setFormState, props.reRenderRoot)) props.callback((0, $45c1a8590053a015$export$71511d61b312f219)({
                    values: (0, $45c1a8590053a015$export$71511d61b312f219)({}, _formValues)
                }, _formState, formState));
            }
        }).unsubscribe;
    const subscribe = (props)=>{
        _state.mount = true;
        _proxySubscribeFormState = (0, $45c1a8590053a015$export$71511d61b312f219)({}, _proxySubscribeFormState, props.formState);
        return _subscribe((0, $8f44472fa5eb25c0$export$71511d61b312f219)((0, $45c1a8590053a015$export$71511d61b312f219)({}, props), {
            formState: _proxySubscribeFormState
        }));
    };
    const unregister = (name, options = {})=>{
        for (const fieldName of name ? $89763f9db12fbe81$var$convertToArrayPayload(name) : _names.mount){
            _names.mount.delete(fieldName);
            _names.array.delete(fieldName);
            if (!options.keepValue) {
                $89763f9db12fbe81$var$unset(_fields, fieldName);
                $89763f9db12fbe81$var$unset(_formValues, fieldName);
            }
            !options.keepError && $89763f9db12fbe81$var$unset(_formState.errors, fieldName);
            !options.keepDirty && $89763f9db12fbe81$var$unset(_formState.dirtyFields, fieldName);
            !options.keepTouched && $89763f9db12fbe81$var$unset(_formState.touchedFields, fieldName);
            !options.keepIsValidating && $89763f9db12fbe81$var$unset(_formState.validatingFields, fieldName);
            !_options.shouldUnregister && !options.keepDefaultValue && $89763f9db12fbe81$var$unset(_defaultValues, fieldName);
        }
        _subjects.state.next({
            values: $89763f9db12fbe81$var$cloneObject(_formValues)
        });
        _subjects.state.next((0, $45c1a8590053a015$export$71511d61b312f219)({}, _formState, !options.keepDirty ? {} : {
            isDirty: _getDirty()
        }));
        !options.keepIsValid && _setValid();
    };
    const _setDisabledField = ({ disabled: disabled, name: name })=>{
        if ($89763f9db12fbe81$var$isBoolean(disabled) && _state.mount || !!disabled || _names.disabled.has(name)) disabled ? _names.disabled.add(name) : _names.disabled.delete(name);
    };
    const register = (name, options = {})=>{
        let field = $89763f9db12fbe81$export$3988ae62b71be9a3(_fields, name);
        const disabledIsDefined = $89763f9db12fbe81$var$isBoolean(options.disabled) || $89763f9db12fbe81$var$isBoolean(_options.disabled);
        $89763f9db12fbe81$export$adaa4cf7ef1b65be(_fields, name, (0, $8f44472fa5eb25c0$export$71511d61b312f219)((0, $45c1a8590053a015$export$71511d61b312f219)({}, field || {}), {
            _f: (0, $45c1a8590053a015$export$71511d61b312f219)((0, $8f44472fa5eb25c0$export$71511d61b312f219)((0, $45c1a8590053a015$export$71511d61b312f219)({}, field && field._f ? field._f : {
                ref: {
                    name: name
                }
            }), {
                name: name,
                mount: true
            }), options)
        }));
        _names.mount.add(name);
        if (field) _setDisabledField({
            disabled: $89763f9db12fbe81$var$isBoolean(options.disabled) ? options.disabled : _options.disabled,
            name: name
        });
        else updateValidAndValue(name, true, options.value);
        return (0, $8f44472fa5eb25c0$export$71511d61b312f219)((0, $45c1a8590053a015$export$71511d61b312f219)({}, disabledIsDefined ? {
            disabled: options.disabled || _options.disabled
        } : {}, _options.progressive ? {
            required: !!options.required,
            min: $89763f9db12fbe81$var$getRuleValue(options.min),
            max: $89763f9db12fbe81$var$getRuleValue(options.max),
            minLength: $89763f9db12fbe81$var$getRuleValue(options.minLength),
            maxLength: $89763f9db12fbe81$var$getRuleValue(options.maxLength),
            pattern: $89763f9db12fbe81$var$getRuleValue(options.pattern)
        } : {}), {
            name: name,
            onChange: onChange,
            onBlur: onChange,
            ref: (ref)=>{
                if (ref) {
                    register(name, options);
                    field = $89763f9db12fbe81$export$3988ae62b71be9a3(_fields, name);
                    const fieldRef = $89763f9db12fbe81$var$isUndefined(ref.value) ? ref.querySelectorAll ? ref.querySelectorAll('input,select,textarea')[0] || ref : ref : ref;
                    const radioOrCheckbox = $89763f9db12fbe81$var$isRadioOrCheckbox(fieldRef);
                    const refs = field._f.refs || [];
                    if (radioOrCheckbox ? refs.find((option)=>option === fieldRef) : fieldRef === field._f.ref) return;
                    $89763f9db12fbe81$export$adaa4cf7ef1b65be(_fields, name, {
                        _f: (0, $45c1a8590053a015$export$71511d61b312f219)({}, field._f, radioOrCheckbox ? {
                            refs: [
                                ...refs.filter($89763f9db12fbe81$var$live),
                                fieldRef,
                                ...Array.isArray($89763f9db12fbe81$export$3988ae62b71be9a3(_defaultValues, name)) ? [
                                    {}
                                ] : []
                            ],
                            ref: {
                                type: fieldRef.type,
                                name: name
                            }
                        } : {
                            ref: fieldRef
                        })
                    });
                    updateValidAndValue(name, false, undefined, fieldRef);
                } else {
                    field = $89763f9db12fbe81$export$3988ae62b71be9a3(_fields, name, {});
                    if (field._f) field._f.mount = false;
                    (_options.shouldUnregister || options.shouldUnregister) && !($89763f9db12fbe81$var$isNameInFieldArray(_names.array, name) && _state.action) && _names.unMount.add(name);
                }
            }
        });
    };
    const _focusError = ()=>_options.shouldFocusError && $89763f9db12fbe81$var$iterateFieldsByAction(_fields, _focusInput, _names.mount);
    const _disableForm = (disabled)=>{
        if ($89763f9db12fbe81$var$isBoolean(disabled)) {
            _subjects.state.next({
                disabled: disabled
            });
            $89763f9db12fbe81$var$iterateFieldsByAction(_fields, (ref, name)=>{
                const currentField = $89763f9db12fbe81$export$3988ae62b71be9a3(_fields, name);
                if (currentField) {
                    ref.disabled = currentField._f.disabled || disabled;
                    if (Array.isArray(currentField._f.refs)) currentField._f.refs.forEach((inputRef)=>{
                        inputRef.disabled = currentField._f.disabled || disabled;
                    });
                }
            }, 0, false);
        }
    };
    const handleSubmit = (onValid, onInvalid)=>async (e)=>{
            let onValidError = undefined;
            if (e) {
                e.preventDefault && e.preventDefault();
                e.persist && e.persist();
            }
            let fieldValues = $89763f9db12fbe81$var$cloneObject(_formValues);
            _subjects.state.next({
                isSubmitting: true
            });
            if (_options.resolver) {
                const { errors: errors, values: values } = await _runSchema();
                _formState.errors = errors;
                fieldValues = values;
            } else await executeBuiltInValidation(_fields);
            if (_names.disabled.size) for (const name of _names.disabled)$89763f9db12fbe81$export$adaa4cf7ef1b65be(fieldValues, name, undefined);
            $89763f9db12fbe81$var$unset(_formState.errors, 'root');
            if ($89763f9db12fbe81$var$isEmptyObject(_formState.errors)) {
                _subjects.state.next({
                    errors: {}
                });
                try {
                    await onValid(fieldValues, e);
                } catch (error) {
                    onValidError = error;
                }
            } else {
                if (onInvalid) await onInvalid((0, $45c1a8590053a015$export$71511d61b312f219)({}, _formState.errors), e);
                _focusError();
                setTimeout(_focusError);
            }
            _subjects.state.next({
                isSubmitted: true,
                isSubmitting: false,
                isSubmitSuccessful: $89763f9db12fbe81$var$isEmptyObject(_formState.errors) && !onValidError,
                submitCount: _formState.submitCount + 1,
                errors: _formState.errors
            });
            if (onValidError) throw onValidError;
        };
    const resetField = (name, options = {})=>{
        if ($89763f9db12fbe81$export$3988ae62b71be9a3(_fields, name)) {
            if ($89763f9db12fbe81$var$isUndefined(options.defaultValue)) setValue(name, $89763f9db12fbe81$var$cloneObject($89763f9db12fbe81$export$3988ae62b71be9a3(_defaultValues, name)));
            else {
                setValue(name, options.defaultValue);
                $89763f9db12fbe81$export$adaa4cf7ef1b65be(_defaultValues, name, $89763f9db12fbe81$var$cloneObject(options.defaultValue));
            }
            if (!options.keepTouched) $89763f9db12fbe81$var$unset(_formState.touchedFields, name);
            if (!options.keepDirty) {
                $89763f9db12fbe81$var$unset(_formState.dirtyFields, name);
                _formState.isDirty = options.defaultValue ? _getDirty(name, $89763f9db12fbe81$var$cloneObject($89763f9db12fbe81$export$3988ae62b71be9a3(_defaultValues, name))) : _getDirty();
            }
            if (!options.keepError) {
                $89763f9db12fbe81$var$unset(_formState.errors, name);
                _proxyFormState.isValid && _setValid();
            }
            _subjects.state.next((0, $45c1a8590053a015$export$71511d61b312f219)({}, _formState));
        }
    };
    const _reset = (formValues, keepStateOptions = {})=>{
        const updatedValues = formValues ? $89763f9db12fbe81$var$cloneObject(formValues) : _defaultValues;
        const cloneUpdatedValues = $89763f9db12fbe81$var$cloneObject(updatedValues);
        const isEmptyResetValues = $89763f9db12fbe81$var$isEmptyObject(formValues);
        const values = isEmptyResetValues ? _defaultValues : cloneUpdatedValues;
        if (!keepStateOptions.keepDefaultValues) _defaultValues = updatedValues;
        if (!keepStateOptions.keepValues) {
            if (keepStateOptions.keepDirtyValues) {
                const fieldsToCheck = new Set([
                    ..._names.mount,
                    ...Object.keys($89763f9db12fbe81$var$getDirtyFields(_defaultValues, _formValues))
                ]);
                for (const fieldName of Array.from(fieldsToCheck))$89763f9db12fbe81$export$3988ae62b71be9a3(_formState.dirtyFields, fieldName) ? $89763f9db12fbe81$export$adaa4cf7ef1b65be(values, fieldName, $89763f9db12fbe81$export$3988ae62b71be9a3(_formValues, fieldName)) : setValue(fieldName, $89763f9db12fbe81$export$3988ae62b71be9a3(values, fieldName));
            } else {
                if ($89763f9db12fbe81$var$isWeb && $89763f9db12fbe81$var$isUndefined(formValues)) for (const name of _names.mount){
                    const field = $89763f9db12fbe81$export$3988ae62b71be9a3(_fields, name);
                    if (field && field._f) {
                        const fieldReference = Array.isArray(field._f.refs) ? field._f.refs[0] : field._f.ref;
                        if ($89763f9db12fbe81$var$isHTMLElement(fieldReference)) {
                            const form = fieldReference.closest('form');
                            if (form) {
                                form.reset();
                                break;
                            }
                        }
                    }
                }
                for (const fieldName of _names.mount)setValue(fieldName, $89763f9db12fbe81$export$3988ae62b71be9a3(values, fieldName));
            }
            _formValues = $89763f9db12fbe81$var$cloneObject(values);
            _subjects.array.next({
                values: (0, $45c1a8590053a015$export$71511d61b312f219)({}, values)
            });
            _subjects.state.next({
                values: (0, $45c1a8590053a015$export$71511d61b312f219)({}, values)
            });
        }
        _names = {
            mount: keepStateOptions.keepDirtyValues ? _names.mount : new Set(),
            unMount: new Set(),
            array: new Set(),
            disabled: new Set(),
            watch: new Set(),
            watchAll: false,
            focus: ''
        };
        _state.mount = !_proxyFormState.isValid || !!keepStateOptions.keepIsValid || !!keepStateOptions.keepDirtyValues;
        _state.watch = !!_options.shouldUnregister;
        _subjects.state.next({
            submitCount: keepStateOptions.keepSubmitCount ? _formState.submitCount : 0,
            isDirty: isEmptyResetValues ? false : keepStateOptions.keepDirty ? _formState.isDirty : !!(keepStateOptions.keepDefaultValues && !$89763f9db12fbe81$var$deepEqual(formValues, _defaultValues)),
            isSubmitted: keepStateOptions.keepIsSubmitted ? _formState.isSubmitted : false,
            dirtyFields: isEmptyResetValues ? {} : keepStateOptions.keepDirtyValues ? keepStateOptions.keepDefaultValues && _formValues ? $89763f9db12fbe81$var$getDirtyFields(_defaultValues, _formValues) : _formState.dirtyFields : keepStateOptions.keepDefaultValues && formValues ? $89763f9db12fbe81$var$getDirtyFields(_defaultValues, formValues) : keepStateOptions.keepDirty ? _formState.dirtyFields : {},
            touchedFields: keepStateOptions.keepTouched ? _formState.touchedFields : {},
            errors: keepStateOptions.keepErrors ? _formState.errors : {},
            isSubmitSuccessful: keepStateOptions.keepIsSubmitSuccessful ? _formState.isSubmitSuccessful : false,
            isSubmitting: false
        });
    };
    const reset = (formValues, keepStateOptions)=>_reset($89763f9db12fbe81$var$isFunction(formValues) ? formValues(_formValues) : formValues, keepStateOptions);
    const setFocus = (name, options = {})=>{
        const field = $89763f9db12fbe81$export$3988ae62b71be9a3(_fields, name);
        const fieldReference = field && field._f;
        if (fieldReference) {
            const fieldRef = fieldReference.refs ? fieldReference.refs[0] : fieldReference.ref;
            if (fieldRef.focus) {
                fieldRef.focus();
                options.shouldSelect && $89763f9db12fbe81$var$isFunction(fieldRef.select) && fieldRef.select();
            }
        }
    };
    const _setFormState = (updatedFormState)=>{
        _formState = (0, $45c1a8590053a015$export$71511d61b312f219)({}, _formState, updatedFormState);
    };
    const _resetDefaultValues = ()=>$89763f9db12fbe81$var$isFunction(_options.defaultValues) && _options.defaultValues().then((values)=>{
            reset(values, _options.resetOptions);
            _subjects.state.next({
                isLoading: false
            });
        });
    const methods = {
        control: {
            register: register,
            unregister: unregister,
            getFieldState: getFieldState,
            handleSubmit: handleSubmit,
            setError: setError,
            _subscribe: _subscribe,
            _runSchema: _runSchema,
            _getWatch: _getWatch,
            _getDirty: _getDirty,
            _setValid: _setValid,
            _setFieldArray: _setFieldArray,
            _setDisabledField: _setDisabledField,
            _setErrors: _setErrors,
            _getFieldArray: _getFieldArray,
            _reset: _reset,
            _resetDefaultValues: _resetDefaultValues,
            _removeUnmounted: _removeUnmounted,
            _disableForm: _disableForm,
            _subjects: _subjects,
            _proxyFormState: _proxyFormState,
            get _fields () {
                return _fields;
            },
            get _formValues () {
                return _formValues;
            },
            get _state () {
                return _state;
            },
            set _state (value){
                _state = value;
            },
            get _defaultValues () {
                return _defaultValues;
            },
            get _names () {
                return _names;
            },
            set _names (value){
                _names = value;
            },
            get _formState () {
                return _formState;
            },
            get _options () {
                return _options;
            },
            set _options (value){
                _options = (0, $45c1a8590053a015$export$71511d61b312f219)({}, _options, value);
            }
        },
        subscribe: subscribe,
        trigger: trigger,
        register: register,
        handleSubmit: handleSubmit,
        watch: watch,
        setValue: setValue,
        getValues: getValues,
        reset: reset,
        resetField: resetField,
        clearErrors: clearErrors,
        unregister: unregister,
        setError: setError,
        setFocus: setFocus,
        getFieldState: getFieldState
    };
    return (0, $8f44472fa5eb25c0$export$71511d61b312f219)((0, $45c1a8590053a015$export$71511d61b312f219)({}, methods), {
        formControl: methods
    });
}
var $89763f9db12fbe81$var$generateId = ()=>{
    const d = typeof performance === 'undefined' ? Date.now() : performance.now() * 1000;
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c)=>{
        const r = (Math.random() * 16 + d) % 16 | 0;
        return (c == 'x' ? r : r & 0x3 | 0x8).toString(16);
    });
};
var $89763f9db12fbe81$var$getFocusFieldName = (name, index, options = {})=>options.shouldFocus || $89763f9db12fbe81$var$isUndefined(options.shouldFocus) ? options.focusName || `${name}.${$89763f9db12fbe81$var$isUndefined(options.focusIndex) ? index : options.focusIndex}.` : '';
var $89763f9db12fbe81$var$appendAt = (data, value1)=>[
        ...data,
        ...$89763f9db12fbe81$var$convertToArrayPayload(value1)
    ];
var $89763f9db12fbe81$var$fillEmptyArray = (value1)=>Array.isArray(value1) ? value1.map(()=>undefined) : undefined;
function $89763f9db12fbe81$var$insert(data, index, value1) {
    return [
        ...data.slice(0, index),
        ...$89763f9db12fbe81$var$convertToArrayPayload(value1),
        ...data.slice(index)
    ];
}
var $89763f9db12fbe81$var$moveArrayAt = (data, from, to)=>{
    if (!Array.isArray(data)) return [];
    if ($89763f9db12fbe81$var$isUndefined(data[to])) data[to] = undefined;
    data.splice(to, 0, data.splice(from, 1)[0]);
    return data;
};
var $89763f9db12fbe81$var$prependAt = (data, value1)=>[
        ...$89763f9db12fbe81$var$convertToArrayPayload(value1),
        ...$89763f9db12fbe81$var$convertToArrayPayload(data)
    ];
function $89763f9db12fbe81$var$removeAtIndexes(data, indexes) {
    let i = 0;
    const temp = [
        ...data
    ];
    for (const index of indexes){
        temp.splice(index - i, 1);
        i++;
    }
    return $89763f9db12fbe81$var$compact(temp).length ? temp : [];
}
var $89763f9db12fbe81$var$removeArrayAt = (data, index)=>$89763f9db12fbe81$var$isUndefined(index) ? [] : $89763f9db12fbe81$var$removeAtIndexes(data, $89763f9db12fbe81$var$convertToArrayPayload(index).sort((a, b)=>a - b));
var $89763f9db12fbe81$var$swapArrayAt = (data, indexA, indexB)=>{
    [data[indexA], data[indexB]] = [
        data[indexB],
        data[indexA]
    ];
};
var $89763f9db12fbe81$var$updateAt = (fieldValues, index, value1)=>{
    fieldValues[index] = value1;
    return fieldValues;
};
/**
 * A custom hook that exposes convenient methods to perform operations with a list of dynamic inputs that need to be appended, updated, removed etc. • [Demo](https://codesandbox.io/s/react-hook-form-usefieldarray-ssugn) • [Video](https://youtu.be/4MrbfGSFY2A)
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/usefieldarray) • [Demo](https://codesandbox.io/s/react-hook-form-usefieldarray-ssugn)
 *
 * @param props - useFieldArray props
 *
 * @returns methods - functions to manipulate with the Field Arrays (dynamic inputs) {@link UseFieldArrayReturn}
 *
 * @example
 * ```tsx
 * function App() {
 *   const { register, control, handleSubmit, reset, trigger, setError } = useForm({
 *     defaultValues: {
 *       test: []
 *     }
 *   });
 *   const { fields, append } = useFieldArray({
 *     control,
 *     name: "test"
 *   });
 *
 *   return (
 *     <form onSubmit={handleSubmit(data => console.log(data))}>
 *       {fields.map((item, index) => (
 *          <input key={item.id} {...register(`test.${index}.firstName`)}  />
 *       ))}
 *       <button type="button" onClick={() => append({ firstName: "bill" })}>
 *         append
 *       </button>
 *       <input type="submit" />
 *     </form>
 *   );
 * }
 * ```
 */ function $89763f9db12fbe81$export$310131896651d559(props) {
    const methods = $89763f9db12fbe81$export$4d957a5e1be13b03();
    const { control: control = methods.control, name: name, keyName: keyName = 'id', shouldUnregister: shouldUnregister, rules: rules } = props;
    const [fields, setFields] = (0, (/*@__PURE__*/$parcel$interopDefault($4Y8Vu))).useState(control._getFieldArray(name));
    const ids = (0, (/*@__PURE__*/$parcel$interopDefault($4Y8Vu))).useRef(control._getFieldArray(name).map($89763f9db12fbe81$var$generateId));
    const _fieldIds = (0, (/*@__PURE__*/$parcel$interopDefault($4Y8Vu))).useRef(fields);
    const _name = (0, (/*@__PURE__*/$parcel$interopDefault($4Y8Vu))).useRef(name);
    const _actioned = (0, (/*@__PURE__*/$parcel$interopDefault($4Y8Vu))).useRef(false);
    _name.current = name;
    _fieldIds.current = fields;
    control._names.array.add(name);
    rules && control.register(name, rules);
    (0, (/*@__PURE__*/$parcel$interopDefault($4Y8Vu))).useEffect(()=>control._subjects.array.subscribe({
            next: ({ values: values, name: fieldArrayName })=>{
                if (fieldArrayName === _name.current || !fieldArrayName) {
                    const fieldValues = $89763f9db12fbe81$export$3988ae62b71be9a3(values, _name.current);
                    if (Array.isArray(fieldValues)) {
                        setFields(fieldValues);
                        ids.current = fieldValues.map($89763f9db12fbe81$var$generateId);
                    }
                }
            }
        }).unsubscribe, [
        control
    ]);
    const updateValues = (0, (/*@__PURE__*/$parcel$interopDefault($4Y8Vu))).useCallback((updatedFieldArrayValues)=>{
        _actioned.current = true;
        control._setFieldArray(name, updatedFieldArrayValues);
    }, [
        control,
        name
    ]);
    const append = (value1, options)=>{
        const appendValue = $89763f9db12fbe81$var$convertToArrayPayload($89763f9db12fbe81$var$cloneObject(value1));
        const updatedFieldArrayValues = $89763f9db12fbe81$var$appendAt(control._getFieldArray(name), appendValue);
        control._names.focus = $89763f9db12fbe81$var$getFocusFieldName(name, updatedFieldArrayValues.length - 1, options);
        ids.current = $89763f9db12fbe81$var$appendAt(ids.current, appendValue.map($89763f9db12fbe81$var$generateId));
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._setFieldArray(name, updatedFieldArrayValues, $89763f9db12fbe81$var$appendAt, {
            argA: $89763f9db12fbe81$var$fillEmptyArray(value1)
        });
    };
    const prepend = (value1, options)=>{
        const prependValue = $89763f9db12fbe81$var$convertToArrayPayload($89763f9db12fbe81$var$cloneObject(value1));
        const updatedFieldArrayValues = $89763f9db12fbe81$var$prependAt(control._getFieldArray(name), prependValue);
        control._names.focus = $89763f9db12fbe81$var$getFocusFieldName(name, 0, options);
        ids.current = $89763f9db12fbe81$var$prependAt(ids.current, prependValue.map($89763f9db12fbe81$var$generateId));
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._setFieldArray(name, updatedFieldArrayValues, $89763f9db12fbe81$var$prependAt, {
            argA: $89763f9db12fbe81$var$fillEmptyArray(value1)
        });
    };
    const remove = (index)=>{
        const updatedFieldArrayValues = $89763f9db12fbe81$var$removeArrayAt(control._getFieldArray(name), index);
        ids.current = $89763f9db12fbe81$var$removeArrayAt(ids.current, index);
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        !Array.isArray($89763f9db12fbe81$export$3988ae62b71be9a3(control._fields, name)) && $89763f9db12fbe81$export$adaa4cf7ef1b65be(control._fields, name, undefined);
        control._setFieldArray(name, updatedFieldArrayValues, $89763f9db12fbe81$var$removeArrayAt, {
            argA: index
        });
    };
    const insert$1 = (index, value1, options)=>{
        const insertValue = $89763f9db12fbe81$var$convertToArrayPayload($89763f9db12fbe81$var$cloneObject(value1));
        const updatedFieldArrayValues = $89763f9db12fbe81$var$insert(control._getFieldArray(name), index, insertValue);
        control._names.focus = $89763f9db12fbe81$var$getFocusFieldName(name, index, options);
        ids.current = $89763f9db12fbe81$var$insert(ids.current, index, insertValue.map($89763f9db12fbe81$var$generateId));
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._setFieldArray(name, updatedFieldArrayValues, $89763f9db12fbe81$var$insert, {
            argA: index,
            argB: $89763f9db12fbe81$var$fillEmptyArray(value1)
        });
    };
    const swap = (indexA, indexB)=>{
        const updatedFieldArrayValues = control._getFieldArray(name);
        $89763f9db12fbe81$var$swapArrayAt(updatedFieldArrayValues, indexA, indexB);
        $89763f9db12fbe81$var$swapArrayAt(ids.current, indexA, indexB);
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._setFieldArray(name, updatedFieldArrayValues, $89763f9db12fbe81$var$swapArrayAt, {
            argA: indexA,
            argB: indexB
        }, false);
    };
    const move = (from, to)=>{
        const updatedFieldArrayValues = control._getFieldArray(name);
        $89763f9db12fbe81$var$moveArrayAt(updatedFieldArrayValues, from, to);
        $89763f9db12fbe81$var$moveArrayAt(ids.current, from, to);
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._setFieldArray(name, updatedFieldArrayValues, $89763f9db12fbe81$var$moveArrayAt, {
            argA: from,
            argB: to
        }, false);
    };
    const update = (index, value1)=>{
        const updateValue = $89763f9db12fbe81$var$cloneObject(value1);
        const updatedFieldArrayValues = $89763f9db12fbe81$var$updateAt(control._getFieldArray(name), index, updateValue);
        ids.current = [
            ...updatedFieldArrayValues
        ].map((item, i)=>!item || i === index ? $89763f9db12fbe81$var$generateId() : ids.current[i]);
        updateValues(updatedFieldArrayValues);
        setFields([
            ...updatedFieldArrayValues
        ]);
        control._setFieldArray(name, updatedFieldArrayValues, $89763f9db12fbe81$var$updateAt, {
            argA: index,
            argB: updateValue
        }, true, false);
    };
    const replace = (value1)=>{
        const updatedFieldArrayValues = $89763f9db12fbe81$var$convertToArrayPayload($89763f9db12fbe81$var$cloneObject(value1));
        ids.current = updatedFieldArrayValues.map($89763f9db12fbe81$var$generateId);
        updateValues([
            ...updatedFieldArrayValues
        ]);
        setFields([
            ...updatedFieldArrayValues
        ]);
        control._setFieldArray(name, [
            ...updatedFieldArrayValues
        ], (data)=>data, {}, true, false);
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($4Y8Vu))).useEffect(()=>{
        control._state.action = false;
        $89763f9db12fbe81$var$isWatched(name, control._names) && control._subjects.state.next((0, $45c1a8590053a015$export$71511d61b312f219)({}, control._formState));
        if (_actioned.current && (!$89763f9db12fbe81$var$getValidationModes(control._options.mode).isOnSubmit || control._formState.isSubmitted) && !$89763f9db12fbe81$var$getValidationModes(control._options.reValidateMode).isOnSubmit) {
            if (control._options.resolver) control._runSchema([
                name
            ]).then((result)=>{
                const error = $89763f9db12fbe81$export$3988ae62b71be9a3(result.errors, name);
                const existingError = $89763f9db12fbe81$export$3988ae62b71be9a3(control._formState.errors, name);
                if (existingError ? !error && existingError.type || error && (existingError.type !== error.type || existingError.message !== error.message) : error && error.type) {
                    error ? $89763f9db12fbe81$export$adaa4cf7ef1b65be(control._formState.errors, name, error) : $89763f9db12fbe81$var$unset(control._formState.errors, name);
                    control._subjects.state.next({
                        errors: control._formState.errors
                    });
                }
            });
            else {
                const field = $89763f9db12fbe81$export$3988ae62b71be9a3(control._fields, name);
                if (field && field._f && !($89763f9db12fbe81$var$getValidationModes(control._options.reValidateMode).isOnSubmit && $89763f9db12fbe81$var$getValidationModes(control._options.mode).isOnSubmit)) $89763f9db12fbe81$var$validateField(field, control._names.disabled, control._formValues, control._options.criteriaMode === $89763f9db12fbe81$var$VALIDATION_MODE.all, control._options.shouldUseNativeValidation, true).then((error)=>!$89763f9db12fbe81$var$isEmptyObject(error) && control._subjects.state.next({
                        errors: $89763f9db12fbe81$var$updateFieldArrayRootError(control._formState.errors, error, name)
                    }));
            }
        }
        control._subjects.state.next({
            name: name,
            values: $89763f9db12fbe81$var$cloneObject(control._formValues)
        });
        control._names.focus && $89763f9db12fbe81$var$iterateFieldsByAction(control._fields, (ref, key)=>{
            if (control._names.focus && key.startsWith(control._names.focus) && ref.focus) {
                ref.focus();
                return 1;
            }
            return;
        });
        control._names.focus = '';
        control._setValid();
        _actioned.current = false;
    }, [
        fields,
        name,
        control
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($4Y8Vu))).useEffect(()=>{
        !$89763f9db12fbe81$export$3988ae62b71be9a3(control._formValues, name) && control._setFieldArray(name);
        return ()=>{
            const updateMounted = (name, value1)=>{
                const field = $89763f9db12fbe81$export$3988ae62b71be9a3(control._fields, name);
                if (field && field._f) field._f.mount = value1;
            };
            control._options.shouldUnregister || shouldUnregister ? control.unregister(name) : updateMounted(name, false);
        };
    }, [
        name,
        control,
        keyName,
        shouldUnregister
    ]);
    return {
        swap: (0, (/*@__PURE__*/$parcel$interopDefault($4Y8Vu))).useCallback(swap, [
            updateValues,
            name,
            control
        ]),
        move: (0, (/*@__PURE__*/$parcel$interopDefault($4Y8Vu))).useCallback(move, [
            updateValues,
            name,
            control
        ]),
        prepend: (0, (/*@__PURE__*/$parcel$interopDefault($4Y8Vu))).useCallback(prepend, [
            updateValues,
            name,
            control
        ]),
        append: (0, (/*@__PURE__*/$parcel$interopDefault($4Y8Vu))).useCallback(append, [
            updateValues,
            name,
            control
        ]),
        remove: (0, (/*@__PURE__*/$parcel$interopDefault($4Y8Vu))).useCallback(remove, [
            updateValues,
            name,
            control
        ]),
        insert: (0, (/*@__PURE__*/$parcel$interopDefault($4Y8Vu))).useCallback(insert$1, [
            updateValues,
            name,
            control
        ]),
        update: (0, (/*@__PURE__*/$parcel$interopDefault($4Y8Vu))).useCallback(update, [
            updateValues,
            name,
            control
        ]),
        replace: (0, (/*@__PURE__*/$parcel$interopDefault($4Y8Vu))).useCallback(replace, [
            updateValues,
            name,
            control
        ]),
        fields: (0, (/*@__PURE__*/$parcel$interopDefault($4Y8Vu))).useMemo(()=>fields.map((field, index)=>(0, $8f44472fa5eb25c0$export$71511d61b312f219)((0, $45c1a8590053a015$export$71511d61b312f219)({}, field), {
                    [keyName]: ids.current[index] || $89763f9db12fbe81$var$generateId()
                })), [
            fields,
            keyName
        ])
    };
}
/**
 * Custom hook to manage the entire form.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/useform) • [Demo](https://codesandbox.io/s/react-hook-form-get-started-ts-5ksmm) • [Video](https://www.youtube.com/watch?v=RkXv4AXXC_4)
 *
 * @param props - form configuration and validation parameters.
 *
 * @returns methods - individual functions to manage the form state. {@link UseFormReturn}
 *
 * @example
 * ```tsx
 * function App() {
 *   const { register, handleSubmit, watch, formState: { errors } } = useForm();
 *   const onSubmit = data => console.log(data);
 *
 *   console.log(watch("example"));
 *
 *   return (
 *     <form onSubmit={handleSubmit(onSubmit)}>
 *       <input defaultValue="test" {...register("example")} />
 *       <input {...register("exampleRequired", { required: true })} />
 *       {errors.exampleRequired && <span>This field is required</span>}
 *       <button>Submit</button>
 *     </form>
 *   );
 * }
 * ```
 */ function $89763f9db12fbe81$export$87c0cf8eb5a167e0(props = {}) {
    const _formControl = (0, (/*@__PURE__*/$parcel$interopDefault($4Y8Vu))).useRef(undefined);
    const _values = (0, (/*@__PURE__*/$parcel$interopDefault($4Y8Vu))).useRef(undefined);
    const [formState, updateFormState] = (0, (/*@__PURE__*/$parcel$interopDefault($4Y8Vu))).useState({
        isDirty: false,
        isValidating: false,
        isLoading: $89763f9db12fbe81$var$isFunction(props.defaultValues),
        isSubmitted: false,
        isSubmitting: false,
        isSubmitSuccessful: false,
        isValid: false,
        submitCount: 0,
        dirtyFields: {},
        touchedFields: {},
        validatingFields: {},
        errors: props.errors || {},
        disabled: props.disabled || false,
        isReady: false,
        defaultValues: $89763f9db12fbe81$var$isFunction(props.defaultValues) ? undefined : props.defaultValues
    });
    if (!_formControl.current) {
        _formControl.current = (0, $8f44472fa5eb25c0$export$71511d61b312f219)((0, $45c1a8590053a015$export$71511d61b312f219)({}, props.formControl ? props.formControl : $89763f9db12fbe81$export$1361f5e0e4cca3c3(props)), {
            formState: formState
        });
        if (props.formControl && props.defaultValues && !$89763f9db12fbe81$var$isFunction(props.defaultValues)) props.formControl.reset(props.defaultValues, props.resetOptions);
    }
    const control = _formControl.current.control;
    control._options = props;
    $89763f9db12fbe81$var$useIsomorphicLayoutEffect(()=>{
        const sub = control._subscribe({
            formState: control._proxyFormState,
            callback: ()=>updateFormState((0, $45c1a8590053a015$export$71511d61b312f219)({}, control._formState)),
            reRenderRoot: true
        });
        updateFormState((data)=>(0, $8f44472fa5eb25c0$export$71511d61b312f219)((0, $45c1a8590053a015$export$71511d61b312f219)({}, data), {
                isReady: true
            }));
        control._formState.isReady = true;
        return sub;
    }, [
        control
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($4Y8Vu))).useEffect(()=>control._disableForm(props.disabled), [
        control,
        props.disabled
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($4Y8Vu))).useEffect(()=>{
        if (props.mode) control._options.mode = props.mode;
        if (props.reValidateMode) control._options.reValidateMode = props.reValidateMode;
        if (props.errors && !$89763f9db12fbe81$var$isEmptyObject(props.errors)) control._setErrors(props.errors);
    }, [
        control,
        props.errors,
        props.mode,
        props.reValidateMode
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($4Y8Vu))).useEffect(()=>{
        props.shouldUnregister && control._subjects.state.next({
            values: control._getWatch()
        });
    }, [
        control,
        props.shouldUnregister
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($4Y8Vu))).useEffect(()=>{
        if (control._proxyFormState.isDirty) {
            const isDirty = control._getDirty();
            if (isDirty !== formState.isDirty) control._subjects.state.next({
                isDirty: isDirty
            });
        }
    }, [
        control,
        formState.isDirty
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($4Y8Vu))).useEffect(()=>{
        if (props.values && !$89763f9db12fbe81$var$deepEqual(props.values, _values.current)) {
            control._reset(props.values, control._options.resetOptions);
            _values.current = props.values;
            updateFormState((state)=>(0, $45c1a8590053a015$export$71511d61b312f219)({}, state));
        } else control._resetDefaultValues();
    }, [
        control,
        props.values
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($4Y8Vu))).useEffect(()=>{
        if (!control._state.mount) {
            control._setValid();
            control._state.mount = true;
        }
        if (control._state.watch) {
            control._state.watch = false;
            control._subjects.state.next((0, $45c1a8590053a015$export$71511d61b312f219)({}, control._formState));
        }
        control._removeUnmounted();
    });
    _formControl.current.formState = $89763f9db12fbe81$var$getProxyFormState(formState, control);
    return _formControl.current;
}






const $6480d1b415ba29cd$var$Input = (_param)=>{
    var { label: label, name: name, register: register, validation: validation, error: error, description: description } = _param, other = (0, $30c24b3cbf3b0a7a$export$71511d61b312f219)(_param, [
        "label",
        "name",
        "register",
        "validation",
        "error",
        "description"
    ]);
    return /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsxs)("div", {
        className: (0, $747032d831df0173$export$2e2bcd8739ae039)("form-group", !!(validation === null || validation === void 0 ? void 0 : validation.required) && "required", error && "invalid"),
        children: [
            /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)("label", {
                htmlFor: `${name}_input`,
                className: "form-label",
                children: label
            }),
            /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)("input", (0, $45c1a8590053a015$export$71511d61b312f219)({
                id: `${name}_input`,
                className: (0, $747032d831df0173$export$2e2bcd8739ae039)("form-control", error && "is-invalid"),
                placeholder: label
            }, register(name, validation), other)),
            error && /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)("div", {
                className: "invalid-feedback",
                children: error.message
            }),
            description && !error && /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)("div", {
                className: "helper-feedback",
                children: description
            })
        ]
    });
};
var $6480d1b415ba29cd$export$2e2bcd8739ae039 = $6480d1b415ba29cd$var$Input;







function $40a2a7eb710615d7$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $40a2a7eb710615d7$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $40a2a7eb710615d7$export$2e2bcd8739ae039(o);
}



function $68fc127c850a54c1$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $40a2a7eb710615d7$export$2e2bcd8739ae039)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $40a2a7eb710615d7$export$2e2bcd8739ae039)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}


function $3d63d0f245d0ecc4$export$2e2bcd8739ae039(t) {
    var i = (0, $68fc127c850a54c1$export$2e2bcd8739ae039)(t, "string");
    return "symbol" == (0, $40a2a7eb710615d7$export$2e2bcd8739ae039)(i) ? i : i + "";
}


function $29be98d1fcef7677$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $3d63d0f245d0ecc4$export$2e2bcd8739ae039)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}


function $0c8ebbb95bc6bc2e$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $0c8ebbb95bc6bc2e$export$2e2bcd8739ae039(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $0c8ebbb95bc6bc2e$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $29be98d1fcef7677$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $0c8ebbb95bc6bc2e$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}


function $7b498f39b286adb4$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return r;
}


function $44ac9d4686bbad7f$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}


function $cb187b83f3c21a33$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}


function $ccadaaeaaa4030f6$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $cb187b83f3c21a33$export$2e2bcd8739ae039)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $cb187b83f3c21a33$export$2e2bcd8739ae039)(r, a) : void 0;
    }
}


function $465b0f63931feb99$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $a4d069dc93b26bb4$export$2e2bcd8739ae039(r, e) {
    return (0, $7b498f39b286adb4$export$2e2bcd8739ae039)(r) || (0, $44ac9d4686bbad7f$export$2e2bcd8739ae039)(r, e) || (0, $ccadaaeaaa4030f6$export$2e2bcd8739ae039)(r, e) || (0, $465b0f63931feb99$export$2e2bcd8739ae039)();
}


function $15707d6ca67adf63$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}


function $deeae5c1248a0831$export$2e2bcd8739ae039(e, t) {
    if (null == e) return {};
    var o, r, i = (0, $15707d6ca67adf63$export$2e2bcd8739ae039)(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}



var $4Y8Vu = parcelRequire("4Y8Vu");
var $877df46b331c347f$var$_excluded = [
    "defaultInputValue",
    "defaultMenuIsOpen",
    "defaultValue",
    "inputValue",
    "menuIsOpen",
    "onChange",
    "onInputChange",
    "onMenuClose",
    "onMenuOpen",
    "value"
];
function $877df46b331c347f$export$3b14a55fb2447963(_ref) {
    var _ref$defaultInputValu = _ref.defaultInputValue, defaultInputValue = _ref$defaultInputValu === void 0 ? '' : _ref$defaultInputValu, _ref$defaultMenuIsOpe = _ref.defaultMenuIsOpen, defaultMenuIsOpen = _ref$defaultMenuIsOpe === void 0 ? false : _ref$defaultMenuIsOpe, _ref$defaultValue = _ref.defaultValue, defaultValue = _ref$defaultValue === void 0 ? null : _ref$defaultValue, propsInputValue = _ref.inputValue, propsMenuIsOpen = _ref.menuIsOpen, propsOnChange = _ref.onChange, propsOnInputChange = _ref.onInputChange, propsOnMenuClose = _ref.onMenuClose, propsOnMenuOpen = _ref.onMenuOpen, propsValue = _ref.value, restSelectProps = (0, $deeae5c1248a0831$export$2e2bcd8739ae039)(_ref, $877df46b331c347f$var$_excluded);
    var _useState = (0, $4Y8Vu.useState)(propsInputValue !== undefined ? propsInputValue : defaultInputValue), _useState2 = (0, $a4d069dc93b26bb4$export$2e2bcd8739ae039)(_useState, 2), stateInputValue = _useState2[0], setStateInputValue = _useState2[1];
    var _useState3 = (0, $4Y8Vu.useState)(propsMenuIsOpen !== undefined ? propsMenuIsOpen : defaultMenuIsOpen), _useState4 = (0, $a4d069dc93b26bb4$export$2e2bcd8739ae039)(_useState3, 2), stateMenuIsOpen = _useState4[0], setStateMenuIsOpen = _useState4[1];
    var _useState5 = (0, $4Y8Vu.useState)(propsValue !== undefined ? propsValue : defaultValue), _useState6 = (0, $a4d069dc93b26bb4$export$2e2bcd8739ae039)(_useState5, 2), stateValue = _useState6[0], setStateValue = _useState6[1];
    var onChange = (0, $4Y8Vu.useCallback)(function(value, actionMeta) {
        if (typeof propsOnChange === 'function') propsOnChange(value, actionMeta);
        setStateValue(value);
    }, [
        propsOnChange
    ]);
    var onInputChange = (0, $4Y8Vu.useCallback)(function(value, actionMeta) {
        var newValue;
        if (typeof propsOnInputChange === 'function') newValue = propsOnInputChange(value, actionMeta);
        setStateInputValue(newValue !== undefined ? newValue : value);
    }, [
        propsOnInputChange
    ]);
    var onMenuOpen = (0, $4Y8Vu.useCallback)(function() {
        if (typeof propsOnMenuOpen === 'function') propsOnMenuOpen();
        setStateMenuIsOpen(true);
    }, [
        propsOnMenuOpen
    ]);
    var onMenuClose = (0, $4Y8Vu.useCallback)(function() {
        if (typeof propsOnMenuClose === 'function') propsOnMenuClose();
        setStateMenuIsOpen(false);
    }, [
        propsOnMenuClose
    ]);
    var inputValue = propsInputValue !== undefined ? propsInputValue : stateInputValue;
    var menuIsOpen = propsMenuIsOpen !== undefined ? propsMenuIsOpen : stateMenuIsOpen;
    var value = propsValue !== undefined ? propsValue : stateValue;
    return (0, $0c8ebbb95bc6bc2e$export$2e2bcd8739ae039)((0, $0c8ebbb95bc6bc2e$export$2e2bcd8739ae039)({}, restSelectProps), {}, {
        inputValue: inputValue,
        menuIsOpen: menuIsOpen,
        onChange: onChange,
        onInputChange: onInputChange,
        onMenuClose: onMenuClose,
        onMenuOpen: onMenuOpen,
        value: value
    });
}




var $4Y8Vu = parcelRequire("4Y8Vu");


function $81bb1a2b496df09f$export$2e2bcd8739ae039(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}



function $6f13d1f555b04ae4$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, $3d63d0f245d0ecc4$export$2e2bcd8739ae039)(o.key), o);
    }
}
function $6f13d1f555b04ae4$export$2e2bcd8739ae039(e, r, t) {
    return r && $6f13d1f555b04ae4$var$_defineProperties(e.prototype, r), t && $6f13d1f555b04ae4$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}



function $31682117dcc79013$export$2e2bcd8739ae039(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && (0, $86863928c474254f$export$2e2bcd8739ae039)(t, e);
}


function $c8d2c21320fe7af0$export$2e2bcd8739ae039(t) {
    return $c8d2c21320fe7af0$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, $c8d2c21320fe7af0$export$2e2bcd8739ae039(t);
}


function $c9eec81bbacaf9f7$export$2e2bcd8739ae039() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($c9eec81bbacaf9f7$export$2e2bcd8739ae039 = function _isNativeReflectConstruct() {
        return !!t;
    })();
}



function $62bd62033e65cf67$export$2e2bcd8739ae039(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}


function $541160cfa3f4c3f7$export$2e2bcd8739ae039(t, e) {
    if (e && ("object" == (0, $40a2a7eb710615d7$export$2e2bcd8739ae039)(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $62bd62033e65cf67$export$2e2bcd8739ae039)(t);
}


function $f45d8b2d8250d322$export$2e2bcd8739ae039(t) {
    var r = (0, $c9eec81bbacaf9f7$export$2e2bcd8739ae039)();
    return function() {
        var e, o = (0, $c8d2c21320fe7af0$export$2e2bcd8739ae039)(t);
        if (r) {
            var s = (0, $c8d2c21320fe7af0$export$2e2bcd8739ae039)(this).constructor;
            e = Reflect.construct(o, arguments, s);
        } else e = o.apply(this, arguments);
        return (0, $541160cfa3f4c3f7$export$2e2bcd8739ae039)(this, e);
    };
}



function $559fdf4055896527$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return (0, $cb187b83f3c21a33$export$2e2bcd8739ae039)(r);
}


function $e558b678779a8acf$export$2e2bcd8739ae039(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}



function $d3f38378b65f7d98$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $b227d8d9cf911b9e$export$2e2bcd8739ae039(r) {
    return (0, $559fdf4055896527$export$2e2bcd8739ae039)(r) || (0, $e558b678779a8acf$export$2e2bcd8739ae039)(r) || (0, $ccadaaeaaa4030f6$export$2e2bcd8739ae039)(r) || (0, $d3f38378b65f7d98$export$2e2bcd8739ae039)();
}



var $4Y8Vu = parcelRequire("4Y8Vu");



var $4Y8Vu = parcelRequire("4Y8Vu");
var $bd685f657870ad68$var$isDevelopment = false;
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ function $bd685f657870ad68$var$sheetForTag(tag) {
    if (tag.sheet) return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) return document.styleSheets[i];
    } // this function should always return with a value
    // TS can't understand it though so we make it stop complaining here
    return undefined;
}
function $bd685f657870ad68$var$createStyleElement(options) {
    var tag = document.createElement('style');
    tag.setAttribute('data-emotion', options.key);
    if (options.nonce !== undefined) tag.setAttribute('nonce', options.nonce);
    tag.appendChild(document.createTextNode(''));
    tag.setAttribute('data-s', '');
    return tag;
}
var $bd685f657870ad68$export$9d753cd7ae895cce = /*#__PURE__*/ function() {
    // Using Node instead of HTMLElement since container may be a ShadowRoot
    function StyleSheet(options) {
        var _this = this;
        this._insertTag = function(tag) {
            var before;
            if (_this.tags.length === 0) {
                if (_this.insertionPoint) before = _this.insertionPoint.nextSibling;
                else if (_this.prepend) before = _this.container.firstChild;
                else before = _this.before;
            } else before = _this.tags[_this.tags.length - 1].nextSibling;
            _this.container.insertBefore(tag, before);
            _this.tags.push(tag);
        };
        this.isSpeedy = options.speedy === undefined ? !$bd685f657870ad68$var$isDevelopment : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.prepend = options.prepend;
        this.insertionPoint = options.insertionPoint;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.hydrate = function hydrate(nodes) {
        nodes.forEach(this._insertTag);
    };
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) this._insertTag($bd685f657870ad68$var$createStyleElement(this));
        var tag = this.tags[this.tags.length - 1];
        if (this.isSpeedy) {
            var sheet = $bd685f657870ad68$var$sheetForTag(tag);
            try {
                // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, sheet.cssRules.length);
            } catch (e) {}
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        this.tags.forEach(function(tag) {
            var _tag$parentNode;
            return (_tag$parentNode = tag.parentNode) == null ? void 0 : _tag$parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
    };
    return StyleSheet;
}();


var $7c552ad2d6ae7e60$export$71ad59f2e432cfe8 = "-ms-";
var $7c552ad2d6ae7e60$export$2c0f367103c8d01c = "-moz-";
var $7c552ad2d6ae7e60$export$39dfd62a25e0fe93 = "-webkit-";
var $7c552ad2d6ae7e60$export$a29989082612d0d9 = "comm";
var $7c552ad2d6ae7e60$export$aa3a2e812ca8570d = "rule";
var $7c552ad2d6ae7e60$export$527d108ccf083c2b = "decl";
var $7c552ad2d6ae7e60$export$d3d35020fa5b54f0 = "@page";
var $7c552ad2d6ae7e60$export$500415a86c544f73 = "@media";
var $7c552ad2d6ae7e60$export$a763edbf796b780a = "@import";
var $7c552ad2d6ae7e60$export$2790aeb8b4e5c826 = "@charset";
var $7c552ad2d6ae7e60$export$1cc683e23b84b133 = "@viewport";
var $7c552ad2d6ae7e60$export$9447a5efea57e862 = "@supports";
var $7c552ad2d6ae7e60$export$ef011b4e114b1fba = "@document";
var $7c552ad2d6ae7e60$export$6aad947bda0f3f46 = "@namespace";
var $7c552ad2d6ae7e60$export$b44a8529a35fcb60 = "@keyframes";
var $7c552ad2d6ae7e60$export$2c16de31893252e6 = "@font-face";
var $7c552ad2d6ae7e60$export$3d846dd52e150c6f = "@counter-style";
var $7c552ad2d6ae7e60$export$22314bfbb57653fe = "@font-feature-values";
var $7c552ad2d6ae7e60$export$d773506282b3cfe6 = "@layer";
var $7c552ad2d6ae7e60$export$2335f513bbd82c6d = Math.abs;
var $7c552ad2d6ae7e60$export$6788812c4e6611e6 = String.fromCharCode;
var $7c552ad2d6ae7e60$export$e6e34fd1f2686227 = Object.assign;
function $7c552ad2d6ae7e60$export$d6af199866bfb566(e, r) {
    return $7c552ad2d6ae7e60$export$a9db5e087081082d(e, 0) ^ 45 ? (((r << 2 ^ $7c552ad2d6ae7e60$export$a9db5e087081082d(e, 0)) << 2 ^ $7c552ad2d6ae7e60$export$a9db5e087081082d(e, 1)) << 2 ^ $7c552ad2d6ae7e60$export$a9db5e087081082d(e, 2)) << 2 ^ $7c552ad2d6ae7e60$export$a9db5e087081082d(e, 3) : 0;
}
function $7c552ad2d6ae7e60$export$87c2784dc9fc4ab(e) {
    return e.trim();
}
function $7c552ad2d6ae7e60$export$4659b591c19bdf3d(e, r) {
    return (e = r.exec(e)) ? e[0] : e;
}
function $7c552ad2d6ae7e60$export$77ad94ebf1c2b9ed(e, r, a) {
    return e.replace(r, a);
}
function $7c552ad2d6ae7e60$export$f8e21b1e77979a08(e, r) {
    return e.indexOf(r);
}
function $7c552ad2d6ae7e60$export$a9db5e087081082d(e, r) {
    return e.charCodeAt(r) | 0;
}
function $7c552ad2d6ae7e60$export$2f35ab04d2335697(e, r, a) {
    return e.slice(r, a);
}
function $7c552ad2d6ae7e60$export$36776f635604f274(e) {
    return e.length;
}
function $7c552ad2d6ae7e60$export$f9084667e487ed46(e) {
    return e.length;
}
function $7c552ad2d6ae7e60$export$10d8903dec122b9d(e, r) {
    return r.push(e), e;
}
function $7c552ad2d6ae7e60$export$1be1fc439b849fdf(e, r) {
    return e.map(r).join("");
}
var $7c552ad2d6ae7e60$export$53f1d5ea8de3d7c = 1;
var $7c552ad2d6ae7e60$export$4e0c71f277ca26b3 = 1;
var $7c552ad2d6ae7e60$export$f24224f1c91d8156 = 0;
var $7c552ad2d6ae7e60$export$5880b8b5730aff45 = 0;
var $7c552ad2d6ae7e60$export$c0306caf338ac095 = 0;
var $7c552ad2d6ae7e60$export$30a86d91af8ff6e6 = "";
function $7c552ad2d6ae7e60$export$35059013cd4a06db(e, r, a, n, c, s, t) {
    return {
        value: e,
        root: r,
        parent: a,
        type: n,
        props: c,
        children: s,
        line: $7c552ad2d6ae7e60$export$53f1d5ea8de3d7c,
        column: $7c552ad2d6ae7e60$export$4e0c71f277ca26b3,
        length: t,
        return: ""
    };
}
function $7c552ad2d6ae7e60$export$784d13d8ee351f07(e, r) {
    return $7c552ad2d6ae7e60$export$e6e34fd1f2686227($7c552ad2d6ae7e60$export$35059013cd4a06db("", null, null, "", null, null, 0), e, {
        length: -e.length
    }, r);
}
function $7c552ad2d6ae7e60$export$eba6f6f03b0a92e7() {
    return $7c552ad2d6ae7e60$export$c0306caf338ac095;
}
function $7c552ad2d6ae7e60$export$232faf9add678146() {
    $7c552ad2d6ae7e60$export$c0306caf338ac095 = $7c552ad2d6ae7e60$export$5880b8b5730aff45 > 0 ? $7c552ad2d6ae7e60$export$a9db5e087081082d($7c552ad2d6ae7e60$export$30a86d91af8ff6e6, --$7c552ad2d6ae7e60$export$5880b8b5730aff45) : 0;
    if ($7c552ad2d6ae7e60$export$4e0c71f277ca26b3--, $7c552ad2d6ae7e60$export$c0306caf338ac095 === 10) $7c552ad2d6ae7e60$export$4e0c71f277ca26b3 = 1, $7c552ad2d6ae7e60$export$53f1d5ea8de3d7c--;
    return $7c552ad2d6ae7e60$export$c0306caf338ac095;
}
function $7c552ad2d6ae7e60$export$48cfd1e771a65c4f() {
    $7c552ad2d6ae7e60$export$c0306caf338ac095 = $7c552ad2d6ae7e60$export$5880b8b5730aff45 < $7c552ad2d6ae7e60$export$f24224f1c91d8156 ? $7c552ad2d6ae7e60$export$a9db5e087081082d($7c552ad2d6ae7e60$export$30a86d91af8ff6e6, $7c552ad2d6ae7e60$export$5880b8b5730aff45++) : 0;
    if ($7c552ad2d6ae7e60$export$4e0c71f277ca26b3++, $7c552ad2d6ae7e60$export$c0306caf338ac095 === 10) $7c552ad2d6ae7e60$export$4e0c71f277ca26b3 = 1, $7c552ad2d6ae7e60$export$53f1d5ea8de3d7c++;
    return $7c552ad2d6ae7e60$export$c0306caf338ac095;
}
function $7c552ad2d6ae7e60$export$4d3fb11e950abb9e() {
    return $7c552ad2d6ae7e60$export$a9db5e087081082d($7c552ad2d6ae7e60$export$30a86d91af8ff6e6, $7c552ad2d6ae7e60$export$5880b8b5730aff45);
}
function $7c552ad2d6ae7e60$export$e88cb2efb12ae807() {
    return $7c552ad2d6ae7e60$export$5880b8b5730aff45;
}
function $7c552ad2d6ae7e60$export$58adb3bec8346d0f(e, r) {
    return $7c552ad2d6ae7e60$export$2f35ab04d2335697($7c552ad2d6ae7e60$export$30a86d91af8ff6e6, e, r);
}
function $7c552ad2d6ae7e60$export$9e1725a4cfeada27(e) {
    switch(e){
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        case 59:
        case 123:
        case 125:
            return 4;
        case 58:
            return 3;
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $7c552ad2d6ae7e60$export$2de70f21292aac9e(e) {
    return $7c552ad2d6ae7e60$export$53f1d5ea8de3d7c = $7c552ad2d6ae7e60$export$4e0c71f277ca26b3 = 1, $7c552ad2d6ae7e60$export$f24224f1c91d8156 = $7c552ad2d6ae7e60$export$36776f635604f274($7c552ad2d6ae7e60$export$30a86d91af8ff6e6 = e), $7c552ad2d6ae7e60$export$5880b8b5730aff45 = 0, [];
}
function $7c552ad2d6ae7e60$export$45918ac1574455b1(e) {
    return $7c552ad2d6ae7e60$export$30a86d91af8ff6e6 = "", e;
}
function $7c552ad2d6ae7e60$export$410ac95b9ec204b8(e) {
    return $7c552ad2d6ae7e60$export$87c2784dc9fc4ab($7c552ad2d6ae7e60$export$58adb3bec8346d0f($7c552ad2d6ae7e60$export$5880b8b5730aff45 - 1, $7c552ad2d6ae7e60$export$c889f2fcc19dbf12(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function $7c552ad2d6ae7e60$export$660b2ee2d4fb4eff(e) {
    return $7c552ad2d6ae7e60$export$45918ac1574455b1($7c552ad2d6ae7e60$export$5f8c09e3ae6f64e1($7c552ad2d6ae7e60$export$2de70f21292aac9e(e)));
}
function $7c552ad2d6ae7e60$export$7af1228ff777d175(e) {
    while($7c552ad2d6ae7e60$export$c0306caf338ac095 = $7c552ad2d6ae7e60$export$4d3fb11e950abb9e())if ($7c552ad2d6ae7e60$export$c0306caf338ac095 < 33) $7c552ad2d6ae7e60$export$48cfd1e771a65c4f();
    else break;
    return $7c552ad2d6ae7e60$export$9e1725a4cfeada27(e) > 2 || $7c552ad2d6ae7e60$export$9e1725a4cfeada27($7c552ad2d6ae7e60$export$c0306caf338ac095) > 3 ? "" : " ";
}
function $7c552ad2d6ae7e60$export$5f8c09e3ae6f64e1(e) {
    while($7c552ad2d6ae7e60$export$48cfd1e771a65c4f())switch($7c552ad2d6ae7e60$export$9e1725a4cfeada27($7c552ad2d6ae7e60$export$c0306caf338ac095)){
        case 0:
            $7c552ad2d6ae7e60$export$10d8903dec122b9d($7c552ad2d6ae7e60$export$c2ab62c7bf24634($7c552ad2d6ae7e60$export$5880b8b5730aff45 - 1), e);
            break;
        case 2:
            $7c552ad2d6ae7e60$export$10d8903dec122b9d($7c552ad2d6ae7e60$export$410ac95b9ec204b8($7c552ad2d6ae7e60$export$c0306caf338ac095), e);
            break;
        default:
            $7c552ad2d6ae7e60$export$10d8903dec122b9d($7c552ad2d6ae7e60$export$6788812c4e6611e6($7c552ad2d6ae7e60$export$c0306caf338ac095), e);
    }
    return e;
}
function $7c552ad2d6ae7e60$export$955ba06d119e085e(e, r) {
    while(--r && $7c552ad2d6ae7e60$export$48cfd1e771a65c4f())if ($7c552ad2d6ae7e60$export$c0306caf338ac095 < 48 || $7c552ad2d6ae7e60$export$c0306caf338ac095 > 102 || $7c552ad2d6ae7e60$export$c0306caf338ac095 > 57 && $7c552ad2d6ae7e60$export$c0306caf338ac095 < 65 || $7c552ad2d6ae7e60$export$c0306caf338ac095 > 70 && $7c552ad2d6ae7e60$export$c0306caf338ac095 < 97) break;
    return $7c552ad2d6ae7e60$export$58adb3bec8346d0f(e, $7c552ad2d6ae7e60$export$e88cb2efb12ae807() + (r < 6 && $7c552ad2d6ae7e60$export$4d3fb11e950abb9e() == 32 && $7c552ad2d6ae7e60$export$48cfd1e771a65c4f() == 32));
}
function $7c552ad2d6ae7e60$export$c889f2fcc19dbf12(e) {
    while($7c552ad2d6ae7e60$export$48cfd1e771a65c4f())switch($7c552ad2d6ae7e60$export$c0306caf338ac095){
        case e:
            return $7c552ad2d6ae7e60$export$5880b8b5730aff45;
        case 34:
        case 39:
            if (e !== 34 && e !== 39) $7c552ad2d6ae7e60$export$c889f2fcc19dbf12($7c552ad2d6ae7e60$export$c0306caf338ac095);
            break;
        case 40:
            if (e === 41) $7c552ad2d6ae7e60$export$c889f2fcc19dbf12(e);
            break;
        case 92:
            $7c552ad2d6ae7e60$export$48cfd1e771a65c4f();
            break;
    }
    return $7c552ad2d6ae7e60$export$5880b8b5730aff45;
}
function $7c552ad2d6ae7e60$export$4254d4e2b3745c4c(e, r) {
    while($7c552ad2d6ae7e60$export$48cfd1e771a65c4f())if (e + $7c552ad2d6ae7e60$export$c0306caf338ac095 === 57) break;
    else if (e + $7c552ad2d6ae7e60$export$c0306caf338ac095 === 84 && $7c552ad2d6ae7e60$export$4d3fb11e950abb9e() === 47) break;
    return "/*" + $7c552ad2d6ae7e60$export$58adb3bec8346d0f(r, $7c552ad2d6ae7e60$export$5880b8b5730aff45 - 1) + "*" + $7c552ad2d6ae7e60$export$6788812c4e6611e6(e === 47 ? e : $7c552ad2d6ae7e60$export$48cfd1e771a65c4f());
}
function $7c552ad2d6ae7e60$export$c2ab62c7bf24634(e) {
    while(!$7c552ad2d6ae7e60$export$9e1725a4cfeada27($7c552ad2d6ae7e60$export$4d3fb11e950abb9e()))$7c552ad2d6ae7e60$export$48cfd1e771a65c4f();
    return $7c552ad2d6ae7e60$export$58adb3bec8346d0f(e, $7c552ad2d6ae7e60$export$5880b8b5730aff45);
}
function $7c552ad2d6ae7e60$export$ef7acd7185315e22(e) {
    return $7c552ad2d6ae7e60$export$45918ac1574455b1($7c552ad2d6ae7e60$export$98e6a39c04603d36("", null, null, null, [
        ""
    ], e = $7c552ad2d6ae7e60$export$2de70f21292aac9e(e), 0, [
        0
    ], e));
}
function $7c552ad2d6ae7e60$export$98e6a39c04603d36(e, r, a, n, c, s, t, u, i) {
    var f = 0;
    var o = 0;
    var l = t;
    var v = 0;
    var p = 0;
    var h = 0;
    var b = 1;
    var w = 1;
    var d = 1;
    var $ = 0;
    var g = "";
    var m = c;
    var x = s;
    var y = n;
    var j = g;
    while(w)switch(h = $, $ = $7c552ad2d6ae7e60$export$48cfd1e771a65c4f()){
        case 40:
            if (h != 108 && $7c552ad2d6ae7e60$export$a9db5e087081082d(j, l - 1) == 58) {
                if ($7c552ad2d6ae7e60$export$f8e21b1e77979a08(j += $7c552ad2d6ae7e60$export$77ad94ebf1c2b9ed($7c552ad2d6ae7e60$export$410ac95b9ec204b8($), "&", "&\f"), "&\f") != -1) d = -1;
                break;
            }
        case 34:
        case 39:
        case 91:
            j += $7c552ad2d6ae7e60$export$410ac95b9ec204b8($);
            break;
        case 9:
        case 10:
        case 13:
        case 32:
            j += $7c552ad2d6ae7e60$export$7af1228ff777d175(h);
            break;
        case 92:
            j += $7c552ad2d6ae7e60$export$955ba06d119e085e($7c552ad2d6ae7e60$export$e88cb2efb12ae807() - 1, 7);
            continue;
        case 47:
            switch($7c552ad2d6ae7e60$export$4d3fb11e950abb9e()){
                case 42:
                case 47:
                    $7c552ad2d6ae7e60$export$10d8903dec122b9d($7c552ad2d6ae7e60$export$4a34f930e789283c($7c552ad2d6ae7e60$export$4254d4e2b3745c4c($7c552ad2d6ae7e60$export$48cfd1e771a65c4f(), $7c552ad2d6ae7e60$export$e88cb2efb12ae807()), r, a), i);
                    break;
                default:
                    j += "/";
            }
            break;
        case 123 * b:
            u[f++] = $7c552ad2d6ae7e60$export$36776f635604f274(j) * d;
        case 125 * b:
        case 59:
        case 0:
            switch($){
                case 0:
                case 125:
                    w = 0;
                case 59 + o:
                    if (d == -1) j = $7c552ad2d6ae7e60$export$77ad94ebf1c2b9ed(j, /\f/g, "");
                    if (p > 0 && $7c552ad2d6ae7e60$export$36776f635604f274(j) - l) $7c552ad2d6ae7e60$export$10d8903dec122b9d(p > 32 ? $7c552ad2d6ae7e60$export$f8483753829ec8f3(j + ";", n, a, l - 1) : $7c552ad2d6ae7e60$export$f8483753829ec8f3($7c552ad2d6ae7e60$export$77ad94ebf1c2b9ed(j, " ", "") + ";", n, a, l - 2), i);
                    break;
                case 59:
                    j += ";";
                default:
                    $7c552ad2d6ae7e60$export$10d8903dec122b9d(y = $7c552ad2d6ae7e60$export$3307ffa7023ede1e(j, r, a, f, o, c, u, g, m = [], x = [], l), s);
                    if ($ === 123) {
                        if (o === 0) $7c552ad2d6ae7e60$export$98e6a39c04603d36(j, r, y, y, m, s, l, u, x);
                        else switch(v === 99 && $7c552ad2d6ae7e60$export$a9db5e087081082d(j, 3) === 110 ? 100 : v){
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                $7c552ad2d6ae7e60$export$98e6a39c04603d36(e, y, y, n && $7c552ad2d6ae7e60$export$10d8903dec122b9d($7c552ad2d6ae7e60$export$3307ffa7023ede1e(e, y, y, 0, 0, c, u, g, c, m = [], l), x), c, x, l, u, n ? m : x);
                                break;
                            default:
                                $7c552ad2d6ae7e60$export$98e6a39c04603d36(j, y, y, y, [
                                    ""
                                ], x, 0, u, x);
                        }
                    }
            }
            f = o = p = 0, b = d = 1, g = j = "", l = t;
            break;
        case 58:
            l = 1 + $7c552ad2d6ae7e60$export$36776f635604f274(j), p = h;
        default:
            if (b < 1) {
                if ($ == 123) --b;
                else if ($ == 125 && b++ == 0 && $7c552ad2d6ae7e60$export$232faf9add678146() == 125) continue;
            }
            switch(j += $7c552ad2d6ae7e60$export$6788812c4e6611e6($), $ * b){
                case 38:
                    d = o > 0 ? 1 : (j += "\f", -1);
                    break;
                case 44:
                    u[f++] = ($7c552ad2d6ae7e60$export$36776f635604f274(j) - 1) * d, d = 1;
                    break;
                case 64:
                    if ($7c552ad2d6ae7e60$export$4d3fb11e950abb9e() === 45) j += $7c552ad2d6ae7e60$export$410ac95b9ec204b8($7c552ad2d6ae7e60$export$48cfd1e771a65c4f());
                    v = $7c552ad2d6ae7e60$export$4d3fb11e950abb9e(), o = l = $7c552ad2d6ae7e60$export$36776f635604f274(g = j += $7c552ad2d6ae7e60$export$c2ab62c7bf24634($7c552ad2d6ae7e60$export$e88cb2efb12ae807())), $++;
                    break;
                case 45:
                    if (h === 45 && $7c552ad2d6ae7e60$export$36776f635604f274(j) == 2) b = 0;
            }
    }
    return s;
}
function $7c552ad2d6ae7e60$export$3307ffa7023ede1e(e, r, a, n, s, t, u, i, f, o, l) {
    var v = s - 1;
    var p = s === 0 ? t : [
        ""
    ];
    var h = $7c552ad2d6ae7e60$export$f9084667e487ed46(p);
    for(var b = 0, w = 0, d = 0; b < n; ++b)for(var $ = 0, k = $7c552ad2d6ae7e60$export$2f35ab04d2335697(e, v + 1, v = $7c552ad2d6ae7e60$export$2335f513bbd82c6d(w = u[b])), m = e; $ < h; ++$)if (m = $7c552ad2d6ae7e60$export$87c2784dc9fc4ab(w > 0 ? p[$] + " " + k : $7c552ad2d6ae7e60$export$77ad94ebf1c2b9ed(k, /&\f/g, p[$]))) f[d++] = m;
    return $7c552ad2d6ae7e60$export$35059013cd4a06db(e, r, a, s === 0 ? $7c552ad2d6ae7e60$export$aa3a2e812ca8570d : i, f, o, l);
}
function $7c552ad2d6ae7e60$export$4a34f930e789283c(e, r, a) {
    return $7c552ad2d6ae7e60$export$35059013cd4a06db(e, r, a, $7c552ad2d6ae7e60$export$a29989082612d0d9, $7c552ad2d6ae7e60$export$6788812c4e6611e6($7c552ad2d6ae7e60$export$eba6f6f03b0a92e7()), $7c552ad2d6ae7e60$export$2f35ab04d2335697(e, 2, -2), 0);
}
function $7c552ad2d6ae7e60$export$f8483753829ec8f3(e, r, a, n) {
    return $7c552ad2d6ae7e60$export$35059013cd4a06db(e, r, a, $7c552ad2d6ae7e60$export$527d108ccf083c2b, $7c552ad2d6ae7e60$export$2f35ab04d2335697(e, 0, n), $7c552ad2d6ae7e60$export$2f35ab04d2335697(e, n + 1, -1), n);
}
function $7c552ad2d6ae7e60$export$82e9f45cca5ba907(n, c, s) {
    switch($7c552ad2d6ae7e60$export$d6af199866bfb566(n, c)){
        case 5103:
            return $7c552ad2d6ae7e60$export$39dfd62a25e0fe93 + "print-" + n + n;
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return $7c552ad2d6ae7e60$export$39dfd62a25e0fe93 + n + n;
        case 4789:
            return $7c552ad2d6ae7e60$export$2c0f367103c8d01c + n + n;
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return $7c552ad2d6ae7e60$export$39dfd62a25e0fe93 + n + $7c552ad2d6ae7e60$export$2c0f367103c8d01c + n + $7c552ad2d6ae7e60$export$71ad59f2e432cfe8 + n + n;
        case 5936:
            switch($7c552ad2d6ae7e60$export$a9db5e087081082d(n, c + 11)){
                case 114:
                    return $7c552ad2d6ae7e60$export$39dfd62a25e0fe93 + n + $7c552ad2d6ae7e60$export$71ad59f2e432cfe8 + $7c552ad2d6ae7e60$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb") + n;
                case 108:
                    return $7c552ad2d6ae7e60$export$39dfd62a25e0fe93 + n + $7c552ad2d6ae7e60$export$71ad59f2e432cfe8 + $7c552ad2d6ae7e60$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb-rl") + n;
                case 45:
                    return $7c552ad2d6ae7e60$export$39dfd62a25e0fe93 + n + $7c552ad2d6ae7e60$export$71ad59f2e432cfe8 + $7c552ad2d6ae7e60$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "lr") + n;
            }
        case 6828:
        case 4268:
        case 2903:
            return $7c552ad2d6ae7e60$export$39dfd62a25e0fe93 + n + $7c552ad2d6ae7e60$export$71ad59f2e432cfe8 + n + n;
        case 6165:
            return $7c552ad2d6ae7e60$export$39dfd62a25e0fe93 + n + $7c552ad2d6ae7e60$export$71ad59f2e432cfe8 + "flex-" + n + n;
        case 5187:
            return $7c552ad2d6ae7e60$export$39dfd62a25e0fe93 + n + $7c552ad2d6ae7e60$export$77ad94ebf1c2b9ed(n, /(\w+).+(:[^]+)/, $7c552ad2d6ae7e60$export$39dfd62a25e0fe93 + "box-$1$2" + $7c552ad2d6ae7e60$export$71ad59f2e432cfe8 + "flex-$1$2") + n;
        case 5443:
            return $7c552ad2d6ae7e60$export$39dfd62a25e0fe93 + n + $7c552ad2d6ae7e60$export$71ad59f2e432cfe8 + "flex-item-" + $7c552ad2d6ae7e60$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") + (!$7c552ad2d6ae7e60$export$4659b591c19bdf3d(n, /flex-|baseline/) ? $7c552ad2d6ae7e60$export$71ad59f2e432cfe8 + "grid-row-" + $7c552ad2d6ae7e60$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") : "") + n;
        case 4675:
            return $7c552ad2d6ae7e60$export$39dfd62a25e0fe93 + n + $7c552ad2d6ae7e60$export$71ad59f2e432cfe8 + "flex-line-pack" + $7c552ad2d6ae7e60$export$77ad94ebf1c2b9ed(n, /align-content|flex-|-self/g, "") + n;
        case 5548:
            return $7c552ad2d6ae7e60$export$39dfd62a25e0fe93 + n + $7c552ad2d6ae7e60$export$71ad59f2e432cfe8 + $7c552ad2d6ae7e60$export$77ad94ebf1c2b9ed(n, "shrink", "negative") + n;
        case 5292:
            return $7c552ad2d6ae7e60$export$39dfd62a25e0fe93 + n + $7c552ad2d6ae7e60$export$71ad59f2e432cfe8 + $7c552ad2d6ae7e60$export$77ad94ebf1c2b9ed(n, "basis", "preferred-size") + n;
        case 6060:
            return $7c552ad2d6ae7e60$export$39dfd62a25e0fe93 + "box-" + $7c552ad2d6ae7e60$export$77ad94ebf1c2b9ed(n, "-grow", "") + $7c552ad2d6ae7e60$export$39dfd62a25e0fe93 + n + $7c552ad2d6ae7e60$export$71ad59f2e432cfe8 + $7c552ad2d6ae7e60$export$77ad94ebf1c2b9ed(n, "grow", "positive") + n;
        case 4554:
            return $7c552ad2d6ae7e60$export$39dfd62a25e0fe93 + $7c552ad2d6ae7e60$export$77ad94ebf1c2b9ed(n, /([^-])(transform)/g, "$1" + $7c552ad2d6ae7e60$export$39dfd62a25e0fe93 + "$2") + n;
        case 6187:
            return $7c552ad2d6ae7e60$export$77ad94ebf1c2b9ed($7c552ad2d6ae7e60$export$77ad94ebf1c2b9ed($7c552ad2d6ae7e60$export$77ad94ebf1c2b9ed(n, /(zoom-|grab)/, $7c552ad2d6ae7e60$export$39dfd62a25e0fe93 + "$1"), /(image-set)/, $7c552ad2d6ae7e60$export$39dfd62a25e0fe93 + "$1"), n, "") + n;
        case 5495:
        case 3959:
            return $7c552ad2d6ae7e60$export$77ad94ebf1c2b9ed(n, /(image-set\([^]*)/, $7c552ad2d6ae7e60$export$39dfd62a25e0fe93 + "$1" + "$`$1");
        case 4968:
            return $7c552ad2d6ae7e60$export$77ad94ebf1c2b9ed($7c552ad2d6ae7e60$export$77ad94ebf1c2b9ed(n, /(.+:)(flex-)?(.*)/, $7c552ad2d6ae7e60$export$39dfd62a25e0fe93 + "box-pack:$3" + $7c552ad2d6ae7e60$export$71ad59f2e432cfe8 + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + $7c552ad2d6ae7e60$export$39dfd62a25e0fe93 + n + n;
        case 4200:
            if (!$7c552ad2d6ae7e60$export$4659b591c19bdf3d(n, /flex-|baseline/)) return $7c552ad2d6ae7e60$export$71ad59f2e432cfe8 + "grid-column-align" + $7c552ad2d6ae7e60$export$2f35ab04d2335697(n, c) + n;
            break;
        case 2592:
        case 3360:
            return $7c552ad2d6ae7e60$export$71ad59f2e432cfe8 + $7c552ad2d6ae7e60$export$77ad94ebf1c2b9ed(n, "template-", "") + n;
        case 4384:
        case 3616:
            if (s && s.some(function(e, r) {
                return c = r, $7c552ad2d6ae7e60$export$4659b591c19bdf3d(e.props, /grid-\w+-end/);
            })) return ~$7c552ad2d6ae7e60$export$f8e21b1e77979a08(n + (s = s[c].value), "span") ? n : $7c552ad2d6ae7e60$export$71ad59f2e432cfe8 + $7c552ad2d6ae7e60$export$77ad94ebf1c2b9ed(n, "-start", "") + n + $7c552ad2d6ae7e60$export$71ad59f2e432cfe8 + "grid-row-span:" + (~$7c552ad2d6ae7e60$export$f8e21b1e77979a08(s, "span") ? $7c552ad2d6ae7e60$export$4659b591c19bdf3d(s, /\d+/) : +$7c552ad2d6ae7e60$export$4659b591c19bdf3d(s, /\d+/) - +$7c552ad2d6ae7e60$export$4659b591c19bdf3d(n, /\d+/)) + ";";
            return $7c552ad2d6ae7e60$export$71ad59f2e432cfe8 + $7c552ad2d6ae7e60$export$77ad94ebf1c2b9ed(n, "-start", "") + n;
        case 4896:
        case 4128:
            return s && s.some(function(e) {
                return $7c552ad2d6ae7e60$export$4659b591c19bdf3d(e.props, /grid-\w+-start/);
            }) ? n : $7c552ad2d6ae7e60$export$71ad59f2e432cfe8 + $7c552ad2d6ae7e60$export$77ad94ebf1c2b9ed($7c552ad2d6ae7e60$export$77ad94ebf1c2b9ed(n, "-end", "-span"), "span ", "") + n;
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return $7c552ad2d6ae7e60$export$77ad94ebf1c2b9ed(n, /(.+)-inline(.+)/, $7c552ad2d6ae7e60$export$39dfd62a25e0fe93 + "$1$2") + n;
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            if ($7c552ad2d6ae7e60$export$36776f635604f274(n) - 1 - c > 6) switch($7c552ad2d6ae7e60$export$a9db5e087081082d(n, c + 1)){
                case 109:
                    if ($7c552ad2d6ae7e60$export$a9db5e087081082d(n, c + 4) !== 45) break;
                case 102:
                    return $7c552ad2d6ae7e60$export$77ad94ebf1c2b9ed(n, /(.+:)(.+)-([^]+)/, "$1" + $7c552ad2d6ae7e60$export$39dfd62a25e0fe93 + "$2-$3" + "$1" + $7c552ad2d6ae7e60$export$2c0f367103c8d01c + ($7c552ad2d6ae7e60$export$a9db5e087081082d(n, c + 3) == 108 ? "$3" : "$2-$3")) + n;
                case 115:
                    return ~$7c552ad2d6ae7e60$export$f8e21b1e77979a08(n, "stretch") ? $7c552ad2d6ae7e60$export$82e9f45cca5ba907($7c552ad2d6ae7e60$export$77ad94ebf1c2b9ed(n, "stretch", "fill-available"), c, s) + n : n;
            }
            break;
        case 5152:
        case 5920:
            return $7c552ad2d6ae7e60$export$77ad94ebf1c2b9ed(n, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(r, a, c, s, t, u, i) {
                return $7c552ad2d6ae7e60$export$71ad59f2e432cfe8 + a + ":" + c + i + (s ? $7c552ad2d6ae7e60$export$71ad59f2e432cfe8 + a + "-span:" + (t ? u : +u - +c) + i : "") + n;
            });
        case 4949:
            if ($7c552ad2d6ae7e60$export$a9db5e087081082d(n, c + 6) === 121) return $7c552ad2d6ae7e60$export$77ad94ebf1c2b9ed(n, ":", ":" + $7c552ad2d6ae7e60$export$39dfd62a25e0fe93) + n;
            break;
        case 6444:
            switch($7c552ad2d6ae7e60$export$a9db5e087081082d(n, $7c552ad2d6ae7e60$export$a9db5e087081082d(n, 14) === 45 ? 18 : 11)){
                case 120:
                    return $7c552ad2d6ae7e60$export$77ad94ebf1c2b9ed(n, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + $7c552ad2d6ae7e60$export$39dfd62a25e0fe93 + ($7c552ad2d6ae7e60$export$a9db5e087081082d(n, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + $7c552ad2d6ae7e60$export$39dfd62a25e0fe93 + "$2$3" + "$1" + $7c552ad2d6ae7e60$export$71ad59f2e432cfe8 + "$2box$3") + n;
                case 100:
                    return $7c552ad2d6ae7e60$export$77ad94ebf1c2b9ed(n, ":", ":" + $7c552ad2d6ae7e60$export$71ad59f2e432cfe8) + n;
            }
            break;
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return $7c552ad2d6ae7e60$export$77ad94ebf1c2b9ed(n, "scroll-", "scroll-snap-") + n;
    }
    return n;
}
function $7c552ad2d6ae7e60$export$dfdc1655ccc5b9cb(e, r) {
    var a = "";
    var n = $7c552ad2d6ae7e60$export$f9084667e487ed46(e);
    for(var c = 0; c < n; c++)a += r(e[c], c, e, r) || "";
    return a;
}
function $7c552ad2d6ae7e60$export$fac44ee5b035f737(e, r, a, t) {
    switch(e.type){
        case $7c552ad2d6ae7e60$export$d773506282b3cfe6:
            if (e.children.length) break;
        case $7c552ad2d6ae7e60$export$a763edbf796b780a:
        case $7c552ad2d6ae7e60$export$527d108ccf083c2b:
            return e.return = e.return || e.value;
        case $7c552ad2d6ae7e60$export$a29989082612d0d9:
            return "";
        case $7c552ad2d6ae7e60$export$b44a8529a35fcb60:
            return e.return = e.value + "{" + $7c552ad2d6ae7e60$export$dfdc1655ccc5b9cb(e.children, t) + "}";
        case $7c552ad2d6ae7e60$export$aa3a2e812ca8570d:
            e.value = e.props.join(",");
    }
    return $7c552ad2d6ae7e60$export$36776f635604f274(a = $7c552ad2d6ae7e60$export$dfdc1655ccc5b9cb(e.children, t)) ? e.return = e.value + "{" + a + "}" : "";
}
function $7c552ad2d6ae7e60$export$5a7767152ae0305f(e) {
    var r = $7c552ad2d6ae7e60$export$f9084667e487ed46(e);
    return function(a, n, c, s) {
        var t = "";
        for(var u = 0; u < r; u++)t += e[u](a, n, c, s) || "";
        return t;
    };
}
function $7c552ad2d6ae7e60$export$38bcb760f1d4871c(e) {
    return function(r) {
        if (!r.root) {
            if (r = r.return) e(r);
        }
    };
}
function $7c552ad2d6ae7e60$export$e08c7d021b829b7a(n, t, u, i) {
    if (n.length > -1) {
        if (!n.return) switch(n.type){
            case $7c552ad2d6ae7e60$export$527d108ccf083c2b:
                n.return = $7c552ad2d6ae7e60$export$82e9f45cca5ba907(n.value, n.length, u);
                return;
            case $7c552ad2d6ae7e60$export$b44a8529a35fcb60:
                return $7c552ad2d6ae7e60$export$dfdc1655ccc5b9cb([
                    $7c552ad2d6ae7e60$export$784d13d8ee351f07(n, {
                        value: $7c552ad2d6ae7e60$export$77ad94ebf1c2b9ed(n.value, "@", "@" + $7c552ad2d6ae7e60$export$39dfd62a25e0fe93)
                    })
                ], i);
            case $7c552ad2d6ae7e60$export$aa3a2e812ca8570d:
                if (n.length) return $7c552ad2d6ae7e60$export$1be1fc439b849fdf(n.props, function(c) {
                    switch($7c552ad2d6ae7e60$export$4659b591c19bdf3d(c, /(::plac\w+|:read-\w+)/)){
                        case ":read-only":
                        case ":read-write":
                            return $7c552ad2d6ae7e60$export$dfdc1655ccc5b9cb([
                                $7c552ad2d6ae7e60$export$784d13d8ee351f07(n, {
                                    props: [
                                        $7c552ad2d6ae7e60$export$77ad94ebf1c2b9ed(c, /:(read-\w+)/, ":" + $7c552ad2d6ae7e60$export$2c0f367103c8d01c + "$1")
                                    ]
                                })
                            ], i);
                        case "::placeholder":
                            return $7c552ad2d6ae7e60$export$dfdc1655ccc5b9cb([
                                $7c552ad2d6ae7e60$export$784d13d8ee351f07(n, {
                                    props: [
                                        $7c552ad2d6ae7e60$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $7c552ad2d6ae7e60$export$39dfd62a25e0fe93 + "input-$1")
                                    ]
                                }),
                                $7c552ad2d6ae7e60$export$784d13d8ee351f07(n, {
                                    props: [
                                        $7c552ad2d6ae7e60$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $7c552ad2d6ae7e60$export$2c0f367103c8d01c + "$1")
                                    ]
                                }),
                                $7c552ad2d6ae7e60$export$784d13d8ee351f07(n, {
                                    props: [
                                        $7c552ad2d6ae7e60$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, $7c552ad2d6ae7e60$export$71ad59f2e432cfe8 + "input-$1")
                                    ]
                                })
                            ], i);
                    }
                    return "";
                });
        }
    }
}
function $7c552ad2d6ae7e60$export$76a88f7de6507443(e) {
    switch(e.type){
        case $7c552ad2d6ae7e60$export$aa3a2e812ca8570d:
            e.props = e.props.map(function(r) {
                return $7c552ad2d6ae7e60$export$1be1fc439b849fdf($7c552ad2d6ae7e60$export$660b2ee2d4fb4eff(r), function(r, a, n) {
                    switch($7c552ad2d6ae7e60$export$a9db5e087081082d(r, 0)){
                        case 12:
                            return $7c552ad2d6ae7e60$export$2f35ab04d2335697(r, 1, $7c552ad2d6ae7e60$export$36776f635604f274(r));
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return r;
                        case 58:
                            if (n[++a] === "global") n[a] = "", n[++a] = "\f" + $7c552ad2d6ae7e60$export$2f35ab04d2335697(n[a], a = 1, -1);
                        case 32:
                            return a === 1 ? "" : r;
                        default:
                            switch(a){
                                case 0:
                                    e = r;
                                    return $7c552ad2d6ae7e60$export$f9084667e487ed46(n) > 1 ? "" : r;
                                case a = $7c552ad2d6ae7e60$export$f9084667e487ed46(n) - 1:
                                case 2:
                                    return a === 2 ? r + e + e : r + e;
                                default:
                                    return r;
                            }
                    }
                });
            });
    }
}


var $7483d8e869d74719$export$2e2bcd8739ae039 = function weakMemoize(func) {
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // Use non-null assertion because we just checked that the cache `has` it
        // This allows us to remove `undefined` from the return value
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};


function $00326b0e1ce23e1f$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}


var $067aee9d91b68cb5$var$isBrowser = typeof document !== 'undefined';
var $067aee9d91b68cb5$var$identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
    var previous = 0;
    var character = 0;
    while(true){
        previous = character;
        character = (0, $7c552ad2d6ae7e60$export$4d3fb11e950abb9e)(); // &\f
        if (previous === 38 && character === 12) points[index] = 1;
        if ((0, $7c552ad2d6ae7e60$export$9e1725a4cfeada27)(character)) break;
        (0, $7c552ad2d6ae7e60$export$48cfd1e771a65c4f)();
    }
    return (0, $7c552ad2d6ae7e60$export$58adb3bec8346d0f)(begin, (0, $7c552ad2d6ae7e60$export$5880b8b5730aff45));
};
var $067aee9d91b68cb5$var$toRules = function toRules(parsed, points) {
    // pretend we've started with a comma
    var index = -1;
    var character = 44;
    do switch((0, $7c552ad2d6ae7e60$export$9e1725a4cfeada27)(character)){
        case 0:
            // &\f
            if (character === 38 && (0, $7c552ad2d6ae7e60$export$4d3fb11e950abb9e)() === 12) // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
            // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
            // and when it should just concatenate the outer and inner selectors
            // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
            points[index] = 1;
            parsed[index] += $067aee9d91b68cb5$var$identifierWithPointTracking((0, $7c552ad2d6ae7e60$export$5880b8b5730aff45) - 1, points, index);
            break;
        case 2:
            parsed[index] += (0, $7c552ad2d6ae7e60$export$410ac95b9ec204b8)(character);
            break;
        case 4:
            // comma
            if (character === 44) {
                // colon
                parsed[++index] = (0, $7c552ad2d6ae7e60$export$4d3fb11e950abb9e)() === 58 ? '&\f' : '';
                points[index] = parsed[index].length;
                break;
            }
        // fallthrough
        default:
            parsed[index] += (0, $7c552ad2d6ae7e60$export$6788812c4e6611e6)(character);
    }
    while (character = (0, $7c552ad2d6ae7e60$export$48cfd1e771a65c4f)());
    return parsed;
};
var $067aee9d91b68cb5$var$getRules = function getRules(value, points) {
    return (0, $7c552ad2d6ae7e60$export$45918ac1574455b1)($067aee9d91b68cb5$var$toRules((0, $7c552ad2d6ae7e60$export$2de70f21292aac9e)(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11
var $067aee9d91b68cb5$var$fixedElements = /* #__PURE__ */ new WeakMap();
var $067aee9d91b68cb5$var$compat = function compat(element) {
    if (element.type !== 'rule' || !element.parent || // positive .length indicates that this rule contains pseudo
    // negative .length indicates that this rule has been already prefixed
    element.length < 1) return;
    var value = element.value;
    var parent = element.parent;
    var isImplicitRule = element.column === parent.column && element.line === parent.line;
    while(parent.type !== 'rule'){
        parent = parent.parent;
        if (!parent) return;
    } // short-circuit for the simplest case
    if (element.props.length === 1 && value.charCodeAt(0) !== 58 && !$067aee9d91b68cb5$var$fixedElements.get(parent)) return;
     // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
    // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"
    if (isImplicitRule) return;
    $067aee9d91b68cb5$var$fixedElements.set(element, true);
    var points = [];
    var rules = $067aee9d91b68cb5$var$getRules(value, points);
    var parentRules = parent.props;
    for(var i = 0, k = 0; i < rules.length; i++)for(var j = 0; j < parentRules.length; j++, k++)element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
};
var $067aee9d91b68cb5$var$removeLabel = function removeLabel(element) {
    if (element.type === 'decl') {
        var value = element.value;
        if (value.charCodeAt(0) === 108 && // charcode for b
        value.charCodeAt(2) === 98) {
            // this ignores label
            element["return"] = '';
            element.value = '';
        }
    }
};
/* eslint-disable no-fallthrough */ function $067aee9d91b68cb5$var$prefix(value, length) {
    switch((0, $7c552ad2d6ae7e60$export$d6af199866bfb566)(value, length)){
        // color-adjust
        case 5103:
            return (0, $7c552ad2d6ae7e60$export$39dfd62a25e0fe93) + 'print-' + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, $7c552ad2d6ae7e60$export$39dfd62a25e0fe93) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $7c552ad2d6ae7e60$export$39dfd62a25e0fe93) + value + (0, $7c552ad2d6ae7e60$export$2c0f367103c8d01c) + value + (0, $7c552ad2d6ae7e60$export$71ad59f2e432cfe8) + value + value;
        // flex, flex-direction
        case 6828:
        case 4268:
            return (0, $7c552ad2d6ae7e60$export$39dfd62a25e0fe93) + value + (0, $7c552ad2d6ae7e60$export$71ad59f2e432cfe8) + value + value;
        // order
        case 6165:
            return (0, $7c552ad2d6ae7e60$export$39dfd62a25e0fe93) + value + (0, $7c552ad2d6ae7e60$export$71ad59f2e432cfe8) + 'flex-' + value + value;
        // align-items
        case 5187:
            return (0, $7c552ad2d6ae7e60$export$39dfd62a25e0fe93) + value + (0, $7c552ad2d6ae7e60$export$77ad94ebf1c2b9ed)(value, /(\w+).+(:[^]+)/, (0, $7c552ad2d6ae7e60$export$39dfd62a25e0fe93) + 'box-$1$2' + (0, $7c552ad2d6ae7e60$export$71ad59f2e432cfe8) + 'flex-$1$2') + value;
        // align-self
        case 5443:
            return (0, $7c552ad2d6ae7e60$export$39dfd62a25e0fe93) + value + (0, $7c552ad2d6ae7e60$export$71ad59f2e432cfe8) + 'flex-item-' + (0, $7c552ad2d6ae7e60$export$77ad94ebf1c2b9ed)(value, /flex-|-self/, '') + value;
        // align-content
        case 4675:
            return (0, $7c552ad2d6ae7e60$export$39dfd62a25e0fe93) + value + (0, $7c552ad2d6ae7e60$export$71ad59f2e432cfe8) + 'flex-line-pack' + (0, $7c552ad2d6ae7e60$export$77ad94ebf1c2b9ed)(value, /align-content|flex-|-self/, '') + value;
        // flex-shrink
        case 5548:
            return (0, $7c552ad2d6ae7e60$export$39dfd62a25e0fe93) + value + (0, $7c552ad2d6ae7e60$export$71ad59f2e432cfe8) + (0, $7c552ad2d6ae7e60$export$77ad94ebf1c2b9ed)(value, 'shrink', 'negative') + value;
        // flex-basis
        case 5292:
            return (0, $7c552ad2d6ae7e60$export$39dfd62a25e0fe93) + value + (0, $7c552ad2d6ae7e60$export$71ad59f2e432cfe8) + (0, $7c552ad2d6ae7e60$export$77ad94ebf1c2b9ed)(value, 'basis', 'preferred-size') + value;
        // flex-grow
        case 6060:
            return (0, $7c552ad2d6ae7e60$export$39dfd62a25e0fe93) + 'box-' + (0, $7c552ad2d6ae7e60$export$77ad94ebf1c2b9ed)(value, '-grow', '') + (0, $7c552ad2d6ae7e60$export$39dfd62a25e0fe93) + value + (0, $7c552ad2d6ae7e60$export$71ad59f2e432cfe8) + (0, $7c552ad2d6ae7e60$export$77ad94ebf1c2b9ed)(value, 'grow', 'positive') + value;
        // transition
        case 4554:
            return (0, $7c552ad2d6ae7e60$export$39dfd62a25e0fe93) + (0, $7c552ad2d6ae7e60$export$77ad94ebf1c2b9ed)(value, /([^-])(transform)/g, '$1' + (0, $7c552ad2d6ae7e60$export$39dfd62a25e0fe93) + '$2') + value;
        // cursor
        case 6187:
            return (0, $7c552ad2d6ae7e60$export$77ad94ebf1c2b9ed)((0, $7c552ad2d6ae7e60$export$77ad94ebf1c2b9ed)((0, $7c552ad2d6ae7e60$export$77ad94ebf1c2b9ed)(value, /(zoom-|grab)/, (0, $7c552ad2d6ae7e60$export$39dfd62a25e0fe93) + '$1'), /(image-set)/, (0, $7c552ad2d6ae7e60$export$39dfd62a25e0fe93) + '$1'), value, '') + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $7c552ad2d6ae7e60$export$77ad94ebf1c2b9ed)(value, /(image-set\([^]*)/, (0, $7c552ad2d6ae7e60$export$39dfd62a25e0fe93) + '$1' + '$`$1');
        // justify-content
        case 4968:
            return (0, $7c552ad2d6ae7e60$export$77ad94ebf1c2b9ed)((0, $7c552ad2d6ae7e60$export$77ad94ebf1c2b9ed)(value, /(.+:)(flex-)?(.*)/, (0, $7c552ad2d6ae7e60$export$39dfd62a25e0fe93) + 'box-pack:$3' + (0, $7c552ad2d6ae7e60$export$71ad59f2e432cfe8) + 'flex-pack:$3'), /s.+-b[^;]+/, 'justify') + (0, $7c552ad2d6ae7e60$export$39dfd62a25e0fe93) + value + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $7c552ad2d6ae7e60$export$77ad94ebf1c2b9ed)(value, /(.+)-inline(.+)/, (0, $7c552ad2d6ae7e60$export$39dfd62a25e0fe93) + '$1$2') + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $7c552ad2d6ae7e60$export$36776f635604f274)(value) - 1 - length > 6) switch((0, $7c552ad2d6ae7e60$export$a9db5e087081082d)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $7c552ad2d6ae7e60$export$a9db5e087081082d)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $7c552ad2d6ae7e60$export$77ad94ebf1c2b9ed)(value, /(.+:)(.+)-([^]+)/, '$1' + (0, $7c552ad2d6ae7e60$export$39dfd62a25e0fe93) + '$2-$3' + '$1' + (0, $7c552ad2d6ae7e60$export$2c0f367103c8d01c) + ((0, $7c552ad2d6ae7e60$export$a9db5e087081082d)(value, length + 3) == 108 ? '$3' : '$2-$3')) + value;
                // (s)tretch
                case 115:
                    return ~(0, $7c552ad2d6ae7e60$export$f8e21b1e77979a08)(value, 'stretch') ? $067aee9d91b68cb5$var$prefix((0, $7c552ad2d6ae7e60$export$77ad94ebf1c2b9ed)(value, 'stretch', 'fill-available'), length) + value : value;
            }
            break;
        // position: sticky
        case 4949:
            // (s)ticky?
            if ((0, $7c552ad2d6ae7e60$export$a9db5e087081082d)(value, length + 1) !== 115) break;
        // display: (flex|inline-flex)
        case 6444:
            switch((0, $7c552ad2d6ae7e60$export$a9db5e087081082d)(value, (0, $7c552ad2d6ae7e60$export$36776f635604f274)(value) - 3 - (~(0, $7c552ad2d6ae7e60$export$f8e21b1e77979a08)(value, '!important') && 10))){
                // stic(k)y
                case 107:
                    return (0, $7c552ad2d6ae7e60$export$77ad94ebf1c2b9ed)(value, ':', ':' + (0, $7c552ad2d6ae7e60$export$39dfd62a25e0fe93)) + value;
                // (inline-)?fl(e)x
                case 101:
                    return (0, $7c552ad2d6ae7e60$export$77ad94ebf1c2b9ed)(value, /(.+:)([^;!]+)(;|!.+)?/, '$1' + (0, $7c552ad2d6ae7e60$export$39dfd62a25e0fe93) + ((0, $7c552ad2d6ae7e60$export$a9db5e087081082d)(value, 14) === 45 ? 'inline-' : '') + 'box$3' + '$1' + (0, $7c552ad2d6ae7e60$export$39dfd62a25e0fe93) + '$2$3' + '$1' + (0, $7c552ad2d6ae7e60$export$71ad59f2e432cfe8) + '$2box$3') + value;
            }
            break;
        // writing-mode
        case 5936:
            switch((0, $7c552ad2d6ae7e60$export$a9db5e087081082d)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $7c552ad2d6ae7e60$export$39dfd62a25e0fe93) + value + (0, $7c552ad2d6ae7e60$export$71ad59f2e432cfe8) + (0, $7c552ad2d6ae7e60$export$77ad94ebf1c2b9ed)(value, /[svh]\w+-[tblr]{2}/, 'tb') + value;
                // vertical-r(l)
                case 108:
                    return (0, $7c552ad2d6ae7e60$export$39dfd62a25e0fe93) + value + (0, $7c552ad2d6ae7e60$export$71ad59f2e432cfe8) + (0, $7c552ad2d6ae7e60$export$77ad94ebf1c2b9ed)(value, /[svh]\w+-[tblr]{2}/, 'tb-rl') + value;
                // horizontal(-)tb
                case 45:
                    return (0, $7c552ad2d6ae7e60$export$39dfd62a25e0fe93) + value + (0, $7c552ad2d6ae7e60$export$71ad59f2e432cfe8) + (0, $7c552ad2d6ae7e60$export$77ad94ebf1c2b9ed)(value, /[svh]\w+-[tblr]{2}/, 'lr') + value;
            }
            return (0, $7c552ad2d6ae7e60$export$39dfd62a25e0fe93) + value + (0, $7c552ad2d6ae7e60$export$71ad59f2e432cfe8) + value + value;
    }
    return value;
}
var $067aee9d91b68cb5$var$prefixer = function prefixer(element, index, children, callback) {
    if (element.length > -1) {
        if (!element["return"]) switch(element.type){
            case 0, $7c552ad2d6ae7e60$export$527d108ccf083c2b:
                element["return"] = $067aee9d91b68cb5$var$prefix(element.value, element.length);
                break;
            case 0, $7c552ad2d6ae7e60$export$b44a8529a35fcb60:
                return (0, $7c552ad2d6ae7e60$export$dfdc1655ccc5b9cb)([
                    (0, $7c552ad2d6ae7e60$export$784d13d8ee351f07)(element, {
                        value: (0, $7c552ad2d6ae7e60$export$77ad94ebf1c2b9ed)(element.value, '@', '@' + (0, $7c552ad2d6ae7e60$export$39dfd62a25e0fe93))
                    })
                ], callback);
            case 0, $7c552ad2d6ae7e60$export$aa3a2e812ca8570d:
                if (element.length) return (0, $7c552ad2d6ae7e60$export$1be1fc439b849fdf)(element.props, function(value) {
                    switch((0, $7c552ad2d6ae7e60$export$4659b591c19bdf3d)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ':read-only':
                        case ':read-write':
                            return (0, $7c552ad2d6ae7e60$export$dfdc1655ccc5b9cb)([
                                (0, $7c552ad2d6ae7e60$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $7c552ad2d6ae7e60$export$77ad94ebf1c2b9ed)(value, /:(read-\w+)/, ':' + (0, $7c552ad2d6ae7e60$export$2c0f367103c8d01c) + '$1')
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case '::placeholder':
                            return (0, $7c552ad2d6ae7e60$export$dfdc1655ccc5b9cb)([
                                (0, $7c552ad2d6ae7e60$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $7c552ad2d6ae7e60$export$77ad94ebf1c2b9ed)(value, /:(plac\w+)/, ':' + (0, $7c552ad2d6ae7e60$export$39dfd62a25e0fe93) + 'input-$1')
                                    ]
                                }),
                                (0, $7c552ad2d6ae7e60$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $7c552ad2d6ae7e60$export$77ad94ebf1c2b9ed)(value, /:(plac\w+)/, ':' + (0, $7c552ad2d6ae7e60$export$2c0f367103c8d01c) + '$1')
                                    ]
                                }),
                                (0, $7c552ad2d6ae7e60$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $7c552ad2d6ae7e60$export$77ad94ebf1c2b9ed)(value, /:(plac\w+)/, (0, $7c552ad2d6ae7e60$export$71ad59f2e432cfe8) + 'input-$1')
                                    ]
                                })
                            ], callback);
                    }
                    return '';
                });
        }
    }
};
var $067aee9d91b68cb5$var$getServerStylisCache = $067aee9d91b68cb5$var$isBrowser ? undefined : (0, $7483d8e869d74719$export$2e2bcd8739ae039)(function() {
    return (0, $00326b0e1ce23e1f$export$2e2bcd8739ae039)(function() {
        return {};
    });
});
var $067aee9d91b68cb5$var$defaultStylisPlugins = [
    $067aee9d91b68cb5$var$prefixer
];
var $067aee9d91b68cb5$export$2e2bcd8739ae039 = function createCache(options) {
    var key = options.key;
    if ($067aee9d91b68cb5$var$isBrowser && key === 'css') {
        var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
        // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
        // note this very very intentionally targets all style elements regardless of the key to ensure
        // that creating a cache works inside of render of a React component
        Array.prototype.forEach.call(ssrStyles, function(node) {
            // we want to only move elements which have a space in the data-emotion attribute value
            // because that indicates that it is an Emotion 11 server-side rendered style elements
            // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
            // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
            // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
            // will not result in the Emotion 10 styles being destroyed
            var dataEmotionAttribute = node.getAttribute('data-emotion');
            if (dataEmotionAttribute.indexOf(' ') === -1) return;
            document.head.appendChild(node);
            node.setAttribute('data-s', '');
        });
    }
    var stylisPlugins = options.stylisPlugins || $067aee9d91b68cb5$var$defaultStylisPlugins;
    var inserted = {};
    var container;
    var nodesToHydrate = [];
    if ($067aee9d91b68cb5$var$isBrowser) {
        container = options.container || document.head;
        Array.prototype.forEach.call(// means that the style elements we're looking at are only Emotion 11 server-rendered style elements
        document.querySelectorAll("style[data-emotion^=\"" + key + " \"]"), function(node) {
            var attrib = node.getAttribute("data-emotion").split(' ');
            for(var i = 1; i < attrib.length; i++)inserted[attrib[i]] = true;
            nodesToHydrate.push(node);
        });
    }
    var _insert;
    var omnipresentPlugins = [
        $067aee9d91b68cb5$var$compat,
        $067aee9d91b68cb5$var$removeLabel
    ];
    if (!$067aee9d91b68cb5$var$getServerStylisCache) {
        var currentSheet;
        var finalizingPlugins = [
            (0, $7c552ad2d6ae7e60$export$fac44ee5b035f737),
            (0, $7c552ad2d6ae7e60$export$38bcb760f1d4871c)(function(rule) {
                currentSheet.insert(rule);
            })
        ];
        var serializer = (0, $7c552ad2d6ae7e60$export$5a7767152ae0305f)(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
        var stylis = function stylis(styles) {
            return (0, $7c552ad2d6ae7e60$export$dfdc1655ccc5b9cb)((0, $7c552ad2d6ae7e60$export$ef7acd7185315e22)(styles), serializer);
        };
        _insert = function insert(selector, serialized, sheet, shouldCache) {
            currentSheet = sheet;
            stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
            if (shouldCache) cache.inserted[serialized.name] = true;
        };
    } else {
        var _finalizingPlugins = [
            (0, $7c552ad2d6ae7e60$export$fac44ee5b035f737)
        ];
        var _serializer = (0, $7c552ad2d6ae7e60$export$5a7767152ae0305f)(omnipresentPlugins.concat(stylisPlugins, _finalizingPlugins));
        var _stylis = function _stylis(styles) {
            return (0, $7c552ad2d6ae7e60$export$dfdc1655ccc5b9cb)((0, $7c552ad2d6ae7e60$export$ef7acd7185315e22)(styles), _serializer);
        };
        var serverStylisCache = $067aee9d91b68cb5$var$getServerStylisCache(stylisPlugins)(key);
        var getRules = function getRules(selector, serialized) {
            var name = serialized.name;
            if (serverStylisCache[name] === undefined) serverStylisCache[name] = _stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
            return serverStylisCache[name];
        };
        _insert = function _insert(selector, serialized, sheet, shouldCache) {
            var name = serialized.name;
            var rules = getRules(selector, serialized);
            if (cache.compat === undefined) {
                // in regular mode, we don't set the styles on the inserted cache
                // since we don't need to and that would be wasting memory
                // we return them so that they are rendered in a style tag
                if (shouldCache) cache.inserted[name] = true;
                return rules;
            } else {
                // in compat mode, we put the styles on the inserted cache so
                // that emotion-server can pull out the styles
                // except when we don't want to cache it which was in Global but now
                // is nowhere but we don't want to do a major right now
                // and just in case we're going to leave the case here
                // it's also not affecting client side bundle size
                // so it's really not a big deal
                if (shouldCache) cache.inserted[name] = rules;
                else return rules;
            }
        };
    }
    var cache = {
        key: key,
        sheet: new (0, $bd685f657870ad68$export$9d753cd7ae895cce)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy,
            prepend: options.prepend,
            insertionPoint: options.insertionPoint
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    cache.sheet.hydrate(nodesToHydrate);
    return cache;
};




var $ac3273262052406d$exports = {};
'use strict';
var $c2549a7a0877e695$exports = {};
'use strict';

$c2549a7a0877e695$exports = (parcelRequire("bAq0e"));


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $ac3273262052406d$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $ac3273262052406d$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $ac3273262052406d$var$FORWARD_REF_STATICS = {
    '$$typeof': true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $ac3273262052406d$var$MEMO_STATICS = {
    '$$typeof': true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $ac3273262052406d$var$TYPE_STATICS = {};
$ac3273262052406d$var$TYPE_STATICS[$c2549a7a0877e695$exports.ForwardRef] = $ac3273262052406d$var$FORWARD_REF_STATICS;
$ac3273262052406d$var$TYPE_STATICS[$c2549a7a0877e695$exports.Memo] = $ac3273262052406d$var$MEMO_STATICS;
function $ac3273262052406d$var$getStatics(component) {
    // React v16.11 and below
    if ($c2549a7a0877e695$exports.isMemo(component)) return $ac3273262052406d$var$MEMO_STATICS;
     // React v16.12 and above
    return $ac3273262052406d$var$TYPE_STATICS[component['$$typeof']] || $ac3273262052406d$var$REACT_STATICS;
}
var $ac3273262052406d$var$defineProperty = Object.defineProperty;
var $ac3273262052406d$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $ac3273262052406d$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $ac3273262052406d$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $ac3273262052406d$var$getPrototypeOf = Object.getPrototypeOf;
var $ac3273262052406d$var$objectPrototype = Object.prototype;
function $ac3273262052406d$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        // don't hoist over string (html) components
        if ($ac3273262052406d$var$objectPrototype) {
            var inheritedComponent = $ac3273262052406d$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $ac3273262052406d$var$objectPrototype) $ac3273262052406d$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $ac3273262052406d$var$getOwnPropertyNames(sourceComponent);
        if ($ac3273262052406d$var$getOwnPropertySymbols) keys = keys.concat($ac3273262052406d$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $ac3273262052406d$var$getStatics(targetComponent);
        var sourceStatics = $ac3273262052406d$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$ac3273262052406d$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $ac3273262052406d$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $ac3273262052406d$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
$ac3273262052406d$exports = $ac3273262052406d$var$hoistNonReactStatics;


// this file isolates this package that is not tree-shakeable
// and if this module doesn't actually contain any logic of its own
// then Rollup just use 'hoist-non-react-statics' directly in other chunks
var $6b2bc38af1c0bce3$export$2e2bcd8739ae039 = function(targetComponent, sourceComponent) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($ac3273262052406d$exports)))(targetComponent, sourceComponent);
};


var $d72e34e8a4dd60ef$var$isBrowser = typeof document !== 'undefined';
function $d72e34e8a4dd60ef$export$95d99596f328fd52(registered, registeredStyles, classNames) {
    var rawClassName = '';
    classNames.split(' ').forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className] + ";");
        else if (className) rawClassName += className + " ";
    });
    return rawClassName;
}
var $d72e34e8a4dd60ef$export$580009a5da2a8b4b = function registerStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    $d72e34e8a4dd60ef$var$isBrowser === false && cache.compat !== undefined) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
};
var $d72e34e8a4dd60ef$export$6f077d94b33a01aa = function insertStyles(cache, serialized, isStringTag) {
    $d72e34e8a4dd60ef$export$580009a5da2a8b4b(cache, serialized, isStringTag);
    var className = cache.key + "-" + serialized.name;
    if (cache.inserted[serialized.name] === undefined) {
        var stylesForSSR = '';
        var current = serialized;
        do {
            var maybeStyles = cache.insert(serialized === current ? "." + className : '', current, cache.sheet, true);
            if (!$d72e34e8a4dd60ef$var$isBrowser && maybeStyles !== undefined) stylesForSSR += maybeStyles;
            current = current.next;
        }while (current !== undefined);
        if (!$d72e34e8a4dd60ef$var$isBrowser && stylesForSSR.length !== 0) return stylesForSSR;
    }
};


/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $27f9ca899a9a1429$export$2e2bcd8739ae039(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}


var $ea2cb85e87a5c35a$export$2e2bcd8739ae039 = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    scale: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};



var $cdfa1116f6d61737$var$isDevelopment = false;
var $cdfa1116f6d61737$var$hyphenateRegex = /[A-Z]|^ms/g;
var $cdfa1116f6d61737$var$animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var $cdfa1116f6d61737$var$isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var $cdfa1116f6d61737$var$isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== 'boolean';
};
var $cdfa1116f6d61737$var$processStyleName = /* #__PURE__ */ (0, $00326b0e1ce23e1f$export$2e2bcd8739ae039)(function(styleName) {
    return $cdfa1116f6d61737$var$isCustomProperty(styleName) ? styleName : styleName.replace($cdfa1116f6d61737$var$hyphenateRegex, '-$&').toLowerCase();
});
var $cdfa1116f6d61737$var$processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case 'animation':
        case 'animationName':
            if (typeof value === 'string') return value.replace($cdfa1116f6d61737$var$animationRegex, function(match, p1, p2) {
                $cdfa1116f6d61737$var$cursor = {
                    name: p1,
                    styles: p2,
                    next: $cdfa1116f6d61737$var$cursor
                };
                return p1;
            });
    }
    if ((0, $ea2cb85e87a5c35a$export$2e2bcd8739ae039)[key] !== 1 && !$cdfa1116f6d61737$var$isCustomProperty(key) && typeof value === 'number' && value !== 0) return value + 'px';
    return value;
};
var $cdfa1116f6d61737$var$noComponentSelectorMessage = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function $cdfa1116f6d61737$var$handleInterpolation(mergedProps, registered, interpolation) {
    if (interpolation == null) return '';
    var componentSelector = interpolation;
    if (componentSelector.__emotion_styles !== undefined) return componentSelector;
    switch(typeof interpolation){
        case 'boolean':
            return '';
        case 'object':
            var keyframes = interpolation;
            if (keyframes.anim === 1) {
                $cdfa1116f6d61737$var$cursor = {
                    name: keyframes.name,
                    styles: keyframes.styles,
                    next: $cdfa1116f6d61737$var$cursor
                };
                return keyframes.name;
            }
            var serializedStyles = interpolation;
            if (serializedStyles.styles !== undefined) {
                var next = serializedStyles.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    $cdfa1116f6d61737$var$cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: $cdfa1116f6d61737$var$cursor
                    };
                    next = next.next;
                }
                var styles = serializedStyles.styles + ";";
                return styles;
            }
            return $cdfa1116f6d61737$var$createStringFromObject(mergedProps, registered, interpolation);
        case 'function':
            if (mergedProps !== undefined) {
                var previousCursor = $cdfa1116f6d61737$var$cursor;
                var result = interpolation(mergedProps);
                $cdfa1116f6d61737$var$cursor = previousCursor;
                return $cdfa1116f6d61737$var$handleInterpolation(mergedProps, registered, result);
            }
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    var asString = interpolation;
    if (registered == null) return asString;
    var cached = registered[asString];
    return cached !== undefined ? cached : asString;
}
function $cdfa1116f6d61737$var$createStringFromObject(mergedProps, registered, obj) {
    var string = '';
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += $cdfa1116f6d61737$var$handleInterpolation(mergedProps, registered, obj[i]) + ";";
    else for(var key in obj){
        var value = obj[key];
        if (typeof value !== 'object') {
            var asString = value;
            if (registered != null && registered[asString] !== undefined) string += key + "{" + registered[asString] + "}";
            else if ($cdfa1116f6d61737$var$isProcessableValue(asString)) string += $cdfa1116f6d61737$var$processStyleName(key) + ":" + $cdfa1116f6d61737$var$processStyleValue(key, asString) + ";";
        } else {
            if (key === 'NO_COMPONENT_SELECTOR' && $cdfa1116f6d61737$var$isDevelopment) throw new Error($cdfa1116f6d61737$var$noComponentSelectorMessage);
            if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
                for(var _i = 0; _i < value.length; _i++)if ($cdfa1116f6d61737$var$isProcessableValue(value[_i])) string += $cdfa1116f6d61737$var$processStyleName(key) + ":" + $cdfa1116f6d61737$var$processStyleValue(key, value[_i]) + ";";
            } else {
                var interpolated = $cdfa1116f6d61737$var$handleInterpolation(mergedProps, registered, value);
                switch(key){
                    case 'animation':
                    case 'animationName':
                        string += $cdfa1116f6d61737$var$processStyleName(key) + ":" + interpolated + ";";
                        break;
                    default:
                        string += key + "{" + interpolated + "}";
                }
            }
        }
    }
    return string;
}
var $cdfa1116f6d61737$var$labelPattern = /label:\s*([^\s;{]+)\s*(;|$)/g; // this is the cursor for keyframes
// keyframes are stored on the SerializedStyles object as a linked list
var $cdfa1116f6d61737$var$cursor;
function $cdfa1116f6d61737$export$6321afa313b251b5(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = '';
    $cdfa1116f6d61737$var$cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += $cdfa1116f6d61737$var$handleInterpolation(mergedProps, registered, strings);
    } else {
        var asTemplateStringsArr = strings;
        styles += asTemplateStringsArr[0];
    } // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += $cdfa1116f6d61737$var$handleInterpolation(mergedProps, registered, args[i]);
        if (stringMode) {
            var templateStringsArr = strings;
            styles += templateStringsArr[i];
        }
    } // using a global regex with .exec is stateful so lastIndex has to be reset each time
    $cdfa1116f6d61737$var$labelPattern.lastIndex = 0;
    var identifierName = '';
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = $cdfa1116f6d61737$var$labelPattern.exec(styles)) !== null)identifierName += '-' + match[1];
    var name = (0, $27f9ca899a9a1429$export$2e2bcd8739ae039)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: $cdfa1116f6d61737$var$cursor
    };
}



var $4Y8Vu = parcelRequire("4Y8Vu");
var $42801d92d87735a5$var$isBrowser = typeof document !== 'undefined';
var $42801d92d87735a5$var$syncFallback = function syncFallback(create) {
    return create();
};
var $42801d92d87735a5$var$useInsertionEffect = $4Y8Vu.useInsertionEffect ? $4Y8Vu.useInsertionEffect : false;
var $42801d92d87735a5$export$db21c7ffa21794e7 = !$42801d92d87735a5$var$isBrowser ? $42801d92d87735a5$var$syncFallback : $42801d92d87735a5$var$useInsertionEffect || $42801d92d87735a5$var$syncFallback;
var $42801d92d87735a5$export$811a713a7276cb9d = $42801d92d87735a5$var$useInsertionEffect || $4Y8Vu.useLayoutEffect;


var $7356e5b7b0984477$export$407448d2b89b1813 = false;
var $7356e5b7b0984477$export$23f2a1d2818174ef = typeof document !== 'undefined';
var $7356e5b7b0984477$var$EmotionCacheContext = /* #__PURE__ */ $4Y8Vu.createContext(// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== 'undefined' ? /* #__PURE__ */ (0, $067aee9d91b68cb5$export$2e2bcd8739ae039)({
    key: 'css'
}) : null);
var $7356e5b7b0984477$export$e7094788287c5e9b = $7356e5b7b0984477$var$EmotionCacheContext.Provider;
var $7356e5b7b0984477$export$71511d61b312f219 = function useEmotionCache() {
    return (0, $4Y8Vu.useContext)($7356e5b7b0984477$var$EmotionCacheContext);
};
var $7356e5b7b0984477$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    return /*#__PURE__*/ (0, $4Y8Vu.forwardRef)(function(props, ref) {
        // the cache will never be null in the browser
        var cache = (0, $4Y8Vu.useContext)($7356e5b7b0984477$var$EmotionCacheContext);
        return func(props, cache, ref);
    });
};
if (!$7356e5b7b0984477$export$23f2a1d2818174ef) $7356e5b7b0984477$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    return function(props) {
        var cache = (0, $4Y8Vu.useContext)($7356e5b7b0984477$var$EmotionCacheContext);
        if (cache === null) {
            // yes, we're potentially creating this on every render
            // it doesn't actually matter though since it's only on the server
            // so there will only every be a single render
            // that could change in the future because of suspense and etc. but for now,
            // this works and i don't want to optimise for a future thing that we aren't sure about
            cache = (0, $067aee9d91b68cb5$export$2e2bcd8739ae039)({
                key: 'css'
            });
            return /*#__PURE__*/ $4Y8Vu.createElement($7356e5b7b0984477$var$EmotionCacheContext.Provider, {
                value: cache
            }, func(props, cache));
        } else return func(props, cache);
    };
};
var $7356e5b7b0984477$export$971d5caa766a69d7 = /* #__PURE__ */ $4Y8Vu.createContext({});
var $7356e5b7b0984477$export$3b14a55fb2447963 = function useTheme() {
    return $4Y8Vu.useContext($7356e5b7b0984477$export$971d5caa766a69d7);
};
var $7356e5b7b0984477$var$getTheme = function getTheme(outerTheme, theme) {
    if (typeof theme === 'function') {
        var mergedTheme = theme(outerTheme);
        return mergedTheme;
    }
    return (0, $f3601d07f0ff7403$export$2e2bcd8739ae039)({}, outerTheme, theme);
};
var $7356e5b7b0984477$var$createCacheWithTheme = /* #__PURE__ */ (0, $7483d8e869d74719$export$2e2bcd8739ae039)(function(outerTheme) {
    return (0, $7483d8e869d74719$export$2e2bcd8739ae039)(function(theme) {
        return $7356e5b7b0984477$var$getTheme(outerTheme, theme);
    });
});
var $7356e5b7b0984477$export$8b22cf2602fb60ce = function ThemeProvider(props) {
    var theme = $4Y8Vu.useContext($7356e5b7b0984477$export$971d5caa766a69d7);
    if (props.theme !== theme) theme = $7356e5b7b0984477$var$createCacheWithTheme(theme)(props.theme);
    return /*#__PURE__*/ $4Y8Vu.createElement($7356e5b7b0984477$export$971d5caa766a69d7.Provider, {
        value: theme
    }, props.children);
};
function $7356e5b7b0984477$export$4368d992c4eafac0(Component) {
    var componentName = Component.displayName || Component.name || 'Component';
    var WithTheme = /*#__PURE__*/ $4Y8Vu.forwardRef(function render(props, ref) {
        var theme = $4Y8Vu.useContext($7356e5b7b0984477$export$971d5caa766a69d7);
        return /*#__PURE__*/ $4Y8Vu.createElement(Component, (0, $f3601d07f0ff7403$export$2e2bcd8739ae039)({
            theme: theme,
            ref: ref
        }, props));
    });
    WithTheme.displayName = "WithTheme(" + componentName + ")";
    return (0, $6b2bc38af1c0bce3$export$2e2bcd8739ae039)(WithTheme, Component);
}
var $7356e5b7b0984477$export$dda1d9f60106f0e9 = {}.hasOwnProperty;
var $7356e5b7b0984477$var$typePropName = '__EMOTION_TYPE_PLEASE_DO_NOT_USE__';
var $7356e5b7b0984477$export$db3b6bfb95261072 = function createEmotionProps(type, props) {
    var newProps = {};
    for(var _key in props)if ($7356e5b7b0984477$export$dda1d9f60106f0e9.call(props, _key)) newProps[_key] = props[_key];
    newProps[$7356e5b7b0984477$var$typePropName] = type; // Runtime labeling is an opt-in feature because:
    return newProps;
};
var $7356e5b7b0984477$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $d72e34e8a4dd60ef$export$580009a5da2a8b4b)(cache, serialized, isStringTag);
    var rules = (0, $42801d92d87735a5$export$db21c7ffa21794e7)(function() {
        return (0, $d72e34e8a4dd60ef$export$6f077d94b33a01aa)(cache, serialized, isStringTag);
    });
    if (!$7356e5b7b0984477$export$23f2a1d2818174ef && rules !== undefined) {
        var _ref2;
        var serializedNames = serialized.name;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += ' ' + next.name;
            next = next.next;
        }
        return /*#__PURE__*/ $4Y8Vu.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedNames, _ref2.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref2.nonce = cache.sheet.nonce, _ref2));
    }
    return null;
};
var $7356e5b7b0984477$var$Emotion = /* #__PURE__ */ $7356e5b7b0984477$export$efccba1c4a2ef57b(function(props, cache, ref) {
    var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
    // not passing the registered cache to serializeStyles because it would
    // make certain babel optimisations not possible
    if (typeof cssProp === 'string' && cache.registered[cssProp] !== undefined) cssProp = cache.registered[cssProp];
    var WrappedComponent = props[$7356e5b7b0984477$var$typePropName];
    var registeredStyles = [
        cssProp
    ];
    var className = '';
    if (typeof props.className === 'string') className = (0, $d72e34e8a4dd60ef$export$95d99596f328fd52)(cache.registered, registeredStyles, props.className);
    else if (props.className != null) className = props.className + " ";
    var serialized = (0, $cdfa1116f6d61737$export$6321afa313b251b5)(registeredStyles, undefined, $4Y8Vu.useContext($7356e5b7b0984477$export$971d5caa766a69d7));
    className += cache.key + "-" + serialized.name;
    var newProps = {};
    for(var _key2 in props)if ($7356e5b7b0984477$export$dda1d9f60106f0e9.call(props, _key2) && _key2 !== 'css' && _key2 !== $7356e5b7b0984477$var$typePropName && !$7356e5b7b0984477$export$407448d2b89b1813) newProps[_key2] = props[_key2];
    newProps.className = className;
    if (ref) newProps.ref = ref;
    return /*#__PURE__*/ $4Y8Vu.createElement($4Y8Vu.Fragment, null, /*#__PURE__*/ $4Y8Vu.createElement($7356e5b7b0984477$var$Insertion, {
        cache: cache,
        serialized: serialized,
        isStringTag: typeof WrappedComponent === 'string'
    }), /*#__PURE__*/ $4Y8Vu.createElement(WrappedComponent, newProps));
});
var $7356e5b7b0984477$export$a9c23c6ac3fc3eca = $7356e5b7b0984477$var$Emotion;



var $4Y8Vu = parcelRequire("4Y8Vu");




var $457f2b86d85d19b8$exports = {};
function $457f2b86d85d19b8$var$_extends() {
    return $457f2b86d85d19b8$exports = $457f2b86d85d19b8$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $457f2b86d85d19b8$exports.__esModule = true, $457f2b86d85d19b8$exports["default"] = $457f2b86d85d19b8$exports, $457f2b86d85d19b8$var$_extends.apply(null, arguments);
}
$457f2b86d85d19b8$exports = $457f2b86d85d19b8$var$_extends, $457f2b86d85d19b8$exports.__esModule = true, $457f2b86d85d19b8$exports["default"] = $457f2b86d85d19b8$exports;





var $fb226fb4d95fe644$export$c8a8987d4410bf2d = function jsx(type, props) {
    // eslint-disable-next-line prefer-rest-params
    var args = arguments;
    if (props == null || !(0, $7356e5b7b0984477$export$dda1d9f60106f0e9).call(props, 'css')) return $4Y8Vu.createElement.apply(undefined, args);
    var argsLength = args.length;
    var createElementArgArray = new Array(argsLength);
    createElementArgArray[0] = (0, $7356e5b7b0984477$export$a9c23c6ac3fc3eca);
    createElementArgArray[1] = (0, $7356e5b7b0984477$export$db3b6bfb95261072)(type, props);
    for(var i = 2; i < argsLength; i++)createElementArgArray[i] = args[i];
    return $4Y8Vu.createElement.apply(null, createElementArgArray);
};
(function(_jsx) {
    var JSX;
    JSX || (JSX = _jsx.JSX || (_jsx.JSX = {}));
})($fb226fb4d95fe644$export$c8a8987d4410bf2d || ($fb226fb4d95fe644$export$c8a8987d4410bf2d = {}));
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var $fb226fb4d95fe644$export$98f03c5d19621d70 = /* #__PURE__ */ (0, $7356e5b7b0984477$export$efccba1c4a2ef57b)(function(props, cache) {
    var styles = props.styles;
    var serialized = (0, $cdfa1116f6d61737$export$6321afa313b251b5)([
        styles
    ], undefined, $4Y8Vu.useContext((0, $7356e5b7b0984477$export$971d5caa766a69d7)));
    if (!(0, $7356e5b7b0984477$export$23f2a1d2818174ef)) {
        var _ref;
        var serializedNames = serialized.name;
        var serializedStyles = serialized.styles;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += ' ' + next.name;
            serializedStyles += next.styles;
            next = next.next;
        }
        var shouldCache = cache.compat === true;
        var rules = cache.insert("", {
            name: serializedNames,
            styles: serializedStyles
        }, cache.sheet, shouldCache);
        if (shouldCache) return null;
        return /*#__PURE__*/ $4Y8Vu.createElement("style", (_ref = {}, _ref["data-emotion"] = cache.key + "-global " + serializedNames, _ref.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref.nonce = cache.sheet.nonce, _ref));
    } // yes, i know these hooks are used conditionally
    // but it is based on a constant that will never change at runtime
    // it's effectively like having two implementations and switching them out
    // so it's not actually breaking anything
    var sheetRef = $4Y8Vu.useRef();
    (0, $42801d92d87735a5$export$811a713a7276cb9d)(function() {
        var key = cache.key + "-global"; // use case of https://github.com/emotion-js/emotion/issues/2675
        var sheet = new cache.sheet.constructor({
            key: key,
            nonce: cache.sheet.nonce,
            container: cache.sheet.container,
            speedy: cache.sheet.isSpeedy
        });
        var rehydrating = false;
        var node = document.querySelector("style[data-emotion=\"" + key + " " + serialized.name + "\"]");
        if (cache.sheet.tags.length) sheet.before = cache.sheet.tags[0];
        if (node !== null) {
            rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s
            node.setAttribute('data-emotion', key);
            sheet.hydrate([
                node
            ]);
        }
        sheetRef.current = [
            sheet,
            rehydrating
        ];
        return function() {
            sheet.flush();
        };
    }, [
        cache
    ]);
    (0, $42801d92d87735a5$export$811a713a7276cb9d)(function() {
        var sheetRefCurrent = sheetRef.current;
        var sheet = sheetRefCurrent[0], rehydrating = sheetRefCurrent[1];
        if (rehydrating) {
            sheetRefCurrent[1] = false;
            return;
        }
        if (serialized.next !== undefined) // insert keyframes
        (0, $d72e34e8a4dd60ef$export$6f077d94b33a01aa)(cache, serialized.next, true);
        if (sheet.tags.length) {
            // if this doesn't exist then it will be null so the style element will be appended
            var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
            sheet.before = element;
            sheet.flush();
        }
        cache.insert("", serialized, sheet, false);
    }, [
        cache,
        serialized.name
    ]);
    return null;
});
function $fb226fb4d95fe644$export$dbf350e5966cf602() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, $cdfa1116f6d61737$export$6321afa313b251b5)(args);
}
function $fb226fb4d95fe644$export$d25ddfdf17c3ad3e() {
    var insertable = $fb226fb4d95fe644$export$dbf350e5966cf602.apply(void 0, arguments);
    var name = "animation-" + insertable.name;
    return {
        name: name,
        styles: "@keyframes " + name + "{" + insertable.styles + "}",
        anim: 1,
        toString: function toString() {
            return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
        }
    };
}
var $fb226fb4d95fe644$var$classnames = function classnames(args) {
    var len = args.length;
    var i = 0;
    var cls = '';
    for(; i < len; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case 'boolean':
                break;
            case 'object':
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = '';
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += ' ');
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += ' ');
            cls += toAdd;
        }
    }
    return cls;
};
function $fb226fb4d95fe644$var$merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, $d72e34e8a4dd60ef$export$95d99596f328fd52)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var $fb226fb4d95fe644$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serializedArr = _ref.serializedArr;
    var rules = (0, $42801d92d87735a5$export$db21c7ffa21794e7)(function() {
        var rules = '';
        for(var i = 0; i < serializedArr.length; i++){
            var res = (0, $d72e34e8a4dd60ef$export$6f077d94b33a01aa)(cache, serializedArr[i], false);
            if (!(0, $7356e5b7b0984477$export$23f2a1d2818174ef) && res !== undefined) rules += res;
        }
        if (!(0, $7356e5b7b0984477$export$23f2a1d2818174ef)) return rules;
    });
    if (!(0, $7356e5b7b0984477$export$23f2a1d2818174ef) && rules.length !== 0) {
        var _ref2;
        return /*#__PURE__*/ $4Y8Vu.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedArr.map(function(serialized) {
            return serialized.name;
        }).join(' '), _ref2.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref2.nonce = cache.sheet.nonce, _ref2));
    }
    return null;
};
var $fb226fb4d95fe644$export$9b9c0f9d9f3552b8 = /* #__PURE__ */ (0, $7356e5b7b0984477$export$efccba1c4a2ef57b)(function(props, cache) {
    var hasRendered = false;
    var serializedArr = [];
    var css = function css() {
        if (hasRendered && (0, $7356e5b7b0984477$export$407448d2b89b1813)) throw new Error('css can only be used during render');
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var serialized = (0, $cdfa1116f6d61737$export$6321afa313b251b5)(args, cache.registered);
        serializedArr.push(serialized); // registration has to happen here as the result of this might get consumed by `cx`
        (0, $d72e34e8a4dd60ef$export$580009a5da2a8b4b)(cache, serialized, false);
        return cache.key + "-" + serialized.name;
    };
    var cx = function cx() {
        if (hasRendered && (0, $7356e5b7b0984477$export$407448d2b89b1813)) throw new Error('cx can only be used during render');
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return $fb226fb4d95fe644$var$merge(cache.registered, css, $fb226fb4d95fe644$var$classnames(args));
    };
    var content = {
        css: css,
        cx: cx,
        theme: $4Y8Vu.useContext((0, $7356e5b7b0984477$export$971d5caa766a69d7))
    };
    var ele = props.children(content);
    hasRendered = true;
    return /*#__PURE__*/ $4Y8Vu.createElement($4Y8Vu.Fragment, null, /*#__PURE__*/ $4Y8Vu.createElement($fb226fb4d95fe644$var$Insertion, {
        cache: cache,
        serializedArr: serializedArr
    }), ele);
});





function $f686099aa26add9e$export$2e2bcd8739ae039(e, t) {
    return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
        raw: {
            value: Object.freeze(t)
        }
    }));
}




var $4Y8Vu = parcelRequire("4Y8Vu");






/**
 * Custom positioning reference element.
 * @see https://floating-ui.com/docs/virtual-elements
 */ 
const $3e54f6501dd55d2d$export$832b6fa47fa053d2 = [
    'top',
    'right',
    'bottom',
    'left'
];
const $3e54f6501dd55d2d$export$27b07d8a310ed8b5 = [
    'start',
    'end'
];
const $3e54f6501dd55d2d$export$803cd8101b6c182b = /*#__PURE__*/ $3e54f6501dd55d2d$export$832b6fa47fa053d2.reduce((acc, side)=>acc.concat(side, side + "-" + $3e54f6501dd55d2d$export$27b07d8a310ed8b5[0], side + "-" + $3e54f6501dd55d2d$export$27b07d8a310ed8b5[1]), []);
const $3e54f6501dd55d2d$export$96ec731ed4dcb222 = Math.min;
const $3e54f6501dd55d2d$export$8960430cfd85939f = Math.max;
const $3e54f6501dd55d2d$export$2077e0241d6afd3c = Math.round;
const $3e54f6501dd55d2d$export$a3fe094919f356fd = Math.floor;
const $3e54f6501dd55d2d$export$a397704b5e280835 = (v)=>({
        x: v,
        y: v
    });
const $3e54f6501dd55d2d$var$oppositeSideMap = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
const $3e54f6501dd55d2d$var$oppositeAlignmentMap = {
    start: 'end',
    end: 'start'
};
function $3e54f6501dd55d2d$export$7d15b64cf5a3a4c4(start, value, end) {
    return $3e54f6501dd55d2d$export$8960430cfd85939f(start, $3e54f6501dd55d2d$export$96ec731ed4dcb222(value, end));
}
function $3e54f6501dd55d2d$export$fef61f332f2c0afc(value, param) {
    return typeof value === 'function' ? value(param) : value;
}
function $3e54f6501dd55d2d$export$3c915306cb7fc97a(placement) {
    return placement.split('-')[0];
}
function $3e54f6501dd55d2d$export$f0989780f32bfcda(placement) {
    return placement.split('-')[1];
}
function $3e54f6501dd55d2d$export$8a000a963141ac32(axis) {
    return axis === 'x' ? 'y' : 'x';
}
function $3e54f6501dd55d2d$export$320bd9d53520c68a(axis) {
    return axis === 'y' ? 'height' : 'width';
}
function $3e54f6501dd55d2d$export$f28e8f882010718a(placement) {
    return [
        'top',
        'bottom'
    ].includes($3e54f6501dd55d2d$export$3c915306cb7fc97a(placement)) ? 'y' : 'x';
}
function $3e54f6501dd55d2d$export$2b57e0052a6d6d4c(placement) {
    return $3e54f6501dd55d2d$export$8a000a963141ac32($3e54f6501dd55d2d$export$f28e8f882010718a(placement));
}
function $3e54f6501dd55d2d$export$be42861551f17911(placement, rects, rtl) {
    if (rtl === void 0) rtl = false;
    const alignment = $3e54f6501dd55d2d$export$f0989780f32bfcda(placement);
    const alignmentAxis = $3e54f6501dd55d2d$export$2b57e0052a6d6d4c(placement);
    const length = $3e54f6501dd55d2d$export$320bd9d53520c68a(alignmentAxis);
    let mainAlignmentSide = alignmentAxis === 'x' ? alignment === (rtl ? 'end' : 'start') ? 'right' : 'left' : alignment === 'start' ? 'bottom' : 'top';
    if (rects.reference[length] > rects.floating[length]) mainAlignmentSide = $3e54f6501dd55d2d$export$9c5e28bad23365fa(mainAlignmentSide);
    return [
        mainAlignmentSide,
        $3e54f6501dd55d2d$export$9c5e28bad23365fa(mainAlignmentSide)
    ];
}
function $3e54f6501dd55d2d$export$496432a3699e50b1(placement) {
    const oppositePlacement = $3e54f6501dd55d2d$export$9c5e28bad23365fa(placement);
    return [
        $3e54f6501dd55d2d$export$2b182c584985588b(placement),
        oppositePlacement,
        $3e54f6501dd55d2d$export$2b182c584985588b(oppositePlacement)
    ];
}
function $3e54f6501dd55d2d$export$2b182c584985588b(placement) {
    return placement.replace(/start|end/g, (alignment)=>$3e54f6501dd55d2d$var$oppositeAlignmentMap[alignment]);
}
function $3e54f6501dd55d2d$var$getSideList(side, isStart, rtl) {
    const lr = [
        'left',
        'right'
    ];
    const rl = [
        'right',
        'left'
    ];
    const tb = [
        'top',
        'bottom'
    ];
    const bt = [
        'bottom',
        'top'
    ];
    switch(side){
        case 'top':
        case 'bottom':
            if (rtl) return isStart ? rl : lr;
            return isStart ? lr : rl;
        case 'left':
        case 'right':
            return isStart ? tb : bt;
        default:
            return [];
    }
}
function $3e54f6501dd55d2d$export$a9b6fb18fd92c3ec(placement, flipAlignment, direction, rtl) {
    const alignment = $3e54f6501dd55d2d$export$f0989780f32bfcda(placement);
    let list = $3e54f6501dd55d2d$var$getSideList($3e54f6501dd55d2d$export$3c915306cb7fc97a(placement), direction === 'start', rtl);
    if (alignment) {
        list = list.map((side)=>side + "-" + alignment);
        if (flipAlignment) list = list.concat(list.map($3e54f6501dd55d2d$export$2b182c584985588b));
    }
    return list;
}
function $3e54f6501dd55d2d$export$9c5e28bad23365fa(placement) {
    return placement.replace(/left|right|bottom|top/g, (side)=>$3e54f6501dd55d2d$var$oppositeSideMap[side]);
}
function $3e54f6501dd55d2d$export$1c66dbf1a9e34223(padding) {
    return (0, $45c1a8590053a015$export$71511d61b312f219)({
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    }, padding);
}
function $3e54f6501dd55d2d$export$598c291c29bc2e71(padding) {
    return typeof padding !== 'number' ? $3e54f6501dd55d2d$export$1c66dbf1a9e34223(padding) : {
        top: padding,
        right: padding,
        bottom: padding,
        left: padding
    };
}
function $3e54f6501dd55d2d$export$ee05aea0aeecbad4(rect) {
    const { x: x, y: y, width: width, height: height } = rect;
    return {
        width: width,
        height: height,
        top: y,
        left: x,
        right: x + width,
        bottom: y + height,
        x: x,
        y: y
    };
}


function $7338c40772a45bcd$var$computeCoordsFromPlacement(_ref, placement, rtl) {
    let { reference: reference, floating: floating } = _ref;
    const sideAxis = (0, $3e54f6501dd55d2d$export$f28e8f882010718a)(placement);
    const alignmentAxis = (0, $3e54f6501dd55d2d$export$2b57e0052a6d6d4c)(placement);
    const alignLength = (0, $3e54f6501dd55d2d$export$320bd9d53520c68a)(alignmentAxis);
    const side = (0, $3e54f6501dd55d2d$export$3c915306cb7fc97a)(placement);
    const isVertical = sideAxis === 'y';
    const commonX = reference.x + reference.width / 2 - floating.width / 2;
    const commonY = reference.y + reference.height / 2 - floating.height / 2;
    const commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
    let coords;
    switch(side){
        case 'top':
            coords = {
                x: commonX,
                y: reference.y - floating.height
            };
            break;
        case 'bottom':
            coords = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 'right':
            coords = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 'left':
            coords = {
                x: reference.x - floating.width,
                y: commonY
            };
            break;
        default:
            coords = {
                x: reference.x,
                y: reference.y
            };
    }
    switch((0, $3e54f6501dd55d2d$export$f0989780f32bfcda)(placement)){
        case 'start':
            coords[alignmentAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
            break;
        case 'end':
            coords[alignmentAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
            break;
    }
    return coords;
}
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 *
 * This export does not have any `platform` interface logic. You will need to
 * write one for the platform you are using Floating UI with.
 */ const $7338c40772a45bcd$export$48a53dcb22e581d0 = async (reference, floating, config)=>{
    const { placement: placement = 'bottom', strategy: strategy = 'absolute', middleware: middleware = [], platform: platform } = config;
    const validMiddleware = middleware.filter(Boolean);
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(floating));
    let rects = await platform.getElementRects({
        reference: reference,
        floating: floating,
        strategy: strategy
    });
    let { x: x, y: y } = $7338c40772a45bcd$var$computeCoordsFromPlacement(rects, placement, rtl);
    let statefulPlacement = placement;
    let middlewareData = {};
    let resetCount = 0;
    for(let i = 0; i < validMiddleware.length; i++){
        const { name: name, fn: fn } = validMiddleware[i];
        const { x: nextX, y: nextY, data: data, reset: reset } = await fn({
            x: x,
            y: y,
            initialPlacement: placement,
            placement: statefulPlacement,
            strategy: strategy,
            middlewareData: middlewareData,
            rects: rects,
            platform: platform,
            elements: {
                reference: reference,
                floating: floating
            }
        });
        x = nextX != null ? nextX : x;
        y = nextY != null ? nextY : y;
        middlewareData = (0, $8f44472fa5eb25c0$export$71511d61b312f219)((0, $45c1a8590053a015$export$71511d61b312f219)({}, middlewareData), {
            [name]: (0, $45c1a8590053a015$export$71511d61b312f219)({}, middlewareData[name], data)
        });
        if (reset && resetCount <= 50) {
            resetCount++;
            if (typeof reset === 'object') {
                if (reset.placement) statefulPlacement = reset.placement;
                if (reset.rects) rects = reset.rects === true ? await platform.getElementRects({
                    reference: reference,
                    floating: floating,
                    strategy: strategy
                }) : reset.rects;
                ({ x: x, y: y } = $7338c40772a45bcd$var$computeCoordsFromPlacement(rects, statefulPlacement, rtl));
            }
            i = -1;
        }
    }
    return {
        x: x,
        y: y,
        placement: statefulPlacement,
        strategy: strategy,
        middlewareData: middlewareData
    };
};
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ async function $7338c40772a45bcd$export$37b6bde19b108ecc(state, options) {
    var _await$platform$isEle;
    if (options === void 0) options = {};
    const { x: x, y: y, platform: platform, rects: rects, elements: elements, strategy: strategy } = state;
    const { boundary: boundary = 'clippingAncestors', rootBoundary: rootBoundary = 'viewport', elementContext: elementContext = 'floating', altBoundary: altBoundary = false, padding: padding = 0 } = (0, $3e54f6501dd55d2d$export$fef61f332f2c0afc)(options, state);
    const paddingObject = (0, $3e54f6501dd55d2d$export$598c291c29bc2e71)(padding);
    const altContext = elementContext === 'floating' ? 'reference' : 'floating';
    const element = elements[altBoundary ? altContext : elementContext];
    const clippingClientRect = (0, $3e54f6501dd55d2d$export$ee05aea0aeecbad4)(await platform.getClippingRect({
        element: ((_await$platform$isEle = await (platform.isElement == null ? void 0 : platform.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || await (platform.getDocumentElement == null ? void 0 : platform.getDocumentElement(elements.floating)),
        boundary: boundary,
        rootBoundary: rootBoundary,
        strategy: strategy
    }));
    const rect = elementContext === 'floating' ? {
        x: x,
        y: y,
        width: rects.floating.width,
        height: rects.floating.height
    } : rects.reference;
    const offsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(elements.floating));
    const offsetScale = await (platform.isElement == null ? void 0 : platform.isElement(offsetParent)) ? await (platform.getScale == null ? void 0 : platform.getScale(offsetParent)) || {
        x: 1,
        y: 1
    } : {
        x: 1,
        y: 1
    };
    const elementClientRect = (0, $3e54f6501dd55d2d$export$ee05aea0aeecbad4)(platform.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform.convertOffsetParentRelativeRectToViewportRelativeRect({
        elements: elements,
        rect: rect,
        offsetParent: offsetParent,
        strategy: strategy
    }) : rect);
    return {
        top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
        bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
        left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
        right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
    };
}
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $7338c40772a45bcd$export$f2120bbfa5450bd2 = (options)=>({
        name: 'arrow',
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, platform: platform, elements: elements, middlewareData: middlewareData } = state;
            // Since `element` is required, we don't Partial<> the type.
            const { element: element, padding: padding = 0 } = (0, $3e54f6501dd55d2d$export$fef61f332f2c0afc)(options, state) || {};
            if (element == null) return {};
            const paddingObject = (0, $3e54f6501dd55d2d$export$598c291c29bc2e71)(padding);
            const coords = {
                x: x,
                y: y
            };
            const axis = (0, $3e54f6501dd55d2d$export$2b57e0052a6d6d4c)(placement);
            const length = (0, $3e54f6501dd55d2d$export$320bd9d53520c68a)(axis);
            const arrowDimensions = await platform.getDimensions(element);
            const isYAxis = axis === 'y';
            const minProp = isYAxis ? 'top' : 'left';
            const maxProp = isYAxis ? 'bottom' : 'right';
            const clientProp = isYAxis ? 'clientHeight' : 'clientWidth';
            const endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
            const startDiff = coords[axis] - rects.reference[axis];
            const arrowOffsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(element));
            let clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;
            // DOM platform can return `window` as the `offsetParent`.
            if (!clientSize || !await (platform.isElement == null ? void 0 : platform.isElement(arrowOffsetParent))) clientSize = elements.floating[clientProp] || rects.floating[length];
            const centerToReference = endDiff / 2 - startDiff / 2;
            // If the padding is large enough that it causes the arrow to no longer be
            // centered, modify the padding so that it is centered.
            const largestPossiblePadding = clientSize / 2 - arrowDimensions[length] / 2 - 1;
            const minPadding = (0, $3e54f6501dd55d2d$export$96ec731ed4dcb222)(paddingObject[minProp], largestPossiblePadding);
            const maxPadding = (0, $3e54f6501dd55d2d$export$96ec731ed4dcb222)(paddingObject[maxProp], largestPossiblePadding);
            // Make sure the arrow doesn't overflow the floating element if the center
            // point is outside the floating element's bounds.
            const min$1 = minPadding;
            const max = clientSize - arrowDimensions[length] - maxPadding;
            const center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
            const offset = (0, $3e54f6501dd55d2d$export$7d15b64cf5a3a4c4)(min$1, center, max);
            // If the reference is small enough that the arrow's padding causes it to
            // to point to nothing for an aligned placement, adjust the offset of the
            // floating element itself. To ensure `shift()` continues to take action,
            // a single reset is performed when this is true.
            const shouldAddOffset = !middlewareData.arrow && (0, $3e54f6501dd55d2d$export$f0989780f32bfcda)(placement) != null && center !== offset && rects.reference[length] / 2 - (center < min$1 ? minPadding : maxPadding) - arrowDimensions[length] / 2 < 0;
            const alignmentOffset = shouldAddOffset ? center < min$1 ? center - min$1 : center - max : 0;
            return {
                [axis]: coords[axis] + alignmentOffset,
                data: (0, $45c1a8590053a015$export$71511d61b312f219)({
                    [axis]: offset,
                    centerOffset: center - offset - alignmentOffset
                }, shouldAddOffset && {
                    alignmentOffset: alignmentOffset
                }),
                reset: shouldAddOffset
            };
        }
    });
function $7338c40772a45bcd$var$getPlacementList(alignment, autoAlignment, allowedPlacements) {
    const allowedPlacementsSortedByAlignment = alignment ? [
        ...allowedPlacements.filter((placement)=>(0, $3e54f6501dd55d2d$export$f0989780f32bfcda)(placement) === alignment),
        ...allowedPlacements.filter((placement)=>(0, $3e54f6501dd55d2d$export$f0989780f32bfcda)(placement) !== alignment)
    ] : allowedPlacements.filter((placement)=>(0, $3e54f6501dd55d2d$export$3c915306cb7fc97a)(placement) === placement);
    return allowedPlacementsSortedByAlignment.filter((placement)=>{
        if (alignment) return (0, $3e54f6501dd55d2d$export$f0989780f32bfcda)(placement) === alignment || (autoAlignment ? (0, $3e54f6501dd55d2d$export$2b182c584985588b)(placement) !== placement : false);
        return true;
    });
}
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $7338c40772a45bcd$export$91fb6ecbd551914 = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'autoPlacement',
        options: options,
        async fn (state) {
            var _middlewareData$autoP, _middlewareData$autoP2, _placementsThatFitOnE;
            const { rects: rects, middlewareData: middlewareData, placement: placement, platform: platform, elements: elements } = state;
            const _evaluate = (0, $3e54f6501dd55d2d$export$fef61f332f2c0afc)(options, state), { crossAxis: crossAxis = false, alignment: alignment, allowedPlacements: allowedPlacements = (0, $3e54f6501dd55d2d$export$803cd8101b6c182b), autoAlignment: autoAlignment = true } = _evaluate, detectOverflowOptions = (0, $30c24b3cbf3b0a7a$export$71511d61b312f219)(_evaluate, [
                "crossAxis",
                "alignment",
                "allowedPlacements",
                "autoAlignment"
            ]);
            const placements$1 = alignment !== undefined || allowedPlacements === (0, $3e54f6501dd55d2d$export$803cd8101b6c182b) ? $7338c40772a45bcd$var$getPlacementList(alignment || null, autoAlignment, allowedPlacements) : allowedPlacements;
            const overflow = await $7338c40772a45bcd$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const currentIndex = ((_middlewareData$autoP = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP.index) || 0;
            const currentPlacement = placements$1[currentIndex];
            if (currentPlacement == null) return {};
            const alignmentSides = (0, $3e54f6501dd55d2d$export$be42861551f17911)(currentPlacement, rects, await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)));
            // Make `computeCoords` start from the right place.
            if (placement !== currentPlacement) return {
                reset: {
                    placement: placements$1[0]
                }
            };
            const currentOverflows = [
                overflow[(0, $3e54f6501dd55d2d$export$3c915306cb7fc97a)(currentPlacement)],
                overflow[alignmentSides[0]],
                overflow[alignmentSides[1]]
            ];
            const allOverflows = [
                ...((_middlewareData$autoP2 = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP2.overflows) || [],
                {
                    placement: currentPlacement,
                    overflows: currentOverflows
                }
            ];
            const nextPlacement = placements$1[currentIndex + 1];
            // There are more placements to check.
            if (nextPlacement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: nextPlacement
                }
            };
            const placementsSortedByMostSpace = allOverflows.map((d)=>{
                const alignment = (0, $3e54f6501dd55d2d$export$f0989780f32bfcda)(d.placement);
                return [
                    d.placement,
                    alignment && crossAxis ? // Check along the mainAxis and main crossAxis side.
                    d.overflows.slice(0, 2).reduce((acc, v)=>acc + v, 0) : // Check only the mainAxis.
                    d.overflows[0],
                    d.overflows
                ];
            }).sort((a, b)=>a[1] - b[1]);
            const placementsThatFitOnEachSide = placementsSortedByMostSpace.filter((d)=>d[2].slice(0, // Aligned placements should not check their opposite crossAxis
                // side.
                (0, $3e54f6501dd55d2d$export$f0989780f32bfcda)(d[0]) ? 2 : 3).every((v)=>v <= 0));
            const resetPlacement = ((_placementsThatFitOnE = placementsThatFitOnEachSide[0]) == null ? void 0 : _placementsThatFitOnE[0]) || placementsSortedByMostSpace[0][0];
            if (resetPlacement !== placement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: resetPlacement
                }
            };
            return {};
        }
    };
};
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $7338c40772a45bcd$export$8a83211c878a3f1f = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'flip',
        options: options,
        async fn (state) {
            var _middlewareData$arrow, _middlewareData$flip;
            const { placement: placement, middlewareData: middlewareData, rects: rects, initialPlacement: initialPlacement, platform: platform, elements: elements } = state;
            const _evaluate = (0, $3e54f6501dd55d2d$export$fef61f332f2c0afc)(options, state), { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true, fallbackPlacements: specifiedFallbackPlacements, fallbackStrategy: fallbackStrategy = 'bestFit', fallbackAxisSideDirection: fallbackAxisSideDirection = 'none', flipAlignment: flipAlignment = true } = _evaluate, detectOverflowOptions = (0, $30c24b3cbf3b0a7a$export$71511d61b312f219)(_evaluate, [
                "mainAxis",
                "crossAxis",
                "fallbackPlacements",
                "fallbackStrategy",
                "fallbackAxisSideDirection",
                "flipAlignment"
            ]);
            // If a reset by the arrow was caused due to an alignment offset being
            // added, we should skip any logic now since `flip()` has already done its
            // work.
            // https://github.com/floating-ui/floating-ui/issues/2549#issuecomment-1719601643
            if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            const side = (0, $3e54f6501dd55d2d$export$3c915306cb7fc97a)(placement);
            const initialSideAxis = (0, $3e54f6501dd55d2d$export$f28e8f882010718a)(initialPlacement);
            const isBasePlacement = (0, $3e54f6501dd55d2d$export$3c915306cb7fc97a)(initialPlacement) === initialPlacement;
            const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
            const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [
                (0, $3e54f6501dd55d2d$export$9c5e28bad23365fa)(initialPlacement)
            ] : (0, $3e54f6501dd55d2d$export$496432a3699e50b1)(initialPlacement));
            const hasFallbackAxisSideDirection = fallbackAxisSideDirection !== 'none';
            if (!specifiedFallbackPlacements && hasFallbackAxisSideDirection) fallbackPlacements.push(...(0, $3e54f6501dd55d2d$export$a9b6fb18fd92c3ec)(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
            const placements = [
                initialPlacement,
                ...fallbackPlacements
            ];
            const overflow = await $7338c40772a45bcd$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const overflows = [];
            let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
            if (checkMainAxis) overflows.push(overflow[side]);
            if (checkCrossAxis) {
                const sides = (0, $3e54f6501dd55d2d$export$be42861551f17911)(placement, rects, rtl);
                overflows.push(overflow[sides[0]], overflow[sides[1]]);
            }
            overflowsData = [
                ...overflowsData,
                {
                    placement: placement,
                    overflows: overflows
                }
            ];
            // One or more sides is overflowing.
            if (!overflows.every((side)=>side <= 0)) {
                var _middlewareData$flip2, _overflowsData$filter;
                const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
                const nextPlacement = placements[nextIndex];
                if (nextPlacement) {
                    var _overflowsData$;
                    const ignoreCrossAxisOverflow = checkCrossAxis === 'alignment' ? initialSideAxis !== (0, $3e54f6501dd55d2d$export$f28e8f882010718a)(nextPlacement) : false;
                    const hasInitialMainAxisOverflow = ((_overflowsData$ = overflowsData[0]) == null ? void 0 : _overflowsData$.overflows[0]) > 0;
                    if (!ignoreCrossAxisOverflow || hasInitialMainAxisOverflow) // Try next placement and re-run the lifecycle.
                    return {
                        data: {
                            index: nextIndex,
                            overflows: overflowsData
                        },
                        reset: {
                            placement: nextPlacement
                        }
                    };
                }
                // First, find the candidates that fit on the mainAxis side of overflow,
                // then find the placement that fits the best on the main crossAxis side.
                let resetPlacement = (_overflowsData$filter = overflowsData.filter((d)=>d.overflows[0] <= 0).sort((a, b)=>a.overflows[1] - b.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;
                // Otherwise fallback.
                if (!resetPlacement) switch(fallbackStrategy){
                    case 'bestFit':
                        {
                            var _overflowsData$filter2;
                            const placement = (_overflowsData$filter2 = overflowsData.filter((d)=>{
                                if (hasFallbackAxisSideDirection) {
                                    const currentSideAxis = (0, $3e54f6501dd55d2d$export$f28e8f882010718a)(d.placement);
                                    return currentSideAxis === initialSideAxis || // Create a bias to the `y` side axis due to horizontal
                                    // reading directions favoring greater width.
                                    currentSideAxis === 'y';
                                }
                                return true;
                            }).map((d)=>[
                                    d.placement,
                                    d.overflows.filter((overflow)=>overflow > 0).reduce((acc, overflow)=>acc + overflow, 0)
                                ]).sort((a, b)=>a[1] - b[1])[0]) == null ? void 0 : _overflowsData$filter2[0];
                            if (placement) resetPlacement = placement;
                            break;
                        }
                    case 'initialPlacement':
                        resetPlacement = initialPlacement;
                        break;
                }
                if (placement !== resetPlacement) return {
                    reset: {
                        placement: resetPlacement
                    }
                };
            }
            return {};
        }
    };
};
function $7338c40772a45bcd$var$getSideOffsets(overflow, rect) {
    return {
        top: overflow.top - rect.height,
        right: overflow.right - rect.width,
        bottom: overflow.bottom - rect.height,
        left: overflow.left - rect.width
    };
}
function $7338c40772a45bcd$var$isAnySideFullyClipped(overflow) {
    return (0, $3e54f6501dd55d2d$export$832b6fa47fa053d2).some((side)=>overflow[side] >= 0);
}
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $7338c40772a45bcd$export$fe8985bb6374093c = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'hide',
        options: options,
        async fn (state) {
            const { rects: rects } = state;
            const _evaluate = (0, $3e54f6501dd55d2d$export$fef61f332f2c0afc)(options, state), { strategy: strategy = 'referenceHidden' } = _evaluate, detectOverflowOptions = (0, $30c24b3cbf3b0a7a$export$71511d61b312f219)(_evaluate, [
                "strategy"
            ]);
            switch(strategy){
                case 'referenceHidden':
                    {
                        const overflow = await $7338c40772a45bcd$export$37b6bde19b108ecc(state, (0, $8f44472fa5eb25c0$export$71511d61b312f219)((0, $45c1a8590053a015$export$71511d61b312f219)({}, detectOverflowOptions), {
                            elementContext: 'reference'
                        }));
                        const offsets = $7338c40772a45bcd$var$getSideOffsets(overflow, rects.reference);
                        return {
                            data: {
                                referenceHiddenOffsets: offsets,
                                referenceHidden: $7338c40772a45bcd$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                case 'escaped':
                    {
                        const overflow = await $7338c40772a45bcd$export$37b6bde19b108ecc(state, (0, $8f44472fa5eb25c0$export$71511d61b312f219)((0, $45c1a8590053a015$export$71511d61b312f219)({}, detectOverflowOptions), {
                            altBoundary: true
                        }));
                        const offsets = $7338c40772a45bcd$var$getSideOffsets(overflow, rects.floating);
                        return {
                            data: {
                                escapedOffsets: offsets,
                                escaped: $7338c40772a45bcd$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                default:
                    return {};
            }
        }
    };
};
function $7338c40772a45bcd$var$getBoundingRect(rects) {
    const minX = (0, $3e54f6501dd55d2d$export$96ec731ed4dcb222)(...rects.map((rect)=>rect.left));
    const minY = (0, $3e54f6501dd55d2d$export$96ec731ed4dcb222)(...rects.map((rect)=>rect.top));
    const maxX = (0, $3e54f6501dd55d2d$export$8960430cfd85939f)(...rects.map((rect)=>rect.right));
    const maxY = (0, $3e54f6501dd55d2d$export$8960430cfd85939f)(...rects.map((rect)=>rect.bottom));
    return {
        x: minX,
        y: minY,
        width: maxX - minX,
        height: maxY - minY
    };
}
function $7338c40772a45bcd$var$getRectsByLine(rects) {
    const sortedRects = rects.slice().sort((a, b)=>a.y - b.y);
    const groups = [];
    let prevRect = null;
    for(let i = 0; i < sortedRects.length; i++){
        const rect = sortedRects[i];
        if (!prevRect || rect.y - prevRect.y > prevRect.height / 2) groups.push([
            rect
        ]);
        else groups[groups.length - 1].push(rect);
        prevRect = rect;
    }
    return groups.map((rect)=>(0, $3e54f6501dd55d2d$export$ee05aea0aeecbad4)($7338c40772a45bcd$var$getBoundingRect(rect)));
}
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $7338c40772a45bcd$export$18c8ad048e32c7d5 = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'inline',
        options: options,
        async fn (state) {
            const { placement: placement, elements: elements, rects: rects, platform: platform, strategy: strategy } = state;
            // A MouseEvent's client{X,Y} coords can be up to 2 pixels off a
            // ClientRect's bounds, despite the event listener being triggered. A
            // padding of 2 seems to handle this issue.
            const { padding: padding = 2, x: x, y: y } = (0, $3e54f6501dd55d2d$export$fef61f332f2c0afc)(options, state);
            const nativeClientRects = Array.from(await (platform.getClientRects == null ? void 0 : platform.getClientRects(elements.reference)) || []);
            const clientRects = $7338c40772a45bcd$var$getRectsByLine(nativeClientRects);
            const fallback = (0, $3e54f6501dd55d2d$export$ee05aea0aeecbad4)($7338c40772a45bcd$var$getBoundingRect(nativeClientRects));
            const paddingObject = (0, $3e54f6501dd55d2d$export$598c291c29bc2e71)(padding);
            function getBoundingClientRect() {
                // There are two rects and they are disjoined.
                if (clientRects.length === 2 && clientRects[0].left > clientRects[1].right && x != null && y != null) // Find the first rect in which the point is fully inside.
                return clientRects.find((rect)=>x > rect.left - paddingObject.left && x < rect.right + paddingObject.right && y > rect.top - paddingObject.top && y < rect.bottom + paddingObject.bottom) || fallback;
                // There are 2 or more connected rects.
                if (clientRects.length >= 2) {
                    if ((0, $3e54f6501dd55d2d$export$f28e8f882010718a)(placement) === 'y') {
                        const firstRect = clientRects[0];
                        const lastRect = clientRects[clientRects.length - 1];
                        const isTop = (0, $3e54f6501dd55d2d$export$3c915306cb7fc97a)(placement) === 'top';
                        const top = firstRect.top;
                        const bottom = lastRect.bottom;
                        const left = isTop ? firstRect.left : lastRect.left;
                        const right = isTop ? firstRect.right : lastRect.right;
                        const width = right - left;
                        const height = bottom - top;
                        return {
                            top: top,
                            bottom: bottom,
                            left: left,
                            right: right,
                            width: width,
                            height: height,
                            x: left,
                            y: top
                        };
                    }
                    const isLeftSide = (0, $3e54f6501dd55d2d$export$3c915306cb7fc97a)(placement) === 'left';
                    const maxRight = (0, $3e54f6501dd55d2d$export$8960430cfd85939f)(...clientRects.map((rect)=>rect.right));
                    const minLeft = (0, $3e54f6501dd55d2d$export$96ec731ed4dcb222)(...clientRects.map((rect)=>rect.left));
                    const measureRects = clientRects.filter((rect)=>isLeftSide ? rect.left === minLeft : rect.right === maxRight);
                    const top = measureRects[0].top;
                    const bottom = measureRects[measureRects.length - 1].bottom;
                    const left = minLeft;
                    const right = maxRight;
                    const width = right - left;
                    const height = bottom - top;
                    return {
                        top: top,
                        bottom: bottom,
                        left: left,
                        right: right,
                        width: width,
                        height: height,
                        x: left,
                        y: top
                    };
                }
                return fallback;
            }
            const resetRects = await platform.getElementRects({
                reference: {
                    getBoundingClientRect: getBoundingClientRect
                },
                floating: elements.floating,
                strategy: strategy
            });
            if (rects.reference.x !== resetRects.reference.x || rects.reference.y !== resetRects.reference.y || rects.reference.width !== resetRects.reference.width || rects.reference.height !== resetRects.reference.height) return {
                reset: {
                    rects: resetRects
                }
            };
            return {};
        }
    };
};
// For type backwards-compatibility, the `OffsetOptions` type was also
// Derivable.
async function $7338c40772a45bcd$var$convertValueToCoords(state, options) {
    const { placement: placement, platform: platform, elements: elements } = state;
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
    const side = (0, $3e54f6501dd55d2d$export$3c915306cb7fc97a)(placement);
    const alignment = (0, $3e54f6501dd55d2d$export$f0989780f32bfcda)(placement);
    const isVertical = (0, $3e54f6501dd55d2d$export$f28e8f882010718a)(placement) === 'y';
    const mainAxisMulti = [
        'left',
        'top'
    ].includes(side) ? -1 : 1;
    const crossAxisMulti = rtl && isVertical ? -1 : 1;
    const rawValue = (0, $3e54f6501dd55d2d$export$fef61f332f2c0afc)(options, state);
    // eslint-disable-next-line prefer-const
    let { mainAxis: mainAxis, crossAxis: crossAxis, alignmentAxis: alignmentAxis } = typeof rawValue === 'number' ? {
        mainAxis: rawValue,
        crossAxis: 0,
        alignmentAxis: null
    } : {
        mainAxis: rawValue.mainAxis || 0,
        crossAxis: rawValue.crossAxis || 0,
        alignmentAxis: rawValue.alignmentAxis
    };
    if (alignment && typeof alignmentAxis === 'number') crossAxis = alignment === 'end' ? alignmentAxis * -1 : alignmentAxis;
    return isVertical ? {
        x: crossAxis * crossAxisMulti,
        y: mainAxis * mainAxisMulti
    } : {
        x: mainAxis * mainAxisMulti,
        y: crossAxis * crossAxisMulti
    };
}
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $7338c40772a45bcd$export$cc800923e997bb8 = function(options) {
    if (options === void 0) options = 0;
    return {
        name: 'offset',
        options: options,
        async fn (state) {
            var _middlewareData$offse, _middlewareData$arrow;
            const { x: x, y: y, placement: placement, middlewareData: middlewareData } = state;
            const diffCoords = await $7338c40772a45bcd$var$convertValueToCoords(state, options);
            // If the placement is the same and the arrow caused an alignment offset
            // then we don't need to change the positioning coordinates.
            if (placement === ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse.placement) && (_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            return {
                x: x + diffCoords.x,
                y: y + diffCoords.y,
                data: (0, $8f44472fa5eb25c0$export$71511d61b312f219)((0, $45c1a8590053a015$export$71511d61b312f219)({}, diffCoords), {
                    placement: placement
                })
            };
        }
    };
};
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $7338c40772a45bcd$export$fba63a578e423eb = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'shift',
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement } = state;
            const _evaluate = (0, $3e54f6501dd55d2d$export$fef61f332f2c0afc)(options, state), { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = false, limiter: limiter = {
                fn: (_ref)=>{
                    let { x: x, y: y } = _ref;
                    return {
                        x: x,
                        y: y
                    };
                }
            } } = _evaluate, detectOverflowOptions = (0, $30c24b3cbf3b0a7a$export$71511d61b312f219)(_evaluate, [
                "mainAxis",
                "crossAxis",
                "limiter"
            ]);
            const coords = {
                x: x,
                y: y
            };
            const overflow = await $7338c40772a45bcd$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const crossAxis = (0, $3e54f6501dd55d2d$export$f28e8f882010718a)((0, $3e54f6501dd55d2d$export$3c915306cb7fc97a)(placement));
            const mainAxis = (0, $3e54f6501dd55d2d$export$8a000a963141ac32)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            if (checkMainAxis) {
                const minSide = mainAxis === 'y' ? 'top' : 'left';
                const maxSide = mainAxis === 'y' ? 'bottom' : 'right';
                const min = mainAxisCoord + overflow[minSide];
                const max = mainAxisCoord - overflow[maxSide];
                mainAxisCoord = (0, $3e54f6501dd55d2d$export$7d15b64cf5a3a4c4)(min, mainAxisCoord, max);
            }
            if (checkCrossAxis) {
                const minSide = crossAxis === 'y' ? 'top' : 'left';
                const maxSide = crossAxis === 'y' ? 'bottom' : 'right';
                const min = crossAxisCoord + overflow[minSide];
                const max = crossAxisCoord - overflow[maxSide];
                crossAxisCoord = (0, $3e54f6501dd55d2d$export$7d15b64cf5a3a4c4)(min, crossAxisCoord, max);
            }
            const limitedCoords = limiter.fn((0, $8f44472fa5eb25c0$export$71511d61b312f219)((0, $45c1a8590053a015$export$71511d61b312f219)({}, state), {
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            }));
            return (0, $8f44472fa5eb25c0$export$71511d61b312f219)((0, $45c1a8590053a015$export$71511d61b312f219)({}, limitedCoords), {
                data: {
                    x: limitedCoords.x - x,
                    y: limitedCoords.y - y,
                    enabled: {
                        [mainAxis]: checkMainAxis,
                        [crossAxis]: checkCrossAxis
                    }
                }
            });
        }
    };
};
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $7338c40772a45bcd$export$7bf07e38f3dc4b69 = function(options) {
    if (options === void 0) options = {};
    return {
        options: options,
        fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, middlewareData: middlewareData } = state;
            const { offset: offset = 0, mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true } = (0, $3e54f6501dd55d2d$export$fef61f332f2c0afc)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const crossAxis = (0, $3e54f6501dd55d2d$export$f28e8f882010718a)(placement);
            const mainAxis = (0, $3e54f6501dd55d2d$export$8a000a963141ac32)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            const rawOffset = (0, $3e54f6501dd55d2d$export$fef61f332f2c0afc)(offset, state);
            const computedOffset = typeof rawOffset === 'number' ? {
                mainAxis: rawOffset,
                crossAxis: 0
            } : (0, $45c1a8590053a015$export$71511d61b312f219)({
                mainAxis: 0,
                crossAxis: 0
            }, rawOffset);
            if (checkMainAxis) {
                const len = mainAxis === 'y' ? 'height' : 'width';
                const limitMin = rects.reference[mainAxis] - rects.floating[len] + computedOffset.mainAxis;
                const limitMax = rects.reference[mainAxis] + rects.reference[len] - computedOffset.mainAxis;
                if (mainAxisCoord < limitMin) mainAxisCoord = limitMin;
                else if (mainAxisCoord > limitMax) mainAxisCoord = limitMax;
            }
            if (checkCrossAxis) {
                var _middlewareData$offse, _middlewareData$offse2;
                const len = mainAxis === 'y' ? 'width' : 'height';
                const isOriginSide = [
                    'top',
                    'left'
                ].includes((0, $3e54f6501dd55d2d$export$3c915306cb7fc97a)(placement));
                const limitMin = rects.reference[crossAxis] - rects.floating[len] + (isOriginSide ? ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse[crossAxis]) || 0 : 0) + (isOriginSide ? 0 : computedOffset.crossAxis);
                const limitMax = rects.reference[crossAxis] + rects.reference[len] + (isOriginSide ? 0 : ((_middlewareData$offse2 = middlewareData.offset) == null ? void 0 : _middlewareData$offse2[crossAxis]) || 0) - (isOriginSide ? computedOffset.crossAxis : 0);
                if (crossAxisCoord < limitMin) crossAxisCoord = limitMin;
                else if (crossAxisCoord > limitMax) crossAxisCoord = limitMax;
            }
            return {
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            };
        }
    };
};
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $7338c40772a45bcd$export$346677f925de839c = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'size',
        options: options,
        async fn (state) {
            var _state$middlewareData, _state$middlewareData2;
            const { placement: placement, rects: rects, platform: platform, elements: elements } = state;
            const _evaluate = (0, $3e54f6501dd55d2d$export$fef61f332f2c0afc)(options, state), { apply: apply = ()=>{} } = _evaluate, detectOverflowOptions = (0, $30c24b3cbf3b0a7a$export$71511d61b312f219)(_evaluate, [
                "apply"
            ]);
            const overflow = await $7338c40772a45bcd$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const side = (0, $3e54f6501dd55d2d$export$3c915306cb7fc97a)(placement);
            const alignment = (0, $3e54f6501dd55d2d$export$f0989780f32bfcda)(placement);
            const isYAxis = (0, $3e54f6501dd55d2d$export$f28e8f882010718a)(placement) === 'y';
            const { width: width, height: height } = rects.floating;
            let heightSide;
            let widthSide;
            if (side === 'top' || side === 'bottom') {
                heightSide = side;
                widthSide = alignment === (await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)) ? 'start' : 'end') ? 'left' : 'right';
            } else {
                widthSide = side;
                heightSide = alignment === 'end' ? 'top' : 'bottom';
            }
            const maximumClippingHeight = height - overflow.top - overflow.bottom;
            const maximumClippingWidth = width - overflow.left - overflow.right;
            const overflowAvailableHeight = (0, $3e54f6501dd55d2d$export$96ec731ed4dcb222)(height - overflow[heightSide], maximumClippingHeight);
            const overflowAvailableWidth = (0, $3e54f6501dd55d2d$export$96ec731ed4dcb222)(width - overflow[widthSide], maximumClippingWidth);
            const noShift = !state.middlewareData.shift;
            let availableHeight = overflowAvailableHeight;
            let availableWidth = overflowAvailableWidth;
            if ((_state$middlewareData = state.middlewareData.shift) != null && _state$middlewareData.enabled.x) availableWidth = maximumClippingWidth;
            if ((_state$middlewareData2 = state.middlewareData.shift) != null && _state$middlewareData2.enabled.y) availableHeight = maximumClippingHeight;
            if (noShift && !alignment) {
                const xMin = (0, $3e54f6501dd55d2d$export$8960430cfd85939f)(overflow.left, 0);
                const xMax = (0, $3e54f6501dd55d2d$export$8960430cfd85939f)(overflow.right, 0);
                const yMin = (0, $3e54f6501dd55d2d$export$8960430cfd85939f)(overflow.top, 0);
                const yMax = (0, $3e54f6501dd55d2d$export$8960430cfd85939f)(overflow.bottom, 0);
                if (isYAxis) availableWidth = width - 2 * (xMin !== 0 || xMax !== 0 ? xMin + xMax : (0, $3e54f6501dd55d2d$export$8960430cfd85939f)(overflow.left, overflow.right));
                else availableHeight = height - 2 * (yMin !== 0 || yMax !== 0 ? yMin + yMax : (0, $3e54f6501dd55d2d$export$8960430cfd85939f)(overflow.top, overflow.bottom));
            }
            await apply((0, $8f44472fa5eb25c0$export$71511d61b312f219)((0, $45c1a8590053a015$export$71511d61b312f219)({}, state), {
                availableWidth: availableWidth,
                availableHeight: availableHeight
            }));
            const nextDimensions = await platform.getDimensions(elements.floating);
            if (width !== nextDimensions.width || height !== nextDimensions.height) return {
                reset: {
                    rects: true
                }
            };
            return {};
        }
    };
};



function $90af9d0b1c819f36$var$hasWindow() {
    return typeof window !== 'undefined';
}
function $90af9d0b1c819f36$export$651544f548703224(node) {
    if ($90af9d0b1c819f36$export$8ee0fc9ee280b4ee(node)) return (node.nodeName || '').toLowerCase();
    // Mocked nodes in testing environments may not be instances of Node. By
    // returning `#document` an infinite loop won't occur.
    // https://github.com/floating-ui/floating-ui/issues/2317
    return '#document';
}
function $90af9d0b1c819f36$export$38b2d434cce3ea22(node) {
    var _node$ownerDocument;
    return (node == null || (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function $90af9d0b1c819f36$export$e495491855dc5418(node) {
    var _ref;
    return (_ref = ($90af9d0b1c819f36$export$8ee0fc9ee280b4ee(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
}
function $90af9d0b1c819f36$export$8ee0fc9ee280b4ee(value) {
    if (!$90af9d0b1c819f36$var$hasWindow()) return false;
    return value instanceof Node || value instanceof $90af9d0b1c819f36$export$38b2d434cce3ea22(value).Node;
}
function $90af9d0b1c819f36$export$45a5e7f76e0caa8d(value) {
    if (!$90af9d0b1c819f36$var$hasWindow()) return false;
    return value instanceof Element || value instanceof $90af9d0b1c819f36$export$38b2d434cce3ea22(value).Element;
}
function $90af9d0b1c819f36$export$1b3bfaa9684536aa(value) {
    if (!$90af9d0b1c819f36$var$hasWindow()) return false;
    return value instanceof HTMLElement || value instanceof $90af9d0b1c819f36$export$38b2d434cce3ea22(value).HTMLElement;
}
function $90af9d0b1c819f36$export$af51f0f06c0f328a(value) {
    if (!$90af9d0b1c819f36$var$hasWindow() || typeof ShadowRoot === 'undefined') return false;
    return value instanceof ShadowRoot || value instanceof $90af9d0b1c819f36$export$38b2d434cce3ea22(value).ShadowRoot;
}
function $90af9d0b1c819f36$export$989e911fa9af580a(element) {
    const { overflow: overflow, overflowX: overflowX, overflowY: overflowY, display: display } = $90af9d0b1c819f36$export$3735103072e4a80(element);
    return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && ![
        'inline',
        'contents'
    ].includes(display);
}
function $90af9d0b1c819f36$export$71535ffaa902797f(element) {
    return [
        'table',
        'td',
        'th'
    ].includes($90af9d0b1c819f36$export$651544f548703224(element));
}
function $90af9d0b1c819f36$export$89e651af02346cd4(element) {
    return [
        ':popover-open',
        ':modal'
    ].some((selector)=>{
        try {
            return element.matches(selector);
        } catch (e) {
            return false;
        }
    });
}
function $90af9d0b1c819f36$export$d6c4e8150c35fed1(elementOrCss) {
    const webkit = $90af9d0b1c819f36$export$78551043582a6a98();
    const css = $90af9d0b1c819f36$export$45a5e7f76e0caa8d(elementOrCss) ? $90af9d0b1c819f36$export$3735103072e4a80(elementOrCss) : elementOrCss;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    // https://drafts.csswg.org/css-transforms-2/#individual-transforms
    return [
        'transform',
        'translate',
        'scale',
        'rotate',
        'perspective'
    ].some((value)=>css[value] ? css[value] !== 'none' : false) || (css.containerType ? css.containerType !== 'normal' : false) || !webkit && (css.backdropFilter ? css.backdropFilter !== 'none' : false) || !webkit && (css.filter ? css.filter !== 'none' : false) || [
        'transform',
        'translate',
        'scale',
        'rotate',
        'perspective',
        'filter'
    ].some((value)=>(css.willChange || '').includes(value)) || [
        'paint',
        'layout',
        'strict',
        'content'
    ].some((value)=>(css.contain || '').includes(value));
}
function $90af9d0b1c819f36$export$940d8225183e1404(element) {
    let currentNode = $90af9d0b1c819f36$export$4e12058fc4d51d56(element);
    while($90af9d0b1c819f36$export$1b3bfaa9684536aa(currentNode) && !$90af9d0b1c819f36$export$d1162fb0b6d4cd51(currentNode)){
        if ($90af9d0b1c819f36$export$d6c4e8150c35fed1(currentNode)) return currentNode;
        else if ($90af9d0b1c819f36$export$89e651af02346cd4(currentNode)) return null;
        currentNode = $90af9d0b1c819f36$export$4e12058fc4d51d56(currentNode);
    }
    return null;
}
function $90af9d0b1c819f36$export$78551043582a6a98() {
    if (typeof CSS === 'undefined' || !CSS.supports) return false;
    return CSS.supports('-webkit-backdrop-filter', 'none');
}
function $90af9d0b1c819f36$export$d1162fb0b6d4cd51(node) {
    return [
        'html',
        'body',
        '#document'
    ].includes($90af9d0b1c819f36$export$651544f548703224(node));
}
function $90af9d0b1c819f36$export$3735103072e4a80(element) {
    return $90af9d0b1c819f36$export$38b2d434cce3ea22(element).getComputedStyle(element);
}
function $90af9d0b1c819f36$export$dc8fc79fa2800137(element) {
    if ($90af9d0b1c819f36$export$45a5e7f76e0caa8d(element)) return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
    return {
        scrollLeft: element.scrollX,
        scrollTop: element.scrollY
    };
}
function $90af9d0b1c819f36$export$4e12058fc4d51d56(node) {
    if ($90af9d0b1c819f36$export$651544f548703224(node) === 'html') return node;
    const result = // Step into the shadow DOM of the parent of a slotted node.
    node.assignedSlot || // DOM Element detected.
    node.parentNode || // ShadowRoot detected.
    $90af9d0b1c819f36$export$af51f0f06c0f328a(node) && node.host || // Fallback.
    $90af9d0b1c819f36$export$e495491855dc5418(node);
    return $90af9d0b1c819f36$export$af51f0f06c0f328a(result) ? result.host : result;
}
function $90af9d0b1c819f36$export$7cd01a57c8ca906c(node) {
    const parentNode = $90af9d0b1c819f36$export$4e12058fc4d51d56(node);
    if ($90af9d0b1c819f36$export$d1162fb0b6d4cd51(parentNode)) return node.ownerDocument ? node.ownerDocument.body : node.body;
    if ($90af9d0b1c819f36$export$1b3bfaa9684536aa(parentNode) && $90af9d0b1c819f36$export$989e911fa9af580a(parentNode)) return parentNode;
    return $90af9d0b1c819f36$export$7cd01a57c8ca906c(parentNode);
}
function $90af9d0b1c819f36$export$3b57c1601291186b(node, list, traverseIframes) {
    var _node$ownerDocument2;
    if (list === void 0) list = [];
    if (traverseIframes === void 0) traverseIframes = true;
    const scrollableAncestor = $90af9d0b1c819f36$export$7cd01a57c8ca906c(node);
    const isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
    const win = $90af9d0b1c819f36$export$38b2d434cce3ea22(scrollableAncestor);
    if (isBody) {
        const frameElement = $90af9d0b1c819f36$export$7bf1f8740e3e34af(win);
        return list.concat(win, win.visualViewport || [], $90af9d0b1c819f36$export$989e911fa9af580a(scrollableAncestor) ? scrollableAncestor : [], frameElement && traverseIframes ? $90af9d0b1c819f36$export$3b57c1601291186b(frameElement) : []);
    }
    return list.concat(scrollableAncestor, $90af9d0b1c819f36$export$3b57c1601291186b(scrollableAncestor, [], traverseIframes));
}
function $90af9d0b1c819f36$export$7bf1f8740e3e34af(win) {
    return win.parent && Object.getPrototypeOf(win.parent) ? win.frameElement : null;
}


function $cda477f7ce910b33$var$getCssDimensions(element) {
    const css = (0, $90af9d0b1c819f36$export$3735103072e4a80)(element);
    // In testing environments, the `width` and `height` properties are empty
    // strings for SVG elements, returning NaN. Fallback to `0` in this case.
    let width = parseFloat(css.width) || 0;
    let height = parseFloat(css.height) || 0;
    const hasOffset = (0, $90af9d0b1c819f36$export$1b3bfaa9684536aa)(element);
    const offsetWidth = hasOffset ? element.offsetWidth : width;
    const offsetHeight = hasOffset ? element.offsetHeight : height;
    const shouldFallback = (0, $3e54f6501dd55d2d$export$2077e0241d6afd3c)(width) !== offsetWidth || (0, $3e54f6501dd55d2d$export$2077e0241d6afd3c)(height) !== offsetHeight;
    if (shouldFallback) {
        width = offsetWidth;
        height = offsetHeight;
    }
    return {
        width: width,
        height: height,
        $: shouldFallback
    };
}
function $cda477f7ce910b33$var$unwrapElement(element) {
    return !(0, $90af9d0b1c819f36$export$45a5e7f76e0caa8d)(element) ? element.contextElement : element;
}
function $cda477f7ce910b33$var$getScale(element) {
    const domElement = $cda477f7ce910b33$var$unwrapElement(element);
    if (!(0, $90af9d0b1c819f36$export$1b3bfaa9684536aa)(domElement)) return (0, $3e54f6501dd55d2d$export$a397704b5e280835)(1);
    const rect = domElement.getBoundingClientRect();
    const { width: width, height: height, $: $ } = $cda477f7ce910b33$var$getCssDimensions(domElement);
    let x = ($ ? (0, $3e54f6501dd55d2d$export$2077e0241d6afd3c)(rect.width) : rect.width) / width;
    let y = ($ ? (0, $3e54f6501dd55d2d$export$2077e0241d6afd3c)(rect.height) : rect.height) / height;
    // 0, NaN, or Infinity should always fallback to 1.
    if (!x || !Number.isFinite(x)) x = 1;
    if (!y || !Number.isFinite(y)) y = 1;
    return {
        x: x,
        y: y
    };
}
const $cda477f7ce910b33$var$noOffsets = /*#__PURE__*/ (0, $3e54f6501dd55d2d$export$a397704b5e280835)(0);
function $cda477f7ce910b33$var$getVisualOffsets(element) {
    const win = (0, $90af9d0b1c819f36$export$38b2d434cce3ea22)(element);
    if (!(0, $90af9d0b1c819f36$export$78551043582a6a98)() || !win.visualViewport) return $cda477f7ce910b33$var$noOffsets;
    return {
        x: win.visualViewport.offsetLeft,
        y: win.visualViewport.offsetTop
    };
}
function $cda477f7ce910b33$var$shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
    if (isFixed === void 0) isFixed = false;
    if (!floatingOffsetParent || isFixed && floatingOffsetParent !== (0, $90af9d0b1c819f36$export$38b2d434cce3ea22)(element)) return false;
    return isFixed;
}
function $cda477f7ce910b33$var$getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    const clientRect = element.getBoundingClientRect();
    const domElement = $cda477f7ce910b33$var$unwrapElement(element);
    let scale = (0, $3e54f6501dd55d2d$export$a397704b5e280835)(1);
    if (includeScale) {
        if (offsetParent) {
            if ((0, $90af9d0b1c819f36$export$45a5e7f76e0caa8d)(offsetParent)) scale = $cda477f7ce910b33$var$getScale(offsetParent);
        } else scale = $cda477f7ce910b33$var$getScale(element);
    }
    const visualOffsets = $cda477f7ce910b33$var$shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? $cda477f7ce910b33$var$getVisualOffsets(domElement) : (0, $3e54f6501dd55d2d$export$a397704b5e280835)(0);
    let x = (clientRect.left + visualOffsets.x) / scale.x;
    let y = (clientRect.top + visualOffsets.y) / scale.y;
    let width = clientRect.width / scale.x;
    let height = clientRect.height / scale.y;
    if (domElement) {
        const win = (0, $90af9d0b1c819f36$export$38b2d434cce3ea22)(domElement);
        const offsetWin = offsetParent && (0, $90af9d0b1c819f36$export$45a5e7f76e0caa8d)(offsetParent) ? (0, $90af9d0b1c819f36$export$38b2d434cce3ea22)(offsetParent) : offsetParent;
        let currentWin = win;
        let currentIFrame = (0, $90af9d0b1c819f36$export$7bf1f8740e3e34af)(currentWin);
        while(currentIFrame && offsetParent && offsetWin !== currentWin){
            const iframeScale = $cda477f7ce910b33$var$getScale(currentIFrame);
            const iframeRect = currentIFrame.getBoundingClientRect();
            const css = (0, $90af9d0b1c819f36$export$3735103072e4a80)(currentIFrame);
            const left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
            const top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
            x *= iframeScale.x;
            y *= iframeScale.y;
            width *= iframeScale.x;
            height *= iframeScale.y;
            x += left;
            y += top;
            currentWin = (0, $90af9d0b1c819f36$export$38b2d434cce3ea22)(currentIFrame);
            currentIFrame = (0, $90af9d0b1c819f36$export$7bf1f8740e3e34af)(currentWin);
        }
    }
    return (0, $3e54f6501dd55d2d$export$ee05aea0aeecbad4)({
        width: width,
        height: height,
        x: x,
        y: y
    });
}
// If <html> has a CSS width greater than the viewport, then this will be
// incorrect for RTL.
function $cda477f7ce910b33$var$getWindowScrollBarX(element, rect) {
    const leftScroll = (0, $90af9d0b1c819f36$export$dc8fc79fa2800137)(element).scrollLeft;
    if (!rect) return $cda477f7ce910b33$var$getBoundingClientRect((0, $90af9d0b1c819f36$export$e495491855dc5418)(element)).left + leftScroll;
    return rect.left + leftScroll;
}
function $cda477f7ce910b33$var$getHTMLOffset(documentElement, scroll, ignoreScrollbarX) {
    if (ignoreScrollbarX === void 0) ignoreScrollbarX = false;
    const htmlRect = documentElement.getBoundingClientRect();
    const x = htmlRect.left + scroll.scrollLeft - (ignoreScrollbarX ? 0 : // RTL <body> scrollbar.
    $cda477f7ce910b33$var$getWindowScrollBarX(documentElement, htmlRect));
    const y = htmlRect.top + scroll.scrollTop;
    return {
        x: x,
        y: y
    };
}
function $cda477f7ce910b33$var$convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
    let { elements: elements, rect: rect, offsetParent: offsetParent, strategy: strategy } = _ref;
    const isFixed = strategy === 'fixed';
    const documentElement = (0, $90af9d0b1c819f36$export$e495491855dc5418)(offsetParent);
    const topLayer = elements ? (0, $90af9d0b1c819f36$export$89e651af02346cd4)(elements.floating) : false;
    if (offsetParent === documentElement || topLayer && isFixed) return rect;
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    let scale = (0, $3e54f6501dd55d2d$export$a397704b5e280835)(1);
    const offsets = (0, $3e54f6501dd55d2d$export$a397704b5e280835)(0);
    const isOffsetParentAnElement = (0, $90af9d0b1c819f36$export$1b3bfaa9684536aa)(offsetParent);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $90af9d0b1c819f36$export$651544f548703224)(offsetParent) !== 'body' || (0, $90af9d0b1c819f36$export$989e911fa9af580a)(documentElement)) scroll = (0, $90af9d0b1c819f36$export$dc8fc79fa2800137)(offsetParent);
        if ((0, $90af9d0b1c819f36$export$1b3bfaa9684536aa)(offsetParent)) {
            const offsetRect = $cda477f7ce910b33$var$getBoundingClientRect(offsetParent);
            scale = $cda477f7ce910b33$var$getScale(offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        }
    }
    const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? $cda477f7ce910b33$var$getHTMLOffset(documentElement, scroll, true) : (0, $3e54f6501dd55d2d$export$a397704b5e280835)(0);
    return {
        width: rect.width * scale.x,
        height: rect.height * scale.y,
        x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x + htmlOffset.x,
        y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y + htmlOffset.y
    };
}
function $cda477f7ce910b33$var$getClientRects(element) {
    return Array.from(element.getClientRects());
}
// Gets the entire size of the scrollable document area, even extending outside
// of the `<html>` and `<body>` rect bounds if horizontally scrollable.
function $cda477f7ce910b33$var$getDocumentRect(element) {
    const html = (0, $90af9d0b1c819f36$export$e495491855dc5418)(element);
    const scroll = (0, $90af9d0b1c819f36$export$dc8fc79fa2800137)(element);
    const body = element.ownerDocument.body;
    const width = (0, $3e54f6501dd55d2d$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
    const height = (0, $3e54f6501dd55d2d$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
    let x = -scroll.scrollLeft + $cda477f7ce910b33$var$getWindowScrollBarX(element);
    const y = -scroll.scrollTop;
    if ((0, $90af9d0b1c819f36$export$3735103072e4a80)(body).direction === 'rtl') x += (0, $3e54f6501dd55d2d$export$8960430cfd85939f)(html.clientWidth, body.clientWidth) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $cda477f7ce910b33$var$getViewportRect(element, strategy) {
    const win = (0, $90af9d0b1c819f36$export$38b2d434cce3ea22)(element);
    const html = (0, $90af9d0b1c819f36$export$e495491855dc5418)(element);
    const visualViewport = win.visualViewport;
    let width = html.clientWidth;
    let height = html.clientHeight;
    let x = 0;
    let y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        const visualViewportBased = (0, $90af9d0b1c819f36$export$78551043582a6a98)();
        if (!visualViewportBased || visualViewportBased && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
// Returns the inner client rect, subtracting scrollbars if present.
function $cda477f7ce910b33$var$getInnerBoundingClientRect(element, strategy) {
    const clientRect = $cda477f7ce910b33$var$getBoundingClientRect(element, true, strategy === 'fixed');
    const top = clientRect.top + element.clientTop;
    const left = clientRect.left + element.clientLeft;
    const scale = (0, $90af9d0b1c819f36$export$1b3bfaa9684536aa)(element) ? $cda477f7ce910b33$var$getScale(element) : (0, $3e54f6501dd55d2d$export$a397704b5e280835)(1);
    const width = element.clientWidth * scale.x;
    const height = element.clientHeight * scale.y;
    const x = left * scale.x;
    const y = top * scale.y;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $cda477f7ce910b33$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
    let rect;
    if (clippingAncestor === 'viewport') rect = $cda477f7ce910b33$var$getViewportRect(element, strategy);
    else if (clippingAncestor === 'document') rect = $cda477f7ce910b33$var$getDocumentRect((0, $90af9d0b1c819f36$export$e495491855dc5418)(element));
    else if ((0, $90af9d0b1c819f36$export$45a5e7f76e0caa8d)(clippingAncestor)) rect = $cda477f7ce910b33$var$getInnerBoundingClientRect(clippingAncestor, strategy);
    else {
        const visualOffsets = $cda477f7ce910b33$var$getVisualOffsets(element);
        rect = {
            x: clippingAncestor.x - visualOffsets.x,
            y: clippingAncestor.y - visualOffsets.y,
            width: clippingAncestor.width,
            height: clippingAncestor.height
        };
    }
    return (0, $3e54f6501dd55d2d$export$ee05aea0aeecbad4)(rect);
}
function $cda477f7ce910b33$var$hasFixedPositionAncestor(element, stopNode) {
    const parentNode = (0, $90af9d0b1c819f36$export$4e12058fc4d51d56)(element);
    if (parentNode === stopNode || !(0, $90af9d0b1c819f36$export$45a5e7f76e0caa8d)(parentNode) || (0, $90af9d0b1c819f36$export$d1162fb0b6d4cd51)(parentNode)) return false;
    return (0, $90af9d0b1c819f36$export$3735103072e4a80)(parentNode).position === 'fixed' || $cda477f7ce910b33$var$hasFixedPositionAncestor(parentNode, stopNode);
}
// A "clipping ancestor" is an `overflow` element with the characteristic of
// clipping (or hiding) child elements. This returns all clipping ancestors
// of the given element up the tree.
function $cda477f7ce910b33$var$getClippingElementAncestors(element, cache) {
    const cachedResult = cache.get(element);
    if (cachedResult) return cachedResult;
    let result = (0, $90af9d0b1c819f36$export$3b57c1601291186b)(element, [], false).filter((el)=>(0, $90af9d0b1c819f36$export$45a5e7f76e0caa8d)(el) && (0, $90af9d0b1c819f36$export$651544f548703224)(el) !== 'body');
    let currentContainingBlockComputedStyle = null;
    const elementIsFixed = (0, $90af9d0b1c819f36$export$3735103072e4a80)(element).position === 'fixed';
    let currentNode = elementIsFixed ? (0, $90af9d0b1c819f36$export$4e12058fc4d51d56)(element) : element;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    while((0, $90af9d0b1c819f36$export$45a5e7f76e0caa8d)(currentNode) && !(0, $90af9d0b1c819f36$export$d1162fb0b6d4cd51)(currentNode)){
        const computedStyle = (0, $90af9d0b1c819f36$export$3735103072e4a80)(currentNode);
        const currentNodeIsContaining = (0, $90af9d0b1c819f36$export$d6c4e8150c35fed1)(currentNode);
        if (!currentNodeIsContaining && computedStyle.position === 'fixed') currentContainingBlockComputedStyle = null;
        const shouldDropCurrentNode = elementIsFixed ? !currentNodeIsContaining && !currentContainingBlockComputedStyle : !currentNodeIsContaining && computedStyle.position === 'static' && !!currentContainingBlockComputedStyle && [
            'absolute',
            'fixed'
        ].includes(currentContainingBlockComputedStyle.position) || (0, $90af9d0b1c819f36$export$989e911fa9af580a)(currentNode) && !currentNodeIsContaining && $cda477f7ce910b33$var$hasFixedPositionAncestor(element, currentNode);
        if (shouldDropCurrentNode) // Drop non-containing blocks.
        result = result.filter((ancestor)=>ancestor !== currentNode);
        else // Record last containing block for next iteration.
        currentContainingBlockComputedStyle = computedStyle;
        currentNode = (0, $90af9d0b1c819f36$export$4e12058fc4d51d56)(currentNode);
    }
    cache.set(element, result);
    return result;
}
// Gets the maximum area that the element is visible in due to any number of
// clipping ancestors.
function $cda477f7ce910b33$var$getClippingRect(_ref) {
    let { element: element, boundary: boundary, rootBoundary: rootBoundary, strategy: strategy } = _ref;
    const elementClippingAncestors = boundary === 'clippingAncestors' ? (0, $90af9d0b1c819f36$export$89e651af02346cd4)(element) ? [] : $cda477f7ce910b33$var$getClippingElementAncestors(element, this._c) : [].concat(boundary);
    const clippingAncestors = [
        ...elementClippingAncestors,
        rootBoundary
    ];
    const firstClippingAncestor = clippingAncestors[0];
    const clippingRect = clippingAncestors.reduce((accRect, clippingAncestor)=>{
        const rect = $cda477f7ce910b33$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy);
        accRect.top = (0, $3e54f6501dd55d2d$export$8960430cfd85939f)(rect.top, accRect.top);
        accRect.right = (0, $3e54f6501dd55d2d$export$96ec731ed4dcb222)(rect.right, accRect.right);
        accRect.bottom = (0, $3e54f6501dd55d2d$export$96ec731ed4dcb222)(rect.bottom, accRect.bottom);
        accRect.left = (0, $3e54f6501dd55d2d$export$8960430cfd85939f)(rect.left, accRect.left);
        return accRect;
    }, $cda477f7ce910b33$var$getClientRectFromClippingAncestor(element, firstClippingAncestor, strategy));
    return {
        width: clippingRect.right - clippingRect.left,
        height: clippingRect.bottom - clippingRect.top,
        x: clippingRect.left,
        y: clippingRect.top
    };
}
function $cda477f7ce910b33$var$getDimensions(element) {
    const { width: width, height: height } = $cda477f7ce910b33$var$getCssDimensions(element);
    return {
        width: width,
        height: height
    };
}
function $cda477f7ce910b33$var$getRectRelativeToOffsetParent(element, offsetParent, strategy) {
    const isOffsetParentAnElement = (0, $90af9d0b1c819f36$export$1b3bfaa9684536aa)(offsetParent);
    const documentElement = (0, $90af9d0b1c819f36$export$e495491855dc5418)(offsetParent);
    const isFixed = strategy === 'fixed';
    const rect = $cda477f7ce910b33$var$getBoundingClientRect(element, true, isFixed, offsetParent);
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    const offsets = (0, $3e54f6501dd55d2d$export$a397704b5e280835)(0);
    // If the <body> scrollbar appears on the left (e.g. RTL systems). Use
    // Firefox with layout.scrollbar.side = 3 in about:config to test this.
    function setLeftRTLScrollbarOffset() {
        offsets.x = $cda477f7ce910b33$var$getWindowScrollBarX(documentElement);
    }
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $90af9d0b1c819f36$export$651544f548703224)(offsetParent) !== 'body' || (0, $90af9d0b1c819f36$export$989e911fa9af580a)(documentElement)) scroll = (0, $90af9d0b1c819f36$export$dc8fc79fa2800137)(offsetParent);
        if (isOffsetParentAnElement) {
            const offsetRect = $cda477f7ce910b33$var$getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        } else if (documentElement) setLeftRTLScrollbarOffset();
    }
    if (isFixed && !isOffsetParentAnElement && documentElement) setLeftRTLScrollbarOffset();
    const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? $cda477f7ce910b33$var$getHTMLOffset(documentElement, scroll) : (0, $3e54f6501dd55d2d$export$a397704b5e280835)(0);
    const x = rect.left + scroll.scrollLeft - offsets.x - htmlOffset.x;
    const y = rect.top + scroll.scrollTop - offsets.y - htmlOffset.y;
    return {
        x: x,
        y: y,
        width: rect.width,
        height: rect.height
    };
}
function $cda477f7ce910b33$var$isStaticPositioned(element) {
    return (0, $90af9d0b1c819f36$export$3735103072e4a80)(element).position === 'static';
}
function $cda477f7ce910b33$var$getTrueOffsetParent(element, polyfill) {
    if (!(0, $90af9d0b1c819f36$export$1b3bfaa9684536aa)(element) || (0, $90af9d0b1c819f36$export$3735103072e4a80)(element).position === 'fixed') return null;
    if (polyfill) return polyfill(element);
    let rawOffsetParent = element.offsetParent;
    // Firefox returns the <html> element as the offsetParent if it's non-static,
    // while Chrome and Safari return the <body> element. The <body> element must
    // be used to perform the correct calculations even if the <html> element is
    // non-static.
    if ((0, $90af9d0b1c819f36$export$e495491855dc5418)(element) === rawOffsetParent) rawOffsetParent = rawOffsetParent.ownerDocument.body;
    return rawOffsetParent;
}
// Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.
function $cda477f7ce910b33$var$getOffsetParent(element, polyfill) {
    const win = (0, $90af9d0b1c819f36$export$38b2d434cce3ea22)(element);
    if ((0, $90af9d0b1c819f36$export$89e651af02346cd4)(element)) return win;
    if (!(0, $90af9d0b1c819f36$export$1b3bfaa9684536aa)(element)) {
        let svgOffsetParent = (0, $90af9d0b1c819f36$export$4e12058fc4d51d56)(element);
        while(svgOffsetParent && !(0, $90af9d0b1c819f36$export$d1162fb0b6d4cd51)(svgOffsetParent)){
            if ((0, $90af9d0b1c819f36$export$45a5e7f76e0caa8d)(svgOffsetParent) && !$cda477f7ce910b33$var$isStaticPositioned(svgOffsetParent)) return svgOffsetParent;
            svgOffsetParent = (0, $90af9d0b1c819f36$export$4e12058fc4d51d56)(svgOffsetParent);
        }
        return win;
    }
    let offsetParent = $cda477f7ce910b33$var$getTrueOffsetParent(element, polyfill);
    while(offsetParent && (0, $90af9d0b1c819f36$export$71535ffaa902797f)(offsetParent) && $cda477f7ce910b33$var$isStaticPositioned(offsetParent))offsetParent = $cda477f7ce910b33$var$getTrueOffsetParent(offsetParent, polyfill);
    if (offsetParent && (0, $90af9d0b1c819f36$export$d1162fb0b6d4cd51)(offsetParent) && $cda477f7ce910b33$var$isStaticPositioned(offsetParent) && !(0, $90af9d0b1c819f36$export$d6c4e8150c35fed1)(offsetParent)) return win;
    return offsetParent || (0, $90af9d0b1c819f36$export$940d8225183e1404)(element) || win;
}
const $cda477f7ce910b33$var$getElementRects = async function(data) {
    const getOffsetParentFn = this.getOffsetParent || $cda477f7ce910b33$var$getOffsetParent;
    const getDimensionsFn = this.getDimensions;
    const floatingDimensions = await getDimensionsFn(data.floating);
    return {
        reference: $cda477f7ce910b33$var$getRectRelativeToOffsetParent(data.reference, await getOffsetParentFn(data.floating), data.strategy),
        floating: {
            x: 0,
            y: 0,
            width: floatingDimensions.width,
            height: floatingDimensions.height
        }
    };
};
function $cda477f7ce910b33$var$isRTL(element) {
    return (0, $90af9d0b1c819f36$export$3735103072e4a80)(element).direction === 'rtl';
}
const $cda477f7ce910b33$export$722a64dea1b767dc = {
    convertOffsetParentRelativeRectToViewportRelativeRect: $cda477f7ce910b33$var$convertOffsetParentRelativeRectToViewportRelativeRect,
    getDocumentElement: $90af9d0b1c819f36$export$e495491855dc5418,
    getClippingRect: $cda477f7ce910b33$var$getClippingRect,
    getOffsetParent: $cda477f7ce910b33$var$getOffsetParent,
    getElementRects: $cda477f7ce910b33$var$getElementRects,
    getClientRects: $cda477f7ce910b33$var$getClientRects,
    getDimensions: $cda477f7ce910b33$var$getDimensions,
    getScale: $cda477f7ce910b33$var$getScale,
    isElement: $90af9d0b1c819f36$export$45a5e7f76e0caa8d,
    isRTL: $cda477f7ce910b33$var$isRTL
};
function $cda477f7ce910b33$var$rectsAreEqual(a, b) {
    return a.x === b.x && a.y === b.y && a.width === b.width && a.height === b.height;
}
// https://samthor.au/2021/observing-dom/
function $cda477f7ce910b33$var$observeMove(element, onMove) {
    let io = null;
    let timeoutId;
    const root = (0, $90af9d0b1c819f36$export$e495491855dc5418)(element);
    function cleanup() {
        var _io;
        clearTimeout(timeoutId);
        (_io = io) == null || _io.disconnect();
        io = null;
    }
    function refresh(skip, threshold) {
        if (skip === void 0) skip = false;
        if (threshold === void 0) threshold = 1;
        cleanup();
        const elementRectForRootMargin = element.getBoundingClientRect();
        const { left: left, top: top, width: width, height: height } = elementRectForRootMargin;
        if (!skip) onMove();
        if (!width || !height) return;
        const insetTop = (0, $3e54f6501dd55d2d$export$a3fe094919f356fd)(top);
        const insetRight = (0, $3e54f6501dd55d2d$export$a3fe094919f356fd)(root.clientWidth - (left + width));
        const insetBottom = (0, $3e54f6501dd55d2d$export$a3fe094919f356fd)(root.clientHeight - (top + height));
        const insetLeft = (0, $3e54f6501dd55d2d$export$a3fe094919f356fd)(left);
        const rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
        const options = {
            rootMargin: rootMargin,
            threshold: (0, $3e54f6501dd55d2d$export$8960430cfd85939f)(0, (0, $3e54f6501dd55d2d$export$96ec731ed4dcb222)(1, threshold)) || 1
        };
        let isFirstUpdate = true;
        function handleObserve(entries) {
            const ratio = entries[0].intersectionRatio;
            if (ratio !== threshold) {
                if (!isFirstUpdate) return refresh();
                if (!ratio) // If the reference is clipped, the ratio is 0. Throttle the refresh
                // to prevent an infinite loop of updates.
                timeoutId = setTimeout(()=>{
                    refresh(false, 1e-7);
                }, 1000);
                else refresh(false, ratio);
            }
            if (ratio === 1 && !$cda477f7ce910b33$var$rectsAreEqual(elementRectForRootMargin, element.getBoundingClientRect())) // It's possible that even though the ratio is reported as 1, the
            // element is not actually fully within the IntersectionObserver's root
            // area anymore. This can happen under performance constraints. This may
            // be a bug in the browser's IntersectionObserver implementation. To
            // work around this, we compare the element's bounding rect now with
            // what it was at the time we created the IntersectionObserver. If they
            // are not equal then the element moved, so we refresh.
            refresh();
            isFirstUpdate = false;
        }
        // Older browsers don't support a `document` as the root and will throw an
        // error.
        try {
            io = new IntersectionObserver(handleObserve, (0, $8f44472fa5eb25c0$export$71511d61b312f219)((0, $45c1a8590053a015$export$71511d61b312f219)({}, options), {
                // Handle <iframe>s
                root: root.ownerDocument
            }));
        } catch (_e) {
            io = new IntersectionObserver(handleObserve, options);
        }
        io.observe(element);
    }
    refresh(true);
    return cleanup;
}
/**
 * Automatically updates the position of the floating element when necessary.
 * Should only be called when the floating element is mounted on the DOM or
 * visible on the screen.
 * @returns cleanup function that should be invoked when the floating element is
 * removed from the DOM or hidden from the screen.
 * @see https://floating-ui.com/docs/autoUpdate
 */ function $cda477f7ce910b33$export$deee3a793edee05f(reference, floating, update, options) {
    if (options === void 0) options = {};
    const { ancestorScroll: ancestorScroll = true, ancestorResize: ancestorResize = true, elementResize: elementResize = typeof ResizeObserver === 'function', layoutShift: layoutShift = typeof IntersectionObserver === 'function', animationFrame: animationFrame = false } = options;
    const referenceEl = $cda477f7ce910b33$var$unwrapElement(reference);
    const ancestors = ancestorScroll || ancestorResize ? [
        ...referenceEl ? (0, $90af9d0b1c819f36$export$3b57c1601291186b)(referenceEl) : [],
        ...(0, $90af9d0b1c819f36$export$3b57c1601291186b)(floating)
    ] : [];
    ancestors.forEach((ancestor)=>{
        ancestorScroll && ancestor.addEventListener('scroll', update, {
            passive: true
        });
        ancestorResize && ancestor.addEventListener('resize', update);
    });
    const cleanupIo = referenceEl && layoutShift ? $cda477f7ce910b33$var$observeMove(referenceEl, update) : null;
    let reobserveFrame = -1;
    let resizeObserver = null;
    if (elementResize) {
        resizeObserver = new ResizeObserver((_ref)=>{
            let [firstEntry] = _ref;
            if (firstEntry && firstEntry.target === referenceEl && resizeObserver) {
                // Prevent update loops when using the `size` middleware.
                // https://github.com/floating-ui/floating-ui/issues/1740
                resizeObserver.unobserve(floating);
                cancelAnimationFrame(reobserveFrame);
                reobserveFrame = requestAnimationFrame(()=>{
                    var _resizeObserver;
                    (_resizeObserver = resizeObserver) == null || _resizeObserver.observe(floating);
                });
            }
            update();
        });
        if (referenceEl && !animationFrame) resizeObserver.observe(referenceEl);
        resizeObserver.observe(floating);
    }
    let frameId;
    let prevRefRect = animationFrame ? $cda477f7ce910b33$var$getBoundingClientRect(reference) : null;
    if (animationFrame) frameLoop();
    function frameLoop() {
        const nextRefRect = $cda477f7ce910b33$var$getBoundingClientRect(reference);
        if (prevRefRect && !$cda477f7ce910b33$var$rectsAreEqual(prevRefRect, nextRefRect)) update();
        prevRefRect = nextRefRect;
        frameId = requestAnimationFrame(frameLoop);
    }
    update();
    return ()=>{
        var _resizeObserver2;
        ancestors.forEach((ancestor)=>{
            ancestorScroll && ancestor.removeEventListener('scroll', update);
            ancestorResize && ancestor.removeEventListener('resize', update);
        });
        cleanupIo == null || cleanupIo();
        (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.disconnect();
        resizeObserver = null;
        if (animationFrame) cancelAnimationFrame(frameId);
    };
}
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ const $cda477f7ce910b33$export$37b6bde19b108ecc = (0, $7338c40772a45bcd$export$37b6bde19b108ecc);
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $cda477f7ce910b33$export$cc800923e997bb8 = (0, $7338c40772a45bcd$export$cc800923e997bb8);
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $cda477f7ce910b33$export$91fb6ecbd551914 = (0, $7338c40772a45bcd$export$91fb6ecbd551914);
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $cda477f7ce910b33$export$fba63a578e423eb = (0, $7338c40772a45bcd$export$fba63a578e423eb);
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $cda477f7ce910b33$export$8a83211c878a3f1f = (0, $7338c40772a45bcd$export$8a83211c878a3f1f);
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $cda477f7ce910b33$export$346677f925de839c = (0, $7338c40772a45bcd$export$346677f925de839c);
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $cda477f7ce910b33$export$fe8985bb6374093c = (0, $7338c40772a45bcd$export$fe8985bb6374093c);
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $cda477f7ce910b33$export$f2120bbfa5450bd2 = (0, $7338c40772a45bcd$export$f2120bbfa5450bd2);
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $cda477f7ce910b33$export$18c8ad048e32c7d5 = (0, $7338c40772a45bcd$export$18c8ad048e32c7d5);
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $cda477f7ce910b33$export$7bf07e38f3dc4b69 = (0, $7338c40772a45bcd$export$7bf07e38f3dc4b69);
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 */ const $cda477f7ce910b33$export$48a53dcb22e581d0 = (reference, floating, options)=>{
    // This caches the expensive `getClippingElementAncestors` function so that
    // multiple lifecycle resets re-use the same result. It only lives for a
    // single call. If other functions become expensive, we can add them as well.
    const cache = new Map();
    const mergedOptions = (0, $45c1a8590053a015$export$71511d61b312f219)({
        platform: $cda477f7ce910b33$export$722a64dea1b767dc
    }, options);
    const platformWithCache = (0, $8f44472fa5eb25c0$export$71511d61b312f219)((0, $45c1a8590053a015$export$71511d61b312f219)({}, mergedOptions.platform), {
        _c: cache
    });
    return (0, $7338c40772a45bcd$export$48a53dcb22e581d0)(reference, floating, (0, $8f44472fa5eb25c0$export$71511d61b312f219)((0, $45c1a8590053a015$export$71511d61b312f219)({}, mergedOptions), {
        platform: platformWithCache
    }));
};



var $4Y8Vu = parcelRequire("4Y8Vu");
var $c0c0e469db57fda3$export$2e2bcd8739ae039 = (0, $4Y8Vu.useLayoutEffect);


var $a7ee0070c0e37770$var$_excluded$4 = [
    "className",
    "clearValue",
    "cx",
    "getStyles",
    "getClassNames",
    "getValue",
    "hasValue",
    "isMulti",
    "isRtl",
    "options",
    "selectOption",
    "selectProps",
    "setValue",
    "theme"
];
// ==============================
// NO OP
// ==============================
var $a7ee0070c0e37770$export$b4171a6734a65d42 = function noop() {};
// ==============================
// Class Name Prefixer
// ==============================
/**
 String representation of component state for styling with class names.

 Expects an array of strings OR a string/object pair:
 - className(['comp', 'comp-arg', 'comp-arg-2'])
   @returns 'react-select__comp react-select__comp-arg react-select__comp-arg-2'
 - className('comp', { some: true, state: false })
   @returns 'react-select__comp react-select__comp--some'
*/ function $a7ee0070c0e37770$var$applyPrefixToName(prefix, name) {
    if (!name) return prefix;
    else if (name[0] === '-') return prefix + name;
    else return prefix + '__' + name;
}
function $a7ee0070c0e37770$export$a9c23c6ac3fc3eca(prefix, state) {
    for(var _len = arguments.length, classNameList = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)classNameList[_key - 2] = arguments[_key];
    var arr = [].concat(classNameList);
    if (state && prefix) {
        for(var key in state)if (state.hasOwnProperty(key) && state[key]) arr.push("".concat($a7ee0070c0e37770$var$applyPrefixToName(prefix, key)));
    }
    return arr.filter(function(i) {
        return i;
    }).map(function(i) {
        return String(i).trim();
    }).join(' ');
}
// ==============================
// Clean Value
// ==============================
var $a7ee0070c0e37770$export$7f8ddf7c7c20b3cd = function cleanValue(value) {
    if ($a7ee0070c0e37770$var$isArray(value)) return value.filter(Boolean);
    if ((0, $40a2a7eb710615d7$export$2e2bcd8739ae039)(value) === 'object' && value !== null) return [
        value
    ];
    return [];
};
// ==============================
// Clean Common Props
// ==============================
var $a7ee0070c0e37770$var$cleanCommonProps = function cleanCommonProps(props) {
    //className
    props.className;
    props.clearValue;
    props.cx;
    props.getStyles;
    props.getClassNames;
    props.getValue;
    props.hasValue;
    props.isMulti;
    props.isRtl;
    props.options;
    props.selectOption;
    props.selectProps;
    props.setValue;
    props.theme;
    var innerProps = (0, $deeae5c1248a0831$export$2e2bcd8739ae039)(props, $a7ee0070c0e37770$var$_excluded$4);
    return (0, $0c8ebbb95bc6bc2e$export$2e2bcd8739ae039)({}, innerProps);
};
// ==============================
// Get Style Props
// ==============================
var $a7ee0070c0e37770$var$getStyleProps = function getStyleProps(props, name, classNamesState) {
    var cx = props.cx, getStyles = props.getStyles, getClassNames = props.getClassNames, className = props.className;
    return {
        css: getStyles(name, props),
        className: cx(classNamesState !== null && classNamesState !== void 0 ? classNamesState : {}, getClassNames(name, props), className)
    };
};
// ==============================
// Handle Input Change
// ==============================
function $a7ee0070c0e37770$export$61196ced6d74a310(inputValue, actionMeta, onInputChange) {
    if (onInputChange) {
        var _newValue = onInputChange(inputValue, actionMeta);
        if (typeof _newValue === 'string') return _newValue;
    }
    return inputValue;
}
// ==============================
// Scroll Helpers
// ==============================
function $a7ee0070c0e37770$export$2329c99376c9d0a4(el) {
    return [
        document.documentElement,
        document.body,
        window
    ].indexOf(el) > -1;
}
// Normalized Scroll Top
// ------------------------------
function $a7ee0070c0e37770$var$normalizedHeight(el) {
    if ($a7ee0070c0e37770$export$2329c99376c9d0a4(el)) return window.innerHeight;
    return el.clientHeight;
}
// Normalized scrollTo & scrollTop
// ------------------------------
function $a7ee0070c0e37770$var$getScrollTop(el) {
    if ($a7ee0070c0e37770$export$2329c99376c9d0a4(el)) return window.pageYOffset;
    return el.scrollTop;
}
function $a7ee0070c0e37770$var$scrollTo(el, top) {
    // with a scroll distance, we perform scroll on the element
    if ($a7ee0070c0e37770$export$2329c99376c9d0a4(el)) {
        window.scrollTo(0, top);
        return;
    }
    el.scrollTop = top;
}
// Get Scroll Parent
// ------------------------------
function $a7ee0070c0e37770$var$getScrollParent(element) {
    var style = getComputedStyle(element);
    var excludeStaticParent = style.position === 'absolute';
    var overflowRx = /(auto|scroll)/;
    if (style.position === 'fixed') return document.documentElement;
    for(var parent = element; parent = parent.parentElement;){
        style = getComputedStyle(parent);
        if (excludeStaticParent && style.position === 'static') continue;
        if (overflowRx.test(style.overflow + style.overflowY + style.overflowX)) return parent;
    }
    return document.documentElement;
}
// Animated Scroll To
// ------------------------------
/**
  @param t: time (elapsed)
  @param b: initial value
  @param c: amount of change
  @param d: duration
*/ function $a7ee0070c0e37770$var$easeOutCubic(t, b, c, d) {
    return c * ((t = t / d - 1) * t * t + 1) + b;
}
function $a7ee0070c0e37770$var$animatedScrollTo(element, to) {
    var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 200;
    var callback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : $a7ee0070c0e37770$export$b4171a6734a65d42;
    var start = $a7ee0070c0e37770$var$getScrollTop(element);
    var change = to - start;
    var increment = 10;
    var currentTime = 0;
    function animateScroll() {
        currentTime += increment;
        var val = $a7ee0070c0e37770$var$easeOutCubic(currentTime, start, change, duration);
        $a7ee0070c0e37770$var$scrollTo(element, val);
        if (currentTime < duration) window.requestAnimationFrame(animateScroll);
        else callback(element);
    }
    animateScroll();
}
// Scroll Into View
// ------------------------------
function $a7ee0070c0e37770$export$9bb611d729802a56(menuEl, focusedEl) {
    var menuRect = menuEl.getBoundingClientRect();
    var focusedRect = focusedEl.getBoundingClientRect();
    var overScroll = focusedEl.offsetHeight / 3;
    if (focusedRect.bottom + overScroll > menuRect.bottom) $a7ee0070c0e37770$var$scrollTo(menuEl, Math.min(focusedEl.offsetTop + focusedEl.clientHeight - menuEl.offsetHeight + overScroll, menuEl.scrollHeight));
    else if (focusedRect.top - overScroll < menuRect.top) $a7ee0070c0e37770$var$scrollTo(menuEl, Math.max(focusedEl.offsetTop - overScroll, 0));
}
// ==============================
// Get bounding client object
// ==============================
// cannot get keys using array notation with DOMRect
function $a7ee0070c0e37770$var$getBoundingClientObj(element) {
    var rect = element.getBoundingClientRect();
    return {
        bottom: rect.bottom,
        height: rect.height,
        left: rect.left,
        right: rect.right,
        top: rect.top,
        width: rect.width
    };
}
// ==============================
// Touch Capability Detector
// ==============================
function $a7ee0070c0e37770$export$df995fae86a55f06() {
    try {
        document.createEvent('TouchEvent');
        return true;
    } catch (e) {
        return false;
    }
}
// ==============================
// Mobile Device Detector
// ==============================
function $a7ee0070c0e37770$export$ebd11618f299a286() {
    try {
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    } catch (e) {
        return false;
    }
}
// ==============================
// Passive Event Detector
// ==============================
// https://github.com/rafgraph/detect-it/blob/main/src/index.ts#L19-L36
var $a7ee0070c0e37770$var$passiveOptionAccessed = false;
var $a7ee0070c0e37770$var$options = {
    get passive () {
        return $a7ee0070c0e37770$var$passiveOptionAccessed = true;
    }
};
// check for SSR
var $a7ee0070c0e37770$var$w = typeof window !== 'undefined' ? window : {};
if ($a7ee0070c0e37770$var$w.addEventListener && $a7ee0070c0e37770$var$w.removeEventListener) {
    $a7ee0070c0e37770$var$w.addEventListener('p', $a7ee0070c0e37770$export$b4171a6734a65d42, $a7ee0070c0e37770$var$options);
    $a7ee0070c0e37770$var$w.removeEventListener('p', $a7ee0070c0e37770$export$b4171a6734a65d42, false);
}
var $a7ee0070c0e37770$export$2408f22a0fab9ae5 = $a7ee0070c0e37770$var$passiveOptionAccessed;
function $a7ee0070c0e37770$export$3466f893ebf79586(item) {
    return item != null;
}
function $a7ee0070c0e37770$var$isArray(arg) {
    return Array.isArray(arg);
}
function $a7ee0070c0e37770$export$96f57966bedc81b4(isMulti, multiValue, singleValue) {
    return isMulti ? multiValue : singleValue;
}
function $a7ee0070c0e37770$export$e7094788287c5e9b(singleValue) {
    return singleValue;
}
function $a7ee0070c0e37770$export$ef35774e6d314e91(multiValue) {
    return multiValue;
}
var $a7ee0070c0e37770$export$43caf9889c228507 = function removeProps(propsObj) {
    for(var _len2 = arguments.length, properties = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)properties[_key2 - 1] = arguments[_key2];
    var propsMap = Object.entries(propsObj).filter(function(_ref) {
        var _ref2 = (0, $a4d069dc93b26bb4$export$2e2bcd8739ae039)(_ref, 1), key = _ref2[0];
        return !properties.includes(key);
    });
    return propsMap.reduce(function(newProps, _ref3) {
        var _ref4 = (0, $a4d069dc93b26bb4$export$2e2bcd8739ae039)(_ref3, 2), key = _ref4[0], val = _ref4[1];
        newProps[key] = val;
        return newProps;
    }, {});
};
var $a7ee0070c0e37770$var$_excluded$3 = [
    "children",
    "innerProps"
], $a7ee0070c0e37770$var$_excluded2$1 = [
    "children",
    "innerProps"
];
function $a7ee0070c0e37770$var$getMenuPlacement(_ref) {
    var preferredMaxHeight = _ref.maxHeight, menuEl = _ref.menuEl, minHeight = _ref.minHeight, preferredPlacement = _ref.placement, shouldScroll = _ref.shouldScroll, isFixedPosition = _ref.isFixedPosition, controlHeight = _ref.controlHeight;
    var scrollParent = $a7ee0070c0e37770$var$getScrollParent(menuEl);
    var defaultState = {
        placement: 'bottom',
        maxHeight: preferredMaxHeight
    };
    // something went wrong, return default state
    if (!menuEl || !menuEl.offsetParent) return defaultState;
    // we can't trust `scrollParent.scrollHeight` --> it may increase when
    // the menu is rendered
    var _scrollParent$getBoun = scrollParent.getBoundingClientRect(), scrollHeight = _scrollParent$getBoun.height;
    var _menuEl$getBoundingCl = menuEl.getBoundingClientRect(), menuBottom = _menuEl$getBoundingCl.bottom, menuHeight = _menuEl$getBoundingCl.height, menuTop = _menuEl$getBoundingCl.top;
    var _menuEl$offsetParent$ = menuEl.offsetParent.getBoundingClientRect(), containerTop = _menuEl$offsetParent$.top;
    var viewHeight = isFixedPosition ? window.innerHeight : $a7ee0070c0e37770$var$normalizedHeight(scrollParent);
    var scrollTop = $a7ee0070c0e37770$var$getScrollTop(scrollParent);
    var marginBottom = parseInt(getComputedStyle(menuEl).marginBottom, 10);
    var marginTop = parseInt(getComputedStyle(menuEl).marginTop, 10);
    var viewSpaceAbove = containerTop - marginTop;
    var viewSpaceBelow = viewHeight - menuTop;
    var scrollSpaceAbove = viewSpaceAbove + scrollTop;
    var scrollSpaceBelow = scrollHeight - scrollTop - menuTop;
    var scrollDown = menuBottom - viewHeight + scrollTop + marginBottom;
    var scrollUp = scrollTop + menuTop - marginTop;
    var scrollDuration = 160;
    switch(preferredPlacement){
        case 'auto':
        case 'bottom':
            // 1: the menu will fit, do nothing
            if (viewSpaceBelow >= menuHeight) return {
                placement: 'bottom',
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceBelow >= menuHeight && !isFixedPosition) {
                if (shouldScroll) $a7ee0070c0e37770$var$animatedScrollTo(scrollParent, scrollDown, scrollDuration);
                return {
                    placement: 'bottom',
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceBelow >= minHeight || isFixedPosition && viewSpaceBelow >= minHeight) {
                if (shouldScroll) $a7ee0070c0e37770$var$animatedScrollTo(scrollParent, scrollDown, scrollDuration);
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                var constrainedHeight = isFixedPosition ? viewSpaceBelow - marginBottom : scrollSpaceBelow - marginBottom;
                return {
                    placement: 'bottom',
                    maxHeight: constrainedHeight
                };
            }
            // 4. Forked beviour when there isn't enough space below
            // AUTO: flip the menu, render above
            if (preferredPlacement === 'auto' || isFixedPosition) {
                // may need to be constrained after flipping
                var _constrainedHeight = preferredMaxHeight;
                var spaceAbove = isFixedPosition ? viewSpaceAbove : scrollSpaceAbove;
                if (spaceAbove >= minHeight) _constrainedHeight = Math.min(spaceAbove - marginBottom - controlHeight, preferredMaxHeight);
                return {
                    placement: 'top',
                    maxHeight: _constrainedHeight
                };
            }
            // BOTTOM: allow browser to increase scrollable area and immediately set scroll
            if (preferredPlacement === 'bottom') {
                if (shouldScroll) $a7ee0070c0e37770$var$scrollTo(scrollParent, scrollDown);
                return {
                    placement: 'bottom',
                    maxHeight: preferredMaxHeight
                };
            }
            break;
        case 'top':
            // 1: the menu will fit, do nothing
            if (viewSpaceAbove >= menuHeight) return {
                placement: 'top',
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceAbove >= menuHeight && !isFixedPosition) {
                if (shouldScroll) $a7ee0070c0e37770$var$animatedScrollTo(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: 'top',
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
                var _constrainedHeight2 = preferredMaxHeight;
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) _constrainedHeight2 = isFixedPosition ? viewSpaceAbove - marginTop : scrollSpaceAbove - marginTop;
                if (shouldScroll) $a7ee0070c0e37770$var$animatedScrollTo(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: 'top',
                    maxHeight: _constrainedHeight2
                };
            }
            // 4. not enough space, the browser WILL NOT increase scrollable area when
            // absolutely positioned element rendered above the viewport (only below).
            // Flip the menu, render below
            return {
                placement: 'bottom',
                maxHeight: preferredMaxHeight
            };
        default:
            throw new Error("Invalid placement provided \"".concat(preferredPlacement, "\"."));
    }
    return defaultState;
}
// Menu Component
// ------------------------------
function $a7ee0070c0e37770$var$alignToControl(placement) {
    var placementToCSSProp = {
        bottom: 'top',
        top: 'bottom'
    };
    return placement ? placementToCSSProp[placement] : 'bottom';
}
var $a7ee0070c0e37770$var$coercePlacement = function coercePlacement(p) {
    return p === 'auto' ? 'bottom' : p;
};
var $a7ee0070c0e37770$export$953cecd6e717a553 = function menuCSS(_ref2, unstyled) {
    var _objectSpread2;
    var placement = _ref2.placement, _ref2$theme = _ref2.theme, borderRadius = _ref2$theme.borderRadius, spacing = _ref2$theme.spacing, colors = _ref2$theme.colors;
    return (0, $0c8ebbb95bc6bc2e$export$2e2bcd8739ae039)((_objectSpread2 = {
        label: 'menu'
    }, (0, $29be98d1fcef7677$export$2e2bcd8739ae039)(_objectSpread2, $a7ee0070c0e37770$var$alignToControl(placement), '100%'), (0, $29be98d1fcef7677$export$2e2bcd8739ae039)(_objectSpread2, "position", 'absolute'), (0, $29be98d1fcef7677$export$2e2bcd8739ae039)(_objectSpread2, "width", '100%'), (0, $29be98d1fcef7677$export$2e2bcd8739ae039)(_objectSpread2, "zIndex", 1), _objectSpread2), unstyled ? {} : {
        backgroundColor: colors.neutral0,
        borderRadius: borderRadius,
        boxShadow: '0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1)',
        marginBottom: spacing.menuGutter,
        marginTop: spacing.menuGutter
    });
};
var $a7ee0070c0e37770$var$PortalPlacementContext = /*#__PURE__*/ (0, $4Y8Vu.createContext)(null);
// NOTE: internal only
var $a7ee0070c0e37770$export$3a1a48c8f6ef640e = function MenuPlacer(props) {
    var children = props.children, minMenuHeight = props.minMenuHeight, maxMenuHeight = props.maxMenuHeight, menuPlacement = props.menuPlacement, menuPosition = props.menuPosition, menuShouldScrollIntoView = props.menuShouldScrollIntoView, theme = props.theme;
    var _ref3 = (0, $4Y8Vu.useContext)($a7ee0070c0e37770$var$PortalPlacementContext) || {}, setPortalPlacement = _ref3.setPortalPlacement;
    var ref = (0, $4Y8Vu.useRef)(null);
    var _useState = (0, $4Y8Vu.useState)(maxMenuHeight), _useState2 = (0, $a4d069dc93b26bb4$export$2e2bcd8739ae039)(_useState, 2), maxHeight = _useState2[0], setMaxHeight = _useState2[1];
    var _useState3 = (0, $4Y8Vu.useState)(null), _useState4 = (0, $a4d069dc93b26bb4$export$2e2bcd8739ae039)(_useState3, 2), placement = _useState4[0], setPlacement = _useState4[1];
    var controlHeight = theme.spacing.controlHeight;
    (0, $c0c0e469db57fda3$export$2e2bcd8739ae039)(function() {
        var menuEl = ref.current;
        if (!menuEl) return;
        // DO NOT scroll if position is fixed
        var isFixedPosition = menuPosition === 'fixed';
        var shouldScroll = menuShouldScrollIntoView && !isFixedPosition;
        var state = $a7ee0070c0e37770$var$getMenuPlacement({
            maxHeight: maxMenuHeight,
            menuEl: menuEl,
            minHeight: minMenuHeight,
            placement: menuPlacement,
            shouldScroll: shouldScroll,
            isFixedPosition: isFixedPosition,
            controlHeight: controlHeight
        });
        setMaxHeight(state.maxHeight);
        setPlacement(state.placement);
        setPortalPlacement === null || setPortalPlacement === void 0 || setPortalPlacement(state.placement);
    }, [
        maxMenuHeight,
        menuPlacement,
        menuPosition,
        menuShouldScrollIntoView,
        minMenuHeight,
        setPortalPlacement,
        controlHeight
    ]);
    return children({
        ref: ref,
        placerProps: (0, $0c8ebbb95bc6bc2e$export$2e2bcd8739ae039)((0, $0c8ebbb95bc6bc2e$export$2e2bcd8739ae039)({}, props), {}, {
            placement: placement || $a7ee0070c0e37770$var$coercePlacement(menuPlacement),
            maxHeight: maxHeight
        })
    });
};
var $a7ee0070c0e37770$var$Menu = function Menu(props) {
    var children = props.children, innerRef = props.innerRef, innerProps = props.innerProps;
    return (0, $fb226fb4d95fe644$export$c8a8987d4410bf2d)("div", (0, $f3601d07f0ff7403$export$2e2bcd8739ae039)({}, $a7ee0070c0e37770$var$getStyleProps(props, 'menu', {
        menu: true
    }), {
        ref: innerRef
    }, innerProps), children);
};
var $a7ee0070c0e37770$var$Menu$1 = $a7ee0070c0e37770$var$Menu;
// ==============================
// Menu List
// ==============================
var $a7ee0070c0e37770$export$7ccc53e8f1e7dfc5 = function menuListCSS(_ref4, unstyled) {
    var maxHeight = _ref4.maxHeight, baseUnit = _ref4.theme.spacing.baseUnit;
    return (0, $0c8ebbb95bc6bc2e$export$2e2bcd8739ae039)({
        maxHeight: maxHeight,
        overflowY: 'auto',
        position: 'relative',
        // required for offset[Height, Top] > keyboard scroll
        WebkitOverflowScrolling: 'touch'
    }, unstyled ? {} : {
        paddingBottom: baseUnit,
        paddingTop: baseUnit
    });
};
var $a7ee0070c0e37770$var$MenuList = function MenuList(props) {
    var children = props.children, innerProps = props.innerProps, innerRef = props.innerRef, isMulti = props.isMulti;
    return (0, $fb226fb4d95fe644$export$c8a8987d4410bf2d)("div", (0, $f3601d07f0ff7403$export$2e2bcd8739ae039)({}, $a7ee0070c0e37770$var$getStyleProps(props, 'menuList', {
        'menu-list': true,
        'menu-list--is-multi': isMulti
    }), {
        ref: innerRef
    }, innerProps), children);
};
// ==============================
// Menu Notices
// ==============================
var $a7ee0070c0e37770$var$noticeCSS = function noticeCSS(_ref5, unstyled) {
    var _ref5$theme = _ref5.theme, baseUnit = _ref5$theme.spacing.baseUnit, colors = _ref5$theme.colors;
    return (0, $0c8ebbb95bc6bc2e$export$2e2bcd8739ae039)({
        textAlign: 'center'
    }, unstyled ? {} : {
        color: colors.neutral40,
        padding: "".concat(baseUnit * 2, "px ").concat(baseUnit * 3, "px")
    });
};
var $a7ee0070c0e37770$export$3b14a55fb2447963 = $a7ee0070c0e37770$var$noticeCSS;
var $a7ee0070c0e37770$export$342063e11d6c3cad = $a7ee0070c0e37770$var$noticeCSS;
var $a7ee0070c0e37770$var$NoOptionsMessage = function NoOptionsMessage(_ref6) {
    var _ref6$children = _ref6.children, children = _ref6$children === void 0 ? 'No options' : _ref6$children, innerProps = _ref6.innerProps, restProps = (0, $deeae5c1248a0831$export$2e2bcd8739ae039)(_ref6, $a7ee0070c0e37770$var$_excluded$3);
    return (0, $fb226fb4d95fe644$export$c8a8987d4410bf2d)("div", (0, $f3601d07f0ff7403$export$2e2bcd8739ae039)({}, $a7ee0070c0e37770$var$getStyleProps((0, $0c8ebbb95bc6bc2e$export$2e2bcd8739ae039)((0, $0c8ebbb95bc6bc2e$export$2e2bcd8739ae039)({}, restProps), {}, {
        children: children,
        innerProps: innerProps
    }), 'noOptionsMessage', {
        'menu-notice': true,
        'menu-notice--no-options': true
    }), innerProps), children);
};
var $a7ee0070c0e37770$var$LoadingMessage = function LoadingMessage(_ref7) {
    var _ref7$children = _ref7.children, children = _ref7$children === void 0 ? 'Loading...' : _ref7$children, innerProps = _ref7.innerProps, restProps = (0, $deeae5c1248a0831$export$2e2bcd8739ae039)(_ref7, $a7ee0070c0e37770$var$_excluded2$1);
    return (0, $fb226fb4d95fe644$export$c8a8987d4410bf2d)("div", (0, $f3601d07f0ff7403$export$2e2bcd8739ae039)({}, $a7ee0070c0e37770$var$getStyleProps((0, $0c8ebbb95bc6bc2e$export$2e2bcd8739ae039)((0, $0c8ebbb95bc6bc2e$export$2e2bcd8739ae039)({}, restProps), {}, {
        children: children,
        innerProps: innerProps
    }), 'loadingMessage', {
        'menu-notice': true,
        'menu-notice--loading': true
    }), innerProps), children);
};
// ==============================
// Menu Portal
// ==============================
var $a7ee0070c0e37770$export$ae1af26003f05816 = function menuPortalCSS(_ref8) {
    var rect = _ref8.rect, offset = _ref8.offset, position = _ref8.position;
    return {
        left: rect.left,
        position: position,
        top: offset,
        width: rect.width,
        zIndex: 1
    };
};
var $a7ee0070c0e37770$var$MenuPortal = function MenuPortal(props) {
    var appendTo = props.appendTo, children = props.children, controlElement = props.controlElement, innerProps = props.innerProps, menuPlacement = props.menuPlacement, menuPosition = props.menuPosition;
    var menuPortalRef = (0, $4Y8Vu.useRef)(null);
    var cleanupRef = (0, $4Y8Vu.useRef)(null);
    var _useState5 = (0, $4Y8Vu.useState)($a7ee0070c0e37770$var$coercePlacement(menuPlacement)), _useState6 = (0, $a4d069dc93b26bb4$export$2e2bcd8739ae039)(_useState5, 2), placement = _useState6[0], setPortalPlacement = _useState6[1];
    var portalPlacementContext = (0, $4Y8Vu.useMemo)(function() {
        return {
            setPortalPlacement: setPortalPlacement
        };
    }, []);
    var _useState7 = (0, $4Y8Vu.useState)(null), _useState8 = (0, $a4d069dc93b26bb4$export$2e2bcd8739ae039)(_useState7, 2), computedPosition = _useState8[0], setComputedPosition = _useState8[1];
    var updateComputedPosition = (0, $4Y8Vu.useCallback)(function() {
        if (!controlElement) return;
        var rect = $a7ee0070c0e37770$var$getBoundingClientObj(controlElement);
        var scrollDistance = menuPosition === 'fixed' ? 0 : window.pageYOffset;
        var offset = rect[placement] + scrollDistance;
        if (offset !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.offset) || rect.left !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.left) || rect.width !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.width)) setComputedPosition({
            offset: offset,
            rect: rect
        });
    }, [
        controlElement,
        menuPosition,
        placement,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.offset,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.left,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.width
    ]);
    (0, $c0c0e469db57fda3$export$2e2bcd8739ae039)(function() {
        updateComputedPosition();
    }, [
        updateComputedPosition
    ]);
    var runAutoUpdate = (0, $4Y8Vu.useCallback)(function() {
        if (typeof cleanupRef.current === 'function') {
            cleanupRef.current();
            cleanupRef.current = null;
        }
        if (controlElement && menuPortalRef.current) cleanupRef.current = (0, $cda477f7ce910b33$export$deee3a793edee05f)(controlElement, menuPortalRef.current, updateComputedPosition, {
            elementResize: 'ResizeObserver' in window
        });
    }, [
        controlElement,
        updateComputedPosition
    ]);
    (0, $c0c0e469db57fda3$export$2e2bcd8739ae039)(function() {
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    var setMenuPortalElement = (0, $4Y8Vu.useCallback)(function(menuPortalElement) {
        menuPortalRef.current = menuPortalElement;
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    // bail early if required elements aren't present
    if (!appendTo && menuPosition !== 'fixed' || !computedPosition) return null;
    // same wrapper element whether fixed or portalled
    var menuWrapper = (0, $fb226fb4d95fe644$export$c8a8987d4410bf2d)("div", (0, $f3601d07f0ff7403$export$2e2bcd8739ae039)({
        ref: setMenuPortalElement
    }, $a7ee0070c0e37770$var$getStyleProps((0, $0c8ebbb95bc6bc2e$export$2e2bcd8739ae039)((0, $0c8ebbb95bc6bc2e$export$2e2bcd8739ae039)({}, props), {}, {
        offset: computedPosition.offset,
        position: menuPosition,
        rect: computedPosition.rect
    }), 'menuPortal', {
        'menu-portal': true
    }), innerProps), children);
    return (0, $fb226fb4d95fe644$export$c8a8987d4410bf2d)($a7ee0070c0e37770$var$PortalPlacementContext.Provider, {
        value: portalPlacementContext
    }, appendTo ? /*#__PURE__*/ (0, $320b03ed0fb31615$exports.createPortal)(menuWrapper, appendTo) : menuWrapper);
};
// ==============================
// Root Container
// ==============================
var $a7ee0070c0e37770$export$8b22cf2602fb60ce = function containerCSS(_ref) {
    var isDisabled = _ref.isDisabled, isRtl = _ref.isRtl;
    return {
        label: 'container',
        direction: isRtl ? 'rtl' : undefined,
        pointerEvents: isDisabled ? 'none' : undefined,
        // cancel mouse events when disabled
        position: 'relative'
    };
};
var $a7ee0070c0e37770$var$SelectContainer = function SelectContainer(props) {
    var children = props.children, innerProps = props.innerProps, isDisabled = props.isDisabled, isRtl = props.isRtl;
    return (0, $fb226fb4d95fe644$export$c8a8987d4410bf2d)("div", (0, $f3601d07f0ff7403$export$2e2bcd8739ae039)({}, $a7ee0070c0e37770$var$getStyleProps(props, 'container', {
        '--is-disabled': isDisabled,
        '--is-rtl': isRtl
    }), innerProps), children);
};
// ==============================
// Value Container
// ==============================
var $a7ee0070c0e37770$export$4a5767248b18ef41 = function valueContainerCSS(_ref2, unstyled) {
    var spacing = _ref2.theme.spacing, isMulti = _ref2.isMulti, hasValue = _ref2.hasValue, controlShouldRenderValue = _ref2.selectProps.controlShouldRenderValue;
    return (0, $0c8ebbb95bc6bc2e$export$2e2bcd8739ae039)({
        alignItems: 'center',
        display: isMulti && hasValue && controlShouldRenderValue ? 'flex' : 'grid',
        flex: 1,
        flexWrap: 'wrap',
        WebkitOverflowScrolling: 'touch',
        position: 'relative',
        overflow: 'hidden'
    }, unstyled ? {} : {
        padding: "".concat(spacing.baseUnit / 2, "px ").concat(spacing.baseUnit * 2, "px")
    });
};
var $a7ee0070c0e37770$var$ValueContainer = function ValueContainer(props) {
    var children = props.children, innerProps = props.innerProps, isMulti = props.isMulti, hasValue = props.hasValue;
    return (0, $fb226fb4d95fe644$export$c8a8987d4410bf2d)("div", (0, $f3601d07f0ff7403$export$2e2bcd8739ae039)({}, $a7ee0070c0e37770$var$getStyleProps(props, 'valueContainer', {
        'value-container': true,
        'value-container--is-multi': isMulti,
        'value-container--has-value': hasValue
    }), innerProps), children);
};
// ==============================
// Indicator Container
// ==============================
var $a7ee0070c0e37770$export$23f2a1d2818174ef = function indicatorsContainerCSS() {
    return {
        alignItems: 'center',
        alignSelf: 'stretch',
        display: 'flex',
        flexShrink: 0
    };
};
var $a7ee0070c0e37770$var$IndicatorsContainer = function IndicatorsContainer(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $fb226fb4d95fe644$export$c8a8987d4410bf2d)("div", (0, $f3601d07f0ff7403$export$2e2bcd8739ae039)({}, $a7ee0070c0e37770$var$getStyleProps(props, 'indicatorsContainer', {
        indicators: true
    }), innerProps), children);
};
var $a7ee0070c0e37770$var$_templateObject;
var $a7ee0070c0e37770$var$_excluded$2 = [
    "size"
], $a7ee0070c0e37770$var$_excluded2 = [
    "innerProps",
    "isRtl",
    "size"
];
function $a7ee0070c0e37770$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// ==============================
// Dropdown & Clear Icons
// ==============================
var $a7ee0070c0e37770$var$_ref2 = {
    name: "8mmkcg",
    styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0"
};
var $a7ee0070c0e37770$var$Svg = function Svg(_ref) {
    var size = _ref.size, props = (0, $deeae5c1248a0831$export$2e2bcd8739ae039)(_ref, $a7ee0070c0e37770$var$_excluded$2);
    return (0, $fb226fb4d95fe644$export$c8a8987d4410bf2d)("svg", (0, $f3601d07f0ff7403$export$2e2bcd8739ae039)({
        height: size,
        width: size,
        viewBox: "0 0 20 20",
        "aria-hidden": "true",
        focusable: "false",
        css: $a7ee0070c0e37770$var$_ref2
    }, props));
};
var $a7ee0070c0e37770$var$CrossIcon = function CrossIcon(props) {
    return (0, $fb226fb4d95fe644$export$c8a8987d4410bf2d)($a7ee0070c0e37770$var$Svg, (0, $f3601d07f0ff7403$export$2e2bcd8739ae039)({
        size: 20
    }, props), (0, $fb226fb4d95fe644$export$c8a8987d4410bf2d)("path", {
        d: "M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"
    }));
};
var $a7ee0070c0e37770$var$DownChevron = function DownChevron(props) {
    return (0, $fb226fb4d95fe644$export$c8a8987d4410bf2d)($a7ee0070c0e37770$var$Svg, (0, $f3601d07f0ff7403$export$2e2bcd8739ae039)({
        size: 20
    }, props), (0, $fb226fb4d95fe644$export$c8a8987d4410bf2d)("path", {
        d: "M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"
    }));
};
// ==============================
// Dropdown & Clear Buttons
// ==============================
var $a7ee0070c0e37770$var$baseCSS = function baseCSS(_ref3, unstyled) {
    var isFocused = _ref3.isFocused, _ref3$theme = _ref3.theme, baseUnit = _ref3$theme.spacing.baseUnit, colors = _ref3$theme.colors;
    return (0, $0c8ebbb95bc6bc2e$export$2e2bcd8739ae039)({
        label: 'indicatorContainer',
        display: 'flex',
        transition: 'color 150ms'
    }, unstyled ? {} : {
        color: isFocused ? colors.neutral60 : colors.neutral20,
        padding: baseUnit * 2,
        ':hover': {
            color: isFocused ? colors.neutral80 : colors.neutral40
        }
    });
};
var $a7ee0070c0e37770$export$f1e1789686576879 = $a7ee0070c0e37770$var$baseCSS;
var $a7ee0070c0e37770$var$DropdownIndicator = function DropdownIndicator(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $fb226fb4d95fe644$export$c8a8987d4410bf2d)("div", (0, $f3601d07f0ff7403$export$2e2bcd8739ae039)({}, $a7ee0070c0e37770$var$getStyleProps(props, 'dropdownIndicator', {
        indicator: true,
        'dropdown-indicator': true
    }), innerProps), children || (0, $fb226fb4d95fe644$export$c8a8987d4410bf2d)($a7ee0070c0e37770$var$DownChevron, null));
};
var $a7ee0070c0e37770$export$407448d2b89b1813 = $a7ee0070c0e37770$var$baseCSS;
var $a7ee0070c0e37770$var$ClearIndicator = function ClearIndicator(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $fb226fb4d95fe644$export$c8a8987d4410bf2d)("div", (0, $f3601d07f0ff7403$export$2e2bcd8739ae039)({}, $a7ee0070c0e37770$var$getStyleProps(props, 'clearIndicator', {
        indicator: true,
        'clear-indicator': true
    }), innerProps), children || (0, $fb226fb4d95fe644$export$c8a8987d4410bf2d)($a7ee0070c0e37770$var$CrossIcon, null));
};
// ==============================
// Separator
// ==============================
var $a7ee0070c0e37770$export$dda1d9f60106f0e9 = function indicatorSeparatorCSS(_ref4, unstyled) {
    var isDisabled = _ref4.isDisabled, _ref4$theme = _ref4.theme, baseUnit = _ref4$theme.spacing.baseUnit, colors = _ref4$theme.colors;
    return (0, $0c8ebbb95bc6bc2e$export$2e2bcd8739ae039)({
        label: 'indicatorSeparator',
        alignSelf: 'stretch',
        width: 1
    }, unstyled ? {} : {
        backgroundColor: isDisabled ? colors.neutral10 : colors.neutral20,
        marginBottom: baseUnit * 2,
        marginTop: baseUnit * 2
    });
};
var $a7ee0070c0e37770$var$IndicatorSeparator = function IndicatorSeparator(props) {
    var innerProps = props.innerProps;
    return (0, $fb226fb4d95fe644$export$c8a8987d4410bf2d)("span", (0, $f3601d07f0ff7403$export$2e2bcd8739ae039)({}, innerProps, $a7ee0070c0e37770$var$getStyleProps(props, 'indicatorSeparator', {
        'indicator-separator': true
    })));
};
// ==============================
// Loading
// ==============================
var $a7ee0070c0e37770$var$loadingDotAnimations = (0, $fb226fb4d95fe644$export$d25ddfdf17c3ad3e)($a7ee0070c0e37770$var$_templateObject || ($a7ee0070c0e37770$var$_templateObject = (0, $f686099aa26add9e$export$2e2bcd8739ae039)([
    "\n  0%, 80%, 100% { opacity: 0; }\n  40% { opacity: 1; }\n"
])));
var $a7ee0070c0e37770$export$882b5998b3b9117c = function loadingIndicatorCSS(_ref5, unstyled) {
    var isFocused = _ref5.isFocused, size = _ref5.size, _ref5$theme = _ref5.theme, colors = _ref5$theme.colors, baseUnit = _ref5$theme.spacing.baseUnit;
    return (0, $0c8ebbb95bc6bc2e$export$2e2bcd8739ae039)({
        label: 'loadingIndicator',
        display: 'flex',
        transition: 'color 150ms',
        alignSelf: 'center',
        fontSize: size,
        lineHeight: 1,
        marginRight: size,
        textAlign: 'center',
        verticalAlign: 'middle'
    }, unstyled ? {} : {
        color: isFocused ? colors.neutral60 : colors.neutral20,
        padding: baseUnit * 2
    });
};
var $a7ee0070c0e37770$var$LoadingDot = function LoadingDot(_ref6) {
    var delay = _ref6.delay, offset = _ref6.offset;
    return (0, $fb226fb4d95fe644$export$c8a8987d4410bf2d)("span", {
        css: /*#__PURE__*/ (0, $fb226fb4d95fe644$export$dbf350e5966cf602)({
            animation: "".concat($a7ee0070c0e37770$var$loadingDotAnimations, " 1s ease-in-out ").concat(delay, "ms infinite;"),
            backgroundColor: 'currentColor',
            borderRadius: '1em',
            display: 'inline-block',
            marginLeft: offset ? '1em' : undefined,
            height: '1em',
            verticalAlign: 'top',
            width: '1em'
        }, "", "")
    });
};
var $a7ee0070c0e37770$var$LoadingIndicator = function LoadingIndicator(_ref7) {
    var innerProps = _ref7.innerProps, isRtl = _ref7.isRtl, _ref7$size = _ref7.size, size = _ref7$size === void 0 ? 4 : _ref7$size, restProps = (0, $deeae5c1248a0831$export$2e2bcd8739ae039)(_ref7, $a7ee0070c0e37770$var$_excluded2);
    return (0, $fb226fb4d95fe644$export$c8a8987d4410bf2d)("div", (0, $f3601d07f0ff7403$export$2e2bcd8739ae039)({}, $a7ee0070c0e37770$var$getStyleProps((0, $0c8ebbb95bc6bc2e$export$2e2bcd8739ae039)((0, $0c8ebbb95bc6bc2e$export$2e2bcd8739ae039)({}, restProps), {}, {
        innerProps: innerProps,
        isRtl: isRtl,
        size: size
    }), 'loadingIndicator', {
        indicator: true,
        'loading-indicator': true
    }), innerProps), (0, $fb226fb4d95fe644$export$c8a8987d4410bf2d)($a7ee0070c0e37770$var$LoadingDot, {
        delay: 0,
        offset: isRtl
    }), (0, $fb226fb4d95fe644$export$c8a8987d4410bf2d)($a7ee0070c0e37770$var$LoadingDot, {
        delay: 160,
        offset: true
    }), (0, $fb226fb4d95fe644$export$c8a8987d4410bf2d)($a7ee0070c0e37770$var$LoadingDot, {
        delay: 320,
        offset: !isRtl
    }));
};
var $a7ee0070c0e37770$export$4368d992c4eafac0 = function css(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, isFocused = _ref.isFocused, _ref$theme = _ref.theme, colors = _ref$theme.colors, borderRadius = _ref$theme.borderRadius, spacing = _ref$theme.spacing;
    return (0, $0c8ebbb95bc6bc2e$export$2e2bcd8739ae039)({
        label: 'control',
        alignItems: 'center',
        cursor: 'default',
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-between',
        minHeight: spacing.controlHeight,
        outline: '0 !important',
        position: 'relative',
        transition: 'all 100ms'
    }, unstyled ? {} : {
        backgroundColor: isDisabled ? colors.neutral5 : colors.neutral0,
        borderColor: isDisabled ? colors.neutral10 : isFocused ? colors.primary : colors.neutral20,
        borderRadius: borderRadius,
        borderStyle: 'solid',
        borderWidth: 1,
        boxShadow: isFocused ? "0 0 0 1px ".concat(colors.primary) : undefined,
        '&:hover': {
            borderColor: isFocused ? colors.primary : colors.neutral30
        }
    });
};
var $a7ee0070c0e37770$var$Control = function Control(props) {
    var children = props.children, isDisabled = props.isDisabled, isFocused = props.isFocused, innerRef = props.innerRef, innerProps = props.innerProps, menuIsOpen = props.menuIsOpen;
    return (0, $fb226fb4d95fe644$export$c8a8987d4410bf2d)("div", (0, $f3601d07f0ff7403$export$2e2bcd8739ae039)({
        ref: innerRef
    }, $a7ee0070c0e37770$var$getStyleProps(props, 'control', {
        control: true,
        'control--is-disabled': isDisabled,
        'control--is-focused': isFocused,
        'control--menu-is-open': menuIsOpen
    }), innerProps, {
        "aria-disabled": isDisabled || undefined
    }), children);
};
var $a7ee0070c0e37770$var$Control$1 = $a7ee0070c0e37770$var$Control;
var $a7ee0070c0e37770$var$_excluded$1 = [
    "data"
];
var $a7ee0070c0e37770$export$39b482c5e57630a8 = function groupCSS(_ref, unstyled) {
    var spacing = _ref.theme.spacing;
    return unstyled ? {} : {
        paddingBottom: spacing.baseUnit * 2,
        paddingTop: spacing.baseUnit * 2
    };
};
var $a7ee0070c0e37770$var$Group = function Group(props) {
    var children = props.children, cx = props.cx, getStyles = props.getStyles, getClassNames = props.getClassNames, Heading = props.Heading, headingProps = props.headingProps, innerProps = props.innerProps, label = props.label, theme = props.theme, selectProps = props.selectProps;
    return (0, $fb226fb4d95fe644$export$c8a8987d4410bf2d)("div", (0, $f3601d07f0ff7403$export$2e2bcd8739ae039)({}, $a7ee0070c0e37770$var$getStyleProps(props, 'group', {
        group: true
    }), innerProps), (0, $fb226fb4d95fe644$export$c8a8987d4410bf2d)(Heading, (0, $f3601d07f0ff7403$export$2e2bcd8739ae039)({}, headingProps, {
        selectProps: selectProps,
        theme: theme,
        getStyles: getStyles,
        getClassNames: getClassNames,
        cx: cx
    }), label), (0, $fb226fb4d95fe644$export$c8a8987d4410bf2d)("div", null, children));
};
var $a7ee0070c0e37770$export$2d1720544b23b823 = function groupHeadingCSS(_ref2, unstyled) {
    var _ref2$theme = _ref2.theme, colors = _ref2$theme.colors, spacing = _ref2$theme.spacing;
    return (0, $0c8ebbb95bc6bc2e$export$2e2bcd8739ae039)({
        label: 'group',
        cursor: 'default',
        display: 'block'
    }, unstyled ? {} : {
        color: colors.neutral40,
        fontSize: '75%',
        fontWeight: 500,
        marginBottom: '0.25em',
        paddingLeft: spacing.baseUnit * 3,
        paddingRight: spacing.baseUnit * 3,
        textTransform: 'uppercase'
    });
};
var $a7ee0070c0e37770$var$GroupHeading = function GroupHeading(props) {
    var _cleanCommonProps = $a7ee0070c0e37770$var$cleanCommonProps(props);
    _cleanCommonProps.data;
    var innerProps = (0, $deeae5c1248a0831$export$2e2bcd8739ae039)(_cleanCommonProps, $a7ee0070c0e37770$var$_excluded$1);
    return (0, $fb226fb4d95fe644$export$c8a8987d4410bf2d)("div", (0, $f3601d07f0ff7403$export$2e2bcd8739ae039)({}, $a7ee0070c0e37770$var$getStyleProps(props, 'groupHeading', {
        'group-heading': true
    }), innerProps));
};
var $a7ee0070c0e37770$var$Group$1 = $a7ee0070c0e37770$var$Group;
var $a7ee0070c0e37770$var$_excluded = [
    "innerRef",
    "isDisabled",
    "isHidden",
    "inputClassName"
];
var $a7ee0070c0e37770$export$35e795649ee09318 = function inputCSS(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, value = _ref.value, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $0c8ebbb95bc6bc2e$export$2e2bcd8739ae039)((0, $0c8ebbb95bc6bc2e$export$2e2bcd8739ae039)({
        visibility: isDisabled ? 'hidden' : 'visible',
        // force css to recompute when value change due to @emotion bug.
        // We can remove it whenever the bug is fixed.
        transform: value ? 'translateZ(0)' : ''
    }, $a7ee0070c0e37770$var$containerStyle), unstyled ? {} : {
        margin: spacing.baseUnit / 2,
        paddingBottom: spacing.baseUnit / 2,
        paddingTop: spacing.baseUnit / 2,
        color: colors.neutral80
    });
};
var $a7ee0070c0e37770$var$spacingStyle = {
    gridArea: '1 / 2',
    font: 'inherit',
    minWidth: '2px',
    border: 0,
    margin: 0,
    outline: 0,
    padding: 0
};
var $a7ee0070c0e37770$var$containerStyle = {
    flex: '1 1 auto',
    display: 'inline-grid',
    gridArea: '1 / 1 / 2 / 3',
    gridTemplateColumns: '0 min-content',
    '&:after': (0, $0c8ebbb95bc6bc2e$export$2e2bcd8739ae039)({
        content: 'attr(data-value) " "',
        visibility: 'hidden',
        whiteSpace: 'pre'
    }, $a7ee0070c0e37770$var$spacingStyle)
};
var $a7ee0070c0e37770$var$inputStyle = function inputStyle(isHidden) {
    return (0, $0c8ebbb95bc6bc2e$export$2e2bcd8739ae039)({
        label: 'input',
        color: 'inherit',
        background: 0,
        opacity: isHidden ? 0 : 1,
        width: '100%'
    }, $a7ee0070c0e37770$var$spacingStyle);
};
var $a7ee0070c0e37770$var$Input = function Input(props) {
    var cx = props.cx, value = props.value;
    var _cleanCommonProps = $a7ee0070c0e37770$var$cleanCommonProps(props), innerRef = _cleanCommonProps.innerRef, isDisabled = _cleanCommonProps.isDisabled, isHidden = _cleanCommonProps.isHidden, inputClassName = _cleanCommonProps.inputClassName, innerProps = (0, $deeae5c1248a0831$export$2e2bcd8739ae039)(_cleanCommonProps, $a7ee0070c0e37770$var$_excluded);
    return (0, $fb226fb4d95fe644$export$c8a8987d4410bf2d)("div", (0, $f3601d07f0ff7403$export$2e2bcd8739ae039)({}, $a7ee0070c0e37770$var$getStyleProps(props, 'input', {
        'input-container': true
    }), {
        "data-value": value || ''
    }), (0, $fb226fb4d95fe644$export$c8a8987d4410bf2d)("input", (0, $f3601d07f0ff7403$export$2e2bcd8739ae039)({
        className: cx({
            input: true
        }, inputClassName),
        ref: innerRef,
        style: $a7ee0070c0e37770$var$inputStyle(isHidden),
        disabled: isDisabled
    }, innerProps)));
};
var $a7ee0070c0e37770$var$Input$1 = $a7ee0070c0e37770$var$Input;
var $a7ee0070c0e37770$export$ffb5f4729a158638 = function multiValueCSS(_ref, unstyled) {
    var _ref$theme = _ref.theme, spacing = _ref$theme.spacing, borderRadius = _ref$theme.borderRadius, colors = _ref$theme.colors;
    return (0, $0c8ebbb95bc6bc2e$export$2e2bcd8739ae039)({
        label: 'multiValue',
        display: 'flex',
        minWidth: 0
    }, unstyled ? {} : {
        backgroundColor: colors.neutral10,
        borderRadius: borderRadius / 2,
        margin: spacing.baseUnit / 2
    });
};
var $a7ee0070c0e37770$export$9e5f44173e64f162 = function multiValueLabelCSS(_ref2, unstyled) {
    var _ref2$theme = _ref2.theme, borderRadius = _ref2$theme.borderRadius, colors = _ref2$theme.colors, cropWithEllipsis = _ref2.cropWithEllipsis;
    return (0, $0c8ebbb95bc6bc2e$export$2e2bcd8739ae039)({
        overflow: 'hidden',
        textOverflow: cropWithEllipsis || cropWithEllipsis === undefined ? 'ellipsis' : undefined,
        whiteSpace: 'nowrap'
    }, unstyled ? {} : {
        borderRadius: borderRadius / 2,
        color: colors.neutral80,
        fontSize: '85%',
        padding: 3,
        paddingLeft: 6
    });
};
var $a7ee0070c0e37770$export$625550452a3fa3ec = function multiValueRemoveCSS(_ref3, unstyled) {
    var _ref3$theme = _ref3.theme, spacing = _ref3$theme.spacing, borderRadius = _ref3$theme.borderRadius, colors = _ref3$theme.colors, isFocused = _ref3.isFocused;
    return (0, $0c8ebbb95bc6bc2e$export$2e2bcd8739ae039)({
        alignItems: 'center',
        display: 'flex'
    }, unstyled ? {} : {
        borderRadius: borderRadius / 2,
        backgroundColor: isFocused ? colors.dangerLight : undefined,
        paddingLeft: spacing.baseUnit,
        paddingRight: spacing.baseUnit,
        ':hover': {
            backgroundColor: colors.dangerLight,
            color: colors.danger
        }
    });
};
var $a7ee0070c0e37770$var$MultiValueGeneric = function MultiValueGeneric(_ref4) {
    var children = _ref4.children, innerProps = _ref4.innerProps;
    return (0, $fb226fb4d95fe644$export$c8a8987d4410bf2d)("div", innerProps, children);
};
var $a7ee0070c0e37770$var$MultiValueContainer = $a7ee0070c0e37770$var$MultiValueGeneric;
var $a7ee0070c0e37770$var$MultiValueLabel = $a7ee0070c0e37770$var$MultiValueGeneric;
function $a7ee0070c0e37770$var$MultiValueRemove(_ref5) {
    var children = _ref5.children, innerProps = _ref5.innerProps;
    return (0, $fb226fb4d95fe644$export$c8a8987d4410bf2d)("div", (0, $f3601d07f0ff7403$export$2e2bcd8739ae039)({
        role: "button"
    }, innerProps), children || (0, $fb226fb4d95fe644$export$c8a8987d4410bf2d)($a7ee0070c0e37770$var$CrossIcon, {
        size: 14
    }));
}
var $a7ee0070c0e37770$var$MultiValue = function MultiValue(props) {
    var children = props.children, components = props.components, data = props.data, innerProps = props.innerProps, isDisabled = props.isDisabled, removeProps = props.removeProps, selectProps = props.selectProps;
    var Container = components.Container, Label = components.Label, Remove = components.Remove;
    return (0, $fb226fb4d95fe644$export$c8a8987d4410bf2d)(Container, {
        data: data,
        innerProps: (0, $0c8ebbb95bc6bc2e$export$2e2bcd8739ae039)((0, $0c8ebbb95bc6bc2e$export$2e2bcd8739ae039)({}, $a7ee0070c0e37770$var$getStyleProps(props, 'multiValue', {
            'multi-value': true,
            'multi-value--is-disabled': isDisabled
        })), innerProps),
        selectProps: selectProps
    }, (0, $fb226fb4d95fe644$export$c8a8987d4410bf2d)(Label, {
        data: data,
        innerProps: (0, $0c8ebbb95bc6bc2e$export$2e2bcd8739ae039)({}, $a7ee0070c0e37770$var$getStyleProps(props, 'multiValueLabel', {
            'multi-value__label': true
        })),
        selectProps: selectProps
    }, children), (0, $fb226fb4d95fe644$export$c8a8987d4410bf2d)(Remove, {
        data: data,
        innerProps: (0, $0c8ebbb95bc6bc2e$export$2e2bcd8739ae039)((0, $0c8ebbb95bc6bc2e$export$2e2bcd8739ae039)({}, $a7ee0070c0e37770$var$getStyleProps(props, 'multiValueRemove', {
            'multi-value__remove': true
        })), {}, {
            'aria-label': "Remove ".concat(children || 'option')
        }, removeProps),
        selectProps: selectProps
    }));
};
var $a7ee0070c0e37770$var$MultiValue$1 = $a7ee0070c0e37770$var$MultiValue;
var $a7ee0070c0e37770$export$90a7f3efeed30595 = function optionCSS(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, isFocused = _ref.isFocused, isSelected = _ref.isSelected, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $0c8ebbb95bc6bc2e$export$2e2bcd8739ae039)({
        label: 'option',
        cursor: 'default',
        display: 'block',
        fontSize: 'inherit',
        width: '100%',
        userSelect: 'none',
        WebkitTapHighlightColor: 'rgba(0, 0, 0, 0)'
    }, unstyled ? {} : {
        backgroundColor: isSelected ? colors.primary : isFocused ? colors.primary25 : 'transparent',
        color: isDisabled ? colors.neutral20 : isSelected ? colors.neutral0 : 'inherit',
        padding: "".concat(spacing.baseUnit * 2, "px ").concat(spacing.baseUnit * 3, "px"),
        // provide some affordance on touch devices
        ':active': {
            backgroundColor: !isDisabled ? isSelected ? colors.primary : colors.primary50 : undefined
        }
    });
};
var $a7ee0070c0e37770$var$Option = function Option(props) {
    var children = props.children, isDisabled = props.isDisabled, isFocused = props.isFocused, isSelected = props.isSelected, innerRef = props.innerRef, innerProps = props.innerProps;
    return (0, $fb226fb4d95fe644$export$c8a8987d4410bf2d)("div", (0, $f3601d07f0ff7403$export$2e2bcd8739ae039)({}, $a7ee0070c0e37770$var$getStyleProps(props, 'option', {
        option: true,
        'option--is-disabled': isDisabled,
        'option--is-focused': isFocused,
        'option--is-selected': isSelected
    }), {
        ref: innerRef,
        "aria-disabled": isDisabled
    }, innerProps), children);
};
var $a7ee0070c0e37770$var$Option$1 = $a7ee0070c0e37770$var$Option;
var $a7ee0070c0e37770$export$efccba1c4a2ef57b = function placeholderCSS(_ref, unstyled) {
    var _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $0c8ebbb95bc6bc2e$export$2e2bcd8739ae039)({
        label: 'placeholder',
        gridArea: '1 / 1 / 2 / 3'
    }, unstyled ? {} : {
        color: colors.neutral50,
        marginLeft: spacing.baseUnit / 2,
        marginRight: spacing.baseUnit / 2
    });
};
var $a7ee0070c0e37770$var$Placeholder = function Placeholder(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $fb226fb4d95fe644$export$c8a8987d4410bf2d)("div", (0, $f3601d07f0ff7403$export$2e2bcd8739ae039)({}, $a7ee0070c0e37770$var$getStyleProps(props, 'placeholder', {
        placeholder: true
    }), innerProps), children);
};
var $a7ee0070c0e37770$var$Placeholder$1 = $a7ee0070c0e37770$var$Placeholder;
var $a7ee0070c0e37770$export$d141bba7fdc215a3 = function css(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $0c8ebbb95bc6bc2e$export$2e2bcd8739ae039)({
        label: 'singleValue',
        gridArea: '1 / 1 / 2 / 3',
        maxWidth: '100%',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
    }, unstyled ? {} : {
        color: isDisabled ? colors.neutral40 : colors.neutral80,
        marginLeft: spacing.baseUnit / 2,
        marginRight: spacing.baseUnit / 2
    });
};
var $a7ee0070c0e37770$var$SingleValue = function SingleValue(props) {
    var children = props.children, isDisabled = props.isDisabled, innerProps = props.innerProps;
    return (0, $fb226fb4d95fe644$export$c8a8987d4410bf2d)("div", (0, $f3601d07f0ff7403$export$2e2bcd8739ae039)({}, $a7ee0070c0e37770$var$getStyleProps(props, 'singleValue', {
        'single-value': true,
        'single-value--is-disabled': isDisabled
    }), innerProps), children);
};
var $a7ee0070c0e37770$var$SingleValue$1 = $a7ee0070c0e37770$var$SingleValue;
var $a7ee0070c0e37770$export$db3b6bfb95261072 = {
    ClearIndicator: $a7ee0070c0e37770$var$ClearIndicator,
    Control: $a7ee0070c0e37770$var$Control$1,
    DropdownIndicator: $a7ee0070c0e37770$var$DropdownIndicator,
    DownChevron: $a7ee0070c0e37770$var$DownChevron,
    CrossIcon: $a7ee0070c0e37770$var$CrossIcon,
    Group: $a7ee0070c0e37770$var$Group$1,
    GroupHeading: $a7ee0070c0e37770$var$GroupHeading,
    IndicatorsContainer: $a7ee0070c0e37770$var$IndicatorsContainer,
    IndicatorSeparator: $a7ee0070c0e37770$var$IndicatorSeparator,
    Input: $a7ee0070c0e37770$var$Input$1,
    LoadingIndicator: $a7ee0070c0e37770$var$LoadingIndicator,
    Menu: $a7ee0070c0e37770$var$Menu$1,
    MenuList: $a7ee0070c0e37770$var$MenuList,
    MenuPortal: $a7ee0070c0e37770$var$MenuPortal,
    LoadingMessage: $a7ee0070c0e37770$var$LoadingMessage,
    NoOptionsMessage: $a7ee0070c0e37770$var$NoOptionsMessage,
    MultiValue: $a7ee0070c0e37770$var$MultiValue$1,
    MultiValueContainer: $a7ee0070c0e37770$var$MultiValueContainer,
    MultiValueLabel: $a7ee0070c0e37770$var$MultiValueLabel,
    MultiValueRemove: $a7ee0070c0e37770$var$MultiValueRemove,
    Option: $a7ee0070c0e37770$var$Option$1,
    Placeholder: $a7ee0070c0e37770$var$Placeholder$1,
    SelectContainer: $a7ee0070c0e37770$var$SelectContainer,
    SingleValue: $a7ee0070c0e37770$var$SingleValue$1,
    ValueContainer: $a7ee0070c0e37770$var$ValueContainer
};
var $a7ee0070c0e37770$export$d66501df72047452 = function defaultComponents(props) {
    return (0, $0c8ebbb95bc6bc2e$export$2e2bcd8739ae039)((0, $0c8ebbb95bc6bc2e$export$2e2bcd8739ae039)({}, $a7ee0070c0e37770$export$db3b6bfb95261072), props.components);
};



var $d117c343e8b9d792$var$safeIsNaN = Number.isNaN || function ponyfill(value) {
    return typeof value === 'number' && value !== value;
};
function $d117c343e8b9d792$var$isEqual(first, second) {
    if (first === second) return true;
    if ($d117c343e8b9d792$var$safeIsNaN(first) && $d117c343e8b9d792$var$safeIsNaN(second)) return true;
    return false;
}
function $d117c343e8b9d792$var$areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) return false;
    for(var i = 0; i < newInputs.length; i++){
        if (!$d117c343e8b9d792$var$isEqual(newInputs[i], lastInputs[i])) return false;
    }
    return true;
}
function $d117c343e8b9d792$export$2e2bcd8739ae039(resultFn, isEqual) {
    if (isEqual === void 0) isEqual = $d117c343e8b9d792$var$areInputsEqual;
    var cache = null;
    function memoized() {
        var newArgs = [];
        for(var _i = 0; _i < arguments.length; _i++)newArgs[_i] = arguments[_i];
        if (cache && cache.lastThis === this && isEqual(newArgs, cache.lastArgs)) return cache.lastResult;
        var lastResult = resultFn.apply(this, newArgs);
        cache = {
            lastResult: lastResult,
            lastArgs: newArgs,
            lastThis: this
        };
        return lastResult;
    }
    memoized.clear = function clear() {
        cache = null;
    };
    return memoized;
}



function $556ecd5f3b314fff$var$_EMOTION_STRINGIFIED_CSS_ERROR__$2() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// Assistive text to describe visual elements. Hidden for sighted users.
var $556ecd5f3b314fff$var$_ref = {
    name: "7pg0cj-a11yText",
    styles: "label:a11yText;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);height:1px;width:1px;position:absolute;overflow:hidden;padding:0;white-space:nowrap"
};
var $556ecd5f3b314fff$var$A11yText = function A11yText(props) {
    return (0, $fb226fb4d95fe644$export$c8a8987d4410bf2d)("span", (0, $f3601d07f0ff7403$export$2e2bcd8739ae039)({
        css: $556ecd5f3b314fff$var$_ref
    }, props));
};
var $556ecd5f3b314fff$var$A11yText$1 = $556ecd5f3b314fff$var$A11yText;
var $556ecd5f3b314fff$var$defaultAriaLiveMessages = {
    guidance: function guidance(props) {
        var isSearchable = props.isSearchable, isMulti = props.isMulti, tabSelectsValue = props.tabSelectsValue, context = props.context, isInitialFocus = props.isInitialFocus;
        switch(context){
            case 'menu':
                return "Use Up and Down to choose options, press Enter to select the currently focused option, press Escape to exit the menu".concat(tabSelectsValue ? ', press Tab to select the option and exit the menu' : '', ".");
            case 'input':
                return isInitialFocus ? "".concat(props['aria-label'] || 'Select', " is focused ").concat(isSearchable ? ',type to refine list' : '', ", press Down to open the menu, ").concat(isMulti ? ' press left to focus selected values' : '') : '';
            case 'value':
                return 'Use left and right to toggle between focused values, press Backspace to remove the currently focused value';
            default:
                return '';
        }
    },
    onChange: function onChange(props) {
        var action = props.action, _props$label = props.label, label = _props$label === void 0 ? '' : _props$label, labels = props.labels, isDisabled = props.isDisabled;
        switch(action){
            case 'deselect-option':
            case 'pop-value':
            case 'remove-value':
                return "option ".concat(label, ", deselected.");
            case 'clear':
                return 'All selected options have been cleared.';
            case 'initial-input-focus':
                return "option".concat(labels.length > 1 ? 's' : '', " ").concat(labels.join(','), ", selected.");
            case 'select-option':
                return isDisabled ? "option ".concat(label, " is disabled. Select another option.") : "option ".concat(label, ", selected.");
            default:
                return '';
        }
    },
    onFocus: function onFocus(props) {
        var context = props.context, focused = props.focused, options = props.options, _props$label2 = props.label, label = _props$label2 === void 0 ? '' : _props$label2, selectValue = props.selectValue, isDisabled = props.isDisabled, isSelected = props.isSelected, isAppleDevice = props.isAppleDevice;
        var getArrayIndex = function getArrayIndex(arr, item) {
            return arr && arr.length ? "".concat(arr.indexOf(item) + 1, " of ").concat(arr.length) : '';
        };
        if (context === 'value' && selectValue) return "value ".concat(label, " focused, ").concat(getArrayIndex(selectValue, focused), ".");
        if (context === 'menu' && isAppleDevice) {
            var disabled = isDisabled ? ' disabled' : '';
            var status = "".concat(isSelected ? ' selected' : '').concat(disabled);
            return "".concat(label).concat(status, ", ").concat(getArrayIndex(options, focused), ".");
        }
        return '';
    },
    onFilter: function onFilter(props) {
        var inputValue = props.inputValue, resultsMessage = props.resultsMessage;
        return "".concat(resultsMessage).concat(inputValue ? ' for search term ' + inputValue : '', ".");
    }
};
var $556ecd5f3b314fff$var$LiveRegion = function LiveRegion(props) {
    var ariaSelection = props.ariaSelection, focusedOption = props.focusedOption, focusedValue = props.focusedValue, focusableOptions = props.focusableOptions, isFocused = props.isFocused, selectValue = props.selectValue, selectProps = props.selectProps, id = props.id, isAppleDevice = props.isAppleDevice;
    var ariaLiveMessages = selectProps.ariaLiveMessages, getOptionLabel = selectProps.getOptionLabel, inputValue = selectProps.inputValue, isMulti = selectProps.isMulti, isOptionDisabled = selectProps.isOptionDisabled, isSearchable = selectProps.isSearchable, menuIsOpen = selectProps.menuIsOpen, options = selectProps.options, screenReaderStatus = selectProps.screenReaderStatus, tabSelectsValue = selectProps.tabSelectsValue, isLoading = selectProps.isLoading;
    var ariaLabel = selectProps['aria-label'];
    var ariaLive = selectProps['aria-live'];
    // Update aria live message configuration when prop changes
    var messages = (0, $4Y8Vu.useMemo)(function() {
        return (0, $0c8ebbb95bc6bc2e$export$2e2bcd8739ae039)((0, $0c8ebbb95bc6bc2e$export$2e2bcd8739ae039)({}, $556ecd5f3b314fff$var$defaultAriaLiveMessages), ariaLiveMessages || {});
    }, [
        ariaLiveMessages
    ]);
    // Update aria live selected option when prop changes
    var ariaSelected = (0, $4Y8Vu.useMemo)(function() {
        var message = '';
        if (ariaSelection && messages.onChange) {
            var option = ariaSelection.option, selectedOptions = ariaSelection.options, removedValue = ariaSelection.removedValue, removedValues = ariaSelection.removedValues, value = ariaSelection.value;
            // select-option when !isMulti does not return option so we assume selected option is value
            var asOption = function asOption(val) {
                return !Array.isArray(val) ? val : null;
            };
            // If there is just one item from the action then get its label
            var selected = removedValue || option || asOption(value);
            var label = selected ? getOptionLabel(selected) : '';
            // If there are multiple items from the action then return an array of labels
            var multiSelected = selectedOptions || removedValues || undefined;
            var labels = multiSelected ? multiSelected.map(getOptionLabel) : [];
            var onChangeProps = (0, $0c8ebbb95bc6bc2e$export$2e2bcd8739ae039)({
                // multiSelected items are usually items that have already been selected
                // or set by the user as a default value so we assume they are not disabled
                isDisabled: selected && isOptionDisabled(selected, selectValue),
                label: label,
                labels: labels
            }, ariaSelection);
            message = messages.onChange(onChangeProps);
        }
        return message;
    }, [
        ariaSelection,
        messages,
        isOptionDisabled,
        selectValue,
        getOptionLabel
    ]);
    var ariaFocused = (0, $4Y8Vu.useMemo)(function() {
        var focusMsg = '';
        var focused = focusedOption || focusedValue;
        var isSelected = !!(focusedOption && selectValue && selectValue.includes(focusedOption));
        if (focused && messages.onFocus) {
            var onFocusProps = {
                focused: focused,
                label: getOptionLabel(focused),
                isDisabled: isOptionDisabled(focused, selectValue),
                isSelected: isSelected,
                options: focusableOptions,
                context: focused === focusedOption ? 'menu' : 'value',
                selectValue: selectValue,
                isAppleDevice: isAppleDevice
            };
            focusMsg = messages.onFocus(onFocusProps);
        }
        return focusMsg;
    }, [
        focusedOption,
        focusedValue,
        getOptionLabel,
        isOptionDisabled,
        messages,
        focusableOptions,
        selectValue,
        isAppleDevice
    ]);
    var ariaResults = (0, $4Y8Vu.useMemo)(function() {
        var resultsMsg = '';
        if (menuIsOpen && options.length && !isLoading && messages.onFilter) {
            var resultsMessage = screenReaderStatus({
                count: focusableOptions.length
            });
            resultsMsg = messages.onFilter({
                inputValue: inputValue,
                resultsMessage: resultsMessage
            });
        }
        return resultsMsg;
    }, [
        focusableOptions,
        inputValue,
        menuIsOpen,
        messages,
        options,
        screenReaderStatus,
        isLoading
    ]);
    var isInitialFocus = (ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === 'initial-input-focus';
    var ariaGuidance = (0, $4Y8Vu.useMemo)(function() {
        var guidanceMsg = '';
        if (messages.guidance) {
            var context = focusedValue ? 'value' : menuIsOpen ? 'menu' : 'input';
            guidanceMsg = messages.guidance({
                'aria-label': ariaLabel,
                context: context,
                isDisabled: focusedOption && isOptionDisabled(focusedOption, selectValue),
                isMulti: isMulti,
                isSearchable: isSearchable,
                tabSelectsValue: tabSelectsValue,
                isInitialFocus: isInitialFocus
            });
        }
        return guidanceMsg;
    }, [
        ariaLabel,
        focusedOption,
        focusedValue,
        isMulti,
        isOptionDisabled,
        isSearchable,
        menuIsOpen,
        messages,
        selectValue,
        tabSelectsValue,
        isInitialFocus
    ]);
    var ScreenReaderText = (0, $fb226fb4d95fe644$export$c8a8987d4410bf2d)((0, $4Y8Vu.Fragment), null, (0, $fb226fb4d95fe644$export$c8a8987d4410bf2d)("span", {
        id: "aria-selection"
    }, ariaSelected), (0, $fb226fb4d95fe644$export$c8a8987d4410bf2d)("span", {
        id: "aria-focused"
    }, ariaFocused), (0, $fb226fb4d95fe644$export$c8a8987d4410bf2d)("span", {
        id: "aria-results"
    }, ariaResults), (0, $fb226fb4d95fe644$export$c8a8987d4410bf2d)("span", {
        id: "aria-guidance"
    }, ariaGuidance));
    return (0, $fb226fb4d95fe644$export$c8a8987d4410bf2d)((0, $4Y8Vu.Fragment), null, (0, $fb226fb4d95fe644$export$c8a8987d4410bf2d)($556ecd5f3b314fff$var$A11yText$1, {
        id: id
    }, isInitialFocus && ScreenReaderText), (0, $fb226fb4d95fe644$export$c8a8987d4410bf2d)($556ecd5f3b314fff$var$A11yText$1, {
        "aria-live": ariaLive,
        "aria-atomic": "false",
        "aria-relevant": "additions text",
        role: "log"
    }, isFocused && !isInitialFocus && ScreenReaderText));
};
var $556ecd5f3b314fff$var$LiveRegion$1 = $556ecd5f3b314fff$var$LiveRegion;
var $556ecd5f3b314fff$var$diacritics = [
    {
        base: 'A',
        letters: "A\u24B6\uFF21\xC0\xC1\xC2\u1EA6\u1EA4\u1EAA\u1EA8\xC3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\xC4\u01DE\u1EA2\xC5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F"
    },
    {
        base: 'AA',
        letters: "\uA732"
    },
    {
        base: 'AE',
        letters: "\xC6\u01FC\u01E2"
    },
    {
        base: 'AO',
        letters: "\uA734"
    },
    {
        base: 'AU',
        letters: "\uA736"
    },
    {
        base: 'AV',
        letters: "\uA738\uA73A"
    },
    {
        base: 'AY',
        letters: "\uA73C"
    },
    {
        base: 'B',
        letters: "B\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181"
    },
    {
        base: 'C',
        letters: "C\u24B8\uFF23\u0106\u0108\u010A\u010C\xC7\u1E08\u0187\u023B\uA73E"
    },
    {
        base: 'D',
        letters: "D\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779"
    },
    {
        base: 'DZ',
        letters: "\u01F1\u01C4"
    },
    {
        base: 'Dz',
        letters: "\u01F2\u01C5"
    },
    {
        base: 'E',
        letters: "E\u24BA\uFF25\xC8\xC9\xCA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\xCB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E"
    },
    {
        base: 'F',
        letters: "F\u24BB\uFF26\u1E1E\u0191\uA77B"
    },
    {
        base: 'G',
        letters: "G\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E"
    },
    {
        base: 'H',
        letters: "H\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D"
    },
    {
        base: 'I',
        letters: "I\u24BE\uFF29\xCC\xCD\xCE\u0128\u012A\u012C\u0130\xCF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197"
    },
    {
        base: 'J',
        letters: "J\u24BF\uFF2A\u0134\u0248"
    },
    {
        base: 'K',
        letters: "K\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2"
    },
    {
        base: 'L',
        letters: "L\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780"
    },
    {
        base: 'LJ',
        letters: "\u01C7"
    },
    {
        base: 'Lj',
        letters: "\u01C8"
    },
    {
        base: 'M',
        letters: "M\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C"
    },
    {
        base: 'N',
        letters: "N\u24C3\uFF2E\u01F8\u0143\xD1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4"
    },
    {
        base: 'NJ',
        letters: "\u01CA"
    },
    {
        base: 'Nj',
        letters: "\u01CB"
    },
    {
        base: 'O',
        letters: "O\u24C4\uFF2F\xD2\xD3\xD4\u1ED2\u1ED0\u1ED6\u1ED4\xD5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\xD6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\xD8\u01FE\u0186\u019F\uA74A\uA74C"
    },
    {
        base: 'OI',
        letters: "\u01A2"
    },
    {
        base: 'OO',
        letters: "\uA74E"
    },
    {
        base: 'OU',
        letters: "\u0222"
    },
    {
        base: 'P',
        letters: "P\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754"
    },
    {
        base: 'Q',
        letters: "Q\u24C6\uFF31\uA756\uA758\u024A"
    },
    {
        base: 'R',
        letters: "R\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782"
    },
    {
        base: 'S',
        letters: "S\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784"
    },
    {
        base: 'T',
        letters: "T\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786"
    },
    {
        base: 'TZ',
        letters: "\uA728"
    },
    {
        base: 'U',
        letters: "U\u24CA\uFF35\xD9\xDA\xDB\u0168\u1E78\u016A\u1E7A\u016C\xDC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244"
    },
    {
        base: 'V',
        letters: "V\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245"
    },
    {
        base: 'VY',
        letters: "\uA760"
    },
    {
        base: 'W',
        letters: "W\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72"
    },
    {
        base: 'X',
        letters: "X\u24CD\uFF38\u1E8A\u1E8C"
    },
    {
        base: 'Y',
        letters: "Y\u24CE\uFF39\u1EF2\xDD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE"
    },
    {
        base: 'Z',
        letters: "Z\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762"
    },
    {
        base: 'a',
        letters: "a\u24D0\uFF41\u1E9A\xE0\xE1\xE2\u1EA7\u1EA5\u1EAB\u1EA9\xE3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\xE4\u01DF\u1EA3\xE5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250"
    },
    {
        base: 'aa',
        letters: "\uA733"
    },
    {
        base: 'ae',
        letters: "\xE6\u01FD\u01E3"
    },
    {
        base: 'ao',
        letters: "\uA735"
    },
    {
        base: 'au',
        letters: "\uA737"
    },
    {
        base: 'av',
        letters: "\uA739\uA73B"
    },
    {
        base: 'ay',
        letters: "\uA73D"
    },
    {
        base: 'b',
        letters: "b\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253"
    },
    {
        base: 'c',
        letters: "c\u24D2\uFF43\u0107\u0109\u010B\u010D\xE7\u1E09\u0188\u023C\uA73F\u2184"
    },
    {
        base: 'd',
        letters: "d\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A"
    },
    {
        base: 'dz',
        letters: "\u01F3\u01C6"
    },
    {
        base: 'e',
        letters: "e\u24D4\uFF45\xE8\xE9\xEA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\xEB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD"
    },
    {
        base: 'f',
        letters: "f\u24D5\uFF46\u1E1F\u0192\uA77C"
    },
    {
        base: 'g',
        letters: "g\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F"
    },
    {
        base: 'h',
        letters: "h\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265"
    },
    {
        base: 'hv',
        letters: "\u0195"
    },
    {
        base: 'i',
        letters: "i\u24D8\uFF49\xEC\xED\xEE\u0129\u012B\u012D\xEF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131"
    },
    {
        base: 'j',
        letters: "j\u24D9\uFF4A\u0135\u01F0\u0249"
    },
    {
        base: 'k',
        letters: "k\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3"
    },
    {
        base: 'l',
        letters: "l\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747"
    },
    {
        base: 'lj',
        letters: "\u01C9"
    },
    {
        base: 'm',
        letters: "m\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F"
    },
    {
        base: 'n',
        letters: "n\u24DD\uFF4E\u01F9\u0144\xF1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5"
    },
    {
        base: 'nj',
        letters: "\u01CC"
    },
    {
        base: 'o',
        letters: "o\u24DE\uFF4F\xF2\xF3\xF4\u1ED3\u1ED1\u1ED7\u1ED5\xF5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\xF6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\xF8\u01FF\u0254\uA74B\uA74D\u0275"
    },
    {
        base: 'oi',
        letters: "\u01A3"
    },
    {
        base: 'ou',
        letters: "\u0223"
    },
    {
        base: 'oo',
        letters: "\uA74F"
    },
    {
        base: 'p',
        letters: "p\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755"
    },
    {
        base: 'q',
        letters: "q\u24E0\uFF51\u024B\uA757\uA759"
    },
    {
        base: 'r',
        letters: "r\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783"
    },
    {
        base: 's',
        letters: "s\u24E2\uFF53\xDF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B"
    },
    {
        base: 't',
        letters: "t\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787"
    },
    {
        base: 'tz',
        letters: "\uA729"
    },
    {
        base: 'u',
        letters: "u\u24E4\uFF55\xF9\xFA\xFB\u0169\u1E79\u016B\u1E7B\u016D\xFC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289"
    },
    {
        base: 'v',
        letters: "v\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C"
    },
    {
        base: 'vy',
        letters: "\uA761"
    },
    {
        base: 'w',
        letters: "w\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73"
    },
    {
        base: 'x',
        letters: "x\u24E7\uFF58\u1E8B\u1E8D"
    },
    {
        base: 'y',
        letters: "y\u24E8\uFF59\u1EF3\xFD\u0177\u1EF9\u0233\u1E8F\xFF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF"
    },
    {
        base: 'z',
        letters: "z\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763"
    }
];
var $556ecd5f3b314fff$var$anyDiacritic = new RegExp('[' + $556ecd5f3b314fff$var$diacritics.map(function(d) {
    return d.letters;
}).join('') + ']', 'g');
var $556ecd5f3b314fff$var$diacriticToBase = {};
for(var $556ecd5f3b314fff$var$i = 0; $556ecd5f3b314fff$var$i < $556ecd5f3b314fff$var$diacritics.length; $556ecd5f3b314fff$var$i++){
    var $556ecd5f3b314fff$var$diacritic = $556ecd5f3b314fff$var$diacritics[$556ecd5f3b314fff$var$i];
    for(var $556ecd5f3b314fff$var$j = 0; $556ecd5f3b314fff$var$j < $556ecd5f3b314fff$var$diacritic.letters.length; $556ecd5f3b314fff$var$j++)$556ecd5f3b314fff$var$diacriticToBase[$556ecd5f3b314fff$var$diacritic.letters[$556ecd5f3b314fff$var$j]] = $556ecd5f3b314fff$var$diacritic.base;
}
var $556ecd5f3b314fff$var$stripDiacritics = function stripDiacritics(str) {
    return str.replace($556ecd5f3b314fff$var$anyDiacritic, function(match) {
        return $556ecd5f3b314fff$var$diacriticToBase[match];
    });
};
var $556ecd5f3b314fff$var$memoizedStripDiacriticsForInput = (0, $d117c343e8b9d792$export$2e2bcd8739ae039)($556ecd5f3b314fff$var$stripDiacritics);
var $556ecd5f3b314fff$var$trimString = function trimString(str) {
    return str.replace(/^\s+|\s+$/g, '');
};
var $556ecd5f3b314fff$var$defaultStringify = function defaultStringify(option) {
    return "".concat(option.label, " ").concat(option.value);
};
var $556ecd5f3b314fff$export$db3b6bfb95261072 = function createFilter(config) {
    return function(option, rawInput) {
        // eslint-disable-next-line no-underscore-dangle
        if (option.data.__isNew__) return true;
        var _ignoreCase$ignoreAcc = (0, $0c8ebbb95bc6bc2e$export$2e2bcd8739ae039)({
            ignoreCase: true,
            ignoreAccents: true,
            stringify: $556ecd5f3b314fff$var$defaultStringify,
            trim: true,
            matchFrom: 'any'
        }, config), ignoreCase = _ignoreCase$ignoreAcc.ignoreCase, ignoreAccents = _ignoreCase$ignoreAcc.ignoreAccents, stringify = _ignoreCase$ignoreAcc.stringify, trim = _ignoreCase$ignoreAcc.trim, matchFrom = _ignoreCase$ignoreAcc.matchFrom;
        var input = trim ? $556ecd5f3b314fff$var$trimString(rawInput) : rawInput;
        var candidate = trim ? $556ecd5f3b314fff$var$trimString(stringify(option)) : stringify(option);
        if (ignoreCase) {
            input = input.toLowerCase();
            candidate = candidate.toLowerCase();
        }
        if (ignoreAccents) {
            input = $556ecd5f3b314fff$var$memoizedStripDiacriticsForInput(input);
            candidate = $556ecd5f3b314fff$var$stripDiacritics(candidate);
        }
        return matchFrom === 'start' ? candidate.substr(0, input.length) === input : candidate.indexOf(input) > -1;
    };
};
var $556ecd5f3b314fff$var$_excluded = [
    "innerRef"
];
function $556ecd5f3b314fff$var$DummyInput(_ref) {
    var innerRef = _ref.innerRef, props = (0, $deeae5c1248a0831$export$2e2bcd8739ae039)(_ref, $556ecd5f3b314fff$var$_excluded);
    // Remove animation props not meant for HTML elements
    var filteredProps = (0, $a7ee0070c0e37770$export$43caf9889c228507)(props, 'onExited', 'in', 'enter', 'exit', 'appear');
    return (0, $fb226fb4d95fe644$export$c8a8987d4410bf2d)("input", (0, $f3601d07f0ff7403$export$2e2bcd8739ae039)({
        ref: innerRef
    }, filteredProps, {
        css: /*#__PURE__*/ (0, $fb226fb4d95fe644$export$dbf350e5966cf602)({
            label: 'dummyInput',
            // get rid of any default styles
            background: 0,
            border: 0,
            // important! this hides the flashing cursor
            caretColor: 'transparent',
            fontSize: 'inherit',
            gridArea: '1 / 1 / 2 / 3',
            outline: 0,
            padding: 0,
            // important! without `width` browsers won't allow focus
            width: 1,
            // remove cursor on desktop
            color: 'transparent',
            // remove cursor on mobile whilst maintaining "scroll into view" behaviour
            left: -100,
            opacity: 0,
            position: 'relative',
            transform: 'scale(.01)'
        }, "", "")
    }));
}
var $556ecd5f3b314fff$var$cancelScroll = function cancelScroll(event) {
    if (event.cancelable) event.preventDefault();
    event.stopPropagation();
};
function $556ecd5f3b314fff$var$useScrollCapture(_ref) {
    var isEnabled = _ref.isEnabled, onBottomArrive = _ref.onBottomArrive, onBottomLeave = _ref.onBottomLeave, onTopArrive = _ref.onTopArrive, onTopLeave = _ref.onTopLeave;
    var isBottom = (0, $4Y8Vu.useRef)(false);
    var isTop = (0, $4Y8Vu.useRef)(false);
    var touchStart = (0, $4Y8Vu.useRef)(0);
    var scrollTarget = (0, $4Y8Vu.useRef)(null);
    var handleEventDelta = (0, $4Y8Vu.useCallback)(function(event, delta) {
        if (scrollTarget.current === null) return;
        var _scrollTarget$current = scrollTarget.current, scrollTop = _scrollTarget$current.scrollTop, scrollHeight = _scrollTarget$current.scrollHeight, clientHeight = _scrollTarget$current.clientHeight;
        var target = scrollTarget.current;
        var isDeltaPositive = delta > 0;
        var availableScroll = scrollHeight - clientHeight - scrollTop;
        var shouldCancelScroll = false;
        // reset bottom/top flags
        if (availableScroll > delta && isBottom.current) {
            if (onBottomLeave) onBottomLeave(event);
            isBottom.current = false;
        }
        if (isDeltaPositive && isTop.current) {
            if (onTopLeave) onTopLeave(event);
            isTop.current = false;
        }
        // bottom limit
        if (isDeltaPositive && delta > availableScroll) {
            if (onBottomArrive && !isBottom.current) onBottomArrive(event);
            target.scrollTop = scrollHeight;
            shouldCancelScroll = true;
            isBottom.current = true;
        // top limit
        } else if (!isDeltaPositive && -delta > scrollTop) {
            if (onTopArrive && !isTop.current) onTopArrive(event);
            target.scrollTop = 0;
            shouldCancelScroll = true;
            isTop.current = true;
        }
        // cancel scroll
        if (shouldCancelScroll) $556ecd5f3b314fff$var$cancelScroll(event);
    }, [
        onBottomArrive,
        onBottomLeave,
        onTopArrive,
        onTopLeave
    ]);
    var onWheel = (0, $4Y8Vu.useCallback)(function(event) {
        handleEventDelta(event, event.deltaY);
    }, [
        handleEventDelta
    ]);
    var onTouchStart = (0, $4Y8Vu.useCallback)(function(event) {
        // set touch start so we can calculate touchmove delta
        touchStart.current = event.changedTouches[0].clientY;
    }, []);
    var onTouchMove = (0, $4Y8Vu.useCallback)(function(event) {
        var deltaY = touchStart.current - event.changedTouches[0].clientY;
        handleEventDelta(event, deltaY);
    }, [
        handleEventDelta
    ]);
    var startListening = (0, $4Y8Vu.useCallback)(function(el) {
        // bail early if no element is available to attach to
        if (!el) return;
        var notPassive = (0, $a7ee0070c0e37770$export$2408f22a0fab9ae5) ? {
            passive: false
        } : false;
        el.addEventListener('wheel', onWheel, notPassive);
        el.addEventListener('touchstart', onTouchStart, notPassive);
        el.addEventListener('touchmove', onTouchMove, notPassive);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    var stopListening = (0, $4Y8Vu.useCallback)(function(el) {
        // bail early if no element is available to detach from
        if (!el) return;
        el.removeEventListener('wheel', onWheel, false);
        el.removeEventListener('touchstart', onTouchStart, false);
        el.removeEventListener('touchmove', onTouchMove, false);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    (0, $4Y8Vu.useEffect)(function() {
        if (!isEnabled) return;
        var element = scrollTarget.current;
        startListening(element);
        return function() {
            stopListening(element);
        };
    }, [
        isEnabled,
        startListening,
        stopListening
    ]);
    return function(element) {
        scrollTarget.current = element;
    };
}
var $556ecd5f3b314fff$var$STYLE_KEYS = [
    'boxSizing',
    'height',
    'overflow',
    'paddingRight',
    'position'
];
var $556ecd5f3b314fff$var$LOCK_STYLES = {
    boxSizing: 'border-box',
    // account for possible declaration `width: 100%;` on body
    overflow: 'hidden',
    position: 'relative',
    height: '100%'
};
function $556ecd5f3b314fff$var$preventTouchMove(e) {
    if (e.cancelable) e.preventDefault();
}
function $556ecd5f3b314fff$var$allowTouchMove(e) {
    e.stopPropagation();
}
function $556ecd5f3b314fff$var$preventInertiaScroll() {
    var top = this.scrollTop;
    var totalScroll = this.scrollHeight;
    var currentScroll = top + this.offsetHeight;
    if (top === 0) this.scrollTop = 1;
    else if (currentScroll === totalScroll) this.scrollTop = top - 1;
}
// `ontouchstart` check works on most browsers
// `maxTouchPoints` works on IE10/11 and Surface
function $556ecd5f3b314fff$var$isTouchDevice() {
    return 'ontouchstart' in window || navigator.maxTouchPoints;
}
var $556ecd5f3b314fff$var$canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
var $556ecd5f3b314fff$var$activeScrollLocks = 0;
var $556ecd5f3b314fff$var$listenerOptions = {
    capture: false,
    passive: false
};
function $556ecd5f3b314fff$var$useScrollLock(_ref) {
    var isEnabled = _ref.isEnabled, _ref$accountForScroll = _ref.accountForScrollbars, accountForScrollbars = _ref$accountForScroll === void 0 ? true : _ref$accountForScroll;
    var originalStyles = (0, $4Y8Vu.useRef)({});
    var scrollTarget = (0, $4Y8Vu.useRef)(null);
    var addScrollLock = (0, $4Y8Vu.useCallback)(function(touchScrollTarget) {
        if (!$556ecd5f3b314fff$var$canUseDOM) return;
        var target = document.body;
        var targetStyle = target && target.style;
        if (accountForScrollbars) // store any styles already applied to the body
        $556ecd5f3b314fff$var$STYLE_KEYS.forEach(function(key) {
            var val = targetStyle && targetStyle[key];
            originalStyles.current[key] = val;
        });
        // apply the lock styles and padding if this is the first scroll lock
        if (accountForScrollbars && $556ecd5f3b314fff$var$activeScrollLocks < 1) {
            var currentPadding = parseInt(originalStyles.current.paddingRight, 10) || 0;
            var clientWidth = document.body ? document.body.clientWidth : 0;
            var adjustedPadding = window.innerWidth - clientWidth + currentPadding || 0;
            Object.keys($556ecd5f3b314fff$var$LOCK_STYLES).forEach(function(key) {
                var val = $556ecd5f3b314fff$var$LOCK_STYLES[key];
                if (targetStyle) targetStyle[key] = val;
            });
            if (targetStyle) targetStyle.paddingRight = "".concat(adjustedPadding, "px");
        }
        // account for touch devices
        if (target && $556ecd5f3b314fff$var$isTouchDevice()) {
            // Mobile Safari ignores { overflow: hidden } declaration on the body.
            target.addEventListener('touchmove', $556ecd5f3b314fff$var$preventTouchMove, $556ecd5f3b314fff$var$listenerOptions);
            // Allow scroll on provided target
            if (touchScrollTarget) {
                touchScrollTarget.addEventListener('touchstart', $556ecd5f3b314fff$var$preventInertiaScroll, $556ecd5f3b314fff$var$listenerOptions);
                touchScrollTarget.addEventListener('touchmove', $556ecd5f3b314fff$var$allowTouchMove, $556ecd5f3b314fff$var$listenerOptions);
            }
        }
        // increment active scroll locks
        $556ecd5f3b314fff$var$activeScrollLocks += 1;
    }, [
        accountForScrollbars
    ]);
    var removeScrollLock = (0, $4Y8Vu.useCallback)(function(touchScrollTarget) {
        if (!$556ecd5f3b314fff$var$canUseDOM) return;
        var target = document.body;
        var targetStyle = target && target.style;
        // safely decrement active scroll locks
        $556ecd5f3b314fff$var$activeScrollLocks = Math.max($556ecd5f3b314fff$var$activeScrollLocks - 1, 0);
        // reapply original body styles, if any
        if (accountForScrollbars && $556ecd5f3b314fff$var$activeScrollLocks < 1) $556ecd5f3b314fff$var$STYLE_KEYS.forEach(function(key) {
            var val = originalStyles.current[key];
            if (targetStyle) targetStyle[key] = val;
        });
        // remove touch listeners
        if (target && $556ecd5f3b314fff$var$isTouchDevice()) {
            target.removeEventListener('touchmove', $556ecd5f3b314fff$var$preventTouchMove, $556ecd5f3b314fff$var$listenerOptions);
            if (touchScrollTarget) {
                touchScrollTarget.removeEventListener('touchstart', $556ecd5f3b314fff$var$preventInertiaScroll, $556ecd5f3b314fff$var$listenerOptions);
                touchScrollTarget.removeEventListener('touchmove', $556ecd5f3b314fff$var$allowTouchMove, $556ecd5f3b314fff$var$listenerOptions);
            }
        }
    }, [
        accountForScrollbars
    ]);
    (0, $4Y8Vu.useEffect)(function() {
        if (!isEnabled) return;
        var element = scrollTarget.current;
        addScrollLock(element);
        return function() {
            removeScrollLock(element);
        };
    }, [
        isEnabled,
        addScrollLock,
        removeScrollLock
    ]);
    return function(element) {
        scrollTarget.current = element;
    };
}
function $556ecd5f3b314fff$var$_EMOTION_STRINGIFIED_CSS_ERROR__$1() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $556ecd5f3b314fff$var$blurSelectInput = function blurSelectInput(event) {
    var element = event.target;
    return element.ownerDocument.activeElement && element.ownerDocument.activeElement.blur();
};
var $556ecd5f3b314fff$var$_ref2$1 = {
    name: "1kfdb0e",
    styles: "position:fixed;left:0;bottom:0;right:0;top:0"
};
function $556ecd5f3b314fff$var$ScrollManager(_ref) {
    var children = _ref.children, lockEnabled = _ref.lockEnabled, _ref$captureEnabled = _ref.captureEnabled, captureEnabled = _ref$captureEnabled === void 0 ? true : _ref$captureEnabled, onBottomArrive = _ref.onBottomArrive, onBottomLeave = _ref.onBottomLeave, onTopArrive = _ref.onTopArrive, onTopLeave = _ref.onTopLeave;
    var setScrollCaptureTarget = $556ecd5f3b314fff$var$useScrollCapture({
        isEnabled: captureEnabled,
        onBottomArrive: onBottomArrive,
        onBottomLeave: onBottomLeave,
        onTopArrive: onTopArrive,
        onTopLeave: onTopLeave
    });
    var setScrollLockTarget = $556ecd5f3b314fff$var$useScrollLock({
        isEnabled: lockEnabled
    });
    var targetRef = function targetRef(element) {
        setScrollCaptureTarget(element);
        setScrollLockTarget(element);
    };
    return (0, $fb226fb4d95fe644$export$c8a8987d4410bf2d)((0, $4Y8Vu.Fragment), null, lockEnabled && (0, $fb226fb4d95fe644$export$c8a8987d4410bf2d)("div", {
        onClick: $556ecd5f3b314fff$var$blurSelectInput,
        css: $556ecd5f3b314fff$var$_ref2$1
    }), children(targetRef));
}
function $556ecd5f3b314fff$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $556ecd5f3b314fff$var$_ref2 = {
    name: "1a0ro4n-requiredInput",
    styles: "label:requiredInput;opacity:0;pointer-events:none;position:absolute;bottom:0;left:0;right:0;width:100%"
};
var $556ecd5f3b314fff$var$RequiredInput = function RequiredInput(_ref) {
    var name = _ref.name, onFocus = _ref.onFocus;
    return (0, $fb226fb4d95fe644$export$c8a8987d4410bf2d)("input", {
        required: true,
        name: name,
        tabIndex: -1,
        "aria-hidden": "true",
        onFocus: onFocus,
        css: $556ecd5f3b314fff$var$_ref2,
        value: "",
        onChange: function onChange() {}
    });
};
var $556ecd5f3b314fff$var$RequiredInput$1 = $556ecd5f3b314fff$var$RequiredInput;
/// <reference types="user-agent-data-types" />
function $556ecd5f3b314fff$var$testPlatform(re) {
    var _window$navigator$use;
    return typeof window !== 'undefined' && window.navigator != null ? re.test(((_window$navigator$use = window.navigator['userAgentData']) === null || _window$navigator$use === void 0 ? void 0 : _window$navigator$use.platform) || window.navigator.platform) : false;
}
function $556ecd5f3b314fff$var$isIPhone() {
    return $556ecd5f3b314fff$var$testPlatform(/^iPhone/i);
}
function $556ecd5f3b314fff$var$isMac() {
    return $556ecd5f3b314fff$var$testPlatform(/^Mac/i);
}
function $556ecd5f3b314fff$var$isIPad() {
    return $556ecd5f3b314fff$var$testPlatform(/^iPad/i) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
    $556ecd5f3b314fff$var$isMac() && navigator.maxTouchPoints > 1;
}
function $556ecd5f3b314fff$var$isIOS() {
    return $556ecd5f3b314fff$var$isIPhone() || $556ecd5f3b314fff$var$isIPad();
}
function $556ecd5f3b314fff$var$isAppleDevice() {
    return $556ecd5f3b314fff$var$isMac() || $556ecd5f3b314fff$var$isIOS();
}
var $556ecd5f3b314fff$var$formatGroupLabel = function formatGroupLabel(group) {
    return group.label;
};
var $556ecd5f3b314fff$export$8b22cf2602fb60ce = function getOptionLabel(option) {
    return option.label;
};
var $556ecd5f3b314fff$export$39b482c5e57630a8 = function getOptionValue(option) {
    return option.value;
};
var $556ecd5f3b314fff$var$isOptionDisabled = function isOptionDisabled(option) {
    return !!option.isDisabled;
};
var $556ecd5f3b314fff$var$defaultStyles = {
    clearIndicator: (0, $a7ee0070c0e37770$export$407448d2b89b1813),
    container: (0, $a7ee0070c0e37770$export$8b22cf2602fb60ce),
    control: (0, $a7ee0070c0e37770$export$4368d992c4eafac0),
    dropdownIndicator: (0, $a7ee0070c0e37770$export$f1e1789686576879),
    group: (0, $a7ee0070c0e37770$export$39b482c5e57630a8),
    groupHeading: (0, $a7ee0070c0e37770$export$2d1720544b23b823),
    indicatorsContainer: (0, $a7ee0070c0e37770$export$23f2a1d2818174ef),
    indicatorSeparator: (0, $a7ee0070c0e37770$export$dda1d9f60106f0e9),
    input: (0, $a7ee0070c0e37770$export$35e795649ee09318),
    loadingIndicator: (0, $a7ee0070c0e37770$export$882b5998b3b9117c),
    loadingMessage: (0, $a7ee0070c0e37770$export$342063e11d6c3cad),
    menu: (0, $a7ee0070c0e37770$export$953cecd6e717a553),
    menuList: (0, $a7ee0070c0e37770$export$7ccc53e8f1e7dfc5),
    menuPortal: (0, $a7ee0070c0e37770$export$ae1af26003f05816),
    multiValue: (0, $a7ee0070c0e37770$export$ffb5f4729a158638),
    multiValueLabel: (0, $a7ee0070c0e37770$export$9e5f44173e64f162),
    multiValueRemove: (0, $a7ee0070c0e37770$export$625550452a3fa3ec),
    noOptionsMessage: (0, $a7ee0070c0e37770$export$3b14a55fb2447963),
    option: (0, $a7ee0070c0e37770$export$90a7f3efeed30595),
    placeholder: (0, $a7ee0070c0e37770$export$efccba1c4a2ef57b),
    singleValue: (0, $a7ee0070c0e37770$export$d141bba7fdc215a3),
    valueContainer: (0, $a7ee0070c0e37770$export$4a5767248b18ef41)
};
// Merge Utility
// Allows consumers to extend a base Select with additional styles
function $556ecd5f3b314fff$export$953cecd6e717a553(source) {
    var target = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    // initialize with source styles
    var styles = (0, $0c8ebbb95bc6bc2e$export$2e2bcd8739ae039)({}, source);
    // massage in target styles
    Object.keys(target).forEach(function(keyAsString) {
        var key = keyAsString;
        if (source[key]) styles[key] = function(rsCss, props) {
            return target[key](source[key](rsCss, props), props);
        };
        else styles[key] = target[key];
    });
    return styles;
}
var $556ecd5f3b314fff$var$colors = {
    primary: '#2684FF',
    primary75: '#4C9AFF',
    primary50: '#B2D4FF',
    primary25: '#DEEBFF',
    danger: '#DE350B',
    dangerLight: '#FFBDAD',
    neutral0: 'hsl(0, 0%, 100%)',
    neutral5: 'hsl(0, 0%, 95%)',
    neutral10: 'hsl(0, 0%, 90%)',
    neutral20: 'hsl(0, 0%, 80%)',
    neutral30: 'hsl(0, 0%, 70%)',
    neutral40: 'hsl(0, 0%, 60%)',
    neutral50: 'hsl(0, 0%, 50%)',
    neutral60: 'hsl(0, 0%, 40%)',
    neutral70: 'hsl(0, 0%, 30%)',
    neutral80: 'hsl(0, 0%, 20%)',
    neutral90: 'hsl(0, 0%, 10%)'
};
var $556ecd5f3b314fff$var$borderRadius = 4;
// Used to calculate consistent margin/padding on elements
var $556ecd5f3b314fff$var$baseUnit = 4;
// The minimum height of the control
var $556ecd5f3b314fff$var$controlHeight = 38;
// The amount of space between the control and menu */
var $556ecd5f3b314fff$var$menuGutter = $556ecd5f3b314fff$var$baseUnit * 2;
var $556ecd5f3b314fff$var$spacing = {
    baseUnit: $556ecd5f3b314fff$var$baseUnit,
    controlHeight: $556ecd5f3b314fff$var$controlHeight,
    menuGutter: $556ecd5f3b314fff$var$menuGutter
};
var $556ecd5f3b314fff$export$4368d992c4eafac0 = {
    borderRadius: $556ecd5f3b314fff$var$borderRadius,
    colors: $556ecd5f3b314fff$var$colors,
    spacing: $556ecd5f3b314fff$var$spacing
};
var $556ecd5f3b314fff$export$407448d2b89b1813 = {
    'aria-live': 'polite',
    backspaceRemovesValue: true,
    blurInputOnSelect: (0, $a7ee0070c0e37770$export$df995fae86a55f06)(),
    captureMenuScroll: !(0, $a7ee0070c0e37770$export$df995fae86a55f06)(),
    classNames: {},
    closeMenuOnSelect: true,
    closeMenuOnScroll: false,
    components: {},
    controlShouldRenderValue: true,
    escapeClearsValue: false,
    filterOption: $556ecd5f3b314fff$export$db3b6bfb95261072(),
    formatGroupLabel: $556ecd5f3b314fff$var$formatGroupLabel,
    getOptionLabel: $556ecd5f3b314fff$export$8b22cf2602fb60ce,
    getOptionValue: $556ecd5f3b314fff$export$39b482c5e57630a8,
    isDisabled: false,
    isLoading: false,
    isMulti: false,
    isRtl: false,
    isSearchable: true,
    isOptionDisabled: $556ecd5f3b314fff$var$isOptionDisabled,
    loadingMessage: function loadingMessage() {
        return 'Loading...';
    },
    maxMenuHeight: 300,
    minMenuHeight: 140,
    menuIsOpen: false,
    menuPlacement: 'bottom',
    menuPosition: 'absolute',
    menuShouldBlockScroll: false,
    menuShouldScrollIntoView: !(0, $a7ee0070c0e37770$export$ebd11618f299a286)(),
    noOptionsMessage: function noOptionsMessage() {
        return 'No options';
    },
    openMenuOnFocus: false,
    openMenuOnClick: true,
    options: [],
    pageSize: 5,
    placeholder: 'Select...',
    screenReaderStatus: function screenReaderStatus(_ref) {
        var count = _ref.count;
        return "".concat(count, " result").concat(count !== 1 ? 's' : '', " available");
    },
    styles: {},
    tabIndex: 0,
    tabSelectsValue: true,
    unstyled: false
};
function $556ecd5f3b314fff$var$toCategorizedOption(props, option, selectValue, index) {
    var isDisabled = $556ecd5f3b314fff$var$_isOptionDisabled(props, option, selectValue);
    var isSelected = $556ecd5f3b314fff$var$_isOptionSelected(props, option, selectValue);
    var label = $556ecd5f3b314fff$var$getOptionLabel(props, option);
    var value = $556ecd5f3b314fff$var$getOptionValue(props, option);
    return {
        type: 'option',
        data: option,
        isDisabled: isDisabled,
        isSelected: isSelected,
        label: label,
        value: value,
        index: index
    };
}
function $556ecd5f3b314fff$var$buildCategorizedOptions(props, selectValue) {
    return props.options.map(function(groupOrOption, groupOrOptionIndex) {
        if ('options' in groupOrOption) {
            var categorizedOptions = groupOrOption.options.map(function(option, optionIndex) {
                return $556ecd5f3b314fff$var$toCategorizedOption(props, option, selectValue, optionIndex);
            }).filter(function(categorizedOption) {
                return $556ecd5f3b314fff$var$isFocusable(props, categorizedOption);
            });
            return categorizedOptions.length > 0 ? {
                type: 'group',
                data: groupOrOption,
                options: categorizedOptions,
                index: groupOrOptionIndex
            } : undefined;
        }
        var categorizedOption = $556ecd5f3b314fff$var$toCategorizedOption(props, groupOrOption, selectValue, groupOrOptionIndex);
        return $556ecd5f3b314fff$var$isFocusable(props, categorizedOption) ? categorizedOption : undefined;
    }).filter((0, $a7ee0070c0e37770$export$3466f893ebf79586));
}
function $556ecd5f3b314fff$var$buildFocusableOptionsFromCategorizedOptions(categorizedOptions) {
    return categorizedOptions.reduce(function(optionsAccumulator, categorizedOption) {
        if (categorizedOption.type === 'group') optionsAccumulator.push.apply(optionsAccumulator, (0, $b227d8d9cf911b9e$export$2e2bcd8739ae039)(categorizedOption.options.map(function(option) {
            return option.data;
        })));
        else optionsAccumulator.push(categorizedOption.data);
        return optionsAccumulator;
    }, []);
}
function $556ecd5f3b314fff$var$buildFocusableOptionsWithIds(categorizedOptions, optionId) {
    return categorizedOptions.reduce(function(optionsAccumulator, categorizedOption) {
        if (categorizedOption.type === 'group') optionsAccumulator.push.apply(optionsAccumulator, (0, $b227d8d9cf911b9e$export$2e2bcd8739ae039)(categorizedOption.options.map(function(option) {
            return {
                data: option.data,
                id: "".concat(optionId, "-").concat(categorizedOption.index, "-").concat(option.index)
            };
        })));
        else optionsAccumulator.push({
            data: categorizedOption.data,
            id: "".concat(optionId, "-").concat(categorizedOption.index)
        });
        return optionsAccumulator;
    }, []);
}
function $556ecd5f3b314fff$var$buildFocusableOptions(props, selectValue) {
    return $556ecd5f3b314fff$var$buildFocusableOptionsFromCategorizedOptions($556ecd5f3b314fff$var$buildCategorizedOptions(props, selectValue));
}
function $556ecd5f3b314fff$var$isFocusable(props, categorizedOption) {
    var _props$inputValue = props.inputValue, inputValue = _props$inputValue === void 0 ? '' : _props$inputValue;
    var data = categorizedOption.data, isSelected = categorizedOption.isSelected, label = categorizedOption.label, value = categorizedOption.value;
    return (!$556ecd5f3b314fff$var$shouldHideSelectedOptions(props) || !isSelected) && $556ecd5f3b314fff$var$_filterOption(props, {
        label: label,
        value: value,
        data: data
    }, inputValue);
}
function $556ecd5f3b314fff$var$getNextFocusedValue(state, nextSelectValue) {
    var focusedValue = state.focusedValue, lastSelectValue = state.selectValue;
    var lastFocusedIndex = lastSelectValue.indexOf(focusedValue);
    if (lastFocusedIndex > -1) {
        var nextFocusedIndex = nextSelectValue.indexOf(focusedValue);
        if (nextFocusedIndex > -1) // the focused value is still in the selectValue, return it
        return focusedValue;
        else if (lastFocusedIndex < nextSelectValue.length) // the focusedValue is not present in the next selectValue array by
        // reference, so return the new value at the same index
        return nextSelectValue[lastFocusedIndex];
    }
    return null;
}
function $556ecd5f3b314fff$var$getNextFocusedOption(state, options) {
    var lastFocusedOption = state.focusedOption;
    return lastFocusedOption && options.indexOf(lastFocusedOption) > -1 ? lastFocusedOption : options[0];
}
var $556ecd5f3b314fff$var$getFocusedOptionId = function getFocusedOptionId(focusableOptionsWithIds, focusedOption) {
    var _focusableOptionsWith;
    var focusedOptionId = (_focusableOptionsWith = focusableOptionsWithIds.find(function(option) {
        return option.data === focusedOption;
    })) === null || _focusableOptionsWith === void 0 ? void 0 : _focusableOptionsWith.id;
    return focusedOptionId || null;
};
var $556ecd5f3b314fff$var$getOptionLabel = function getOptionLabel(props, data) {
    return props.getOptionLabel(data);
};
var $556ecd5f3b314fff$var$getOptionValue = function getOptionValue(props, data) {
    return props.getOptionValue(data);
};
function $556ecd5f3b314fff$var$_isOptionDisabled(props, option, selectValue) {
    return typeof props.isOptionDisabled === 'function' ? props.isOptionDisabled(option, selectValue) : false;
}
function $556ecd5f3b314fff$var$_isOptionSelected(props, option, selectValue) {
    if (selectValue.indexOf(option) > -1) return true;
    if (typeof props.isOptionSelected === 'function') return props.isOptionSelected(option, selectValue);
    var candidate = $556ecd5f3b314fff$var$getOptionValue(props, option);
    return selectValue.some(function(i) {
        return $556ecd5f3b314fff$var$getOptionValue(props, i) === candidate;
    });
}
function $556ecd5f3b314fff$var$_filterOption(props, option, inputValue) {
    return props.filterOption ? props.filterOption(option, inputValue) : true;
}
var $556ecd5f3b314fff$var$shouldHideSelectedOptions = function shouldHideSelectedOptions(props) {
    var hideSelectedOptions = props.hideSelectedOptions, isMulti = props.isMulti;
    if (hideSelectedOptions === undefined) return isMulti;
    return hideSelectedOptions;
};
var $556ecd5f3b314fff$var$instanceId = 1;
var $556ecd5f3b314fff$export$25ce5a424b770e84 = /*#__PURE__*/ function(_Component) {
    (0, $31682117dcc79013$export$2e2bcd8739ae039)(Select, _Component);
    var _super = (0, $f45d8b2d8250d322$export$2e2bcd8739ae039)(Select);
    // Misc. Instance Properties
    // ------------------------------
    // TODO
    // Refs
    // ------------------------------
    // Lifecycle
    // ------------------------------
    function Select(_props) {
        var _this;
        (0, $81bb1a2b496df09f$export$2e2bcd8739ae039)(this, Select);
        _this = _super.call(this, _props);
        _this.state = {
            ariaSelection: null,
            focusedOption: null,
            focusedOptionId: null,
            focusableOptionsWithIds: [],
            focusedValue: null,
            inputIsHidden: false,
            isFocused: false,
            selectValue: [],
            clearFocusValueOnUpdate: false,
            prevWasFocused: false,
            inputIsHiddenAfterUpdate: undefined,
            prevProps: undefined,
            instancePrefix: ''
        };
        _this.blockOptionHover = false;
        _this.isComposing = false;
        _this.commonProps = void 0;
        _this.initialTouchX = 0;
        _this.initialTouchY = 0;
        _this.openAfterFocus = false;
        _this.scrollToFocusedOptionOnUpdate = false;
        _this.userIsDragging = void 0;
        _this.isAppleDevice = $556ecd5f3b314fff$var$isAppleDevice();
        _this.controlRef = null;
        _this.getControlRef = function(ref) {
            _this.controlRef = ref;
        };
        _this.focusedOptionRef = null;
        _this.getFocusedOptionRef = function(ref) {
            _this.focusedOptionRef = ref;
        };
        _this.menuListRef = null;
        _this.getMenuListRef = function(ref) {
            _this.menuListRef = ref;
        };
        _this.inputRef = null;
        _this.getInputRef = function(ref) {
            _this.inputRef = ref;
        };
        _this.focus = _this.focusInput;
        _this.blur = _this.blurInput;
        _this.onChange = function(newValue, actionMeta) {
            var _this$props = _this.props, onChange = _this$props.onChange, name = _this$props.name;
            actionMeta.name = name;
            _this.ariaOnChange(newValue, actionMeta);
            onChange(newValue, actionMeta);
        };
        _this.setValue = function(newValue, action, option) {
            var _this$props2 = _this.props, closeMenuOnSelect = _this$props2.closeMenuOnSelect, isMulti = _this$props2.isMulti, inputValue = _this$props2.inputValue;
            _this.onInputChange('', {
                action: 'set-value',
                prevInputValue: inputValue
            });
            if (closeMenuOnSelect) {
                _this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                _this.onMenuClose();
            }
            // when the select value should change, we should reset focusedValue
            _this.setState({
                clearFocusValueOnUpdate: true
            });
            _this.onChange(newValue, {
                action: action,
                option: option
            });
        };
        _this.selectOption = function(newValue) {
            var _this$props3 = _this.props, blurInputOnSelect = _this$props3.blurInputOnSelect, isMulti = _this$props3.isMulti, name = _this$props3.name;
            var selectValue = _this.state.selectValue;
            var deselected = isMulti && _this.isOptionSelected(newValue, selectValue);
            var isDisabled = _this.isOptionDisabled(newValue, selectValue);
            if (deselected) {
                var candidate = _this.getOptionValue(newValue);
                _this.setValue((0, $a7ee0070c0e37770$export$ef35774e6d314e91)(selectValue.filter(function(i) {
                    return _this.getOptionValue(i) !== candidate;
                })), 'deselect-option', newValue);
            } else if (!isDisabled) {
                // Select option if option is not disabled
                if (isMulti) _this.setValue((0, $a7ee0070c0e37770$export$ef35774e6d314e91)([].concat((0, $b227d8d9cf911b9e$export$2e2bcd8739ae039)(selectValue), [
                    newValue
                ])), 'select-option', newValue);
                else _this.setValue((0, $a7ee0070c0e37770$export$e7094788287c5e9b)(newValue), 'select-option');
            } else {
                _this.ariaOnChange((0, $a7ee0070c0e37770$export$e7094788287c5e9b)(newValue), {
                    action: 'select-option',
                    option: newValue,
                    name: name
                });
                return;
            }
            if (blurInputOnSelect) _this.blurInput();
        };
        _this.removeValue = function(removedValue) {
            var isMulti = _this.props.isMulti;
            var selectValue = _this.state.selectValue;
            var candidate = _this.getOptionValue(removedValue);
            var newValueArray = selectValue.filter(function(i) {
                return _this.getOptionValue(i) !== candidate;
            });
            var newValue = (0, $a7ee0070c0e37770$export$96f57966bedc81b4)(isMulti, newValueArray, newValueArray[0] || null);
            _this.onChange(newValue, {
                action: 'remove-value',
                removedValue: removedValue
            });
            _this.focusInput();
        };
        _this.clearValue = function() {
            var selectValue = _this.state.selectValue;
            _this.onChange((0, $a7ee0070c0e37770$export$96f57966bedc81b4)(_this.props.isMulti, [], null), {
                action: 'clear',
                removedValues: selectValue
            });
        };
        _this.popValue = function() {
            var isMulti = _this.props.isMulti;
            var selectValue = _this.state.selectValue;
            var lastSelectedValue = selectValue[selectValue.length - 1];
            var newValueArray = selectValue.slice(0, selectValue.length - 1);
            var newValue = (0, $a7ee0070c0e37770$export$96f57966bedc81b4)(isMulti, newValueArray, newValueArray[0] || null);
            if (lastSelectedValue) _this.onChange(newValue, {
                action: 'pop-value',
                removedValue: lastSelectedValue
            });
        };
        _this.getFocusedOptionId = function(focusedOption) {
            return $556ecd5f3b314fff$var$getFocusedOptionId(_this.state.focusableOptionsWithIds, focusedOption);
        };
        _this.getFocusableOptionsWithIds = function() {
            return $556ecd5f3b314fff$var$buildFocusableOptionsWithIds($556ecd5f3b314fff$var$buildCategorizedOptions(_this.props, _this.state.selectValue), _this.getElementId('option'));
        };
        _this.getValue = function() {
            return _this.state.selectValue;
        };
        _this.cx = function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return (0, $a7ee0070c0e37770$export$a9c23c6ac3fc3eca).apply(void 0, [
                _this.props.classNamePrefix
            ].concat(args));
        };
        _this.getOptionLabel = function(data) {
            return $556ecd5f3b314fff$var$getOptionLabel(_this.props, data);
        };
        _this.getOptionValue = function(data) {
            return $556ecd5f3b314fff$var$getOptionValue(_this.props, data);
        };
        _this.getStyles = function(key, props) {
            var unstyled = _this.props.unstyled;
            var base = $556ecd5f3b314fff$var$defaultStyles[key](props, unstyled);
            base.boxSizing = 'border-box';
            var custom = _this.props.styles[key];
            return custom ? custom(base, props) : base;
        };
        _this.getClassNames = function(key, props) {
            var _this$props$className, _this$props$className2;
            return (_this$props$className = (_this$props$className2 = _this.props.classNames)[key]) === null || _this$props$className === void 0 ? void 0 : _this$props$className.call(_this$props$className2, props);
        };
        _this.getElementId = function(element) {
            return "".concat(_this.state.instancePrefix, "-").concat(element);
        };
        _this.getComponents = function() {
            return (0, $a7ee0070c0e37770$export$d66501df72047452)(_this.props);
        };
        _this.buildCategorizedOptions = function() {
            return $556ecd5f3b314fff$var$buildCategorizedOptions(_this.props, _this.state.selectValue);
        };
        _this.getCategorizedOptions = function() {
            return _this.props.menuIsOpen ? _this.buildCategorizedOptions() : [];
        };
        _this.buildFocusableOptions = function() {
            return $556ecd5f3b314fff$var$buildFocusableOptionsFromCategorizedOptions(_this.buildCategorizedOptions());
        };
        _this.getFocusableOptions = function() {
            return _this.props.menuIsOpen ? _this.buildFocusableOptions() : [];
        };
        _this.ariaOnChange = function(value, actionMeta) {
            _this.setState({
                ariaSelection: (0, $0c8ebbb95bc6bc2e$export$2e2bcd8739ae039)({
                    value: value
                }, actionMeta)
            });
        };
        _this.onMenuMouseDown = function(event) {
            if (event.button !== 0) return;
            event.stopPropagation();
            event.preventDefault();
            _this.focusInput();
        };
        _this.onMenuMouseMove = function(event) {
            _this.blockOptionHover = false;
        };
        _this.onControlMouseDown = function(event) {
            // Event captured by dropdown indicator
            if (event.defaultPrevented) return;
            var openMenuOnClick = _this.props.openMenuOnClick;
            if (!_this.state.isFocused) {
                if (openMenuOnClick) _this.openAfterFocus = true;
                _this.focusInput();
            } else if (!_this.props.menuIsOpen) {
                if (openMenuOnClick) _this.openMenu('first');
            } else if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') _this.onMenuClose();
            if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') event.preventDefault();
        };
        _this.onDropdownIndicatorMouseDown = function(event) {
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === 'mousedown' && event.button !== 0) return;
            if (_this.props.isDisabled) return;
            var _this$props4 = _this.props, isMulti = _this$props4.isMulti, menuIsOpen = _this$props4.menuIsOpen;
            _this.focusInput();
            if (menuIsOpen) {
                _this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                _this.onMenuClose();
            } else _this.openMenu('first');
            event.preventDefault();
        };
        _this.onClearIndicatorMouseDown = function(event) {
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === 'mousedown' && event.button !== 0) return;
            _this.clearValue();
            event.preventDefault();
            _this.openAfterFocus = false;
            if (event.type === 'touchend') _this.focusInput();
            else setTimeout(function() {
                return _this.focusInput();
            });
        };
        _this.onScroll = function(event) {
            if (typeof _this.props.closeMenuOnScroll === 'boolean') {
                if (event.target instanceof HTMLElement && (0, $a7ee0070c0e37770$export$2329c99376c9d0a4)(event.target)) _this.props.onMenuClose();
            } else if (typeof _this.props.closeMenuOnScroll === 'function') {
                if (_this.props.closeMenuOnScroll(event)) _this.props.onMenuClose();
            }
        };
        _this.onCompositionStart = function() {
            _this.isComposing = true;
        };
        _this.onCompositionEnd = function() {
            _this.isComposing = false;
        };
        _this.onTouchStart = function(_ref2) {
            var touches = _ref2.touches;
            var touch = touches && touches.item(0);
            if (!touch) return;
            _this.initialTouchX = touch.clientX;
            _this.initialTouchY = touch.clientY;
            _this.userIsDragging = false;
        };
        _this.onTouchMove = function(_ref3) {
            var touches = _ref3.touches;
            var touch = touches && touches.item(0);
            if (!touch) return;
            var deltaX = Math.abs(touch.clientX - _this.initialTouchX);
            var deltaY = Math.abs(touch.clientY - _this.initialTouchY);
            var moveThreshold = 5;
            _this.userIsDragging = deltaX > moveThreshold || deltaY > moveThreshold;
        };
        _this.onTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            // close the menu if the user taps outside
            // we're checking on event.target here instead of event.currentTarget, because we want to assert information
            // on events on child elements, not the document (which we've attached this handler to).
            if (_this.controlRef && !_this.controlRef.contains(event.target) && _this.menuListRef && !_this.menuListRef.contains(event.target)) _this.blurInput();
            // reset move vars
            _this.initialTouchX = 0;
            _this.initialTouchY = 0;
        };
        _this.onControlTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onControlMouseDown(event);
        };
        _this.onClearIndicatorTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onClearIndicatorMouseDown(event);
        };
        _this.onDropdownIndicatorTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onDropdownIndicatorMouseDown(event);
        };
        _this.handleInputChange = function(event) {
            var prevInputValue = _this.props.inputValue;
            var inputValue = event.currentTarget.value;
            _this.setState({
                inputIsHiddenAfterUpdate: false
            });
            _this.onInputChange(inputValue, {
                action: 'input-change',
                prevInputValue: prevInputValue
            });
            if (!_this.props.menuIsOpen) _this.onMenuOpen();
        };
        _this.onInputFocus = function(event) {
            if (_this.props.onFocus) _this.props.onFocus(event);
            _this.setState({
                inputIsHiddenAfterUpdate: false,
                isFocused: true
            });
            if (_this.openAfterFocus || _this.props.openMenuOnFocus) _this.openMenu('first');
            _this.openAfterFocus = false;
        };
        _this.onInputBlur = function(event) {
            var prevInputValue = _this.props.inputValue;
            if (_this.menuListRef && _this.menuListRef.contains(document.activeElement)) {
                _this.inputRef.focus();
                return;
            }
            if (_this.props.onBlur) _this.props.onBlur(event);
            _this.onInputChange('', {
                action: 'input-blur',
                prevInputValue: prevInputValue
            });
            _this.onMenuClose();
            _this.setState({
                focusedValue: null,
                isFocused: false
            });
        };
        _this.onOptionHover = function(focusedOption) {
            if (_this.blockOptionHover || _this.state.focusedOption === focusedOption) return;
            var options = _this.getFocusableOptions();
            var focusedOptionIndex = options.indexOf(focusedOption);
            _this.setState({
                focusedOption: focusedOption,
                focusedOptionId: focusedOptionIndex > -1 ? _this.getFocusedOptionId(focusedOption) : null
            });
        };
        _this.shouldHideSelectedOptions = function() {
            return $556ecd5f3b314fff$var$shouldHideSelectedOptions(_this.props);
        };
        _this.onValueInputFocus = function(e) {
            e.preventDefault();
            e.stopPropagation();
            _this.focus();
        };
        _this.onKeyDown = function(event) {
            var _this$props5 = _this.props, isMulti = _this$props5.isMulti, backspaceRemovesValue = _this$props5.backspaceRemovesValue, escapeClearsValue = _this$props5.escapeClearsValue, inputValue = _this$props5.inputValue, isClearable = _this$props5.isClearable, isDisabled = _this$props5.isDisabled, menuIsOpen = _this$props5.menuIsOpen, onKeyDown = _this$props5.onKeyDown, tabSelectsValue = _this$props5.tabSelectsValue, openMenuOnFocus = _this$props5.openMenuOnFocus;
            var _this$state = _this.state, focusedOption = _this$state.focusedOption, focusedValue = _this$state.focusedValue, selectValue = _this$state.selectValue;
            if (isDisabled) return;
            if (typeof onKeyDown === 'function') {
                onKeyDown(event);
                if (event.defaultPrevented) return;
            }
            // Block option hover events when the user has just pressed a key
            _this.blockOptionHover = true;
            switch(event.key){
                case 'ArrowLeft':
                    if (!isMulti || inputValue) return;
                    _this.focusValue('previous');
                    break;
                case 'ArrowRight':
                    if (!isMulti || inputValue) return;
                    _this.focusValue('next');
                    break;
                case 'Delete':
                case 'Backspace':
                    if (inputValue) return;
                    if (focusedValue) _this.removeValue(focusedValue);
                    else {
                        if (!backspaceRemovesValue) return;
                        if (isMulti) _this.popValue();
                        else if (isClearable) _this.clearValue();
                    }
                    break;
                case 'Tab':
                    if (_this.isComposing) return;
                    if (event.shiftKey || !menuIsOpen || !tabSelectsValue || !focusedOption || // don't capture the event if the menu opens on focus and the focused
                    // option is already selected; it breaks the flow of navigation
                    openMenuOnFocus && _this.isOptionSelected(focusedOption, selectValue)) return;
                    _this.selectOption(focusedOption);
                    break;
                case 'Enter':
                    if (event.keyCode === 229) break;
                    if (menuIsOpen) {
                        if (!focusedOption) return;
                        if (_this.isComposing) return;
                        _this.selectOption(focusedOption);
                        break;
                    }
                    return;
                case 'Escape':
                    if (menuIsOpen) {
                        _this.setState({
                            inputIsHiddenAfterUpdate: false
                        });
                        _this.onInputChange('', {
                            action: 'menu-close',
                            prevInputValue: inputValue
                        });
                        _this.onMenuClose();
                    } else if (isClearable && escapeClearsValue) _this.clearValue();
                    break;
                case ' ':
                    // space
                    if (inputValue) return;
                    if (!menuIsOpen) {
                        _this.openMenu('first');
                        break;
                    }
                    if (!focusedOption) return;
                    _this.selectOption(focusedOption);
                    break;
                case 'ArrowUp':
                    if (menuIsOpen) _this.focusOption('up');
                    else _this.openMenu('last');
                    break;
                case 'ArrowDown':
                    if (menuIsOpen) _this.focusOption('down');
                    else _this.openMenu('first');
                    break;
                case 'PageUp':
                    if (!menuIsOpen) return;
                    _this.focusOption('pageup');
                    break;
                case 'PageDown':
                    if (!menuIsOpen) return;
                    _this.focusOption('pagedown');
                    break;
                case 'Home':
                    if (!menuIsOpen) return;
                    _this.focusOption('first');
                    break;
                case 'End':
                    if (!menuIsOpen) return;
                    _this.focusOption('last');
                    break;
                default:
                    return;
            }
            event.preventDefault();
        };
        _this.state.instancePrefix = 'react-select-' + (_this.props.instanceId || ++$556ecd5f3b314fff$var$instanceId);
        _this.state.selectValue = (0, $a7ee0070c0e37770$export$7f8ddf7c7c20b3cd)(_props.value);
        // Set focusedOption if menuIsOpen is set on init (e.g. defaultMenuIsOpen)
        if (_props.menuIsOpen && _this.state.selectValue.length) {
            var focusableOptionsWithIds = _this.getFocusableOptionsWithIds();
            var focusableOptions = _this.buildFocusableOptions();
            var optionIndex = focusableOptions.indexOf(_this.state.selectValue[0]);
            _this.state.focusableOptionsWithIds = focusableOptionsWithIds;
            _this.state.focusedOption = focusableOptions[optionIndex];
            _this.state.focusedOptionId = $556ecd5f3b314fff$var$getFocusedOptionId(focusableOptionsWithIds, focusableOptions[optionIndex]);
        }
        return _this;
    }
    (0, $6f13d1f555b04ae4$export$2e2bcd8739ae039)(Select, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.startListeningComposition();
                this.startListeningToTouch();
                if (this.props.closeMenuOnScroll && document && document.addEventListener) // Listen to all scroll events, and filter them out inside of 'onScroll'
                document.addEventListener('scroll', this.onScroll, true);
                if (this.props.autoFocus) this.focusInput();
                // Scroll focusedOption into view if menuIsOpen is set on mount (e.g. defaultMenuIsOpen)
                if (this.props.menuIsOpen && this.state.focusedOption && this.menuListRef && this.focusedOptionRef) (0, $a7ee0070c0e37770$export$9bb611d729802a56)(this.menuListRef, this.focusedOptionRef);
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                var _this$props6 = this.props, isDisabled = _this$props6.isDisabled, menuIsOpen = _this$props6.menuIsOpen;
                var isFocused = this.state.isFocused;
                if (// ensure focus is restored correctly when the control becomes enabled
                isFocused && !isDisabled && prevProps.isDisabled || // ensure focus is on the Input when the menu opens
                isFocused && menuIsOpen && !prevProps.menuIsOpen) this.focusInput();
                if (isFocused && isDisabled && !prevProps.isDisabled) // ensure select state gets blurred in case Select is programmatically disabled while focused
                // eslint-disable-next-line react/no-did-update-set-state
                this.setState({
                    isFocused: false
                }, this.onMenuClose);
                else if (!isFocused && !isDisabled && prevProps.isDisabled && this.inputRef === document.activeElement) // ensure select state gets focused in case Select is programatically re-enabled while focused (Firefox)
                // eslint-disable-next-line react/no-did-update-set-state
                this.setState({
                    isFocused: true
                });
                // scroll the focused option into view if necessary
                if (this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate) {
                    (0, $a7ee0070c0e37770$export$9bb611d729802a56)(this.menuListRef, this.focusedOptionRef);
                    this.scrollToFocusedOptionOnUpdate = false;
                }
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.stopListeningComposition();
                this.stopListeningToTouch();
                document.removeEventListener('scroll', this.onScroll, true);
            }
        },
        {
            key: "onMenuOpen",
            value: function onMenuOpen() {
                this.props.onMenuOpen();
            }
        },
        {
            key: "onMenuClose",
            value: function onMenuClose() {
                this.onInputChange('', {
                    action: 'menu-close',
                    prevInputValue: this.props.inputValue
                });
                this.props.onMenuClose();
            }
        },
        {
            key: "onInputChange",
            value: function onInputChange(newValue, actionMeta) {
                this.props.onInputChange(newValue, actionMeta);
            }
        },
        {
            key: "focusInput",
            value: function focusInput() {
                if (!this.inputRef) return;
                this.inputRef.focus();
            }
        },
        {
            key: "blurInput",
            value: function blurInput() {
                if (!this.inputRef) return;
                this.inputRef.blur();
            }
        },
        {
            key: "openMenu",
            value: function openMenu(focusOption) {
                var _this2 = this;
                var _this$state2 = this.state, selectValue = _this$state2.selectValue, isFocused = _this$state2.isFocused;
                var focusableOptions = this.buildFocusableOptions();
                var openAtIndex = focusOption === 'first' ? 0 : focusableOptions.length - 1;
                if (!this.props.isMulti) {
                    var selectedIndex = focusableOptions.indexOf(selectValue[0]);
                    if (selectedIndex > -1) openAtIndex = selectedIndex;
                }
                // only scroll if the menu isn't already open
                this.scrollToFocusedOptionOnUpdate = !(isFocused && this.menuListRef);
                this.setState({
                    inputIsHiddenAfterUpdate: false,
                    focusedValue: null,
                    focusedOption: focusableOptions[openAtIndex],
                    focusedOptionId: this.getFocusedOptionId(focusableOptions[openAtIndex])
                }, function() {
                    return _this2.onMenuOpen();
                });
            }
        },
        {
            key: "focusValue",
            value: function focusValue(direction) {
                var _this$state3 = this.state, selectValue = _this$state3.selectValue, focusedValue = _this$state3.focusedValue;
                // Only multiselects support value focusing
                if (!this.props.isMulti) return;
                this.setState({
                    focusedOption: null
                });
                var focusedIndex = selectValue.indexOf(focusedValue);
                if (!focusedValue) focusedIndex = -1;
                var lastIndex = selectValue.length - 1;
                var nextFocus = -1;
                if (!selectValue.length) return;
                switch(direction){
                    case 'previous':
                        if (focusedIndex === 0) // don't cycle from the start to the end
                        nextFocus = 0;
                        else if (focusedIndex === -1) // if nothing is focused, focus the last value first
                        nextFocus = lastIndex;
                        else nextFocus = focusedIndex - 1;
                        break;
                    case 'next':
                        if (focusedIndex > -1 && focusedIndex < lastIndex) nextFocus = focusedIndex + 1;
                        break;
                }
                this.setState({
                    inputIsHidden: nextFocus !== -1,
                    focusedValue: selectValue[nextFocus]
                });
            }
        },
        {
            key: "focusOption",
            value: function focusOption() {
                var direction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'first';
                var pageSize = this.props.pageSize;
                var focusedOption = this.state.focusedOption;
                var options = this.getFocusableOptions();
                if (!options.length) return;
                var nextFocus = 0; // handles 'first'
                var focusedIndex = options.indexOf(focusedOption);
                if (!focusedOption) focusedIndex = -1;
                if (direction === 'up') nextFocus = focusedIndex > 0 ? focusedIndex - 1 : options.length - 1;
                else if (direction === 'down') nextFocus = (focusedIndex + 1) % options.length;
                else if (direction === 'pageup') {
                    nextFocus = focusedIndex - pageSize;
                    if (nextFocus < 0) nextFocus = 0;
                } else if (direction === 'pagedown') {
                    nextFocus = focusedIndex + pageSize;
                    if (nextFocus > options.length - 1) nextFocus = options.length - 1;
                } else if (direction === 'last') nextFocus = options.length - 1;
                this.scrollToFocusedOptionOnUpdate = true;
                this.setState({
                    focusedOption: options[nextFocus],
                    focusedValue: null,
                    focusedOptionId: this.getFocusedOptionId(options[nextFocus])
                });
            }
        },
        {
            key: "getTheme",
            value: // ==============================
            // Getters
            // ==============================
            function getTheme() {
                // Use the default theme if there are no customisations.
                if (!this.props.theme) return $556ecd5f3b314fff$export$4368d992c4eafac0;
                // If the theme prop is a function, assume the function
                // knows how to merge the passed-in default theme with
                // its own modifications.
                if (typeof this.props.theme === 'function') return this.props.theme($556ecd5f3b314fff$export$4368d992c4eafac0);
                // Otherwise, if a plain theme object was passed in,
                // overlay it with the default theme.
                return (0, $0c8ebbb95bc6bc2e$export$2e2bcd8739ae039)((0, $0c8ebbb95bc6bc2e$export$2e2bcd8739ae039)({}, $556ecd5f3b314fff$export$4368d992c4eafac0), this.props.theme);
            }
        },
        {
            key: "getCommonProps",
            value: function getCommonProps() {
                var clearValue = this.clearValue, cx = this.cx, getStyles = this.getStyles, getClassNames = this.getClassNames, getValue = this.getValue, selectOption = this.selectOption, setValue = this.setValue, props = this.props;
                var isMulti = props.isMulti, isRtl = props.isRtl, options = props.options;
                var hasValue = this.hasValue();
                return {
                    clearValue: clearValue,
                    cx: cx,
                    getStyles: getStyles,
                    getClassNames: getClassNames,
                    getValue: getValue,
                    hasValue: hasValue,
                    isMulti: isMulti,
                    isRtl: isRtl,
                    options: options,
                    selectOption: selectOption,
                    selectProps: props,
                    setValue: setValue,
                    theme: this.getTheme()
                };
            }
        },
        {
            key: "hasValue",
            value: function hasValue() {
                var selectValue = this.state.selectValue;
                return selectValue.length > 0;
            }
        },
        {
            key: "hasOptions",
            value: function hasOptions() {
                return !!this.getFocusableOptions().length;
            }
        },
        {
            key: "isClearable",
            value: function isClearable() {
                var _this$props7 = this.props, isClearable = _this$props7.isClearable, isMulti = _this$props7.isMulti;
                // single select, by default, IS NOT clearable
                // multi select, by default, IS clearable
                if (isClearable === undefined) return isMulti;
                return isClearable;
            }
        },
        {
            key: "isOptionDisabled",
            value: function isOptionDisabled(option, selectValue) {
                return $556ecd5f3b314fff$var$_isOptionDisabled(this.props, option, selectValue);
            }
        },
        {
            key: "isOptionSelected",
            value: function isOptionSelected(option, selectValue) {
                return $556ecd5f3b314fff$var$_isOptionSelected(this.props, option, selectValue);
            }
        },
        {
            key: "filterOption",
            value: function filterOption(option, inputValue) {
                return $556ecd5f3b314fff$var$_filterOption(this.props, option, inputValue);
            }
        },
        {
            key: "formatOptionLabel",
            value: function formatOptionLabel(data, context) {
                if (typeof this.props.formatOptionLabel === 'function') {
                    var _inputValue = this.props.inputValue;
                    var _selectValue = this.state.selectValue;
                    return this.props.formatOptionLabel(data, {
                        context: context,
                        inputValue: _inputValue,
                        selectValue: _selectValue
                    });
                } else return this.getOptionLabel(data);
            }
        },
        {
            key: "formatGroupLabel",
            value: function formatGroupLabel(data) {
                return this.props.formatGroupLabel(data);
            }
        },
        {
            key: "startListeningComposition",
            value: // ==============================
            // Composition Handlers
            // ==============================
            function startListeningComposition() {
                if (document && document.addEventListener) {
                    document.addEventListener('compositionstart', this.onCompositionStart, false);
                    document.addEventListener('compositionend', this.onCompositionEnd, false);
                }
            }
        },
        {
            key: "stopListeningComposition",
            value: function stopListeningComposition() {
                if (document && document.removeEventListener) {
                    document.removeEventListener('compositionstart', this.onCompositionStart);
                    document.removeEventListener('compositionend', this.onCompositionEnd);
                }
            }
        },
        {
            key: "startListeningToTouch",
            value: // ==============================
            // Touch Handlers
            // ==============================
            function startListeningToTouch() {
                if (document && document.addEventListener) {
                    document.addEventListener('touchstart', this.onTouchStart, false);
                    document.addEventListener('touchmove', this.onTouchMove, false);
                    document.addEventListener('touchend', this.onTouchEnd, false);
                }
            }
        },
        {
            key: "stopListeningToTouch",
            value: function stopListeningToTouch() {
                if (document && document.removeEventListener) {
                    document.removeEventListener('touchstart', this.onTouchStart);
                    document.removeEventListener('touchmove', this.onTouchMove);
                    document.removeEventListener('touchend', this.onTouchEnd);
                }
            }
        },
        {
            key: "renderInput",
            value: // ==============================
            // Renderers
            // ==============================
            function renderInput() {
                var _this$props8 = this.props, isDisabled = _this$props8.isDisabled, isSearchable = _this$props8.isSearchable, inputId = _this$props8.inputId, inputValue = _this$props8.inputValue, tabIndex = _this$props8.tabIndex, form = _this$props8.form, menuIsOpen = _this$props8.menuIsOpen, required = _this$props8.required;
                var _this$getComponents = this.getComponents(), Input = _this$getComponents.Input;
                var _this$state4 = this.state, inputIsHidden = _this$state4.inputIsHidden, ariaSelection = _this$state4.ariaSelection;
                var commonProps = this.commonProps;
                var id = inputId || this.getElementId('input');
                // aria attributes makes the JSX "noisy", separated for clarity
                var ariaAttributes = (0, $0c8ebbb95bc6bc2e$export$2e2bcd8739ae039)((0, $0c8ebbb95bc6bc2e$export$2e2bcd8739ae039)((0, $0c8ebbb95bc6bc2e$export$2e2bcd8739ae039)({
                    'aria-autocomplete': 'list',
                    'aria-expanded': menuIsOpen,
                    'aria-haspopup': true,
                    'aria-errormessage': this.props['aria-errormessage'],
                    'aria-invalid': this.props['aria-invalid'],
                    'aria-label': this.props['aria-label'],
                    'aria-labelledby': this.props['aria-labelledby'],
                    'aria-required': required,
                    role: 'combobox',
                    'aria-activedescendant': this.isAppleDevice ? undefined : this.state.focusedOptionId || ''
                }, menuIsOpen && {
                    'aria-controls': this.getElementId('listbox')
                }), !isSearchable && {
                    'aria-readonly': true
                }), this.hasValue() ? (ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === 'initial-input-focus' && {
                    'aria-describedby': this.getElementId('live-region')
                } : {
                    'aria-describedby': this.getElementId('placeholder')
                });
                if (!isSearchable) // use a dummy input to maintain focus/blur functionality
                return /*#__PURE__*/ $4Y8Vu.createElement($556ecd5f3b314fff$var$DummyInput, (0, $f3601d07f0ff7403$export$2e2bcd8739ae039)({
                    id: id,
                    innerRef: this.getInputRef,
                    onBlur: this.onInputBlur,
                    onChange: (0, $a7ee0070c0e37770$export$b4171a6734a65d42),
                    onFocus: this.onInputFocus,
                    disabled: isDisabled,
                    tabIndex: tabIndex,
                    inputMode: "none",
                    form: form,
                    value: ""
                }, ariaAttributes));
                return /*#__PURE__*/ $4Y8Vu.createElement(Input, (0, $f3601d07f0ff7403$export$2e2bcd8739ae039)({}, commonProps, {
                    autoCapitalize: "none",
                    autoComplete: "off",
                    autoCorrect: "off",
                    id: id,
                    innerRef: this.getInputRef,
                    isDisabled: isDisabled,
                    isHidden: inputIsHidden,
                    onBlur: this.onInputBlur,
                    onChange: this.handleInputChange,
                    onFocus: this.onInputFocus,
                    spellCheck: "false",
                    tabIndex: tabIndex,
                    form: form,
                    type: "text",
                    value: inputValue
                }, ariaAttributes));
            }
        },
        {
            key: "renderPlaceholderOrValue",
            value: function renderPlaceholderOrValue() {
                var _this3 = this;
                var _this$getComponents2 = this.getComponents(), MultiValue = _this$getComponents2.MultiValue, MultiValueContainer = _this$getComponents2.MultiValueContainer, MultiValueLabel = _this$getComponents2.MultiValueLabel, MultiValueRemove = _this$getComponents2.MultiValueRemove, SingleValue = _this$getComponents2.SingleValue, Placeholder = _this$getComponents2.Placeholder;
                var commonProps = this.commonProps;
                var _this$props9 = this.props, controlShouldRenderValue = _this$props9.controlShouldRenderValue, isDisabled = _this$props9.isDisabled, isMulti = _this$props9.isMulti, inputValue = _this$props9.inputValue, placeholder = _this$props9.placeholder;
                var _this$state5 = this.state, selectValue = _this$state5.selectValue, focusedValue = _this$state5.focusedValue, isFocused = _this$state5.isFocused;
                if (!this.hasValue() || !controlShouldRenderValue) return inputValue ? null : /*#__PURE__*/ $4Y8Vu.createElement(Placeholder, (0, $f3601d07f0ff7403$export$2e2bcd8739ae039)({}, commonProps, {
                    key: "placeholder",
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    innerProps: {
                        id: this.getElementId('placeholder')
                    }
                }), placeholder);
                if (isMulti) return selectValue.map(function(opt, index) {
                    var isOptionFocused = opt === focusedValue;
                    var key = "".concat(_this3.getOptionLabel(opt), "-").concat(_this3.getOptionValue(opt));
                    return /*#__PURE__*/ $4Y8Vu.createElement(MultiValue, (0, $f3601d07f0ff7403$export$2e2bcd8739ae039)({}, commonProps, {
                        components: {
                            Container: MultiValueContainer,
                            Label: MultiValueLabel,
                            Remove: MultiValueRemove
                        },
                        isFocused: isOptionFocused,
                        isDisabled: isDisabled,
                        key: key,
                        index: index,
                        removeProps: {
                            onClick: function onClick() {
                                return _this3.removeValue(opt);
                            },
                            onTouchEnd: function onTouchEnd() {
                                return _this3.removeValue(opt);
                            },
                            onMouseDown: function onMouseDown(e) {
                                e.preventDefault();
                            }
                        },
                        data: opt
                    }), _this3.formatOptionLabel(opt, 'value'));
                });
                if (inputValue) return null;
                var singleValue = selectValue[0];
                return /*#__PURE__*/ $4Y8Vu.createElement(SingleValue, (0, $f3601d07f0ff7403$export$2e2bcd8739ae039)({}, commonProps, {
                    data: singleValue,
                    isDisabled: isDisabled
                }), this.formatOptionLabel(singleValue, 'value'));
            }
        },
        {
            key: "renderClearIndicator",
            value: function renderClearIndicator() {
                var _this$getComponents3 = this.getComponents(), ClearIndicator = _this$getComponents3.ClearIndicator;
                var commonProps = this.commonProps;
                var _this$props10 = this.props, isDisabled = _this$props10.isDisabled, isLoading = _this$props10.isLoading;
                var isFocused = this.state.isFocused;
                if (!this.isClearable() || !ClearIndicator || isDisabled || !this.hasValue() || isLoading) return null;
                var innerProps = {
                    onMouseDown: this.onClearIndicatorMouseDown,
                    onTouchEnd: this.onClearIndicatorTouchEnd,
                    'aria-hidden': 'true'
                };
                return /*#__PURE__*/ $4Y8Vu.createElement(ClearIndicator, (0, $f3601d07f0ff7403$export$2e2bcd8739ae039)({}, commonProps, {
                    innerProps: innerProps,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderLoadingIndicator",
            value: function renderLoadingIndicator() {
                var _this$getComponents4 = this.getComponents(), LoadingIndicator = _this$getComponents4.LoadingIndicator;
                var commonProps = this.commonProps;
                var _this$props11 = this.props, isDisabled = _this$props11.isDisabled, isLoading = _this$props11.isLoading;
                var isFocused = this.state.isFocused;
                if (!LoadingIndicator || !isLoading) return null;
                var innerProps = {
                    'aria-hidden': 'true'
                };
                return /*#__PURE__*/ $4Y8Vu.createElement(LoadingIndicator, (0, $f3601d07f0ff7403$export$2e2bcd8739ae039)({}, commonProps, {
                    innerProps: innerProps,
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderIndicatorSeparator",
            value: function renderIndicatorSeparator() {
                var _this$getComponents5 = this.getComponents(), DropdownIndicator = _this$getComponents5.DropdownIndicator, IndicatorSeparator = _this$getComponents5.IndicatorSeparator;
                // separator doesn't make sense without the dropdown indicator
                if (!DropdownIndicator || !IndicatorSeparator) return null;
                var commonProps = this.commonProps;
                var isDisabled = this.props.isDisabled;
                var isFocused = this.state.isFocused;
                return /*#__PURE__*/ $4Y8Vu.createElement(IndicatorSeparator, (0, $f3601d07f0ff7403$export$2e2bcd8739ae039)({}, commonProps, {
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderDropdownIndicator",
            value: function renderDropdownIndicator() {
                var _this$getComponents6 = this.getComponents(), DropdownIndicator = _this$getComponents6.DropdownIndicator;
                if (!DropdownIndicator) return null;
                var commonProps = this.commonProps;
                var isDisabled = this.props.isDisabled;
                var isFocused = this.state.isFocused;
                var innerProps = {
                    onMouseDown: this.onDropdownIndicatorMouseDown,
                    onTouchEnd: this.onDropdownIndicatorTouchEnd,
                    'aria-hidden': 'true'
                };
                return /*#__PURE__*/ $4Y8Vu.createElement(DropdownIndicator, (0, $f3601d07f0ff7403$export$2e2bcd8739ae039)({}, commonProps, {
                    innerProps: innerProps,
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderMenu",
            value: function renderMenu() {
                var _this4 = this;
                var _this$getComponents7 = this.getComponents(), Group = _this$getComponents7.Group, GroupHeading = _this$getComponents7.GroupHeading, Menu = _this$getComponents7.Menu, MenuList = _this$getComponents7.MenuList, MenuPortal = _this$getComponents7.MenuPortal, LoadingMessage = _this$getComponents7.LoadingMessage, NoOptionsMessage = _this$getComponents7.NoOptionsMessage, Option = _this$getComponents7.Option;
                var commonProps = this.commonProps;
                var focusedOption = this.state.focusedOption;
                var _this$props12 = this.props, captureMenuScroll = _this$props12.captureMenuScroll, inputValue = _this$props12.inputValue, isLoading = _this$props12.isLoading, loadingMessage = _this$props12.loadingMessage, minMenuHeight = _this$props12.minMenuHeight, maxMenuHeight = _this$props12.maxMenuHeight, menuIsOpen = _this$props12.menuIsOpen, menuPlacement = _this$props12.menuPlacement, menuPosition = _this$props12.menuPosition, menuPortalTarget = _this$props12.menuPortalTarget, menuShouldBlockScroll = _this$props12.menuShouldBlockScroll, menuShouldScrollIntoView = _this$props12.menuShouldScrollIntoView, noOptionsMessage = _this$props12.noOptionsMessage, onMenuScrollToTop = _this$props12.onMenuScrollToTop, onMenuScrollToBottom = _this$props12.onMenuScrollToBottom;
                if (!menuIsOpen) return null;
                // TODO: Internal Option Type here
                var render = function render(props, id) {
                    var type = props.type, data = props.data, isDisabled = props.isDisabled, isSelected = props.isSelected, label = props.label, value = props.value;
                    var isFocused = focusedOption === data;
                    var onHover = isDisabled ? undefined : function() {
                        return _this4.onOptionHover(data);
                    };
                    var onSelect = isDisabled ? undefined : function() {
                        return _this4.selectOption(data);
                    };
                    var optionId = "".concat(_this4.getElementId('option'), "-").concat(id);
                    var innerProps = {
                        id: optionId,
                        onClick: onSelect,
                        onMouseMove: onHover,
                        onMouseOver: onHover,
                        tabIndex: -1,
                        role: 'option',
                        'aria-selected': _this4.isAppleDevice ? undefined : isSelected // is not supported on Apple devices
                    };
                    return /*#__PURE__*/ $4Y8Vu.createElement(Option, (0, $f3601d07f0ff7403$export$2e2bcd8739ae039)({}, commonProps, {
                        innerProps: innerProps,
                        data: data,
                        isDisabled: isDisabled,
                        isSelected: isSelected,
                        key: optionId,
                        label: label,
                        type: type,
                        value: value,
                        isFocused: isFocused,
                        innerRef: isFocused ? _this4.getFocusedOptionRef : undefined
                    }), _this4.formatOptionLabel(props.data, 'menu'));
                };
                var menuUI;
                if (this.hasOptions()) menuUI = this.getCategorizedOptions().map(function(item) {
                    if (item.type === 'group') {
                        var _data = item.data, options = item.options, groupIndex = item.index;
                        var groupId = "".concat(_this4.getElementId('group'), "-").concat(groupIndex);
                        var headingId = "".concat(groupId, "-heading");
                        return /*#__PURE__*/ $4Y8Vu.createElement(Group, (0, $f3601d07f0ff7403$export$2e2bcd8739ae039)({}, commonProps, {
                            key: groupId,
                            data: _data,
                            options: options,
                            Heading: GroupHeading,
                            headingProps: {
                                id: headingId,
                                data: item.data
                            },
                            label: _this4.formatGroupLabel(item.data)
                        }), item.options.map(function(option) {
                            return render(option, "".concat(groupIndex, "-").concat(option.index));
                        }));
                    } else if (item.type === 'option') return render(item, "".concat(item.index));
                });
                else if (isLoading) {
                    var message = loadingMessage({
                        inputValue: inputValue
                    });
                    if (message === null) return null;
                    menuUI = /*#__PURE__*/ $4Y8Vu.createElement(LoadingMessage, commonProps, message);
                } else {
                    var _message = noOptionsMessage({
                        inputValue: inputValue
                    });
                    if (_message === null) return null;
                    menuUI = /*#__PURE__*/ $4Y8Vu.createElement(NoOptionsMessage, commonProps, _message);
                }
                var menuPlacementProps = {
                    minMenuHeight: minMenuHeight,
                    maxMenuHeight: maxMenuHeight,
                    menuPlacement: menuPlacement,
                    menuPosition: menuPosition,
                    menuShouldScrollIntoView: menuShouldScrollIntoView
                };
                var menuElement = /*#__PURE__*/ $4Y8Vu.createElement((0, $a7ee0070c0e37770$export$3a1a48c8f6ef640e), (0, $f3601d07f0ff7403$export$2e2bcd8739ae039)({}, commonProps, menuPlacementProps), function(_ref4) {
                    var ref = _ref4.ref, _ref4$placerProps = _ref4.placerProps, placement = _ref4$placerProps.placement, maxHeight = _ref4$placerProps.maxHeight;
                    return /*#__PURE__*/ $4Y8Vu.createElement(Menu, (0, $f3601d07f0ff7403$export$2e2bcd8739ae039)({}, commonProps, menuPlacementProps, {
                        innerRef: ref,
                        innerProps: {
                            onMouseDown: _this4.onMenuMouseDown,
                            onMouseMove: _this4.onMenuMouseMove
                        },
                        isLoading: isLoading,
                        placement: placement
                    }), /*#__PURE__*/ $4Y8Vu.createElement($556ecd5f3b314fff$var$ScrollManager, {
                        captureEnabled: captureMenuScroll,
                        onTopArrive: onMenuScrollToTop,
                        onBottomArrive: onMenuScrollToBottom,
                        lockEnabled: menuShouldBlockScroll
                    }, function(scrollTargetRef) {
                        return /*#__PURE__*/ $4Y8Vu.createElement(MenuList, (0, $f3601d07f0ff7403$export$2e2bcd8739ae039)({}, commonProps, {
                            innerRef: function innerRef(instance) {
                                _this4.getMenuListRef(instance);
                                scrollTargetRef(instance);
                            },
                            innerProps: {
                                role: 'listbox',
                                'aria-multiselectable': commonProps.isMulti,
                                id: _this4.getElementId('listbox')
                            },
                            isLoading: isLoading,
                            maxHeight: maxHeight,
                            focusedOption: focusedOption
                        }), menuUI);
                    }));
                });
                // positioning behaviour is almost identical for portalled and fixed,
                // so we use the same component. the actual portalling logic is forked
                // within the component based on `menuPosition`
                return menuPortalTarget || menuPosition === 'fixed' ? /*#__PURE__*/ $4Y8Vu.createElement(MenuPortal, (0, $f3601d07f0ff7403$export$2e2bcd8739ae039)({}, commonProps, {
                    appendTo: menuPortalTarget,
                    controlElement: this.controlRef,
                    menuPlacement: menuPlacement,
                    menuPosition: menuPosition
                }), menuElement) : menuElement;
            }
        },
        {
            key: "renderFormField",
            value: function renderFormField() {
                var _this5 = this;
                var _this$props13 = this.props, delimiter = _this$props13.delimiter, isDisabled = _this$props13.isDisabled, isMulti = _this$props13.isMulti, name = _this$props13.name, required = _this$props13.required;
                var selectValue = this.state.selectValue;
                if (required && !this.hasValue() && !isDisabled) return /*#__PURE__*/ $4Y8Vu.createElement($556ecd5f3b314fff$var$RequiredInput$1, {
                    name: name,
                    onFocus: this.onValueInputFocus
                });
                if (!name || isDisabled) return;
                if (isMulti) {
                    if (delimiter) {
                        var value = selectValue.map(function(opt) {
                            return _this5.getOptionValue(opt);
                        }).join(delimiter);
                        return /*#__PURE__*/ $4Y8Vu.createElement("input", {
                            name: name,
                            type: "hidden",
                            value: value
                        });
                    } else {
                        var input = selectValue.length > 0 ? selectValue.map(function(opt, i) {
                            return /*#__PURE__*/ $4Y8Vu.createElement("input", {
                                key: "i-".concat(i),
                                name: name,
                                type: "hidden",
                                value: _this5.getOptionValue(opt)
                            });
                        }) : /*#__PURE__*/ $4Y8Vu.createElement("input", {
                            name: name,
                            type: "hidden",
                            value: ""
                        });
                        return /*#__PURE__*/ $4Y8Vu.createElement("div", null, input);
                    }
                } else {
                    var _value = selectValue[0] ? this.getOptionValue(selectValue[0]) : '';
                    return /*#__PURE__*/ $4Y8Vu.createElement("input", {
                        name: name,
                        type: "hidden",
                        value: _value
                    });
                }
            }
        },
        {
            key: "renderLiveRegion",
            value: function renderLiveRegion() {
                var commonProps = this.commonProps;
                var _this$state6 = this.state, ariaSelection = _this$state6.ariaSelection, focusedOption = _this$state6.focusedOption, focusedValue = _this$state6.focusedValue, isFocused = _this$state6.isFocused, selectValue = _this$state6.selectValue;
                var focusableOptions = this.getFocusableOptions();
                return /*#__PURE__*/ $4Y8Vu.createElement($556ecd5f3b314fff$var$LiveRegion$1, (0, $f3601d07f0ff7403$export$2e2bcd8739ae039)({}, commonProps, {
                    id: this.getElementId('live-region'),
                    ariaSelection: ariaSelection,
                    focusedOption: focusedOption,
                    focusedValue: focusedValue,
                    isFocused: isFocused,
                    selectValue: selectValue,
                    focusableOptions: focusableOptions,
                    isAppleDevice: this.isAppleDevice
                }));
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$getComponents8 = this.getComponents(), Control = _this$getComponents8.Control, IndicatorsContainer = _this$getComponents8.IndicatorsContainer, SelectContainer = _this$getComponents8.SelectContainer, ValueContainer = _this$getComponents8.ValueContainer;
                var _this$props14 = this.props, className = _this$props14.className, id = _this$props14.id, isDisabled = _this$props14.isDisabled, menuIsOpen = _this$props14.menuIsOpen;
                var isFocused = this.state.isFocused;
                var commonProps = this.commonProps = this.getCommonProps();
                return /*#__PURE__*/ $4Y8Vu.createElement(SelectContainer, (0, $f3601d07f0ff7403$export$2e2bcd8739ae039)({}, commonProps, {
                    className: className,
                    innerProps: {
                        id: id,
                        onKeyDown: this.onKeyDown
                    },
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }), this.renderLiveRegion(), /*#__PURE__*/ $4Y8Vu.createElement(Control, (0, $f3601d07f0ff7403$export$2e2bcd8739ae039)({}, commonProps, {
                    innerRef: this.getControlRef,
                    innerProps: {
                        onMouseDown: this.onControlMouseDown,
                        onTouchEnd: this.onControlTouchEnd
                    },
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    menuIsOpen: menuIsOpen
                }), /*#__PURE__*/ $4Y8Vu.createElement(ValueContainer, (0, $f3601d07f0ff7403$export$2e2bcd8739ae039)({}, commonProps, {
                    isDisabled: isDisabled
                }), this.renderPlaceholderOrValue(), this.renderInput()), /*#__PURE__*/ $4Y8Vu.createElement(IndicatorsContainer, (0, $f3601d07f0ff7403$export$2e2bcd8739ae039)({}, commonProps, {
                    isDisabled: isDisabled
                }), this.renderClearIndicator(), this.renderLoadingIndicator(), this.renderIndicatorSeparator(), this.renderDropdownIndicator())), this.renderMenu(), this.renderFormField());
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(props, state) {
                var prevProps = state.prevProps, clearFocusValueOnUpdate = state.clearFocusValueOnUpdate, inputIsHiddenAfterUpdate = state.inputIsHiddenAfterUpdate, ariaSelection = state.ariaSelection, isFocused = state.isFocused, prevWasFocused = state.prevWasFocused, instancePrefix = state.instancePrefix;
                var options = props.options, value = props.value, menuIsOpen = props.menuIsOpen, inputValue = props.inputValue, isMulti = props.isMulti;
                var selectValue = (0, $a7ee0070c0e37770$export$7f8ddf7c7c20b3cd)(value);
                var newMenuOptionsState = {};
                if (prevProps && (value !== prevProps.value || options !== prevProps.options || menuIsOpen !== prevProps.menuIsOpen || inputValue !== prevProps.inputValue)) {
                    var focusableOptions = menuIsOpen ? $556ecd5f3b314fff$var$buildFocusableOptions(props, selectValue) : [];
                    var focusableOptionsWithIds = menuIsOpen ? $556ecd5f3b314fff$var$buildFocusableOptionsWithIds($556ecd5f3b314fff$var$buildCategorizedOptions(props, selectValue), "".concat(instancePrefix, "-option")) : [];
                    var focusedValue = clearFocusValueOnUpdate ? $556ecd5f3b314fff$var$getNextFocusedValue(state, selectValue) : null;
                    var focusedOption = $556ecd5f3b314fff$var$getNextFocusedOption(state, focusableOptions);
                    var focusedOptionId = $556ecd5f3b314fff$var$getFocusedOptionId(focusableOptionsWithIds, focusedOption);
                    newMenuOptionsState = {
                        selectValue: selectValue,
                        focusedOption: focusedOption,
                        focusedOptionId: focusedOptionId,
                        focusableOptionsWithIds: focusableOptionsWithIds,
                        focusedValue: focusedValue,
                        clearFocusValueOnUpdate: false
                    };
                }
                // some updates should toggle the state of the input visibility
                var newInputIsHiddenState = inputIsHiddenAfterUpdate != null && props !== prevProps ? {
                    inputIsHidden: inputIsHiddenAfterUpdate,
                    inputIsHiddenAfterUpdate: undefined
                } : {};
                var newAriaSelection = ariaSelection;
                var hasKeptFocus = isFocused && prevWasFocused;
                if (isFocused && !hasKeptFocus) {
                    // If `value` or `defaultValue` props are not empty then announce them
                    // when the Select is initially focused
                    newAriaSelection = {
                        value: (0, $a7ee0070c0e37770$export$96f57966bedc81b4)(isMulti, selectValue, selectValue[0] || null),
                        options: selectValue,
                        action: 'initial-input-focus'
                    };
                    hasKeptFocus = !prevWasFocused;
                }
                // If the 'initial-input-focus' action has been set already
                // then reset the ariaSelection to null
                if ((ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === 'initial-input-focus') newAriaSelection = null;
                return (0, $0c8ebbb95bc6bc2e$export$2e2bcd8739ae039)((0, $0c8ebbb95bc6bc2e$export$2e2bcd8739ae039)((0, $0c8ebbb95bc6bc2e$export$2e2bcd8739ae039)({}, newMenuOptionsState), newInputIsHiddenState), {}, {
                    prevProps: props,
                    ariaSelection: newAriaSelection,
                    prevWasFocused: hasKeptFocus
                });
            }
        }
    ]);
    return Select;
}((0, $4Y8Vu.Component));
$556ecd5f3b314fff$export$25ce5a424b770e84.defaultProps = $556ecd5f3b314fff$export$407448d2b89b1813;





var $db84523f45a179cb$exports = {};
var $fa3c0c280869a8cd$exports = {};
var $c4757970c464e3b6$exports = {};
var $5af9c364f35c1696$exports = {};
function $5af9c364f35c1696$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $5af9c364f35c1696$exports = $5af9c364f35c1696$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $5af9c364f35c1696$exports.__esModule = true, $5af9c364f35c1696$exports["default"] = $5af9c364f35c1696$exports, $5af9c364f35c1696$var$_typeof(o);
}
$5af9c364f35c1696$exports = $5af9c364f35c1696$var$_typeof, $5af9c364f35c1696$exports.__esModule = true, $5af9c364f35c1696$exports["default"] = $5af9c364f35c1696$exports;


var $c4757970c464e3b6$var$_typeof = $5af9c364f35c1696$exports.default;
var $54613acbc933c3ed$exports = {};

var $54613acbc933c3ed$var$_typeof = $5af9c364f35c1696$exports.default;
function $54613acbc933c3ed$var$toPrimitive(t, r) {
    if ("object" != $54613acbc933c3ed$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $54613acbc933c3ed$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
$54613acbc933c3ed$exports = $54613acbc933c3ed$var$toPrimitive, $54613acbc933c3ed$exports.__esModule = true, $54613acbc933c3ed$exports["default"] = $54613acbc933c3ed$exports;


function $c4757970c464e3b6$var$toPropertyKey(t) {
    var i = $54613acbc933c3ed$exports(t, "string");
    return "symbol" == $c4757970c464e3b6$var$_typeof(i) ? i : i + "";
}
$c4757970c464e3b6$exports = $c4757970c464e3b6$var$toPropertyKey, $c4757970c464e3b6$exports.__esModule = true, $c4757970c464e3b6$exports["default"] = $c4757970c464e3b6$exports;


function $fa3c0c280869a8cd$var$_defineProperty(e, r, t) {
    return (r = $c4757970c464e3b6$exports(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
$fa3c0c280869a8cd$exports = $fa3c0c280869a8cd$var$_defineProperty, $fa3c0c280869a8cd$exports.__esModule = true, $fa3c0c280869a8cd$exports["default"] = $fa3c0c280869a8cd$exports;


function $db84523f45a179cb$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $db84523f45a179cb$var$_objectSpread2(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $db84523f45a179cb$var$ownKeys(Object(t), !0).forEach(function(r) {
            $fa3c0c280869a8cd$exports(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $db84523f45a179cb$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
$db84523f45a179cb$exports = $db84523f45a179cb$var$_objectSpread2, $db84523f45a179cb$exports.__esModule = true, $db84523f45a179cb$exports["default"] = $db84523f45a179cb$exports;


var $ef6efb6e9710c2ca$exports = {};
var $1f335d2fc607af70$exports = {};
function $1f335d2fc607af70$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
$1f335d2fc607af70$exports = $1f335d2fc607af70$var$_arrayWithHoles, $1f335d2fc607af70$exports.__esModule = true, $1f335d2fc607af70$exports["default"] = $1f335d2fc607af70$exports;


var $1bc839a394a2537b$exports = {};
function $1bc839a394a2537b$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
$1bc839a394a2537b$exports = $1bc839a394a2537b$var$_iterableToArrayLimit, $1bc839a394a2537b$exports.__esModule = true, $1bc839a394a2537b$exports["default"] = $1bc839a394a2537b$exports;


var $462aee54e9d2a4a9$exports = {};
var $b6038c56e450848a$exports = {};
function $b6038c56e450848a$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
$b6038c56e450848a$exports = $b6038c56e450848a$var$_arrayLikeToArray, $b6038c56e450848a$exports.__esModule = true, $b6038c56e450848a$exports["default"] = $b6038c56e450848a$exports;


function $462aee54e9d2a4a9$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $b6038c56e450848a$exports(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $b6038c56e450848a$exports(r, a) : void 0;
    }
}
$462aee54e9d2a4a9$exports = $462aee54e9d2a4a9$var$_unsupportedIterableToArray, $462aee54e9d2a4a9$exports.__esModule = true, $462aee54e9d2a4a9$exports["default"] = $462aee54e9d2a4a9$exports;


var $89c177c449337712$exports = {};
function $89c177c449337712$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
$89c177c449337712$exports = $89c177c449337712$var$_nonIterableRest, $89c177c449337712$exports.__esModule = true, $89c177c449337712$exports["default"] = $89c177c449337712$exports;


function $ef6efb6e9710c2ca$var$_slicedToArray(r, e) {
    return $1f335d2fc607af70$exports(r) || $1bc839a394a2537b$exports(r, e) || $462aee54e9d2a4a9$exports(r, e) || $89c177c449337712$exports();
}
$ef6efb6e9710c2ca$exports = $ef6efb6e9710c2ca$var$_slicedToArray, $ef6efb6e9710c2ca$exports.__esModule = true, $ef6efb6e9710c2ca$exports["default"] = $ef6efb6e9710c2ca$exports;


var $cd64e4d2887f1c17$exports = {};
var $f53afe2fa313c105$exports = {};
function $f53afe2fa313c105$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
$f53afe2fa313c105$exports = $f53afe2fa313c105$var$_objectWithoutPropertiesLoose, $f53afe2fa313c105$exports.__esModule = true, $f53afe2fa313c105$exports["default"] = $f53afe2fa313c105$exports;


function $cd64e4d2887f1c17$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $f53afe2fa313c105$exports(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
$cd64e4d2887f1c17$exports = $cd64e4d2887f1c17$var$_objectWithoutProperties, $cd64e4d2887f1c17$exports.__esModule = true, $cd64e4d2887f1c17$exports["default"] = $cd64e4d2887f1c17$exports;


var $49c55903fe944e2e$exports = {};
function $49c55903fe944e2e$var$_classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
$49c55903fe944e2e$exports = $49c55903fe944e2e$var$_classCallCheck, $49c55903fe944e2e$exports.__esModule = true, $49c55903fe944e2e$exports["default"] = $49c55903fe944e2e$exports;


var $92abd063b6619eeb$exports = {};

function $92abd063b6619eeb$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, $c4757970c464e3b6$exports(o.key), o);
    }
}
function $92abd063b6619eeb$var$_createClass(e, r, t) {
    return r && $92abd063b6619eeb$var$_defineProperties(e.prototype, r), t && $92abd063b6619eeb$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
$92abd063b6619eeb$exports = $92abd063b6619eeb$var$_createClass, $92abd063b6619eeb$exports.__esModule = true, $92abd063b6619eeb$exports["default"] = $92abd063b6619eeb$exports;


var $9ef12d2032544b2e$exports = {};
var $00c59f8343864dd6$exports = {};
function $00c59f8343864dd6$var$_setPrototypeOf(t, e) {
    return $00c59f8343864dd6$exports = $00c59f8343864dd6$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $00c59f8343864dd6$exports.__esModule = true, $00c59f8343864dd6$exports["default"] = $00c59f8343864dd6$exports, $00c59f8343864dd6$var$_setPrototypeOf(t, e);
}
$00c59f8343864dd6$exports = $00c59f8343864dd6$var$_setPrototypeOf, $00c59f8343864dd6$exports.__esModule = true, $00c59f8343864dd6$exports["default"] = $00c59f8343864dd6$exports;


function $9ef12d2032544b2e$var$_inherits(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && $00c59f8343864dd6$exports(t, e);
}
$9ef12d2032544b2e$exports = $9ef12d2032544b2e$var$_inherits, $9ef12d2032544b2e$exports.__esModule = true, $9ef12d2032544b2e$exports["default"] = $9ef12d2032544b2e$exports;


var $97cdde27b9d96431$exports = {};
var $2921493eb354d654$exports = {};
function $2921493eb354d654$var$_getPrototypeOf(t) {
    return $2921493eb354d654$exports = $2921493eb354d654$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, $2921493eb354d654$exports.__esModule = true, $2921493eb354d654$exports["default"] = $2921493eb354d654$exports, $2921493eb354d654$var$_getPrototypeOf(t);
}
$2921493eb354d654$exports = $2921493eb354d654$var$_getPrototypeOf, $2921493eb354d654$exports.__esModule = true, $2921493eb354d654$exports["default"] = $2921493eb354d654$exports;


var $2df25253e8e05466$exports = {};
function $2df25253e8e05466$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($2df25253e8e05466$exports = $2df25253e8e05466$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    }, $2df25253e8e05466$exports.__esModule = true, $2df25253e8e05466$exports["default"] = $2df25253e8e05466$exports)();
}
$2df25253e8e05466$exports = $2df25253e8e05466$var$_isNativeReflectConstruct, $2df25253e8e05466$exports.__esModule = true, $2df25253e8e05466$exports["default"] = $2df25253e8e05466$exports;


var $be2a414d3fb2cd0f$exports = {};

var $be2a414d3fb2cd0f$var$_typeof = $5af9c364f35c1696$exports.default;
var $36a930aefcc8803a$exports = {};
function $36a930aefcc8803a$var$_assertThisInitialized(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}
$36a930aefcc8803a$exports = $36a930aefcc8803a$var$_assertThisInitialized, $36a930aefcc8803a$exports.__esModule = true, $36a930aefcc8803a$exports["default"] = $36a930aefcc8803a$exports;


function $be2a414d3fb2cd0f$var$_possibleConstructorReturn(t, e) {
    if (e && ("object" == $be2a414d3fb2cd0f$var$_typeof(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return $36a930aefcc8803a$exports(t);
}
$be2a414d3fb2cd0f$exports = $be2a414d3fb2cd0f$var$_possibleConstructorReturn, $be2a414d3fb2cd0f$exports.__esModule = true, $be2a414d3fb2cd0f$exports["default"] = $be2a414d3fb2cd0f$exports;


function $97cdde27b9d96431$var$_createSuper(t) {
    var r = $2df25253e8e05466$exports();
    return function() {
        var e, o = $2921493eb354d654$exports(t);
        if (r) {
            var s = $2921493eb354d654$exports(this).constructor;
            e = Reflect.construct(o, arguments, s);
        } else e = o.apply(this, arguments);
        return $be2a414d3fb2cd0f$exports(this, e);
    };
}
$97cdde27b9d96431$exports = $97cdde27b9d96431$var$_createSuper, $97cdde27b9d96431$exports.__esModule = true, $97cdde27b9d96431$exports["default"] = $97cdde27b9d96431$exports;


var $332df0b366cca29e$exports = {};
var $68333b5295b6f198$exports = {};

function $68333b5295b6f198$var$_arrayWithoutHoles(r) {
    if (Array.isArray(r)) return $b6038c56e450848a$exports(r);
}
$68333b5295b6f198$exports = $68333b5295b6f198$var$_arrayWithoutHoles, $68333b5295b6f198$exports.__esModule = true, $68333b5295b6f198$exports["default"] = $68333b5295b6f198$exports;


var $3fc2ebffd98279a6$exports = {};
function $3fc2ebffd98279a6$var$_iterableToArray(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
$3fc2ebffd98279a6$exports = $3fc2ebffd98279a6$var$_iterableToArray, $3fc2ebffd98279a6$exports.__esModule = true, $3fc2ebffd98279a6$exports["default"] = $3fc2ebffd98279a6$exports;



var $8f4edf824e6b612b$exports = {};
function $8f4edf824e6b612b$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
$8f4edf824e6b612b$exports = $8f4edf824e6b612b$var$_nonIterableSpread, $8f4edf824e6b612b$exports.__esModule = true, $8f4edf824e6b612b$exports["default"] = $8f4edf824e6b612b$exports;


function $332df0b366cca29e$var$_toConsumableArray(r) {
    return $68333b5295b6f198$exports(r) || $3fc2ebffd98279a6$exports(r) || $462aee54e9d2a4a9$exports(r) || $8f4edf824e6b612b$exports();
}
$332df0b366cca29e$exports = $332df0b366cca29e$var$_toConsumableArray, $332df0b366cca29e$exports.__esModule = true, $332df0b366cca29e$exports["default"] = $332df0b366cca29e$exports;




var $bcbd84fd27c98318$exports = {};
function $bcbd84fd27c98318$var$_taggedTemplateLiteral(e, t) {
    return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
        raw: {
            value: Object.freeze(t)
        }
    }));
}
$bcbd84fd27c98318$exports = $bcbd84fd27c98318$var$_taggedTemplateLiteral, $bcbd84fd27c98318$exports.__esModule = true, $bcbd84fd27c98318$exports["default"] = $bcbd84fd27c98318$exports;






var $93806ea81e977dc9$var$StateManagedSelect = /*#__PURE__*/ (0, $4Y8Vu.forwardRef)(function(props, ref) {
    var baseSelectProps = (0, $877df46b331c347f$export$3b14a55fb2447963)(props);
    return /*#__PURE__*/ $4Y8Vu.createElement((0, $556ecd5f3b314fff$export$25ce5a424b770e84), (0, $f3601d07f0ff7403$export$2e2bcd8739ae039)({
        ref: ref
    }, baseSelectProps));
});
var $93806ea81e977dc9$export$2e2bcd8739ae039 = $93806ea81e977dc9$var$StateManagedSelect;
var $93806ea81e977dc9$export$a7deb1594c5ce10e = function(_ref) {
    var nonce = _ref.nonce, children = _ref.children, cacheKey = _ref.cacheKey;
    var emotionCache = (0, $4Y8Vu.useMemo)(function() {
        return (0, $067aee9d91b68cb5$export$2e2bcd8739ae039)({
            key: cacheKey,
            nonce: nonce
        });
    }, [
        cacheKey,
        nonce
    ]);
    return /*#__PURE__*/ $4Y8Vu.createElement((0, $7356e5b7b0984477$export$e7094788287c5e9b), {
        value: emotionCache
    }, children);
};






var $ef75e4dd58e14509$var$safeIsNaN = Number.isNaN || function ponyfill(value) {
    return typeof value === 'number' && value !== value;
};
function $ef75e4dd58e14509$var$isEqual(first, second) {
    if (first === second) return true;
    if ($ef75e4dd58e14509$var$safeIsNaN(first) && $ef75e4dd58e14509$var$safeIsNaN(second)) return true;
    return false;
}
function $ef75e4dd58e14509$var$areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) return false;
    for(var i = 0; i < newInputs.length; i++){
        if (!$ef75e4dd58e14509$var$isEqual(newInputs[i], lastInputs[i])) return false;
    }
    return true;
}
function $ef75e4dd58e14509$var$memoizeOne(resultFn, isEqual) {
    if (isEqual === void 0) isEqual = $ef75e4dd58e14509$var$areInputsEqual;
    var lastThis;
    var lastArgs = [];
    var lastResult;
    var calledOnce = false;
    function memoized() {
        var newArgs = [];
        for(var _i = 0; _i < arguments.length; _i++)newArgs[_i] = arguments[_i];
        if (calledOnce && lastThis === this && isEqual(newArgs, lastArgs)) return lastResult;
        lastResult = resultFn.apply(this, newArgs);
        calledOnce = true;
        lastThis = this;
        lastArgs = newArgs;
        return lastResult;
    }
    return memoized;
}
var $ef75e4dd58e14509$export$2e2bcd8739ae039 = $ef75e4dd58e14509$var$memoizeOne;



var $4Y8Vu = parcelRequire("4Y8Vu");

// Animation frame based implementation of setTimeout.
// Inspired by Joe Lambert, https://gist.github.com/joelambert/1002116#file-requesttimeout-js
var $937657a3f91652b2$var$hasNativePerformanceNow = typeof performance === 'object' && typeof performance.now === 'function';
var $937657a3f91652b2$var$now = $937657a3f91652b2$var$hasNativePerformanceNow ? function() {
    return performance.now();
} : function() {
    return Date.now();
};
function $937657a3f91652b2$var$cancelTimeout(timeoutID) {
    cancelAnimationFrame(timeoutID.id);
}
function $937657a3f91652b2$var$requestTimeout(callback, delay) {
    var start = $937657a3f91652b2$var$now();
    function tick() {
        if ($937657a3f91652b2$var$now() - start >= delay) callback.call(null);
        else timeoutID.id = requestAnimationFrame(tick);
    }
    var timeoutID = {
        id: requestAnimationFrame(tick)
    };
    return timeoutID;
}
var $937657a3f91652b2$var$size = -1; // This utility copied from "dom-helpers" package.
function $937657a3f91652b2$var$getScrollbarSize(recalculate) {
    if (recalculate === void 0) recalculate = false;
    if ($937657a3f91652b2$var$size === -1 || recalculate) {
        var div = document.createElement('div');
        var style = div.style;
        style.width = '50px';
        style.height = '50px';
        style.overflow = 'scroll';
        document.body.appendChild(div);
        $937657a3f91652b2$var$size = div.offsetWidth - div.clientWidth;
        document.body.removeChild(div);
    }
    return $937657a3f91652b2$var$size;
}
var $937657a3f91652b2$var$cachedRTLResult = null; // TRICKY According to the spec, scrollLeft should be negative for RTL aligned elements.
// Chrome does not seem to adhere; its scrollLeft values are positive (measured relative to the left).
// Safari's elastic bounce makes detecting this even more complicated wrt potential false positives.
// The safest way to check this is to intentionally set a negative offset,
// and then verify that the subsequent "scroll" event matches the negative offset.
// If it does not match, then we can assume a non-standard RTL scroll implementation.
function $937657a3f91652b2$var$getRTLOffsetType(recalculate) {
    if (recalculate === void 0) recalculate = false;
    if ($937657a3f91652b2$var$cachedRTLResult === null || recalculate) {
        var outerDiv = document.createElement('div');
        var outerStyle = outerDiv.style;
        outerStyle.width = '50px';
        outerStyle.height = '50px';
        outerStyle.overflow = 'scroll';
        outerStyle.direction = 'rtl';
        var innerDiv = document.createElement('div');
        var innerStyle = innerDiv.style;
        innerStyle.width = '100px';
        innerStyle.height = '100px';
        outerDiv.appendChild(innerDiv);
        document.body.appendChild(outerDiv);
        if (outerDiv.scrollLeft > 0) $937657a3f91652b2$var$cachedRTLResult = 'positive-descending';
        else {
            outerDiv.scrollLeft = 1;
            if (outerDiv.scrollLeft === 0) $937657a3f91652b2$var$cachedRTLResult = 'negative';
            else $937657a3f91652b2$var$cachedRTLResult = 'positive-ascending';
        }
        document.body.removeChild(outerDiv);
        return $937657a3f91652b2$var$cachedRTLResult;
    }
    return $937657a3f91652b2$var$cachedRTLResult;
}
var $937657a3f91652b2$var$IS_SCROLLING_DEBOUNCE_INTERVAL = 150;
var $937657a3f91652b2$var$defaultItemKey = function defaultItemKey(_ref) {
    var columnIndex = _ref.columnIndex, data = _ref.data, rowIndex = _ref.rowIndex;
    return rowIndex + ":" + columnIndex;
}; // In DEV mode, this Set helps us only log a warning once per component instance.
// This avoids spamming the console every time a render happens.
var $937657a3f91652b2$var$devWarningsOverscanCount = null;
var $937657a3f91652b2$var$devWarningsOverscanRowsColumnsCount = null;
var $937657a3f91652b2$var$devWarningsTagName = null;
function $937657a3f91652b2$var$createGridComponent(_ref2) {
    var _class;
    var getColumnOffset = _ref2.getColumnOffset, getColumnStartIndexForOffset = _ref2.getColumnStartIndexForOffset, getColumnStopIndexForStartIndex = _ref2.getColumnStopIndexForStartIndex, getColumnWidth = _ref2.getColumnWidth, getEstimatedTotalHeight = _ref2.getEstimatedTotalHeight, getEstimatedTotalWidth = _ref2.getEstimatedTotalWidth, getOffsetForColumnAndAlignment = _ref2.getOffsetForColumnAndAlignment, getOffsetForRowAndAlignment = _ref2.getOffsetForRowAndAlignment, getRowHeight = _ref2.getRowHeight, getRowOffset = _ref2.getRowOffset, getRowStartIndexForOffset = _ref2.getRowStartIndexForOffset, getRowStopIndexForStartIndex = _ref2.getRowStopIndexForStartIndex, initInstanceProps = _ref2.initInstanceProps, shouldResetStyleCacheOnItemSizeChange = _ref2.shouldResetStyleCacheOnItemSizeChange, validateProps = _ref2.validateProps;
    return _class = /*#__PURE__*/ function(_PureComponent) {
        (0, $4708a8791a55a98c$export$2e2bcd8739ae039)(Grid, _PureComponent);
        // Always use explicit constructor for React components.
        // It produces less code after transpilation. (#26)
        // eslint-disable-next-line no-useless-constructor
        function Grid(props) {
            var _this;
            _this = _PureComponent.call(this, props) || this;
            _this._instanceProps = initInstanceProps(_this.props, (0, $62bd62033e65cf67$export$2e2bcd8739ae039)(_this));
            _this._resetIsScrollingTimeoutId = null;
            _this._outerRef = void 0;
            _this.state = {
                instance: (0, $62bd62033e65cf67$export$2e2bcd8739ae039)(_this),
                isScrolling: false,
                horizontalScrollDirection: 'forward',
                scrollLeft: typeof _this.props.initialScrollLeft === 'number' ? _this.props.initialScrollLeft : 0,
                scrollTop: typeof _this.props.initialScrollTop === 'number' ? _this.props.initialScrollTop : 0,
                scrollUpdateWasRequested: false,
                verticalScrollDirection: 'forward'
            };
            _this._callOnItemsRendered = void 0;
            _this._callOnItemsRendered = (0, $ef75e4dd58e14509$export$2e2bcd8739ae039)(function(overscanColumnStartIndex, overscanColumnStopIndex, overscanRowStartIndex, overscanRowStopIndex, visibleColumnStartIndex, visibleColumnStopIndex, visibleRowStartIndex, visibleRowStopIndex) {
                return _this.props.onItemsRendered({
                    overscanColumnStartIndex: overscanColumnStartIndex,
                    overscanColumnStopIndex: overscanColumnStopIndex,
                    overscanRowStartIndex: overscanRowStartIndex,
                    overscanRowStopIndex: overscanRowStopIndex,
                    visibleColumnStartIndex: visibleColumnStartIndex,
                    visibleColumnStopIndex: visibleColumnStopIndex,
                    visibleRowStartIndex: visibleRowStartIndex,
                    visibleRowStopIndex: visibleRowStopIndex
                });
            });
            _this._callOnScroll = void 0;
            _this._callOnScroll = (0, $ef75e4dd58e14509$export$2e2bcd8739ae039)(function(scrollLeft, scrollTop, horizontalScrollDirection, verticalScrollDirection, scrollUpdateWasRequested) {
                return _this.props.onScroll({
                    horizontalScrollDirection: horizontalScrollDirection,
                    scrollLeft: scrollLeft,
                    scrollTop: scrollTop,
                    verticalScrollDirection: verticalScrollDirection,
                    scrollUpdateWasRequested: scrollUpdateWasRequested
                });
            });
            _this._getItemStyle = void 0;
            _this._getItemStyle = function(rowIndex, columnIndex) {
                var _this$props = _this.props, columnWidth = _this$props.columnWidth, direction = _this$props.direction, rowHeight = _this$props.rowHeight;
                var itemStyleCache = _this._getItemStyleCache(shouldResetStyleCacheOnItemSizeChange && columnWidth, shouldResetStyleCacheOnItemSizeChange && direction, shouldResetStyleCacheOnItemSizeChange && rowHeight);
                var key = rowIndex + ":" + columnIndex;
                var style;
                if (itemStyleCache.hasOwnProperty(key)) style = itemStyleCache[key];
                else {
                    var _offset = getColumnOffset(_this.props, columnIndex, _this._instanceProps);
                    var isRtl = direction === 'rtl';
                    itemStyleCache[key] = style = {
                        position: 'absolute',
                        left: isRtl ? undefined : _offset,
                        right: isRtl ? _offset : undefined,
                        top: getRowOffset(_this.props, rowIndex, _this._instanceProps),
                        height: getRowHeight(_this.props, rowIndex, _this._instanceProps),
                        width: getColumnWidth(_this.props, columnIndex, _this._instanceProps)
                    };
                }
                return style;
            };
            _this._getItemStyleCache = void 0;
            _this._getItemStyleCache = (0, $ef75e4dd58e14509$export$2e2bcd8739ae039)(function(_, __, ___) {
                return {};
            });
            _this._onScroll = function(event) {
                var _event$currentTarget = event.currentTarget, clientHeight = _event$currentTarget.clientHeight, clientWidth = _event$currentTarget.clientWidth, scrollLeft = _event$currentTarget.scrollLeft, scrollTop = _event$currentTarget.scrollTop, scrollHeight = _event$currentTarget.scrollHeight, scrollWidth = _event$currentTarget.scrollWidth;
                _this.setState(function(prevState) {
                    if (prevState.scrollLeft === scrollLeft && prevState.scrollTop === scrollTop) // Scroll position may have been updated by cDM/cDU,
                    // In which case we don't need to trigger another render,
                    // And we don't want to update state.isScrolling.
                    return null;
                    var direction = _this.props.direction; // TRICKY According to the spec, scrollLeft should be negative for RTL aligned elements.
                    // This is not the case for all browsers though (e.g. Chrome reports values as positive, measured relative to the left).
                    // It's also easier for this component if we convert offsets to the same format as they would be in for ltr.
                    // So the simplest solution is to determine which browser behavior we're dealing with, and convert based on it.
                    var calculatedScrollLeft = scrollLeft;
                    if (direction === 'rtl') switch($937657a3f91652b2$var$getRTLOffsetType()){
                        case 'negative':
                            calculatedScrollLeft = -scrollLeft;
                            break;
                        case 'positive-descending':
                            calculatedScrollLeft = scrollWidth - clientWidth - scrollLeft;
                            break;
                    }
                     // Prevent Safari's elastic scrolling from causing visual shaking when scrolling past bounds.
                    calculatedScrollLeft = Math.max(0, Math.min(calculatedScrollLeft, scrollWidth - clientWidth));
                    var calculatedScrollTop = Math.max(0, Math.min(scrollTop, scrollHeight - clientHeight));
                    return {
                        isScrolling: true,
                        horizontalScrollDirection: prevState.scrollLeft < scrollLeft ? 'forward' : 'backward',
                        scrollLeft: calculatedScrollLeft,
                        scrollTop: calculatedScrollTop,
                        verticalScrollDirection: prevState.scrollTop < scrollTop ? 'forward' : 'backward',
                        scrollUpdateWasRequested: false
                    };
                }, _this._resetIsScrollingDebounced);
            };
            _this._outerRefSetter = function(ref) {
                var outerRef = _this.props.outerRef;
                _this._outerRef = ref;
                if (typeof outerRef === 'function') outerRef(ref);
                else if (outerRef != null && typeof outerRef === 'object' && outerRef.hasOwnProperty('current')) outerRef.current = ref;
            };
            _this._resetIsScrollingDebounced = function() {
                if (_this._resetIsScrollingTimeoutId !== null) $937657a3f91652b2$var$cancelTimeout(_this._resetIsScrollingTimeoutId);
                _this._resetIsScrollingTimeoutId = $937657a3f91652b2$var$requestTimeout(_this._resetIsScrolling, $937657a3f91652b2$var$IS_SCROLLING_DEBOUNCE_INTERVAL);
            };
            _this._resetIsScrolling = function() {
                _this._resetIsScrollingTimeoutId = null;
                _this.setState({
                    isScrolling: false
                }, function() {
                    // Clear style cache after state update has been committed.
                    // This way we don't break pure sCU for items that don't use isScrolling param.
                    _this._getItemStyleCache(-1);
                });
            };
            return _this;
        }
        Grid.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, prevState) {
            $937657a3f91652b2$var$validateSharedProps(nextProps, prevState);
            validateProps(nextProps);
            return null;
        };
        var _proto = Grid.prototype;
        _proto.scrollTo = function scrollTo(_ref3) {
            var scrollLeft = _ref3.scrollLeft, scrollTop = _ref3.scrollTop;
            if (scrollLeft !== undefined) scrollLeft = Math.max(0, scrollLeft);
            if (scrollTop !== undefined) scrollTop = Math.max(0, scrollTop);
            this.setState(function(prevState) {
                if (scrollLeft === undefined) scrollLeft = prevState.scrollLeft;
                if (scrollTop === undefined) scrollTop = prevState.scrollTop;
                if (prevState.scrollLeft === scrollLeft && prevState.scrollTop === scrollTop) return null;
                return {
                    horizontalScrollDirection: prevState.scrollLeft < scrollLeft ? 'forward' : 'backward',
                    scrollLeft: scrollLeft,
                    scrollTop: scrollTop,
                    scrollUpdateWasRequested: true,
                    verticalScrollDirection: prevState.scrollTop < scrollTop ? 'forward' : 'backward'
                };
            }, this._resetIsScrollingDebounced);
        };
        _proto.scrollToItem = function scrollToItem(_ref4) {
            var _ref4$align = _ref4.align, align = _ref4$align === void 0 ? 'auto' : _ref4$align, columnIndex = _ref4.columnIndex, rowIndex = _ref4.rowIndex;
            var _this$props2 = this.props, columnCount = _this$props2.columnCount, height = _this$props2.height, rowCount = _this$props2.rowCount, width = _this$props2.width;
            var _this$state = this.state, scrollLeft = _this$state.scrollLeft, scrollTop = _this$state.scrollTop;
            var scrollbarSize = $937657a3f91652b2$var$getScrollbarSize();
            if (columnIndex !== undefined) columnIndex = Math.max(0, Math.min(columnIndex, columnCount - 1));
            if (rowIndex !== undefined) rowIndex = Math.max(0, Math.min(rowIndex, rowCount - 1));
            var estimatedTotalHeight = getEstimatedTotalHeight(this.props, this._instanceProps);
            var estimatedTotalWidth = getEstimatedTotalWidth(this.props, this._instanceProps); // The scrollbar size should be considered when scrolling an item into view,
            // to ensure it's fully visible.
            // But we only need to account for its size when it's actually visible.
            var horizontalScrollbarSize = estimatedTotalWidth > width ? scrollbarSize : 0;
            var verticalScrollbarSize = estimatedTotalHeight > height ? scrollbarSize : 0;
            this.scrollTo({
                scrollLeft: columnIndex !== undefined ? getOffsetForColumnAndAlignment(this.props, columnIndex, align, scrollLeft, this._instanceProps, verticalScrollbarSize) : scrollLeft,
                scrollTop: rowIndex !== undefined ? getOffsetForRowAndAlignment(this.props, rowIndex, align, scrollTop, this._instanceProps, horizontalScrollbarSize) : scrollTop
            });
        };
        _proto.componentDidMount = function componentDidMount() {
            var _this$props3 = this.props, initialScrollLeft = _this$props3.initialScrollLeft, initialScrollTop = _this$props3.initialScrollTop;
            if (this._outerRef != null) {
                var outerRef = this._outerRef;
                if (typeof initialScrollLeft === 'number') outerRef.scrollLeft = initialScrollLeft;
                if (typeof initialScrollTop === 'number') outerRef.scrollTop = initialScrollTop;
            }
            this._callPropsCallbacks();
        };
        _proto.componentDidUpdate = function componentDidUpdate() {
            var direction = this.props.direction;
            var _this$state2 = this.state, scrollLeft = _this$state2.scrollLeft, scrollTop = _this$state2.scrollTop, scrollUpdateWasRequested = _this$state2.scrollUpdateWasRequested;
            if (scrollUpdateWasRequested && this._outerRef != null) {
                // TRICKY According to the spec, scrollLeft should be negative for RTL aligned elements.
                // This is not the case for all browsers though (e.g. Chrome reports values as positive, measured relative to the left).
                // So we need to determine which browser behavior we're dealing with, and mimic it.
                var outerRef = this._outerRef;
                if (direction === 'rtl') switch($937657a3f91652b2$var$getRTLOffsetType()){
                    case 'negative':
                        outerRef.scrollLeft = -scrollLeft;
                        break;
                    case 'positive-ascending':
                        outerRef.scrollLeft = scrollLeft;
                        break;
                    default:
                        var clientWidth = outerRef.clientWidth, scrollWidth = outerRef.scrollWidth;
                        outerRef.scrollLeft = scrollWidth - clientWidth - scrollLeft;
                        break;
                }
                else outerRef.scrollLeft = Math.max(0, scrollLeft);
                outerRef.scrollTop = Math.max(0, scrollTop);
            }
            this._callPropsCallbacks();
        };
        _proto.componentWillUnmount = function componentWillUnmount() {
            if (this._resetIsScrollingTimeoutId !== null) $937657a3f91652b2$var$cancelTimeout(this._resetIsScrollingTimeoutId);
        };
        _proto.render = function render() {
            var _this$props4 = this.props, children = _this$props4.children, className = _this$props4.className, columnCount = _this$props4.columnCount, direction = _this$props4.direction, height = _this$props4.height, innerRef = _this$props4.innerRef, innerElementType = _this$props4.innerElementType, innerTagName = _this$props4.innerTagName, itemData = _this$props4.itemData, _this$props4$itemKey = _this$props4.itemKey, itemKey = _this$props4$itemKey === void 0 ? $937657a3f91652b2$var$defaultItemKey : _this$props4$itemKey, outerElementType = _this$props4.outerElementType, outerTagName = _this$props4.outerTagName, rowCount = _this$props4.rowCount, style = _this$props4.style, useIsScrolling = _this$props4.useIsScrolling, width = _this$props4.width;
            var isScrolling = this.state.isScrolling;
            var _this$_getHorizontalR = this._getHorizontalRangeToRender(), columnStartIndex = _this$_getHorizontalR[0], columnStopIndex = _this$_getHorizontalR[1];
            var _this$_getVerticalRan = this._getVerticalRangeToRender(), rowStartIndex = _this$_getVerticalRan[0], rowStopIndex = _this$_getVerticalRan[1];
            var items = [];
            if (columnCount > 0 && rowCount) {
                for(var _rowIndex = rowStartIndex; _rowIndex <= rowStopIndex; _rowIndex++)for(var _columnIndex = columnStartIndex; _columnIndex <= columnStopIndex; _columnIndex++)items.push((0, $4Y8Vu.createElement)(children, {
                    columnIndex: _columnIndex,
                    data: itemData,
                    isScrolling: useIsScrolling ? isScrolling : undefined,
                    key: itemKey({
                        columnIndex: _columnIndex,
                        data: itemData,
                        rowIndex: _rowIndex
                    }),
                    rowIndex: _rowIndex,
                    style: this._getItemStyle(_rowIndex, _columnIndex)
                }));
            } // Read this value AFTER items have been created,
            // So their actual sizes (if variable) are taken into consideration.
            var estimatedTotalHeight = getEstimatedTotalHeight(this.props, this._instanceProps);
            var estimatedTotalWidth = getEstimatedTotalWidth(this.props, this._instanceProps);
            return (0, $4Y8Vu.createElement)(outerElementType || outerTagName || 'div', {
                className: className,
                onScroll: this._onScroll,
                ref: this._outerRefSetter,
                style: (0, $f3601d07f0ff7403$export$2e2bcd8739ae039)({
                    position: 'relative',
                    height: height,
                    width: width,
                    overflow: 'auto',
                    WebkitOverflowScrolling: 'touch',
                    willChange: 'transform',
                    direction: direction
                }, style)
            }, (0, $4Y8Vu.createElement)(innerElementType || innerTagName || 'div', {
                children: items,
                ref: innerRef,
                style: {
                    height: estimatedTotalHeight,
                    pointerEvents: isScrolling ? 'none' : undefined,
                    width: estimatedTotalWidth
                }
            }));
        };
        _proto._callPropsCallbacks = function _callPropsCallbacks() {
            var _this$props5 = this.props, columnCount = _this$props5.columnCount, onItemsRendered = _this$props5.onItemsRendered, onScroll = _this$props5.onScroll, rowCount = _this$props5.rowCount;
            if (typeof onItemsRendered === 'function') {
                if (columnCount > 0 && rowCount > 0) {
                    var _this$_getHorizontalR2 = this._getHorizontalRangeToRender(), _overscanColumnStartIndex = _this$_getHorizontalR2[0], _overscanColumnStopIndex = _this$_getHorizontalR2[1], _visibleColumnStartIndex = _this$_getHorizontalR2[2], _visibleColumnStopIndex = _this$_getHorizontalR2[3];
                    var _this$_getVerticalRan2 = this._getVerticalRangeToRender(), _overscanRowStartIndex = _this$_getVerticalRan2[0], _overscanRowStopIndex = _this$_getVerticalRan2[1], _visibleRowStartIndex = _this$_getVerticalRan2[2], _visibleRowStopIndex = _this$_getVerticalRan2[3];
                    this._callOnItemsRendered(_overscanColumnStartIndex, _overscanColumnStopIndex, _overscanRowStartIndex, _overscanRowStopIndex, _visibleColumnStartIndex, _visibleColumnStopIndex, _visibleRowStartIndex, _visibleRowStopIndex);
                }
            }
            if (typeof onScroll === 'function') {
                var _this$state3 = this.state, _horizontalScrollDirection = _this$state3.horizontalScrollDirection, _scrollLeft = _this$state3.scrollLeft, _scrollTop = _this$state3.scrollTop, _scrollUpdateWasRequested = _this$state3.scrollUpdateWasRequested, _verticalScrollDirection = _this$state3.verticalScrollDirection;
                this._callOnScroll(_scrollLeft, _scrollTop, _horizontalScrollDirection, _verticalScrollDirection, _scrollUpdateWasRequested);
            }
        } // Lazily create and cache item styles while scrolling,
        ;
        _proto._getHorizontalRangeToRender = function _getHorizontalRangeToRender() {
            var _this$props6 = this.props, columnCount = _this$props6.columnCount, overscanColumnCount = _this$props6.overscanColumnCount, overscanColumnsCount = _this$props6.overscanColumnsCount, overscanCount = _this$props6.overscanCount, rowCount = _this$props6.rowCount;
            var _this$state4 = this.state, horizontalScrollDirection = _this$state4.horizontalScrollDirection, isScrolling = _this$state4.isScrolling, scrollLeft = _this$state4.scrollLeft;
            var overscanCountResolved = overscanColumnCount || overscanColumnsCount || overscanCount || 1;
            if (columnCount === 0 || rowCount === 0) return [
                0,
                0,
                0,
                0
            ];
            var startIndex = getColumnStartIndexForOffset(this.props, scrollLeft, this._instanceProps);
            var stopIndex = getColumnStopIndexForStartIndex(this.props, startIndex, scrollLeft, this._instanceProps); // Overscan by one item in each direction so that tab/focus works.
            // If there isn't at least one extra item, tab loops back around.
            var overscanBackward = !isScrolling || horizontalScrollDirection === 'backward' ? Math.max(1, overscanCountResolved) : 1;
            var overscanForward = !isScrolling || horizontalScrollDirection === 'forward' ? Math.max(1, overscanCountResolved) : 1;
            return [
                Math.max(0, startIndex - overscanBackward),
                Math.max(0, Math.min(columnCount - 1, stopIndex + overscanForward)),
                startIndex,
                stopIndex
            ];
        };
        _proto._getVerticalRangeToRender = function _getVerticalRangeToRender() {
            var _this$props7 = this.props, columnCount = _this$props7.columnCount, overscanCount = _this$props7.overscanCount, overscanRowCount = _this$props7.overscanRowCount, overscanRowsCount = _this$props7.overscanRowsCount, rowCount = _this$props7.rowCount;
            var _this$state5 = this.state, isScrolling = _this$state5.isScrolling, verticalScrollDirection = _this$state5.verticalScrollDirection, scrollTop = _this$state5.scrollTop;
            var overscanCountResolved = overscanRowCount || overscanRowsCount || overscanCount || 1;
            if (columnCount === 0 || rowCount === 0) return [
                0,
                0,
                0,
                0
            ];
            var startIndex = getRowStartIndexForOffset(this.props, scrollTop, this._instanceProps);
            var stopIndex = getRowStopIndexForStartIndex(this.props, startIndex, scrollTop, this._instanceProps); // Overscan by one item in each direction so that tab/focus works.
            // If there isn't at least one extra item, tab loops back around.
            var overscanBackward = !isScrolling || verticalScrollDirection === 'backward' ? Math.max(1, overscanCountResolved) : 1;
            var overscanForward = !isScrolling || verticalScrollDirection === 'forward' ? Math.max(1, overscanCountResolved) : 1;
            return [
                Math.max(0, startIndex - overscanBackward),
                Math.max(0, Math.min(rowCount - 1, stopIndex + overscanForward)),
                startIndex,
                stopIndex
            ];
        };
        return Grid;
    }((0, $4Y8Vu.PureComponent)), _class.defaultProps = {
        direction: 'ltr',
        itemData: undefined,
        useIsScrolling: false
    }, _class;
}
var $937657a3f91652b2$var$validateSharedProps = function validateSharedProps(_ref5, _ref6) {
    var children = _ref5.children, direction = _ref5.direction, height = _ref5.height, innerTagName = _ref5.innerTagName, outerTagName = _ref5.outerTagName, overscanColumnsCount = _ref5.overscanColumnsCount, overscanCount = _ref5.overscanCount, overscanRowsCount = _ref5.overscanRowsCount, width = _ref5.width;
    var instance = _ref6.instance;
};
var $937657a3f91652b2$var$DEFAULT_ESTIMATED_ITEM_SIZE = 50;
var $937657a3f91652b2$var$getEstimatedTotalHeight = function getEstimatedTotalHeight(_ref, _ref2) {
    var rowCount = _ref.rowCount;
    var rowMetadataMap = _ref2.rowMetadataMap, estimatedRowHeight = _ref2.estimatedRowHeight, lastMeasuredRowIndex = _ref2.lastMeasuredRowIndex;
    var totalSizeOfMeasuredRows = 0; // Edge case check for when the number of items decreases while a scroll is in progress.
    // https://github.com/bvaughn/react-window/pull/138
    if (lastMeasuredRowIndex >= rowCount) lastMeasuredRowIndex = rowCount - 1;
    if (lastMeasuredRowIndex >= 0) {
        var itemMetadata = rowMetadataMap[lastMeasuredRowIndex];
        totalSizeOfMeasuredRows = itemMetadata.offset + itemMetadata.size;
    }
    var numUnmeasuredItems = rowCount - lastMeasuredRowIndex - 1;
    var totalSizeOfUnmeasuredItems = numUnmeasuredItems * estimatedRowHeight;
    return totalSizeOfMeasuredRows + totalSizeOfUnmeasuredItems;
};
var $937657a3f91652b2$var$getEstimatedTotalWidth = function getEstimatedTotalWidth(_ref3, _ref4) {
    var columnCount = _ref3.columnCount;
    var columnMetadataMap = _ref4.columnMetadataMap, estimatedColumnWidth = _ref4.estimatedColumnWidth, lastMeasuredColumnIndex = _ref4.lastMeasuredColumnIndex;
    var totalSizeOfMeasuredRows = 0; // Edge case check for when the number of items decreases while a scroll is in progress.
    // https://github.com/bvaughn/react-window/pull/138
    if (lastMeasuredColumnIndex >= columnCount) lastMeasuredColumnIndex = columnCount - 1;
    if (lastMeasuredColumnIndex >= 0) {
        var itemMetadata = columnMetadataMap[lastMeasuredColumnIndex];
        totalSizeOfMeasuredRows = itemMetadata.offset + itemMetadata.size;
    }
    var numUnmeasuredItems = columnCount - lastMeasuredColumnIndex - 1;
    var totalSizeOfUnmeasuredItems = numUnmeasuredItems * estimatedColumnWidth;
    return totalSizeOfMeasuredRows + totalSizeOfUnmeasuredItems;
};
var $937657a3f91652b2$var$getItemMetadata = function getItemMetadata(itemType, props, index, instanceProps) {
    var itemMetadataMap, itemSize, lastMeasuredIndex;
    if (itemType === 'column') {
        itemMetadataMap = instanceProps.columnMetadataMap;
        itemSize = props.columnWidth;
        lastMeasuredIndex = instanceProps.lastMeasuredColumnIndex;
    } else {
        itemMetadataMap = instanceProps.rowMetadataMap;
        itemSize = props.rowHeight;
        lastMeasuredIndex = instanceProps.lastMeasuredRowIndex;
    }
    if (index > lastMeasuredIndex) {
        var offset = 0;
        if (lastMeasuredIndex >= 0) {
            var itemMetadata = itemMetadataMap[lastMeasuredIndex];
            offset = itemMetadata.offset + itemMetadata.size;
        }
        for(var i = lastMeasuredIndex + 1; i <= index; i++){
            var size = itemSize(i);
            itemMetadataMap[i] = {
                offset: offset,
                size: size
            };
            offset += size;
        }
        if (itemType === 'column') instanceProps.lastMeasuredColumnIndex = index;
        else instanceProps.lastMeasuredRowIndex = index;
    }
    return itemMetadataMap[index];
};
var $937657a3f91652b2$var$findNearestItem = function findNearestItem(itemType, props, instanceProps, offset) {
    var itemMetadataMap, lastMeasuredIndex;
    if (itemType === 'column') {
        itemMetadataMap = instanceProps.columnMetadataMap;
        lastMeasuredIndex = instanceProps.lastMeasuredColumnIndex;
    } else {
        itemMetadataMap = instanceProps.rowMetadataMap;
        lastMeasuredIndex = instanceProps.lastMeasuredRowIndex;
    }
    var lastMeasuredItemOffset = lastMeasuredIndex > 0 ? itemMetadataMap[lastMeasuredIndex].offset : 0;
    if (lastMeasuredItemOffset >= offset) // If we've already measured items within this range just use a binary search as it's faster.
    return $937657a3f91652b2$var$findNearestItemBinarySearch(itemType, props, instanceProps, lastMeasuredIndex, 0, offset);
    else // If we haven't yet measured this high, fallback to an exponential search with an inner binary search.
    // The exponential search avoids pre-computing sizes for the full set of items as a binary search would.
    // The overall complexity for this approach is O(log n).
    return $937657a3f91652b2$var$findNearestItemExponentialSearch(itemType, props, instanceProps, Math.max(0, lastMeasuredIndex), offset);
};
var $937657a3f91652b2$var$findNearestItemBinarySearch = function findNearestItemBinarySearch(itemType, props, instanceProps, high, low, offset) {
    while(low <= high){
        var middle = low + Math.floor((high - low) / 2);
        var currentOffset = $937657a3f91652b2$var$getItemMetadata(itemType, props, middle, instanceProps).offset;
        if (currentOffset === offset) return middle;
        else if (currentOffset < offset) low = middle + 1;
        else if (currentOffset > offset) high = middle - 1;
    }
    if (low > 0) return low - 1;
    else return 0;
};
var $937657a3f91652b2$var$findNearestItemExponentialSearch = function findNearestItemExponentialSearch(itemType, props, instanceProps, index, offset) {
    var itemCount = itemType === 'column' ? props.columnCount : props.rowCount;
    var interval = 1;
    while(index < itemCount && $937657a3f91652b2$var$getItemMetadata(itemType, props, index, instanceProps).offset < offset){
        index += interval;
        interval *= 2;
    }
    return $937657a3f91652b2$var$findNearestItemBinarySearch(itemType, props, instanceProps, Math.min(index, itemCount - 1), Math.floor(index / 2), offset);
};
var $937657a3f91652b2$var$getOffsetForIndexAndAlignment = function getOffsetForIndexAndAlignment(itemType, props, index, align, scrollOffset, instanceProps, scrollbarSize) {
    var size = itemType === 'column' ? props.width : props.height;
    var itemMetadata = $937657a3f91652b2$var$getItemMetadata(itemType, props, index, instanceProps); // Get estimated total size after ItemMetadata is computed,
    // To ensure it reflects actual measurements instead of just estimates.
    var estimatedTotalSize = itemType === 'column' ? $937657a3f91652b2$var$getEstimatedTotalWidth(props, instanceProps) : $937657a3f91652b2$var$getEstimatedTotalHeight(props, instanceProps);
    var maxOffset = Math.max(0, Math.min(estimatedTotalSize - size, itemMetadata.offset));
    var minOffset = Math.max(0, itemMetadata.offset - size + scrollbarSize + itemMetadata.size);
    if (align === 'smart') {
        if (scrollOffset >= minOffset - size && scrollOffset <= maxOffset + size) align = 'auto';
        else align = 'center';
    }
    switch(align){
        case 'start':
            return maxOffset;
        case 'end':
            return minOffset;
        case 'center':
            return Math.round(minOffset + (maxOffset - minOffset) / 2);
        case 'auto':
        default:
            if (scrollOffset >= minOffset && scrollOffset <= maxOffset) return scrollOffset;
            else if (minOffset > maxOffset) // Because we only take into account the scrollbar size when calculating minOffset
            // this value can be larger than maxOffset when at the end of the list
            return minOffset;
            else if (scrollOffset < minOffset) return minOffset;
            else return maxOffset;
    }
};
var $937657a3f91652b2$export$32c206c84102e73c = /*#__PURE__*/ $937657a3f91652b2$var$createGridComponent({
    getColumnOffset: function getColumnOffset(props, index, instanceProps) {
        return $937657a3f91652b2$var$getItemMetadata('column', props, index, instanceProps).offset;
    },
    getColumnStartIndexForOffset: function getColumnStartIndexForOffset(props, scrollLeft, instanceProps) {
        return $937657a3f91652b2$var$findNearestItem('column', props, instanceProps, scrollLeft);
    },
    getColumnStopIndexForStartIndex: function getColumnStopIndexForStartIndex(props, startIndex, scrollLeft, instanceProps) {
        var columnCount = props.columnCount, width = props.width;
        var itemMetadata = $937657a3f91652b2$var$getItemMetadata('column', props, startIndex, instanceProps);
        var maxOffset = scrollLeft + width;
        var offset = itemMetadata.offset + itemMetadata.size;
        var stopIndex = startIndex;
        while(stopIndex < columnCount - 1 && offset < maxOffset){
            stopIndex++;
            offset += $937657a3f91652b2$var$getItemMetadata('column', props, stopIndex, instanceProps).size;
        }
        return stopIndex;
    },
    getColumnWidth: function getColumnWidth(props, index, instanceProps) {
        return instanceProps.columnMetadataMap[index].size;
    },
    getEstimatedTotalHeight: $937657a3f91652b2$var$getEstimatedTotalHeight,
    getEstimatedTotalWidth: $937657a3f91652b2$var$getEstimatedTotalWidth,
    getOffsetForColumnAndAlignment: function getOffsetForColumnAndAlignment(props, index, align, scrollOffset, instanceProps, scrollbarSize) {
        return $937657a3f91652b2$var$getOffsetForIndexAndAlignment('column', props, index, align, scrollOffset, instanceProps, scrollbarSize);
    },
    getOffsetForRowAndAlignment: function getOffsetForRowAndAlignment(props, index, align, scrollOffset, instanceProps, scrollbarSize) {
        return $937657a3f91652b2$var$getOffsetForIndexAndAlignment('row', props, index, align, scrollOffset, instanceProps, scrollbarSize);
    },
    getRowOffset: function getRowOffset(props, index, instanceProps) {
        return $937657a3f91652b2$var$getItemMetadata('row', props, index, instanceProps).offset;
    },
    getRowHeight: function getRowHeight(props, index, instanceProps) {
        return instanceProps.rowMetadataMap[index].size;
    },
    getRowStartIndexForOffset: function getRowStartIndexForOffset(props, scrollTop, instanceProps) {
        return $937657a3f91652b2$var$findNearestItem('row', props, instanceProps, scrollTop);
    },
    getRowStopIndexForStartIndex: function getRowStopIndexForStartIndex(props, startIndex, scrollTop, instanceProps) {
        var rowCount = props.rowCount, height = props.height;
        var itemMetadata = $937657a3f91652b2$var$getItemMetadata('row', props, startIndex, instanceProps);
        var maxOffset = scrollTop + height;
        var offset = itemMetadata.offset + itemMetadata.size;
        var stopIndex = startIndex;
        while(stopIndex < rowCount - 1 && offset < maxOffset){
            stopIndex++;
            offset += $937657a3f91652b2$var$getItemMetadata('row', props, stopIndex, instanceProps).size;
        }
        return stopIndex;
    },
    initInstanceProps: function initInstanceProps(props, instance) {
        var _ref5 = props, estimatedColumnWidth = _ref5.estimatedColumnWidth, estimatedRowHeight = _ref5.estimatedRowHeight;
        var instanceProps = {
            columnMetadataMap: {},
            estimatedColumnWidth: estimatedColumnWidth || $937657a3f91652b2$var$DEFAULT_ESTIMATED_ITEM_SIZE,
            estimatedRowHeight: estimatedRowHeight || $937657a3f91652b2$var$DEFAULT_ESTIMATED_ITEM_SIZE,
            lastMeasuredColumnIndex: -1,
            lastMeasuredRowIndex: -1,
            rowMetadataMap: {}
        };
        instance.resetAfterColumnIndex = function(columnIndex, shouldForceUpdate) {
            if (shouldForceUpdate === void 0) shouldForceUpdate = true;
            instance.resetAfterIndices({
                columnIndex: columnIndex,
                shouldForceUpdate: shouldForceUpdate
            });
        };
        instance.resetAfterRowIndex = function(rowIndex, shouldForceUpdate) {
            if (shouldForceUpdate === void 0) shouldForceUpdate = true;
            instance.resetAfterIndices({
                rowIndex: rowIndex,
                shouldForceUpdate: shouldForceUpdate
            });
        };
        instance.resetAfterIndices = function(_ref6) {
            var columnIndex = _ref6.columnIndex, rowIndex = _ref6.rowIndex, _ref6$shouldForceUpda = _ref6.shouldForceUpdate, shouldForceUpdate = _ref6$shouldForceUpda === void 0 ? true : _ref6$shouldForceUpda;
            if (typeof columnIndex === 'number') instanceProps.lastMeasuredColumnIndex = Math.min(instanceProps.lastMeasuredColumnIndex, columnIndex - 1);
            if (typeof rowIndex === 'number') instanceProps.lastMeasuredRowIndex = Math.min(instanceProps.lastMeasuredRowIndex, rowIndex - 1);
             // We could potentially optimize further by only evicting styles after this index,
            // But since styles are only cached while scrolling is in progress-
            // It seems an unnecessary optimization.
            // It's unlikely that resetAfterIndex() will be called while a user is scrolling.
            instance._getItemStyleCache(-1);
            if (shouldForceUpdate) instance.forceUpdate();
        };
        return instanceProps;
    },
    shouldResetStyleCacheOnItemSizeChange: false,
    validateProps: function validateProps(_ref7) {
        var columnWidth = _ref7.columnWidth, rowHeight = _ref7.rowHeight;
    }
});
var $937657a3f91652b2$var$IS_SCROLLING_DEBOUNCE_INTERVAL$1 = 150;
var $937657a3f91652b2$var$defaultItemKey$1 = function defaultItemKey(index, data) {
    return index;
}; // In DEV mode, this Set helps us only log a warning once per component instance.
// This avoids spamming the console every time a render happens.
var $937657a3f91652b2$var$devWarningsDirection = null;
var $937657a3f91652b2$var$devWarningsTagName$1 = null;
function $937657a3f91652b2$var$createListComponent(_ref) {
    var _class;
    var getItemOffset = _ref.getItemOffset, getEstimatedTotalSize = _ref.getEstimatedTotalSize, getItemSize = _ref.getItemSize, getOffsetForIndexAndAlignment = _ref.getOffsetForIndexAndAlignment, getStartIndexForOffset = _ref.getStartIndexForOffset, getStopIndexForStartIndex = _ref.getStopIndexForStartIndex, initInstanceProps = _ref.initInstanceProps, shouldResetStyleCacheOnItemSizeChange = _ref.shouldResetStyleCacheOnItemSizeChange, validateProps = _ref.validateProps;
    return _class = /*#__PURE__*/ function(_PureComponent) {
        (0, $4708a8791a55a98c$export$2e2bcd8739ae039)(List, _PureComponent);
        // Always use explicit constructor for React components.
        // It produces less code after transpilation. (#26)
        // eslint-disable-next-line no-useless-constructor
        function List(props) {
            var _this;
            _this = _PureComponent.call(this, props) || this;
            _this._instanceProps = initInstanceProps(_this.props, (0, $62bd62033e65cf67$export$2e2bcd8739ae039)(_this));
            _this._outerRef = void 0;
            _this._resetIsScrollingTimeoutId = null;
            _this.state = {
                instance: (0, $62bd62033e65cf67$export$2e2bcd8739ae039)(_this),
                isScrolling: false,
                scrollDirection: 'forward',
                scrollOffset: typeof _this.props.initialScrollOffset === 'number' ? _this.props.initialScrollOffset : 0,
                scrollUpdateWasRequested: false
            };
            _this._callOnItemsRendered = void 0;
            _this._callOnItemsRendered = (0, $ef75e4dd58e14509$export$2e2bcd8739ae039)(function(overscanStartIndex, overscanStopIndex, visibleStartIndex, visibleStopIndex) {
                return _this.props.onItemsRendered({
                    overscanStartIndex: overscanStartIndex,
                    overscanStopIndex: overscanStopIndex,
                    visibleStartIndex: visibleStartIndex,
                    visibleStopIndex: visibleStopIndex
                });
            });
            _this._callOnScroll = void 0;
            _this._callOnScroll = (0, $ef75e4dd58e14509$export$2e2bcd8739ae039)(function(scrollDirection, scrollOffset, scrollUpdateWasRequested) {
                return _this.props.onScroll({
                    scrollDirection: scrollDirection,
                    scrollOffset: scrollOffset,
                    scrollUpdateWasRequested: scrollUpdateWasRequested
                });
            });
            _this._getItemStyle = void 0;
            _this._getItemStyle = function(index) {
                var _this$props = _this.props, direction = _this$props.direction, itemSize = _this$props.itemSize, layout = _this$props.layout;
                var itemStyleCache = _this._getItemStyleCache(shouldResetStyleCacheOnItemSizeChange && itemSize, shouldResetStyleCacheOnItemSizeChange && layout, shouldResetStyleCacheOnItemSizeChange && direction);
                var style;
                if (itemStyleCache.hasOwnProperty(index)) style = itemStyleCache[index];
                else {
                    var _offset = getItemOffset(_this.props, index, _this._instanceProps);
                    var size = getItemSize(_this.props, index, _this._instanceProps); // TODO Deprecate direction "horizontal"
                    var isHorizontal = direction === 'horizontal' || layout === 'horizontal';
                    var isRtl = direction === 'rtl';
                    var offsetHorizontal = isHorizontal ? _offset : 0;
                    itemStyleCache[index] = style = {
                        position: 'absolute',
                        left: isRtl ? undefined : offsetHorizontal,
                        right: isRtl ? offsetHorizontal : undefined,
                        top: !isHorizontal ? _offset : 0,
                        height: !isHorizontal ? size : '100%',
                        width: isHorizontal ? size : '100%'
                    };
                }
                return style;
            };
            _this._getItemStyleCache = void 0;
            _this._getItemStyleCache = (0, $ef75e4dd58e14509$export$2e2bcd8739ae039)(function(_, __, ___) {
                return {};
            });
            _this._onScrollHorizontal = function(event) {
                var _event$currentTarget = event.currentTarget, clientWidth = _event$currentTarget.clientWidth, scrollLeft = _event$currentTarget.scrollLeft, scrollWidth = _event$currentTarget.scrollWidth;
                _this.setState(function(prevState) {
                    if (prevState.scrollOffset === scrollLeft) // Scroll position may have been updated by cDM/cDU,
                    // In which case we don't need to trigger another render,
                    // And we don't want to update state.isScrolling.
                    return null;
                    var direction = _this.props.direction;
                    var scrollOffset = scrollLeft;
                    if (direction === 'rtl') // TRICKY According to the spec, scrollLeft should be negative for RTL aligned elements.
                    // This is not the case for all browsers though (e.g. Chrome reports values as positive, measured relative to the left).
                    // It's also easier for this component if we convert offsets to the same format as they would be in for ltr.
                    // So the simplest solution is to determine which browser behavior we're dealing with, and convert based on it.
                    switch($937657a3f91652b2$var$getRTLOffsetType()){
                        case 'negative':
                            scrollOffset = -scrollLeft;
                            break;
                        case 'positive-descending':
                            scrollOffset = scrollWidth - clientWidth - scrollLeft;
                            break;
                    }
                     // Prevent Safari's elastic scrolling from causing visual shaking when scrolling past bounds.
                    scrollOffset = Math.max(0, Math.min(scrollOffset, scrollWidth - clientWidth));
                    return {
                        isScrolling: true,
                        scrollDirection: prevState.scrollOffset < scrollOffset ? 'forward' : 'backward',
                        scrollOffset: scrollOffset,
                        scrollUpdateWasRequested: false
                    };
                }, _this._resetIsScrollingDebounced);
            };
            _this._onScrollVertical = function(event) {
                var _event$currentTarget2 = event.currentTarget, clientHeight = _event$currentTarget2.clientHeight, scrollHeight = _event$currentTarget2.scrollHeight, scrollTop = _event$currentTarget2.scrollTop;
                _this.setState(function(prevState) {
                    if (prevState.scrollOffset === scrollTop) // Scroll position may have been updated by cDM/cDU,
                    // In which case we don't need to trigger another render,
                    // And we don't want to update state.isScrolling.
                    return null;
                     // Prevent Safari's elastic scrolling from causing visual shaking when scrolling past bounds.
                    var scrollOffset = Math.max(0, Math.min(scrollTop, scrollHeight - clientHeight));
                    return {
                        isScrolling: true,
                        scrollDirection: prevState.scrollOffset < scrollOffset ? 'forward' : 'backward',
                        scrollOffset: scrollOffset,
                        scrollUpdateWasRequested: false
                    };
                }, _this._resetIsScrollingDebounced);
            };
            _this._outerRefSetter = function(ref) {
                var outerRef = _this.props.outerRef;
                _this._outerRef = ref;
                if (typeof outerRef === 'function') outerRef(ref);
                else if (outerRef != null && typeof outerRef === 'object' && outerRef.hasOwnProperty('current')) outerRef.current = ref;
            };
            _this._resetIsScrollingDebounced = function() {
                if (_this._resetIsScrollingTimeoutId !== null) $937657a3f91652b2$var$cancelTimeout(_this._resetIsScrollingTimeoutId);
                _this._resetIsScrollingTimeoutId = $937657a3f91652b2$var$requestTimeout(_this._resetIsScrolling, $937657a3f91652b2$var$IS_SCROLLING_DEBOUNCE_INTERVAL$1);
            };
            _this._resetIsScrolling = function() {
                _this._resetIsScrollingTimeoutId = null;
                _this.setState({
                    isScrolling: false
                }, function() {
                    // Clear style cache after state update has been committed.
                    // This way we don't break pure sCU for items that don't use isScrolling param.
                    _this._getItemStyleCache(-1, null);
                });
            };
            return _this;
        }
        List.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, prevState) {
            $937657a3f91652b2$var$validateSharedProps$1(nextProps, prevState);
            validateProps(nextProps);
            return null;
        };
        var _proto = List.prototype;
        _proto.scrollTo = function scrollTo(scrollOffset) {
            scrollOffset = Math.max(0, scrollOffset);
            this.setState(function(prevState) {
                if (prevState.scrollOffset === scrollOffset) return null;
                return {
                    scrollDirection: prevState.scrollOffset < scrollOffset ? 'forward' : 'backward',
                    scrollOffset: scrollOffset,
                    scrollUpdateWasRequested: true
                };
            }, this._resetIsScrollingDebounced);
        };
        _proto.scrollToItem = function scrollToItem(index, align) {
            if (align === void 0) align = 'auto';
            var _this$props2 = this.props, itemCount = _this$props2.itemCount, layout = _this$props2.layout;
            var scrollOffset = this.state.scrollOffset;
            index = Math.max(0, Math.min(index, itemCount - 1)); // The scrollbar size should be considered when scrolling an item into view, to ensure it's fully visible.
            // But we only need to account for its size when it's actually visible.
            // This is an edge case for lists; normally they only scroll in the dominant direction.
            var scrollbarSize = 0;
            if (this._outerRef) {
                var outerRef = this._outerRef;
                if (layout === 'vertical') scrollbarSize = outerRef.scrollWidth > outerRef.clientWidth ? $937657a3f91652b2$var$getScrollbarSize() : 0;
                else scrollbarSize = outerRef.scrollHeight > outerRef.clientHeight ? $937657a3f91652b2$var$getScrollbarSize() : 0;
            }
            this.scrollTo(getOffsetForIndexAndAlignment(this.props, index, align, scrollOffset, this._instanceProps, scrollbarSize));
        };
        _proto.componentDidMount = function componentDidMount() {
            var _this$props3 = this.props, direction = _this$props3.direction, initialScrollOffset = _this$props3.initialScrollOffset, layout = _this$props3.layout;
            if (typeof initialScrollOffset === 'number' && this._outerRef != null) {
                var outerRef = this._outerRef; // TODO Deprecate direction "horizontal"
                if (direction === 'horizontal' || layout === 'horizontal') outerRef.scrollLeft = initialScrollOffset;
                else outerRef.scrollTop = initialScrollOffset;
            }
            this._callPropsCallbacks();
        };
        _proto.componentDidUpdate = function componentDidUpdate() {
            var _this$props4 = this.props, direction = _this$props4.direction, layout = _this$props4.layout;
            var _this$state = this.state, scrollOffset = _this$state.scrollOffset, scrollUpdateWasRequested = _this$state.scrollUpdateWasRequested;
            if (scrollUpdateWasRequested && this._outerRef != null) {
                var outerRef = this._outerRef; // TODO Deprecate direction "horizontal"
                if (direction === 'horizontal' || layout === 'horizontal') {
                    if (direction === 'rtl') // TRICKY According to the spec, scrollLeft should be negative for RTL aligned elements.
                    // This is not the case for all browsers though (e.g. Chrome reports values as positive, measured relative to the left).
                    // So we need to determine which browser behavior we're dealing with, and mimic it.
                    switch($937657a3f91652b2$var$getRTLOffsetType()){
                        case 'negative':
                            outerRef.scrollLeft = -scrollOffset;
                            break;
                        case 'positive-ascending':
                            outerRef.scrollLeft = scrollOffset;
                            break;
                        default:
                            var clientWidth = outerRef.clientWidth, scrollWidth = outerRef.scrollWidth;
                            outerRef.scrollLeft = scrollWidth - clientWidth - scrollOffset;
                            break;
                    }
                    else outerRef.scrollLeft = scrollOffset;
                } else outerRef.scrollTop = scrollOffset;
            }
            this._callPropsCallbacks();
        };
        _proto.componentWillUnmount = function componentWillUnmount() {
            if (this._resetIsScrollingTimeoutId !== null) $937657a3f91652b2$var$cancelTimeout(this._resetIsScrollingTimeoutId);
        };
        _proto.render = function render() {
            var _this$props5 = this.props, children = _this$props5.children, className = _this$props5.className, direction = _this$props5.direction, height = _this$props5.height, innerRef = _this$props5.innerRef, innerElementType = _this$props5.innerElementType, innerTagName = _this$props5.innerTagName, itemCount = _this$props5.itemCount, itemData = _this$props5.itemData, _this$props5$itemKey = _this$props5.itemKey, itemKey = _this$props5$itemKey === void 0 ? $937657a3f91652b2$var$defaultItemKey$1 : _this$props5$itemKey, layout = _this$props5.layout, outerElementType = _this$props5.outerElementType, outerTagName = _this$props5.outerTagName, style = _this$props5.style, useIsScrolling = _this$props5.useIsScrolling, width = _this$props5.width;
            var isScrolling = this.state.isScrolling; // TODO Deprecate direction "horizontal"
            var isHorizontal = direction === 'horizontal' || layout === 'horizontal';
            var onScroll = isHorizontal ? this._onScrollHorizontal : this._onScrollVertical;
            var _this$_getRangeToRend = this._getRangeToRender(), startIndex = _this$_getRangeToRend[0], stopIndex = _this$_getRangeToRend[1];
            var items = [];
            if (itemCount > 0) for(var _index = startIndex; _index <= stopIndex; _index++)items.push((0, $4Y8Vu.createElement)(children, {
                data: itemData,
                key: itemKey(_index, itemData),
                index: _index,
                isScrolling: useIsScrolling ? isScrolling : undefined,
                style: this._getItemStyle(_index)
            }));
             // Read this value AFTER items have been created,
            // So their actual sizes (if variable) are taken into consideration.
            var estimatedTotalSize = getEstimatedTotalSize(this.props, this._instanceProps);
            return (0, $4Y8Vu.createElement)(outerElementType || outerTagName || 'div', {
                className: className,
                onScroll: onScroll,
                ref: this._outerRefSetter,
                style: (0, $f3601d07f0ff7403$export$2e2bcd8739ae039)({
                    position: 'relative',
                    height: height,
                    width: width,
                    overflow: 'auto',
                    WebkitOverflowScrolling: 'touch',
                    willChange: 'transform',
                    direction: direction
                }, style)
            }, (0, $4Y8Vu.createElement)(innerElementType || innerTagName || 'div', {
                children: items,
                ref: innerRef,
                style: {
                    height: isHorizontal ? '100%' : estimatedTotalSize,
                    pointerEvents: isScrolling ? 'none' : undefined,
                    width: isHorizontal ? estimatedTotalSize : '100%'
                }
            }));
        };
        _proto._callPropsCallbacks = function _callPropsCallbacks() {
            if (typeof this.props.onItemsRendered === 'function') {
                var itemCount = this.props.itemCount;
                if (itemCount > 0) {
                    var _this$_getRangeToRend2 = this._getRangeToRender(), _overscanStartIndex = _this$_getRangeToRend2[0], _overscanStopIndex = _this$_getRangeToRend2[1], _visibleStartIndex = _this$_getRangeToRend2[2], _visibleStopIndex = _this$_getRangeToRend2[3];
                    this._callOnItemsRendered(_overscanStartIndex, _overscanStopIndex, _visibleStartIndex, _visibleStopIndex);
                }
            }
            if (typeof this.props.onScroll === 'function') {
                var _this$state2 = this.state, _scrollDirection = _this$state2.scrollDirection, _scrollOffset = _this$state2.scrollOffset, _scrollUpdateWasRequested = _this$state2.scrollUpdateWasRequested;
                this._callOnScroll(_scrollDirection, _scrollOffset, _scrollUpdateWasRequested);
            }
        } // Lazily create and cache item styles while scrolling,
        ;
        _proto._getRangeToRender = function _getRangeToRender() {
            var _this$props6 = this.props, itemCount = _this$props6.itemCount, overscanCount = _this$props6.overscanCount;
            var _this$state3 = this.state, isScrolling = _this$state3.isScrolling, scrollDirection = _this$state3.scrollDirection, scrollOffset = _this$state3.scrollOffset;
            if (itemCount === 0) return [
                0,
                0,
                0,
                0
            ];
            var startIndex = getStartIndexForOffset(this.props, scrollOffset, this._instanceProps);
            var stopIndex = getStopIndexForStartIndex(this.props, startIndex, scrollOffset, this._instanceProps); // Overscan by one item in each direction so that tab/focus works.
            // If there isn't at least one extra item, tab loops back around.
            var overscanBackward = !isScrolling || scrollDirection === 'backward' ? Math.max(1, overscanCount) : 1;
            var overscanForward = !isScrolling || scrollDirection === 'forward' ? Math.max(1, overscanCount) : 1;
            return [
                Math.max(0, startIndex - overscanBackward),
                Math.max(0, Math.min(itemCount - 1, stopIndex + overscanForward)),
                startIndex,
                stopIndex
            ];
        };
        return List;
    }((0, $4Y8Vu.PureComponent)), _class.defaultProps = {
        direction: 'ltr',
        itemData: undefined,
        layout: 'vertical',
        overscanCount: 2,
        useIsScrolling: false
    }, _class;
} // NOTE: I considered further wrapping individual items with a pure ListItem component.
// This would avoid ever calling the render function for the same index more than once,
// But it would also add the overhead of a lot of components/fibers.
// I assume people already do this (render function returning a class component),
// So my doing it would just unnecessarily double the wrappers.
var $937657a3f91652b2$var$validateSharedProps$1 = function validateSharedProps(_ref2, _ref3) {
    var children = _ref2.children, direction = _ref2.direction, height = _ref2.height, layout = _ref2.layout, innerTagName = _ref2.innerTagName, outerTagName = _ref2.outerTagName, width = _ref2.width;
    var instance = _ref3.instance;
    var isHorizontal;
};
var $937657a3f91652b2$var$DEFAULT_ESTIMATED_ITEM_SIZE$1 = 50;
var $937657a3f91652b2$var$getItemMetadata$1 = function getItemMetadata(props, index, instanceProps) {
    var _ref = props, itemSize = _ref.itemSize;
    var itemMetadataMap = instanceProps.itemMetadataMap, lastMeasuredIndex = instanceProps.lastMeasuredIndex;
    if (index > lastMeasuredIndex) {
        var offset = 0;
        if (lastMeasuredIndex >= 0) {
            var itemMetadata = itemMetadataMap[lastMeasuredIndex];
            offset = itemMetadata.offset + itemMetadata.size;
        }
        for(var i = lastMeasuredIndex + 1; i <= index; i++){
            var size = itemSize(i);
            itemMetadataMap[i] = {
                offset: offset,
                size: size
            };
            offset += size;
        }
        instanceProps.lastMeasuredIndex = index;
    }
    return itemMetadataMap[index];
};
var $937657a3f91652b2$var$findNearestItem$1 = function findNearestItem(props, instanceProps, offset) {
    var itemMetadataMap = instanceProps.itemMetadataMap, lastMeasuredIndex = instanceProps.lastMeasuredIndex;
    var lastMeasuredItemOffset = lastMeasuredIndex > 0 ? itemMetadataMap[lastMeasuredIndex].offset : 0;
    if (lastMeasuredItemOffset >= offset) // If we've already measured items within this range just use a binary search as it's faster.
    return $937657a3f91652b2$var$findNearestItemBinarySearch$1(props, instanceProps, lastMeasuredIndex, 0, offset);
    else // If we haven't yet measured this high, fallback to an exponential search with an inner binary search.
    // The exponential search avoids pre-computing sizes for the full set of items as a binary search would.
    // The overall complexity for this approach is O(log n).
    return $937657a3f91652b2$var$findNearestItemExponentialSearch$1(props, instanceProps, Math.max(0, lastMeasuredIndex), offset);
};
var $937657a3f91652b2$var$findNearestItemBinarySearch$1 = function findNearestItemBinarySearch(props, instanceProps, high, low, offset) {
    while(low <= high){
        var middle = low + Math.floor((high - low) / 2);
        var currentOffset = $937657a3f91652b2$var$getItemMetadata$1(props, middle, instanceProps).offset;
        if (currentOffset === offset) return middle;
        else if (currentOffset < offset) low = middle + 1;
        else if (currentOffset > offset) high = middle - 1;
    }
    if (low > 0) return low - 1;
    else return 0;
};
var $937657a3f91652b2$var$findNearestItemExponentialSearch$1 = function findNearestItemExponentialSearch(props, instanceProps, index, offset) {
    var itemCount = props.itemCount;
    var interval = 1;
    while(index < itemCount && $937657a3f91652b2$var$getItemMetadata$1(props, index, instanceProps).offset < offset){
        index += interval;
        interval *= 2;
    }
    return $937657a3f91652b2$var$findNearestItemBinarySearch$1(props, instanceProps, Math.min(index, itemCount - 1), Math.floor(index / 2), offset);
};
var $937657a3f91652b2$var$getEstimatedTotalSize = function getEstimatedTotalSize(_ref2, _ref3) {
    var itemCount = _ref2.itemCount;
    var itemMetadataMap = _ref3.itemMetadataMap, estimatedItemSize = _ref3.estimatedItemSize, lastMeasuredIndex = _ref3.lastMeasuredIndex;
    var totalSizeOfMeasuredItems = 0; // Edge case check for when the number of items decreases while a scroll is in progress.
    // https://github.com/bvaughn/react-window/pull/138
    if (lastMeasuredIndex >= itemCount) lastMeasuredIndex = itemCount - 1;
    if (lastMeasuredIndex >= 0) {
        var itemMetadata = itemMetadataMap[lastMeasuredIndex];
        totalSizeOfMeasuredItems = itemMetadata.offset + itemMetadata.size;
    }
    var numUnmeasuredItems = itemCount - lastMeasuredIndex - 1;
    var totalSizeOfUnmeasuredItems = numUnmeasuredItems * estimatedItemSize;
    return totalSizeOfMeasuredItems + totalSizeOfUnmeasuredItems;
};
var $937657a3f91652b2$export$d8ac3b6b20be856e = /*#__PURE__*/ $937657a3f91652b2$var$createListComponent({
    getItemOffset: function getItemOffset(props, index, instanceProps) {
        return $937657a3f91652b2$var$getItemMetadata$1(props, index, instanceProps).offset;
    },
    getItemSize: function getItemSize(props, index, instanceProps) {
        return instanceProps.itemMetadataMap[index].size;
    },
    getEstimatedTotalSize: $937657a3f91652b2$var$getEstimatedTotalSize,
    getOffsetForIndexAndAlignment: function getOffsetForIndexAndAlignment(props, index, align, scrollOffset, instanceProps, scrollbarSize) {
        var direction = props.direction, height = props.height, layout = props.layout, width = props.width; // TODO Deprecate direction "horizontal"
        var isHorizontal = direction === 'horizontal' || layout === 'horizontal';
        var size = isHorizontal ? width : height;
        var itemMetadata = $937657a3f91652b2$var$getItemMetadata$1(props, index, instanceProps); // Get estimated total size after ItemMetadata is computed,
        // To ensure it reflects actual measurements instead of just estimates.
        var estimatedTotalSize = $937657a3f91652b2$var$getEstimatedTotalSize(props, instanceProps);
        var maxOffset = Math.max(0, Math.min(estimatedTotalSize - size, itemMetadata.offset));
        var minOffset = Math.max(0, itemMetadata.offset - size + itemMetadata.size + scrollbarSize);
        if (align === 'smart') {
            if (scrollOffset >= minOffset - size && scrollOffset <= maxOffset + size) align = 'auto';
            else align = 'center';
        }
        switch(align){
            case 'start':
                return maxOffset;
            case 'end':
                return minOffset;
            case 'center':
                return Math.round(minOffset + (maxOffset - minOffset) / 2);
            case 'auto':
            default:
                if (scrollOffset >= minOffset && scrollOffset <= maxOffset) return scrollOffset;
                else if (scrollOffset < minOffset) return minOffset;
                else return maxOffset;
        }
    },
    getStartIndexForOffset: function getStartIndexForOffset(props, offset, instanceProps) {
        return $937657a3f91652b2$var$findNearestItem$1(props, instanceProps, offset);
    },
    getStopIndexForStartIndex: function getStopIndexForStartIndex(props, startIndex, scrollOffset, instanceProps) {
        var direction = props.direction, height = props.height, itemCount = props.itemCount, layout = props.layout, width = props.width; // TODO Deprecate direction "horizontal"
        var isHorizontal = direction === 'horizontal' || layout === 'horizontal';
        var size = isHorizontal ? width : height;
        var itemMetadata = $937657a3f91652b2$var$getItemMetadata$1(props, startIndex, instanceProps);
        var maxOffset = scrollOffset + size;
        var offset = itemMetadata.offset + itemMetadata.size;
        var stopIndex = startIndex;
        while(stopIndex < itemCount - 1 && offset < maxOffset){
            stopIndex++;
            offset += $937657a3f91652b2$var$getItemMetadata$1(props, stopIndex, instanceProps).size;
        }
        return stopIndex;
    },
    initInstanceProps: function initInstanceProps(props, instance) {
        var _ref4 = props, estimatedItemSize = _ref4.estimatedItemSize;
        var instanceProps = {
            itemMetadataMap: {},
            estimatedItemSize: estimatedItemSize || $937657a3f91652b2$var$DEFAULT_ESTIMATED_ITEM_SIZE$1,
            lastMeasuredIndex: -1
        };
        instance.resetAfterIndex = function(index, shouldForceUpdate) {
            if (shouldForceUpdate === void 0) shouldForceUpdate = true;
            instanceProps.lastMeasuredIndex = Math.min(instanceProps.lastMeasuredIndex, index - 1); // We could potentially optimize further by only evicting styles after this index,
            // But since styles are only cached while scrolling is in progress-
            // It seems an unnecessary optimization.
            // It's unlikely that resetAfterIndex() will be called while a user is scrolling.
            instance._getItemStyleCache(-1);
            if (shouldForceUpdate) instance.forceUpdate();
        };
        return instanceProps;
    },
    shouldResetStyleCacheOnItemSizeChange: false,
    validateProps: function validateProps(_ref5) {
        var itemSize = _ref5.itemSize;
    }
});
var $937657a3f91652b2$export$f331158cccad7361 = /*#__PURE__*/ $937657a3f91652b2$var$createGridComponent({
    getColumnOffset: function getColumnOffset(_ref, index) {
        var columnWidth = _ref.columnWidth;
        return index * columnWidth;
    },
    getColumnWidth: function getColumnWidth(_ref2, index) {
        var columnWidth = _ref2.columnWidth;
        return columnWidth;
    },
    getRowOffset: function getRowOffset(_ref3, index) {
        var rowHeight = _ref3.rowHeight;
        return index * rowHeight;
    },
    getRowHeight: function getRowHeight(_ref4, index) {
        var rowHeight = _ref4.rowHeight;
        return rowHeight;
    },
    getEstimatedTotalHeight: function getEstimatedTotalHeight(_ref5) {
        var rowCount = _ref5.rowCount, rowHeight = _ref5.rowHeight;
        return rowHeight * rowCount;
    },
    getEstimatedTotalWidth: function getEstimatedTotalWidth(_ref6) {
        var columnCount = _ref6.columnCount, columnWidth = _ref6.columnWidth;
        return columnWidth * columnCount;
    },
    getOffsetForColumnAndAlignment: function getOffsetForColumnAndAlignment(_ref7, columnIndex, align, scrollLeft, instanceProps, scrollbarSize) {
        var columnCount = _ref7.columnCount, columnWidth = _ref7.columnWidth, width = _ref7.width;
        var lastColumnOffset = Math.max(0, columnCount * columnWidth - width);
        var maxOffset = Math.min(lastColumnOffset, columnIndex * columnWidth);
        var minOffset = Math.max(0, columnIndex * columnWidth - width + scrollbarSize + columnWidth);
        if (align === 'smart') {
            if (scrollLeft >= minOffset - width && scrollLeft <= maxOffset + width) align = 'auto';
            else align = 'center';
        }
        switch(align){
            case 'start':
                return maxOffset;
            case 'end':
                return minOffset;
            case 'center':
                // "Centered" offset is usually the average of the min and max.
                // But near the edges of the list, this doesn't hold true.
                var middleOffset = Math.round(minOffset + (maxOffset - minOffset) / 2);
                if (middleOffset < Math.ceil(width / 2)) return 0; // near the beginning
                else if (middleOffset > lastColumnOffset + Math.floor(width / 2)) return lastColumnOffset; // near the end
                else return middleOffset;
            case 'auto':
            default:
                if (scrollLeft >= minOffset && scrollLeft <= maxOffset) return scrollLeft;
                else if (minOffset > maxOffset) // Because we only take into account the scrollbar size when calculating minOffset
                // this value can be larger than maxOffset when at the end of the list
                return minOffset;
                else if (scrollLeft < minOffset) return minOffset;
                else return maxOffset;
        }
    },
    getOffsetForRowAndAlignment: function getOffsetForRowAndAlignment(_ref8, rowIndex, align, scrollTop, instanceProps, scrollbarSize) {
        var rowHeight = _ref8.rowHeight, height = _ref8.height, rowCount = _ref8.rowCount;
        var lastRowOffset = Math.max(0, rowCount * rowHeight - height);
        var maxOffset = Math.min(lastRowOffset, rowIndex * rowHeight);
        var minOffset = Math.max(0, rowIndex * rowHeight - height + scrollbarSize + rowHeight);
        if (align === 'smart') {
            if (scrollTop >= minOffset - height && scrollTop <= maxOffset + height) align = 'auto';
            else align = 'center';
        }
        switch(align){
            case 'start':
                return maxOffset;
            case 'end':
                return minOffset;
            case 'center':
                // "Centered" offset is usually the average of the min and max.
                // But near the edges of the list, this doesn't hold true.
                var middleOffset = Math.round(minOffset + (maxOffset - minOffset) / 2);
                if (middleOffset < Math.ceil(height / 2)) return 0; // near the beginning
                else if (middleOffset > lastRowOffset + Math.floor(height / 2)) return lastRowOffset; // near the end
                else return middleOffset;
            case 'auto':
            default:
                if (scrollTop >= minOffset && scrollTop <= maxOffset) return scrollTop;
                else if (minOffset > maxOffset) // Because we only take into account the scrollbar size when calculating minOffset
                // this value can be larger than maxOffset when at the end of the list
                return minOffset;
                else if (scrollTop < minOffset) return minOffset;
                else return maxOffset;
        }
    },
    getColumnStartIndexForOffset: function getColumnStartIndexForOffset(_ref9, scrollLeft) {
        var columnWidth = _ref9.columnWidth, columnCount = _ref9.columnCount;
        return Math.max(0, Math.min(columnCount - 1, Math.floor(scrollLeft / columnWidth)));
    },
    getColumnStopIndexForStartIndex: function getColumnStopIndexForStartIndex(_ref10, startIndex, scrollLeft) {
        var columnWidth = _ref10.columnWidth, columnCount = _ref10.columnCount, width = _ref10.width;
        var left = startIndex * columnWidth;
        var numVisibleColumns = Math.ceil((width + scrollLeft - left) / columnWidth);
        return Math.max(0, Math.min(columnCount - 1, startIndex + numVisibleColumns - 1 // -1 is because stop index is inclusive
        ));
    },
    getRowStartIndexForOffset: function getRowStartIndexForOffset(_ref11, scrollTop) {
        var rowHeight = _ref11.rowHeight, rowCount = _ref11.rowCount;
        return Math.max(0, Math.min(rowCount - 1, Math.floor(scrollTop / rowHeight)));
    },
    getRowStopIndexForStartIndex: function getRowStopIndexForStartIndex(_ref12, startIndex, scrollTop) {
        var rowHeight = _ref12.rowHeight, rowCount = _ref12.rowCount, height = _ref12.height;
        var top = startIndex * rowHeight;
        var numVisibleRows = Math.ceil((height + scrollTop - top) / rowHeight);
        return Math.max(0, Math.min(rowCount - 1, startIndex + numVisibleRows - 1 // -1 is because stop index is inclusive
        ));
    },
    initInstanceProps: function initInstanceProps(props) {},
    shouldResetStyleCacheOnItemSizeChange: true,
    validateProps: function validateProps(_ref13) {
        var columnWidth = _ref13.columnWidth, rowHeight = _ref13.rowHeight;
    }
});
var $937657a3f91652b2$export$ae9e55e1d8a2f4b7 = /*#__PURE__*/ $937657a3f91652b2$var$createListComponent({
    getItemOffset: function getItemOffset(_ref, index) {
        var itemSize = _ref.itemSize;
        return index * itemSize;
    },
    getItemSize: function getItemSize(_ref2, index) {
        var itemSize = _ref2.itemSize;
        return itemSize;
    },
    getEstimatedTotalSize: function getEstimatedTotalSize(_ref3) {
        var itemCount = _ref3.itemCount, itemSize = _ref3.itemSize;
        return itemSize * itemCount;
    },
    getOffsetForIndexAndAlignment: function getOffsetForIndexAndAlignment(_ref4, index, align, scrollOffset, instanceProps, scrollbarSize) {
        var direction = _ref4.direction, height = _ref4.height, itemCount = _ref4.itemCount, itemSize = _ref4.itemSize, layout = _ref4.layout, width = _ref4.width;
        // TODO Deprecate direction "horizontal"
        var isHorizontal = direction === 'horizontal' || layout === 'horizontal';
        var size = isHorizontal ? width : height;
        var lastItemOffset = Math.max(0, itemCount * itemSize - size);
        var maxOffset = Math.min(lastItemOffset, index * itemSize);
        var minOffset = Math.max(0, index * itemSize - size + itemSize + scrollbarSize);
        if (align === 'smart') {
            if (scrollOffset >= minOffset - size && scrollOffset <= maxOffset + size) align = 'auto';
            else align = 'center';
        }
        switch(align){
            case 'start':
                return maxOffset;
            case 'end':
                return minOffset;
            case 'center':
                // "Centered" offset is usually the average of the min and max.
                // But near the edges of the list, this doesn't hold true.
                var middleOffset = Math.round(minOffset + (maxOffset - minOffset) / 2);
                if (middleOffset < Math.ceil(size / 2)) return 0; // near the beginning
                else if (middleOffset > lastItemOffset + Math.floor(size / 2)) return lastItemOffset; // near the end
                else return middleOffset;
            case 'auto':
            default:
                if (scrollOffset >= minOffset && scrollOffset <= maxOffset) return scrollOffset;
                else if (scrollOffset < minOffset) return minOffset;
                else return maxOffset;
        }
    },
    getStartIndexForOffset: function getStartIndexForOffset(_ref5, offset) {
        var itemCount = _ref5.itemCount, itemSize = _ref5.itemSize;
        return Math.max(0, Math.min(itemCount - 1, Math.floor(offset / itemSize)));
    },
    getStopIndexForStartIndex: function getStopIndexForStartIndex(_ref6, startIndex, scrollOffset) {
        var direction = _ref6.direction, height = _ref6.height, itemCount = _ref6.itemCount, itemSize = _ref6.itemSize, layout = _ref6.layout, width = _ref6.width;
        // TODO Deprecate direction "horizontal"
        var isHorizontal = direction === 'horizontal' || layout === 'horizontal';
        var offset = startIndex * itemSize;
        var size = isHorizontal ? width : height;
        var numVisibleItems = Math.ceil((size + scrollOffset - offset) / itemSize);
        return Math.max(0, Math.min(itemCount - 1, startIndex + numVisibleItems - 1 // -1 is because stop index is inclusive
        ));
    },
    initInstanceProps: function initInstanceProps(props) {},
    shouldResetStyleCacheOnItemSizeChange: true,
    validateProps: function validateProps(_ref7) {
        var itemSize = _ref7.itemSize;
    }
});
// Pulled from react-compat
// https://github.com/developit/preact-compat/blob/7c5de00e7c85e2ffd011bf3af02899b63f699d3a/src/index.js#L349
function $937657a3f91652b2$var$shallowDiffers(prev, next) {
    for(var attribute in prev){
        if (!(attribute in next)) return true;
    }
    for(var _attribute in next){
        if (prev[_attribute] !== next[_attribute]) return true;
    }
    return false;
}
var $937657a3f91652b2$var$_excluded = [
    "style"
], $937657a3f91652b2$var$_excluded2 = [
    "style"
];
// It knows to compare individual style props and ignore the wrapper object.
// See https://reactjs.org/docs/react-api.html#reactmemo
function $937657a3f91652b2$export$b141efd0b0fb9174(prevProps, nextProps) {
    var prevStyle = prevProps.style, prevRest = (0, $15707d6ca67adf63$export$2e2bcd8739ae039)(prevProps, $937657a3f91652b2$var$_excluded);
    var nextStyle = nextProps.style, nextRest = (0, $15707d6ca67adf63$export$2e2bcd8739ae039)(nextProps, $937657a3f91652b2$var$_excluded2);
    return !$937657a3f91652b2$var$shallowDiffers(prevStyle, nextStyle) && !$937657a3f91652b2$var$shallowDiffers(prevRest, nextRest);
}
// It knows to compare individual style props and ignore the wrapper object.
// See https://reactjs.org/docs/react-component.html#shouldcomponentupdate
function $937657a3f91652b2$export$aa365c903ed149ff(nextProps, nextState) {
    return !$937657a3f91652b2$export$b141efd0b0fb9174(this.props, nextProps) || $937657a3f91652b2$var$shallowDiffers(this.state, nextState);
}


const $378b90f0f2f43004$var$customStyles = {
    control: (provided, state)=>{
        let borderColor = "#d8d8d8";
        if (state.isFocused) borderColor = "#ed6842";
        if (!!state.selectProps["data-error"]) borderColor = "#dc3545";
        return (0, $8f44472fa5eb25c0$export$71511d61b312f219)((0, $45c1a8590053a015$export$71511d61b312f219)({}, provided), {
            minHeight: 44,
            borderWidth: 2,
            borderColor: borderColor,
            borderRadius: 0,
            boxShadow: "none",
            "&:hover": {
                borderColor: borderColor
            }
        });
    },
    dropdownIndicator: (provided, state)=>(0, $8f44472fa5eb25c0$export$71511d61b312f219)((0, $45c1a8590053a015$export$71511d61b312f219)({}, provided), {
            color: state.isFocused ? "#ed6842" : "#d8d8d8"
        }),
    menu: (provided)=>(0, $8f44472fa5eb25c0$export$71511d61b312f219)((0, $45c1a8590053a015$export$71511d61b312f219)({}, provided), {
            zIndex: 100,
            borderWidth: 1,
            borderStyle: "solid",
            borderColor: "#d8d8d8",
            borderRadius: 0
        }),
    option: (provided, state)=>{
        let backgroundColor = "#fff";
        if (state.isFocused) backgroundColor = "#eee";
        if (state.isSelected) backgroundColor = "#ed6842";
        return (0, $8f44472fa5eb25c0$export$71511d61b312f219)((0, $45c1a8590053a015$export$71511d61b312f219)({}, provided), {
            color: state.isSelected ? "#fff" : "#444",
            backgroundColor: backgroundColor,
            "&:active": {
                backgroundColor: backgroundColor
            }
        });
    }
};
const $378b90f0f2f43004$var$Select = (_param)=>{
    var { label: label, info: info, name: name, control: control, defaultValue: defaultValue, options: options = [], placeholder: placeholder, validation: validation, error: error, isLoading: isLoading = false } = _param, props = (0, $30c24b3cbf3b0a7a$export$71511d61b312f219)(_param, [
        "label",
        "info",
        "name",
        "control",
        "defaultValue",
        "options",
        "placeholder",
        "validation",
        "error",
        "isLoading"
    ]);
    return /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsxs)("div", {
        className: (0, $747032d831df0173$export$2e2bcd8739ae039)("form-group", !!(validation === null || validation === void 0 ? void 0 : validation.required) && "required", error && "invalid"),
        children: [
            /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsxs)("label", {
                htmlFor: `${name}_select`,
                className: "form-label",
                children: [
                    label,
                    info && /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)("span", {
                        className: "form-info-icon",
                        title: info,
                        children: "i"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)((0, $89763f9db12fbe81$export$bd0bf19f25da8474), {
                name: name,
                control: control,
                defaultValue: defaultValue,
                rules: validation,
                render: ({ field: field })=>/*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)((0, $93806ea81e977dc9$export$2e2bcd8739ae039), (0, $8f44472fa5eb25c0$export$71511d61b312f219)((0, $45c1a8590053a015$export$71511d61b312f219)({}, field, props), {
                        id: `${name}_select`,
                        instanceId: `${name}_select`,
                        options: options,
                        value: options.find((option)=>option.value === field.value),
                        styles: $378b90f0f2f43004$var$customStyles,
                        placeholder: isLoading ? "Loading..." : placeholder,
                        onChange: (value)=>field.onChange(value === null || value === void 0 ? void 0 : value.value),
                        onBlur: (e)=>e.preventDefault(),
                        "data-error": error,
                        isLoading: isLoading
                    }))
            }),
            error && /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)("div", {
                className: "invalid-feedback mt-1",
                children: error.message
            })
        ]
    });
};
var $378b90f0f2f43004$export$2e2bcd8739ae039 = $378b90f0f2f43004$var$Select;
const $378b90f0f2f43004$export$bbd05575237de7c6 = ({ options: options, children: children, maxHeight: maxHeight, getValue: getValue })=>{
    const height = 40; // Height of each option
    const selectedValue = getValue()[0]; // Currently selected value
    const initialIndex = options.findIndex((option)=>option.value === (selectedValue === null || selectedValue === void 0 ? void 0 : selectedValue.value));
    return /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)((0, $937657a3f91652b2$export$ae9e55e1d8a2f4b7), {
        height: Math.min(maxHeight, children.length * height),
        itemCount: children.length,
        itemSize: height,
        initialScrollOffset: Math.max(0, initialIndex * height),
        children: ({ index: index, style: style })=>/*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)("div", {
                style: style,
                children: children[index]
            })
    });
};






const $b723499cd35e7763$var$Radio = (_param)=>{
    var { label: label, name: name, options: options, inline: inline, defaultValue: defaultValue, register: register, validation: validation, error: error } = _param, other = (0, $30c24b3cbf3b0a7a$export$71511d61b312f219)(_param, [
        "label",
        "name",
        "options",
        "inline",
        "defaultValue",
        "register",
        "validation",
        "error"
    ]);
    return /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsxs)("fieldset", {
        className: (0, $747032d831df0173$export$2e2bcd8739ae039)("form-group", !!(validation === null || validation === void 0 ? void 0 : validation.required) && "required", error && "invalid"),
        children: [
            /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)("legend", {
                htmlFor: `${name}_input`,
                className: "form-label",
                children: label
            }),
            options.map((option)=>/*#__PURE__*/ (0, $65eed959c02d7598$exports.jsxs)("div", {
                    className: (0, $747032d831df0173$export$2e2bcd8739ae039)("form-check align-items-center", inline && "form-check-inline"),
                    children: [
                        /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)("input", (0, $45c1a8590053a015$export$71511d61b312f219)({
                            type: "radio",
                            id: `${name}-${option.value}`,
                            className: "form-check-input",
                            value: option.value,
                            defaultChecked: defaultValue === option.value
                        }, register(name, validation), other)),
                        /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)("label", {
                            htmlFor: `${name}-${option.value}`,
                            className: "form-check-label",
                            children: option.label
                        })
                    ]
                }, `${name}-${option.value}`)),
            error && /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)("div", {
                className: "invalid-feedback mt-2",
                children: error.message
            })
        ]
    });
};
var $b723499cd35e7763$export$2e2bcd8739ae039 = $b723499cd35e7763$var$Radio;




var $4Y8Vu = parcelRequire("4Y8Vu");


var $4Y8Vu = parcelRequire("4Y8Vu");
function $98321c8f8d0135ab$export$e70e6da722faba05(u, e, c) {
    var i = this, a = (0, $4Y8Vu.useRef)(null), o = (0, $4Y8Vu.useRef)(0), f = (0, $4Y8Vu.useRef)(null), l = (0, $4Y8Vu.useRef)([]), m = (0, $4Y8Vu.useRef)(), v = (0, $4Y8Vu.useRef)(), d = (0, $4Y8Vu.useRef)(u), p = (0, $4Y8Vu.useRef)(!0);
    (0, $4Y8Vu.useEffect)(function() {
        d.current = u;
    }, [
        u
    ]);
    var g = !e && 0 !== e && "undefined" != typeof window;
    if ("function" != typeof u) throw new TypeError("Expected a function");
    e = +e || 0;
    var w = !!(c = c || {}).leading, s = !("trailing" in c) || !!c.trailing, x = "maxWait" in c, y = x ? Math.max(+c.maxWait || 0, e) : null;
    (0, $4Y8Vu.useEffect)(function() {
        return p.current = !0, function() {
            p.current = !1;
        };
    }, []);
    var h = (0, $4Y8Vu.useMemo)(function() {
        var r = function(r) {
            var n = l.current, t = m.current;
            return l.current = m.current = null, o.current = r, v.current = d.current.apply(t, n);
        }, n = function(r, n) {
            g && cancelAnimationFrame(f.current), f.current = g ? requestAnimationFrame(r) : setTimeout(r, n);
        }, t = function(r) {
            if (!p.current) return !1;
            var n = r - a.current;
            return !a.current || n >= e || n < 0 || x && r - o.current >= y;
        }, u = function(n) {
            return f.current = null, s && l.current ? r(n) : (l.current = m.current = null, v.current);
        }, c = function r() {
            var c = Date.now();
            if (t(c)) return u(c);
            if (p.current) {
                var i = e - (c - a.current), f = x ? Math.min(i, y - (c - o.current)) : i;
                n(r, f);
            }
        }, h = function() {
            var u = Date.now(), d = t(u);
            if (l.current = [].slice.call(arguments), m.current = i, a.current = u, d) {
                if (!f.current && p.current) return o.current = a.current, n(c, e), w ? r(a.current) : v.current;
                if (x) return n(c, e), r(a.current);
            }
            return f.current || n(c, e), v.current;
        };
        return h.cancel = function() {
            f.current && (g ? cancelAnimationFrame(f.current) : clearTimeout(f.current)), o.current = 0, l.current = a.current = m.current = f.current = null;
        }, h.isPending = function() {
            return !!f.current;
        }, h.flush = function() {
            return f.current ? u(Date.now()) : v.current;
        }, h;
    }, [
        w,
        x,
        e,
        y,
        s,
        g
    ]);
    return h;
}
function $98321c8f8d0135ab$var$i(r, n) {
    return r === n;
}
function $98321c8f8d0135ab$var$a(r) {
    return "function" == typeof r ? function() {
        return r;
    } : r;
}
function $98321c8f8d0135ab$export$21805fee57372823(n, t, o) {
    var f, l, m = o && o.equalityFn || $98321c8f8d0135ab$var$i, v = (f = (0, $4Y8Vu.useState)($98321c8f8d0135ab$var$a(n)), l = f[1], [
        f[0],
        (0, $4Y8Vu.useCallback)(function(r) {
            return l($98321c8f8d0135ab$var$a(r));
        }, [])
    ]), d = v[0], p = v[1], g = $98321c8f8d0135ab$export$e70e6da722faba05((0, $4Y8Vu.useCallback)(function(r) {
        return p(r);
    }, [
        p
    ]), t, o), w = (0, $4Y8Vu.useRef)(n);
    return m(w.current, n) || (g(n), w.current = n), [
        d,
        g
    ];
}
function $98321c8f8d0135ab$export$7158785e55df0693(r, n, t) {
    var u = void 0 === t ? {} : t, e = u.leading, i = u.trailing;
    return $98321c8f8d0135ab$export$e70e6da722faba05(r, n, {
        maxWait: n,
        leading: void 0 === e || e,
        trailing: void 0 === i || i
    });
}


const $05bf20bc7e7084be$var$AddressLookup = ({ onSubmit: onSubmit, error: error })=>{
    const [term, setTerm] = (0, $4Y8Vu.useState)("");
    const [suggestions, setSuggestions] = (0, $4Y8Vu.useState)(null);
    const fetchSuggestions = (0, $98321c8f8d0135ab$export$e70e6da722faba05)(async (term)=>{
        const result = await fetch(`${api.url}/address-lookup?term=${term}`);
        const data = await result.json();
        setSuggestions(data);
    }, 500);
    (0, $4Y8Vu.useEffect)(()=>{
        if (term.length < 3) setSuggestions(null);
        else fetchSuggestions(term);
    }, [
        term
    ]);
    const handleAddress = async (id)=>{
        const result = await fetch(`${api.url}/address-lookup/${id}`);
        const data = await result.json();
        onSubmit(data);
    };
    return /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsxs)("div", {
        className: (0, $747032d831df0173$export$2e2bcd8739ae039)("form-group", "required", error && "invalid"),
        children: [
            /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)("label", {
                className: "form-label",
                htmlFor: "AddressLookup",
                children: "Address"
            }),
            /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)("input", {
                type: "text",
                placeholder: "Search address...",
                className: "form-control",
                value: term,
                onChange: (e)=>setTerm(e.target.value),
                autoComplete: "off",
                autoComplete: "chrome-off"
            }),
            suggestions && /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsxs)("ul", {
                className: "form-autocomplete",
                "aria-expanded": "true",
                children: [
                    !suggestions.length && /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)("li", {
                        className: "no-results",
                        children: /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)("em", {
                            children: "No addresses found"
                        })
                    }),
                    suggestions.map((suggestion)=>/*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)("li", {
                            children: /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)("button", {
                                type: "button",
                                onClick: ()=>handleAddress(suggestion.id),
                                children: suggestion.address
                            })
                        }, suggestion.id))
                ]
            }),
            error && /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)("div", {
                className: "invalid-feedback",
                children: error.message
            })
        ]
    });
};
var $05bf20bc7e7084be$export$2e2bcd8739ae039 = $05bf20bc7e7084be$var$AddressLookup;


const $18997da1559b0013$var$fetcher = (endpoint)=>{
    return async ()=>{
        try {
            const res = await fetch(api.url + endpoint);
            return await res.json();
        } catch (error) {
            console.error(error);
            return null;
        }
    };
};
const $18997da1559b0013$export$1cd3ed34adda6afb = $18997da1559b0013$var$fetcher("/benefits");
const $18997da1559b0013$export$44f7508c6c352cc6 = $18997da1559b0013$var$fetcher("/countries");
const $18997da1559b0013$export$9bebd9a7a0c2cf34 = $18997da1559b0013$var$fetcher("/disabilities");
const $18997da1559b0013$export$dc9e82ea61b7b5fa = $18997da1559b0013$var$fetcher("/disabilities-learning-difficulties");
const $18997da1559b0013$export$62ab29374050bbde = $18997da1559b0013$var$fetcher("/employment-intensities");
const $18997da1559b0013$export$f26c9a1685001982 = $18997da1559b0013$var$fetcher("/employment-lengths");
const $18997da1559b0013$export$7acdecf75c1d2792 = $18997da1559b0013$var$fetcher("/employment-statuses");
const $18997da1559b0013$export$9d4521120c9c549b = $18997da1559b0013$var$fetcher("/ethnicities");
const $18997da1559b0013$export$3d3ea4e0e6ea8c54 = $18997da1559b0013$var$fetcher("/genders");
const $18997da1559b0013$export$e4eea529fcb0b4f0 = $18997da1559b0013$var$fetcher("/household-situations");
const $18997da1559b0013$export$6c92aa14a77b72f5 = $18997da1559b0013$var$fetcher("/learning-difficulties");
const $18997da1559b0013$export$5ac6cc32fb25fa6e = $18997da1559b0013$var$fetcher("/nationalities");
const $18997da1559b0013$export$2154b715912f9d42 = $18997da1559b0013$var$fetcher("/prior-attainment-levels");
const $18997da1559b0013$export$4234f37d13f7271a = $18997da1559b0013$var$fetcher("/qualifications");
const $18997da1559b0013$export$2dccbe657ab23dc = $18997da1559b0013$var$fetcher("/qualification");
const $18997da1559b0013$export$eba4d43ca46b7353 = $18997da1559b0013$var$fetcher("/schools");
const $18997da1559b0013$export$d12772bd0dd951a2 = (id)=>$18997da1559b0013$var$fetcher(`/statements/${id}`)();
const $18997da1559b0013$export$965b5fd3c89734c9 = $18997da1559b0013$var$fetcher("/titles");
const $18997da1559b0013$export$867f818e1792266b = $18997da1559b0013$var$fetcher("/unemployment-lengths");



const $50842bd933b9f179$export$cbf315268bff9bd2 = (defaults, data)=>{
    let values = (0, $45c1a8590053a015$export$71511d61b312f219)({}, defaults);
    if (!data) return values;
    for (const [key, value] of Object.entries(values))values[key] = data.hasOwnProperty(key) ? data[key] : value;
    return values;
};


const $4c8d0e2996c4d41a$var$defaultValues = {
    Title: "",
    FirstForename: "",
    Surname: "",
    OtherForenames: "",
    Sex: "",
    StudentDetailUserDefined34: "",
    DateOfBirth: "",
    Email: "",
    Email2: "",
    MobileTel: "",
    Address: false,
    AddressLookup: "",
    Postcode: "",
    Address1: "",
    Address2: "",
    Address3: "",
    Address4: ""
};
const $4c8d0e2996c4d41a$var$PersonalDetails = ({ type: type, data: data, onSubmit: onSubmitSuccess })=>{
    const titles = (0, $57c3b87db6e4f350$export$dd0a697e1782aedd)("titles", (0, $18997da1559b0013$export$965b5fd3c89734c9));
    const genders = (0, $57c3b87db6e4f350$export$dd0a697e1782aedd)("genders", (0, $18997da1559b0013$export$3d3ea4e0e6ea8c54));
    const { control: control, register: register, handleSubmit: handleSubmit, formState: formState, watch: watch, setError: setError, setValue: setValue, clearErrors: clearErrors } = (0, $89763f9db12fbe81$export$87c0cf8eb5a167e0)({
        mode: "all",
        defaultValues: (0, $50842bd933b9f179$export$cbf315268bff9bd2)($4c8d0e2996c4d41a$var$defaultValues, data)
    });
    const { errors: errors, isSubmitting: isSubmitting } = formState;
    const email = watch("Email");
    const [addressLookup, setAddressLookup] = (0, $4Y8Vu.useState)(!(data === null || data === void 0 ? void 0 : data.Address1));
    const setAddress = (address)=>{
        setValue("Address1", address === null || address === void 0 ? void 0 : address.line_1);
        setValue("Address2", (address === null || address === void 0 ? void 0 : address.line_2) !== "" ? address.line_2 : address === null || address === void 0 ? void 0 : address.locality);
        setValue("Address3", address === null || address === void 0 ? void 0 : address.town_or_city);
        setValue("Address4", address === null || address === void 0 ? void 0 : address.county);
        setValue("Postcode", address === null || address === void 0 ? void 0 : address.postcode);
        clearErrors("AddressLookup");
        setAddressLookup(false);
    };
    const clearAddress = ()=>{
        setValue("Address1", "");
        setValue("Address2", "");
        setValue("Address3", "");
        setValue("Address4", "");
        setValue("Postcode", "");
        setAddressLookup(true);
    };
    const onSubmit = (data)=>{
        if (!(data === null || data === void 0 ? void 0 : data.Address1)) setError("AddressLookup", {
            type: "manual",
            message: "Please enter an address."
        });
        else onSubmitSuccess(data);
    };
    return /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsxs)((0, $65eed959c02d7598$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)("h2", {
                children: "Personal Details"
            }),
            /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsxs)("form", {
                onSubmit: handleSubmit(onSubmit),
                children: [
                    /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)("div", {
                        className: "row",
                        children: /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)("div", {
                            className: "col-12 col-md-4",
                            children: /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)((0, $378b90f0f2f43004$export$2e2bcd8739ae039), {
                                label: "Title",
                                name: "Title",
                                control: control,
                                isLoading: titles.isLoading,
                                options: titles.data,
                                placeholder: "Please select a title"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsxs)("div", {
                        className: "row",
                        children: [
                            /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)("div", {
                                className: "col-12 col-md-6",
                                children: /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)((0, $6480d1b415ba29cd$export$2e2bcd8739ae039), {
                                    label: "First Name",
                                    name: "FirstForename",
                                    autoComplete: "given-name",
                                    register: register,
                                    validation: {
                                        required: "First name is required",
                                        maxLength: {
                                            value: 50,
                                            message: "Maximum 50 characters long"
                                        }
                                    },
                                    error: errors.FirstForename
                                })
                            }),
                            /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)("div", {
                                className: "col-12 col-md-6",
                                children: /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)((0, $6480d1b415ba29cd$export$2e2bcd8739ae039), {
                                    label: "Surname",
                                    name: "Surname",
                                    autoComplete: "family-name",
                                    register: register,
                                    validation: {
                                        required: "Surname is required",
                                        maxLength: {
                                            value: 30,
                                            message: "Maximum 30 characters long"
                                        }
                                    },
                                    error: errors.Surname
                                })
                            }),
                            /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)("div", {
                                className: "col-12 col-md-6",
                                children: /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)((0, $6480d1b415ba29cd$export$2e2bcd8739ae039), {
                                    label: "Other Names",
                                    name: "OtherForenames",
                                    autoComplete: "additional-name",
                                    register: register,
                                    validation: {
                                        maxLength: {
                                            value: 30,
                                            message: "Maximum 30 characters long"
                                        }
                                    },
                                    error: errors.OtherForenames
                                })
                            }),
                            /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)("div", {
                                className: "col-12 col-md-6",
                                children: /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)((0, $6480d1b415ba29cd$export$2e2bcd8739ae039), {
                                    type: "tel",
                                    label: "Mobile Phone",
                                    name: "MobileTel",
                                    register: register,
                                    autoComplete: "tel",
                                    validation: {
                                        required: "Phone number is required",
                                        pattern: {
                                            value: /^[0-9]{11}$/,
                                            message: "Please enter 11 digit UK number, without any special characters."
                                        },
                                        maxLength: {
                                            value: 35,
                                            message: "Maximum 35 characters long"
                                        }
                                    },
                                    error: errors.MobileTel
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsxs)("div", {
                        className: "row",
                        children: [
                            /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)("div", {
                                className: "col-12 col-md-6",
                                children: /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)((0, $b723499cd35e7763$export$2e2bcd8739ae039), {
                                    label: "Sex",
                                    name: "Sex",
                                    options: [
                                        {
                                            label: "Male",
                                            value: "M"
                                        },
                                        {
                                            label: "Female",
                                            value: "F"
                                        },
                                        {
                                            label: "Rather Not Say",
                                            value: "R"
                                        }
                                    ],
                                    autoComplete: "sex",
                                    inline: true,
                                    register: register,
                                    validation: {
                                        required: "Sex is required"
                                    },
                                    error: errors.Sex
                                })
                            }),
                            /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)("div", {
                                className: "col-12 col-md-6",
                                children: /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)((0, $378b90f0f2f43004$export$2e2bcd8739ae039), {
                                    label: "Gender",
                                    name: "StudentDetailUserDefined34",
                                    control: control,
                                    isLoading: genders.isLoading,
                                    options: genders.data,
                                    placeholder: "Please select a gender",
                                    info: "Gender identity is a way to describe how someone feels about their gender. For example, some people may identify as a male or a female, while others may find neither of these terms feel right for them, and identify as neither or somewhere in the middle.",
                                    error: errors.StudentDetailUserDefined34
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsxs)("div", {
                        className: "row",
                        children: [
                            /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)("div", {
                                className: "col-12 col-md-6",
                                children: /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)((0, $6480d1b415ba29cd$export$2e2bcd8739ae039), {
                                    type: "email",
                                    label: "Email Address",
                                    name: "Email",
                                    autoComplete: "email",
                                    register: register,
                                    description: "Use your personal email rather than your School email",
                                    validation: {
                                        required: "Email Address is required",
                                        pattern: {
                                            value: /\S+@\S+\.\S+/,
                                            message: "Please enter a valid email address"
                                        },
                                        validate: (value)=>{
                                            if (type === "enrol") return true;
                                            if ($4c8d0e2996c4d41a$var$checkSchoolEmails(value)) return "Please use your personal email rather than your School email";
                                        }
                                    },
                                    error: errors.Email
                                })
                            }),
                            /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)("div", {
                                className: "col-12 col-md-6",
                                children: /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)((0, $6480d1b415ba29cd$export$2e2bcd8739ae039), {
                                    type: "email",
                                    label: "Confirm Email Address",
                                    name: "Email2",
                                    autoComplete: "off",
                                    register: register,
                                    validation: {
                                        required: "Email Address is required",
                                        validate: (value)=>value === email || "The email addresses do not match"
                                    },
                                    error: errors.Email2
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsxs)("div", {
                        className: "row",
                        children: [
                            /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)("div", {
                                className: "col-12 col-md-6",
                                children: addressLookup && /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsxs)((0, $65eed959c02d7598$exports.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)((0, $05bf20bc7e7084be$export$2e2bcd8739ae039), {
                                            onSubmit: setAddress,
                                            error: errors.AddressLookup
                                        }),
                                        /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)("button", {
                                            type: "button",
                                            onClick: ()=>setAddressLookup(false),
                                            className: "form-link",
                                            children: "Enter address manually"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)("div", {
                                className: "col-12 col-md-6",
                                children: /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)((0, $6480d1b415ba29cd$export$2e2bcd8739ae039), {
                                    label: "Date of Birth",
                                    name: "DateOfBirth",
                                    placeholder: "dd/mm/yyyy",
                                    min: "1901-01-01",
                                    register: register,
                                    validation: {
                                        required: "Date of birth is required",
                                        pattern: {
                                            value: /^(0[1-9]|[12][0-9]|3[01])[/](0[1-9]|1[012])[/](19|20)\d\d$/,
                                            message: "Please enter date of birth in format dd/mm/yyyy"
                                        }
                                    },
                                    error: errors.DateOfBirth
                                })
                            })
                        ]
                    }),
                    !addressLookup && /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsxs)((0, $65eed959c02d7598$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsxs)("div", {
                                className: "row",
                                children: [
                                    /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)("div", {
                                        className: "col-12 col-md-6",
                                        children: /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)((0, $6480d1b415ba29cd$export$2e2bcd8739ae039), {
                                            label: "Address 1",
                                            name: "Address1",
                                            autoComplete: "address-line1",
                                            register: register,
                                            validation: {
                                                required: "Address line 1 is required."
                                            },
                                            error: errors.Address1
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)("div", {
                                        className: "col-12 col-md-6",
                                        children: /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)((0, $6480d1b415ba29cd$export$2e2bcd8739ae039), {
                                            label: "Address 2",
                                            name: "Address2",
                                            autoComplete: "address-line2",
                                            register: register,
                                            error: errors.Address2
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)("div", {
                                        className: "col-12 col-md-6",
                                        children: /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)((0, $6480d1b415ba29cd$export$2e2bcd8739ae039), {
                                            label: "Town",
                                            name: "Address3",
                                            register: register,
                                            validation: {
                                                required: "Town is required."
                                            },
                                            error: errors.Address3
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)("div", {
                                        className: "col-12 col-md-6",
                                        children: /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)((0, $6480d1b415ba29cd$export$2e2bcd8739ae039), {
                                            label: "County",
                                            name: "Address4",
                                            register: register,
                                            error: errors.Address4
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)("div", {
                                        className: "col-12 col-md-6",
                                        children: /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)((0, $6480d1b415ba29cd$export$2e2bcd8739ae039), {
                                            label: "Postcode",
                                            name: "Postcode",
                                            autoComplete: "postal-code",
                                            register: register,
                                            validation: {
                                                required: "Postcode is required."
                                            },
                                            error: errors.Postcode
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)("div", {
                                children: /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)("button", {
                                    type: "button",
                                    onClick: clearAddress,
                                    className: "form-link",
                                    children: "Search a different address"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)("button", {
                        type: "submit",
                        className: "form-submit",
                        disabled: isSubmitting,
                        children: isSubmitting ? "Saving" : "Next"
                    })
                ]
            })
        ]
    });
};
var $4c8d0e2996c4d41a$export$2e2bcd8739ae039 = $4c8d0e2996c4d41a$var$PersonalDetails;
function $4c8d0e2996c4d41a$var$checkSchoolEmails(value) {
    const excluded = [
        "stantonbury-tove.org.uk",
        "radcliffeschool.org.uk",
        "mket.org.uk",
        "sponne.org.uk",
        "haz5d.com",
        "cedarsupper.co.uk",
        "vandyke.org.uk",
        "ousedale.org.uk",
        "cottesloe.bucks.sch.uk",
        "miltonkeynesacademy.org.uk",
        "lordgrey.org.uk"
    ];
    return excluded.some((domain)=>value.endsWith(domain));
}











const $797561708eef40b7$var$Checkbox = (_param)=>{
    var { label: label, name: name, register: register, validation: validation, error: error } = _param, other = (0, $30c24b3cbf3b0a7a$export$71511d61b312f219)(_param, [
        "label",
        "name",
        "register",
        "validation",
        "error"
    ]);
    return /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsxs)("div", {
        className: "form-group",
        children: [
            /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsxs)("div", {
                className: (0, $747032d831df0173$export$2e2bcd8739ae039)("form-check align-items-center", !!(validation === null || validation === void 0 ? void 0 : validation.required) && "required", error && "invalid"),
                children: [
                    /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)("input", (0, $45c1a8590053a015$export$71511d61b312f219)({
                        type: "checkbox",
                        id: `${name}_checkbox`,
                        className: "form-check-input"
                    }, register(name, validation), other)),
                    /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)("label", {
                        htmlFor: `${name}_checkbox`,
                        className: "form-check-label",
                        children: label
                    })
                ]
            }),
            error && /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)("div", {
                className: "invalid-feedback mt-2",
                children: error.message
            })
        ]
    });
};
var $797561708eef40b7$export$2e2bcd8739ae039 = $797561708eef40b7$var$Checkbox;




const $c5a967d8445573bf$var$defaultValues = {
    NationalityID: "GB",
    CountryID: "XF",
    EthnicGroupID: "31",
    EuroResidentID: "",
    DisabilityID: "98",
    LearningDifficultyID: "98",
    YoungAsylumSeeker: false,
    LookedAfter: false,
    CareLeaver: false,
    YoungCarer: false,
    HasEducationHealthCarePlan: false,
    CriminalConvictionID: ""
};
const $c5a967d8445573bf$var$EqualOpportunities = ({ data: data, onSubmit: onSubmit })=>{
    // Data loading
    const nationalities = (0, $57c3b87db6e4f350$export$dd0a697e1782aedd)("nationalities", (0, $18997da1559b0013$export$5ac6cc32fb25fa6e));
    const ethnicities = (0, $57c3b87db6e4f350$export$dd0a697e1782aedd)("ethnicities", (0, $18997da1559b0013$export$9d4521120c9c549b));
    const countries = (0, $57c3b87db6e4f350$export$dd0a697e1782aedd)("countries", (0, $18997da1559b0013$export$44f7508c6c352cc6));
    const disabilities = (0, $57c3b87db6e4f350$export$dd0a697e1782aedd)("disabilities", (0, $18997da1559b0013$export$9bebd9a7a0c2cf34));
    const learningDifficulties = (0, $57c3b87db6e4f350$export$dd0a697e1782aedd)("learning-difficulties", (0, $18997da1559b0013$export$6c92aa14a77b72f5));
    // Form
    const { control: control, register: register, handleSubmit: handleSubmit, formState: formState } = (0, $89763f9db12fbe81$export$87c0cf8eb5a167e0)({
        mode: "all",
        defaultValues: (0, $50842bd933b9f179$export$cbf315268bff9bd2)($c5a967d8445573bf$var$defaultValues, data)
    });
    const { errors: errors, isSubmitting: isSubmitting } = formState;
    return /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsxs)((0, $65eed959c02d7598$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)("h2", {
                children: "Equal Opportunities"
            }),
            /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)("p", {
                children: "South Central Institute of Technology is an equal opportunities provider. For the equal opportunities policy to be effective, it is necessary to monitor all applications. Answering the questions below will not influence your eligibility for one of our training programmes."
            }),
            /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsxs)("form", {
                onSubmit: handleSubmit(onSubmit),
                children: [
                    /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsxs)("div", {
                        className: "row",
                        children: [
                            /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)("div", {
                                className: "col-12 col-md-6",
                                children: /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)((0, $378b90f0f2f43004$export$2e2bcd8739ae039), {
                                    label: "Nationality (as on passport)",
                                    name: "NationalityID",
                                    control: control,
                                    isLoading: nationalities.isLoading,
                                    options: nationalities.data,
                                    placeholder: "Please select a nationality",
                                    validation: {
                                        required: "This field is required"
                                    },
                                    error: errors.NationalityID
                                })
                            }),
                            /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)("div", {
                                className: "col-12 col-md-6",
                                children: /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)((0, $378b90f0f2f43004$export$2e2bcd8739ae039), {
                                    label: "Ethnicity",
                                    name: "EthnicGroupID",
                                    control: control,
                                    isLoading: ethnicities.isLoading,
                                    options: ethnicities.data,
                                    placeholder: "Please select an ethnicity",
                                    validation: {
                                        required: "This field is required"
                                    },
                                    error: errors.EthnicGroupID
                                })
                            }),
                            /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)("div", {
                                className: "col-12 col-md-6",
                                children: /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)((0, $378b90f0f2f43004$export$2e2bcd8739ae039), {
                                    label: "Country of Residence",
                                    name: "CountryID",
                                    control: control,
                                    isLoading: countries.isLoading,
                                    options: countries.data,
                                    validation: {
                                        required: "This field is required"
                                    },
                                    error: errors.CountryID
                                })
                            }),
                            /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)("div", {
                                className: "col-12 col-md-6",
                                children: /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)((0, $b723499cd35e7763$export$2e2bcd8739ae039), {
                                    label: "Are you a UK national who has been resident in the UK for the last 3 years?",
                                    name: "EuroResidentID",
                                    options: [
                                        {
                                            label: "Yes",
                                            value: "1"
                                        },
                                        {
                                            label: "No",
                                            value: "0"
                                        }
                                    ],
                                    inline: true,
                                    register: register,
                                    validation: {
                                        required: "This field is required"
                                    },
                                    error: errors.EuroResidentID
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)("h2", {
                        children: "Learner Support"
                    }),
                    /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsxs)("div", {
                        className: "row",
                        children: [
                            /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)("div", {
                                className: "col-12 col-md-6",
                                children: /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)((0, $378b90f0f2f43004$export$2e2bcd8739ae039), {
                                    label: "Do you have a disability that we need to be aware of?",
                                    name: "DisabilityID",
                                    control: control,
                                    isLoading: disabilities.isLoading,
                                    options: disabilities.data,
                                    validation: {
                                        required: "This field is required"
                                    },
                                    error: errors.DisabilityID
                                })
                            }),
                            /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)("div", {
                                className: "col-12 col-md-6",
                                children: /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)((0, $378b90f0f2f43004$export$2e2bcd8739ae039), {
                                    label: "Do you have a learning difficulty that we need to be aware of?",
                                    name: "LearningDifficultyID",
                                    control: control,
                                    isLoading: learningDifficulties.isLoading,
                                    options: learningDifficulties.data,
                                    validation: {
                                        required: "This field is required"
                                    },
                                    error: errors.LearningDifficultyID
                                })
                            }),
                            /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)("div", {
                                className: "col-12",
                                children: /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsxs)("fieldset", {
                                    className: "form-group",
                                    children: [
                                        /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)("legend", {
                                            className: "form-label",
                                            children: "Do any of the following apply?"
                                        }),
                                        /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)((0, $797561708eef40b7$export$2e2bcd8739ae039), {
                                            label: "Young Asylum Seeker",
                                            name: "YoungAsylumSeeker",
                                            register: register
                                        }),
                                        /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)((0, $797561708eef40b7$export$2e2bcd8739ae039), {
                                            label: "Looked After",
                                            name: "LookedAfter",
                                            register: register
                                        }),
                                        /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)((0, $797561708eef40b7$export$2e2bcd8739ae039), {
                                            label: "Care Leaver",
                                            name: "CareLeaver",
                                            register: register
                                        }),
                                        /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)((0, $797561708eef40b7$export$2e2bcd8739ae039), {
                                            label: "Carer",
                                            name: "YoungCarer",
                                            register: register
                                        }),
                                        /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)((0, $797561708eef40b7$export$2e2bcd8739ae039), {
                                            label: "Education Health Care Plan",
                                            name: "HasEducationHealthCarePlan",
                                            register: register
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)("h2", {
                        children: "Criminal Convictions"
                    }),
                    /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)((0, $b723499cd35e7763$export$2e2bcd8739ae039), {
                        label: "Do you have any relevant unspent criminal conviction?",
                        name: "CriminalConvictionID",
                        options: [
                            {
                                label: "Yes",
                                value: "2"
                            },
                            {
                                label: "No",
                                value: "3"
                            }
                        ],
                        inline: true,
                        register: register,
                        validation: {
                            required: "This field is required"
                        },
                        error: errors.CriminalConvictionID
                    }),
                    /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)("div", {
                        className: "form-info-box",
                        children: /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)("p", {
                            children: "If you declare that you have a relevant conviction, you will be contacted by a College manager to discuss your conviction further and possibly arrange a meeting to discuss your application. If you would like advice on whether your conviction is unspent, please contact NACRO on 0300 123 1999."
                        })
                    }),
                    /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)("button", {
                        type: "submit",
                        className: "form-submit",
                        disabled: isSubmitting,
                        children: isSubmitting ? "Saving" : "Next"
                    })
                ]
            })
        ]
    });
};
var $c5a967d8445573bf$export$2e2bcd8739ae039 = $c5a967d8445573bf$var$EqualOpportunities;




var $4Y8Vu = parcelRequire("4Y8Vu");








const $9c94ede4f9cdff83$var$Textarea = (_param)=>{
    var { label: label, name: name, register: register, validation: validation, error: error } = _param, other = (0, $30c24b3cbf3b0a7a$export$71511d61b312f219)(_param, [
        "label",
        "name",
        "register",
        "validation",
        "error"
    ]);
    return /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsxs)("div", {
        className: (0, $747032d831df0173$export$2e2bcd8739ae039)("form-group", !!(validation === null || validation === void 0 ? void 0 : validation.required) && "required", error && "invalid"),
        children: [
            /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)("label", {
                htmlFor: `${name}_textarea`,
                className: "form-label",
                children: label
            }),
            /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)("textarea", (0, $45c1a8590053a015$export$71511d61b312f219)({
                id: `${name}_input`,
                className: (0, $747032d831df0173$export$2e2bcd8739ae039)("form-control", error && "is-invalid"),
                placeholder: label
            }, register(name, validation), other)),
            error && /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)("div", {
                className: "invalid-feedback mt-1",
                children: error.message
            })
        ]
    });
};
var $9c94ede4f9cdff83$export$2e2bcd8739ae039 = $9c94ede4f9cdff83$var$Textarea;




const $d1c02fb19c01837e$var$defaultValues = {
    StillAtLastSchool: "",
    SchoolID: "",
    ResultsGCSEByEndOfYear11: "",
    QualsGCSEByEndOfYear11: "",
    AchievedEnglishGCSEByEndOfYear11: "",
    AchievedMathsGCSEByEndOfYear11: "",
    ListGCSEByEndOfYear11: ""
};
const $d1c02fb19c01837e$var$EducationHistory = ({ data: data, onSubmit: onSubmit })=>{
    // Data loading
    const schools = (0, $57c3b87db6e4f350$export$dd0a697e1782aedd)("schools", (0, $18997da1559b0013$export$eba4d43ca46b7353));
    const qualification = (0, $57c3b87db6e4f350$export$dd0a697e1782aedd)("qualification", (0, $18997da1559b0013$export$2dccbe657ab23dc));
    const qualifications = (0, $57c3b87db6e4f350$export$dd0a697e1782aedd)("qualifications", (0, $18997da1559b0013$export$4234f37d13f7271a));
    // Form
    const { control: control, register: register, handleSubmit: handleSubmit, formState: formState, watch: watch, trigger: trigger } = (0, $89763f9db12fbe81$export$87c0cf8eb5a167e0)({
        mode: "all",
        defaultValues: (0, $50842bd933b9f179$export$cbf315268bff9bd2)($d1c02fb19c01837e$var$defaultValues, data)
    });
    const { errors: errors, isSubmitting: isSubmitting, touchedFields: touchedFields } = formState;
    const stillAtLastSchool = watch("StillAtLastSchool");
    // Validate SchoolID field
    (0, $4Y8Vu.useEffect)(()=>{
        if ("SchoolID" in touchedFields) trigger("SchoolID");
    }, [
        stillAtLastSchool
    ]);
    return /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsxs)((0, $65eed959c02d7598$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)("h2", {
                children: "Education History"
            }),
            /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)("p", {
                children: "This section must be completed in order for your application to be processed. If you have not yet taken your exams, please provide us with your predicted grades below and bring with you a signed copy of these from your school when you attend your interview. If these are not yet available please let us know what you are studying below and bring the signed copy of them with you to your interview. Please include information on all qualifications, ie GCSE, NVQs, BTEC, Diplomas, A levels, or any other subjects you may have studied."
            }),
            /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)("p", {
                children: "Please enter the details of your prior qualifications, choosing from the drop-down lists below."
            }),
            /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsxs)("form", {
                onSubmit: handleSubmit(onSubmit),
                children: [
                    /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsxs)("div", {
                        className: "row",
                        children: [
                            /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)("div", {
                                className: "col-12 col-md-6",
                                children: /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)((0, $b723499cd35e7763$export$2e2bcd8739ae039), {
                                    label: "Are you still at school or finished school in the last 12 months?",
                                    name: "StillAtLastSchool",
                                    options: [
                                        {
                                            label: "Yes",
                                            value: "1"
                                        },
                                        {
                                            label: "No",
                                            value: "0"
                                        }
                                    ],
                                    inline: true,
                                    register: register,
                                    validation: {
                                        required: "This field is required"
                                    },
                                    error: errors.StillAtLastSchool
                                })
                            }),
                            /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)("div", {
                                className: "col-12 col-md-6",
                                children: /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)((0, $378b90f0f2f43004$export$2e2bcd8739ae039), {
                                    label: "Most Recent School",
                                    name: "SchoolID",
                                    control: control,
                                    isLoading: schools.isLoading,
                                    options: schools.data,
                                    placeholder: "Start Typing...",
                                    validation: {
                                        required: stillAtLastSchool === "1" && "This field is required"
                                    },
                                    error: errors.SchoolID,
                                    components: {
                                        MenuList: (0, $378b90f0f2f43004$export$bbd05575237de7c6)
                                    },
                                    maxMenuHeight: 320
                                })
                            }),
                            /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)("div", {
                                className: "col-12 col-md-6",
                                children: /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)((0, $378b90f0f2f43004$export$2e2bcd8739ae039), {
                                    label: "Are these results predicted or achieved results?",
                                    name: "ResultsGCSEByEndOfYear11",
                                    options: [
                                        {
                                            value: "predicted",
                                            label: "Predicted"
                                        },
                                        {
                                            value: "achieved",
                                            label: "Achieved"
                                        },
                                        {
                                            value: "none",
                                            label: "None of the above"
                                        }
                                    ],
                                    control: control,
                                    validation: {
                                        required: "This field is required"
                                    },
                                    error: errors.ResultsGCSEByEndOfYear11
                                })
                            }),
                            /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)("div", {
                                className: "col-12 col-md-6",
                                children: /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)((0, $378b90f0f2f43004$export$2e2bcd8739ae039), {
                                    label: "Qualification Details",
                                    name: "QualsGCSEByEndOfYear11",
                                    control: control,
                                    isLoading: qualifications.isLoading,
                                    options: qualifications.data,
                                    validation: {
                                        required: "This field is required"
                                    },
                                    error: errors.QualsGCSEByEndOfYear11
                                })
                            }),
                            /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)("div", {
                                className: "col-12 col-md-6",
                                children: /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)((0, $378b90f0f2f43004$export$2e2bcd8739ae039), {
                                    label: "English Qualification",
                                    name: "AchievedEnglishGCSEByEndOfYear11",
                                    control: control,
                                    isLoading: qualification.isLoading,
                                    options: qualification.data,
                                    validation: {
                                        required: "This field is required"
                                    },
                                    error: errors.AchievedEnglishGCSEByEndOfYear11
                                })
                            }),
                            /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)("div", {
                                className: "col-12 col-md-6",
                                children: /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)((0, $378b90f0f2f43004$export$2e2bcd8739ae039), {
                                    label: "Math Qualification",
                                    name: "AchievedMathsGCSEByEndOfYear11",
                                    control: control,
                                    isLoading: qualification.isLoading,
                                    options: qualification.data,
                                    validation: {
                                        required: "This field is required"
                                    },
                                    error: errors.AchievedMathsGCSEByEndOfYear11
                                })
                            }),
                            /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)("div", {
                                className: "col-12",
                                children: /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)((0, $9c94ede4f9cdff83$export$2e2bcd8739ae039), {
                                    label: "Please list out your exam subjects results below (e.g Art - B):",
                                    name: "ListGCSEByEndOfYear11",
                                    register: register
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)("button", {
                        type: "submit",
                        className: "form-submit",
                        disabled: isSubmitting,
                        children: isSubmitting ? "Saving" : "Next"
                    })
                ]
            })
        ]
    });
};
var $d1c02fb19c01837e$export$2e2bcd8739ae039 = $d1c02fb19c01837e$var$EducationHistory;








const $8e561ea4153ce13e$var$defaultValues = {
    ApplicationUserDefined12: ""
};
const $8e561ea4153ce13e$var$MoreAboutYou = ({ id: id, data: data, onSubmit: onSubmit })=>{
    // Data loading
    const statements = (0, $57c3b87db6e4f350$export$dd0a697e1782aedd)("statements", ()=>(0, $18997da1559b0013$export$d12772bd0dd951a2)(id));
    // Form
    const { register: register, handleSubmit: handleSubmit, formState: formState } = (0, $89763f9db12fbe81$export$87c0cf8eb5a167e0)({
        mode: "all",
        defaultValues: (0, $50842bd933b9f179$export$cbf315268bff9bd2)($8e561ea4153ce13e$var$defaultValues, data)
    });
    const { errors: errors, isSubmitting: isSubmitting } = formState;
    return /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsxs)((0, $65eed959c02d7598$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)("h2", {
                children: "More About You"
            }),
            /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsxs)("form", {
                onSubmit: handleSubmit(onSubmit),
                children: [
                    statements.isLoading ? /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)("p", {
                        children: "Loading..."
                    }) : /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)((0, $b723499cd35e7763$export$2e2bcd8739ae039), {
                        label: "What statement best describes you?",
                        name: "ApplicationUserDefined12",
                        options: (statements === null || statements === void 0 ? void 0 : statements.data) || [],
                        register: register,
                        validation: {
                            required: "Please select a statement"
                        },
                        error: errors.ApplicationUserDefined12
                    }),
                    /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)("button", {
                        type: "submit",
                        className: "form-submit",
                        disabled: isSubmitting,
                        children: isSubmitting ? "Saving" : "Next"
                    })
                ]
            })
        ]
    });
};
var $8e561ea4153ce13e$export$2e2bcd8739ae039 = $8e561ea4153ce13e$var$MoreAboutYou;





const $1d539cfe11387c5b$var$Declaration = ({ onSubmit: onSubmit })=>{
    // Form
    const { register: register, handleSubmit: handleSubmit, formState: formState } = (0, $89763f9db12fbe81$export$87c0cf8eb5a167e0)({
        defaultValues: {
            Declaration: false
        }
    });
    const { errors: errors, isSubmitting: isSubmitting } = formState;
    return /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsxs)((0, $65eed959c02d7598$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)("h2", {
                children: "Declaration"
            }),
            /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsxs)("div", {
                className: "form-terms",
                children: [
                    /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)("p", {
                        children: "I wish to apply for admission to the Institute and will abide by institute regulations. I undertake that, if admitted, I will make every effort to complete the course. The information I have supplied is correct and true. I realise that if I have supplied false information or neglected to provide additional information that could prove important, any offer of a place may be withdrawn. If any of this information changes I will inform the Institute. If I am currently in receipt of qualifying benefit I agree to inform the Institute immediately if my benefit status changes. I understand that I may be asked to provide evidence of continued eligibility to fee remission."
                    }),
                    /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)("p", {
                        children: "Should your personal data change (e.g. Address), please notify us as soon as possible."
                    }),
                    /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)("p", {
                        children: "The Institute collects information about staff and students for various administrative, academic, and health & safety reasons. The Data Protection Act 1998 requires your consent before we can obtain this information. Should you require further information regarding this please contact Admissions Information & Enquiries."
                    }),
                    /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsxs)("ul", {
                        children: [
                            /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)("li", {
                                children: "I agree to South Central Institute of Technology obtaining, processing and storing personal information obtained from this electronic form, or any other information obtained from me, or other people, whilst I am a student. I agree that the information obtained can be used for purposes connected with my studies and health & safety whilst on the premises or for any other legitimate reason."
                            }),
                            /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)("li", {
                                children: "I agree information may be shared with other organisations for education, training, employment and well-being related purposes, including research. You may be contacted after you have completed your programme of learning to establish whether you have entered employment or gone onto further training."
                            }),
                            /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)("li", {
                                children: "I agree to the institute publishing data on my achievement as a student. I also confirm that any photographs or video footage taken of me with my permission may be used for marketing purposes."
                            }),
                            /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)("li", {
                                children: "I give permission for the South Central Institute of Technology to contact me with communications other than those essential to the process, with news, event invitations and useful information that may be of interest."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)("p", {
                        children: "By providing your mobile telephone number and email address you are agreeing that the institute can contact you by text and email as well as by telephone and post. If you have any concerns about this please contact the institute to discuss."
                    })
                ]
            }),
            /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsxs)("form", {
                onSubmit: handleSubmit(onSubmit),
                children: [
                    /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)((0, $797561708eef40b7$export$2e2bcd8739ae039), {
                        label: "By ticking this box, I confirm that I have read the declaration above and agree to the statements within it. Ticking this box replaces my signature on this electronic form",
                        name: "Declaration",
                        register: register,
                        validation: {
                            required: "Please tick this box after reading the above declaration"
                        },
                        error: errors.Declaration
                    }),
                    /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)("button", {
                        type: "submit",
                        className: "form-submit",
                        disabled: isSubmitting,
                        children: isSubmitting ? "Saving" : "Submit"
                    })
                ]
            })
        ]
    });
};
var $1d539cfe11387c5b$export$2e2bcd8739ae039 = $1d539cfe11387c5b$var$Declaration;


const $0e08294b9fa211a3$var$Apply = ()=>{
    // Form State
    const { id: id, data: data, onUpdate: onUpdate, onSubmit: onSubmit } = (0, $7fc884044a60e38c$export$aaf75bb403fe1fb5)();
    // Step State
    const maxPossibleStep = (0, $71113b02d2c3a867$export$81183a123171043b)(data);
    const [activeStep, setActiveStep] = (0, $4Y8Vu.useState)(maxPossibleStep);
    // Update Form
    const handleUpdate = (nextStep)=>(formData)=>{
            onUpdate(formData);
            setActiveStep(nextStep);
        };
    (0, $4Y8Vu.useEffect)(()=>{
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: "instant"
        });
    }, [
        activeStep
    ]);
    const CurrentStep = (0, $4Y8Vu.useMemo)(()=>{
        switch(activeStep){
            case (0, $71113b02d2c3a867$export$31f4a6fd27e146da).PersonalDetails:
                return /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)((0, $4c8d0e2996c4d41a$export$2e2bcd8739ae039), {
                    type: "apply",
                    data: data,
                    onSubmit: handleUpdate((0, $71113b02d2c3a867$export$31f4a6fd27e146da).EqualOpportunities)
                });
            case (0, $71113b02d2c3a867$export$31f4a6fd27e146da).EqualOpportunities:
                return /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)((0, $c5a967d8445573bf$export$2e2bcd8739ae039), {
                    data: data,
                    onSubmit: handleUpdate((0, $71113b02d2c3a867$export$31f4a6fd27e146da).EducationHistory)
                });
            case (0, $71113b02d2c3a867$export$31f4a6fd27e146da).EducationHistory:
                return /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)((0, $d1c02fb19c01837e$export$2e2bcd8739ae039), {
                    data: data,
                    onSubmit: handleUpdate((0, $71113b02d2c3a867$export$31f4a6fd27e146da).MoreAboutYou)
                });
            case (0, $71113b02d2c3a867$export$31f4a6fd27e146da).MoreAboutYou:
                return /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)((0, $8e561ea4153ce13e$export$2e2bcd8739ae039), {
                    id: id,
                    data: data,
                    onSubmit: handleUpdate((0, $71113b02d2c3a867$export$31f4a6fd27e146da).Declaration)
                });
            case (0, $71113b02d2c3a867$export$31f4a6fd27e146da).Declaration:
                return /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)((0, $1d539cfe11387c5b$export$2e2bcd8739ae039), {
                    onSubmit: onSubmit
                });
        }
    }, [
        activeStep
    ]);
    return /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsxs)((0, $65eed959c02d7598$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)((0, $27aa04694c091085$export$2e2bcd8739ae039), {
                activeStep: activeStep,
                maxPossibleStep: maxPossibleStep,
                steps: (0, $71113b02d2c3a867$export$be3f796aed065412),
                onChange: setActiveStep
            }),
            CurrentStep
        ]
    });
};
var $0e08294b9fa211a3$export$2e2bcd8739ae039 = $0e08294b9fa211a3$var$Apply;




var $4Y8Vu = parcelRequire("4Y8Vu");
const $63fe866510f70bb3$export$31f4a6fd27e146da = {
    PersonalDetails: 1,
    EqualOpportunities: 2,
    PriorAttainment: 3,
    Declaration: 4
};
const $63fe866510f70bb3$export$be3f796aed065412 = [
    {
        step: $63fe866510f70bb3$export$31f4a6fd27e146da.PersonalDetails,
        name: "Personal Details"
    },
    {
        step: $63fe866510f70bb3$export$31f4a6fd27e146da.EqualOpportunities,
        name: "Equal Opportunities"
    },
    {
        step: $63fe866510f70bb3$export$31f4a6fd27e146da.PriorAttainment,
        name: "Prior Attainment"
    },
    {
        step: $63fe866510f70bb3$export$31f4a6fd27e146da.Declaration,
        name: "Declaration"
    }
];
const $63fe866510f70bb3$export$81183a123171043b = (data)=>{
    if (data === null || data === void 0 ? void 0 : data.PriorAttainmentLevelID) return $63fe866510f70bb3$export$31f4a6fd27e146da.Declaration;
    if (data === null || data === void 0 ? void 0 : data.CriminalConvictionID) return $63fe866510f70bb3$export$31f4a6fd27e146da.PriorAttainment;
    if (data === null || data === void 0 ? void 0 : data.FirstForename) return $63fe866510f70bb3$export$31f4a6fd27e146da.EqualOpportunities;
    return $63fe866510f70bb3$export$31f4a6fd27e146da.PersonalDetails;
};












const $273437c394df1fae$var$defaultValues = {
    NationalityID: "GB",
    CountryID: "XF",
    EthnicGroupID: "31",
    EuroResidentID: "",
    CriminalConvictionID: ""
};
const $273437c394df1fae$var$EqualOpportunities = ({ data: data, onSubmit: onSubmit })=>{
    // Data loading
    const nationalities = (0, $57c3b87db6e4f350$export$dd0a697e1782aedd)("nationalities", (0, $18997da1559b0013$export$5ac6cc32fb25fa6e));
    const ethnicities = (0, $57c3b87db6e4f350$export$dd0a697e1782aedd)("ethnicities", (0, $18997da1559b0013$export$9d4521120c9c549b));
    const countries = (0, $57c3b87db6e4f350$export$dd0a697e1782aedd)("countries", (0, $18997da1559b0013$export$44f7508c6c352cc6));
    // Form
    const { control: control, register: register, handleSubmit: handleSubmit, formState: formState } = (0, $89763f9db12fbe81$export$87c0cf8eb5a167e0)({
        mode: "all",
        defaultValues: (0, $50842bd933b9f179$export$cbf315268bff9bd2)($273437c394df1fae$var$defaultValues, data)
    });
    const { errors: errors, isSubmitting: isSubmitting } = formState;
    return /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsxs)((0, $65eed959c02d7598$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)("h2", {
                children: "Equal Opportunities"
            }),
            /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)("p", {
                children: "South Central Institute of Technology is an equal opportunities provider. For the equal opportunities policy to be effective, it is necessary to monitor all applications. Answering the questions below will not influence your eligibility for one of our training programmes."
            }),
            /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsxs)("form", {
                onSubmit: handleSubmit(onSubmit),
                children: [
                    /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsxs)("div", {
                        className: "row",
                        children: [
                            /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)("div", {
                                className: "col-12 col-md-6",
                                children: /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)((0, $378b90f0f2f43004$export$2e2bcd8739ae039), {
                                    label: "Nationality (as on passport)",
                                    name: "NationalityID",
                                    control: control,
                                    isLoading: nationalities.isLoading,
                                    options: nationalities.data,
                                    placeholder: "Please select a nationality",
                                    validation: {
                                        required: "This field is required"
                                    },
                                    error: errors.NationalityID
                                })
                            }),
                            /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)("div", {
                                className: "col-12 col-md-6",
                                children: /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)((0, $378b90f0f2f43004$export$2e2bcd8739ae039), {
                                    label: "Ethnicity",
                                    name: "EthnicGroupID",
                                    control: control,
                                    isLoading: ethnicities.isLoading,
                                    options: ethnicities.data,
                                    placeholder: "Please select an ethnicity",
                                    validation: {
                                        required: "This field is required"
                                    },
                                    error: errors.EthnicGroupID
                                })
                            }),
                            /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)("div", {
                                className: "col-12 col-md-6",
                                children: /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)((0, $378b90f0f2f43004$export$2e2bcd8739ae039), {
                                    label: "Country of Residence",
                                    name: "CountryID",
                                    control: control,
                                    isLoading: countries.isLoading,
                                    options: countries.data,
                                    validation: {
                                        required: "This field is required"
                                    },
                                    error: errors.CountryID
                                })
                            }),
                            /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)("div", {
                                className: "col-12 col-md-6",
                                children: /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)((0, $b723499cd35e7763$export$2e2bcd8739ae039), {
                                    label: "Are you a UK national who has been resident in the UK for the last 3 years?",
                                    name: "EuroResidentID",
                                    options: [
                                        {
                                            label: "Yes",
                                            value: "1"
                                        },
                                        {
                                            label: "No",
                                            value: "0"
                                        }
                                    ],
                                    inline: true,
                                    register: register,
                                    validation: {
                                        required: "This field is required"
                                    },
                                    error: errors.EuroResidentID
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)("h2", {
                        children: "Criminal Convictions"
                    }),
                    /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)((0, $b723499cd35e7763$export$2e2bcd8739ae039), {
                        label: "Do you have any relevant unspent criminal conviction?",
                        name: "CriminalConvictionID",
                        options: [
                            {
                                label: "Yes",
                                value: "2"
                            },
                            {
                                label: "No",
                                value: "3"
                            }
                        ],
                        inline: true,
                        register: register,
                        validation: {
                            required: "This field is required"
                        },
                        error: errors.CriminalConvictionID
                    }),
                    /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)("div", {
                        className: "form-info-box",
                        children: /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)("p", {
                            children: "If you declare that you have a relevant conviction, you will be contacted by a College manager to discuss your conviction further and possibly arrange a meeting to discuss your application. If you would like advice on whether your conviction is unspent, please contact NACRO on 0300 123 1999."
                        })
                    }),
                    /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)("button", {
                        type: "submit",
                        className: "form-submit",
                        disabled: isSubmitting,
                        children: isSubmitting ? "Saving" : "Next"
                    })
                ]
            })
        ]
    });
};
var $273437c394df1fae$export$2e2bcd8739ae039 = $273437c394df1fae$var$EqualOpportunities;









const $7546b9ee6dbe175b$var$PriorAttainmentLevelInfo = ({ value: value })=>{
    switch(value){
        case "01":
            return /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)("p", {
                children: "Examples: GCSE (less than 5 at grades A-C); 1 AS Level; Level 1 Award/Certificate/Diploma; NVQ Level 1; GNVQ Foundation"
            });
        case "02":
            return /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)("p", {
                children: "Examples: GCSE (5 or more, grade A*-C); 2 or 3 AS Levels; BTEC First Diploma; NVQ Level 2; GNVQ Intermediate"
            });
        case "03":
            return /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)("p", {
                children: "Examples: A Level (2 or more, grades A*-E); 4 or more AS Levels; BTEC National Diploma; NVQ Level 3; GNVQ Advanced"
            });
        case "09":
            return /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)("p", {
                children: "Examples: QCF Award/Certificate at Entry Level; Certificate in Adult Literacy, Numeracy, ESOL at Entry Level"
            });
        case "10":
            return /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)("p", {
                children: "Examples: Higher Education, First Degree, HNC, NVQ Level 4, RSA Advanced, RSA Higher, Teaching Qualification"
            });
        case "11":
            return /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)("p", {
                children: "Examples: Foundation Degree, HND, NVQ Level 5, other high level professional qualification"
            });
        case "12":
            return /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)("p", {
                children: "Examples: Bachelor's Degree; Graduate Certificate/Diploma"
            });
        case "13":
            return /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)("p", {
                children: "Examples: Doctorate; Masters Degree; Postgraduate Certificate/Diploma"
            });
        default:
            return null;
    }
};
var $7546b9ee6dbe175b$export$2e2bcd8739ae039 = $7546b9ee6dbe175b$var$PriorAttainmentLevelInfo;




const $0294f7b6f20cc081$var$defaultValues = {
    PriorAttainmentLevelID: "",
    HouseholdSituation1ID: "",
    EmploymentStatusID: "",
    IsSelfEmployed: "",
    EmploymentIntensityID: "",
    LengthOfEmploymentID: "",
    BenefitStatusIndicatorID: "",
    LengthOfUnemploymentID: "",
    LearningDiffOrDisID: "",
    DisabilityCategory1ID: ""
};
const $0294f7b6f20cc081$var$PriorAttainment = ({ data: data, onSubmit: onSubmit })=>{
    // Data loading
    const benefits = (0, $57c3b87db6e4f350$export$dd0a697e1782aedd)("benefits", (0, $18997da1559b0013$export$1cd3ed34adda6afb));
    const disabilities = (0, $57c3b87db6e4f350$export$dd0a697e1782aedd)("disabilitiesLearningDifficulties", (0, $18997da1559b0013$export$dc9e82ea61b7b5fa));
    const employmentIntensities = (0, $57c3b87db6e4f350$export$dd0a697e1782aedd)("employmentIntensities", (0, $18997da1559b0013$export$62ab29374050bbde));
    const employmentStatuses = (0, $57c3b87db6e4f350$export$dd0a697e1782aedd)("employmentStatuses", (0, $18997da1559b0013$export$7acdecf75c1d2792));
    const employmentLengths = (0, $57c3b87db6e4f350$export$dd0a697e1782aedd)("employmentLengths", (0, $18997da1559b0013$export$f26c9a1685001982));
    const householdSituations = (0, $57c3b87db6e4f350$export$dd0a697e1782aedd)("householdSituations", (0, $18997da1559b0013$export$e4eea529fcb0b4f0));
    const priorAttainmentLevels = (0, $57c3b87db6e4f350$export$dd0a697e1782aedd)("priorAttainmentLevels", (0, $18997da1559b0013$export$2154b715912f9d42));
    const unemployedLengths = (0, $57c3b87db6e4f350$export$dd0a697e1782aedd)("unemployedLengths", (0, $18997da1559b0013$export$867f818e1792266b));
    // Form
    const { control: control, register: register, handleSubmit: handleSubmit, formState: formState, watch: watch } = (0, $89763f9db12fbe81$export$87c0cf8eb5a167e0)({
        mode: "all",
        defaultValues: (0, $50842bd933b9f179$export$cbf315268bff9bd2)($0294f7b6f20cc081$var$defaultValues, data)
    });
    const { errors: errors, isSubmitting: isSubmitting } = formState;
    // Watch fields for changes
    const priorAttainmentLevel = watch("PriorAttainmentLevelID");
    const learningDiffOrDis = watch("LearningDiffOrDisID");
    const employmentStatus = watch("EmploymentStatusID");
    return /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsxs)("form", {
        onSubmit: handleSubmit(onSubmit),
        children: [
            /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)("h2", {
                children: "Distance Learning"
            }),
            /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)((0, $378b90f0f2f43004$export$2e2bcd8739ae039), {
                label: "Please select the level that corresponds to your highest qualification achieved PRIOR to starting this course:",
                name: "PriorAttainmentLevelID",
                control: control,
                isLoading: priorAttainmentLevels.isLoading,
                options: priorAttainmentLevels.data,
                validation: {
                    required: "This field is required"
                },
                error: errors.PriorAttainmentLevelID
            }),
            /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)((0, $7546b9ee6dbe175b$export$2e2bcd8739ae039), {
                value: priorAttainmentLevel
            }),
            /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)("h2", {
                children: "Household Details"
            }),
            /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)((0, $378b90f0f2f43004$export$2e2bcd8739ae039), {
                label: "Please select the statement which applies to your household situation:",
                name: "HouseholdSituation1ID",
                control: control,
                isLoading: householdSituations.isLoading,
                options: householdSituations.data,
                validation: {
                    required: "This field is required"
                },
                error: errors.HouseholdSituation1ID
            }),
            /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)("h2", {
                children: "Employment Status"
            }),
            /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)((0, $378b90f0f2f43004$export$2e2bcd8739ae039), {
                label: "Please chose the statement that best describes your status BEFORE starting the course:",
                name: "EmploymentStatusID",
                control: control,
                isLoading: employmentStatuses.isLoading,
                options: employmentStatuses.data,
                validation: {
                    required: "This field is required"
                },
                error: errors.EmploymentStatusID
            }),
            employmentStatus === "10" && /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsxs)((0, $65eed959c02d7598$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)((0, $b723499cd35e7763$export$2e2bcd8739ae039), {
                        label: "I am Self Employed",
                        name: "IsSelfEmployed",
                        options: [
                            {
                                label: "Yes",
                                value: "1"
                            },
                            {
                                label: "No",
                                value: "0"
                            }
                        ],
                        inline: true,
                        register: register,
                        validation: {
                            required: "This field is required"
                        },
                        error: errors.IsSelfEmployed
                    }),
                    /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)((0, $378b90f0f2f43004$export$2e2bcd8739ae039), {
                        label: "I am employed for:",
                        name: "EmploymentIntensityID",
                        control: control,
                        isLoading: employmentIntensities.isLoading,
                        options: employmentIntensities.data,
                        validation: {
                            required: "This field is required"
                        },
                        error: errors.EmploymentIntensityID
                    }),
                    /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)((0, $378b90f0f2f43004$export$2e2bcd8739ae039), {
                        label: "I have been employed for:",
                        name: "LengthOfEmploymentID",
                        control: control,
                        isLoading: employmentLengths.isLoading,
                        options: employmentLengths.data,
                        validation: {
                            required: "This field is required"
                        },
                        error: errors.LengthOfEmploymentID
                    })
                ]
            }),
            employmentStatus === "11" && /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)((0, $378b90f0f2f43004$export$2e2bcd8739ae039), {
                label: "I am in receipt of the following benefits:",
                name: "BenefitStatusIndicatorID",
                control: control,
                isLoading: benefits.isLoading,
                options: benefits.data,
                validation: {
                    required: "This field is required"
                },
                error: errors.BenefitStatusIndicatorID
            }),
            (employmentStatus === "11" || employmentStatus === "12") && /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)((0, $378b90f0f2f43004$export$2e2bcd8739ae039), {
                label: "I have been unemployed for:",
                name: "LengthOfUnemploymentID",
                control: control,
                isLoading: unemployedLengths.isLoading,
                options: unemployedLengths.data,
                validation: {
                    required: "This field is required"
                },
                error: errors.LengthOfUnemploymentID
            }),
            /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)("h2", {
                children: "Support Services"
            }),
            /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)((0, $b723499cd35e7763$export$2e2bcd8739ae039), {
                label: "Do you consider yourself to have a disability, learning difficulty or health problem?",
                name: "LearningDiffOrDisID",
                options: [
                    {
                        label: "Yes",
                        value: "1"
                    },
                    {
                        label: "No",
                        value: "2"
                    }
                ],
                inline: true,
                register: register,
                validation: {
                    required: "This field is required"
                },
                error: errors.LearningDiffOrDisID
            }),
            learningDiffOrDis === "1" && /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)((0, $378b90f0f2f43004$export$2e2bcd8739ae039), {
                label: "Please indicate the most significant or primary learning difficulty, disability or health problem that impacts your education:",
                name: "DisabilityCategory1ID",
                control: control,
                isLoading: disabilities.isLoading,
                options: disabilities.data,
                validation: {
                    required: "This field is required"
                },
                error: errors.DisabilityCategory1ID
            }),
            /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsxs)("fieldset", {
                className: "form-group",
                children: [
                    /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)("legend", {
                        className: "form-label",
                        children: "Do any of the following apply?"
                    }),
                    /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)((0, $797561708eef40b7$export$2e2bcd8739ae039), {
                        label: "Young Asylum Seeker",
                        name: "YoungAsylumSeeker",
                        register: register
                    }),
                    /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)((0, $797561708eef40b7$export$2e2bcd8739ae039), {
                        label: "Looked After",
                        name: "LookedAfter",
                        register: register
                    }),
                    /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)((0, $797561708eef40b7$export$2e2bcd8739ae039), {
                        label: "Care Leaver",
                        name: "CareLeaver",
                        register: register
                    }),
                    /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)((0, $797561708eef40b7$export$2e2bcd8739ae039), {
                        label: "Carer",
                        name: "YoungCarer",
                        register: register
                    })
                ]
            }),
            /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)("button", {
                type: "submit",
                className: "form-submit",
                disabled: isSubmitting,
                children: isSubmitting ? "Saving" : "Next"
            })
        ]
    });
};
var $0294f7b6f20cc081$export$2e2bcd8739ae039 = $0294f7b6f20cc081$var$PriorAttainment;





const $10736c52b78f4270$var$Declaration = ({ onSubmit: onSubmit })=>{
    // Form
    const { register: register, handleSubmit: handleSubmit, formState: formState } = (0, $89763f9db12fbe81$export$87c0cf8eb5a167e0)({
        defaultValues: {
            Declaration: false
        }
    });
    const { errors: errors, isSubmitting: isSubmitting } = formState;
    return /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsxs)((0, $65eed959c02d7598$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)("h2", {
                children: "Declaration"
            }),
            /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsxs)("div", {
                className: "form-terms",
                children: [
                    /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)("h3", {
                        children: "Learning Agreement Declaration & Terms and Conditions"
                    }),
                    /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)("p", {
                        children: "I, the learner, agree to South Central Institute of Technology processing the personal data contained in this form for any purposes connected with my studies or my health and safety whilst on the premises or for any other legitimate and reasonable reason. This will include the forwarding of information I provide at enrolment to the Education and Skills Funding Agency for England, which is also registered under the Data Protection Act 1998. The registration is primarily for the collection and analysis of statistical data, but it also allows the Agency to share information with organisations for the purpose of detecting fraud. I agree that my data will be used for a full range of marketing/alumni activities, including sending Institute publications, promotion of benefits and services available to alumni. I understand that Milton Keynes Institute is required to record progression data and I agree to provide details of employment as required. I understand that my course may be part/match funded by the ESF."
                    }),
                    /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)("p", {
                        children: "Where applicable, In order to assist my choice of course, I have received guidance from the Institute about its suitability to my needs, advice on learning and financial support where appropriate. Guidance has been received in either written materials, such as leaflets or a prospectus, and/or by discussions with an appropriate member of Institute staff that may have included any interview/assessment."
                    }),
                    /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)("p", {
                        children: "I confirm that I have been made aware of the Institute Fees Policy and understand that, if I have declared false information, action to reclaim course fees may be taken against me. I accept that the Institute has the right to share information about my attendance and progress with my parent(s) / carer(s) if I am aged under 19, and with my employer / sponsor if they are paying my fees. I agree to my photograph being taken and understand that it may be used to promote the Institute. Any objection to this arrangement should be put in writing to the Marketing Department at the Institute. I understand that I am responsible for my own learning and behaviour, and my conduct should be in line with all Institute policies to ensure an environment where people feel respected, safe and secure, and are able to learn effectively. I agree to behave in a way that will not adversely affect others and abide by the Institute policy surrounding the use of IT systems, which will be communicated at induction and can also be found on the Institute's Virtual Learning Environment."
                    }),
                    /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)("h4", {
                        children: "HOW WE USE YOUR PERSONAL INFORMATION"
                    }),
                    /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)("p", {
                        children: "This privacy notice is issued by the Education and Skills Funding Agency (ESFA), on behalf of the Secretary of State for the Department of Education (DfE). It is to inform learners how their personal information will be used by the DfE, the ESFA (an executive agency of the DfE) and any successor bodies to these organisations. For the purposes of the Data Protection Act 1998, the DfE is the data controller for personal data processed by the ESFA. Your personal information is used by the DfE to exercise its functions and to meet its statutory responsibilities, including under the Apprenticeships, Skills, Children and Learning Act 2009 and to create and maintain a unique learner number (ULN) and a personal learning record (PLR). Your information may be shared with third parties for education, training, employment and well-being related purposes, including for research. This will only take place where the law allows it and the sharing is in compliance with the Data Protection Act 1998. The English European Social Fund (ESF) Managing Authority (or agents acting on its behalf) may contact you in order for them to carry out research and evaluation to inform the effectiveness of training."
                    }),
                    /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsxs)("p", {
                        children: [
                            "Further information about use of and access to your personal data, and details of organisations with whom we regularly share data are available at:",
                            /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)("a", {
                                href: "https://www.gov.uk/government/publications/esfa-privacy-notice",
                                target: "_blank",
                                children: "https://www.gov.uk/government/publications/esfa-privacy-notice"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)("h4", {
                        children: "FEES"
                    }),
                    /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)("p", {
                        children: "'Fees' refers to the charges passed on to a student in respect to educational services, this includes tuition, examination and assessment costs. Fees paid will be dependent on age, personal circumstances as well as type and level of the course. All fees will be explained to a student prior to enrolment. This Fee Policy applies to all learners starting new learning aims on or after 1st August 2017."
                    }),
                    /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)("p", {
                        children: "Fees must be paid before or at Enrolment. The enrolment process will not be completed until all fees are paid in full or an approved payment plan has been agreed with the institute. Enrolment on a course will be refused where there are outstanding fees relating to previous enrolments. The Institute uses information disclosed by the learner at enrolment to determine a student's fees. The Institute reserves the right to re-assess fees if it discovers this information given at enrolment is incorrect. Fees are charged based on an individual's status at the time of enrolment; changes to this status post enrolment will not affect the fee status. The Institute reserves the right to take reasonable steps to recover unpaid fees, including using an external debt collection agency. The Institute reserves the right to vary fees without notice at any time up to the start of a programme. Where students are on a funded course we will apply all fee remissions as set out by the relevant funding agency. In the event that a relevant funding agency changes its fee remission criteria, the Institute reserves the right to collect/waive fees accordingly."
                    }),
                    /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)("h4", {
                        children: "REFUNDS"
                    }),
                    /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)("p", {
                        children: "South Central Institute of Technology has a 'no refunds' policy which means that we do not give refunds other than in the circumstances detailed below. Once you have signed the enrolment form, you have agreed to the following terms and conditions as far as fees are concerned. Refunds may only be considered if one or more of the following circumstances exist:"
                    }),
                    /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsxs)("ul", {
                        style: {
                            listStyleType: "upper-roman"
                        },
                        children: [
                            /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)("li", {
                                children: "The Institute terminates a course."
                            }),
                            /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)("li", {
                                children: "The Institute does not provide an advertised course and is unable to provide suitable alternative provision"
                            }),
                            /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)("li", {
                                children: "The Institute materially alters the time or location of a course from that advertised"
                            }),
                            /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)("li", {
                                children: "The Institute recommends a student transfers to a course with a lower fee"
                            }),
                            /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)("li", {
                                children: "The Institute has overcharged a student or assessed their fees incorrectly"
                            }),
                            /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)("li", {
                                children: "Medical conditions, certified by appropriate medical professionals, resulting in the student having to leave the Institute completely."
                            }),
                            /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)("li", {
                                children: "You notify the Institute, in writing, prior to the course start date. A full refund of total fees paid will be refunded, less a \xa350 administration fee. (A refund request form must be received by the Institute on or before 14 days after the start of the course)."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)("p", {
                        children: "If after enrolment, you decide to withdraw from your course for any other reason than above, you shall not be entitled to a refund. If we have agreed for you to pay in instalments then you must pay all unpaid instalments immediately."
                    }),
                    /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)("p", {
                        children: "Refund applications will only be considered if received on a correctly completed form, available from all Institute receptions. Where refunds are declined, the Institute may issue a credit note or voucher for another Institute course as an alternative. Where the Institute terminates a course, which has already started, you will receive a full refund of all amounts paid; however, all other refunds and credit notes will be subject to deductions for classes already attended, the examination fee where the Institute has already registered your entry and an administration fee of \xa350.00."
                    }),
                    /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)("h4", {
                        children: "FEE POLICY"
                    }),
                    /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)("p", {
                        children: "The full Institute Fees Policy is available on our website or upon request from Customer Services."
                    }),
                    /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)("h4", {
                        children: "EXAMINATIONS / REGISTRATIONS"
                    }),
                    /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)("p", {
                        children: "It is your responsibility to ensure that all examination and awarding body registrations are made on your behalf."
                    }),
                    /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)("h4", {
                        children: "DEFINITION OF RELEVANT CRIMINAL CONVICTIONS"
                    }),
                    /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)("p", {
                        children: "By relevant criminal convictions, the Institute means convictions for offences against the person, whether of a violent or sexual nature, and convictions for offences involving unlawful supply or use of controlled drugs or substances. You do not have to tell us about any convictions that are spent (as defined by the Rehabilitation of Offenders Act 1974), or about any cautions, reprimands or final warnings. For further advice on whether convictions are unspent, please contact NACRO on 020 7840 6464."
                    }),
                    /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)("h4", {
                        children: "FAIR PROCESSING NOTICE"
                    }),
                    /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsxs)("p", {
                        children: [
                            "The Education and Skills Funding Agency is a public body that funds qualifications and training that you may be receiving. The Education and Skills Funding Agency may obtain and use third party reference data to assist when verifying your ULN and when checking that the data it holds about you is correct, in order to comply with the requirements of the Data Protection Act 1998 to keep your details accurate and up to date The information you supply will be used by the Education and Skills Funding Agency, an executive agency of the Department for Education (DfE), to issue you with a Unique Learner Number (ULN), and to create your Personal Learning Record. For more information about how your information is processed and shared refer to the Extended Privacy Notice available on",
                            " ",
                            /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)("a", {
                                href: "https://www.gov.uk",
                                target: "_blank",
                                children: "https://www.gov.uk"
                            }),
                            " ",
                            "You can opt-out of sharing your participation and achievement data by contacting the Learning Records Service customer helpdesk on 0345 602 2589. For further details of how your information is shared and used by the Learning Records Service please visit the Learning Records Service website at",
                            " ",
                            /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)("a", {
                                href: "https://www.gov.uk/guidance/how-to-access-your-personal-learning-record",
                                target: "_blank",
                                children: "https://www.gov.uk/guidance/how-to-access-your-personal-learning-record"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)("p", {
                        children: "I give permission for the South Central Institute of Technology to contact me with communications other than those essential to the process, with news, event invitations and useful information that may be of interest."
                    })
                ]
            }),
            /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsxs)("form", {
                onSubmit: handleSubmit(onSubmit),
                children: [
                    /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)((0, $797561708eef40b7$export$2e2bcd8739ae039), {
                        label: "By ticking this box, I confirm that I have read the declaration above and agree to the statements within it. Ticking this box replaces my signature on this electronic form",
                        name: "Declaration",
                        register: register,
                        validation: {
                            required: "Please tick this box after reading the above declaration"
                        },
                        error: errors.Declaration
                    }),
                    /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)("button", {
                        type: "submit",
                        className: "form-submit",
                        disabled: isSubmitting,
                        children: isSubmitting ? "Saving" : "Submit"
                    })
                ]
            })
        ]
    });
};
var $10736c52b78f4270$export$2e2bcd8739ae039 = $10736c52b78f4270$var$Declaration;


const $e9009287b55c6f1d$var$Enrol = ()=>{
    // Form State
    const { id: id, data: data, onUpdate: onUpdate, onSubmit: onSubmit } = (0, $7fc884044a60e38c$export$aaf75bb403fe1fb5)();
    // Step State
    const maxPossibleStep = (0, $63fe866510f70bb3$export$81183a123171043b)(data);
    const [activeStep, setActiveStep] = (0, $4Y8Vu.useState)(maxPossibleStep);
    // Update Form
    const handleUpdate = (nextStep)=>(formData)=>{
            onUpdate(formData);
            setActiveStep(nextStep);
        };
    (0, $4Y8Vu.useEffect)(()=>{
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: "instant"
        });
    }, [
        activeStep
    ]);
    const CurrentStep = (0, $4Y8Vu.useMemo)(()=>{
        switch(activeStep){
            case (0, $63fe866510f70bb3$export$31f4a6fd27e146da).PersonalDetails:
                return /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)((0, $4c8d0e2996c4d41a$export$2e2bcd8739ae039), {
                    type: "enrol",
                    data: data,
                    onSubmit: handleUpdate((0, $63fe866510f70bb3$export$31f4a6fd27e146da).EqualOpportunities)
                });
            case (0, $63fe866510f70bb3$export$31f4a6fd27e146da).EqualOpportunities:
                return /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)((0, $273437c394df1fae$export$2e2bcd8739ae039), {
                    data: data,
                    onSubmit: handleUpdate((0, $63fe866510f70bb3$export$31f4a6fd27e146da).PriorAttainment)
                });
            case (0, $63fe866510f70bb3$export$31f4a6fd27e146da).PriorAttainment:
                return /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)((0, $0294f7b6f20cc081$export$2e2bcd8739ae039), {
                    data: data,
                    onSubmit: handleUpdate((0, $63fe866510f70bb3$export$31f4a6fd27e146da).Declaration)
                });
            case (0, $63fe866510f70bb3$export$31f4a6fd27e146da).Declaration:
                return /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)((0, $10736c52b78f4270$export$2e2bcd8739ae039), {
                    onSubmit: onSubmit
                });
        }
    }, [
        activeStep
    ]);
    return /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsxs)((0, $65eed959c02d7598$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)((0, $27aa04694c091085$export$2e2bcd8739ae039), {
                activeStep: activeStep,
                maxPossibleStep: maxPossibleStep,
                steps: (0, $63fe866510f70bb3$export$be3f796aed065412),
                onChange: setActiveStep
            }),
            CurrentStep
        ]
    });
};
var $e9009287b55c6f1d$export$2e2bcd8739ae039 = $e9009287b55c6f1d$var$Enrol;


const $267f0acfc5901bdf$var$ApplicationForm = ({ type: type })=>{
    switch(type){
        case "apply":
            return /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)((0, $0e08294b9fa211a3$export$2e2bcd8739ae039), {});
        case "enrol":
            return /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)((0, $e9009287b55c6f1d$export$2e2bcd8739ae039), {});
    }
};
var $267f0acfc5901bdf$export$2e2bcd8739ae039 = $267f0acfc5901bdf$var$ApplicationForm;


// Create a client
const $90d41d14f82eb37d$var$queryClient = new (0, $af3ad2fcddfb519e$export$405d0624ed55a03f)();
const $90d41d14f82eb37d$var$App = ({ courseID: courseID, type: type })=>{
    return /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)((0, $5bfa3d489cb629a7$export$45604f0cc8ae667b), {
        client: $90d41d14f82eb37d$var$queryClient,
        children: /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)((0, $7fc884044a60e38c$export$2e2bcd8739ae039), {
            id: courseID,
            children: /*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)((0, $267f0acfc5901bdf$export$2e2bcd8739ae039), {
                type: type
            })
        })
    });
};
// Render App to DOM
const $90d41d14f82eb37d$var$element = document.getElementById("applicationRoot");
if ($90d41d14f82eb37d$var$element) {
    const type = $90d41d14f82eb37d$var$element.getAttribute("data-course-type");
    const courseID = $90d41d14f82eb37d$var$element.getAttribute("data-course-id");
    (0, (/*@__PURE__*/$parcel$interopDefault($320b03ed0fb31615$exports))).render(/*#__PURE__*/ (0, $65eed959c02d7598$exports.jsx)($90d41d14f82eb37d$var$App, {
        type: type,
        courseID: courseID
    }), $90d41d14f82eb37d$var$element);
}

})();
//# sourceMappingURL=index.js.map
